(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("mobx-react"), require("ca-ui-toolkit"), require("mobx-state-tree"), require("underscore"), require("prop-types"), require("classnames"), require("mobx"), require("jquery"), require("react-dom"), require("polyglot"), require("ca-modeller/shaping"), require("explore-common"), require("gemini/lib/@waca/core-client/js/core-client/ui/core/Class"), require("gemini/lib/@waca/dashboard-common/dist/core/Model"), require("dashboard-analytics/visualizations/vipr/VIPRConfig"), require("gemini/lib/@waca/dashboard-common/dist/core/APIFactory"), require("gemini/lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI"), require("gemini/dashboard/model/LayoutModel"), require("gemini/dashboard/model/content/ContentModel"), require("gemini/lib/@waca/core-client/js/core-client/i18n/Formatter"), require("gemini/lib/@waca/dashboard-common/dist/utils/EventChainLocal"), require("gemini/api/impl/Dashboard"), require("dashboard-analytics/visualizations/vipr/VIPRUtils"), require("dashboard-analytics/widgets/livewidget/query/QueryResultData"), require("dashboard-analytics/widgets/livewidget/query/QueryResultObject"), require("gemini/dashboard/glass/BaseBoardView"), require("gemini/dashboard/layout/views/LayoutApi"), require("gemini/lib/@waca/dashboard-common/dist/utils/HtmlXSSUtils"), require("gemini/dashboard/layout/views/Widget"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "mobx-react", "ca-ui-toolkit", "mobx-state-tree", "underscore", "prop-types", "classnames", "mobx", "jquery", "react-dom", "polyglot", "ca-modeller/shaping", "explore-common", "gemini/lib/@waca/core-client/js/core-client/ui/core/Class", "gemini/lib/@waca/dashboard-common/dist/core/Model", "dashboard-analytics/visualizations/vipr/VIPRConfig", "gemini/lib/@waca/dashboard-common/dist/core/APIFactory", "gemini/lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI", "gemini/dashboard/model/LayoutModel", "gemini/dashboard/model/content/ContentModel", "gemini/lib/@waca/core-client/js/core-client/i18n/Formatter", "gemini/lib/@waca/dashboard-common/dist/utils/EventChainLocal", "gemini/api/impl/Dashboard", "dashboard-analytics/visualizations/vipr/VIPRUtils", "dashboard-analytics/widgets/livewidget/query/QueryResultData", "dashboard-analytics/widgets/livewidget/query/QueryResultObject", "gemini/dashboard/glass/BaseBoardView", "gemini/dashboard/layout/views/LayoutApi", "gemini/lib/@waca/dashboard-common/dist/utils/HtmlXSSUtils", "gemini/dashboard/layout/views/Widget"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("mobx-react"), require("ca-ui-toolkit"), require("mobx-state-tree"), require("underscore"), require("prop-types"), require("classnames"), require("mobx"), require("jquery"), require("react-dom"), require("polyglot"), require("ca-modeller/shaping"), require("explore-common"), require("gemini/lib/@waca/core-client/js/core-client/ui/core/Class"), require("gemini/lib/@waca/dashboard-common/dist/core/Model"), require("dashboard-analytics/visualizations/vipr/VIPRConfig"), require("gemini/lib/@waca/dashboard-common/dist/core/APIFactory"), require("gemini/lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI"), require("gemini/dashboard/model/LayoutModel"), require("gemini/dashboard/model/content/ContentModel"), require("gemini/lib/@waca/core-client/js/core-client/i18n/Formatter"), require("gemini/lib/@waca/dashboard-common/dist/utils/EventChainLocal"), require("gemini/api/impl/Dashboard"), require("dashboard-analytics/visualizations/vipr/VIPRUtils"), require("dashboard-analytics/widgets/livewidget/query/QueryResultData"), require("dashboard-analytics/widgets/livewidget/query/QueryResultObject"), require("gemini/dashboard/glass/BaseBoardView"), require("gemini/dashboard/layout/views/LayoutApi"), require("gemini/lib/@waca/dashboard-common/dist/utils/HtmlXSSUtils"), require("gemini/dashboard/layout/views/Widget")) : factory(root["react"], root["mobx-react"], root["ca-ui-toolkit"], root["mobx-state-tree"], root["underscore"], root["prop-types"], root["classnames"], root["mobx"], root["jquery"], root["react-dom"], root["polyglot"], root["ca-modeller/shaping"], root["explore-common"], root["gemini/lib/@waca/core-client/js/core-client/ui/core/Class"], root["gemini/lib/@waca/dashboard-common/dist/core/Model"], root["dashboard-analytics/visualizations/vipr/VIPRConfig"], root["gemini/lib/@waca/dashboard-common/dist/core/APIFactory"], root["gemini/lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI"], root["gemini/dashboard/model/LayoutModel"], root["gemini/dashboard/model/content/ContentModel"], root["gemini/lib/@waca/core-client/js/core-client/i18n/Formatter"], root["gemini/lib/@waca/dashboard-common/dist/utils/EventChainLocal"], root["gemini/api/impl/Dashboard"], root["dashboard-analytics/visualizations/vipr/VIPRUtils"], root["dashboard-analytics/widgets/livewidget/query/QueryResultData"], root["dashboard-analytics/widgets/livewidget/query/QueryResultObject"], root["gemini/dashboard/glass/BaseBoardView"], root["gemini/dashboard/layout/views/LayoutApi"], root["gemini/lib/@waca/dashboard-common/dist/utils/HtmlXSSUtils"], root["gemini/dashboard/layout/views/Widget"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_17__, __WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_28__, __WEBPACK_EXTERNAL_MODULE_33__, __WEBPACK_EXTERNAL_MODULE_39__, __WEBPACK_EXTERNAL_MODULE_68__, __WEBPACK_EXTERNAL_MODULE_76__, __WEBPACK_EXTERNAL_MODULE_102__, __WEBPACK_EXTERNAL_MODULE_103__, __WEBPACK_EXTERNAL_MODULE_177__, __WEBPACK_EXTERNAL_MODULE_178__, __WEBPACK_EXTERNAL_MODULE_182__, __WEBPACK_EXTERNAL_MODULE_218__, __WEBPACK_EXTERNAL_MODULE_233__, __WEBPACK_EXTERNAL_MODULE_244__, __WEBPACK_EXTERNAL_MODULE_245__, __WEBPACK_EXTERNAL_MODULE_246__, __WEBPACK_EXTERNAL_MODULE_253__, __WEBPACK_EXTERNAL_MODULE_255__, __WEBPACK_EXTERNAL_MODULE_257__, __WEBPACK_EXTERNAL_MODULE_456__) {
return webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_17__;

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t) {
  function n(e) {
    if (o[e]) return o[e].exports;var r = o[e] = { i: e, l: !1, exports: {} };return t[e].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }var e = window.webpackJsonPBaGraphics;window.webpackJsonPBaGraphics = function (o, i, u) {
    for (var c, s, a, f = 0, d = []; f < o.length; f++) {
      s = o[f], r[s] && d.push(r[s][0]), r[s] = 0;
    }for (c in i) {
      Object.prototype.hasOwnProperty.call(i, c) && (t[c] = i[c]);
    }for (e && e(o, i, u); d.length;) {
      d.shift()();
    }if (u) for (f = 0; f < u.length; f++) {
      a = n(n.s = u[f]);
    }return a;
  };var o = {},
      r = { 2086: 0 };n.m = t, n.c = o, n.d = function (t, e, o) {
    n.o(t, e) || Object.defineProperty(t, e, { configurable: !1, enumerable: !0, get: o });
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };return n.d(e, "a", e), e;
  }, n.o = function (t, n) {
    return Object.prototype.hasOwnProperty.call(t, n);
  }, n.p = "", n.oe = function (t) {
    throw console.error(t), t;
  };
}({ "698d75b157f24ae829cc": function d75b157f24ae829cc(t, n) {
    var e;e = function () {
      return this;
    }();try {
      e = e || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (e = window);
    }t.exports = e;
  }, "9689a9c94ae38b47fa2c": function a9c94ae38b47fa2c(t, n, e) {
    (function (n) {
      !function (n, e) {
        t.exports = e();
      }(0, function () {
        "use strict";
        function t(t, n) {
          return n = { exports: {} }, t(n, n.exports), n.exports;
        }var e = function e(t) {
          var n = t.id,
              e = t.viewBox,
              o = t.content;this.id = n, this.viewBox = e, this.content = o;
        };e.prototype.stringify = function () {
          return this.content;
        }, e.prototype.toString = function () {
          return this.stringify();
        }, e.prototype.destroy = function () {
          var t = this;["id", "viewBox", "content"].forEach(function (n) {
            return delete t[n];
          });
        };var o = function o(t) {
          var n = !!document.importNode,
              e = new DOMParser().parseFromString(t, "image/svg+xml").documentElement;return n ? document.importNode(e, !0) : e;
        },
            r = ("undefined" != typeof window ? window : void 0 !== n || "undefined" != typeof self && self, t(function (t, n) {
          !function (n, e) {
            t.exports = e();
          }(0, function () {
            function t(t) {
              return t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && "[object RegExp]" !== Object.prototype.toString.call(t) && "[object Date]" !== Object.prototype.toString.call(t);
            }function n(t) {
              return Array.isArray(t) ? [] : {};
            }function e(e, o) {
              return o && !0 === o.clone && t(e) ? i(n(e), e, o) : e;
            }function o(n, o, r) {
              var u = n.slice();return o.forEach(function (o, c) {
                void 0 === u[c] ? u[c] = e(o, r) : t(o) ? u[c] = i(n[c], o, r) : -1 === n.indexOf(o) && u.push(e(o, r));
              }), u;
            }function r(n, o, r) {
              var u = {};return t(n) && Object.keys(n).forEach(function (t) {
                u[t] = e(n[t], r);
              }), Object.keys(o).forEach(function (c) {
                t(o[c]) && n[c] ? u[c] = i(n[c], o[c], r) : u[c] = e(o[c], r);
              }), u;
            }function i(t, n, i) {
              var u = Array.isArray(n),
                  c = i || { arrayMerge: o },
                  s = c.arrayMerge || o;return u ? Array.isArray(t) ? s(t, n, i) : e(n, i) : r(t, n, i);
            }return i.all = function (t, n) {
              if (!Array.isArray(t) || t.length < 2) throw new Error("first argument should be an array with at least two elements");return t.reduce(function (t, e) {
                return i(t, e, n);
              });
            }, i;
          });
        })),
            i = t(function (t, n) {
          var e = { svg: { name: "xmlns", uri: "http://www.w3.org/2000/svg" }, xlink: { name: "xmlns:xlink", uri: "http://www.w3.org/1999/xlink" } };n.default = e, t.exports = n.default;
        }),
            u = function u(t) {
          return Object.keys(t).map(function (n) {
            return n + '="' + t[n].toString().replace(/"/g, "&quot;") + '"';
          }).join(" ");
        },
            c = i.svg,
            s = i.xlink,
            a = {};a[c.name] = c.uri, a[s.name] = s.uri;var f = function f(t, n) {
          void 0 === t && (t = "");var e = r(a, n || {});return "<svg " + u(e) + ">" + t + "</svg>";
        };return function (t) {
          function n() {
            t.apply(this, arguments);
          }t && (n.__proto__ = t), n.prototype = Object.create(t && t.prototype), n.prototype.constructor = n;var e = { isMounted: {} };return e.isMounted.get = function () {
            return !!this.node;
          }, n.createFromExistingNode = function (t) {
            return new n({ id: t.getAttribute("id"), viewBox: t.getAttribute("viewBox"), content: t.outerHTML });
          }, n.prototype.destroy = function () {
            this.isMounted && this.unmount(), t.prototype.destroy.call(this);
          }, n.prototype.mount = function (t) {
            if (this.isMounted) return this.node;var n = "string" == typeof t ? document.querySelector(t) : t,
                e = this.render();return this.node = e, n.appendChild(e), e;
          }, n.prototype.render = function () {
            var t = this.stringify();return o(f(t)).childNodes[0];
          }, n.prototype.unmount = function () {
            this.node.parentNode.removeChild(this.node);
          }, Object.defineProperties(n.prototype, e), n;
        }(e);
      });
    }).call(n, e("698d75b157f24ae829cc"));
  }, "9ce58a7deea14f49ef01": function ce58a7deea14f49ef01(t, n, e) {
    (function (n) {
      !function (n, e) {
        t.exports = e();
      }(0, function () {
        "use strict";
        function t(t, n) {
          return n = { exports: {} }, t(n, n.exports), n.exports;
        }function e(t) {
          return t = t || Object.create(null), { on: function on(n, e) {
              (t[n] || (t[n] = [])).push(e);
            }, off: function off(n, e) {
              t[n] && t[n].splice(t[n].indexOf(e) >>> 0, 1);
            }, emit: function emit(n, e) {
              (t[n] || []).map(function (t) {
                t(e);
              }), (t["*"] || []).map(function (t) {
                t(n, e);
              });
            } };
        }function o(t, n) {
          return _(t).reduce(function (t, e) {
            if (!e.attributes) return t;var o = _(e.attributes),
                r = n ? o.filter(n) : o;return t.concat(r);
          }, []);
        }function r(t) {
          return t.replace(B, function (t) {
            return "%" + t[0].charCodeAt(0).toString(16).toUpperCase();
          });
        }function i(t, n, e) {
          return _(t).forEach(function (t) {
            var o = t.getAttribute(k);if (o && 0 === o.indexOf(n)) {
              var r = o.replace(n, e);t.setAttributeNS(T, k, r);
            }
          }), t;
        }var u = ("undefined" != typeof window ? window : void 0 !== n || "undefined" != typeof self && self, t(function (t, n) {
          !function (n, e) {
            t.exports = e();
          }(0, function () {
            function t(t) {
              return t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && "[object RegExp]" !== Object.prototype.toString.call(t) && "[object Date]" !== Object.prototype.toString.call(t);
            }function n(t) {
              return Array.isArray(t) ? [] : {};
            }function e(e, o) {
              return o && !0 === o.clone && t(e) ? i(n(e), e, o) : e;
            }function o(n, o, r) {
              var u = n.slice();return o.forEach(function (o, c) {
                void 0 === u[c] ? u[c] = e(o, r) : t(o) ? u[c] = i(n[c], o, r) : -1 === n.indexOf(o) && u.push(e(o, r));
              }), u;
            }function r(n, o, r) {
              var u = {};return t(n) && Object.keys(n).forEach(function (t) {
                u[t] = e(n[t], r);
              }), Object.keys(o).forEach(function (c) {
                t(o[c]) && n[c] ? u[c] = i(n[c], o[c], r) : u[c] = e(o[c], r);
              }), u;
            }function i(t, n, i) {
              var u = Array.isArray(n),
                  c = i || { arrayMerge: o },
                  s = c.arrayMerge || o;return u ? Array.isArray(t) ? s(t, n, i) : e(n, i) : r(t, n, i);
            }return i.all = function (t, n) {
              if (!Array.isArray(t) || t.length < 2) throw new Error("first argument should be an array with at least two elements");return t.reduce(function (t, e) {
                return i(t, e, n);
              });
            }, i;
          });
        })),
            c = t(function (t, n) {
          var e = { svg: { name: "xmlns", uri: "http://www.w3.org/2000/svg" }, xlink: { name: "xmlns:xlink", uri: "http://www.w3.org/1999/xlink" } };n.default = e, t.exports = n.default;
        }),
            s = function s(t) {
          return Object.keys(t).map(function (n) {
            return n + '="' + t[n].toString().replace(/"/g, "&quot;") + '"';
          }).join(" ");
        },
            a = c.svg,
            f = c.xlink,
            d = {};d[a.name] = a.uri, d[f.name] = f.uri;var l,
            p = function p(t, n) {
          void 0 === t && (t = "");var e = u(d, n || {});return "<svg " + s(e) + ">" + t + "</svg>";
        },
            h = c.svg,
            y = c.xlink,
            m = { attrs: (l = { style: ["position: absolute", "width: 0", "height: 0"].join("; ") }, l[h.name] = h.uri, l[y.name] = y.uri, l) },
            v = function v(t) {
          this.config = u(m, t || {}), this.symbols = [];
        };v.prototype.add = function (t) {
          var n = this,
              e = n.symbols,
              o = this.find(t.id);return o ? (e[e.indexOf(o)] = t, !1) : (e.push(t), !0);
        }, v.prototype.remove = function (t) {
          var n = this,
              e = n.symbols,
              o = this.find(t);return !!o && (e.splice(e.indexOf(o), 1), o.destroy(), !0);
        }, v.prototype.find = function (t) {
          return this.symbols.filter(function (n) {
            return n.id === t;
          })[0] || null;
        }, v.prototype.has = function (t) {
          return null !== this.find(t);
        }, v.prototype.stringify = function () {
          var t = this.config,
              n = t.attrs,
              e = this.symbols.map(function (t) {
            return t.stringify();
          }).join("");return p(e, n);
        }, v.prototype.toString = function () {
          return this.stringify();
        }, v.prototype.destroy = function () {
          this.symbols.forEach(function (t) {
            return t.destroy();
          });
        };var g = function g(t) {
          var n = t.id,
              e = t.viewBox,
              o = t.content;this.id = n, this.viewBox = e, this.content = o;
        };g.prototype.stringify = function () {
          return this.content;
        }, g.prototype.toString = function () {
          return this.stringify();
        }, g.prototype.destroy = function () {
          var t = this;["id", "viewBox", "content"].forEach(function (n) {
            return delete t[n];
          });
        };var w,
            b = function b(t) {
          var n = !!document.importNode,
              e = new DOMParser().parseFromString(t, "image/svg+xml").documentElement;return n ? document.importNode(e, !0) : e;
        },
            x = function (t) {
          function n() {
            t.apply(this, arguments);
          }t && (n.__proto__ = t), n.prototype = Object.create(t && t.prototype), n.prototype.constructor = n;var e = { isMounted: {} };return e.isMounted.get = function () {
            return !!this.node;
          }, n.createFromExistingNode = function (t) {
            return new n({ id: t.getAttribute("id"), viewBox: t.getAttribute("viewBox"), content: t.outerHTML });
          }, n.prototype.destroy = function () {
            this.isMounted && this.unmount(), t.prototype.destroy.call(this);
          }, n.prototype.mount = function (t) {
            if (this.isMounted) return this.node;var n = "string" == typeof t ? document.querySelector(t) : t,
                e = this.render();return this.node = e, n.appendChild(e), e;
          }, n.prototype.render = function () {
            var t = this.stringify();return b(p(t)).childNodes[0];
          }, n.prototype.unmount = function () {
            this.node.parentNode.removeChild(this.node);
          }, Object.defineProperties(n.prototype, e), n;
        }(g),
            E = { autoConfigure: !0, mountTo: "body", syncUrlsWithBaseTag: !1, listenLocationChangeEvent: !0, locationChangeEvent: "locationChange", locationChangeAngularEmitter: !1, usagesToUpdate: "use[*|href]", moveGradientsOutsideSymbol: !1 },
            _ = function _(t) {
          return Array.prototype.slice.call(t, 0);
        },
            O = navigator.userAgent,
            S = { isChrome: /chrome/i.test(O), isFirefox: /firefox/i.test(O), isIE: /msie/i.test(O) || /trident/i.test(O), isEdge: /edge/i.test(O) },
            M = function M(t, n) {
          var e = document.createEvent("CustomEvent");e.initCustomEvent(t, !1, !1, n), window.dispatchEvent(e);
        },
            A = function A(t) {
          var n = [];return _(t.querySelectorAll("style")).forEach(function (t) {
            t.textContent += "", n.push(t);
          }), n;
        },
            C = function C(t) {
          return (t || window.location.href).split("#")[0];
        },
            j = function j(t) {
          angular.module("ng").run(["$rootScope", function (n) {
            n.$on("$locationChangeSuccess", function (n, e, o) {
              M(t, { oldUrl: o, newUrl: e });
            });
          }]);
        },
            N = function N(t, n) {
          return void 0 === n && (n = "linearGradient, radialGradient, pattern"), _(t.querySelectorAll("symbol")).forEach(function (t) {
            _(t.querySelectorAll(n)).forEach(function (n) {
              t.parentNode.insertBefore(n, t);
            });
          }), t;
        },
            T = c.xlink.uri,
            k = "xlink:href",
            B = /[{}|\\\^\[\]`"<>]/g,
            U = ["clipPath", "colorProfile", "src", "cursor", "fill", "filter", "marker", "markerStart", "markerMid", "markerEnd", "mask", "stroke", "style"],
            L = U.map(function (t) {
          return "[" + t + "]";
        }).join(","),
            P = function P(t, n, e, u) {
          var c = r(e),
              s = r(u);o(t.querySelectorAll(L), function (t) {
            var n = t.localName,
                e = t.value;return -1 !== U.indexOf(n) && -1 !== e.indexOf("url(" + c);
          }).forEach(function (t) {
            return t.value = t.value.replace(c, s);
          }), i(n, c, s);
        },
            G = { MOUNT: "mount", SYMBOL_MOUNT: "symbol_mount" },
            q = function (t) {
          function n(n) {
            var o = this;void 0 === n && (n = {}), t.call(this, u(E, n));var r = e();this._emitter = r, this.node = null;var i = this,
                c = i.config;if (c.autoConfigure && this._autoConfigure(n), c.syncUrlsWithBaseTag) {
              var s = document.getElementsByTagName("base")[0].getAttribute("href");r.on(G.MOUNT, function () {
                return o.updateUrls("#", s);
              });
            }var a = this._handleLocationChange.bind(this);this._handleLocationChange = a, c.listenLocationChangeEvent && window.addEventListener(c.locationChangeEvent, a), c.locationChangeAngularEmitter && j(c.locationChangeEvent), r.on(G.MOUNT, function (t) {
              c.moveGradientsOutsideSymbol && N(t);
            }), r.on(G.SYMBOL_MOUNT, function (t) {
              c.moveGradientsOutsideSymbol && N(t.parentNode), (S.isIE || S.isEdge) && A(t);
            });
          }t && (n.__proto__ = t), n.prototype = Object.create(t && t.prototype), n.prototype.constructor = n;var o = { isMounted: {} };return o.isMounted.get = function () {
            return !!this.node;
          }, n.prototype._autoConfigure = function (t) {
            var n = this,
                e = n.config;void 0 === t.syncUrlsWithBaseTag && (e.syncUrlsWithBaseTag = void 0 !== document.getElementsByTagName("base")[0]), void 0 === t.locationChangeAngularEmitter && (e.locationChangeAngularEmitter = "angular" in window), void 0 === t.moveGradientsOutsideSymbol && (e.moveGradientsOutsideSymbol = S.isFirefox);
          }, n.prototype._handleLocationChange = function (t) {
            var n = t.detail,
                e = n.oldUrl,
                o = n.newUrl;this.updateUrls(e, o);
          }, n.prototype.add = function (n) {
            var e = this,
                o = t.prototype.add.call(this, n);return this.isMounted && o && (n.mount(e.node), this._emitter.emit(G.SYMBOL_MOUNT, n.node)), o;
          }, n.prototype.attach = function (t) {
            var n = this,
                e = this;if (e.isMounted) return e.node;var o = "string" == typeof t ? document.querySelector(t) : t;return e.node = o, this.symbols.forEach(function (t) {
              t.mount(e.node), n._emitter.emit(G.SYMBOL_MOUNT, t.node);
            }), _(o.querySelectorAll("symbol")).forEach(function (t) {
              var n = x.createFromExistingNode(t);n.node = t, e.add(n);
            }), this._emitter.emit(G.MOUNT, o), o;
          }, n.prototype.destroy = function () {
            var t = this,
                n = t.config,
                e = t.symbols,
                o = t._emitter;e.forEach(function (t) {
              return t.destroy();
            }), o.off("*"), window.removeEventListener(n.locationChangeEvent, this._handleLocationChange), this.isMounted && this.unmount();
          }, n.prototype.mount = function (t, n) {
            void 0 === t && (t = this.config.mountTo), void 0 === n && (n = !1);var e = this;if (e.isMounted) return e.node;var o = "string" == typeof t ? document.querySelector(t) : t,
                r = e.render();return this.node = r, n && o.childNodes[0] ? o.insertBefore(r, o.childNodes[0]) : o.appendChild(r), this._emitter.emit(G.MOUNT, r), r;
          }, n.prototype.render = function () {
            return b(this.stringify());
          }, n.prototype.unmount = function () {
            this.node.parentNode.removeChild(this.node);
          }, n.prototype.updateUrls = function (t, n) {
            if (!this.isMounted) return !1;var e = document.querySelectorAll(this.config.usagesToUpdate);return P(this.node, e, C(t) + "#", C(n) + "#"), !0;
          }, Object.defineProperties(n.prototype, o), n;
        }(v),
            D = t(function (t) {
          /*!
          * domready (c) Dustin Diaz 2014 - License MIT
          */
          !function (n, e) {
            t.exports = function () {
              var _t,
                  n = [],
                  e = document,
                  o = e.documentElement.doScroll,
                  r = (o ? /^loaded|^c/ : /^loaded|^i|^c/).test(e.readyState);return r || e.addEventListener("DOMContentLoaded", _t = function t() {
                for (e.removeEventListener("DOMContentLoaded", _t), r = 1; _t = n.shift();) {
                  _t();
                }
              }), function (t) {
                r ? setTimeout(t, 0) : n.push(t);
              };
            }();
          }();
        }),
            F = !!window.__SVG_SPRITE__;F ? w = window.__SVG_SPRITE__ : (w = new q({ attrs: { id: "__SVG_SPRITE_NODE__" } }), window.__SVG_SPRITE__ = w);var I = function I() {
          var t = document.getElementById("__SVG_SPRITE_NODE__");t ? w.attach(t) : w.mount(document.body, !0);
        };return document.body ? I() : D(I), w;
      });
    }).call(n, e("698d75b157f24ae829cc"));
  } });

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_22__;

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.findLinkWithAnyNodeInDiagram = exports.formatLinkStrength = exports.findDirectLink = exports.getAllFieldNodesFromDiagramCache = exports.findNodesFromCache = exports.findSingleNodeFromCache = exports.addSingleField = exports.addFields = exports.linkStrengthInRange = exports.formatFilterResult = exports.adjustMinMaxStrength = exports.triageLinks = exports.filterSecondaryLinks = exports.filterPrimaryLinks = exports.filterRelationshipStrength = exports.removeDeletedFields = exports.getOrphanFields = exports.getConnectedFields = exports.applyTransforms = exports.printMsg = exports.getDataVerificationResults = exports.getGroupTypeAndGroupLabel = exports.getFieldLabel = exports.getGroupLabel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                   *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                   *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                   *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                                                                                                                                   *|
                                                                                                                                                                                                                                                                   *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                   *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                   */


var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _Config = __webpack_require__(16);

var _Config2 = _interopRequireDefault(_Config);

var _DataBuilder = __webpack_require__(81);

var _DataBuilder2 = _interopRequireDefault(_DataBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GROUP_TYPES_PREFIXES = {
	HIERARCHY: 'hierarchy_',
	CONCEPT: 'concept_',
	NONE: 'none_'
};

var MESSAGE_STATUS = {
	WARN: 'warn'
};

var REQUEST_CATEGORY = {
	LINKDATASET: 'LinkDataset',
	NODEDATASET: 'NodeDataset'
};

function getFieldLabel(uid, metadataInfo) {
	if (metadataInfo) {
		var field = metadataInfo.find(function (field) {
			return field.id === uid;
		});
		if (field) {
			return field.name;
		}
	}
	return uid;
}

function getGroupLabel(groupUid, metadataInfo) {
	var groupUidLength = groupUid.length;
	if (groupUid.startsWith(GROUP_TYPES_PREFIXES.HIERARCHY)) {
		return groupUid.substr(GROUP_TYPES_PREFIXES.HIERARCHY.length, groupUidLength);
	}
	if (groupUid.startsWith(GROUP_TYPES_PREFIXES.CONCEPT)) {
		return groupUid.substr(GROUP_TYPES_PREFIXES.CONCEPT.length, groupUidLength);
	}
	if (groupUid.startsWith(GROUP_TYPES_PREFIXES.NONE)) {
		return getFieldLabel(groupUid.substr(GROUP_TYPES_PREFIXES.NONE.length, groupUidLength), metadataInfo);
	}
	return '';
}

function getGroupTypeAndGroupLabel(groupUid) {
	var groupUidLength = groupUid.length;
	var result = {
		groupType: null,
		groupLabel: null
	};
	if (groupUid.startsWith(GROUP_TYPES_PREFIXES.NONE)) {
		result.groupLabel = groupUid.substr(GROUP_TYPES_PREFIXES.NONE.length, groupUidLength);
		result.groupType = 'none';
		return result;
	}
	if (groupUid.startsWith(GROUP_TYPES_PREFIXES.HIERARCHY)) {
		result.groupLabel = groupUid.substr(GROUP_TYPES_PREFIXES.HIERARCHY.length, groupUidLength);
		result.groupType = 'hierarchy';
		return result;
	}
	if (groupUid.startsWith(GROUP_TYPES_PREFIXES.CONCEPT)) {
		result.groupLabel = groupUid.substr(GROUP_TYPES_PREFIXES.CONCEPT.length, groupUidLength);
		result.groupType = 'concept';
		return result;
	}

	return result;
}

/**
* @param {JSONObject} rawData
* @param {JSONObject} options
* @return {JSONObject} return an object that holds the status of verifycation status and string of details
*/
function getDataVerificationResults(rawData, options) {
	return {
		'linkDataset': _verifyLinkDataset(rawData, options),
		'nodeDataset': _verifyNodeDataset()
	};
}

function _verifyLinkDataset(rawData, options) {
	if (rawData && rawData.relationshipStrength && rawData.relationshipStrength.predictStatus) {
		if ('ERROR' === rawData.relationshipStrength.predictStatus.state) {
			//By design we output warnings for link dataset errors
			var targetId = options ? options.targetId : 'unknown';
			return _buildVerificationResult(MESSAGE_STATUS.WARN, targetId, REQUEST_CATEGORY.LINKDATASET);
		}
	}
	return null;
}

//TODO: Augment this when Service end's informaiton is available
function _verifyNodeDataset() /** rawData, options */{
	return null;
}

function _buildVerificationResult(status, targetId, category) {
	//Console Debugging Message only, localization is not needed
	var err_details_linkDataset = 'An error occurs when querying relationship strengths (link datasets) for target: ' + targetId;
	var err_details_nodeDataset = 'An error occurs when querying relationship nodes (node datasets) for target: ' + targetId;
	var details = category === REQUEST_CATEGORY.LINKDATASET ? err_details_linkDataset : err_details_nodeDataset;
	return {
		status: status,
		category: category,
		details: details
	};
}

//Console Error for debugging
function printMsg(msgObject) {
	if (msgObject && msgObject.status === MESSAGE_STATUS.WARN) {
		console.warn(msgObject.details);
	}
}

/**
 * Transform raw data before preparing it for VIDA
 * @param {object} context - contains all information needed for transformations, including:
 * rawData {object} - Predict response for request of 100 nodes
 * diagramData {object} - diagram data saved last time in RelationshipTargetModel
 * transformOptions: {object} - transform operation and its parameters
 *   e.g. `deletedFields` with list of fields to remove
 *
 * @return {object} - result in same format as data, mutated by transforms
 */
function applyTransforms(context) {
	var transformKey = Object.keys(context.transformOptions)[0];
	var data = null;
	var targetModel = context.targetModel;
	switch (transformKey) {
		case 'filterStrength':
		case 'showPrimaryRelationshipView':
		case 'scopedFields':
			//we have new scope, rerender the relationship diagram
			data = filterRelationships(context.rawData, context);
			break;
		case 'deletedFields':
			data = removeDeletedFields(context.diagramData, context.transformOptions.deletedFields);
			data = removeOrphanFields(data);
			break;
		case 'lastAddedFields':
			{
				var result = addFields(context.diagramData, context.rawData, { addedFields: context.transformOptions.lastAddedFields, targetId: context.model.getCurrentTargetId(), showPrimaryRelationshipView: context.targetModel.getDiagramFilterCondition().showPrimaryRelationshipView });
				setInfoMessageForAddedFields(result, context);
				data = context.diagramData;
			}
			break;
		case 'lastShowRelationshipsField':
			{
				var _context$transformOpt = context.transformOptions.lastShowRelationshipsField,
				    from = _context$transformOpt.from,
				    to = _context$transformOpt.to;
				var relationship = context.transformOptions.lastShowRelationshipsField.relationship;
				var diagramData = context.diagramData;

				relationship = _normalizeRelationship(relationship);
				var _result = showRelationship(from, to, relationship, diagramData, { targetModel: targetModel, showMessage: true });
				if (_result && _result.isToNodeNotInDiagram === true) {
					// Add `to` into `addedFields`
					targetModel.addToAddedFields([to]);
				}
				targetModel.setRelationship(from, to, relationship);
				data = diagramData;
			}
			break;
		default:
			// this is for unit test
			data = context.diagramData || context.rawData;
	}
	if (data && targetModel) {
		targetModel.setDiagramData(data);
	}
	return data;
}

function setInfoMessageForAddedFields(result, context) {
	if (result && result.unfoundNodeIds.length) {
		var showPrimaryRelationshipView = context.targetModel.getDiagramFilterCondition().showPrimaryRelationshipView;
		var message = '';
		if (context.transformOptions.lastAddedFields.length === 1) {
			message = _StringResources2.default.get('startingPoints_no_relationship_found');
		} else {
			if (showPrimaryRelationshipView) {
				message = _StringResources2.default.get('startingPoints_no_direct_relationship_withNumberNotFound', { notFoundNodesNumber: JSON.stringify(result.unfoundNodeIds.length), totalAddedNodesNumber: JSON.stringify(context.transformOptions.lastAddedFields.length) });
			} else {
				message = _StringResources2.default.get('startingPoints_no_relationship_withNumberNotFound', { notFoundNodesNumber: JSON.stringify(result.unfoundNodeIds.length), totalAddedNodesNumber: JSON.stringify(context.transformOptions.lastAddedFields.length) });
			}
		}
		context.targetModel.setActionInfoStatus(message);
	}
}

/**
 * Given a field in data, identifies all other fields related to it directly and
 * indirectly.
 * @param {object} data
 * @param {string} root
 * @return {string[]}
 */
function getConnectedFields(data, root) {

	//Get copy of all relationships for fast look-up
	var fieldRelationships = {};
	var addRelationship = function addRelationship(source, target) {
		if (!fieldRelationships[source]) {
			fieldRelationships[source] = [];
		}
		fieldRelationships[source].push(target);
	};
	data.relationshipStrength.results.forEach(function (_ref) {
		var relationships = _ref.relationships;
		return relationships.forEach(function (_ref2) {
			var fieldA = _ref2.fieldA,
			    fieldB = _ref2.fieldB;

			addRelationship(fieldA, fieldB);
			addRelationship(fieldB, fieldA);
		});
	});

	var visitedFields = {};
	var pendingFields = [root];

	while (pendingFields.length) {
		var field = pendingFields.pop();
		if (!visitedFields[field]) {
			visitedFields[field] = true;
			var related = fieldRelationships[field] || [];
			pendingFields = pendingFields.concat(related);
		}
	}

	return _underscore2.default.keys(visitedFields);
}

/**
 * Identifies any fields orphaned from the target field.
 * @param {object} data
 * @return {string[]}
 */
function getOrphanFields(data) {
	if (!(data && data.nodesDataset)) {
		return data; // this is for unit test to mock this function
	}
	var allFields = _underscore2.default.flatten(data.nodesDataset.groupings.map(function (grouping) {
		return grouping.groups.map(function (group) {
			return group.members.map(function (_ref3) {
				var id = _ref3.id;
				return id;
			});
		});
	}));

	var connectedFields = getConnectedFields(data, data.nodesDataset.targetId);

	return _underscore2.default.difference(allFields, connectedFields);
}

/**
 * Modifies `data` to only include fields and links related to the target field
 * @param {object} data
 * @return {object}
 */
function removeOrphanFields(data) {
	return removeDeletedFields(data, getOrphanFields(data));
}

/**
 * Modifies `data` to exclude fields and links involving `deletedFields`
 * @param {object} data
 * @param {string[]} deletedFields
 * @return {object}
 */
function removeDeletedFields(data, deletedFields) {
	var isDeletedField = function isDeletedField(field) {
		return deletedFields.indexOf(field) > -1;
	};
	if (!(data && data.nodesDataset)) {
		return data; // this is for unit test to mock this function
	}
	return _extends({}, data, {
		nodesDataset: _extends({}, data.nodesDataset, {
			groupings: data.nodesDataset.groupings.map(function (grouping) {
				return _extends({}, grouping, {
					groups: grouping.groups.map(function (group) {
						return _extends({}, group, {
							//Only keep members if they haven't been deleted
							members: group.members.filter(function (_ref4) {
								var id = _ref4.id;
								return !isDeletedField(id);
							})
						});
					}).filter(
					//Only keep groups if they have members which have not been filtered out
					function (_ref5) {
						var members = _ref5.members;
						return !!members.length;
					})
				});
			})
		}),
		relationshipStrength: _extends({}, data.relationshipStrength, {
			results: data.relationshipStrength.results.map(function (result) {
				return _extends({}, result, {
					relationships: result.relationships.filter(function (_ref6) {
						var fieldA = _ref6.fieldA,
						    fieldB = _ref6.fieldB;
						return !isDeletedField(fieldA) && !isDeletedField(fieldB);
					})
				});
			})
		})
	});
}
/**
* This function filters raw data from Predict response to return only nodes and links satisfying filter strength and view type (primary/secondary relationship view) then apply delete/add fields if necessary
* @param {object} rawData - raw data from Predict response
* @param {object} context - contains target model reference
* @return {object} filtered data and calculated filter strength (if first time loading)
*/
function filterRelationships(rawData, context) {
	var targetModel = context.targetModel;
	var scopedRawData = getScopedRawData(rawData, targetModel) || rawData;
	var filterCondition = targetModel.getDiagramFilterCondition();
	var result = scopedRawData;
	// filterCondition null only used in unit test, should not happen in production
	if (filterCondition) {
		result = filterRelationshipStrength(scopedRawData, filterCondition);
		if (result && result.distinctNodes.length) {
			// update slider info
			targetModel.updateInitialFilterStrength(result.filterStrengthInfo);
			result = formatFilterResult(scopedRawData, result);
			var deletedFields = targetModel.getDeletedFields();
			if (deletedFields.length) {
				result = removeDeletedFields(result, deletedFields);
				result = removeOrphanFields(result);
			}
			var addedFields = targetModel.getAddedFields();
			if (addedFields.length) {
				var targetId = filterCondition.targetId;
				var showPrimaryRelationshipView = filterCondition.showPrimaryRelationshipView;
				addFields(result, rawData, { addedFields: addedFields, targetId: targetId, showPrimaryRelationshipView: showPrimaryRelationshipView });
			}

			var showRelationshipsMap = targetModel.getShowRelationships();
			var froms = Object.keys(showRelationshipsMap);
			if (froms.length) {
				froms.forEach(function (from) {
					var toEntries = showRelationshipsMap[from];
					toEntries.forEach(function (toEntry) {
						showRelationship(from, toEntry.to, toEntry.relationship, result);
					});
				});
			}
		}
	}
	return result;
}

function _normalizeRelationship(relationship) {
	if (relationship) {
		//do a deep copy
		relationship = JSON.parse(JSON.stringify(relationship));
		var _relationship = relationship,
		    toNode = _relationship.toNode;
		//remove the type, for the case the `toNode` is the target in the cache

		if (toNode && toNode.members && toNode.members.length > 0) {
			delete toNode.members[0].type;
		}
	}
	return relationship;
}

function showRelationship(from, to, relationship, diagramData) {
	var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

	var fromNodeInDiagramData = findSingleNodeFromCache(from, diagramData);
	//if `from` field is not in current diagram, return
	if (!fromNodeInDiagramData) {
		return;
	}
	var result = {};
	var message = null;
	if (relationship) {
		var toNode = relationship.toNode,
		    link = relationship.link;

		if (!findSingleNodeFromCache(to, diagramData)) {
			//if the `to` field is not in current diagram, add it
			var currentgroups = diagramData.nodesDataset.groupings[0].groups;
			currentgroups.push(toNode);
			result.isToNodeNotInDiagram = true;
		}
		var currentRelationships = diagramData.relationshipStrength.results[0].relationships;
		if (!currentRelationships.find(function (currentRelationship) {
			return _underscore2.default.isEqual(currentRelationship, link);
		})) {
			currentRelationships.push(link);
		}
	} else {
		//no direct relationship found between two nodes
		message = _StringResources2.default.get('startingPoints_no_direct_relationship_between_two_nodes', {
			columndIDAndLabelFrom: from,
			columndIDAndLabelTo: to
		});
	}
	var showMessage = options.showMessage;
	var targetModel = options.targetModel;
	if (targetModel && showMessage && message && message.length) {
		targetModel.setActionInfoStatus(message);
	}
	return result;
}

/**
 * Get the scoped raw data of current scope
 * @param {object} rawData
 * @param {object} targetModel
 */
function getScopedRawData(rawData, targetModel) {
	var scope = targetModel.scope;
	var scopedFields = scope.getScopedFields();
	var scopedRawData = null;
	if (scopedFields) {
		scopedRawData = scopeFields(rawData, { scopedFields: scopedFields.map(function (scopedField) {
				return scopedField.fieldIDForExpression;
			}), targetId: scope.fieldId });
		//Need to sort
		if (scopedRawData) {
			var relationshipResults = scopedRawData.relationshipStrength && scopedRawData.relationshipStrength.results;
			if (relationshipResults && relationshipResults.length) {
				relationshipResults[0].relationships.sort(function (relationship1, relationship2) {
					return relationship2.strength - relationship1.strength;
				});
			}
		}
	}
	return scopedRawData;
}

/**
* This function filters the raw data from Predict response to select only nodes and relationships that satisfy user settings.
* @param {Object} rawData - Predict response from relationshipStrength request, including a set of nodes and links
* @param {Object} filterCondition - filter condition (
* targetId: string, // target in the raw data
* showPrimaryRelationshipView: boolean, // determine what type of relationship to display
* maxNodesToDisplay: number,
* maxLinksToDisplay: number,
* filterStrength: {min: int, max: int} or null (if first time loading)
* )
*/
function filterRelationshipStrength(rawData, filterCondition) {
	var linkDataset = rawData && rawData.relationshipStrength && rawData.relationshipStrength.results && rawData.relationshipStrength.results.length ? rawData.relationshipStrength.results[0].relationships : [];

	var triagedLinks = triageLinks(linkDataset, filterCondition.targetId);

	// Prioritize primary links for both views
	var result = filterPrimaryLinks(triagedLinks.primaryLinks, filterCondition);
	if (result.links.length === 0) {
		// no primary links satisfy strength range, stop here
		return result;
	}
	// Continue to add link for secondary relationship view
	if (!filterCondition.showPrimaryRelationshipView && triagedLinks.secondaryLinks.length > 0) {
		var context = result;
		// memorize primary links filterStrengthInfo
		var _result2 = result,
		    primaryLinksfilterStrengthInfo = _result2.filterStrengthInfo;

		var primaryLinksCount = result.links.length;
		result = filterSecondaryLinks(triagedLinks.secondaryLinks, filterCondition, context);
		if (result.links.length > primaryLinksCount) {
			// adjust min, max strength after adding secondary links
			result.filterStrengthInfo = adjustMinMaxStrength(result.links, primaryLinksCount);
		} else {
			// if no secondary links added, restore primary links filterStrengthInfo
			result.filterStrengthInfo = primaryLinksfilterStrengthInfo;
		}
	}
	return result;
}

/**
* This function returns the primary links that satisfy filter condition.
* @param {Object[]} primaryLinks - array of link objects
* @param {Object} - filter condition (targetId: string, maxNodesToDisplay: int, filterStrength {min: int, max: int})
*/
function filterPrimaryLinks(primaryLinks, _ref7) {
	var targetId = _ref7.targetId,
	    maxNodesToDisplay = _ref7.maxNodesToDisplay,
	    filterStrength = _ref7.filterStrength;

	// If no links satisfy filter strength condition, return single node
	var nodes = [targetId];
	var links = [];
	var done = false,
	    i = 0;
	if (primaryLinks && primaryLinks.length) {
		while (!done && nodes.length < maxNodesToDisplay) {
			var link = primaryLinks[i++];
			if (linkStrengthInRange(link, filterStrength)) {
				nodes.push(link.fieldA === targetId ? link.fieldB : link.fieldA);
				links.push(link);
			}
			if (i === primaryLinks.length || filterStrength && filterStrength.min > link.strength) {
				done = true;
			}
		}
		// Handle the scenario where there are many nodes having the same min or max strength: in this case, even we hit 10 nodes, we still add these nodes in the diagram until we hit 100 nodes
		var maxTotalNodes = _Config2.default.max_nodes_to_display;
		if (nodes.length < maxTotalNodes && i === maxNodesToDisplay - 1 && i < primaryLinks.length) {
			addLinksWithTightStrengths(nodes, links, i, targetId, primaryLinks);
		}
	}
	// min/max strength is set to default values if no primary links found
	return {
		links: links,
		distinctNodes: nodes,
		// links are sorted in decreasing order, thus max is the first and min should be the last
		filterStrengthInfo: {
			min: links.length ? links[links.length - 1].strength : 10,
			max: links.length ? links[0].strength : 100
		}
	};
}

/**
* This function collects links (and their associated nodes) that have the same strength as the min or max strength collected so far.
* @param {String[]} nodes - array of columnId that have been collected before
* @param {Object[]} links - array of links that have been collected before
* @param {integer} startIndex - position in the source links where we should start to add tight links
* @param {String} targetId - targetId
* @param {Object[]} sourceLinks - array of sorted links in the raw cache, source to get more candidate links
*/
function addLinksWithTightStrengths(nodes, links, startIndex, targetId, sourceLinks) {
	var threshold = null;
	if (links[0].strength === links[links.length - 1].strength) {
		// all collected links have the same strength, this strength is the threshold that allow to add more links
		threshold = links[0].strength;
	} else {
		// min strength !== max strength, the min strength is the threshold
		threshold = links[links.length - 1].strength;
	}
	var maxTotalNodes = _Config2.default.max_nodes_to_display;
	while (nodes.length < maxTotalNodes && startIndex < sourceLinks.length && sourceLinks[startIndex].strength === threshold) {
		var link = sourceLinks[startIndex];
		nodes.push(link.fieldA === targetId ? link.fieldB : link.fieldA);
		links.push(link);
		startIndex++;
	}
}

/**
* This function returns the secondary links that satisfy filter condition.
* A secondary link can only be added if it's connected to the set of nodes previously collected to avoid isolate islands.
* As the diagram grows after each iteration, make this function recursive to make sure we don't miss any potential secondary links until one of the filter condition breaks.
* @param {Object[]} secondaryLinks - array of potential secondary links to add in the diagram
* @param {Object} - filter condition (maxNodesToDisplay: int, maxLinksToDisplay: int, filterStrength {min: int, max: int})
* @param {Object} - context : set of links and nodes that are already collected and connected with each other, used to verify if these
* nodes can be connected with a new candidate secondary link
*/
function filterSecondaryLinks(secondaryLinks, filterCondition, context) {
	var maxNodesToDisplay = filterCondition.maxNodesToDisplay,
	    maxLinksToDisplay = filterCondition.maxLinksToDisplay,
	    filterStrength = filterCondition.filterStrength;
	var links = context.links,
	    distinctNodes = context.distinctNodes;

	var done = false,
	    i = 0;
	var remainingLinks = [];
	// For each potential input link, if it's connected to any nodes previously collected (context.distinctNodes) and satisfy filter condition, collect it.
	// If it satisfies filter condition but not yet connected to context, store it in remainingLinks for the next round in recursive process.
	while (!done && distinctNodes.length < maxNodesToDisplay) {
		var link = secondaryLinks[i++];
		if (linkStrengthInRange(link, filterStrength) && links.length < maxLinksToDisplay) {
			var seenNodes = _underscore2.default.intersection(distinctNodes, [link.fieldA, link.fieldB]);
			// only add link if it is connected (at least one of the end nodes should be previously added)
			if (seenNodes.length > 0) {
				links.push(link);
				if (seenNodes.length === 1) {
					// Only 1 node of the link is collected, need to add the other node
					if (seenNodes[0] === link.fieldA) {
						distinctNodes.push(link.fieldB);
					} else {
						distinctNodes.push(link.fieldA);
					}
				}
			} else {
				// link satisfy filter condition but not connected, store it for next round of recursive process
				remainingLinks.push(link);
			}
		}
		if (i === secondaryLinks.length || filterStrength && filterStrength.min > link.strength || links.length === maxLinksToDisplay) {
			done = true;
		}
	}
	// If we still have room to add nodes or links and still have potential links to add,
	// recursively process these links until no remaining links or filter condition breaks.
	if (distinctNodes.length < maxNodesToDisplay && remainingLinks.length > 0 && remainingLinks.length < secondaryLinks.length && links.length < maxLinksToDisplay) {
		filterSecondaryLinks(remainingLinks, filterCondition, context);
	} else if (distinctNodes.length >= maxNodesToDisplay && secondaryLinks.length > 0) {
		// max nodes is reached, can only add secondary links that have both ends already in until maxLinks is reached
		var slinks = remainingLinks.length > 0 ? remainingLinks : secondaryLinks;
		slinks.forEach(function (link) {
			if (linkStrengthInRange(link, filterStrength) && links.length < maxLinksToDisplay) {
				var _seenNodes = _underscore2.default.intersection(distinctNodes, [link.fieldA, link.fieldB]);
				if (_seenNodes.length === 2) {
					links.push(link);
				}
			}
		});
	}
	return {
		'links': links,
		'distinctNodes': distinctNodes
	};
}
/**
* Links (from Predict response) are always sorted by decreasing order.
* We need to keep the decreasing order in primary and secondary links after triage to make sure
* we always select strongest links for the limit number of nodes.
* We also rely on this order to calculate/adjust the min and max strength after filter links.
*/
function triageLinks(linkDataset, targetId) {
	var primaryLinks = [];
	var secondaryLinks = [];
	// First pass: triage primary and secondary relationships
	linkDataset.forEach(function (link) {
		if (link.fieldA === targetId || link.fieldB === targetId) {
			primaryLinks.push(link);
		} else {
			secondaryLinks.push(link);
		}
	});
	return {
		primaryLinks: primaryLinks,
		secondaryLinks: secondaryLinks
	};
}

function linkStrengthInRange(link, filterLinkStrength) {
	if (filterLinkStrength) {
		if (link.strength < filterLinkStrength.min || link.strength > filterLinkStrength.max) {
			return false;
		}
	}
	return true;
}

/**
* The primary links are added in the decreasing order of strength, so no need to sort.
* The secondary links are not guaranteed to be added in this order, so sort them before comparing with primary links.
*/
function adjustMinMaxStrength(links, primaryLinksCount) {
	var minPrimaryLink = links[primaryLinksCount - 1].strength;
	var maxPrimaryLink = links[0].strength;
	// sort secondary links strength
	var sLinksStrength = links.slice(primaryLinksCount).map(function (link) {
		return link.strength;
	});
	// sort ascending
	sLinksStrength.sort(function (a, b) {
		return a - b;
	});
	var last = sLinksStrength.length - 1;
	return {
		min: sLinksStrength[0] < minPrimaryLink ? sLinksStrength[0] : minPrimaryLink,
		max: sLinksStrength[last] > maxPrimaryLink ? sLinksStrength[last] : maxPrimaryLink
	};
}
/**
* This function build the diagram data as per structure of Predict response to make it consumable by dataProvider
* @param {object} rawData - Predict response data
* @param {object} filterResult - diagram data after applying transformation, contains only array of nodes and links
@ @return {object} filterResult in formatted structure
*/
function formatFilterResult(rawData, filterResult) {
	var isFilteredNode = function isFilteredNode(id) {
		return filterResult.distinctNodes.indexOf(id) > -1;
	};
	return _extends({}, rawData, {
		nodesDataset: _extends({}, rawData.nodesDataset, {
			groupings: rawData.nodesDataset.groupings.map(function (grouping) {
				return _extends({}, grouping, {
					groups: grouping.groups.map(function (group) {
						return _extends({}, group, {
							//Only keep members if they haven't been deleted
							members: group.members.filter(function (_ref8) {
								var id = _ref8.id;
								return isFilteredNode(id);
							})
						});
					}).filter(
					//Only keep groups if they have members which have not been filtered out
					function (_ref9) {
						var members = _ref9.members;
						return !!members.length;
					})
				});
			})
		}),
		relationshipStrength: _extends({}, rawData.relationshipStrength, {
			results: [{
				relationships: filterResult.links
			}]
		})
	});
}

function addFields(diagramData, rawData, _ref10) {
	var addedFields = _ref10.addedFields,
	    targetId = _ref10.targetId,
	    showPrimaryRelationshipView = _ref10.showPrimaryRelationshipView;

	var result = null;
	if (addedFields && addedFields.length > 0) {
		if (showPrimaryRelationshipView) {
			result = addFieldsForPrimaryRelationshipView(addedFields, diagramData, rawData, targetId);
		} else {
			result = addFieldsForSecondaryRelationshipView(addedFields, diagramData, rawData);
		}
	}
	return result;
}

function addFieldsForPrimaryRelationshipView(addedFields, diagramData, rawData, targetId) {
	var result = {
		foundNodes: [],
		unfoundNodeIds: []
	};
	addedFields.forEach(function (addedField) {
		var resultSingleField = addSingleField(diagramData, rawData, { fieldId: addedField, targetId: targetId });
		if (resultSingleField && resultSingleField.node) {
			result.foundNodes.push(resultSingleField.node);
		} else {
			result.unfoundNodeIds.push(addedField);
		}
	});
	return result;
}

function addFieldsForSecondaryRelationshipView(addedFields, diagramData, rawData) {
	var result = {
		foundNodes: [],
		unfoundNodeIds: [],
		nodesToAdd: [],
		linksToAdd: []
	};
	var searchFromDiagram = findNodesFromCache(addedFields, diagramData);
	if (searchFromDiagram.foundNodes.length) {
		result.foundNodes = result.foundNodes.concat(searchFromDiagram.foundNodes);
	}
	if (searchFromDiagram.unfoundNodeIds.length) {
		var searchFromRawCache = findNodesFromCache(searchFromDiagram.unfoundNodeIds, rawData);
		if (searchFromRawCache.foundNodes.length) {
			searchFromRawCache.foundNodes.forEach(function (foundNode) {
				var fieldId = foundNode.members[0].id;
				var linksToAdd = findLinkWithAnyNodeInDiagram(diagramData, rawData, fieldId);
				if (linksToAdd.length) {
					result.nodesToAdd.push(foundNode);
					result.linksToAdd = result.linksToAdd.concat(linksToAdd);
				} else {
					result.unfoundNodeIds.push(fieldId);
				}
			});
		}
		if (searchFromRawCache.unfoundNodeIds.length) {
			result.unfoundNodeIds = result.unfoundNodeIds.concat(searchFromRawCache.unfoundNodeIds);
		}
	}
	if (result.nodesToAdd.length) {
		// Add group nodes in the diagramData
		diagramData.nodesDataset.groupings[0].groups = diagramData.nodesDataset.groupings[0].groups.concat(result.nodesToAdd);
		result.foundNodes = result.foundNodes.concat(result.nodesToAdd);
	}
	if (result.linksToAdd.length) {
		// Add new links in the diagramData
		diagramData.relationshipStrength.results[0].relationships = diagramData.relationshipStrength.results[0].relationships.concat(result.linksToAdd);
	}
	return result;
}

/**
 * Add a single field to existing diagram
 * @param {Object} diagramData
 * @param {Object} rawData
 * @param {String} fieldId
 * @param {String} targetId
 * @param {boolean} showPrimaryRelationshipView True, show primary relaitonship only
 * @return {Object} that has nodes, links and informaiton about if direct links are found or not
 */
function addSingleField(diagramData, rawData, _ref11) {
	var fieldId = _ref11.fieldId,
	    targetId = _ref11.targetId;

	var result = findNodeAndLinks(diagramData, rawData, { fieldId: fieldId, targetId: targetId, showPrimaryRelationshipView: true });
	if (result && result.node && result.links && result.links.length) {
		// Add node and links in diagram if they are not already in
		var currentgroups = diagramData.nodesDataset.groupings[0].groups;
		if (!currentgroups.find(function (group) {
			return group.groupId === result.node.groupId;
		})) {
			currentgroups.push(result.node);

			var currentRelationships = diagramData.relationshipStrength.results[0].relationships;
			result.links.forEach(function (entry) {
				if (currentRelationships.indexOf(entry) === -1) {
					currentRelationships.push(entry);
				}
			});
		}
	}
	return result;
}

function scopeFields(rawData, _ref12) {
	var scopedFields = _ref12.scopedFields,
	    targetId = _ref12.targetId;

	var diagramData = _DataBuilder2.default.createSingleNode(targetId, 'completed');
	scopedFields.forEach(function (scopedField) {
		var result = findNodeAndLinks({}, rawData, { fieldId: scopedField, targetId: targetId }, [].concat(scopedFields, [targetId]));
		if (result && result.node && result.links && result.links.length) {
			diagramData.nodesDataset.groupings[0].groups.push(result.node);
			var currentRelatioships = diagramData.relationshipStrength.results[0].relationships;
			result.links.forEach(function (entry) {
				if (currentRelatioships.indexOf(entry) === -1) {
					currentRelatioships.push(entry);
				}
			});
		}
	});
	return diagramData;
}

/**
 * Find node and links in given rawData for given field
 * @param  {object} diagramData    diagram data that holds node dataste and link datasets
 * @param {object} rawData 			Predict response for request of 100 nodes
 * @param  {String} fieldId		  field id to search
 * @param  {String} targetId		  Id of the target
 * @param {boolean} appendToBase if True, merge the new node and links to base raw data
 * @param  {boolean} showPrimaryRelationshipView the current view type of the target
 * @param  {array} scope if given, then all nodes connected to the found node should be in the scope
*/
function findNodeAndLinks(diagramData, rawData, _ref13, scope) {
	var fieldId = _ref13.fieldId,
	    targetId = _ref13.targetId,
	    showPrimaryRelationshipView = _ref13.showPrimaryRelationshipView;

	if (fieldId && targetId && diagramData) {
		var localAllNodesCache = rawData;
		var node = findSingleNodeFromCache(fieldId, rawData);
		if (node) {
			var resultsCache = localAllNodesCache.relationshipStrength && localAllNodesCache.relationshipStrength.results;
			if (resultsCache && resultsCache.length > 0) {
				var addedRelationships = resultsCache[0].relationships.filter(function (entry) {
					if (entry.fieldB === fieldId && entry.fieldA === targetId || entry.fieldB === targetId && entry.fieldA === fieldId) {
						return true;
					}
					if (!showPrimaryRelationshipView) {
						if (scope && scope.length) {
							return entry.fieldB === fieldId && scope.indexOf(entry.fieldA) !== -1 || entry.fieldA === fieldId && scope.indexOf(entry.fieldB) !== -1;
						} else {
							// Find if there are links between this field and any nodes in the diagram
							return findLinkWithAnyNodeInDiagram(diagramData, rawData, fieldId);
						}
					}
				});
				if (addedRelationships.length) {
					return {
						node: node,
						links: addedRelationships
					};
				}
			}
		}
	}
	return null;
}

function findLinkWithAnyNodeInDiagram(diagramData, rawData, fieldId) {
	var rawLinks = rawData.relationshipStrength.results[0].relationships;
	var links = [];
	if (rawLinks) {
		// Get all links and nodes from raw cache that link to the field
		var foundLinksInRaw = rawLinks.filter(function (link) {
			return link.fieldA === fieldId || link.fieldB === fieldId;
		});
		if (foundLinksInRaw.length) {
			var otherNodes = foundLinksInRaw.map(function (link) {
				if (link.fieldA === fieldId) {
					return link.fieldB;
				} else {
					return link.fieldA;
				}
			});
			var diagramNodes = getAllFieldNodesFromDiagramCache(diagramData, false /*exclude target*/);
			// intersection between diagram nodes and nodes that have link with the field
			var commonNodes = _underscore2.default.intersection(otherNodes, diagramNodes);
			if (commonNodes.length > 0) {
				commonNodes.forEach(function (commonNode) {
					var secondaryLink = foundLinksInRaw.find(function (link) {
						return link.fieldA === commonNode || link.fieldB === commonNode;
					});
					if (secondaryLink) {
						links.push(secondaryLink);
					}
				});
			}
		}
	}
	return links;
}

function findNodesFromCache(nodeIds, rawData) {
	var result = {
		foundNodes: [],
		unfoundNodeIds: []
	};
	if (nodeIds && nodeIds.length) {
		nodeIds.find(function (nodeId) {
			var node = findSingleNodeFromCache(nodeId, rawData);
			if (node) {
				result.foundNodes.push(node);
			} else {
				result.unfoundNodeIds.push(nodeId);
			}
		});
	}
	return result;
}

/**
 * Find all nodes from data cache, excluding focus field if needed
 *
 * @param {Object} response cache that contains node dataset and link dataset
 * @param {boolean} excludeFocusField if True, exclude focus field, False, not.
 */
function getAllFieldNodesFromDiagramCache(cache) {
	var excludeFocusField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	var result = [];
	var groupingsCache = cache && cache.nodesDataset && cache.nodesDataset.groupings;
	if (groupingsCache && groupingsCache.length > 0) {
		var groupsCache = groupingsCache[0].groups;
		if (groupsCache && groupsCache.length > 0) {
			groupsCache.forEach(function (entry) {
				var member = entry.members[0];
				if (!(excludeFocusField && member.type === 'focusField')) {
					result.push(member.id);
				}
			});
		}
	}
	return result;
}

/**
 * get single node from cached reponse data
 * @param {string} nodeID
 * @param {object} cachedData
 */
function findSingleNodeFromCache(nodeID, cachedData) {
	var node = null;
	if (nodeID && cachedData && cachedData.nodesDataset && cachedData.nodesDataset.groupings) {
		var groupingsCache = cachedData.nodesDataset.groupings;
		if (groupingsCache && groupingsCache.length > 0) {
			var groupsCache = groupingsCache[0].groups;
			if (groupsCache && groupsCache.length > 0) {
				node = groupsCache.find(function (entry) {
					if (entry && entry.members && entry.members.length > 0) {
						return entry.members[0].id === nodeID;
					}
				});
			}
		}
	}
	return node;
}

/**
 * Check if there is direct link between two nodes
 * @param  {[type]} fieldOne  first node of the link
 * @param  {[type]} fieldTwo  second node of the link
 * @param  {[type]} cachedData Cache that holds the node dataset and link dataset
 * @return {object} {nodeOne, nodeTwo, link}- nodeOne is the node for`fieldOne`, nodeTwo is the node for`fieldTwo`
 */
function findDirectLink(fieldOne, fieldTwo, cachedData) {
	var nodeOne = findSingleNodeFromCache(fieldOne, cachedData);
	var nodeTwo = findSingleNodeFromCache(fieldTwo, cachedData);
	if (nodeOne && nodeTwo) {
		if (cachedData && cachedData.relationshipStrength) {
			var results = cachedData.relationshipStrength.results;
			if (results && results.length) {
				var matchedResult = results[0].relationships.find(function (link) {
					return link.fieldA === fieldOne && link.fieldB === fieldTwo || link.fieldA === fieldTwo && link.fieldB === fieldOne;
				});
				if (matchedResult) {
					return {
						nodeOne: nodeOne,
						nodeTwo: nodeTwo,
						link: matchedResult
					};
				}
			}
		}
	}
	return null;
}

function formatLinkStrength(link) {
	if (link) {
		if (!Number.isInteger(link.strength)) {
			link.strength = Math.round(link.strength * 100);
		} else if (link.strength === 1) {
			link.strength = 100;
		}
	}
	return link;
}

exports.getGroupLabel = getGroupLabel;
exports.getFieldLabel = getFieldLabel;
exports.getGroupTypeAndGroupLabel = getGroupTypeAndGroupLabel;
exports.getDataVerificationResults = getDataVerificationResults;
exports.printMsg = printMsg;
exports.applyTransforms = applyTransforms;
exports.getConnectedFields = getConnectedFields;
exports.getOrphanFields = getOrphanFields;
exports.removeDeletedFields = removeDeletedFields;
exports.filterRelationshipStrength = filterRelationshipStrength;
exports.filterPrimaryLinks = filterPrimaryLinks;
exports.filterSecondaryLinks = filterSecondaryLinks;
exports.triageLinks = triageLinks;
exports.adjustMinMaxStrength = adjustMinMaxStrength;
exports.formatFilterResult = formatFilterResult;
exports.linkStrengthInRange = linkStrengthInRange;
exports.addFields = addFields;
exports.addSingleField = addSingleField;
exports.findSingleNodeFromCache = findSingleNodeFromCache;
exports.findNodesFromCache = findNodesFromCache;
exports.getAllFieldNodesFromDiagramCache = getAllFieldNodesFromDiagramCache;
exports.findDirectLink = findDirectLink;
exports.formatLinkStrength = formatLinkStrength;
exports.findLinkWithAnyNodeInDiagram = findLinkWithAnyNodeInDiagram;

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(9));

var _addClass = _interopRequireDefault(__webpack_require__(262));

var _removeClass = _interopRequireDefault(__webpack_require__(265));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(266));

var _PropTypes = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _VisRecommenderResources = __webpack_require__(274);

var _VisRecommenderResources2 = _interopRequireDefault(_VisRecommenderResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Licensed Materials - Property of IBM
                                                                                                                                                           * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
                                                                                                                                                           * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           */

var Polyglot = __webpack_require__(22);

var StringResources = function () {
	function StringResources() {
		_classCallCheck(this, StringResources);

		/**
   * Module which provides simple access to string resources.
   */
		this.polyglot = new Polyglot({
			phrases: _VisRecommenderResources2.default
		});
	}

	/**
  * Get the string resource for the given key and interpolation options
  *
  * @param key						The  key of the string to return
  * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
  * @returns							The string to display
  */


	StringResources.prototype.get = function get(key, interpolationOptions) {
		return this.polyglot.t(key, interpolationOptions);
	};

	return StringResources;
}();

exports.default = new StringResources();

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_28__;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /**
             * Licensed Materials - Property of IBM
             * IBM Watson (C) Copyright IBM Corp. 2018, 2019
             * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(5);

var _classnames4 = __webpack_require__(10);

var _classnames5 = _interopRequireDefault(_classnames4);

var _caUiToolkit = __webpack_require__(6);

var _VisualizationPreview = __webpack_require__(275);

var _VisualizationPreview2 = _interopRequireDefault(_VisualizationPreview);

var _VisualizationAutoMode = __webpack_require__(285);

var _VisualizationAutoMode2 = _interopRequireDefault(_VisualizationAutoMode);

var _StringResources = __webpack_require__(27);

var _StringResources2 = _interopRequireDefault(_StringResources);

__webpack_require__(58);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CLASS_NAME = 'vis-recommender__preview-list';

var VisualizationPreviewList = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(VisualizationPreviewList, _Component);

	function VisualizationPreviewList(props) {
		_classCallCheck(this, VisualizationPreviewList);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._onAutoSwitchIconClick = function () {
			// TODO: have a separate argument for this (onAutoClick or smth like that)
			_this.props.onClickItem({
				key: 'autoModeIcon',
				isAutoModeSwitcher: true
			}, 0);
		};

		_this._rootRef = _react2.default.createRef();

		_this.state = {
			maxDisplayedItems: _this.props.maxDisplayedItems,
			isExpanded: false
		};
		return _this;
	}

	VisualizationPreviewList.prototype.render = function render() {
		var _classnames, _classnames2;

		var isHorizontal = this.props.horizontal;

		var classNames = (0, _classnames5.default)('' + CLASS_NAME, (_classnames = {}, _classnames[CLASS_NAME + '--horizontal'] = isHorizontal, _classnames[CLASS_NAME + '--vertical'] = !isHorizontal, _classnames));

		var itemsClassNames = (0, _classnames5.default)((_classnames2 = {}, _classnames2[CLASS_NAME + '--horizontal__items'] = isHorizontal, _classnames2[CLASS_NAME + '--vertical__items'] = !isHorizontal, _classnames2));

		return _react2.default.createElement(
			'div',
			{ className: classNames, ref: this._rootRef },
			_react2.default.createElement(
				'div',
				{ className: itemsClassNames },
				this.renderAutoMode(),
				this.renderListItems()
			),
			this.renderSeeMore()
		);
	};

	VisualizationPreviewList.prototype._getFinalVizItemsList = function _getFinalVizItemsList() {
		var maxDisplayedItems = this.state.maxDisplayedItems;
		var _props = this.props,
		    visStartingIndex = _props.visStartingIndex,
		    items = _props.items;


		if (maxDisplayedItems > -1) {
			return items.slice(visStartingIndex, visStartingIndex + maxDisplayedItems);
		} else {
			return items;
		}
	};

	VisualizationPreviewList.prototype.renderAutoMode = function renderAutoMode() {
		if (this.props.selectedVisId) {
			var isSelected = this.props.isVizTypeLocked !== true;
			var isHorizontal = this.props.horizontal;
			return _react2.default.createElement(
				_caUiToolkit.Tooltip,
				{
					title: _StringResources2.default.get('change_vis'),
					orient: 'top',
					display: 'block'
				},
				_react2.default.createElement(_VisualizationAutoMode2.default, {
					isHorizontal: isHorizontal,
					isSelected: isSelected,
					onSelect: this._onAutoSwitchIconClick,
					size: this.props.itemSize
				})
			);
		}
	};

	VisualizationPreviewList.prototype.renderListItems = function renderListItems() {
		var _props2 = this.props,
		    horizontal = _props2.horizontal,
		    isVizTypeLocked = _props2.isVizTypeLocked,
		    visStartingIndex = _props2.visStartingIndex,
		    predictData = _props2.predictData,
		    isPredictPreview = _props2.isPredictPreview,
		    onAddItem = _props2.onAddItem,
		    titleOnBottom = _props2.titleOnBottom,
		    onClickItem = _props2.onClickItem,
		    spinnerSize = _props2.spinnerSize,
		    featureSet = _props2.featureSet,
		    onPromptingError = _props2.onPromptingError,
		    isNewLayoutEnabled = _props2.isNewLayoutEnabled,
		    additionalProperties = _props2.additionalProperties,
		    noBottomTitle = _props2.noBottomTitle,
		    itemSize = _props2.itemSize,
		    dashboardApi = _props2.dashboardApi,
		    logger = _props2.logger;


		var items = this._getFinalVizItemsList();

		return items.map(function (item, i) {
			var index = visStartingIndex + i;

			// when new recommendations are coming in, if we don't make each key unique,
			// react will not pick up on the change and keep the old view without re-rendering
			// mainly because we don't do any processing of `item` in the VisualizationPreview component.
			// the proper way to do this would be to handle the new `item` prop through componentDidUpdate
			// and not care about the key.
			// for now we can live with this.
			var key = index + item.name;
			return _react2.default.createElement(_VisualizationPreview2.default, {
				isVizTypeLocked: isVizTypeLocked,
				horizontal: horizontal,
				key: key,
				visTypeName: item,
				predictData: predictData,
				isPredictPreview: isPredictPreview,
				index: index,
				item: item,
				add: onAddItem,
				titleOnBottom: titleOnBottom,
				onClick: onClickItem,
				dashboardApi: dashboardApi,
				spinnerSize: spinnerSize,
				featureSet: featureSet,
				logger: logger,
				onPromptingError: onPromptingError,
				isNewLayoutEnabled: isNewLayoutEnabled,
				additionalProperties: additionalProperties,
				noBottomTitle: noBottomTitle,
				size: itemSize
			});
		});
	};

	VisualizationPreviewList.prototype.renderSeeMore = function renderSeeMore() {
		var _classnames3;

		var classNames = (0, _classnames5.default)(CLASS_NAME + '__see-more', (_classnames3 = {}, _classnames3[CLASS_NAME + '__see-more--hidden'] = !this._isSeeMoreEnabled(), _classnames3));

		return _react2.default.createElement(
			'div',
			{ className: classNames },
			_react2.default.createElement(
				_caUiToolkit.Link,
				{
					tabIndex: '0',
					href: '#',
					target: '_self',
					'aria-label': _StringResources2.default.get('see_more_aria_label'),
					onClick: this._onClickSeeMore.bind(this),
					onKeyDown: this._onKeyDownSeeMore.bind(this)
				},
				_StringResources2.default.get('see_more')
			)
		);
	};

	VisualizationPreviewList.prototype._onKeyDownSeeMore = function _onKeyDownSeeMore(e) {
		if (e.keyCode === 13 || e.keyCode === 32) {
			this._doSeeMore(e);
		}
	};

	VisualizationPreviewList.prototype._onClickSeeMore = function _onClickSeeMore(e) {
		this._doSeeMore(e);
	};

	VisualizationPreviewList.prototype._doSeeMore = function _doSeeMore(e) {
		e.preventDefault();

		this.setState({
			maxDisplayedItems: -1,
			isExpanded: true
		});
	};

	VisualizationPreviewList.prototype._isSeeMoreEnabled = function _isSeeMoreEnabled() {
		if (this.props.enableSeeMore && !this.state.isExpanded) {
			return this.props.items.length > 3;
		}
		return false;
	};

	VisualizationPreviewList.prototype.componentDidMount = function componentDidMount() {
		if (this._rootRef.current && this.props.horizontal && this.props.hasFocus) {
			this._rootRef.current.querySelector('[tabIndex]').focus();
		}
	};

	return VisualizationPreviewList;
}(_react.Component)) || _class;

VisualizationPreviewList.propTypes = {
	dashboardApi: _propTypes2.default.object.isRequired,
	items: _propTypes2.default.array.isRequired,
	onClickItem: _propTypes2.default.func,
	onAddItem: _propTypes2.default.func,
	horizontal: _propTypes2.default.bool,
	maxDisplayedItems: _propTypes2.default.number,
	visStartingIndex: _propTypes2.default.number,
	titleOnBottom: _propTypes2.default.bool,
	enableSeeMore: _propTypes2.default.bool,
	recommendSwitch: _propTypes2.default.bool,
	isVizTypeLocked: _propTypes2.default.bool,
	selectedVisId: _propTypes2.default.string,
	additionalProperties: _propTypes2.default.arrayOf(_propTypes2.default.object),
	spinnerSize: _propTypes2.default.oneOf(['small', 'normal', 'large']),
	featureSet: _propTypes2.default.array,
	predictData: _propTypes2.default.object,
	logger: _propTypes2.default.object,
	isPredictPreview: _propTypes2.default.bool,
	onPromptingError: _propTypes2.default.func,
	isNewLayoutEnabled: _propTypes2.default.bool,
	noBottomTitle: _propTypes2.default.bool,
	itemSize: _propTypes2.default.oneOf(['small', 'medium']),
	hasFocus: _propTypes2.default.bool
};

VisualizationPreviewList.defaultProps = {
	horizontal: false,
	maxDisplayedItems: -1,
	visStartingIndex: 0,
	titleOnBottom: true,
	enableSeeMore: true,
	recommendSwitch: false,
	isVizTypeLocked: false,
	isPredictPreview: false,
	additionalProperties: [],
	spinnerSize: 'normal',
	featureSet: [],
	onPromptingError: function onPromptingError() {},
	noBottomTitle: false,
	hasFocus: true
};

exports.default = VisualizationPreviewList;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.DropDownToolbarItem = exports.CustomToolbarItem = exports.CaretToolbarItem = exports.ToolbarItem = undefined;

var _ToolbarItem = __webpack_require__(324);

var _ToolbarItem2 = _interopRequireDefault(_ToolbarItem);

var _CaretToolbarItem = __webpack_require__(94);

var _CaretToolbarItem2 = _interopRequireDefault(_CaretToolbarItem);

var _CustomToolbarItem = __webpack_require__(329);

var _CustomToolbarItem2 = _interopRequireDefault(_CustomToolbarItem);

var _DropDownToolbarItem = __webpack_require__(332);

var _DropDownToolbarItem2 = _interopRequireDefault(_DropDownToolbarItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

exports.ToolbarItem = _ToolbarItem2.default;
exports.CaretToolbarItem = _CaretToolbarItem2.default;
exports.CustomToolbarItem = _CustomToolbarItem2.default;
exports.DropDownToolbarItem = _DropDownToolbarItem2.default;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(405);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./relationshipVisView.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./relationshipVisView.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_33__;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.generateUniqueId = generateUniqueId;
exports.adoptFunctions = adoptFunctions;
exports.setUsingPatch = setUsingPatch;
exports.constructProps = constructProps;

var _mobxStateTree = __webpack_require__(7);

var CoreModelClass = __webpack_require__(68); /*
                                                                                    *+------------------------------------------------------------------------+
                                                                                    *| Licensed Materials - Property of IBM
                                                                                    *| IBM Cognos Products: Explore
                                                                                    *| (C) Copyright IBM Corp. 2018, 2019
                                                                                    *|
                                                                                    *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                    *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                    *+------------------------------------------------------------------------+
                                                                                    */


var model = new CoreModelClass(); //dont like creating model just to get the id generation

function generateUniqueId(prefix) {
	return model._generateUniqueId(prefix);
}

function adoptFunctions(coreModel, target, methodList, isBlocked, self) {
	var scope = self || target;
	for (var m in coreModel) {
		var shouldAdopt = isBlocked ? !(methodList.indexOf(m) !== -1) : methodList.indexOf(m) !== -1;
		if (typeof coreModel[m] === 'function' && shouldAdopt) {
			Object.defineProperty(target, m, {
				value: coreModel[m].bind(scope),
				writable: true
			});
		}
	}
}

function setUsingPatch(model, name, value) {
	var patch = {
		path: '/' + name,
		op: 'replace',
		value: value
	};

	(0, _mobxStateTree.applyPatch)(model, patch);
}

function constructProps(attrs) {

	var props = {
		id: _mobxStateTree.types.optional(_mobxStateTree.types.identifier, generateUniqueId('model'))
	};

	var whitelistAttrs = attrs && attrs.whitelistAttrs || [];

	whitelistAttrs.forEach(function (value) {
		props[value] = _mobxStateTree.types.union(_mobxStateTree.types.maybeNull(_mobxStateTree.types.undefined), _mobxStateTree.types.number, _mobxStateTree.types.boolean, _mobxStateTree.types.Date, _mobxStateTree.types.string);
	});
	return props;
}

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ReactLayoutImplBase = exports.LayoutBase = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(17);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _mobxStateTree = __webpack_require__(7);

var _mobx = __webpack_require__(11);

var _ExploreViewModel = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

var LayoutApi = __webpack_require__(255);

/**
 * Class representing base layout view
 * replaces dashboard core's LayoutBaseView
 * Each LayoutBase view wraps around a 'ReactLayoutImplBase' based view implementation specified by this.Component
 * The root 'LayoutBase' view gets a DOM element and bootstraps a vdom tree
 * To render a 'LayoutBase' hierarchy, each view receives it's children's JSX markup in this.childrenRenderMarkup
 * and then it includes that in it's render JSX markup
 *
 * Each 'LayoutBase' view has the following functions
 *   getRenderMarkup         : returns JSX using this.Component or from this.view (the react view instance)
 *   addChildRenderMarkup    : called by 'LayoutController infrastructure' when a child view is instantiated
 *   getChildrenRenderMarkup : returns the received child render markup
 *
 * In simple terms, 'LayoutController infrastructure' refers to Layout authoring helper class, eventing
 * via CommonAuthoringFeature & LayoutController.createLayoutModel()
 * TODO: reduce dependence on 'LayoutController infrastructure'
 */
var LayoutBase = exports.LayoutBase = function () {
	function LayoutBase(props) {
		_classCallCheck(this, LayoutBase);

		this.dashboardApi = props.dashboardApi;
		this.content = props.content;
		this.layoutController = props.layoutController;
		this.parentLayout = props.parentLayout;
		this.authorHelper = props.authorHelper;

		this.model = props.model;
		this.services = props.services;
		this.logger = this.services.biGlass.glassContext.getCoreSvc('.Logger');
		this.Component = this.Component || props.Component;

		this.id = props.model.id;

		//Each layout view may have child layout views.
		//As each child layout view is created and is ready, its render markup gets added to
		//the parent's childrenRenderMarkup
		//This is how react based views get rendered
		this.childrenRenderMarkup = [];

		//When we add a child layout e.g. card gets added to explore container, explore container
		//should be rendered again. When we are adding multiple child layouts at the same time e.g.
		//multi-select and duplicate cards, if we render ExploreContainer again for every child that
		//becomes available, it makes for inefficient rendering
		//If we have a way to only render the parent when all its children layouts are ready, it reduces
		//the number of times parent is rendered
		//
		//shouldRenderCount is used a simple perf tweak to reduce the number of renders
		//shouldRenderCount indicates the number of children whose markup is ready
		//as each child markup is made available, childCount is updated
		//when childCount is equal to the number of children in the model, we know that we have all
		//the children markup ready, so now the parent layout can simply observe changes in shouldRenderCount
		//and render
		this.renderTracker = (0, _mobx.observable)({ shouldRenderCount: 0 });
		this.childCount = 0;

		this.$el = this.layoutController.$el.find('#' + this.id); //TODO: get rid of jquery
		this.domNode = this.$el.get(0);

		if (this._isTopLevel()) {
			var reactLayoutClass = this.model.type + '-react-layout-view';
			this.$el.addClass(reactLayoutClass);
		}

		this._alive = true;

		this.api = new LayoutApi(this);
	}

	LayoutBase.prototype.destroy = function destroy() {
		var _this = this;

		clearTimeout(this.resizeTimer);
		this.authorHelper && this.authorHelper.destroy();
		this.removeRenderMarkupFromParent();
		this.layoutController.removeView(this);
		this._alive = false;

		var destroyChild = function destroyChild(item) {
			if (item) {
				var e = { value: { parameter: item.id } };
				_this.layoutController.destroyLayoutView(item.id, e);
			}
		};
		if (this.model.items) {
			this.model.items.forEach(destroyChild);
		}

		if (this._mountedComponent) {
			_reactDom2.default.unmountComponentAtNode(this.$el[0]);
		}

		if (this.domNode) {
			this.domNode._layout = null;
		}
	};

	LayoutBase.prototype.setViewImpl = function setViewImpl(view) {
		this.view = view;
	};

	LayoutBase.prototype.getChildRenderMarkup = function getChildRenderMarkup(childId) {
		return this.childrenRenderMarkup.find(function (entry) {
			return entry.id === childId;
		});
	};

	LayoutBase.prototype.addChildRenderMarkup = function addChildRenderMarkup(childId, renderMarkup) {
		var found = this.getChildRenderMarkup(childId);
		if (!found) {
			this.childrenRenderMarkup.push({ id: childId, value: renderMarkup });
			this.childCount++;
			this._tagReadyForRender();
		}
		return !found;
	};

	LayoutBase.prototype._tagReadyForRender = function _tagReadyForRender() {
		var numChildren = this.model.items && this.model.items.length || 0;
		if (this.childCount === numChildren) {
			this.renderTracker.shouldRenderCount = this.childCount;
		}
	};

	LayoutBase.prototype.removeChildRenderMarkup = function removeChildRenderMarkup(childId) {
		this.childrenRenderMarkup = this.childrenRenderMarkup.filter(function (entry) {
			return entry.id !== childId;
		});
		this.childCount--;
		this._tagReadyForRender();
	};

	LayoutBase.prototype.getChildrenRenderMarkup = function getChildrenRenderMarkup() {
		return this.childrenRenderMarkup;
	};

	LayoutBase.prototype.getRenderMarkup = function getRenderMarkup() {
		return this.view && this.view.getRenderMarkup();
	};

	LayoutBase.prototype.addToParentRenderMarkup = function addToParentRenderMarkup() {
		if (this.parentLayout) {
			this.parentLayout.addChildRenderMarkup(this.id, this.getRenderMarkup());
		}
	};

	LayoutBase.prototype.removeRenderMarkupFromParent = function removeRenderMarkupFromParent() {
		if (this.parentLayout) {
			this.parentLayout.removeChildRenderMarkup(this.id);
		}
	};

	// --- PUBLIC METHODS

	LayoutBase.prototype.getTemplate = function getTemplate() {
		return ['<div id="{{id}}" tabindex="-1" class="page {{type}}-react-layout-view{{extraCSS}}"{{style}}>{{items}}</div>'];
	};

	LayoutBase.prototype.getNodeId = function getNodeId() {
		console.warn('`getNodeId` called - not implemented yet');
	};

	LayoutBase.prototype.onResize = function onResize() {
		// not implemented, we rely on `react-measure` to figure out when the widgets have resized.
	};

	LayoutBase.prototype.resize = function resize() {
		this.resizeChildren(0);
	};

	LayoutBase.prototype.resizeChildren = function resizeChildren(timeout) {
		clearTimeout(this.resizeTimer);
		this.resizeTimer = setTimeout(this._onResize.bind(this), timeout);
	};

	LayoutBase.prototype._onResize = function _onResize() {
		var _this2 = this;

		clearTimeout(this.resizeTimer);

		if (!this._alive) {
			return;
		}

		var handleResize = function handleResize(item) {
			var view = _this2.layoutController.getLayoutView(item.id);
			if (view && view.onResize) {
				// do not try re-sizing hidden el ements, as their sizes won't be accurate
				if (!view.$el.is(':hidden') && view.widget && view.widget.isFirstRenderComplete && view.widget.isFirstRenderComplete()) {
					view.onResize();
				} else {
					view.resizeOnShow();
				}
			}
		};

		//TODO: can we avoid isAlive check ??
		if ((0, _mobxStateTree.isAlive)(this.model)) {
			if (this.model.items) {
				this.model.items.forEach(function (item) {
					item.items && item.items.forEach(handleResize);
					handleResize(item);
				});
			}
		}
	};

	LayoutBase.prototype.onSelect = function onSelect() {
		console.warn('`onSelect` called - not implemented yet');
	};

	LayoutBase.prototype.onDeselect = function onDeselect() {
		console.warn('`onDeselect` called - not implemented yet');
	};

	LayoutBase.prototype._isTopLevel = function _isTopLevel() {
		return this.model.boardModel.layout.id === this.model.id;
	};

	LayoutBase.prototype.onShow = function onShow() {
		if (this.Component && this.view) {
			return; //already mounted nothing to do
		}
		if (!this.$el.length) {
			return; //can't render without a DOM element
		}

		this._beforeOnShowForAllChildren();
		this._callChildrenFunction('addToParentRenderMarkup');

		this.beforeOnShow && this.beforeOnShow();

		this.model.setDisplayStyleOn();

		this._mountedComponent = true;
		_reactDom2.default.unmountComponentAtNode(this.$el[0]);
		var e = _react2.default.createElement(this.Component, {
			items: this.model ? this.model.items : [],
			model: this.model,
			services: this.services,
			layoutController: this.layoutController,
			dashboardApi: this.dashboardApi,
			layoutOwner: this
		});
		_reactDom2.default.render(e, this.$el.get(0));

		this.$el.get(0)._layout = this; //to allow LayoutController to destroy top level layout !?#@
	};

	LayoutBase.prototype.render = function render() {
		this.onShow();
	};

	LayoutBase.prototype.renderContent = function renderContent(additionalWidgetData) {
		var _this3 = this;

		var stateApi = this.content.getFeature('state.internal');
		stateApi.setStatus(stateApi.STATUS.RENDERING);
		// to be implemented by views
		var promises = [];
		if (this.model.items) {
			for (var i = 0; i < this.model.items.length; i++) {
				promises.push(this.layoutController.createLayoutModule(this.model.items[i].id, this, additionalWidgetData).then(function (layout) {
					return layout.renderContent();
				}));
			}
		}
		return Promise.all(promises).then(function () {
			stateApi.setStatus(stateApi.STATUS.RENDERED);
			_this3.layoutController.markViewAsReady(_this3);
		});
	};

	LayoutBase.prototype.removeChild = function removeChild() {
		//no op
	};

	LayoutBase.prototype.onHide = function onHide() {
		console.warn('`onHide` called - not implemented yet');
	};

	LayoutBase.prototype.onTransition = function onTransition() {
		console.warn('`onTransition` called - not implemented yet');
	};

	LayoutBase.prototype.afterTransition = function afterTransition() {
		console.warn('`afterTransition` called - not implemented yet');
	};

	LayoutBase.prototype.resizeOnShow = function resizeOnShow() {
		console.warn('`resizeOnShow` called - not implemented yet');
	};

	LayoutBase.prototype.getProperties = function getProperties() {
		console.warn('`getProperties` called - not implemented yet');
	};

	LayoutBase.prototype.getBannerProperty = function getBannerProperty() {
		console.warn('`getBannerProperty` called - not implemented yet');
	};

	LayoutBase.prototype.reduce = function reduce() {
		console.warn('`reduce` called - not implemented yet');
	};

	LayoutBase.prototype.setLoading = function setLoading() {
		console.warn('`setLoading` called - not implemented yet');
	};

	LayoutBase.prototype.getSelectedSubViewId = function getSelectedSubViewId() {
		if (this.model.exploreVM.isStartingPointsDisplayed()) {
			return _ExploreViewModel.STARTING_POINTS;
		}
		return this.model.exploreVM.getDisplayedCard();
	};

	// --- PRIVATE METHODS

	LayoutBase.prototype._callChildrenFunction = function _callChildrenFunction(name) {
		var _this4 = this;

		(this.model.items || []).forEach(function (item) {
			var view = _this4.layoutController.getLayoutView(item.id);
			if (view && view[name]) {
				view[name]();
			}
		});
	};

	LayoutBase.prototype._beforeOnShowForAllChildren = function _beforeOnShowForAllChildren() {
		var _this5 = this;

		(this.model.items || []).forEach(function (item) {
			var view = _this5.layoutController.getLayoutView(item.id);
			if (view) {
				if (_this5._beforeOnShow) {
					_this5._beforeOnShow(item.id, view);
				}
				if (view._beforeOnShowForAllChildren) {
					view._beforeOnShowForAllChildren();
				}
			}
		});
	};

	LayoutBase.prototype.getAPI = function getAPI() {
		return this.api;
	};

	return LayoutBase;
}();

/**
 * Class representing react based view implementation for 'LayoutBase' views
 * Keeping the view implemenation separate from 'LayoutBase' layout owner to help with rendering
 * layout view hierarchies
 */


var ReactLayoutImplBase = exports.ReactLayoutImplBase = function (_Component) {
	_inherits(ReactLayoutImplBase, _Component);

	function ReactLayoutImplBase(props) {
		_classCallCheck(this, ReactLayoutImplBase);

		var _this6 = _possibleConstructorReturn(this, _Component.call(this, props));

		_this6.layoutOwner = props.layoutOwner;
		_this6.layoutOwner.setViewImpl(_this6);
		_this6.model = props.model;
		_this6.layoutController = props.layoutController;
		_this6.services = props.services;
		_this6.dashboardApi = props.dashboardApi;
		return _this6;
	}

	ReactLayoutImplBase.prototype.getChildrenRenderMarkup = function getChildrenRenderMarkup() {
		return this.layoutOwner.getChildrenRenderMarkup();
	};

	ReactLayoutImplBase.prototype.getRenderMarkup = function getRenderMarkup() {
		return {};
	};

	return ReactLayoutImplBase;
}(_react.Component);

ReactLayoutImplBase.propTypes = {
	items: _PropTypes2.default.array,
	layoutController: _PropTypes2.default.object,
	services: _PropTypes2.default.object,
	dashboardApi: _PropTypes2.default.object,
	parentLayout: _PropTypes2.default.object,
	model: _PropTypes2.default.object,
	layoutOwner: _PropTypes2.default.object.isRequired,
	footerView: _PropTypes2.default.object
};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_39__;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

exports.default = [{
  id: 'widget.legend.display',
  value: false
}];

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.CalcType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
                                                                                                                                                                                                                                                                               *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                               *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                               *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                               *| (C) Copyright IBM Corp. 2018, 2019, 2020
                                                                                                                                                                                                                                                                               *|
                                                                                                                                                                                                                                                                               *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                               *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                               *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                               */

var _mobxStateTree = __webpack_require__(7);

var _FormatterWrapper = __webpack_require__(71);

var NA = '-';

var CalcType = exports.CalcType = {
	TOTAL: 'total',
	TOTAL_SEL: 'totalSelection',
	MIN_SEL: 'minSelection',
	MAX_SEL: 'maxSelection',
	DIFF: 'difference',
	DIFF_SEL: 'differenceSelection',
	PERCENT_vsALLDATA: 'percentVsAllData',
	PERCENT_SEL_vsALLDATA: 'percentSelVsAllData',
	PERCENT_CHARTvsCHART: 'percentChartVsChart',
	PERCENT_SELvsCHART: 'percentSelVsChart',
	MIN: 'min',
	MAX: 'max',
	AVG: 'avg',
	AVG_SEL: 'avgSelection',
	WEIGHTED_AVG: 'weightedAvg',
	WEIGHTED_AVG_SEL: 'weightedAvgSelection',
	DETAIL_ROWCOUNT: 'detailRowCount',
	DETAIL_SUM: 'detailSum',
	SEL_CONTEXT: 'selectionContext',
	NUM_SELECTIONS: 'numSelections',
	HAS_NEGATIVE_VALUES: 'hasNegativeValues',
	MISSING_VALUE_COUNT: 'missingValueCount',
	ROW_COUNT: 'rowCount',
	SUMMARY_USE: 'summaryUse'
};

//Get a single tooltip for a compare table column from string resources based on the calculation and an optional line#.
//If a missingValueCount is included, both the 'pure tooltip' is included (for no missingValueCount or missingValueCount=0)
//AND a 'missingValueCount' id should exist in exploreResources (that reports the missing values in some way)
//Form: compareTable_tip_<aggtype>{_n}{_missingValueCount}
function _getCompareTableTip(getStringRes, calc, params, lineNumber) {
	var lineNumberStr = lineNumber === undefined ? '' : '_' + lineNumber;
	var missingValueCountStr = params.missingValueCount && params.missingValueCount > 0 ? '_missingValueCount' : '';
	var toolTipId = 'compareTable_tip_' + calc + lineNumberStr + missingValueCountStr;
	return getStringRes(toolTipId, params);
}

function _getToolTipsList(getStringRes, num, calc, params) {
	if (getStringRes) {
		var tips = [];
		for (var i = 0; i < num; i++) {
			tips[i] = _getCompareTableTip(getStringRes, calc, params, i);
		}
		return tips;
	}
	return undefined;
}

//Get a single tooltip for the combined column of the compare table from string resources based on the calculation and an optional line#.
function _getCombinationToolTip(getStringRes, calc, params, lineNumber) {
	var lineNumberStr = lineNumber === undefined ? '' : '_' + lineNumber;
	return getStringRes('compareTable_tip_combination_' + calc + lineNumberStr, params);
}

function _getCombinationToolTipsList(getStringRes, num, calc, params) {
	if (getStringRes) {
		var tips = [];
		for (var i = 0; i < num; i++) {
			tips[i] = _getCombinationToolTip(getStringRes, calc, params, i);
		}
		return tips;
	}
	return undefined;
}

function _getCombinedCalcTooltip(getString, allMeasuresSame, widgetContextCheckResult) {
	if (getString) {
		var tips = [];
		if (!allMeasuresSame) {
			tips[0] = getString('compareTable_tip_na_incompatible_measures');
		} else if (widgetContextCheckResult && !widgetContextCheckResult.canCombineCalculations) {
			tips[0] = getString('compareTable_tip_na_overlap');
		} else if (widgetContextCheckResult && !widgetContextCheckResult.isCategoryContextSame) {
			tips[0] = getString('compareTable_tip_na_category_context');
		}
		return tips;
	}
	return undefined;
}

function _round(num) {
	var rounded = Math.round(num * 100) / 100;
	if (rounded === 0) {
		rounded = Math.round(num * 1000) / 1000;
	}
	if (rounded === 0) {
		rounded = Math.round(num * 10000) / 10000;
	}
	return rounded;
}

function _formatNumber(theNumber, formatSpec) {
	if (isNaN(theNumber) || theNumber === NA) {
		return NA; //The string equivalent to undefined is NA (-)
	} else if (typeof formatSpec !== 'undefined') {
		return _FormatterWrapper.Formatter.format(theNumber, formatSpec);
	}
	return theNumber; //Its not a number....just return what was passed in.
}

function _formatPercent(theNumber, formatSpec) {
	if (formatSpec) {
		//Use the locale from the formatSpec to determine how to format the number as a %age.
		var formatSpecForPercent = { locale: formatSpec.locale };
		return _formatNumber(theNumber, formatSpecForPercent);
	}
	return theNumber;
}

function _percentString(num) {
	if (typeof num === 'number') {
		return isNaN(num) ? num : num + '%';
	} else {
		return num !== 'NaN' && num !== NA ? num + '%' : NA;
	}
}

function _isMinMax(aggType) {
	return aggType === 'min' || aggType === 'max';
}

function _isMin(aggType) {
	return aggType === 'min';
}

function _isMax(aggType) {
	return aggType === 'max';
}

function _isAvg(aggType) {
	return aggType === 'avg';
}

function _isCountDistinct(aggType) {
	return aggType === 'countdistinct';
}

function _isSummable(aggType) {
	return aggType && (aggType === 'sum' || aggType === 'count');
}

function _supportsAverage(aggType) {
	//Averages are supported for summables (sum/count) and minMax.
	return _isMinMax(aggType) || _isSummable(aggType);
}

function _supportsWeightedAverage(aggType) {
	//Weighted Averages are supported for avg only (currently)
	return _isAvg(aggType);
}

function _checkAggregateType(measures, fn) {
	if (measures.length === 0) {
		return false;
	}
	var agg = true;
	measures.forEach(function (measure) {
		var meta = measure && measure.metadata && measure.metadata.aggregationType;
		agg = agg && fn(meta);
	});
	return agg;
}

function _atleastOneAggType(measures, fn) {
	if (measures.length === 0) {
		return false;
	}
	var agg = measures.some(function (measure) {
		var meta = measure && measure.metadata && measure.metadata.aggregationType;
		return fn(meta);
	});
	return agg;
}

function _atleastOneAggTypeSupportsAverages(measures) {
	//Simple averages are valid for min/max/count/sum.
	return _atleastOneAggType(measures, _isSummable) || _atleastOneAggType(measures, _isMinMax);
}

function _addAverage(stats) {
	var measures = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	//This function appends average to the supplied stats array
	//If measures is passed in, the calc is only appended if the check for applicable types passes.
	if (!measures || _atleastOneAggTypeSupportsAverages(measures)) {
		stats.push(CalcType.AVG);
	}
}

function _addAverageSel(stats) {
	var measures = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	//This function appends average to the supplied stats array (selection case)
	//If measures is passed in, the calc is only appended if the check for applicable types passes.
	if (!measures || _atleastOneAggTypeSupportsAverages(measures)) {
		stats.push(CalcType.AVG_SEL);
	}
}

function _checkAggregateTypeGeneric(entries, fn) {
	if (entries.length === 0) {
		return false;
	}
	var agg = true;
	entries.forEach(function (measure) {
		var meta = measure.aggregationType;
		agg = agg && fn(meta);
	});
	return agg;
}

function _areAllMeasuresSame(statsInfoList) {
	var isInCompatible = false;
	if (statsInfoList.length === 0) {
		return false;
	}

	var name = undefined;
	isInCompatible = statsInfoList.some(function (statsInfo) {
		if (!name) {
			name = statsInfo.measureName;
			return false;
		} else {
			return name !== statsInfo.measureName;
		}
	});
	return !isInCompatible;
}

function _oneOrMoreRowCountsGreaterThanZero(statsInfoList) {
	return statsInfoList.some(function (statsInfo) {
		var stats = statsInfo.statsUse;
		var rowCount = stats[CalcType.ROW_COUNT];
		return rowCount > 0;
	});
}

function _getMeasureValue(aggType, valueArray) {
	// the total used for _isMin(aggType) || _isMax(aggType) to compute the average is not displayed directly and is not applicable calculation
	if (_isSummable(aggType) || _isMin(aggType) || _isMax(aggType)) {
		if (valueArray && isNaN(valueArray)) {
			return _getValueTotal(valueArray);
		} else {
			return valueArray || 0;
		}
	} else if (_isAvg(aggType)) {
		return valueArray;
	} else {
		return undefined;
	}
}

function _getValueCount(measureDetail) {
	// to match predict we discount nulls and other non numeric values
	return measureDetail && measureDetail['values'].filter(function (e) {
		return typeof e === 'number';
	}).length || 0;
}

function _getMissingValueCount(measureDetail) {
	// for selection stats we count nulls as missing values
	return measureDetail && measureDetail['values'].filter(function (e) {
		return e === null;
	}).length || 0;
}

function _getValueTotal(valueArray) {
	return valueArray.length > 0 && valueArray.reduce(function (accumulator, currentValue) {
		return accumulator + currentValue;
	}) || 0;
}

/***********************
 * Compare table stats
 ***********************/

function getChartSummaryStats(options) {
	var newCompareTableStatsEnabled = options.newCompareTableStatsEnabled,
	    statsModel = options.statsModel,
	    chartVsChart = options.chartVsChart,
	    measureName = options.measureName,
	    getString = options.getString,
	    widgetAlias = options.widgetAlias;


	var getTooltipList = function getTooltipList() {
		for (var _len = arguments.length, theArgs = Array(_len), _key = 0; _key < _len; _key++) {
			theArgs[_key] = arguments[_key];
		}

		return getString && _getToolTipsList.apply(undefined, [getString].concat(theArgs)) || '';
	};

	var stats = {};
	var statsUse = {};
	var toolTip = {};

	//Formatted strings reported in the compare table.
	var min = NA;
	var max = NA;
	var avg = NA;
	var weightedAvg = NA;
	var difference = void 0;
	var total = NA;
	var percentVsAllData = NA;
	var percentChartVsChart = NA;

	//Unformatted values.
	var totalUse = void 0,
	    minUse = void 0,
	    maxUse = void 0,
	    avgUse = void 0,
	    rowCount = void 0,
	    weightedAvgUse = void 0,
	    detailSumUse = void 0,
	    detailRowCountUse = void 0,
	    missingValueCount = void 0;

	//Calculated strings
	var percentVsAllData_f = percentVsAllData;
	var percentChartVsChart_f = percentChartVsChart;

	//Tooltips
	var percentVsAllDataTip = '',
	    percentChartVsChartTip = '',
	    totalTip = '';

	var measuresMap = statsModel.measures || new Map();
	var measureDetail = measuresMap.get(measureName);
	var meta = measureDetail && measureDetail.get('metadata');
	var hasNegativeValues = measureDetail && measureDetail.get('hasNegativeValues') || false;

	var aggregationType = meta && meta.aggregationType;
	var summaryUse = measureDetail && measureDetail.get('summaryValueUse');

	if (measureDetail) {
		min = measureDetail.get('min');
		max = measureDetail.get('max');
		avg = measureDetail.get('avg');
		weightedAvg = measureDetail.get('weightedAvg') || NA;
		minUse = measureDetail.get('minUse');
		maxUse = measureDetail.get('maxUse');
		avgUse = measureDetail.get('avgUse');
		rowCount = measureDetail.get('rowCount');

		//Note: The formatted "total" should be N/A UNLESS the aggregation type is summable (sum/count) so don't save it otherwise
		//However: save totalUse into the statsUse table so that it can be used to calculate averages of min and max (see _computeAverageData()).
		totalUse = measureDetail.get('totalUse');

		weightedAvgUse = measureDetail.get('weightedAvgUse');
		//These 2 are intermediate use values for calculation a combined detail average.
		detailSumUse = measureDetail.get('detailSumUse');
		detailRowCountUse = measureDetail.get('detailRowCountUse');
		missingValueCount = measureDetail.get('missingValueCount');
	}

	if (meta) {
		if (_isSummable(meta.aggregationType)) {
			total = measureDetail.get('total');

			var summaryUse_f = _formatNumber(summaryUse, formatSpec);

			percentChartVsChart = chartVsChart && chartVsChart[measureName] && chartVsChart[measureName].value;
			percentVsAllData = _round(totalUse / summaryUse * 100);

			var allChartTotal = chartVsChart && chartVsChart[measureName] && chartVsChart[measureName].allChartTotal;

			var formatSpec = meta.format;
			total = total || _formatNumber(totalUse, formatSpec);
			summaryUse_f = _formatNumber(summaryUse_f, formatSpec);
			allChartTotal = _formatNumber(allChartTotal, formatSpec);

			percentVsAllData_f = _formatPercent(percentVsAllData, formatSpec);
			percentChartVsChart_f = _formatPercent(percentChartVsChart, formatSpec);
			//Present a tooltip if this total has negative values.
			totalTip = hasNegativeValues && getTooltipList(2, CalcType.TOTAL, { itemName: meta.label, widgetAlias: widgetAlias });
			// Show tooltips only when formatted total use, summary use and allChartTotal are defined
			if ((typeof total === 'undefined' ? 'undefined' : _typeof(total)) !== NA && summaryUse_f !== NA && typeof allChartTotal !== 'undefined') {
				percentChartVsChartTip = getTooltipList(2, CalcType.PERCENT_CHARTvsCHART, { widgetAlias: widgetAlias, total: total, allChartTotal: allChartTotal });
				percentVsAllDataTip = getTooltipList(hasNegativeValues ? 3 : 2, CalcType.PERCENT_vsALLDATA, { widgetAlias: widgetAlias, total: total, summary: summaryUse_f });
			}
		} else if (newCompareTableStatsEnabled && _isCountDistinct(aggregationType)) {
			totalUse = measureDetail.get('filteredSummaryValueUse');
			total = measureDetail.get('filteredSummaryValue');
			if (totalUse !== undefined && summaryUse !== undefined) {
				var _formatSpec = meta.format;
				percentVsAllData = _round(totalUse / summaryUse * 100);
				percentVsAllData_f = _formatPercent(percentVsAllData, _formatSpec);
				var _summaryUse_f = _formatNumber(summaryUse, _formatSpec);
				totalTip = _getCompareTableTip(getString, aggregationType + '_' + CalcType.TOTAL, { uniqueValues: total, label: meta.label, overallSummaryValue: _summaryUse_f });
				percentVsAllDataTip = _getCompareTableTip(getString, aggregationType + '_' + CalcType.PERCENT_vsALLDATA, { uniqueValues: total, label: meta.label, percent: _percentString(percentVsAllData_f), overallSummaryValue: _summaryUse_f });
			}
		}
	}

	var supportsAvg = _supportsAverage(aggregationType) && (avg || avg === 0);
	//all stats for selection are NA
	stats[CalcType.TOTAL] = total || total === 0 ? total : NA;
	stats[CalcType.TOTAL_SEL] = NA;
	stats[CalcType.MIN_SEL] = NA;
	stats[CalcType.MAX_SEL] = NA;
	stats[CalcType.DIFF] = difference;
	stats[CalcType.DIFF_SEL] = undefined;
	stats[CalcType.PERCENT_vsALLDATA] = percentVsAllData_f && _percentString(percentVsAllData_f) || NA;
	stats[CalcType.PERCENT_CHARTvsCHART] = percentChartVsChart_f && _percentString(percentChartVsChart_f) || NA;
	stats[CalcType.PERCENT_SELvsCHART] = NA;
	stats[CalcType.MIN] = typeof min !== 'undefined' ? min.toString() : NA;
	stats[CalcType.MAX] = typeof max !== 'undefined' ? max.toString() : NA;
	stats[CalcType.AVG] = supportsAvg ? avg.toString() : NA;
	stats[CalcType.WEIGHTED_AVG] = _supportsWeightedAverage(aggregationType) ? weightedAvg : NA;
	stats[CalcType.NUM_SELECTIONS] = NA;
	stats[CalcType.ROW_COUNT] = rowCount || NA;
	stats[CalcType.MISSING_VALUE_COUNT] = missingValueCount || NA;

	statsUse[CalcType.TOTAL] = totalUse || totalUse === 0 ? totalUse : NA;
	statsUse[CalcType.DIFF] = 0;
	statsUse[CalcType.PERCENT_vsALLDATA] = percentVsAllData;
	statsUse[CalcType.PERCENT_CHARTvsCHART] = percentChartVsChart;
	statsUse[CalcType.PERCENT_SELvsCHART] = NA;
	statsUse[CalcType.MIN] = minUse || minUse === 0 ? minUse : NA;
	statsUse[CalcType.MAX] = maxUse || maxUse === 0 ? maxUse : NA;
	statsUse[CalcType.AVG] = _supportsAverage(aggregationType) ? avgUse : NA;
	statsUse[CalcType.ROW_COUNT] = rowCount;
	statsUse[CalcType.MISSING_VALUE_COUNT] = missingValueCount;

	statsUse[CalcType.WEIGHTED_AVG] = _supportsWeightedAverage(aggregationType) ? weightedAvgUse : NA;
	statsUse[CalcType.DETAIL_ROWCOUNT] = detailRowCountUse;
	statsUse[CalcType.DETAIL_SUM] = detailSumUse;
	statsUse[CalcType.NUM_SELECTIONS] = 0;
	statsUse[CalcType.SUMMARY_USE] = summaryUse;

	if (hasNegativeValues && aggregationType === 'sum') {
		//If the stats returns that there are negative values AND this is a summed item, mark BOTH the TOTAL and PERCENT_vsALLDATA cells (and augment tooltips)
		statsUse[CalcType.HAS_NEGATIVE_VALUES] = [CalcType.TOTAL, CalcType.PERCENT_vsALLDATA];
	}

	toolTip[CalcType.PERCENT_vsALLDATA] = percentVsAllDataTip;
	toolTip[CalcType.PERCENT_CHARTvsCHART] = percentChartVsChartTip;
	if (totalTip) {
		toolTip[CalcType.TOTAL] = totalTip;
	}
	if (stats[CalcType.WEIGHTED_AVG] !== NA) {
		toolTip[CalcType.WEIGHTED_AVG] = _getCompareTableTip(getString, CalcType.WEIGHTED_AVG, { weightedAvg: weightedAvg, detailRowCount: detailRowCountUse, missingValueCount: missingValueCount });
	}
	if (stats[CalcType.AVG] !== NA) {
		toolTip[CalcType.AVG] = _getCompareTableTip(getString, CalcType.AVG, { avg: avg, rowCount: rowCount, missingValueCount: missingValueCount });
	}

	return { stats: stats, statsUse: statsUse, toolTip: toolTip, aggregationType: aggregationType, measureName: measureName, meta: meta, widgetAlias: widgetAlias };
}

/***********************
 * Compare table selection stats
 ***********************/

function getSelectionContextLabel(selStatsModel, measureName) {
	var lastCategorySelection = selStatsModel.lastCategorySelection && (0, _mobxStateTree.getSnapshot)(selStatsModel.lastCategorySelection) || [];

	var measuresMap = selStatsModel.measures || new Map();
	var measureDetail = measuresMap.get(measureName);
	var numSelections = _getValueCount(measureDetail);

	var lastCategorySelectionLabel = lastCategorySelection.length > 1 ? lastCategorySelection.join(' | ') : lastCategorySelection[0] || '';
	return { lastCategorySelectionLabel: lastCategorySelectionLabel, numSelections: numSelections };
}

function getChartSelectionSummaryStats(options) {
	var newCompareTableStatsEnabled = options.newCompareTableStatsEnabled,
	    statsModel = options.statsModel,
	    selStatsModel = options.selStatsModel,
	    measureName = options.measureName,
	    getString = options.getString,
	    widgetAlias = options.widgetAlias;


	var getTooltipList = function getTooltipList() {
		for (var _len2 = arguments.length, theArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			theArgs[_key2] = arguments[_key2];
		}

		return getString && _getToolTipsList.apply(undefined, [getString].concat(theArgs)) || '';
	};

	var stats = {};
	var statsUse = {};
	var toolTip = {};

	var min_f = NA;
	var max_f = NA;
	var avg_f = NA;
	var weightedAvg_f = NA;
	var totalUse_f = NA;
	var minSelection = void 0;
	var maxSelection = void 0;
	var hasNegativeValues = false;
	var difference = void 0;
	var percentVsAllData = NA;
	var percentSelVsChart = NA;
	var defTotalUse = void 0,
	    avgUse = void 0,
	    weightedAvgUse = void 0,
	    detailRowCountUse = void 0,
	    detailSumUse = void 0;
	var percentVsAllData_f = percentVsAllData,
	    percentSelVsChart_f = percentSelVsChart;

	var percentVsAllDataTip = '',
	    percentSelVsChartTip = '',
	    totalSelTip = '';

	var defMeasuresMap = statsModel.measures || new Map();
	var defMeasureDetail = defMeasuresMap.get(measureName);
	var meta = defMeasureDetail && defMeasureDetail.get('metadata');

	var measuresMap = selStatsModel.measures || new Map();
	var measureDetail = measuresMap.get(measureName);

	var lastCategorySelection = selStatsModel.lastCategorySelection && (0, _mobxStateTree.getSnapshot)(selStatsModel.lastCategorySelection) || [];
	var formatSpec = meta && meta.format;

	var aggregationType = meta && meta.aggregationType;

	var value = void 0;
	var numSelections = _getValueCount(measureDetail);
	var rowCount = _getValueCount(measureDetail);
	var missingValueCount = _getMissingValueCount(measureDetail);

	var lastCategorySelectionLabel = lastCategorySelection.length > 1 ? lastCategorySelection.join(' | ') : lastCategorySelection;
	if (numSelections > 1) {
		lastCategorySelectionLabel = lastCategorySelectionLabel + '+' + (numSelections - 1);
	}

	var totalUse = _getMeasureValue(aggregationType, measureDetail && measureDetail['values']);
	totalUse = _round(totalUse);
	var summaryUse = defMeasureDetail && defMeasureDetail.get('summaryValueUse');

	if (meta && _isSummable(aggregationType)) {
		defTotalUse = defMeasureDetail.get('totalUse');
		hasNegativeValues = defMeasureDetail.get('hasNegativeValues');
		percentSelVsChart = _round(totalUse / defTotalUse * 100);
		percentVsAllData = _round(totalUse / summaryUse * 100);

		var _formatSpec2 = meta.format;
		var defTotalUse_f = defTotalUse,
		    summaryUse_f = summaryUse;
		totalUse_f = _formatNumber(totalUse, _formatSpec2);
		summaryUse_f = _formatNumber(summaryUse_f, _formatSpec2);
		defTotalUse_f = _formatNumber(defTotalUse_f, _formatSpec2);

		percentVsAllData_f = _formatPercent(percentVsAllData, _formatSpec2);
		percentSelVsChart_f = _formatPercent(percentSelVsChart, _formatSpec2);
		totalSelTip = hasNegativeValues && getTooltipList(2, CalcType.TOTAL_SEL, { itemName: meta.label, widgetAlias: widgetAlias });
		percentSelVsChartTip = getTooltipList(2, CalcType.PERCENT_SELvsCHART, { widgetAlias: widgetAlias, total: totalUse_f, summary: defTotalUse_f });
		percentVsAllDataTip = getTooltipList(hasNegativeValues ? 3 : 2, CalcType.PERCENT_SEL_vsALLDATA, { widgetAlias: widgetAlias, total: totalUse_f, summary: summaryUse_f });
	}
	//Report min and max as actual values (even for the summables) if the combination of aggregation types makes sense.
	var allValues = measureDetail && measureDetail['values'] || [];
	maxSelection = Math.max.apply(Math, allValues);
	maxSelection = _round(maxSelection);
	var maxSelection_f = maxSelection;
	minSelection = Math.min.apply(Math, allValues);
	minSelection = _round(minSelection);
	var minSelection_f = minSelection;

	if (formatSpec) {
		maxSelection_f = _formatNumber(maxSelection_f, formatSpec);
		minSelection_f = _formatNumber(minSelection_f, formatSpec);
	}

	if (meta && (_isMin(aggregationType) || _isCountDistinct(aggregationType))) {
		min_f = _formatNumber(value, formatSpec);
	}

	if (meta && (_isMax(aggregationType) || _isCountDistinct(aggregationType))) {
		max_f = _formatNumber(value, formatSpec);
	}

	if (newCompareTableStatsEnabled && meta && _isCountDistinct(aggregationType)) {
		totalUse = measureDetail && measureDetail.filteredSummaryValueUse;
		totalUse_f = _formatNumber(totalUse, formatSpec);

		percentVsAllData = _round(totalUse / summaryUse * 100);
		percentVsAllData_f = _formatPercent(percentVsAllData, formatSpec);
		if (totalUse !== undefined && summaryUse !== undefined) {
			var _formatSpec3 = meta.format;
			var _summaryUse_f2 = _formatNumber(summaryUse, _formatSpec3);
			totalSelTip = _getCompareTableTip(getString, aggregationType + '_' + CalcType.TOTAL_SEL, { uniqueValues: totalUse_f, label: meta.label, overallSummaryValue: _summaryUse_f2 });
			percentVsAllDataTip = _getCompareTableTip(getString, aggregationType + '_' + CalcType.PERCENT_SEL_vsALLDATA, { uniqueValues: totalUse_f, label: meta.label, percent: _percentString(percentVsAllData_f), overallSummaryValue: _summaryUse_f2 });
		}
	}

	if (meta && _supportsWeightedAverage(aggregationType)) {
		if (measureDetail && measureDetail.weightedAvgUse !== undefined && measureDetail.detailRowCountUse > 0) {
			weightedAvg_f = formatSpec ? _formatNumber(measureDetail.weightedAvgUse, formatSpec) : measureDetail.weightedAvgUse.toString();
			weightedAvgUse = measureDetail.weightedAvgUse;
			detailRowCountUse = measureDetail.detailRowCountUse;
			detailSumUse = measureDetail.detailSumUse;
		}
	}

	if (meta && _supportsAverage(aggregationType)) {
		var tempCountOfValues = _getValueCount(measureDetail);
		if (tempCountOfValues > 0) {
			avgUse = _getMeasureValue(aggregationType, measureDetail && measureDetail['values']) / tempCountOfValues;
			avg_f = formatSpec ? _formatNumber(avgUse, formatSpec) : avgUse.toString();
		}
	}

	//all stats for default summary are NA
	stats[CalcType.NUM_SELECTIONS] = _getValueCount(measureDetail);
	stats[CalcType.SEL_CONTEXT] = lastCategorySelectionLabel;

	stats[CalcType.TOTAL] = NA;
	stats[CalcType.DIFF] = difference;
	stats[CalcType.TOTAL_SEL] = totalUse_f;
	stats[CalcType.MIN_SEL] = minSelection_f;
	stats[CalcType.MAX_SEL] = maxSelection_f;
	stats[CalcType.DIFF_SEL] = difference;
	stats[CalcType.PERCENT_vsALLDATA] = NA;
	stats[CalcType.PERCENT_SEL_vsALLDATA] = percentVsAllData_f && _percentString(percentVsAllData_f) || NA;
	stats[CalcType.PERCENT_CHARTvsCHART] = NA;
	stats[CalcType.PERCENT_SELvsCHART] = percentSelVsChart_f && _percentString(percentSelVsChart_f) || NA;
	stats[CalcType.MIN] = min_f;
	stats[CalcType.MAX] = max_f;
	stats[CalcType.AVG] = avg_f;
	stats[CalcType.AVG_SEL] = avg_f;
	stats[CalcType.WEIGHTED_AVG_SEL] = weightedAvg_f;

	statsUse[CalcType.TOTAL_SEL] = totalUse;
	statsUse[CalcType.MIN_SEL] = minSelection;
	statsUse[CalcType.MAX_SEL] = maxSelection;
	statsUse[CalcType.DIFF_SEL] = 0;
	statsUse[CalcType.PERCENT_vsALLDATA] = NA;
	statsUse[CalcType.PERCENT_SEL_vsALLDATA] = percentVsAllData;
	statsUse[CalcType.PERCENT_CHARTvsCHART] = 0;
	statsUse[CalcType.PERCENT_SELvsCHART] = percentSelVsChart;
	statsUse[CalcType.MIN] = NA;
	statsUse[CalcType.MAX] = NA;
	statsUse[CalcType.AVG] = avgUse || NA;
	statsUse[CalcType.ROW_COUNT] = rowCount;
	statsUse[CalcType.MISSING_VALUE_COUNT] = missingValueCount;
	statsUse[CalcType.AVG_SEL] = avgUse || NA;
	statsUse[CalcType.WEIGHTED_AVG_SEL] = weightedAvgUse || NA;
	statsUse[CalcType.DETAIL_ROWCOUNT] = detailRowCountUse; //This information only surfaces in tooltips
	statsUse[CalcType.DETAIL_SUM] = detailSumUse;
	statsUse[CalcType.SUMMARY_USE] = summaryUse;

	if (hasNegativeValues && aggregationType === 'sum') {
		//If the stats returns that there are negative values, mark BOTH the TOTAL and PERCENT_SEL_vsALLDATA cells (and augment tooltips)
		statsUse[CalcType.HAS_NEGATIVE_VALUES] = [CalcType.TOTAL_SEL, CalcType.PERCENT_SEL_vsALLDATA];
	}

	statsUse[CalcType.NUM_SELECTIONS] = _getValueCount(measureDetail);

	toolTip[CalcType.PERCENT_SEL_vsALLDATA] = percentVsAllDataTip;
	toolTip[CalcType.PERCENT_SELvsCHART] = percentSelVsChartTip;
	if (totalSelTip) {
		toolTip[CalcType.TOTAL_SEL] = totalSelTip;
	}
	if (statsUse[CalcType.AVG_SEL] !== NA) {
		toolTip[CalcType.AVG_SEL] = _getCompareTableTip(getString, CalcType.AVG_SEL, { avg: avg_f, rowCount: rowCount, missingValueCount: missingValueCount });
	}
	if (statsUse[CalcType.WEIGHTED_AVG_SEL] !== NA) {
		toolTip[CalcType.WEIGHTED_AVG_SEL] = _getCompareTableTip(getString, CalcType.WEIGHTED_AVG_SEL, { weightedAvg: weightedAvg_f, detailRowCount: detailRowCountUse, missingValueCount: missingValueCount });
	}

	return { stats: stats, statsUse: statsUse, toolTip: toolTip, aggregationType: aggregationType, measureName: measureName, meta: meta, widgetAlias: widgetAlias };
}

/***********************
 * compare table calculated stats
 ***********************/

/**
 * returns combined calculations
 * @param {object} params
 * @param {object[]} params.statsInfoList  each object is return value from getChartSummaryStats()
 *                                  ie { stats, statsUse, aggregationType, measureName, meta }
 * @param {string[]} params.applicableCalcs list of applicable calculations for all widgets on compare card
 *                                  e.g [ 'total','difference','percentVsAllData','percentChartVsChart' ]
 * @param {function} params.getString
 * @param {object} params.widgetContextCheckResult
 * @return {string[]} applicable stat values for all calcs in applicableCalcs
 */
function getCalculatedSummaryData(params) {
	var newCompareTableStatsEnabled = params.newCompareTableStatsEnabled,
	    statsInfoList = params.statsInfoList,
	    applicableCalcs = params.applicableCalcs,
	    getString = params.getString,
	    widgetContextCheckResult = params.widgetContextCheckResult,
	    combinedSummaryValueMap = params.combinedSummaryValueMap;

	var computedStatsAndTooltip = { stats: {}, statsUse: {}, toolTip: {} };

	var getTooltip = function getTooltip() {
		for (var _len3 = arguments.length, theArgs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
			theArgs[_key3] = arguments[_key3];
		}

		return getString && _getCombinationToolTipsList.apply(undefined, [getString].concat(theArgs)) || '';
	};
	var getSingleTooltip = function getSingleTooltip() {
		for (var _len4 = arguments.length, theArgs = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
			theArgs[_key4] = arguments[_key4];
		}

		return getString && _getCombinationToolTip.apply(undefined, [getString].concat(theArgs)) || '';
	};
	var applicableStatsList = [];
	var allMeasuresSame = _areAllMeasuresSame(statsInfoList);
	var oneOrMoreRowCountsGreaterThanZero = _oneOrMoreRowCountsGreaterThanZero(statsInfoList);
	var canDiffThisCountDistinctCalculation = newCompareTableStatsEnabled && _checkAggregateTypeGeneric(statsInfoList, _isCountDistinct);
	var isCalculationValid = allMeasuresSame && oneOrMoreRowCountsGreaterThanZero && (widgetContextCheckResult.canCombineCalculations || canDiffThisCountDistinctCalculation) && widgetContextCheckResult.isCategoryContextSame && statsInfoList.length > 1;

	if (isCalculationValid) {
		//This block returns a structure with any computations defined
		//{
		//  stats: { difference: 50, differenceSelection: 20, avg: 40, avgSelection: 10 },
		//  tooltip: { difference: '-', differenceSelection: '-', avg: 'cannot show total when data overlaps', avgSelection: '-'}
		//}
		if (_checkAggregateTypeGeneric(statsInfoList, _isSummable)) {
			computedStatsAndTooltip = _computeCalculatedDataForSummables(statsInfoList, getTooltip);
			computedStatsAndTooltip = _computeAverageData(statsInfoList, /*not used*/undefined, getSingleTooltip, computedStatsAndTooltip); // append to existing stats
		} else if (_checkAggregateTypeGeneric(statsInfoList, _isCountDistinct)) {
			//distinct counts can be subtracted (it simply means how many more distinct values are in 1 set than another).
			computedStatsAndTooltip = _computeDiffData(statsInfoList, CalcType.TOTAL, CalcType.TOTAL_SEL, getTooltip, /*multi*/true);
			if (allMeasuresSame && combinedSummaryValueMap) {
				var totalCalc = statsInfoList[0].stats[CalcType.TOTAL_SEL] !== NA ? CalcType.TOTAL_SEL : CalcType.TOTAL;
				var percentOfDatasetCalc = statsInfoList[0].stats[CalcType.TOTAL_SEL] !== NA ? CalcType.PERCENT_SEL_vsALLDATA : CalcType.PERCENT_vsALLDATA;

				var measureName = statsInfoList[0].measureName;
				computedStatsAndTooltip = _computeCombinedSummaryValues(combinedSummaryValueMap[measureName], totalCalc, percentOfDatasetCalc, statsInfoList[0].statsUse.summaryUse, getSingleTooltip, computedStatsAndTooltip);
			}
		} else if (_checkAggregateTypeGeneric(statsInfoList, _isAvg)) {
			computedStatsAndTooltip = _computeWeightedAverageData(statsInfoList, 'avg', getSingleTooltip);
		} else if (_checkAggregateTypeGeneric(statsInfoList, _isMax)) {
			computedStatsAndTooltip = _computeDiffData(statsInfoList, CalcType.MAX, CalcType.MAX_SEL, getTooltip);
			computedStatsAndTooltip = _computeAverageData(statsInfoList, CalcType.MAX, getSingleTooltip, computedStatsAndTooltip); // append to existing stats
		} else if (_checkAggregateTypeGeneric(statsInfoList, _isMin)) {
			computedStatsAndTooltip = _computeDiffData(statsInfoList, CalcType.MIN, CalcType.MIN_SEL, getTooltip);
			computedStatsAndTooltip = _computeAverageData(statsInfoList, CalcType.MIN, getSingleTooltip, computedStatsAndTooltip); // append to existing stats
		}
	}

	applicableCalcs.forEach(function (calc) {
		var value = isCalculationValid && computedStatsAndTooltip.stats[calc] !== undefined ? computedStatsAndTooltip.stats[calc] : NA;
		var valueUse = isCalculationValid && computedStatsAndTooltip.statsUse && computedStatsAndTooltip.statsUse[calc] !== undefined ? computedStatsAndTooltip.statsUse[calc] : undefined;
		var toolTip = isCalculationValid && computedStatsAndTooltip.toolTip[calc];

		if (!isCalculationValid && oneOrMoreRowCountsGreaterThanZero) {
			toolTip = _getCombinedCalcTooltip(getString, allMeasuresSame, widgetContextCheckResult);
		}

		applicableStatsList.push({ value: value, valueUse: valueUse, toolTip: toolTip });
	});
	return applicableStatsList;
}

function _setSummableToolTips(toolTipStr, statsInfoList, getTooltip, formatSpec, isSelection) {
	var calcsList = [[CalcType.TOTAL, CalcType.DIFF], [CalcType.TOTAL_SEL, CalcType.DIFF_SEL]];

	var calcs = isSelection ? calcsList[1] : calcsList[0];

	var TOTAL = 0,
	    DIFF = 1;
	var _roundAndFormatNum = function _roundAndFormatNum(num) {
		var rnum = _round(num);
		return formatSpec ? _formatNumber(rnum, formatSpec) : rnum.toString();
	};
	var a = {},
	    b = {};
	a[calcs[TOTAL]] = _roundAndFormatNum(statsInfoList[0].statsUse[calcs[TOTAL]]);
	b[calcs[TOTAL]] = _roundAndFormatNum(statsInfoList[1].statsUse[calcs[TOTAL]]);

	if (!isSelection) {
		a[CalcType.PERCENT_vsALLDATA] = _roundAndFormatNum(statsInfoList[0].statsUse[CalcType.PERCENT_vsALLDATA]);
		b[CalcType.PERCENT_vsALLDATA] = _roundAndFormatNum(statsInfoList[1].statsUse[CalcType.PERCENT_vsALLDATA]);
	}

	toolTipStr[calcs[DIFF]] = getTooltip(2, calcs[DIFF], { a: a[calcs[TOTAL]], b: b[calcs[TOTAL]] });
	toolTipStr[calcs[TOTAL]] = getTooltip(2, calcs[TOTAL], { a: a[calcs[TOTAL]], b: b[calcs[TOTAL]] });
	if (!isSelection) {
		toolTipStr[CalcType.PERCENT_vsALLDATA] = getTooltip(2, CalcType.PERCENT_vsALLDATA, { a: a[CalcType.PERCENT_vsALLDATA], b: b[CalcType.PERCENT_vsALLDATA] });
	}
}

function _setDiffToolTips(toolTipStr, prop, statsInfoList, getTooltip, formatSpec, isSelection) {

	var _roundAndFormatNum = function _roundAndFormatNum(num) {
		var rnum = _round(num);
		return formatSpec ? _formatNumber(rnum, formatSpec) : rnum.toString();
	};
	var a = {},
	    b = {};
	a[prop] = _roundAndFormatNum(statsInfoList[0].statsUse[prop]);
	b[prop] = _roundAndFormatNum(statsInfoList[1].statsUse[prop]);

	var calc = isSelection ? CalcType.DIFF_SEL : CalcType.DIFF;
	toolTipStr[calc] = getTooltip(2, calc, { a: a[prop], b: b[prop] });
}

function _computeCalculatedDataForSummables(statsInfoList, getTooltip) {
	var result = {};
	var resultUse = {};
	var toolTip = {};

	var total = 0;
	var diff = undefined;
	var perAllData = 0;

	var toolTipStr = {};

	var formatSpec = statsInfoList[0].meta && statsInfoList[0].meta.format;

	if (statsInfoList && statsInfoList.length > 0 && statsInfoList[0].stats[CalcType.TOTAL] !== NA) {
		if (statsInfoList.length === 2) {
			diff = statsInfoList[0].statsUse[CalcType.TOTAL] - statsInfoList[1].statsUse[CalcType.TOTAL];
			diff = _round(diff);

			_setSummableToolTips(toolTipStr, statsInfoList, getTooltip, formatSpec);
		}
		statsInfoList.forEach(function (infoForChart) {
			total += infoForChart.statsUse[CalcType.TOTAL];
			perAllData += infoForChart.statsUse[CalcType.PERCENT_vsALLDATA];
		});
	}

	var totalSel = 0;
	var diffSel = undefined;

	if (statsInfoList && statsInfoList.length > 0 && statsInfoList[0].stats[CalcType.TOTAL_SEL] !== NA) {
		if (statsInfoList.length === 2) {
			diffSel = statsInfoList[0].statsUse[CalcType.TOTAL_SEL] - statsInfoList[1].statsUse[CalcType.TOTAL_SEL];
			diffSel = _round(diffSel);
			_setSummableToolTips(toolTipStr, statsInfoList, getTooltip, formatSpec, true);
		}

		statsInfoList.forEach(function (infoForChart) {
			totalSel += infoForChart.statsUse[CalcType.TOTAL_SEL];
		});
	}

	var roundedTotal = _round(total);
	result[CalcType.TOTAL] = formatSpec ? _formatNumber(roundedTotal, formatSpec) : roundedTotal.toString();
	resultUse[CalcType.TOTAL] = roundedTotal;
	result[CalcType.DIFF] = formatSpec ? _formatNumber(diff, formatSpec) : diff && diff.toString() || NA;
	resultUse[CalcType.DIFF] = diff;
	result[CalcType.PERCENT_vsALLDATA] = _percentString(_round(perAllData));
	resultUse[CalcType.PERCENT_vsALLDATA] = _round(perAllData);

	roundedTotal = _round(totalSel);
	result[CalcType.TOTAL_SEL] = formatSpec ? _formatNumber(roundedTotal, formatSpec) : roundedTotal.toString();
	resultUse[CalcType.TOTAL_SEL] = roundedTotal;
	result[CalcType.DIFF_SEL] = formatSpec ? _formatNumber(diffSel, formatSpec) : diffSel && diffSel.toString() || NA;
	resultUse[CalcType.DIFF_SEL] = diffSel || NA;

	result[CalcType.PERCENT_CHARTvsCHART] = _percentString(100);
	resultUse[CalcType.PERCENT_CHARTvsCHART] = 100;
	toolTipStr[CalcType.PERCENT_CHARTvsCHART] = undefined;

	toolTip[CalcType.TOTAL] = toolTipStr[CalcType.TOTAL];
	toolTip[CalcType.DIFF] = toolTipStr[CalcType.DIFF];
	toolTip[CalcType.TOTAL_SEL] = toolTipStr[CalcType.TOTAL_SEL];
	toolTip[CalcType.DIFF_SEL] = toolTipStr[CalcType.DIFF_SEL];
	toolTip[CalcType.PERCENT_vsALLDATA] = toolTipStr[CalcType.PERCENT_vsALLDATA];
	toolTip[CalcType.PERCENT_CHARTvsCHART] = toolTipStr[CalcType.PERCENT_CHARTvsCHART];

	return { stats: result, statsUse: resultUse, toolTip: toolTip };
}

function _computeAverageData(statsInfoList, prop, getSingleTooltip, /*optional*/stats) {
	var result = {};
	var resultUse = {};
	var toolTip = {};
	var combinedAverage = NA;

	if (statsInfoList && statsInfoList.length === 2) {
		var formatSpec = statsInfoList[0].meta && statsInfoList[0].meta.format;
		[CalcType.AVG, CalcType.AVG_SEL].forEach(function (calcType) {
			if (statsInfoList[0].stats[calcType] !== NA && statsInfoList[1].stats[calcType] !== NA) {
				var chartA_rowCount = 0,
				    chartB_rowCount = 0;
				var chartA_total = statsInfoList[0].statsUse[CalcType.TOTAL];
				var chartB_total = statsInfoList[1].statsUse[CalcType.TOTAL];
				var chartA_total_sel = statsInfoList[0].statsUse[CalcType.TOTAL_SEL];
				var chartB_total_sel = statsInfoList[1].statsUse[CalcType.TOTAL_SEL];
				var chartA_missingValueCount = statsInfoList[0].statsUse[CalcType.MISSING_VALUE_COUNT] || 0;
				var chartB_missingValueCount = statsInfoList[1].statsUse[CalcType.MISSING_VALUE_COUNT] || 0;
				if (typeof chartA_total === 'number' && typeof chartB_total === 'number') {
					// combined averages for summary
					chartA_rowCount = statsInfoList[0].statsUse[CalcType.ROW_COUNT];
					chartB_rowCount = statsInfoList[1].statsUse[CalcType.ROW_COUNT];
					combinedAverage = _round((chartA_total + chartB_total) / (chartA_rowCount + chartB_rowCount));
				} else if (typeof chartA_total_sel === 'number' && typeof chartB_total_sel === 'number') {
					// combined averages for selection
					chartA_rowCount = statsInfoList[0].statsUse[CalcType.NUM_SELECTIONS];
					chartB_rowCount = statsInfoList[1].statsUse[CalcType.NUM_SELECTIONS];
					combinedAverage = _round((chartA_total_sel + chartB_total_sel) / (chartA_rowCount + chartB_rowCount));
				}
				result[calcType] = formatSpec ? _formatNumber(combinedAverage, formatSpec) : combinedAverage.toString();
				resultUse[calcType] = combinedAverage;

				if (getSingleTooltip && combinedAverage && chartA_missingValueCount + chartB_missingValueCount) {
					toolTip[calcType] = getSingleTooltip(CalcType.MISSING_VALUE_COUNT, { avg: combinedAverage, rowCount: chartA_rowCount + chartB_rowCount, missingValueCount: chartA_missingValueCount + chartB_missingValueCount });
				} else if (getSingleTooltip && combinedAverage) {
					toolTip[calcType] = getSingleTooltip(calcType, { avg: combinedAverage, rowCount: chartA_rowCount + chartB_rowCount });
				}
			}
		});
	}

	if (stats) {
		stats.stats = _extends({}, stats.stats, result);
		stats.statsUse = _extends({}, stats.statsUse, resultUse);
		stats.toolTip = _extends({}, stats.toolTip, toolTip);
	} else {
		stats = { stats: result, statsUse: resultUse, toolTip: toolTip };
	}

	return stats;
}

function _computeWeightedAverageData(statsInfoList, prop, getSingleTooltip) {
	var result = {};
	var resultUse = {};
	var toolTip = {};

	if (statsInfoList && statsInfoList.length === 2) {
		var formatSpec = statsInfoList[0].meta && statsInfoList[0].meta.format;
		[CalcType.WEIGHTED_AVG, CalcType.WEIGHTED_AVG_SEL].forEach(function (calcType) {
			if (statsInfoList[0].stats[calcType] !== NA && statsInfoList[1].stats[calcType] !== NA) {
				var detailRowCount0 = statsInfoList[0].statsUse[CalcType.DETAIL_ROWCOUNT];
				var detailRowCount1 = statsInfoList[1].statsUse[CalcType.DETAIL_ROWCOUNT];
				if (detailRowCount0 > 0 && detailRowCount1 > 0) {
					var detailSum0 = statsInfoList[0].statsUse[CalcType.DETAIL_SUM];
					var detailSum1 = statsInfoList[1].statsUse[CalcType.DETAIL_SUM];
					var weightedAverage = _round((detailSum0 + detailSum1) / (detailRowCount0 + detailRowCount1));
					result[calcType] = formatSpec ? _formatNumber(weightedAverage, formatSpec) : weightedAverage.toString();
					resultUse[calcType] = weightedAverage;

					if (getSingleTooltip && weightedAverage) {
						toolTip[calcType] = getSingleTooltip(calcType, { weightedAvg: weightedAverage, detailRowCount: detailRowCount0 + detailRowCount1 });
					}
				}
			}
		});
	}

	return { stats: result, statsUse: resultUse, toolTip: toolTip };
}

function _computeDiffData(statsInfoList, prop, propSel, getTooltip) {
	var multiAllowed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

	var result = {};
	var toolTip = {};
	var toolTipStr = {};
	var formatSpec = statsInfoList[0].meta && statsInfoList[0].meta.format;

	if (statsInfoList && statsInfoList.length > 0) {
		if (statsInfoList[0].stats[CalcType.DIFF] !== NA) {

			if (statsInfoList.length === 2) {
				result[CalcType.DIFF] = statsInfoList[0].statsUse[prop] - statsInfoList[1].statsUse[prop];

				_setDiffToolTips(toolTipStr, prop, statsInfoList, getTooltip, formatSpec);
				toolTip[CalcType.DIFF] = toolTipStr[CalcType.DIFF];
			}
		}

		if (statsInfoList[0].stats[CalcType.DIFF_SEL] !== NA) {
			if (statsInfoList.length === 2) {
				if (multiAllowed || statsInfoList[0].statsUse[CalcType.NUM_SELECTIONS] === 1 && statsInfoList[1].statsUse[CalcType.NUM_SELECTIONS] === 1) {
					var val = statsInfoList[0].statsUse[propSel] - statsInfoList[1].statsUse[propSel];
					result[CalcType.DIFF_SEL] = _round(val);
					_setDiffToolTips(toolTipStr, propSel, statsInfoList, getTooltip, formatSpec, true);
					toolTip[CalcType.DIFF_SEL] = toolTipStr[CalcType.DIFF_SEL];
				}
			}
		}
	}

	return { stats: result, statsUse: result, toolTip: toolTip };
}

function _computeCombinedSummaryValues(measureInfo, totalCalc, percentOfDatasetCalc, overallSummaryValue, getSingleTooltip) {
	var stats = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

	var result = {};
	var resultUse = {};
	var toolTip = {};

	if (measureInfo) {
		result[totalCalc] = measureInfo.filteredSummaryValue;
		resultUse[totalCalc] = measureInfo.filteredSummaryValueUse;
		var percentDatasetCalc = _round(measureInfo.filteredSummaryValueUse / overallSummaryValue * 100);
		result[percentOfDatasetCalc] = _percentString(percentDatasetCalc);
		resultUse[percentOfDatasetCalc] = percentDatasetCalc;
		if (getSingleTooltip && measureInfo.filteredSummaryValue) {
			var label = measureInfo.metadata && measureInfo.metadata.label || NA; //NA should never happen.
			toolTip[totalCalc] = getSingleTooltip('countdistinct_' + totalCalc, { uniqueValues: measureInfo.filteredSummaryValue, label: label, overallSummaryValue: overallSummaryValue });
			toolTip[percentOfDatasetCalc] = getSingleTooltip('countdistinct_' + percentOfDatasetCalc, { uniqueValues: measureInfo.filteredSummaryValue, label: label, percent: result[percentOfDatasetCalc], overallSummaryValue: overallSummaryValue });
		}
	}

	if (stats) {
		stats.stats = _extends({}, stats.stats, result);
		stats.statsUse = _extends({}, stats.statsUse, resultUse);
		stats.toolTip = _extends({}, stats.toolTip, toolTip);
	} else {
		stats = { stats: result, statsuse: resultUse, toolTip: toolTip };
	}
	return stats;
}

/***********************
 * Applicable calculations for default and selection case
 ***********************/

function getApplicableSummaryCalcTypes(measures, newCompareTableStatsEnabled) {
	var stats = [];

	if (measures.length === 0) {
		return [];
	} else if (_checkAggregateType(measures, _isSummable)) {
		stats.push(CalcType.PERCENT_vsALLDATA);
		if (_areAllMeasuresSame(measures)) {
			stats.push(CalcType.PERCENT_CHARTvsCHART);
			_addAverage(stats);
			stats = stats.concat([CalcType.TOTAL, CalcType.DIFF]);
		} else {
			_addAverage(stats);
			stats.push(CalcType.TOTAL);
		}
	} else if (_checkAggregateType(measures, _isMinMax)) {
		stats = [CalcType.MIN, CalcType.MAX];
		_addAverage(stats);
	} else if (_checkAggregateType(measures, _isAvg)) {
		stats = [CalcType.MIN, CalcType.MAX, CalcType.WEIGHTED_AVG];
	} else if (_checkAggregateType(measures, _isCountDistinct)) {
		if (newCompareTableStatsEnabled) {
			stats = [CalcType.MIN, CalcType.MAX, CalcType.PERCENT_vsALLDATA, CalcType.TOTAL, CalcType.DIFF];
		} else {
			stats = [CalcType.MIN, CalcType.MAX];
		}
	} else {
		stats = [CalcType.MIN, CalcType.MAX];

		_addAverage(stats, measures);

		if (_atleastOneAggType(measures, _isAvg)) {
			stats.push(CalcType.WEIGHTED_AVG);
		}

		if (_atleastOneAggType(measures, _isSummable)) {
			stats = stats.concat([CalcType.PERCENT_vsALLDATA, CalcType.TOTAL]);
		}
	}

	return stats;
}

function getApplicableSelectionSummaryCalcTypes(measures, newCompareTableStatsEnabled) {
	var stats = [];

	if (measures.length === 0) {
		return [];
	} else if (_checkAggregateType(measures, _isSummable)) {
		stats.push(CalcType.PERCENT_SEL_vsALLDATA);
		if (_areAllMeasuresSame(measures)) {
			stats.push(CalcType.PERCENT_SELvsCHART);
			_addAverageSel(stats);
			stats = stats.concat([CalcType.TOTAL_SEL, CalcType.DIFF_SEL]);
		} else {
			_addAverageSel(stats);
			stats.push(CalcType.TOTAL_SEL);
		}
	} else if (_checkAggregateType(measures, _isAvg)) {
		stats = [CalcType.MIN_SEL, CalcType.MAX_SEL, CalcType.WEIGHTED_AVG_SEL];
	} else if (_checkAggregateType(measures, _isMax) || _checkAggregateType(measures, _isMin)) {
		stats = [CalcType.MIN_SEL, CalcType.MAX_SEL, CalcType.DIFF_SEL];
		_addAverageSel(stats);
	} else if (_checkAggregateType(measures, _isCountDistinct)) {
		if (newCompareTableStatsEnabled) {
			stats = [CalcType.MIN_SEL, CalcType.MAX_SEL, CalcType.PERCENT_SEL_vsALLDATA, CalcType.TOTAL_SEL, CalcType.DIFF_SEL];
		} else {
			stats = [CalcType.MIN_SEL, CalcType.MAX_SEL];
		}
	} else {
		stats = [CalcType.MIN_SEL, CalcType.MAX_SEL];

		_addAverageSel(stats, measures);
		if (_atleastOneAggType(measures, _isAvg)) {
			stats.push(CalcType.WEIGHTED_AVG_SEL);
		}
		if (_atleastOneAggType(measures, _isSummable)) {
			stats = stats.concat([CalcType.PERCENT_SEL_vsALLDATA, CalcType.TOTAL_SEL]);
		}
	}

	return stats;
}

function _getMeasureAggregateInfo(measuresMap, nameOfValueProperty) {
	measuresMap = measuresMap || new Map();
	var cumulativeTotalCollection = {};

	measuresMap.forEach(function (measureDetail, measureName) {
		var meta = measureDetail.metadata || measureDetail.get('metadata');

		if (meta && _isSummable(meta.aggregationType)) {

			var value = measureDetail[nameOfValueProperty] || measureDetail.get(nameOfValueProperty);

			var _value = _getMeasureValue(meta.aggregationType, value);
			var item = {
				measureLabel: meta.label,
				meta: meta
			};

			cumulativeTotalCollection[measureName] = cumulativeTotalCollection[measureName] || {};
			cumulativeTotalCollection[measureName].value = cumulativeTotalCollection[measureName].value || 0;
			cumulativeTotalCollection[measureName].value += _value;
			cumulativeTotalCollection[measureName].detail = cumulativeTotalCollection[measureName].detail || item;
		}
	});

	return cumulativeTotalCollection;
}

/*
* @return {Map.<Object>} Object is of the form
* {
*   <widgetId> : {
*       <measureName>: {
*           value : <aggregate % number>,
*           allChartTotal: <number>,
*           measureLabel : <string>
*       }
*   }
* }
*/
function getChartVsChartTotalPercentStats(statsModelMap) {
	var _getChartAggregate2 = _getChartAggregate(statsModelMap),
	    cumulativeAggregate = _getChartAggregate2.cumulativeAggregate,
	    chartInfo = _getChartAggregate2.chartInfo;

	return _getPercentTotalChart(cumulativeAggregate, chartInfo);
}

function _getChartAggregate(statsModelMap) {
	var cumulativeAggregate = {};
	var chartInfo = {};
	Array.from(statsModelMap.entries()).forEach(function (entry) {
		var widgetId = entry[0];
		var statsModel = entry[1];
		var widgetAggregateInfo = _getMeasureAggregateInfo(statsModel.measures, 'totalUse');
		chartInfo[widgetId] = widgetAggregateInfo;
		_addTo(widgetAggregateInfo, cumulativeAggregate);
	});

	return { cumulativeAggregate: cumulativeAggregate, chartInfo: chartInfo };
}

function _addTo(widgetAggregateInfo, cumulativeAggregate) {
	Object.entries(widgetAggregateInfo).map(function (measureEntry) {
		var measureName = measureEntry[0];
		var measureInfo = measureEntry[1];
		var meta = measureInfo.detail.meta;

		if (_isSummable(meta.aggregationType)) {
			cumulativeAggregate[measureName] = cumulativeAggregate[measureName] || 0;
			cumulativeAggregate[measureName] += measureInfo.value;
		}
		return cumulativeAggregate;
	});
}

function _getPercentTotalChart(cumulativeAggregate, chartInfo) {

	var percentStats = {};
	Object.entries(chartInfo).forEach(function (entry) {
		var widgetId = entry[0];
		var widgetInfo = entry[1];
		Object.entries(widgetInfo).forEach(function (measureEntry) {
			var measureName = measureEntry[0];
			var measureValue = measureEntry[1].value;
			var measureLabel = measureEntry[1].detail.measureLabel;

			var cumulativeTotal = cumulativeAggregate[measureName];

			percentStats[widgetId] = percentStats[widgetId] || {};
			percentStats[widgetId][measureName] = percentStats[widgetId][measureName] || {};
			percentStats[widgetId][measureName].value = _round(measureValue / cumulativeTotal * 100);
			percentStats[widgetId][measureName].measureLabel = percentStats[widgetId][measureName].measureLabel || measureLabel;
			percentStats[widgetId][measureName].allChartTotal = cumulativeTotal; //for tooltip
		});
	});
	return percentStats;
}

exports.default = {
	getChartSummaryStats: getChartSummaryStats,
	getChartSelectionSummaryStats: getChartSelectionSummaryStats,
	getSelectionContextLabel: getSelectionContextLabel,
	getCalculatedSummaryData: getCalculatedSummaryData,
	getApplicableSummaryCalcTypes: getApplicableSummaryCalcTypes,
	getApplicableSelectionSummaryCalcTypes: getApplicableSelectionSummaryCalcTypes,
	getChartVsChartTotalPercentStats: getChartVsChartTotalPercentStats
};

/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _SmartsRecommenderError = __webpack_require__(222);

var _SmartsRecommenderError2 = _interopRequireDefault(_SmartsRecommenderError);

var _SmartsRecommenderStatus = __webpack_require__(47);

var _SmartsRecommenderStatus2 = _interopRequireDefault(_SmartsRecommenderStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Dashboard
                                                                                                                                                           *| (C) Copyright IBM Corp. 2017, 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

var SmartsRecommenderService = function () {
	function SmartsRecommenderService(options) {
		_classCallCheck(this, SmartsRecommenderService);

		this.ajaxSvc = options.ajaxSvc || (options.dashboardApi && options.dashboardApi.getGlassCoreSvc ? options.dashboardApi.getGlassCoreSvc('.Ajax') : {});
		this.logger = options.logger || {
			debug: function debug() {},
			error: function error() {}
		};
		// This request name is displayed on console, not to end user, so no need to localize
		this.requestName = options.requestName || '';
	}

	SmartsRecommenderService.prototype._executeRequest = function _executeRequest(data, requestURL) {
		var requestPayload = {
			type: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			data: JSON.stringify(data),
			processData: false,
			url: requestURL
		};

		return this.ajaxSvc.ajax(requestPayload);
	};

	SmartsRecommenderService.prototype._processResponse = function _processResponse(ajaxResponse) {
		var recommenderResponse = ajaxResponse.data;
		if (this._isSucessfulResponse(recommenderResponse)) {
			return recommenderResponse.recommendation.recommendedFields;
		} else {
			throw this._createError({
				smartsCode: recommenderResponse && recommenderResponse.status ? recommenderResponse.status.statusCode : null,
				responseMessage: recommenderResponse && recommenderResponse.status ? recommenderResponse.status.message : null
			});
		}
	};

	SmartsRecommenderService.prototype._isSucessfulResponse = function _isSucessfulResponse(smartsResponse) {
		return smartsResponse && smartsResponse.status && smartsResponse.status.statusCode === _SmartsRecommenderStatus2.default.COMPLETED;
	};

	SmartsRecommenderService.prototype._createError = function _createError(options) {
		// this error is not displayed to user, do not need to localize
		var errorCode = options.httpCode || options.smartsCode;
		this.logger.error('this.requestName ' + options.code + ': ' + errorCode + ' ' + options.responseMessage);
		options.requestName = this.requestName;
		var errorObj = new _SmartsRecommenderError2.default(options);
		var userMessages = this._getUserMessages(errorCode);
		if (userMessages) {
			errorObj.setUserStrings(userMessages.title, userMessages.description);
		}
		return errorObj;
	};

	SmartsRecommenderService.prototype._handleError = function _handleError(ajaxError) {
		var ERROR_CODE = 'EXPLORE_SMARTS_REQUEST_ERROR'; //Localization not needed, debugging use only
		var ERROR_MSG = 'Error occured after explore sends request to smarts service.'; //Localization not needed, debugging use only
		var responseJSON = ajaxError.jqXHR && ajaxError.jqXHR.responseJSON;
		if (responseJSON) {
			this.logger.debug(responseJSON);
			throw this._createError({
				smartsCode: responseJSON.status ? responseJSON.status.statusCode : ERROR_CODE,
				responseMessage: responseJSON.status ? responseJSON.status.message : ERROR_MSG
			});
		} else {
			var errorObj = ajaxError.jqXHR && ajaxError.jqXHR.error && ajaxError.jqXHR.error();
			var statusCode = errorObj && errorObj.status ? errorObj.status : ERROR_CODE;
			var msg = errorObj && errorObj.responseText ? errorObj.responseText : ERROR_MSG;
			throw this._createError({
				httpCode: statusCode, //TODO: Not all errors thrown from the request are ajaxError that have HTTP Codes
				responseMessage: msg
			});
		}
	};

	SmartsRecommenderService.prototype._getUserMessages = function _getUserMessages(errCode) {
		var mappings = this.getErrorCodeMappings();
		if (mappings && mappings[errCode]) {
			return mappings[errCode];
		}
		return null;
	};

	/**
  * @return {Object}
  * 	A map that has the following structure
  * 		{
  * 			'Smarts-IRF_21' : {'title':<user friendly title>, 'description': <user friendly messages>},
  * 			'ErrorCode': {'title':<user friendly title>, 'description': <user friendly messages>}
  * 		}
  */


	SmartsRecommenderService.prototype.getErrorCodeMappings = function getErrorCodeMappings() {
		return null; //sub class to override
	};

	return SmartsRecommenderService;
}();

exports.default = SmartsRecommenderService;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

exports.default = {
	COMPLETED: 'Smarts-IFR-20',
	UNSUPPORTED_UNENRICHED_PACKAGE: 'Smarts-IFR-21',
	INVALID_SMARTSMODULE_URI: 'Smarts-IFR-40',
	INVALID_SMARTSMODULE_JSON: 'Smarts-IFR-41',
	INVALID_ANALYSIS_SCOPE_TABLE: 'Smarts-IFR-42',
	INVALID_ANALYSIS_SCOPE_FIELD: 'Smarts-IFR-43',
	INVALID_TARGET_FIELD: 'Smarts-IFR-44',
	INVALID_MISSING_SMARTSMODULE: 'Smarts-IFR-45',
	INVALID_REQUESTCONTEXT: 'Smarts-IFR-46',
	INVALID_REQUEST: 'Smarts-IFR-47',
	INVALID_MODULE_ID: 'Smarts-IFR-48',
	UNSUPPORTED_MODULE_TYPE: 'Smarts-IFR-49',
	INTERNAL_ERROR: 'Smarts-IFR-50',
	INTERNAL_INVALID_ONTOLOGY_DOMAIN: 'Smarts-IFR-51',
	INTERNAL_INVALID_FIELD_STATS: 'Smarts-IFR-52',
	INTERNAL_INVALID_SAMPLE_STATS: 'Smarts-IFR-53',
	//Generic errors
	RELATIONSHIP_REQUEST_TIMEOUT: 'timeout',
	NOT_JOINED_ERROR: 'XQE-MSR-0008'
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ABANDONED_RELATIONSHIP_REQUEST = undefined;

var _RelationshipUtil = __webpack_require__(24);

var _DataBuilder = __webpack_require__(81);

var _DataBuilder2 = _interopRequireDefault(_DataBuilder);

var _Config = __webpack_require__(16);

var _Config2 = _interopRequireDefault(_Config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Dashboard
                                                                                                                                                           *| (C) Copyright IBM Corp. 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */


var ABANDONED_RELATIONSHIP_REQUEST = exports.ABANDONED_RELATIONSHIP_REQUEST = 'ABANDONED_RELATIONSHIP_REQUEST';

/**
 * This is the base request handler for relationship request main flow
 */

var RelationshipBaseRequestHandler = function () {
	function RelationshipBaseRequestHandler() {
		_classCallCheck(this, RelationshipBaseRequestHandler);
	}

	/**
  * @private
  * @param {JSONObject} querySpec Query specifications
  * @param {String} requestOptions the request options
  * @param {context} context the context info of the requset, such as the associated module API
  * @param {service} passed in service instance
  */
	RelationshipBaseRequestHandler._sendRequest = function _sendRequest(querySpec, requestOptions, context, service) {
		var _this = this;

		if (querySpec && context && context.moduleAPI) {
			return this._addQueryParams(querySpec, context).then(function () {
				var targetModel = context.targetModel;
				var abandonedRequest = Object.keys(context.transformOptions)[0];
				var abandonPromise = new Promise(function (resolve, reject) {
					targetModel && targetModel.setAbandon(reject);
				}).catch(function () {
					return Promise.reject({
						abandonedRequest: abandonedRequest,
						code: ABANDONED_RELATIONSHIP_REQUEST
					});
				});

				return Promise.race([context.moduleAPI.querySmartsExploreRelationshipData({
					data: querySpec,
					requestOptions: requestOptions
				}), abandonPromise]).then( // better to use finally here, but we do not support finally in unit test
				function (ajaxResponse) {
					// promise is determined by respose or abandoned, set abandon to null
					targetModel && targetModel.setAbandon(null);
					return ajaxResponse;
				}, function (error) {
					// promise is determined by respose or abandoned, set abandon to null
					targetModel && targetModel.setAbandon(null);
					throw error;
				}).catch(function (error) {
					// if abandoned Request, directly return
					if (error && error.code === ABANDONED_RELATIONSHIP_REQUEST) {
						return Promise.reject(error);
					}
					return _this._handleError(querySpec, error, context, service);
				}).then(function (ajaxResponse) {
					return _this._handleResponse(querySpec, ajaxResponse, context, service);
				});
			});
		}
		return Promise.reject(new Error('INVALID_REQUEST_EXPLORE_sendRequest'));
	};

	RelationshipBaseRequestHandler._handleError = function _handleError(querySpec, error, context) {
		//Verify and generate a possible fallback response of 'completed' status for cetrain Error codes
		var errContext = {
			targetID: querySpec.targetFieldIDForExpression,
			glassContext: context.glassContext,
			relationshipModel: context.model
		};
		return _DataBuilder2.default.convertErrorsToCompletedResponse(error, errContext);
	};

	RelationshipBaseRequestHandler._handleResponse = function _handleResponse(querySpec, ajaxResponse, context, service) {
		var ajaxResponseData = ajaxResponse.data;
		if (service._isSucessfulResponse(ajaxResponseData)) {
			service._handlePredictStatus(ajaxResponseData);
			// TODO: verify if this function is really needed
			this._callback(ajaxResponseData, context);
		} else {
			//TODO: Should we reject a promise for this ASYNC function
			throw service._createError({
				smartsCode: ajaxResponseData.status.statusCode,
				responseMessage: ajaxResponseData.status.message
			});
		}
		service._addRawDataToCache(querySpec, ajaxResponseData, context);
		if (context && context.model.getIsFilterStrengthFeatureEnabled()) {
			context.rawData = ajaxResponseData;
			// R3 behavior: filter data based on the needed transformation
			ajaxResponseData = (0, _RelationshipUtil.applyTransforms)(context);
		}
		return Promise.resolve(ajaxResponseData);
	};

	/**
  * To be Overriden by subclass
  */


	RelationshipBaseRequestHandler._callback = function _callback(ajaxResponseData, context) {
		void [ajaxResponseData, context];
	};

	/**
  * This method add common parameters for relationship strength request.
  *  Subclass should call this method before adding their specific parameters.
  */


	RelationshipBaseRequestHandler._addQueryParams = function _addQueryParams(querySpec, context) {
		if (context.model && context.model.isTimeoutFeatureEnabled && context.model.isTimeoutFeatureEnabled()) {
			querySpec.timeout = _Config2.default.max_request_waiting_time;
		}
		return context.moduleAPI.saveTemporaryModule().then(function (shapingModuleId) {
			if (context.moduleAPI.getAssetId() !== shapingModuleId) {
				querySpec.tempModuleId = shapingModuleId;
			}
		});
	};

	return RelationshipBaseRequestHandler;
}();

exports.default = RelationshipBaseRequestHandler;

/***/ }),
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.OVERRIDE_ACTIONS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(11);

var mobx = _interopRequireWildcard(_mobx);

var _mobxStateTree = __webpack_require__(7);

var _ArrayOperations = __webpack_require__(25);

var _Config = __webpack_require__(16);

var _Config2 = _interopRequireDefault(_Config);

var _ScopeModel = __webpack_require__(51);

var _mobxUtils = __webpack_require__(15);

var _ToastUtil = __webpack_require__(36);

var _Logger = __webpack_require__(37);

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OVERRIDE_ACTIONS = exports.OVERRIDE_ACTIONS = {
	ADDED: 'added',
	DELETED: 'deleted'
};

/**
 * Some information are associated with a certain target ID, for instance the
 * array of addded files to diagram, an array of removed fields from diagram,
 * etc.
 */
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
exports.default = _mobxStateTree.types.model('RelationshipTargetModel', {}).volatile(function () {
	return {
		addedFields: mobx.observable([]), /*Added columns to an existing relationship diagram*/
		deletedFields: mobx.observable([]), /*Deleted columsn from an existing relationship diagram*/
		lastAddedFields: null, /*last added fields*/
		lastCanceledAction: null,
		diagramData: null, /*diagram data after transformations */
		initialState: true, /* as long as user doesn't change the filter strength, the diagram should stay in this state, that means limited to 10 nodes */
		showPrimaryRelationshipView: _Config2.default.default_show_primary_relationship_view, /*true by default*/
		filterStrength: {
			min: _Config2.default.default_min_strength,
			max: _Config2.default.default_max_strength
		}, /*min/max relationship strength set by user */
		initialFilterStrength: {
			min: _Config2.default.default_min_strength,
			max: _Config2.default.default_max_strength
		}, /*min/max relationship strength calculated from initial loading of a target*/
		scope: null,
		renderNeeded: 0, /*indicator to trigger fetchData on selective property change*/
		changedProperty: '', /*the property that is modified and need fetch data*/
		actionStatus: null, /*A JSON that shows the current status of the actions { level: xxx, message: xxx}*/
		showRelationshipsMap: {},
		lastShowRelationshipsField: {},
		data: null, /*a FromPromise instance for the relationship fetch data request*/
		id: null, /*TargetModel's Id is the tareget column ID*/
		requestStartTime: null, /*Starting Time of a Relationship fecth request*/
		requestEndTime: null, /*Starting Time of a Relationship fecth request*/
		abandon: null, /*delegator (function) to abadon a pending fetch data promise*/
		metadataInfo: null /*Metadata information for all columns*/
	};
}).views(function (self) {
	return {
		get computedMinStrength() {
			if (self.initialState) {
				return self.initialFilterStrength.min;
			} else {
				return self.filterStrength.min;
			}
		},

		get computedMaxStrength() {
			if (self.initialState) {
				return self.initialFilterStrength.max;
			} else {
				return self.filterStrength.max;
			}
		},

		/**
  * This function based on the modified property to return the type of transformation and its parameters that need to pass to the relationshipStrengthService via function fetchData to filter data before rendering
  * (e.g primary/secondary view, filter strength, delete/add operation, etc...)
  */
		getTransformOptions: function getTransformOptions() {
			var transformOptions = null;
			switch (self.changedProperty) {
				case 'filterStrength':
				case 'showPrimaryRelationshipView':
				case 'cancelAction':
					transformOptions = {
						'filterStrength': self.filterStrength
					};
					break;
				case 'deletedFields':
					transformOptions = {
						'deletedFields': self.deletedFields
					};
					break;
				case 'lastAddedFields':
					transformOptions = {
						'lastAddedFields': self.lastAddedFields,
						'addedFields': self.addedFields,
						'showPrimaryRelationshipView': self.showPrimaryRelationshipView,
						'targetId': self.id
					};
					break;
				case 'lastShowRelationshipsField':
					transformOptions = {
						'lastShowRelationshipsField': self.lastShowRelationshipsField
					};
					break;
				case 'scopedFields':
					transformOptions = {
						scopedFields: self.scope.getScopedFields().map(function (scopedField) {
							return scopedField.fieldIDForExpression;
						}),
						targetId: self.id
					};
					break;
				default:
					return null;
			}
			return {
				transformOptions: transformOptions
			};
		},
		getDiagramData: function getDiagramData() {
			return self.diagramData;
		},
		getInitialState: function getInitialState() {
			return self.initialState;
		},
		getDiagramFilterCondition: function getDiagramFilterCondition() {
			var maxNodesToDisplay = self.initialState ? _Config2.default.max_nodes_to_firstTime_display : _Config2.default.max_nodes_to_display;
			return {
				'targetId': self.id,
				'showPrimaryRelationshipView': self.showPrimaryRelationshipView,
				'maxNodesToDisplay': maxNodesToDisplay,
				'maxLinksToDisplay': Math.round(maxNodesToDisplay * _Config2.default.node_Link_ratio),
				'filterStrength': self.initialState ? null : self.filterStrength,
				'deletedFields': self.deletedFields,
				'addedFields': self.addedFields
			};
		},
		getDeletedFields: function getDeletedFields() {
			return self.deletedFields;
		},
		getAddedFields: function getAddedFields() {
			return self.addedFields;
		},
		getScope: function getScope() {
			return self.scope;
		},
		getShowRelationships: function getShowRelationships() {
			return self.showRelationshipsMap;
		},


		/*Return the current Id of the target model*/
		getTargetId: function getTargetId() {
			return self.id;
		},
		getDiagramNodeCount: function getDiagramNodeCount() {
			var diagramData = self.getDiagramData();
			if (diagramData && diagramData.nodesDataset && diagramData.nodesDataset.groupings && diagramData.nodesDataset.groupings.length && diagramData.nodesDataset.groupings[0].groups) {
				return diagramData.nodesDataset.groupings[0].groups.length;
			}
			return 0;
		},


		/**
   * see if we need to change the fetchDataContext. eg for the case that changing back to an abandoned target,
   * if the abandonedrequest  is a editing scope request, we want to resend a editing scope request (ie has analysisScope)
   * instead of sending a common request
   * @param {object} fetchDataContext
   */
		modifyFetchDataContextIfNeeded: function modifyFetchDataContextIfNeeded(fetchDataContext) {
			if (self.data && self.data.state === _mobxUtils.REJECTED) {
				var error = self.data.value;
				if (error) {
					if (error.errObj && error.errObj.code === 'CA_EXPLORE_REL_003' /* abandoned request error, see StartingPointsRequestError*/) {
							// if previously abandoned request is a edting scope request
							if (error.abandonedRequest === 'scopedFields') {
								// and if we are changing target, we need to resend the editing scope request
								if (fetchDataContext && fetchDataContext.setTarget === true) {
									var scopedFields = self.scope.getScopedFields();
									if (scopedFields) {
										fetchDataContext.transformOptions = {
											scopedFields: scopedFields.map(function (scopedField) {
												return scopedField.fieldIDForExpression;
											}),
											targetId: self.id
										};
									}
								}
							}
						}
				}
			}
			return fetchDataContext;
		}
	};
}).actions(function (self) {
	var disposeFunctions = [];
	return {
		afterCreate: function afterCreate() {
			self.logger = new _Logger2.default('CA_EXPLORE_RELATIONSHIP_TARGETMODEL_VM'); //explore natvie logger
			self.relationshipVM = (0, _mobxStateTree.getEnv)(self).relationshipVM;
			self.id = (0, _mobxStateTree.getEnv)(self).id;
			self.label = (0, _mobxStateTree.getEnv)(self).label;
			var dataSourceId = self.relationshipVM.dataSourceId;
			var fieldId = self.id;
			var module = (0, _mobxStateTree.getEnv)(self).exploreVM.activeDataSourceModule;
			var sourceModuleId = module && module.value.getAssetId();

			self.scope = _ScopeModel.ScopeModel.create({
				fieldId: fieldId,
				dataSourceId: dataSourceId,
				sourceModuleId: sourceModuleId
			}, { targetModel: self, exploreVM: (0, _mobxStateTree.getEnv)(self).exploreVM });

			disposeFunctions.push(mobx.reaction(function () {
				return self.renderNeeded;
			}, function () {
				var fetchDataContext = self.getTransformOptions();
				if (fetchDataContext) {
					self.relationshipVM.fetchData(fetchDataContext);
				}
			}));

			disposeFunctions.push(mobx.reaction(function () {
				return self.data && self.data.state;
			}, function (state) {
				//Allways show toast message if the response data is not for the current targetID,
				//Allways Show toast message if the current explore perspective is deactivated
				//Only show toast message if the request is a long request, check Config.request_execution_time_elapse_to_show_fulfilled_toast
				if (state === _mobxUtils.FULFILLED && self._shouldShowToast()) {
					(0, _ToastUtil.showRequestFinishedToast)(self.relationshipVM.glassContext, self, self.relationshipVM.exploreViewId);
				}
			}));
		},
		_shouldShowToast: function _shouldShowToast() {
			self.stopRequestTimer();
			var isLongRequest = self.getRequsetTimeDuration() >= _Config2.default.request_execution_time_elapse_to_show_fulfilled_toast;
			if (isLongRequest) {
				if (self.relationshipVM.exploreViewActivated) {
					return self.relationshipVM.getCurrentTargetId() !== self.id;
				} else {
					return true;
				}
			}
		},
		setChangedProperty: function setChangedProperty(propertyName) {
			self.changedProperty = propertyName;
		},


		/**
   * Build the analysisScope query parameter for /relationship request
   * @param  {string[]} fieldsArray A flat list of fields IDs.
   * @return {object}
   * @example
   * 		[
  			 {
  				 “tableID” : “Hollywood_Movies_csv”,
  				 “inScopeFieldIDs” : [ “Title”, “Year”, “Release_Day” ]
  			 } ,
  			 {
  				 “tableID” : “Anohter table ID”,
  				 “inScopeFieldIDs” : [ “Field1”, “Field2”, “Field3” ]
  			 }
   	 	]
   *
   */
		buildScopedFields: function buildScopedFields(fieldsArray) {
			//the fieldID should be composed of query subject ID + . + columndID
			//we are splitting them using the last ., a known limitation is that
			//this only support relational datasource.
			var result = [];
			var querySubjectID = void 0;
			var columnID = void 0;
			var length = void 0;
			var lastDotPos = void 0;
			var targetId = self.id;
			fieldsArray.forEach(function (fieldID) {
				// Do not add targetId in the list of analysis scope, server throws duplicate node in this case
				if (fieldID !== targetId) {
					length = fieldID.length;
					lastDotPos = fieldID.lastIndexOf('.');
					querySubjectID = fieldID.substr(0, lastDotPos);
					columnID = fieldID.substr(lastDotPos + 1, length);
					var tableEntry = result.find(function (entry) {
						return entry.tableID == querySubjectID;
					});
					if (!tableEntry) {
						result.push({
							'tableID': querySubjectID,
							'inScopeFieldIDs': [columnID]
						});
					} else {
						tableEntry.inScopeFieldIDs.push(columnID);
					}
				}
			});
			return result;
		},


		/**
   * Reset model to initial state,
   * such as empty added fields, empty removed fields
   */
		reset: function reset() {
			self.resetTargetModelProps();
			self.resetScope();
			//rerender the diagram
			self.renderNeeded++;
			self.setChangedProperty('filterStrength');
		},
		resetTargetModelProps: function resetTargetModelProps() {
			self.setInitialState(true);
			(0, _ArrayOperations.replaceArray)(self.addedFields, []);
			(0, _ArrayOperations.replaceArray)(self.deletedFields, []);
			self.showRelationshipsMap = {};
			self.lastShowRelationshipsField = {};
			self.lastAddedFields = null;
			self.filterStrength.min = _Config2.default.default_min_strength;
			self.filterStrength.max = _Config2.default.default_max_strength;
			self.showPrimaryRelationshipView = _Config2.default.default_show_primary_relationship_view;
			self.setDiagramData(null);
		},
		resetScope: function resetScope() {
			self.scope && self.scope.reset();
		},


		/**
   * Set Scope
   * @param {object[]} fields have data structure like below
  		[
  			{
  				fieldID: '',
  				fieldIDForExpression: '',
  				tableID: '',
  			},
  			{
  				fieldID: '',
  				fieldIDForExpression: '',
  				tableID: '',
  			}
  		]
   */
		setScope: function setScope(fields) {
			if (fields) {
				var isSetNewScope = self.scope && self.scope.setScopedFields(fields);
				if (isSetNewScope) {
					// when change to a new scope, reset the filter
					if (!self.initialState) {
						self.setInitialState(true);
					}
					var scopedFields = self.scope.getScopedFields();
					if (scopedFields) {
						// when a field is no longer in the new scope, then remove it from both `added` and `deleted`
						var foundInScopedFields = function foundInScopedFields(field) {
							return scopedFields.find(function (scopedField) {
								return scopedField.fieldIDForExpression === field;
							});
						};
						(0, _ArrayOperations.replaceArray)(self.addedFields, self.addedFields.filter(foundInScopedFields));
						(0, _ArrayOperations.replaceArray)(self.deletedFields, self.deletedFields.filter(foundInScopedFields));
						//update showRelationshipsMap
						var froms = Object.keys(self.showRelationshipsMap);
						if (froms.length) {
							froms.forEach(function (from) {
								if (!foundInScopedFields(from)) {
									delete self.showRelationshipsMap[from];
									return;
								}
								var toEntries = self.showRelationshipsMap[from];
								(0, _ArrayOperations.replaceArray)(toEntries, toEntries.filter(function (toEntry) {
									return foundInScopedFields(toEntry.to);
								}));
								if (toEntries.length === 0) {
									delete self.showRelationshipsMap[from];
								}
							});
						}
						// fetch data for new scope
						self.renderNeeded++;
						self.setChangedProperty('scopedFields');
					}
				}
			}
		},


		/**
   * Set last added fields
   * @param {String[]} columnIds, metadata column IDs
   */
		setLastAddedFields: function setLastAddedFields(columnIds) {
			self.lastAddedFields = columnIds;
			self.addToAddedFields(columnIds);
			self.scope && self.scope.addToScopedFields(columnIds);
			self.renderNeeded++;
			self.setChangedProperty('lastAddedFields');
		},


		/**
   * Add added field Ids to the added fields list
   * @param {String[]} columnIds
   */
		addToAddedFields: function addToAddedFields(columnIds) {
			if (columnIds && columnIds.length) {
				//Need to remove the columns just added from the deleted fields
				(0, _ArrayOperations.replaceArray)(self.deletedFields, self.deletedFields.filter(function (deletedField) {
					return columnIds.indexOf(deletedField) === -1;
				}));
				columnIds.forEach(function (columnId) {
					if (self.addedFields && self.addedFields.length) {
						if (self.addedFields.indexOf(columnId) === -1) {
							self.addedFields.push(columnId);
						}
					} else {
						self.addedFields = [columnId];
					}
				});
			}
		},


		/**
   * Set a fromPromise object to targetModel
   * @param {object} data fromProise object
   */
		setData: function setData(data) {
			self.data = data;
		},


		/**
   * Add removed field Ids to the removed fields list
   * @param {String[]} columnIds
   */
		deleteFields: function deleteFields(columnIds) {
			//Need to remove the columns just deleted from the added fields
			(0, _ArrayOperations.replaceArray)(self.addedFields, self.addedFields.filter(function (addedField) {
				return columnIds.indexOf(addedField) === -1;
			}));
			//Will also need to clear showRelationshipsMap
			columnIds.forEach(function (columnId) {
				return self.deleteFromShowRelationshipsMap(columnId);
			});
			(0, _ArrayOperations.appendToArray)(self.deletedFields, columnIds);
			self.renderNeeded++;
			self.setChangedProperty('deletedFields');
		},
		beforeDestroy: function beforeDestroy() {
			disposeFunctions.forEach(function (dispose) {
				return dispose();
			});
		},
		setFilterStrength: function setFilterStrength(filterStrengthValue) {
			// User has changed filter strength, unset initial state
			self.setInitialState(false);
			self.filterStrength.min = filterStrengthValue.min;
			self.filterStrength.max = filterStrengthValue.max;
			self.renderNeeded++;
			self.setChangedProperty('filterStrength');
		},
		setInitialFilterStrength: function setInitialFilterStrength(filterStrengthValue) {
			self.initialFilterStrength.min = filterStrengthValue.min;
			self.initialFilterStrength.max = filterStrengthValue.max;
		},
		setShowPrimaryRelationshipView: function setShowPrimaryRelationshipView(value) {
			self.showPrimaryRelationshipView = value;
			//when changing mode, set initialState to false to not limit the number of displayed nodes to 10
			if (self.initialState) {
				self.setInitialState(false);
			}
			self.renderNeeded++;
			self.setChangedProperty('showPrimaryRelationshipView');
		},
		setDiagramData: function setDiagramData(data) {
			self.diagramData = data;
		},
		setInitialState: function setInitialState(value) {
			self.initialState = value;
		},
		setActionErrorStatus: function setActionErrorStatus(message) {
			self._setActionStatus('error', message);
		},
		setActionWarnStatus: function setActionWarnStatus(message) {
			self._setActionStatus('warning', message);
		},
		setActionInfoStatus: function setActionInfoStatus(message) {
			self._setActionStatus('info', message);
		},
		setActionSuccessStatus: function setActionSuccessStatus(message) {
			self._setActionStatus('success', message);
		},
		_setActionStatus: function _setActionStatus(level, message) {
			self.actionStatus = {
				level: level,
				message: message
			};
		},
		emptyActionStatus: function emptyActionStatus() {
			self.actionStatus = null;
		},
		updateInitialFilterStrength: function updateInitialFilterStrength(filterStrengthInfo) {
			if (self.initialState && filterStrengthInfo) {
				self.setInitialFilterStrength(filterStrengthInfo);
				//keep filterStrength in sync with InitialFilterStrength
				self.filterStrength.min = filterStrengthInfo.min;
				self.filterStrength.max = filterStrengthInfo.max;
			}
		},


		/**
   * Show the relationship between `from` node and `to` node
   * @param {string} from - field id
   * @param {string} to - field id
   */
		showRelationshipsBetween: function showRelationshipsBetween(from, to) {
			(0, _ArrayOperations.replaceArray)(self.deletedFields, self.deletedFields.filter(function (deletedField) {
				return deletedField !== to;
			}));
			if (self.scope) {
				var scopedFields = self.scope.getScopedFields();
				var targetId = self.id;
				if (scopedFields) {
					if (to !== targetId && !scopedFields.find(function (scopedField) {
						return scopedField.fieldIDForExpression === to;
					})) {
						self.scope.addToScopedFields([to]);
					}
				}
			}
			if (self.showRelationshipsMap[from]) {
				if (!self.showRelationshipsMap[from].find(function (entry) {
					return entry.to === to;
				})) {
					self.showRelationshipsMap[from].push({ to: to });
				}
			} else {
				self.showRelationshipsMap[from] = [{ to: to }];
			}
			self.lastShowRelationshipsField = { from: from, to: to };
			self.renderNeeded++;
			self.setChangedProperty('lastShowRelationshipsField');
		},


		/**
   * Set the relationship bewtween `from` field and `to` field
   * @param {*} from - `from` field
   * @param {*} to - `to` field
   * @param {*} relationship - relationship bewtween `from` field and `to` field: {toNode, link}
   */
		setRelationship: function setRelationship(from, to, relationship) {
			if (self.showRelationshipsMap[from]) {
				var found = self.showRelationshipsMap[from].find(function (entry) {
					return entry.to === to;
				});
				if (found) {
					found.relationship = relationship;
				}
			}
		},


		/**
   * Set the request starting time stamp
   */
		startRequestTimer: function startRequestTimer() {
			self.resetRequestTimer();
			self.requestStartTime = new Date();
		},


		/**
   * Set the request ending time stamp
   */
		stopRequestTimer: function stopRequestTimer() {
			self.requestEndTime = new Date();
		},


		/**
   * Get the request duration time
   */
		getRequsetTimeDuration: function getRequsetTimeDuration() {
			return self.requestEndTime && self.requestStartTime ? self.requestEndTime.getTime() - self.requestStartTime.getTime() : 0; //Ms
		},


		/**
   * Reset the request staring and ending time stamp
   */
		resetRequestTimer: function resetRequestTimer() {
			self.requestStartTime = null;
			self.requestEndTime = null;
		},


		/**
   * Given fieldId, delete it from the `ShowRelationshipsMap`
   * @param {string} columnId - field id
   */
		deleteFromShowRelationshipsMap: function deleteFromShowRelationshipsMap(columnId) {
			//delete from `from fields`
			if (self.showRelationshipsMap[columnId]) {
				delete self.showRelationshipsMap[columnId];
			}

			//delete from `to fields`
			for (var from in self.showRelationshipsMap) {
				var toEntries = self.showRelationshipsMap[from];
				(0, _ArrayOperations.deleteFromArray)(toEntries, function (toEntry) {
					return toEntry.to === columnId;
				});
				if (toEntries.length === 0) {
					delete self.showRelationshipsMap[from];
				}
			}
		},


		/**
   * Cancel an action
   * @param {string} actionToCancel - one of actions in `OVERRIDE_ACTIONS`
   * @param {string} fieldID - field id (the field that the action to be canceled on)
   */
		cancelAction: function cancelAction(actionToCancel, fieldID) {
			switch (actionToCancel) {
				case OVERRIDE_ACTIONS.ADDED:
					{
						(0, _ArrayOperations.deleteFromArray)(self.addedFields, function (addedField) {
							return addedField === fieldID;
						});
						self.deleteFromShowRelationshipsMap(fieldID);
						self.lastCanceledAction = {
							canceledAction: OVERRIDE_ACTIONS.ADDED,
							fieldID: fieldID
						};
						break;
					}
				case OVERRIDE_ACTIONS.DELETED:
					{
						(0, _ArrayOperations.deleteFromArray)(self.deletedFields, function (deletedField) {
							return deletedField === fieldID;
						});
						self.lastCanceledAction = {
							canceledAction: OVERRIDE_ACTIONS.DELETED,
							fieldID: fieldID
						};
						break;
					}
				default:
					return;
			}
			self.setChangedProperty('cancelAction');
			self.renderNeeded++;
		},

		/**
   * Set the abadon request trigger function
   * //TODO: Move the trigger to a fromPromise
   * @param {function}
   */
		setAbandon: function setAbandon(abandon) {
			self.abandon = abandon;
		},


		/**
   * abandon Request
   */
		abandonRequest: function abandonRequest() {
			if (self.abandon) {
				self.abandon();
			}
		}
	};
});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ScopeModel = exports.parseFieldIDForExpression = undefined;

var _mobxStateTree = __webpack_require__(7);

var _ArrayOperations = __webpack_require__(25);

/**
 * Parse and convert `fieldIDForExpression` to an object `{ fieldID, fieldIDForExpression, tableID }`
 * @param {string} fieldIDForExpression 
 */
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var parseFieldIDForExpression = exports.parseFieldIDForExpression = function parseFieldIDForExpression(fieldIDForExpression) {
	var length = fieldIDForExpression.length;
	var lastDotPos = fieldIDForExpression.lastIndexOf('.');
	var tableID = fieldIDForExpression.substr(0, lastDotPos);
	var fieldID = fieldIDForExpression.substr(lastDotPos + 1, length);
	return {
		fieldID: fieldID,
		fieldIDForExpression: fieldIDForExpression,
		tableID: tableID
	};
};

var ScopeModel = exports.ScopeModel = _mobxStateTree.types.model('ScopeModel', {
	fieldId: _mobxStateTree.types.string,
	dataSourceId: _mobxStateTree.types.string,
	sourceModuleId: _mobxStateTree.types.optional(_mobxStateTree.types.string, '')
}).volatile(function () {
	return {
		defaultRecommendations: null,
		scopedFields: null,
		serializedFields: null /*the observable fields is one long string, serialized from sorted and flattened field IDs*/
	};
}).extend(function (self) {
	function fetchPredictRecommendations() {
		return (0, _mobxStateTree.getEnv)(self).exploreVM.getSmartsRecommenderWrapper().fetchPredictRecommendations(self.dataSourceId, self.fieldId);
	}

	/*
  * serialize the scoped fields hierarchical data structure to be a string that is observable.
  * So that the reaction handler is only trigged when 'net columns' are changed regardless the order
  */
	var _getSerializedFields = function _getSerializedFields(fields) {
		if (fields && fields.length) {
			return fields.map(function (field) {
				return field.fieldIDForExpression;
			}).sort().join(' ');
		} else {
			return '';
		}
	};

	return {
		views: {
			/**
   	* Get default recommendations
   	* @param  {object} field
   	* @returns {Promise} Promise object represents array of default recommendations
   	*/
			getDefaultRecommendations: function getDefaultRecommendations() {
				if (self.defaultRecommendations) {
					return Promise.resolve(self.defaultRecommendations);
				}
				return fetchPredictRecommendations().then(function (recommendations) {
					self.setDefaultRecommendations(recommendations);
					self.setScopedFields(recommendations);
					var addedFields = (0, _mobxStateTree.getEnv)(self).targetModel.getAddedFields();
					if (addedFields && addedFields.length) {
						self.addToScopedFields(addedFields);
					}

					var showRelationshipsMap = (0, _mobxStateTree.getEnv)(self).targetModel.getShowRelationships();
					var froms = Object.keys(showRelationshipsMap);
					if (froms.length) {
						froms.forEach(function (from) {
							var toEntries = showRelationshipsMap[from];
							self.addToScopedFields(toEntries.map(function (toEntry) {
								return toEntry.to;
							}));
						});
					}
					return recommendations;
				});
			},
			getScopedFields: function getScopedFields() {
				return self.scopedFields;
			}
		},
		actions: {
			/**
    * Set scoped fields
    * @param {object[]} fields have data structure like below
   	[
   		{
   			fieldID: '',
   			fieldIDForExpression: '',
   			tableID: '',
   		},
   		{
   			fieldID: '',
   			fieldIDForExpression: '',
   			tableID: '',
   		}
   	]
   * @returns {boolean} `true` if set a new scope `false` if scope does not change
   */
			setScopedFields: function setScopedFields(fields) {
				//filter out target
				self.scopedFields = fields && fields.filter(function (field) {
					return field.fieldIDForExpression !== self.fieldId;
				});
				//Serilize the fields into a string that is observable
				var serializedFields = _getSerializedFields(self.scopedFields);

				//if we have a new scope
				if (self.serializedFields !== serializedFields) {
					self.serializedFields = serializedFields;
					return true;
				}
				return false;
			},


			/**
    * Add To Scope
    * @param {[string]} addedFields 
    */
			addToScopedFields: function addToScopedFields(addedFields) {
				if (self.scopedFields) {
					addedFields.forEach(function (addedField) {
						var addToScope = parseFieldIDForExpression(addedField);
						if (!self.scopedFields.find(function (scopedField) {
							return scopedField.fieldIDForExpression === addedField;
						})) {
							self.scopedFields.push(addToScope);
						}
					});
				}
				self.serializedFields = _getSerializedFields(self.scopedFields);
			},


			/**
    * Delete from Scope
    * @param {[string]} deletedFields 
    */
			removeFromScopedFields: function removeFromScopedFields(deletedFields) {
				if (self.scopedFields && self.scopedFields.length) {
					(0, _ArrayOperations.replaceArray)(self.scopedFields, self.scopedFields.filter(function (scopedField) {
						return deletedFields.indexOf(scopedField.fieldIDForExpression) === -1;
					}));
				}
				self.serializedFields = _getSerializedFields(self.scopedFields);
			},
			setDefaultRecommendations: function setDefaultRecommendations(recommendations) {
				self.defaultRecommendations = recommendations;
			},
			reset: function reset() {
				if (self.scopedFields) {
					//if a scope has been set for current target, then remove the asscioated cache from raw cache 
					var smartsRelationshipStrengthService = (0, _mobxStateTree.getEnv)(self).exploreVM.getSmartsRecommenderWrapper().smartsRelationshipStrengthService;
					smartsRelationshipStrengthService.removeDatedEntriesFromCache(self.sourceModuleId, self.fieldId);
				}
				self.setDefaultRecommendations(null);
				self.setScopedFields(null);
			}
		}
	};
});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports._DnDHandler = undefined;

var _class, _desc, _value, _class2, _descriptor;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _mobx = __webpack_require__(11);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _caUiToolkit = __webpack_require__(6);

var _dragFields_ = __webpack_require__(256);

var _dragFields_2 = _interopRequireDefault(_dragFields_);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _UnescapedString = __webpack_require__(53);

var _UnescapedString2 = _interopRequireDefault(_UnescapedString);

var _SingleVisDnDHandler2 = __webpack_require__(85);

var _SingleVisDnDHandler3 = _interopRequireDefault(_SingleVisDnDHandler2);

var _Empty = __webpack_require__(18);

var _Empty2 = _interopRequireDefault(_Empty);

__webpack_require__(87);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
	if (!descriptor) return;
	Object.defineProperty(target, property, {
		enumerable: descriptor.enumerable,
		configurable: descriptor.configurable,
		writable: descriptor.writable,
		value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	});
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

function _initializerWarningHelper(descriptor, context) {
	throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var _DnDHandler = exports._DnDHandler = function (_SingleVisDnDHandler) {
	_inherits(_DnDHandler, _SingleVisDnDHandler);

	function _DnDHandler(options) {
		_classCallCheck(this, _DnDHandler);

		return _possibleConstructorReturn(this, _SingleVisDnDHandler.call(this, options));
	}

	_DnDHandler.prototype.accepts = function accepts(dragObject) {
		if (this._dropColumns(dragObject)) {
			return dragObject.data && dragObject.data.utils && dragObject.data.utils.isValid({
				fromCanvas: true
			});
		}
		return _SingleVisDnDHandler.prototype.accepts.call(this, dragObject);
	};

	_DnDHandler.prototype.getWidgetSpec = function getWidgetSpec(dragObject) {
		if (this._dropColumns(dragObject)) {
			return this._getWidgetSpecOnDropColumns(dragObject);
		}
		return _SingleVisDnDHandler.prototype.getWidgetSpec.call(this, dragObject);
	};

	_DnDHandler.prototype._dropColumns = function _dropColumns(dragObject) {
		return ['MODEL_ITEM', 'GRID_HEADER_ITEM'].indexOf(dragObject.type) !== -1;
	};

	_DnDHandler.prototype._getWidgetSpecOnDropColumns = function _getWidgetSpecOnDropColumns(dragObject) {
		var canvasDnD = this.dashboardApi.getFeature('CanvasDnD');
		return Promise.resolve(canvasDnD.onDrop(dragObject)).then(function (model) {
			return {
				model: model,
				specType: 'widget'
			};
		});
	};

	return _DnDHandler;
}(_SingleVisDnDHandler3.default);

var CreateExplorationLayout = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
	_inherits(CreateExplorationLayout, _Component);

	function CreateExplorationLayout(props) {
		_classCallCheck(this, CreateExplorationLayout);

		var _this2 = _possibleConstructorReturn(this, _Component.call(this, props));

		_initDefineProp(_this2, 'activateDropTarget', _descriptor, _this2);

		_this2.services = props.services;
		return _this2;
	}

	CreateExplorationLayout.prototype._onClick = function _onClick() {
		this.props.handleShowVisTypesClick && this.props.handleShowVisTypesClick();
	};

	CreateExplorationLayout.prototype._onTouchEnd = function _onTouchEnd(e) {
		e.nativeEvent.preventDefault();
	};

	CreateExplorationLayout.prototype._handleEnterKey = function _handleEnterKey(e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			this._onClick();
		}
	};

	CreateExplorationLayout.prototype.render = function render() {
		var _this3 = this;

		var message = void 0;
		var isComparison = this.props.isComparison;
		if (isComparison) {
			message = _StringResources2.default.get('startingPoints_createComparison');
		} else {
			message = _StringResources2.default.get('startingPoints_createVisualization');
		}
		void this.activateDropTarget;
		return _react2.default.createElement(
			'div',
			{ className: 'create-exploration create-exploration--droptarget', ref: function ref(node) {
					_this3.domNode = node;
				} },
			this.activateDropTarget && this.getEmptyRenderMarkup(),
			_react2.default.createElement(
				'div',
				{ className: 'create-exploration__container' },
				this.props.fill ? _react2.default.createElement(_caUiToolkit.SVGIcon, { className: 'create-exploration-icon', iconId: _dragFields_2.default.id, size: '128' }) : null,
				_react2.default.createElement(
					'h3',
					null,
					message
				),
				_react2.default.createElement(
					_UnescapedString2.default,
					null,
					_react2.default.createElement(
						'p',
						null,
						_StringResources2.default.get('startingPoints_dragAndDrop')
					)
				),
				_react2.default.createElement(_caUiToolkit.Button, { label: _StringResources2.default.get('startingPoints_chooseVisType'), variant: 'solid', intent: 'primary', onTouchEnd: this._onTouchEnd.bind(this), onTouchStart: this._onClick.bind(this), onClick: this._onClick.bind(this), onKeyDown: function onKeyDown(event) {
						return _this3._handleEnterKey(event);
					} })
			)
		);
	};

	CreateExplorationLayout.prototype.componentDidMount = function componentDidMount() {
		var _this4 = this;

		var options = {
			domNode: this.domNode,
			className: 'dndHover',
			dashboardApi: this.props.dashboardApi,
			createVis: this.props.createVis,
			activate: function activate() {
				return _this4.activateDropTarget = true;
			},
			deactivate: function deactivate() {
				return _this4.activateDropTarget = false;
			}
		};
		this.props.services.getSvc('.DndManager').then(function (dndManager) {
			dndManager.addDropTarget(_this4.domNode, new _DnDHandler(options));
		});
	};

	CreateExplorationLayout.prototype.getEmptyRenderMarkup = function getEmptyRenderMarkup() {
		return _react2.default.createElement(
			'div',
			{ className: 'explore-empty-create-layout-dnd' },
			_react2.default.createElement(_Empty2.default, null)
		);
	};

	return CreateExplorationLayout;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'activateDropTarget', [_mobx.observable], {
	enumerable: true,
	initializer: function initializer() {
		return false;
	}
})), _class2)) || _class;

CreateExplorationLayout.propTypes = {
	fill: _PropTypes2.default.bool.isRequired,
	services: _PropTypes2.default.object.isRequired,
	dashboardApi: _PropTypes2.default.object.isRequired,
	createVis: _PropTypes2.default.func.isRequired,
	isComparison: _PropTypes2.default.bool,
	activeDataSourceId: _PropTypes2.default.string,
	handleShowVisTypesClick: _PropTypes2.default.func
};

exports.default = CreateExplorationLayout;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var HtmlXSSUtils = __webpack_require__(257);

var UnescapedString = function (_Component) {
	_inherits(UnescapedString, _Component);

	function UnescapedString() {
		_classCallCheck(this, UnescapedString);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	UnescapedString.prototype.render = function render() {
		if (Array.isArray(this.props.children) || !this.props.children.type) {
			throw new Error('must contain exactly 1 child elements');
		}

		var CustomComponent = this.props.children.type;
		var forwardedProps = _underscore2.default.omit(this.props.children.props, 'children');

		return _react2.default.createElement(CustomComponent, _extends({}, forwardedProps, { dangerouslySetInnerHTML: { __html: HtmlXSSUtils.sanitizeHtml(this.props.children.props.children) } }));
	};

	return UnescapedString;
}(_react.Component);

UnescapedString.propTypes = {
	children: _PropTypes2.default.any
};

exports.default = UnescapedString;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _CSSTransition = __webpack_require__(26);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(268);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var Slideout = function (_Component) {
	_inherits(Slideout, _Component);

	function Slideout(props) {
		_classCallCheck(this, Slideout);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	Slideout.prototype.render = function render() {
		this._bindUnbindEvents();

		var cNames = (0, _classnames2.default)({
			'explore__slideout': true,
			'explore__slideout--fullHeight': this.props.fullHeight
		});

		return _react2.default.createElement(
			_CSSTransition2.default,
			{
				'in': this.props.active,
				classNames: this.props.className,
				timeout: this.props.timeout,
				appear: true,
				mountOnEnter: true,
				unmountOnExit: true },
			_react2.default.createElement(
				'div',
				{ className: cNames },
				this.props.children
			)
		);
	};

	Slideout.prototype.componentWillUnmount = function componentWillUnmount() {
		this._unbindEvents();

		// Trigger the on close even when this component unmounts.
		// This allows the consuming component to update the model to reflect the closed state.
		this.props.onClickOutside();
	};

	Slideout.prototype._handleOutsideClick = function _handleOutsideClick(event) {
		if (!(0, _jquery2.default)(event.target).closest('.explore__slideout').length) {
			this.props.onClickOutside();
		}
	};

	Slideout.prototype._bindEvents = function _bindEvents() {
		if (!this._outsideClickListener) {
			this._outsideClickListener = this._handleOutsideClick.bind(this);

			document.addEventListener('mousedown', this._outsideClickListener);
			document.addEventListener('touchstart', this._outsideClickListener);
		}
	};

	Slideout.prototype._unbindEvents = function _unbindEvents() {
		if (this._outsideClickListener) {
			document.removeEventListener('mousedown', this._outsideClickListener);
			document.removeEventListener('touchstart', this._outsideClickListener);

			this._outsideClickListener = null;
		}
	};

	Slideout.prototype._bindUnbindEvents = function _bindUnbindEvents() {
		if (this.props.active) {
			this._bindEvents();
		} else {
			this._unbindEvents();
		}
	};

	return Slideout;
}(_react.Component);

Slideout.propTypes = {
	active: _PropTypes2.default.bool,
	timeout: _PropTypes2.default.number,
	fullHeight: _PropTypes2.default.bool,
	className: _PropTypes2.default.string,
	children: _PropTypes2.default.any,
	onClickOutside: _PropTypes2.default.func
};
Slideout.defaultProps = {
	active: true,
	timeout: 400,
	fullHeight: false,
	className: '',
	children: [],
	onClickOutside: function onClickOutside() {}
};
exports.default = Slideout;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _caUiToolkit = __webpack_require__(6);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _close_ = __webpack_require__(56);

var _close_2 = _interopRequireDefault(_close_);

__webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var CLASS_NAME = 'explore-slideout-content';

var SlideoutContent = function (_Component) {
	_inherits(SlideoutContent, _Component);

	function SlideoutContent() {
		_classCallCheck(this, SlideoutContent);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	SlideoutContent.prototype.render = function render() {
		var _props = this.props,
		    className = _props.className,
		    children = _props.children;


		var header = this.renderHeader();
		var cNames = (0, _classnames2.default)(CLASS_NAME, className);
		var contentClassNames = this.props.contentClassName ? (0, _classnames2.default)(CLASS_NAME + '__content', CLASS_NAME + '__' + this.props.contentClassName) : CLASS_NAME + '__content';

		return _react2.default.createElement(
			'div',
			{ className: cNames, tabIndex: -1 },
			header,
			_react2.default.createElement(
				'div',
				{ className: contentClassNames },
				children
			)
		);
	};

	SlideoutContent.prototype.renderHeader = function renderHeader() {
		var title = this.renderHeaderTitle();
		var subTitle = this.renderHeaderSubtitle();
		var closeButton = this.renderCloseButton();

		return _react2.default.createElement(
			'div',
			{ className: CLASS_NAME + '__header' },
			_react2.default.createElement(
				'div',
				{ className: CLASS_NAME + '__header__section' },
				title,
				subTitle
			),
			closeButton
		);
	};

	SlideoutContent.prototype.renderHeaderTitle = function renderHeaderTitle() {
		var title = this.props.title;

		return _react2.default.createElement(
			'div',
			{ className: CLASS_NAME + '__header__section__title' },
			title
		);
	};

	SlideoutContent.prototype.renderHeaderSubtitle = function renderHeaderSubtitle() {
		var subTitle = this.props.subTitle;

		if (!subTitle) {
			return;
		}
		return _react2.default.createElement(
			'div',
			{ className: CLASS_NAME + '__header__section__subTitle' },
			subTitle
		);
	};

	SlideoutContent.prototype.renderCloseButton = function renderCloseButton() {
		var _this2 = this;

		if (this.props.onClose) {
			return _react2.default.createElement(
				'div',
				{ className: CLASS_NAME + '__header__close-button' },
				_react2.default.createElement(
					'button',
					{
						tabIndex: '0',
						type: 'button',
						role: 'button',
						'aria-label': _StringResources2.default.get('close'),
						title: _StringResources2.default.get('close'),
						onClick: function onClick() {
							return _this2.props.onClose();
						}
					},
					_react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _close_2.default.id })
				)
			);
		}
	};

	return SlideoutContent;
}(_react.Component);

SlideoutContent.propTypes = {
	title: _PropTypes2.default.string.isRequired,
	subTitle: _PropTypes2.default.string,
	children: _PropTypes2.default.any,
	onClose: _PropTypes2.default.func,
	className: _PropTypes2.default.string,
	contentClassName: _PropTypes2.default.string
};
SlideoutContent.defaultProps = {
	showCloseButton: false,
	children: []
};

exports.default = SlideoutContent;

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "close_32",
  "use": "close_32-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"close_32\"><path d=\"M24 9.4L22.6 8 16 14.6 9.4 8 8 9.4l6.6 6.6L8 22.6 9.4 24l6.6-6.6 6.6 6.6 1.4-1.4-6.6-6.6L24 9.4z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(284);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./visPreview.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./visPreview.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(287);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./visPreviewList.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./visPreviewList.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

function openDatasetPane(dashboardApi) {
	if (dashboardApi) {
		// TODO: cleanup, provide API to check if datasetpane is open/closed without reaching into glass
		var plugin = dashboardApi.findGlassPlugin('com.ibm.bi.dashboard.dataSources.sourcesBtn');
		if (plugin && !plugin.isPressed()) {
			dashboardApi.getCurrentContentView().openDatasetpane();
		}
	}
}

function openCardsPane(dashboardApi) {
	if (dashboardApi) {
		// TODO: cleanup, provide API to check if card list is open/closed without reaching into glass
		var plugin = dashboardApi.findGlassPlugin('com.ibm.bi.explore.thumbnailBtn');
		if (plugin && !plugin.isPressed()) {
			dashboardApi.getCurrentContentView().openCardListPane();
		}
	}
}

exports.openDatasetPane = openDatasetPane;
exports.openCardsPane = openCardsPane;

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "no-properties_128",
  "use": "no-properties_128-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"no-properties_128\"><circle class=\"ba-graphics-neutral-white4\" cx=\"100\" cy=\"100\" r=\"100\" /><path class=\"ba-graphics-white\" d=\"M14.97 170.08h135.66\" /><path class=\"ba-graphics-gray60\" d=\"M150.63 172.08H15a2 2 0 110-4h135.63a2 2 0 010 4z\" /><path class=\"ba-graphics-white\" d=\"M2 170.08h4.97\" /><path class=\"ba-graphics-gray60\" d=\"M7 172.08H2a2 2 0 010-4h5a2 2 0 010 4z\" /><path class=\"ba-graphics-white\" d=\"M179.03 170.08H198\" /><path class=\"ba-graphics-gray60\" d=\"M198 172.08h-19a2 2 0 010-4h19a2 2 0 010 4z\" /><path class=\"ba-graphics-white\" d=\"M158.63 170.08h12.4\" /><path class=\"ba-graphics-gray60\" d=\"M171 172.08h-12.4a2 2 0 010-4H171a2 2 0 010 4z\" /><rect class=\"ba-graphics-white\" x=\"23.95\" y=\"46.52\" width=\"152\" height=\"107\" rx=\"6.21\" /><path class=\"ba-graphics-gray60\" d=\"M169.74 50.34a2.39 2.39 0 012.39 2.39v94.57a2.4 2.4 0 01-2.39 2.4H30.17a2.41 2.41 0 01-2.4-2.4V52.73a2.4 2.4 0 012.4-2.39h139.57m0-3.82H30.17A6.22 6.22 0 0024 52.73v94.57a6.22 6.22 0 006.22 6.22h139.52a6.21 6.21 0 006.26-6.22V52.73a6.21 6.21 0 00-6.21-6.21z\" /><path class=\"ba-graphics-gray1\" d=\"M176 67.28V52.7a6.21 6.21 0 00-6.21-6.22H30.17A6.22 6.22 0 0024 52.7v14.58z\" /><path class=\"ba-graphics-gray60\" d=\"M169.74 50.3a2.4 2.4 0 012.39 2.4v10.76H27.77V52.7a2.41 2.41 0 012.4-2.4h139.57m0-3.82H30.17A6.22 6.22 0 0024 52.7v14.58h152V52.7a6.21 6.21 0 00-6.21-6.22z\" /><circle class=\"ba-graphics-gray60\" cx=\"34.07\" cy=\"56.82\" r=\"2\" /><circle class=\"ba-graphics-gray60\" cx=\"41.21\" cy=\"56.82\" r=\"2\" /><circle class=\"ba-graphics-gray60\" cx=\"48.34\" cy=\"56.82\" r=\"2\" /><path class=\"ba-graphics-white\" d=\"M70.22 88.74h59.56\" /><path class=\"ba-graphics-gray60\" d=\"M129.78 90.74H70.22a2 2 0 010-4h59.56a2 2 0 010 4z\" /><circle class=\"ba-graphics-gray60\" cx=\"87.06\" cy=\"88.74\" r=\"8\" /><circle class=\"ba-graphics-white\" cx=\"87.06\" cy=\"88.74\" r=\"2.47\" /><path class=\"ba-graphics-white\" d=\"M70.22 109.02h59.56\" /><path class=\"ba-graphics-gray60\" d=\"M129.78 111H70.22a2 2 0 010-4h59.56a2 2 0 010 4z\" /><circle class=\"ba-graphics-gray60\" cx=\"112.69\" cy=\"109.02\" r=\"8\" /><circle class=\"ba-graphics-white\" cx=\"112.69\" cy=\"109.02\" r=\"2.47\" /><path class=\"ba-graphics-white\" d=\"M70.22 129.31h59.56\" /><path class=\"ba-graphics-gray60\" d=\"M129.78 131.31H70.22a2 2 0 010-4h59.56a2 2 0 110 4z\" /><circle class=\"ba-graphics-gray60\" cx=\"87.06\" cy=\"129.31\" r=\"8\" /><circle class=\"ba-graphics-white\" cx=\"87.06\" cy=\"129.31\" r=\"2.47\" /><circle class=\"ba-graphics-gray60\" cx=\"93.12\" cy=\"30.52\" r=\"2\" /><circle class=\"ba-graphics-gray60\" cx=\"129.41\" cy=\"34.06\" r=\"2\" /><path class=\"ba-graphics-gray60\" d=\"M67.72 25.71a4 4 0 004-4 1 1 0 012 0 4 4 0 004 4 1 1 0 010 2 4 4 0 00-4 4 1 1 0 11-2 0 4 4 0 00-4-4 1 1 0 010-2zm44.88-7.97a2.65 2.65 0 002.65-2.65.66.66 0 111.32 0 2.65 2.65 0 002.64 2.65.66.66 0 110 1.32 2.65 2.65 0 00-2.64 2.65.66.66 0 11-1.32 0 2.65 2.65 0 00-2.65-2.65.66.66 0 110-1.32z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_68__;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Functions to extract layouts, widgets from a card

function getLayouts(card, boardModel) {
	var layouts = [];
	card.items.forEach(function (item) {
		if (item.type === 'widget') {
			var id = item.id;
			var widgetModel = boardModel.getWidgetModel(id);
			if (widgetModel && widgetModel.type === 'placeholder') {
				layouts.push({ placeholder: item });
			} else {
				layouts.push({ widgetLayout: item });
			}
		}
	});
	return layouts;
} /*
   *+------------------------------------------------------------------------+
   *| Licensed Materials - Property of IBM
   *| IBM Cognos Products: Explore
   *| (C) Copyright IBM Corp. 2018, 2020
   *|
   *| US Government Users Restricted Rights - Use, duplication or disclosure
   *| restricted by GSA ADP Schedule Contract with IBM Corp.
   *+------------------------------------------------------------------------+
   */

function getVisualizations(card, boardModel) {
	return getLayouts(card, boardModel).map(function (layout) {
		return layout.widgetLayout || null;
	});
}

function getVisualizationsIncludingEmpty(card, boardModel) {
	return getLayouts(card, boardModel).map(function (layout) {
		return layout.widgetLayout || layout.placeholder;
	});
}

function getVisualization(card, boardModel, index) {
	var layouts = getLayouts(card, boardModel);
	return index < layouts.length && layouts[index].widgetLayout || null;
}

// Functions to create new cards

function _getPayload(payload) {
	return _underscore2.default.isString(payload) ? {
		undoRedoTransactionId: _underscore2.default.uniqueId(payload)
	} : payload;
}

// Function to duplicate cards
//Utility function to duplicate widget instance and layout which references it.
function duplicateVisualizationsInCard(card, _ref) {
	var boardModel = _ref.boardModel,
	    extraWidgetPayload = _ref.extraWidgetPayload,
	    _ref$widgetIgnoredPro = _ref.widgetIgnoredProps,
	    widgetIgnoredProps = _ref$widgetIgnoredPro === undefined ? [] : _ref$widgetIgnoredPro;

	var idMap = {};

	//Duplicate widgets in card
	var cardWidgets = boardModel._cloneWidgets(card, idMap);

	return getVisualizationsIncludingEmpty(card, boardModel).map(function (vis) {
		if (vis) {
			var newWidget = cardWidgets[idMap[vis.id]];

			widgetIgnoredProps.forEach(function (prop) {
				delete newWidget[prop];
			});

			var oldProperties = newWidget.properties;
			Object.assign(newWidget, extraWidgetPayload);
			if (oldProperties && extraWidgetPayload && extraWidgetPayload.properties) {
				var _newWidget$properties;

				// make copy of properties array, as it was copied by reference in Object.assign(...)
				newWidget.properties = [].concat(newWidget.properties);
				var newPropertyKeys = newWidget.properties.map(function (prop) {
					return prop.id;
				});
				// add in all oldProperties that were not part of the payload
				(_newWidget$properties = newWidget.properties).unshift.apply(_newWidget$properties, oldProperties.filter(function (prop) {
					return !(newPropertyKeys.indexOf(prop.id) !== -1);
				}));
			}

			var widgetLayout = vis.cloneLayout(idMap).toJSON();
			delete widgetLayout.relatedLayouts;
			return {
				layout: widgetLayout,
				widget: newWidget
			};
		} else {
			return null;
		}
	});
}

// --- CREATE


function _createPlaceHolderWidgetSpec() {
	return {
		model: {
			type: 'placeholder',
			placeHolder: true //not needed per se, used only for helping debug
		}
	};
}

function _createCard(exploreLayout, options) {
	var _options$extraLayoutP = options.extraLayoutPayload;
	_options$extraLayoutP = _options$extraLayoutP === undefined ? {} : _options$extraLayoutP;
	var _options$extraLayoutP2 = _options$extraLayoutP.model,
	    optionsModel = _options$extraLayoutP2 === undefined ? {} : _options$extraLayoutP2;


	var boardModel = exploreLayout.boardModel;

	var model = Object.assign({
		type: 'exploreCard',
		items: options.layouts
	}, optionsModel);
	var layoutPayload = Object.assign({}, options.extraLayoutPayload || {}, {
		model: model
	});

	var pageSpec = {
		addLayoutArray: [layoutPayload],
		parentId: exploreLayout.id
	};
	if (options.widgetSpecMap) {
		pageSpec.widgetSpecMap = options.widgetSpecMap;
	}
	var sender = options && options.extraLayoutPayload && options.extraLayoutPayload.sender;
	var addLayoutData = boardModel.addLayouts(pageSpec, sender ? sender : 'CardModelUtil', options.payload);
	var updatedExploreSpec = addLayoutData.value.parameter;

	return updatedExploreSpec.addLayoutArray[0].model.id;
}

function createCardFromFragment(exploreLayout, widgetSpec, payload) {
	var options = {
		insertBefore: null,
		parentId: exploreLayout.id,
		model: widgetSpec.model
	};
	var event = exploreLayout.addFragment(options, 'createCardFromFragment', payload);
	return event.value.parameter.model.layout[0].id;
}

function createCardFromSpec(exploreLayout, widgetSpecs, options) {
	var payload = _getPayload(options.payload);
	if (widgetSpecs[0] && widgetSpecs[0].specType && widgetSpecs[0].specType === 'fragment') {
		return createCardFromFragment(exploreLayout, widgetSpecs[0], payload);
	}
	if (widgetSpecs[0] && widgetSpecs[0].model) {
		delete widgetSpecs[0].model.titleHtml;
	}
	var placeholders = undefined;
	var newCardLayoutId = _createCard(exploreLayout, {
		layouts: placeholders,
		payload: payload,
		extraLayoutPayload: options.extraLayoutPayload
	});
	//Add visualizations to card
	var layoutModel = exploreLayout.boardModel.layout;
	var newLayoutModel = layoutModel.findChildItem(layoutModel.items, newCardLayoutId);
	for (var i = 0; i < widgetSpecs.length; i++) {
		if (widgetSpecs[i]) {
			newLayoutModel.placeWidgetInCard(widgetSpecs[i], payload);
		} else {
			newLayoutModel.placeWidgetInCard(_createPlaceHolderWidgetSpec(), payload);
		}
	}
	return newCardLayoutId;
}

function createCardFromExistingCards(exploreLayout, cards, options) {
	var _payload = options.payload,
	    extraLayoutPayload = options.extraLayoutPayload,
	    extraWidgetPayload = options.extraWidgetPayload,
	    widgetIgnoredProps = options.widgetIgnoredProps;


	var payload = _getPayload(_payload);
	var boardModel = exploreLayout.boardModel;
	var widgetSpecMap = {};
	var newWidgetIdsBySourceCard = {};
	var layouts = [];

	cards.forEach(function (card) {
		var duplicatedVisualizations = duplicateVisualizationsInCard(card, {
			boardModel: boardModel,
			extraWidgetPayload: extraWidgetPayload,
			widgetIgnoredProps: widgetIgnoredProps
		}) || [];

		newWidgetIdsBySourceCard[card.getId()] = [];
		duplicatedVisualizations.forEach(function (viz) {
			widgetSpecMap[viz.widget.id] = viz.widget;
			layouts.push(viz.layout);
			if (viz.layout && viz.layout.id) {
				newWidgetIdsBySourceCard[card.getId()].push(viz.layout.id);
			}
		});
	});

	//Create the target card and assign all of the widgets to it.
	var newLayoutId = _createCard(exploreLayout, {
		layouts: layouts,
		widgetSpecMap: widgetSpecMap,
		payload: payload,
		extraLayoutPayload: extraLayoutPayload
	});

	createEventGroupsForWidgetsInTheTargetCard(exploreLayout, newLayoutId, newWidgetIdsBySourceCard, payload);
	return newLayoutId;
}

function createEventGroupsForWidgetsInTheTargetCard(exploreLayout, newLayoutId, newWidgetIdsBySourceCard, payload) {
	//Manage the event groups for the target card (eg: a compare card) based on the cards they came from.
	//Place each card in the comparison into its own event group to ensure they remain as they were.
	Object.keys(newWidgetIdsBySourceCard).forEach(function (sourceCardId) {
		var targetWidgetIds = newWidgetIdsBySourceCard[sourceCardId]; //Note: currently only 1 widget per source card.
		if (targetWidgetIds.length) {
			var newEventGroupId = _initializeEventGroup(exploreLayout.boardModel, /*targetCard*/newLayoutId, /*targetWidgetIds*/targetWidgetIds, payload.undoRedoTransactionId);

			//Rescope the pageContext entries and ensure any brushing entries are placed into the right event group.
			copyPageContextAndRescope(exploreLayout, {
				layoutId: sourceCardId,
				cloneId: newLayoutId,
				eventGroupId: newEventGroupId,
				undoRedoTransactionId: payload.undoRedoTransactionId
			});
		}
	});

	return newLayoutId;
}

/**
 * Delete an array of cards
 * @param  {string[]} ids, An array of card IDs to be deleted.
 * @return {boolean} True if it successfully deleted passed in cards
 */
function deleteCards(exploreLayout, ids) {
	if (!ids || !ids.length) {
		return false;
	}

	var payload = {
		undoRedoTransactionId: _underscore2.default.uniqueId(ids.length === 1 ? 'removeSingleCard' : 'removeMultipleCards')
	};

	//The following line returns an object that has information about removed objects
	exploreLayout.boardModel.removeLayouts(ids, 'ExploreCardList', payload);

	return true;
}

/**
 * Delete given visualization and select next vis if it's not a placeholder
 * @param  {Object} exploreLayout is layout of exploration
 * @param  {Array} ids of target widget(s) for deletion
 * @return {boolean} on successful deletion of given visualization
 */
var deleteVisAndSelectRemainingVis = function deleteVisAndSelectRemainingVis(exploreLayout, ids) {
	if (!ids || !ids.length) {
		return false;
	}
	var currentContentView = exploreLayout.dashboardApi.getCurrentContentView();
	var exploreContainerModel = currentContentView.getExploreContainerLayoutModel();
	var payload = {
		undoRedoTransactionId: _underscore2.default.uniqueId('removeSingleCard')
	};
	var parentLayoutModel = void 0,
	    targetWidgetId = void 0;
	ids.forEach(function (id) {
		var childLayoutModel = exploreContainerModel.findModel(id);
		if (childLayoutModel) {
			parentLayoutModel = childLayoutModel.getParent();
			parentLayoutModel.replaceWidgetInCard(_createPlaceHolderWidgetSpec(), id, payload);
		}
	});

	if (parentLayoutModel.isCompareEnabled) {
		var cardLayouts = getLayouts(parentLayoutModel, exploreLayout.boardModel) || [];
		cardLayouts.forEach(function (layout) {
			if (layout.hasOwnProperty('widgetLayout')) {
				// find remaining non-placeholder widget id
				targetWidgetId = layout.widgetLayout.id;
			}
		});
		if (targetWidgetId && exploreContainerModel.findModel(targetWidgetId)) {
			currentContentView.getDashboardApi().getCanvas().selectContent([targetWidgetId]);
		}
	}

	return true;
};

/**
 * Copy page contexts items from the old scope to the new scope
 * @param {Object} exploreLayout
 * @param {Object} options { cloneId: newLayoutId, layoutId: oldLayoutId}
 */
function copyPageContextAndRescope(exploreLayout, options) {
	if (exploreLayout.boardModel.pageContext && options) {
		exploreLayout.boardModel.pageContext.copyPageContextItemsAndRescope(options);
	}
}

function _createCards(exploreLayout, options) {

	var optionsArray = Array.isArray(options) ? options : [options];

	var boardModel = exploreLayout.boardModel;

	var widgetSpecMap = {};
	var layoutPayloads = optionsArray.map(function (options) {
		var _options$extraLayoutP3 = options.extraLayoutPayload;
		_options$extraLayoutP3 = _options$extraLayoutP3 === undefined ? {} : _options$extraLayoutP3;
		var _options$extraLayoutP4 = _options$extraLayoutP3.model,
		    optionsModel = _options$extraLayoutP4 === undefined ? {} : _options$extraLayoutP4,
		    _widgetSpecMap = options.widgetSpecMap;

		// merge all widget spec maps from all the cards

		Object.keys(_widgetSpecMap).forEach(function (key) {
			return widgetSpecMap[key] = _widgetSpecMap[key];
		});

		var model = Object.assign({
			type: 'exploreCard',
			items: options.layouts
		}, optionsModel);
		var layoutPayload = Object.assign({}, options.extraLayoutPayload || {}, {
			model: model
		});

		return layoutPayload;
	});

	var pageSpec = {
		addLayoutArray: layoutPayloads,
		parentId: exploreLayout.id,
		widgetSpecMap: widgetSpecMap
	};

	var transactionId = options.length && options[0].payload && options[0].payload.undoRedoTransactionId;
	var addLayoutData = boardModel.addLayouts(pageSpec, 'CardModelUtil', { undoRedoTransactionId: transactionId });
	var updatedExploreSpec = addLayoutData.value.parameter;

	return updatedExploreSpec.addLayoutArray.map(function (addLayout, index) {
		void layoutPayloads;
		var newLayoutId = addLayout.model.id;
		var originalCard = optionsArray[index] && optionsArray[index].card;
		var thisWidgetSpecMap = optionsArray[index] && optionsArray[index].widgetSpecMap;
		if (originalCard) {
			_initializeEventGroupsForDuplicatedCard(boardModel,
			/*sourceWidgetIds*/originalCard.items.map(function (item) {
				return item.id;
			}),
			/*targetCard*/newLayoutId,
			/*targetWidgets*/Object.keys(thisWidgetSpecMap), transactionId);

			//When duplicating, we simply need to rescope (change the pageId)
			//(ie: if a source filter was in group 2, its still in group 2)
			copyPageContextAndRescope(exploreLayout, {
				layoutId: originalCard.id,
				cloneId: newLayoutId,
				undoRedoTransactionId: transactionId
			});
		}
		return newLayoutId;
	});
}

function _initializeEventGroupsForDuplicatedCard(boardModel, sourceWidgetIds, targetCardId, targetWidgetIds, transactionId) {
	//Build a map of assignments from the original eventGroup to the source and target widgetIds
	var matchingEventGroupMap = {};
	boardModel.eventGroups.getModels().forEach(function (eventGroup) {
		var eventGroupId = eventGroup.id;
		eventGroup.widgetIds.forEach(function (widgetId) {
			var widgetIdx = sourceWidgetIds.indexOf(widgetId);
			if (widgetIdx >= 0) {
				matchingEventGroupMap[eventGroupId] = matchingEventGroupMap[eventGroupId] || [];
				matchingEventGroupMap[eventGroupId].push({ sourceWidgetId: sourceWidgetIds[widgetIdx], targetWidgetId: targetWidgetIds[widgetIdx] });
			}
		});
	});

	//For each source eventGroup, create a new group with the new widgetId
	//(to keep scope limited, only do this for the compare card with multiple groups case - otherwise, let things default.).
	if (Object.keys(matchingEventGroupMap).length > 1) {
		Object.values(matchingEventGroupMap).forEach(function (eventGroupMapping) {
			var targetWidgetIds = eventGroupMapping.map(function (eventGroupMapping) {
				return eventGroupMapping.targetWidgetId;
			});
			_initializeEventGroup(boardModel, targetCardId, targetWidgetIds, transactionId);
		});
	}
}

function _initializeEventGroup(boardModel, targetCardId, targetWidgetIds, transactionId) {
	var newEventGroup = boardModel.eventGroups.createGroup(targetWidgetIds, { targetPageId: targetCardId, payloadData: { undoRedoTransactionId: transactionId, silent: true } });
	return newEventGroup && newEventGroup.id || null;
}

function duplicateCards(exploreLayout, options) {

	var optionsArray = Array.isArray(options) ? options : [options];

	var boardModel = exploreLayout.boardModel;

	var createCardOptions = optionsArray.map(function (_ref2) {
		var card = _ref2.card,
		    options = _ref2.options;
		var _payload = options.payload,
		    _options$extraLayoutP5 = options.extraLayoutPayload,
		    extraLayoutPayload = _options$extraLayoutP5 === undefined ? {} : _options$extraLayoutP5,
		    extraWidgetPayload = options.extraWidgetPayload;


		var widgetSpecMap = {};
		var layouts = [];
		var payload = _getPayload(_payload);

		var duplicatedVisualizations = duplicateVisualizationsInCard(card, {
			boardModel: boardModel,
			extraWidgetPayload: extraWidgetPayload
		}) || [];

		duplicatedVisualizations.forEach(function (viz) {
			widgetSpecMap[viz.widget.id] = viz.widget;
			layouts.push(viz.layout);
		});

		return {
			card: card,
			layouts: layouts,
			widgetSpecMap: widgetSpecMap,
			payload: payload,
			extraLayoutPayload: extraLayoutPayload
		};
	});

	var newLayoutIds = _createCards(exploreLayout, createCardOptions);
	return newLayoutIds;
}

exports.default = {
	getLayouts: getLayouts,
	getVisualizations: getVisualizations,
	getVisualization: getVisualization,
	createCardFromSpec: createCardFromSpec,
	createCardFromExistingCards: createCardFromExistingCards,
	createEventGroupsForWidgetsInTheTargetCard: createEventGroupsForWidgetsInTheTargetCard,
	deleteCards: deleteCards,
	deleteVisAndSelectRemainingVis: deleteVisAndSelectRemainingVis,
	copyPageContextAndRescope: copyPageContextAndRescope,
	duplicateCards: duplicateCards
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var RefChecker = function RefChecker(subject) {
	_classCallCheck(this, RefChecker);

	var validRef = new WeakMap();
	validRef.set(subject, true);
	this.isValid = function () {
		return validRef.has(subject);
	};

	this.remove = function () {
		validRef.delete(subject);
	};
};

exports.default = RefChecker;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

//const Formatter = { format: (a) => { return a; } }; //require('gemini/lib/@waca/core-client/js/core-client/i18n/Formatter');
var Formatter = exports.Formatter = __webpack_require__(182);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _mobxStateTree = __webpack_require__(7);

exports.default = _mobxStateTree.types.model({
	scopeId: _mobxStateTree.types.string
}).views(function (self) {
	return {

		/**
  * Get the total active filter count from the given scope id (aka layout model id for the scope)
  * @param {String} scopeId
  * @returns {int} filterCount
  */
		getFilterCount: function getFilterCount() {
			return self.filterCount;
		},
		getCurrentExtensionScope: function getCurrentExtensionScope() {
			if (self._filterDockExtensionView) {
				return self._filterDockExtensionView.getApi().currentScope();
			}
		}
	};
}).volatile(function () {
	return {
		dashboardApi: null,
		exploreVM: null,
		_disposeEvents: [],
		filterCount: null,
		filterCountExtensionFn: null
	};
}).actions(function (self) {
	return {
		afterCreate: function afterCreate() {
			self.dashboardApi = (0, _mobxStateTree.getEnv)(self).dashboardApi;
			self._registerDashboardApiEvents();
			self.exploreVM = (0, _mobxStateTree.getEnv)(self).exploreVM;
		},
		registerFilterCountPayloadExtension: function registerFilterCountPayloadExtension(fn) {
			self.filterCountExtensionFn = fn;
		},


		/**
  * Get and filter out all of the active dock filters within the scope in pageContext
  * sets filterCount to the number of active filters in current context
  * eg. PageContext Spec Sample
  * if the scope is 'page1:2', the number of active dock filters will be 1 in the below spec
  * {
  	 origin: 'filter',
  	 sourceId: '123',
  	 scope: 'page1:1'
   }, {
  	 origin: 'filter',
  	 sourceId: '123',
  	 scope: 'page1:2'
   }, {
  	 origin: 'visualization',
  	 sourceId: '123',
  	 scope: 'page1:2'
   }
   */

		fetchFilterCount: function fetchFilterCount() {
			var selector = { scope: self.scopeId, origin: 'filter' };
			if (self.filterCountExtensionFn) {
				selector = self.filterCountExtensionFn(selector);
			}
			self.filterCount = self.dashboardApi.getFeature('GlobalFilters').getFilterList(selector).length;
		},
		beforeDestroy: function beforeDestroy() {
			// Remove the events
			self._disposeEvents && self._disposeEvents.forEach(function (dispose) {
				return dispose && dispose.remove();
			});
			self.dashboardApi = null;
		},
		switchDatasource: function switchDatasource(activeDataSourceId) {
			if (self._filterDockExtensionView) {
				self._filterDockExtensionView.getApi().switchDatasource(activeDataSourceId);
				self.fetchFilterCount();
			}
		},
		initializeFilterDock: function initializeFilterDock() {
			return self.dashboardApi.getDashboardSvc('.CanvasExtensions').then(function (canvasExtensions) {
				self.canvasExtensions = canvasExtensions;
				if (self.canvasExtensions) {
					self._filterDockExtensionView = self.canvasExtensions.getExtension('filterDock');
					self.filterDockCollapseView = self.canvasExtensions.getExtension('filterDockCollapseControl');
					self.fetchFilterCount();
				}
			});
		},
		_switchDatasourceSilently: function _switchDatasourceSilently() {
			if (self._filterDockExtensionView) {
				if (self.exploreVM && self.exploreVM.isStartingPointsDisplayed()) {
					self._filterDockExtensionView.getApi().switchDatasource(self.dashboardApi.getActiveDataSourceId(), { silent: true });
				} else {
					self._filterDockExtensionView.getApi().switchDatasource(null, { silent: true });
				}
			}
			self.fetchFilterCount();
		},


		/**
  *  register to listen to dashboard api events and fetch filter count
   *
   *  listens to the following scenarios
   *  1) collapse - user close the filter dock in compare card
   * 	2) filterIndicator:removeEntry - use delete a filter entry from filter indicator
   *  3) brushing:undoRedo - undo / redo of pagecontext change. Misleading event name, not just for brushing.
   */
		_registerDashboardApiEvents: function _registerDashboardApiEvents() {
			self._disposeEvents.push(self.dashboardApi.on('filterDock:collapse', function () {
				self.fetchFilterCount();
			}));
			self._disposeEvents.push(self.dashboardApi.on('filterIndicator:removeEntry', function () {
				self.fetchFilterCount();
			}));
			self._disposeEvents.push(self.dashboardApi.on('brushing:undoRedo', function () {
				self.fetchFilterCount();
			}));
			self._disposeEvents.push(self.dashboardApi.on('tab:tabChanged', function () {
				self._switchDatasourceSilently();
			}));
		}
	};
}); /*
     *+------------------------------------------------------------------------+
     *| Licensed Materials - Property of IBM
     *| IBM Cognos Products: Explore
     *| (C) Copyright IBM Corp. 2018, 2019
     *|
     *| US Government Users Restricted Rights - Use, duplication or disclosure
     *| restricted by GSA ADP Schedule Contract with IBM Corp.
     *+------------------------------------------------------------------------+
     */

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _mobxStateTree = __webpack_require__(7);

var _mobxUtils = __webpack_require__(15);

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

exports.default = _mobxStateTree.types.model('NaturalLanguageTextModel', {
	id: _mobxStateTree.types.string,
	shouldFetch: _mobxStateTree.types.optional(_mobxStateTree.types.boolean, false)
}).volatile(function () {
	return {
		items: null
	};
}).views(function (self) {
	return {
		getItems: function getItems() {
			var items = void 0;
			if (self.items && self.items.state === _mobxUtils.FULFILLED) {
				items = self.items.value;
			}
			return items || [];
		}
	};
}).actions(function (self) {
	function getFeature() {
		var _getEnv = (0, _mobxStateTree.getEnv)(self),
		    dashboardApi = _getEnv.dashboardApi;

		return dashboardApi.getCanvasWhenReady().then(function (canvas) {
			self.widgetContentApi = canvas.getContent(self.id);
			return canvas.getWidgetWhenReady(self.id);
		}).then(function (widget) {
			if (widget) {
				return widget.getFeature('vis-chart-insights');
			}
		});
	}

	return {
		afterCreate: function afterCreate() {
			getFeature().then(function (feature) {
				if (feature) {
					return feature.activate({
						widgetContentApi: self.widgetContentApi,
						cbChartInsightsUpdated: function cbChartInsightsUpdated() {
							self.setShouldFetch(true);
						}
					});
				}
			});
		},
		setShouldFetch: function setShouldFetch(fetch) {
			self.shouldFetch = fetch;
		},
		fetchItems: function fetchItems() {
			if (!self.shouldFetch) {
				return self.items || Promise.resolve();
			}

			self.setShouldFetch(false);

			var promise = (0, _mobxUtils.fromPromise)(getFeature().then(function (feature) {
				if (feature) {
					return feature.getInsights();
				}
			}).then(function (response) {
				if (response) {
					return response.insights || [];
				}
				return [];
			}));

			self.items = promise;

			return promise;
		}
	};
});

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_76__;

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _SmartsRecommenderStatus = __webpack_require__(47);

var _SmartsRecommenderStatus2 = _interopRequireDefault(_SmartsRecommenderStatus);

var _ToastUtil = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */


var MEMBER_TYPE_FOCUSFILED = 'focusField';
var ERROR_CODES_CONVERTED_TO_SINGLE_NODE = [_SmartsRecommenderStatus2.default.UNSUPPORTED_MODULE_TYPE, _SmartsRecommenderStatus2.default.UNSUPPORTED_UNENRICHED_PACKAGE];
var GROUPID = 'all';

/**
* This class builds data structure locally that is sames as from the /relatonship endpoint response
*
*/

var DataBuilder = function () {
	function DataBuilder() {
		_classCallCheck(this, DataBuilder);
	}

	/**
 * Convert certain error code to be a local built relationship diagram response with a 'completed' status
 * (that has one node (targetID) dataset structure)
 * @param {object} ajaxResponse - response from Smarts-explore service
 @ @param {object} context - contains targetId
 */
	DataBuilder.convertErrorsToCompletedResponse = function convertErrorsToCompletedResponse(ajaxResponse, context) {
		var status = ajaxResponse && ajaxResponse.data && ajaxResponse.data.status;

		if (status) {
			var statusCode = status.statusCode;
			if (ERROR_CODES_CONVERTED_TO_SINGLE_NODE.indexOf(statusCode) !== -1) {
				var statusMsg = 'Explore fallback response for error code ' + statusCode;
				this._handleStatusObjectAsToast(context, statusCode);
				return Promise.resolve({ 'data': this.createSingleNode(context.targetID, statusMsg, null) });
			}
		} else if (ajaxResponse && ajaxResponse.statusText) {
			this._handleStatusTextAsToast(context, ajaxResponse.statusText);
		}
		return Promise.reject(ajaxResponse);
	};

	DataBuilder._handleStatusObjectAsToast = function _handleStatusObjectAsToast(context, statusCode) {
		void statusCode;
		var model = context.relationshipModel;
		if (model) {
			var targetModel = model.getTargetModel();
			if (targetModel) {
				targetModel.setActionErrorStatus('We were unable to show relationships because there is limited support for this data source type.');
			}
		}
	};

	DataBuilder._showUnsupportedSourceTypeToast = function _showUnsupportedSourceTypeToast(statusCode, glassContext) {
		if (statusCode === _SmartsRecommenderStatus2.default.UNSUPPORTED_MODULE_TYPE) {
			(0, _ToastUtil.showUnsupportedSourceTypeToast)(glassContext);
		} else if (statusCode === _SmartsRecommenderStatus2.default.UNSUPPORTED_UNENRICHED_PACKAGE) {
			(0, _ToastUtil.showUnsupportedUnenrichedToast)(glassContext);
		}
	};

	DataBuilder._handleStatusTextAsToast = function _handleStatusTextAsToast(context, statusText) {
		if (_SmartsRecommenderStatus2.default.RELATIONSHIP_REQUEST_TIMEOUT === statusText) {
			(0, _ToastUtil.showRelationRequestTimeoutToast)(context.glassContext);
		}
	};

	/**
 * @param {String} targetId
 * @param {String} statusMsg
 * @param {String} statusCode
 * @param {JSONObject} predictStatusObject
 */


	DataBuilder.createSingleNode = function createSingleNode(targetID, statusMsg) {
		var predictStatusObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

		return {
			'nodesDataset': {
				'targetId': targetID,
				'groupings': [{
					'groups': [{
						'groupId': 'none_' + targetID,
						'members': [{
							'id': targetID,
							'type': MEMBER_TYPE_FOCUSFILED
						}]
					}],
					'id': GROUPID
				}]
			},
			'relationshipStrength': {
				'results': [{
					'relationships': [],
					'id': GROUPID
				}],
				'predictStatus': predictStatusObject
			},
			'status': {
				'message': statusMsg,
				'statusCode': _SmartsRecommenderStatus2.default.COMPLETED
			}
		};
	};

	return DataBuilder;
}();

exports.default = DataBuilder;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.StartingPointsViewModel = exports.Field = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                   *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                   *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                   *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                   *|
                                                                                                                                                                                                                                                                   *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                   *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                   */


var _mobxStateTree = __webpack_require__(7);

var _mobx = __webpack_require__(11);

var mobx = _interopRequireWildcard(_mobx);

var _mobxUtils = __webpack_require__(15);

var _FetchSmartsData = __webpack_require__(83);

var _FieldsModel = __webpack_require__(234);

var _RelationshipVisViewModel = __webpack_require__(235);

var _RelationshipVisViewModel2 = _interopRequireDefault(_RelationshipVisViewModel);

var _RelationshipVisLoader = __webpack_require__(238);

var _RelationshipVisLoader2 = _interopRequireDefault(_RelationshipVisLoader);

var _FilterDockModel = __webpack_require__(72);

var _FilterDockModel2 = _interopRequireDefault(_FilterDockModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var STARTING_POINTS = 'starting points';

var Field = exports.Field = _mobxStateTree.types.model('Field', {
	name: _mobxStateTree.types.string,
	id: _mobxStateTree.types.optional(_mobxStateTree.types.string, '')
});

var StartingPointsViewModel = exports.StartingPointsViewModel = _mobxStateTree.types.model('StartingPointsViewModel', {
	fields: _FieldsModel.FieldsModel,
	relationship: _RelationshipVisViewModel2.default,
	showModalVisTypePicker: _mobxStateTree.types.optional(_mobxStateTree.types.boolean, false)
}).volatile(function () {
	return {
		_isAlive: _mobxStateTree.isAlive,
		exploreVM: null,
		relationshipSupported: null, //Deprecated. Delete when newStartingPoints flag is removed
		recommendations: mobx.observable.map(),
		recommendationsOfStaticType: null,
		selectedInfluencers: [],
		filterDockModel: null,
		activeDataSourceName: null
	};
}).extend(function (self) {
	var disposeFunctions = [];

	var FIELD_ID_SEPARATOR = ';';
	function _fieldsToString(fieldIds, datasouceId) {
		var result = fieldIds.reduce(function (accumulator, fieldId, index) {
			return '' + accumulator + (index > 0 ? FIELD_ID_SEPARATOR : '') + fieldId;
		}, '');
		return datasouceId + '_' + result; //Prefix fields string with datasource ID
	}

	//Deprecated. Delete this function when the newStartingPoints flag is removed.
	function initializeRelationshipSupported() {
		var relationshipSupportedFunctions = {};
		var promise = new Promise(function (resolve, reject) {
			relationshipSupportedFunctions.resolve = resolve;
			relationshipSupportedFunctions.reject = reject;
		});
		var relSupported = (0, _mobxUtils.fromPromise)(promise);
		self.setRelationshipSupported(relSupported);
		//On first response from smarts service, determine whether it's functioning correctly
		var disposeRelationshipSupportedResolver = mobx.autorun(function () {
			if (shouldExecuteToGetFields()) {
				var _self$fields$getField = self.fields.getFields(),
				    interesting = _self$fields$getField.interesting;

				if (interesting.state === _mobxUtils.REJECTED) {
					//If fields cannot be loaded, cannot render relationship
					relationshipSupportedFunctions.reject(interesting.error);
				} else if (interesting.state === _mobxUtils.FULFILLED) {
					var targetModel = self.relationship.getTargetModel();
					var relationshipPromise = targetModel && targetModel.data;
					if (relationshipPromise && relationshipPromise.state === _mobxUtils.REJECTED) {
						//In general, we assume that errors which occur when rendering the
						//relationship diagram are *potentially* recoverable by selecting a
						//new field, so we can resolve the relationship supported promise.
						//The exception is if there is a missing smarts module, however this
						//case should fail the fields promise, preventing relationship
						//promise from ever finishing.
						relationshipSupportedFunctions.resolve();
					} else if (relationshipPromise && relationshipPromise.state === _mobxUtils.FULFILLED) {
						relationshipSupportedFunctions.resolve();
					}
				}
			}
		});
		//Whether relationship is supported is determined upon first response from smarts server.
		//Once relationship support is determined, we no longer need the autorun logic.
		self.relationshipSupported.then( //Node 8 doesn't support Promise.finally
		function () {
			return disposeRelationshipSupportedResolver();
		}, function () {
			return disposeRelationshipSupportedResolver();
		});
	}

	//We only send requests to get interesting fields if the current display card is starting points
	function shouldExecuteToGetFields() {
		return self._isAlive(self.exploreVM) && self.exploreVM.activeDataSourceId && self.exploreVM.displayedCard === STARTING_POINTS;
	}

	function _setActiveDataSourceName(dataSourceId) {
		(0, _mobxStateTree.getEnv)(self).dashboardApi.getFeature('DataSources').getDataSource(dataSourceId).getLocalizedName().then(function (sourceName) {
			if (sourceName) {
				self.setActiveDataSourceName(sourceName);
			}
		});
	}

	function _switchFilterDockDatasource(activeDataSourceId) {
		if (self.exploreVM.isStartingPointsDisplayed()) {
			self.filterDockModel.switchDatasource(activeDataSourceId);
			if (self.filterDockModel.getCurrentExtensionScope() != STARTING_POINTS) {
				self.exploreVM.notifyTabChanged(STARTING_POINTS);
			}
		}
	}

	return {
		views: {
			getSelectedInfluencers: function getSelectedInfluencers() {
				if (self.selectedInfluencers && self.selectedInfluencers.length) {
					return self.selectedInfluencers;
				}

				if (!self.isNewStartingPointsFeatureEnabled()) {
					return null;
				}

				if (self.relationship) {
					var field = self.fields.getFocusField();
					if (field) {
						return [{ id: field.id, label: field.name }];
					}
				}

				return null;
			},
			getRecommendations: function getRecommendations(fieldIds) {
				if (!fieldIds || fieldIds.length === 0) {
					return null;
				}
				return self.recommendations.get(_fieldsToString(fieldIds, self.exploreVM.activeDataSourceId)) || self._fetchRecommendedVisualizations(fieldIds);
			},
			isRecommendationOfStaticType: function isRecommendationOfStaticType(recommendationKey) {
				return self.recommendationsOfStaticType.indexOf(recommendationKey) > -1;
			},
			_fetchRecommendedVisualizations: function _fetchRecommendedVisualizations(fieldIds) {
				var recommendations = (0, _mobxUtils.fromPromise)((0, _FetchSmartsData.fetchRecommendations)(self.exploreVM, fieldIds));
				self.recommendations.set(_fieldsToString(fieldIds, self.exploreVM.activeDataSourceId), recommendations);
				return recommendations;
			},
			loadVisForSelectedInfluencers: function loadVisForSelectedInfluencers() {
				return self._fetchRecommendedVisualizations(self.getSelectedInfluencers());
			},
			isNewStartingPointsFeatureEnabled: function isNewStartingPointsFeatureEnabled() {
				return !(0, _mobxStateTree.getEnv)(self).isFeatureEnabled('newStartingPoints', 'false');
			},
			shouldUseDisambiguatedPaths: function shouldUseDisambiguatedPaths() {
				var env = (0, _mobxStateTree.getEnv)(self);
				return env && env.isFeatureEnabled && !env.isFeatureEnabled('useDisambiguatedPaths', 'false');
			},
			showFilterDock: function showFilterDock() {
				return !!self.fields.getFocusField();
			},
			getActiveDataSourceName: function getActiveDataSourceName() {
				return self.activeDataSourceName;
			}
		},
		actions: {
			afterCreate: function afterCreate() {
				self._isAlive = (0, _mobxStateTree.getEnv)(self).isAlive || self._isAlive;
				self.exploreVM = (0, _mobxStateTree.getEnv)(self).exploreVM;
				self.dashboardApi = (0, _mobxStateTree.getEnv)(self).dashboardApi;
				self.recommendationsOfStaticType = [];
				self.relationship.setExploreViewId((0, _mobxStateTree.getEnv)(self).exploreViewId);
				self.relationship.setSmartsRecommenderWrapper(self.exploreVM.getSmartsRecommenderWrapper());
				//StartingPointViewModel holds one VisLoader instance only
				var visLoader = new _RelationshipVisLoader2.default({
					dashboardApi: self.dashboardApi,
					startingPointsVM: self
				});
				self.relationship.setVisLoader(visLoader);
				var isFilterStrengthFeatureEnabled = (0, _mobxStateTree.getEnv)(self).isFeatureEnabled('filterRelationshipStrength');
				self.relationship.setIsFilterStrengthFeatureEnabled(isFilterStrengthFeatureEnabled);
				self.filterDockModel = _FilterDockModel2.default.create({
					scopeId: STARTING_POINTS
				}, {
					dashboardApi: self.dashboardApi,
					exploreVM: self.exploreVM,
					logger: (0, _mobxStateTree.getEnv)(self).logger
				});
				self.filterDockModel.registerFilterCountPayloadExtension(function (object) {
					return _extends({}, object, {
						sourceId: self.exploreVM.activeDataSourceId,
						_strictMatch: true
					});
				});
				//On set/change datasource, initialize new relationshipSupported promise
				disposeFunctions.push(mobx.reaction(function () {
					return self.exploreVM.activeDataSourceId;
				}, function (activeDataSourceId) {
					if (activeDataSourceId) {
						_setActiveDataSourceName(activeDataSourceId);
						self.setSelectedInfluencers();
						if (!self.isNewStartingPointsFeatureEnabled()) {
							initializeRelationshipSupported();
						}
						self.filterDockModel.initializeFilterDock(activeDataSourceId).then(function () {
							return _switchFilterDockDatasource(activeDataSourceId);
						});
					}
				}));

				disposeFunctions.push(mobx.reaction(function () {
					if (shouldExecuteToGetFields()) {
						var fields = self.fields.getFields();
						var fieldsReady = false;
						if (self.isNewStartingPointsFeatureEnabled()) {
							if (fields.all.state === _mobxUtils.FULFILLED) {
								fieldsReady = true;
							}
						} else {
							fieldsReady = fields.interesting.state === _mobxUtils.FULFILLED;
						}
						if (fieldsReady) {
							var field = self.fields.getFocusField();
							return field;
						}
					}
				}, function (field) {
					if (self.relationship) {
						if (field) {
							//Initialize relationship chart
							self.relationship.setTargetIds([field.id], [{ label: field.name }]);
							self.relationship.setDataSourceId(self.exploreVM.activeDataSourceId);
							self.setSelectedInfluencers(self.selectedInfluencers);
						} else {
							//Clear relationship chart
							self.relationship.setTargetIds([]);
							if (self.exploreVM.activeDataSourceId) {
								self.relationship.setDataSourceId(self.exploreVM.activeDataSourceId);
							} else {
								self.relationship.setDataSourceId(null);
							}
						}
					}
				}
				// No other state is possible here - see relationshipSupported promise
				));
			},


			/* TO-DO this function is actually never called
    * when we do call it we should destroy filterDockModel
    */
			beforeDestroy: function beforeDestroy() {
				disposeFunctions.forEach(function (dispose) {
					return dispose();
				});
				self.filterDockModel && (0, _mobxStateTree.destroy)(self.filterDockModel);
			},
			setModelChecker: function setModelChecker(isAlive) {
				self._isAlive = isAlive;
			},
			setRelationshipSupported: function setRelationshipSupported(relationshipSupported) {
				self.relationshipSupported = relationshipSupported;
			},
			setShowModalVisTypePicker: function setShowModalVisTypePicker(show) {
				self.showModalVisTypePicker = show;
			},
			setSelectedInfluencers: function setSelectedInfluencers() {
				var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

				self.selectedInfluencers = fields;
				self.recommendationsOfStaticType = [];
			},
			addRecommendationsOfStaticType: function addRecommendationsOfStaticType(recommendationKey) {
				self.recommendationsOfStaticType.push(recommendationKey);
			},
			reset: function reset() {
				self.fields.resetData();
				var field = self.fields.getFocusField();
				self.relationship.reset();
				if (field) {
					self.relationship.setTargetIds([field.id], [{ label: field.name }]);
				}
				self.relationship.setDataSourceId(self.exploreVM.activeDataSourceId);
			},
			refreshStartingPoints: function refreshStartingPoints() {
				//we are forcing a refresh of the starting points
				self.fields.clearFields();
				self.setSelectedInfluencers();
				initializeRelationshipSupported();
			},
			setActiveDataSourceName: function setActiveDataSourceName(dataSourceName) {
				self.activeDataSourceName = dataSourceName;
			}
		}
	};
});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var fetchFieldPromises = function fetchFieldPromises(exploreVM, dataSourceId) {
	var all = exploreVM.getSmartsRecommenderWrapper().getMetadataColumns(dataSourceId).then(function (columns) {
		return columns.map(function (col) {
			return {
				name: col.getLabel(),
				id: col.getId()
			};
		});
	});

	var interesting = all.then(function () {
		return exploreVM.getSmartsRecommenderWrapper().recommendInterestingFields(dataSourceId);
	});

	return {
		all: all, interesting: interesting
	};
};

//Deprecated
var fetchFields = function fetchFields(exploreVM, dataSourceId) {
	var _fetchFieldPromises = fetchFieldPromises(exploreVM, dataSourceId),
	    all = _fetchFieldPromises.all,
	    interesting = _fetchFieldPromises.interesting;

	return Promise.all([all, interesting]).then(function (_ref) {
		var all = _ref[0],
		    interesting = _ref[1];
		return { all: all, interesting: interesting };
	});
};

var fetchRecommendations = function fetchRecommendations(exploreVM, fieldIds) {
	return exploreVM.getSmartsRecommenderWrapper().recommendRelatedVisualizationsAsWidgetSpecs(exploreVM.activeDataSourceId, fieldIds, { includeBestVisForTargetFields: true });
};

exports.fetchFields = fetchFields;
exports.fetchFieldPromises = fetchFieldPromises;
exports.fetchRecommendations = fetchRecommendations;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
//TODO: move it to a shared lib

//Small wrapper utility to allow defer loading AMD modules from webpack bundle
//Webpack collects all external deps and does require on them at the start of the bundle
//This tries to hide the require reference from webpack to prevent upfront requires
var loadModules = function loadModules(arrModule, cb, cbErr) {
  var reqFn = 'require';
  window[reqFn](arrModule, cb, cbErr);
};

var disabledLoader = false;
exports.loadModules = loadModules;
exports.disabledLoader = disabledLoader;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _DnDHandler2 = __webpack_require__(86);

var _DnDHandler3 = _interopRequireDefault(_DnDHandler2);

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

var _WidgetSpecUtil = __webpack_require__(258);

var _WidgetSpecUtil2 = _interopRequireDefault(_WidgetSpecUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var SingleVisDnDHandler = function (_DnDHandler) {
	_inherits(SingleVisDnDHandler, _DnDHandler);

	function SingleVisDnDHandler(options) {
		_classCallCheck(this, SingleVisDnDHandler);

		var _this = _possibleConstructorReturn(this, _DnDHandler.call(this, options));

		_this.dashboardApi = options.dashboardApi;
		_this.createVis = options.createVis;
		_this.replaceWithWidget = options.replaceWithWidget;
		_this.placeWidgetInCard = options.placeWidgetInCard;
		_this.widgetLayout = options.widgetLayout;
		_this.layoutModel = options.layoutModel;
		return _this;
	}

	SingleVisDnDHandler.prototype.getNewCompareDnDEnabled = function getNewCompareDnDEnabled() {
		return this.layoutModel && this.layoutModel.isNewCompareDnDFeature();
	};

	// Since we use opacity to determine selected card in explore and all cards are stacked 
	// with opacity 0(except the selected one), DNDManager does not know which dropzones belong to which card, or other
	// drop targets in the layout(cardlist, starting points, etc)
	// Even though card with opacity 1(selected card) may be visible, there might be other listening drop targets 
	// in front of it with opacity 0, resulting in partial or complete highlight target deactivation on hover action.
	// DNDManager is used across entire product stack, therefore this check is isolated to Explore where we employ 
	// opacity for current card.


	SingleVisDnDHandler.prototype.isVisible = function isVisible() {
		var n = this.domNode;
		while (n && n !== document) {
			if (!n.getClientRects().length || (0, _jquery2.default)(n).css('opacity') === '0') {
				return false;
			}
			n = n.parentElement;
		}
		return true;
	};

	SingleVisDnDHandler.prototype.accepts = function accepts(dragObject) {
		if (!this.isVisible()) {
			return false;
		}

		if (this.getNewCompareDnDEnabled() && dragObject.type === 'card' && dragObject.data.length === 1) {
			var card = this.getCardById(dragObject.data[0]);
			return card.subType !== 'compare'; // prevent dropping compare card onto vis template
		}
		if (this.replaceWithWidget && !this.widgetLayout) {
			return false;
		}
		if (this.isPinObject(dragObject)) {
			var liveWidgets = this.getPinWidgets(dragObject);
			return liveWidgets.length === 1;
		} else if (this.isAcceptedLiveWidget(dragObject)) {
			return true;
		}
		return false;
	};

	SingleVisDnDHandler.prototype.onDrop = function onDrop(dragObject) {
		var _this2 = this;

		var isDnDFromCardList = dragObject.type === 'card' && dragObject.data.length === 1 || false;
		return this.getWidgetSpec(dragObject).then(function (widgetSpec) {
			if (widgetSpec) {
				var shouldCreate = isDnDFromCardList ? 'cardCreate' : undefined;
				_this2.createVis && _this2.createVis(widgetSpec);
				_this2.replaceWithWidget && _this2.replaceWithWidget(widgetSpec, _this2.widgetLayout.id, shouldCreate);
			}
		});
	};

	SingleVisDnDHandler.prototype.getWidgetSpec = function getWidgetSpec(dragObject) {
		var _this3 = this;

		if (dragObject.type === 'card') {
			var card = this.getCardById(dragObject.data[0]);
			return _WidgetSpecUtil2.default.getWidgetSpecForCompareCard(card, this.dashboardApi);
		} else if (this.isPinObject(dragObject)) {
			return this.getSpecfromPin(dragObject).then(function (spec) {
				return _this3._getSpec(spec, 'fragment');
			});
		} else if (this.isAcceptedLiveWidget(dragObject)) {
			return this._getSpec(dragObject.data.model, 'widget');
		}
		return Promise.resolve(null);
	};

	/**
  * @param {String} id of the Card
  * Return Card object
  */


	SingleVisDnDHandler.prototype.getCardById = function getCardById(id) {
		return this.dashboardApi.getCurrentContentView().getExploreContainerLayoutModel().findModel(id);
	};

	SingleVisDnDHandler.prototype._getSpec = function _getSpec(spec, specType) {
		return Promise.resolve({
			model: spec,
			specType: specType
		});
	};

	return SingleVisDnDHandler;
}(_DnDHandler3.default);

exports.default = SingleVisDnDHandler;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

var _ExtVisUtil = __webpack_require__(45);

var _ToastUtil = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

var DnDHandler = function () {
	function DnDHandler(options) {
		_classCallCheck(this, DnDHandler);

		this.domNode = options.domNode;
		this.className = options.className;
		this.dashboardApi = options.dashboardApi;
		this.activate = options.activate;
		this.deactivate = options.deactivate;
		this.isExtVis = false;
	}

	DnDHandler.prototype.accepts = function accepts() {
		return false;
	};

	DnDHandler.prototype.activateDropTarget = function activateDropTarget() {
		this.activate && this.activate();
		(0, _jquery2.default)(this.domNode).toggleClass(this.className, true);
	};

	DnDHandler.prototype.deactivateDropTarget = function deactivateDropTarget() {
		this.deactivate && this.deactivate();
		(0, _jquery2.default)(this.domNode).toggleClass(this.className, false);
	};

	DnDHandler.prototype.onDragEnter = function onDragEnter(dragObject) {
		this.activateDropTarget();
		if (dragObject.avatar && dragObject.avatar.length && dragObject.avatar.length > 0) {
			dragObject.avatar[0].style.zIndex = '9999999';
		}
	};

	DnDHandler.prototype.onDragLeave = function onDragLeave() {
		this.deactivateDropTarget();
	};

	DnDHandler.prototype.onDragEnd = function onDragEnd() {
		this.deactivateDropTarget();
		if (this.isExtVis && this.glassContext) {
			(0, _ToastUtil.showUnsupportedExtVisToast)(this.glassContext);
			this.isExtVis = false;
		}
	};

	DnDHandler.prototype.onDrop = function onDrop(dragObject, dropNode) {
		this.dropHandler(dragObject, dropNode);
	};

	DnDHandler.prototype.getSpecfromPin = function getSpecfromPin(dragObject) {
		var content = dragObject.data.pinSpec.content;
		return this.dashboardApi.getGlassSvc('.ConversionService').then(function (conversionSvc) {
			return conversionSvc.convert('DASHBOARD', 'EXPLORE', JSON.stringify(content));
		}).then(function (spec) {
			return JSON.parse(spec);
		});
	};

	DnDHandler.prototype.isPinObject = function isPinObject(dragObject) {
		return dragObject.type === 'pin';
	};

	DnDHandler.prototype.isAcceptedLiveWidget = function isAcceptedLiveWidget(dragObject) {
		//live widget from pin type == 'live'
		//live widget from conversation view type == 'widget' && widgetType == 'live'
		if (dragObject.type === 'live' || dragObject.type === 'widget' && dragObject.widgetType === 'live') {
			var visId = dragObject.visId;
			this.isExtVis = (0, _ExtVisUtil.isExtVis)(visId);
			return visId !== 'dataPlayer' && !this.isExtVis;
		}
		return false;
	};

	DnDHandler.prototype.getPinWidgets = function getPinWidgets(dragObject) {
		var _this = this;

		if (dragObject.data.pinSpec.content.widgets) {
			var liveWidgets = dragObject.data.pinSpec.content.widgets.filter(function (widget) {
				return _this.isAcceptedLiveWidget(widget);
			});
			return liveWidgets;
		}
		return [];
	};

	return DnDHandler;
}();

exports.default = DnDHandler;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(259);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./create.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./create.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var BaseClass = __webpack_require__(39);

var CommonAuthoringFeature = BaseClass.extend({

	init: function init(layout) {
		this.layoutView = layout;
		this._events = [this.layoutView.model.on('add:item', this.onModelAddItem, this), this.layoutView.model.on('remove:item', this.onModelRemoveItem, this)];

		this._childrenLayouts = {};
	},

	destroy: function destroy() {
		if (this._events) {
			for (var i = 0; i < this._events.length; i++) {
				if (this._events[i]) {
					this._events[i].remove();
				}
			}
		}
		this._events = null;
		this._destroyChildrenLayouts();
	},
	/**
  * Called when a new item is added to the model.
  * Tracks child layout added after creation of this layout - not called if this layout already
  * had items populated when it was created
  * @param {object}  Event payload that contains the model to be added.
  */
	onModelAddItem: function onModelAddItem(payload) {
		var _this = this;

		var modelJson = payload.value.parameter.model;
		var addItemPromise = this.layoutView.layoutController.createLayoutModule(modelJson.id, this.layoutView, { addPayloadData: payload.data });
		addItemPromise.then(function (layoutView) {
			// Once the view is created, get the node and add it to the parent view.
			_this.layoutView.add(layoutView, payload.value.parameter.insertBefore, payload);
			_this._childrenLayouts[layoutView.id] = layoutView;
			layoutView.renderContent({ addPayloadData: payload.data });
		});

		if (this.layoutView.onItemAddDone) {
			addItemPromise.then(this.layoutView.onItemAddDone.bind(this.layoutView, payload));
		}

		return addItemPromise;
	},

	/**
  * Called when a layout model is removed
  * @param eventPayload
  */
	onModelRemoveItem: function onModelRemoveItem(eventPayload) {
		var sModelId = eventPayload.value.parameter;
		this._deleteChildLayout(sModelId, eventPayload);
	},

	_deleteChildLayout: function _deleteChildLayout(sModelId, eventPayload) {
		if (!this.layoutView) {
			console.warn('_deleteChildLayout called for non existent layout ', sModelId, eventPayload);
			return;
		}
		var n = document.getElementById(this.layoutView.getNodeId(sModelId));
		if (n) {
			//legacy child layout
			var layout = n._layout;
			if (layout) {
				if (layout.parentLayout) {
					layout.parentLayout.removeChild(layout, eventPayload);
				}
				layout.destroy(eventPayload);
			}
		} else {
			var _layout = this._childrenLayouts[sModelId] || this.layoutView.dashboardApi.getLayout(sModelId).view;
			_layout && _layout.destroy(eventPayload);
		}

		delete this._childrenLayouts[sModelId];
	},

	_destroyChildrenLayouts: function _destroyChildrenLayouts() {
		var _this2 = this;

		Object.entries(this._childrenLayouts).forEach(function (entry) {
			var layoutId = entry[0];
			var eventPayload = { value: { parameter: layoutId } }; //can we avoid this ??
			_this2._deleteChildLayout(layoutId, eventPayload);
		});

		this._childrenLayouts = {};
	}
});

//Not using authoring/views/LayoutBaseView as BaseClass to keep things simple
//i.e. const BaseClass = require('gemini/dashboard/layout/authoring/views/LayoutBaseView');
var LayoutBaseAuthoring = BaseClass.extend({

	init: function init(options) {
		LayoutBaseAuthoring.inherited('init', this, arguments);

		this.consumeView = options.consumeView; // the consume view
		this.id = this.consumeView.id;
		this.layoutController = this.consumeView.layoutController;
		this.model = this.consumeView.model;
		this.consumeView.authorHelper = this;
		this.consumeView.isAuthoringMode = true;

		this.consumeView.add = this.add.bind(this);
		this.consumeView.remove = this.remove.bind(this);

		this.commonAuthoringFeature = new CommonAuthoringFeature(this.consumeView);
	},

	add: function add(layoutView) {
		this.consumeView.addChildRenderMarkup(layoutView.id, layoutView.getRenderMarkup());
	},
	remove: function remove(layoutView) {
		this.consumeView.removeChildRenderMarkup(layoutView.id);
	},

	destroy: function destroy() {
		this.commonAuthoringFeature.destroy();
		this.consumeView.isAuthoringMode = false;
	}
});

exports.default = LayoutBaseAuthoring;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                   *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                   *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                   *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                   *|
                                                                                                                                                                                                                                                                   *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                   *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                   */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _CSSTransition = __webpack_require__(26);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This React component will automatically sets/unsets the 'display' property on the containing component
 * based on whether the component is hidden from view or not.
 */

var CSSHidingTransition = function CSSHidingTransition(props) {
  return _react2.default.createElement(_CSSTransition2.default, _extends({}, props, {
    timeout: 300,
    onEnter: props.onEnter ? props.onEnter : function (node) {
      return (0, _jquery2.default)(node).css('display', '');
    },
    onExited: props.onExited ? props.onExited : function (node) {
      return (0, _jquery2.default)(node).css('display', 'none');
    }
  }));
};

CSSHidingTransition.propTypes = {
  onEnter: _PropTypes2.default.func,
  onExited: _PropTypes2.default.func
};

exports.default = CSSHidingTransition;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(9));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Slideout = __webpack_require__(54);

var _Slideout2 = _interopRequireDefault(_Slideout);

var _SlideoutContent = __webpack_require__(55);

var _SlideoutContent2 = _interopRequireDefault(_SlideoutContent);

var _VisTypeChooser = __webpack_require__(272);

var _VisTypeChooser2 = _interopRequireDefault(_VisTypeChooser);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var VisTypeChooser_Slideout = function (_Component) {
	_inherits(VisTypeChooser_Slideout, _Component);

	function VisTypeChooser_Slideout() {
		_classCallCheck(this, VisTypeChooser_Slideout);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	VisTypeChooser_Slideout.prototype.render = function render() {
		var _this2 = this;

		var forwardedProps = _underscore2.default.omit(this.props, 'active', 'className', 'onClose');

		return _react2.default.createElement(
			_Slideout2.default,
			{
				active: this.props.active,
				className: this.props.className,
				fullHeight: true,
				onClickOutside: this.props.onClose
			},
			_react2.default.createElement(
				_SlideoutContent2.default,
				{
					title: _StringResources2.default.get('choose_visualization_type'),
					onClose: function onClose() {
						return _this2._handleOnCloseClick();
					}
				},
				_react2.default.createElement(_VisTypeChooser2.default, forwardedProps)
			)
		);
	};

	VisTypeChooser_Slideout.prototype._handleOnCloseClick = function _handleOnCloseClick() {
		this.props && this.props.onClose && this.props.onClose();
	};

	return VisTypeChooser_Slideout;
}(_react.Component);

VisTypeChooser_Slideout.propTypes = {
	active: _PropTypes2.default.bool,
	className: _PropTypes2.default.string,
	onClose: _PropTypes2.default.func
};

exports.default = VisTypeChooser_Slideout;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class; /**
             * Licensed Materials - Property of IBM
             * IBM Watson (C) Copyright IBM Corp. 2018
             * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _caUiToolkit = __webpack_require__(6);

var _StringResources = __webpack_require__(27);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _VisualizationPreviewList = __webpack_require__(29);

var _VisualizationPreviewList2 = _interopRequireDefault(_VisualizationPreviewList);

var _mobxReact = __webpack_require__(5);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(288);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RecommendedCommon = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(RecommendedCommon, _Component);

	function RecommendedCommon(props) {
		_classCallCheck(this, RecommendedCommon);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	RecommendedCommon.prototype.render = function render() {
		var classes = (0, _classnames2.default)(this.props.className, 'vis-recommendation-common');

		return _react2.default.createElement(
			'div',
			{ className: classes },
			this.renderContent()
		);
	};

	RecommendedCommon.prototype.renderContent = function renderContent() {
		switch (this.props.recommendationVM.state) {
			case 'done':
				return this.renderPreviewList();
			case 'pending':
				return _react2.default.createElement(
					'div',
					{ className: 'vis-recommendation-common__progress-indicator-container' },
					_react2.default.createElement(_caUiToolkit.ProgressIndicator, null)
				);
			case 'error':
				return this.renderMessage(_StringResources2.default.get('widget_recommender_fail'));
		}
	};

	RecommendedCommon.prototype.renderPreviewList = function renderPreviewList() {
		var _props = this.props,
		    recommendationVM = _props.recommendationVM,
		    other = _objectWithoutProperties(_props, ['recommendationVM']);

		if (this._hasRecommendation()) {
			return _react2.default.createElement(_VisualizationPreviewList2.default, _extends({
				isVizTypeLocked: this.props.isVizTypeLocked,
				recommendationFilter: this.props.recommendationFilter,
				selectedVisId: this.props.selectedVisId,
				onPromptingError: this.props.onPromptingError
			}, other, {
				horizontal: true,
				items: recommendationVM.getRecommendations(),
				titleOnBottom: false,
				logger: this.props.logger,
				isNewLayoutEnabled: this.props.recommendationVM.getNewLayoutEnabled()
			}));
		}

		return this.renderMessage(_StringResources2.default.get('widget_recommender_fail'));
	};

	RecommendedCommon.prototype.renderMessage = function renderMessage(message) {
		return _react2.default.createElement(
			'div',
			{ className: 'vis-recommendation-common__recommender-message' },
			_react2.default.createElement(_caUiToolkit.Label, { label: message })
		);
	};

	RecommendedCommon.prototype._hasRecommendation = function _hasRecommendation() {
		var recommendationVM = this.props.recommendationVM;

		var recommendations = recommendationVM.getRecommendations();
		return !!(recommendations && recommendations.length > 0);
	};

	return RecommendedCommon;
}(_react.Component)) || _class;

RecommendedCommon.propTypes = {
	dashboardApi: _propTypes2.default.object.isRequired,
	onClickItem: _propTypes2.default.func,
	recommendationVM: _propTypes2.default.object.isRequired,
	enableSeeMore: _propTypes2.default.bool,
	maxDisplayedItems: _propTypes2.default.number,
	className: _propTypes2.default.string,
	isVizTypeLocked: _propTypes2.default.bool,
	recommendationFilter: _propTypes2.default.string,
	selectedVisId: _propTypes2.default.string,
	additionalProperties: _propTypes2.default.arrayOf(_propTypes2.default.object),
	logger: _propTypes2.default.object,
	onPromptingError: _propTypes2.default.func
};
RecommendedCommon.defaultProps = {
	onClickItem: function onClickItem() {},
	additionalProperties: []
};
exports.default = RecommendedCommon;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.VisTypeModel = undefined;

var _mobxStateTree = __webpack_require__(7);

var _StringResources = __webpack_require__(293);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VisTypeModel = exports.VisTypeModel = _mobxStateTree.types.model('VisTypeModel', {
	filter: _mobxStateTree.types.optional(_mobxStateTree.types.array(_mobxStateTree.types.string), []),
	chartSpecs: _mobxStateTree.types.optional(_mobxStateTree.types.frozen(), {}),
	chartSpecsState: _mobxStateTree.types.optional(_mobxStateTree.types.enumeration('chartSpecsState', ['loading', 'loaded', 'empty']), 'empty')
}).views(function (self) {
	return {
		getChartSpecs: function getChartSpecs(usageId) {
			try {
				if (self.chartSpecsState === 'empty') {
					self.setChartSpecsStateToLoading();
					var visDefinitions = (0, _mobxStateTree.getEnv)(self).visDefinitions;
					var visDefsByUsage = self.getVisDefsByUsage({ excludeIds: self.filter, visDefinitions: visDefinitions });
					self.updateChartSpecs(visDefsByUsage);
				} else if (self.chartSpecsState === 'loaded') {
					return self.chartSpecs[usageId];
				}
				return;
			} catch (e) {
				self.setChartSpecsStateToEmpty();
			}
		},

		/**
   * @param options - an object that can be used to control what definitions/usages are returned.
   *			excludeIds: an array of definition ids to be excluded from any Usage(s) it is assigned to
   *			visDef: vis definition manager to source bundle definitions
   *
   * @returns vis definitions organized into a set of 'usages'
   *			(a user-oriented grouping of visualization types (stored in the 'usages' member of each visualization definition (or in VIPRConfig)).
   *			NOTE: A visualization can belong to 1 or more usages.
   */
		getVisDefsByUsage: function getVisDefsByUsage() {
			var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { excludeIds: [], visDefinitions: [] };

			var rtnUsageMapJSON = {};
			var excludedBundleIds = options.excludeIds;
			var visDefinitions = options.visDefinitions;

			var updateUsageMapEntry = function updateUsageMapEntry(usageId, visBundle) {
				//Augment a single entry in the usageMap with this visBundle
				var usageEntry = rtnUsageMapJSON[usageId] || {};
				usageEntry.usageId = usageId;
				//Save the localized label for the usage into the JSON.
				usageEntry.usageLabel = _StringResources2.default.get('visUsage' + usageId);
				usageEntry.chartTypes = usageEntry.chartTypes || [];
				usageEntry.chartTypes.push(visBundle);
				rtnUsageMapJSON[usageId] = usageEntry;
			};

			visDefinitions.forEach(function (visDef) {
				if (excludedBundleIds.indexOf(visDef.getId()) === -1) {
					var visDescription = {
						description: visDef.getLabel(),
						iconUri: visDef.getIcon(),
						id: visDef.getId(),
						minimalVisId: visDef.getId(),
						name: visDef.getLabel(),
						placeholderIcon: visDef.getPlaceholderIconUri(),
						usages: visDef.getProperty('usages'),
						visIds: [visDef.getId()]
					};
					var usages = visDescription.usages || ['Other'];
					usages.forEach(function (usageId) {
						updateUsageMapEntry(usageId, visDescription);
					});
				}
			});
			return rtnUsageMapJSON;
		}
	};
}).actions(function (self) {
	return {
		updateChartSpecs: function updateChartSpecs(specs) {
			self.chartSpecs = specs;
			self.chartSpecsState = 'loaded';
		},
		setChartSpecsStateToLoading: function setChartSpecsStateToLoading() {
			self.chartSpecsState = 'loading';
		},
		setChartSpecsStateToEmpty: function setChartSpecsStateToEmpty() {
			self.chartSpecsState = 'empty';
		}
	};
});

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _caUiToolkit = __webpack_require__(6);

var _chevronDown_ = __webpack_require__(95);

var _chevronDown_2 = _interopRequireDefault(_chevronDown_);

var _chevronUp_ = __webpack_require__(96);

var _chevronUp_2 = _interopRequireDefault(_chevronUp_);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

__webpack_require__(327);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var CaretToolbarItem = function (_Component) {
	_inherits(CaretToolbarItem, _Component);

	function CaretToolbarItem(props) {
		_classCallCheck(this, CaretToolbarItem);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			open: false
		};
		return _this;
	}

	CaretToolbarItem.prototype.render = function render() {
		var _this2 = this;

		if (this.props.hidden) {
			return null;
		}

		var forwardedProps = _underscore2.default.omit(this.props, 'children', 'onPrimaryAction', 'enabled', 'selected', 'hidden', 'icon', 'iconId', 'label');

		var classes = (0, _classnames2.default)({
			'explore-vis-toolbar__caret-item': true,
			'explore-vis-toolbar__caret-item--selected': this.props.selected,
			'explore-vis-toolbar__caret-item--enabled': this.isEnabled(),
			'explore-vis-toolbar__caret-item--actionable': this.isActionable(),
			'explore-vis-toolbar__caret-item--has-text': !!this.props.label
		});

		var icon = this.renderIcon(this.props.icon) || this.renderIconId(this.props.iconId);
		var label = this.props.size !== 'small' || !icon ? this.renderLabel(this.props.label) : undefined;
		var caret = this.renderCaret(this.props.selected);
		var tabIndex = this.isActionable() ? 0 : -1;
		/* use ariaLabel in props if it is defined. Otherwise use title
  +		when both of them are falsy, react is smart enough not to render an undefined attribute */
		var ariaLabel = this.props.ariaLabel || this.props.title;
		var id = this.props.id;

		return _react2.default.createElement(
			'div',
			_extends({
				className: classes,
				onMouseDown: function onMouseDown() {
					return _this2.performAction.apply(_this2, arguments);
				},
				onTouchStart: function onTouchStart() {
					return _this2.performAction.apply(_this2, arguments);
				}
				// ↓ on mobile to suppress the default behavior of a tap - eliminate the superfluous mousedown event
				, onTouchEnd: function onTouchEnd(event) {
					return event.preventDefault();
				},
				onKeyPress: function onKeyPress() {
					return _this2.onKeyPress.apply(_this2, arguments);
				},
				tabIndex: tabIndex,
				'aria-label': ariaLabel,
				'data-id': id,
				'appcues-data-id': id
			}, forwardedProps),
			icon,
			label,
			this.props.children,
			caret
		);
	};

	CaretToolbarItem.prototype.renderIcon = function renderIcon(icon) {
		if (!icon) {
			return;
		}

		return _react2.default.createElement(
			'div',
			{ className: 'explore-vis-toolbar__caret-item__icon' },
			icon
		);
	};

	CaretToolbarItem.prototype.renderIconId = function renderIconId(id) {
		if (!id) {
			return;
		}

		return this.renderIcon(_react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: id }));
	};

	CaretToolbarItem.prototype.renderLabel = function renderLabel(text) {
		if (!text) {
			return;
		}

		return _react2.default.createElement(
			'div',
			{ className: 'explore-vis-toolbar__caret-item__text' },
			text
		);
	};

	CaretToolbarItem.prototype.renderCaret = function renderCaret(selected) {
		var id = void 0;
		if (this.props.arrow === 'up') {
			id = selected ? _chevronDown_2.default.id : _chevronUp_2.default.id;
		} else {
			id = selected ? _chevronUp_2.default.id : _chevronDown_2.default.id;
		}

		return _react2.default.createElement(
			'div',
			{ className: 'explore-vis-toolbar__caret-item__caret' },
			_react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: id, size: 'small' })
		);
	};

	CaretToolbarItem.prototype.isEnabled = function isEnabled() {
		return this.props.enabled;
	};

	CaretToolbarItem.prototype.isActionable = function isActionable() {
		return this.isEnabled() && this.props.onPrimaryAction;
	};

	CaretToolbarItem.prototype.onEnter = function onEnter(event) {
		this.performAction(event);
	};

	CaretToolbarItem.prototype.onKeyPress = function onKeyPress(event) {
		var _this3 = this;

		var handler = {
			'Enter': function Enter() {
				return _this3.onEnter(event);
			}
		}[event.key];

		handler && handler();
	};

	CaretToolbarItem.prototype.performAction = function performAction(event) {
		if (this.isActionable()) {
			this.props.onPrimaryAction(event);
		}
	};

	return CaretToolbarItem;
}(_react.Component);

CaretToolbarItem.propTypes = {
	children: _PropTypes2.default.any,
	id: _PropTypes2.default.string,
	icon: _PropTypes2.default.node,
	iconId: _PropTypes2.default.string,
	arrow: _PropTypes2.default.string,
	ariaLabel: _PropTypes2.default.string,
	label: _PropTypes2.default.string,
	title: _PropTypes2.default.string,
	hidden: _PropTypes2.default.bool,
	enabled: _PropTypes2.default.bool,
	selected: _PropTypes2.default.bool,
	onPrimaryAction: _PropTypes2.default.func,
	size: _PropTypes2.default.string
};

CaretToolbarItem.defaultProps = {
	children: [],
	arrow: 'down',
	hidden: false,
	enabled: true,
	selected: false
};

exports.default = CaretToolbarItem;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, o) {
  if ("object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module))) module.exports = o(__webpack_require__(19));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (o),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var s = o("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js") : e["@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for (var a in s) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : e)[a] = s[a];
    }
  }
}("undefined" != typeof self ? self : undefined, function (e) {
  return webpackJsonPBaGraphics([1660], { "3865314c5959606874d4": function c5959606874d4(o, s) {
      o.exports = e;
    }, aa537d430eed17163a1c: function aa537d430eed17163a1c(e, o, s) {
      "use strict";
      Object.defineProperty(o, "__esModule", { value: !0 });var a = s("3865314c5959606874d4"),
          i = (s.n(a), s("f21266730b5c85314a2a"));o.default = i.a;
    }, f21266730b5c85314a2a: function f21266730b5c85314a2a(e, o, s) {
      "use strict";
      var a = s("9689a9c94ae38b47fa2c"),
          i = s.n(a),
          t = s("9ce58a7deea14f49ef01"),
          c = s.n(t),
          n = new i.a({ id: "chevron-down_16_v7", use: "chevron-down_16_v7-usage", viewBox: "0 0 16 16", content: '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="chevron-down_16_v7"><path d="M8 11L3 6l.7-.7L8 9.6l4.3-4.3.7.7z" /><path style="fill:none" d="M0 0h16v16H0z" /></symbol>' });c.a.add(n);o.a = n;
    } }, ["aa537d430eed17163a1c"]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)(module)))

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, o) {
  if ("object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module))) module.exports = o(__webpack_require__(19));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (o),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var s = o("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js") : e["@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for (var i in s) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : e)[i] = s[i];
    }
  }
}("undefined" != typeof self ? self : undefined, function (e) {
  return webpackJsonPBaGraphics([1651], { "3865314c5959606874d4": function c5959606874d4(o, s) {
      o.exports = e;
    }, "68a319985f3b647a817f": function a319985f3b647a817f(e, o, s) {
      "use strict";
      Object.defineProperty(o, "__esModule", { value: !0 });var i = s("3865314c5959606874d4"),
          c = (s.n(i), s("d2ce30dcc1f42ef9d8d4"));o.default = c.a;
    }, d2ce30dcc1f42ef9d8d4: function d2ce30dcc1f42ef9d8d4(e, o, s) {
      "use strict";
      var i = s("9689a9c94ae38b47fa2c"),
          c = s.n(i),
          t = s("9ce58a7deea14f49ef01"),
          a = s.n(t),
          n = new c.a({ id: "chevron-up_16_v7", use: "chevron-up_16_v7-usage", viewBox: "0 0 16 16", content: '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="chevron-up_16_v7"><path d="M8 5l5 5-.7.7L8 6.4l-4.3 4.3L3 10z" /><path style="fill:none" d="M0 0h16v16H0z" /></symbol>' });a.a.add(n);o.a = n;
    } }, ["68a319985f3b647a817f"]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)(module)))

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "filter_16",
  "use": "filter_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"filter_16\"><path d=\"M9 14H7c-.6 0-1-.4-1-1V9.2L2.3 5.5c-.2-.2-.3-.4-.3-.7V3c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v1.8c0 .3-.1.5-.3.7L10 9.2V13c0 .6-.4 1-1 1zM3 3v1.8l4 4V13h2V8.8l4-4V3H3z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(338);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./AddNewCard.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./AddNewCard.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _mobxReact = __webpack_require__(5);

var _CanvasTabs = __webpack_require__(100);

var _CanvasTabs2 = _interopRequireDefault(_CanvasTabs);

var _CSSTransition = __webpack_require__(26);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExploreContainerItem = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(ExploreContainerItem, _Component);

	function ExploreContainerItem() {
		_classCallCheck(this, ExploreContainerItem);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	ExploreContainerItem.prototype.componentDidUpdate = function componentDidUpdate() {
		var item = this.props.item;
		var model = this._findModel(this.props.containerModel, item.id);
		var background = model && model.isCurrentThumbnail;
		var done = model && model.isDoneThumbnail;
		if (background === true && !done && !this.props.item.displayed) {
			model.renderThumbnail(item.id);
		}
	};

	ExploreContainerItem.prototype.render = function render() {
		var item = this.props.item;
		var model = this._findModel(this.props.containerModel, item.id);

		var background = model && model.isCurrentThumbnail;

		var done = model && model.isDoneThumbnail;
		var isDisplayed = model && model.isDisplayed || item.displayed;
		var visible = isDisplayed || background || done;

		var isBackground = background && !isDisplayed;
		var isDone = done && !isDisplayed;

		var classes = (0, _classnames2.default)({
			'card-item': true,
			'background': isBackground,
			'done': isDone
		});

		var sidePanel = this.renderSidePanel(model);
		return _react2.default.createElement(
			'div',
			{
				className: classes,
				'data-id': item.id,
				style: {
					display: visible ? '' : 'none'
				}
			},
			item.render(visible),
			sidePanel
		);
	};

	ExploreContainerItem.prototype._findModel = function _findModel(parentModel, itemId) {
		var model = void 0;

		var items = parentModel && parentModel.items || [];

		items.some(function (item) {
			if (item.id === itemId) {
				model = item;
				return true;
			}
		});

		return model;
	};

	ExploreContainerItem.prototype.renderSidePanel = function renderSidePanel(model) {
		var _props = this.props,
		    services = _props.services,
		    exploreVM = _props.exploreVM;


		if (!model || !model.canvasTabs) {
			return null;
		}

		var canvasTabsModel = model.canvasTabs;
		var showSidePanel = model.canShowCanvasSidePanel;
		var isDisplayed = model.isDisplayed;

		// TODO: exploreVM should not be passed down to canvasTabs as it can lead to performance issues when there
		// are a lot of cards

		return _react2.default.createElement(
			_CSSTransition2.default,
			{
				'in': showSidePanel,
				timeout: 300,
				mountOnEnter: true,
				unmountOnExit: true,
				classNames: 'explore__animation--slideLeft'
			},
			_react2.default.createElement(_CanvasTabs2.default, {
				services: services,
				exploreVM: exploreVM,
				model: canvasTabsModel,
				className: 'card-layout-content__side-panel',
				tabIndex: -1,
				isDisplayed: isDisplayed
			})
		);
	};

	return ExploreContainerItem;
}(_react.Component)) || _class;

ExploreContainerItem.propTypes = {
	item: _propTypes2.default.object.isRequired,
	services: _propTypes2.default.object.isRequired,
	exploreVM: _propTypes2.default.object,
	containerModel: _propTypes2.default.object,
	background: _propTypes2.default.bool,
	sidePanel: _propTypes2.default.object
};

exports.default = ExploreContainerItem;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.TAB_STATE = undefined;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2020
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _caUiToolkit = __webpack_require__(6);

var _noProperties_ = __webpack_require__(60);

var _noProperties_2 = _interopRequireDefault(_noProperties_);

var _Tabs = __webpack_require__(347);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Empty = __webpack_require__(18);

var _Empty2 = _interopRequireDefault(_Empty);

var _SlotsContainer = __webpack_require__(348);

var _SlotsContainer2 = _interopRequireDefault(_SlotsContainer);

var _NaturalLanguageText = __webpack_require__(349);

var _NaturalLanguageText2 = _interopRequireDefault(_NaturalLanguageText);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _PropertiesContainer = __webpack_require__(354);

var _PropertiesContainer2 = _interopRequireDefault(_PropertiesContainer);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

__webpack_require__(356);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TAB_STATE = exports.TAB_STATE = {
	EMPTY: 'empty',
	NO_VIS_SELECTED: 'no_vis_selected',
	SHOW_SLOTS: 'show_slots',
	SHOW_DATA: 'show_data'
};

var CanvasTabs = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(CanvasTabs, _Component);

	function CanvasTabs() {
		var _temp, _this, _ret;

		_classCallCheck(this, CanvasTabs);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._getWidgetInfo = function () {
			var widget = _this.props.exploreVM.selectedWidget;
			var dashboardApi = _this.props.exploreVM.layoutModel && _this.props.exploreVM.layoutModel.getDashboardApi();
			var isCompareCard = _this.props.exploreVM.isCompare();
			var isMappingComplete = null;
			var visErrorState = null;
			var visualization = null;
			var tabState = null;

			if (widget && widget.getId && widget.getVisApi && dashboardApi) {
				var canvas = dashboardApi.getCanvas();
				var content = canvas.getContent(widget.getId());
				visualization = content.getFeature('Visualization');
				visErrorState = content.getFeature('state').getError();
				var slots = visualization.getSlots();
				isMappingComplete = !visErrorState ? slots.isMappingComplete() : false;
			}

			if (isCompareCard) {
				if (!widget) {
					tabState = TAB_STATE.NO_VIS_SELECTED;
				} else if (widget && widget.getVisApi && !isMappingComplete) {
					tabState = TAB_STATE.SHOW_SLOTS;
				} else if (widget && !widget.getVisApi) {
					tabState = TAB_STATE.EMPTY;
				} else {
					tabState = TAB_STATE.SHOW_DATA;
				}
			} else {
				if (widget && widget.getVisApi && !visErrorState) {
					tabState = isMappingComplete ? TAB_STATE.SHOW_DATA : TAB_STATE.SHOW_SLOTS;
				} else {
					tabState = TAB_STATE.EMPTY;
				}
			}

			return {
				widget: widget,
				visualization: visualization,
				dashboardApi: dashboardApi,
				tabState: tabState
			};
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	CanvasTabs.prototype.render = function render() {
		if (!this.props.isDisplayed) {
			return null;
		}

		var widgetInfo = this._getWidgetInfo();

		var forwardedProps = _underscore2.default.omit(this.props, 'exploreVM', 'services');
		var slots = this.renderSlots(widgetInfo);
		var nlt = this.renderNlt(widgetInfo);
		var properties = this.renderProperties(widgetInfo);

		return _react2.default.createElement(
			_Tabs2.default,
			forwardedProps,
			nlt,
			slots,
			properties
		);
	};

	CanvasTabs.prototype.renderProperties = function renderProperties(widgetInfo) {
		var tabState = widgetInfo.tabState === TAB_STATE.SHOW_SLOTS ? TAB_STATE.EMPTY : widgetInfo.tabState;
		var content = null;
		if (widgetInfo.tabState === TAB_STATE.SHOW_DATA) {
			var widget = widgetInfo.widget;
			var widgetType = widgetInfo.visualization.getType();
			var widgetId = widget.getId();

			content = _react2.default.createElement(_PropertiesContainer2.default, {
				widgetType: widgetType,
				widgetId: widgetId,
				dashboardApi: widgetInfo.dashboardApi,
				isDisplayed: this.props.isDisplayed
			});
		} else {
			content = _react2.default.createElement(
				'div',
				{ className: 'card-layout-content__side-panel__empty-container' },
				_react2.default.createElement(_Empty2.default, {
					icon: _react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _noProperties_2.default.id, width: 192, height: 111 }),
					title: _StringResources2.default.get('properties_panel_' + tabState + '_title'),
					description: _StringResources2.default.get('properties_panel_' + tabState + '_description')
				})
			);
		}

		return _react2.default.createElement(
			_caUiToolkit.TabPanel,
			{ id: 'properties', label: _StringResources2.default.get('propertiesPanelLabel') },
			content
		);
	};

	CanvasTabs.prototype.renderSlots = function renderSlots(_ref) {
		var widget = _ref.widget,
		    dashboardApi = _ref.dashboardApi;

		var content = _react2.default.createElement(_SlotsContainer2.default, {
			widget: widget,
			dashboardApi: dashboardApi
		});
		return _react2.default.createElement(
			_caUiToolkit.TabPanel,
			{ id: 'slots', label: _StringResources2.default.get('slot_editor') },
			content
		);
	};

	CanvasTabs.prototype.renderNlt = function renderNlt(widgetInfo) {
		var widgetLayoutModel = widgetInfo.widget && this.props.exploreVM.selectedWidgetLayoutModel;
		var tabState = widgetInfo.tabState === TAB_STATE.SHOW_SLOTS ? TAB_STATE.EMPTY : widgetInfo.tabState;

		// Force a re-render when this value changes. Can be removed when widget model is mobx.
		void (widgetLayoutModel && widgetLayoutModel.renderId);

		var content = _react2.default.createElement(
			'div',
			{ className: 'explore-details', 'appcues-data-id': 'nlt-details' },
			_react2.default.createElement(_NaturalLanguageText2.default, {
				model: widgetLayoutModel ? widgetLayoutModel.nlt : null,
				tabState: tabState
			})
		);
		return _react2.default.createElement(
			_caUiToolkit.TabPanel,
			{ id: 'details', label: _StringResources2.default.get('card_details') },
			content
		);
	};

	return CanvasTabs;
}(_react.Component)) || _class;

CanvasTabs.propTypes = {
	exploreVM: _PropTypes2.default.object.isRequired,
	services: _PropTypes2.default.object.isRequired,
	isDisplayed: _PropTypes2.default.boolean
};

exports.default = CanvasTabs;

/***/ }),
/* 101 */,
/* 102 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_102__;

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_103__;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(370);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./editDiagram.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./editDiagram.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


exports.eventIsInDropdown = eventIsInDropdown;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(17);

var _caUiToolkit = __webpack_require__(6);

var _mobxReact = __webpack_require__(5);

var _reactMeasure = __webpack_require__(20);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

__webpack_require__(372);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BASE_CLASS_NAME = 'dropdownWrapper';
var BLUR_TIME = 350;

function elementIsInDropdown(e) {
	while (e) {
		var classList = e.classList;
		if (classList && classList.contains(BASE_CLASS_NAME)) {
			return true;
		}
		e = e.parentElement;
	}
	return false;
}

/**
 * Determine whether an event originated in an instance of `Dropdown`. This is
 * to assist with detecting events which should dismiss the Dropdown, e.g. a
 * click outside the Dropdown. Note that events which originate in the target
 * (the control which is visible even when the dropdown is closed) and events
 * which originate in the dropdown contents will both satisfy this test.
 * @param {object} event - event supplied by the browser
 * @return {boolean}
 */
function eventIsInDropdown(evt) {
	return elementIsInDropdown(evt.target);
}

/**
 * An arbitrary dropdown control. It will make the dropdown the same width as
 * the 'target' control, i.e. the thing is "drops down" from.
 */

var Dropdown = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(Dropdown, _Component);

	function Dropdown(props) {
		_classCallCheck(this, Dropdown);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.props = props;

		_this.targetNode = null;
		_this.state = {
			dropdownWidth: 0,
			dropdownMaxHeight: _this.props.getDropdownMaxHeight()
		};
		return _this;
	}

	Dropdown.prototype.render = function render() {
		var _this2 = this;

		var getTargetNode = function getTargetNode(node) {
			if (node) {
				/* eslint react/no-find-dom-node:"off" */
				// React developers don't seem consistent about this point, but it seems
				// that findDOMNode is discouraged for use, but not actually deprecated.
				// It's better to use the ref attribute to get the generated node,
				// however when it's a React component you place ref on, the callback
				// param is the component itself, not the DOM node. findDOMNode is
				// required in this case. More info here:
				// https://github.com/facebook/react/issues/9217#issuecomment-287622539
				var e = (0, _reactDom.findDOMNode)(node);
				_this2.targetNode = e;
				if (e) {
					var width = e.getBoundingClientRect().width;
					var maxHeight = _this2.props.getDropdownMaxHeight();
					if (_this2.state.dropdownWidth !== width || _this2.state.dropdownMaxHeight !== maxHeight) {
						_this2.setState({
							dropdownWidth: width,
							dropdownMaxHeight: _this2.props.getDropdownMaxHeight()
						});
					}
				}
			}
		};

		var dropdownTarget = this.props.renderTrigger(getTargetNode);
		var dropdownContent = _react2.default.createElement(
			'div',
			{
				className: 'ba-common-dropdown dropdown',
				style: {
					width: this.state.dropdownWidth + 'px',
					'max-height': this.state.dropdownMaxHeight > 0 ? this.state.dropdownMaxHeight + 'px' : 'none'
				}
			},
			_react2.default.createElement(
				_caUiToolkit.Collapse,
				{
					isOpened: this.props.open && this.state.dropdownWidth > 0,
					autoUnmount: true
					/* Has to use this prop to control if we want animation when dropdown content changes, check https://github.com/nkbt/react-collapse */
					, hasNestedCollapse: !this.props.animationWhenContentChanges
				},
				this.props.renderDropdownContents()
			)
		);

		return _react2.default.createElement(
			_reactMeasure2.default,
			{ bounds: true,
				onResize: function onResize(args) {
					return _this2._onResize(args);
				}
			},
			function (_ref) {
				var measureRef = _ref.measureRef;
				return _react2.default.createElement(
					'div',
					{
						className: BASE_CLASS_NAME,
						ref: measureRef,
						onBlur: function onBlur() {
							return _this2.blurTimer = setTimeout(_this2.props.onBlur, BLUR_TIME);
						},
						onFocus: function onFocus() {
							if (_this2.blurTimer) {
								clearTimeout(_this2.blurTimer);
								delete _this2.blurTimer;
							}
						}
					},
					dropdownTarget,
					dropdownContent
				);
			}
		);
	};

	Dropdown.prototype._onResize = function _onResize(args) {
		if (args.bounds) {
			if (this.state.dropdownWidth !== args.bounds.width) {
				this.setState({ dropdownWidth: args.bounds.width });
			}
		}
		var height = this.props.getDropdownMaxHeight();
		if (this.state.dropdownMaxHeight !== height) {
			this.setState({ dropdownMaxHeight: height });
		}
	};

	return Dropdown;
}(_react.Component)) || _class;

Dropdown.propTypes = {
	renderDropdownContents: _PropTypes2.default.func.isRequired,
	renderTrigger: _PropTypes2.default.func.isRequired,
	open: _PropTypes2.default.bool.isRequired,
	getDropdownMaxHeight: _PropTypes2.default.func.isRequired,
	onBlur: _PropTypes2.default.func,
	animationWhenContentChanges: _PropTypes2.default.bool
};
Dropdown.defaultProps = {
	animationWhenContentChanges: true
};
exports.default = Dropdown;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _mobxReact = __webpack_require__(5);

var _FieldButton = __webpack_require__(374);

var _FieldButton2 = _interopRequireDefault(_FieldButton);

__webpack_require__(107);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FieldsList = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(FieldsList, _Component);

	function FieldsList(props) {
		_classCallCheck(this, FieldsList);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.fieldsListRef = _react2.default.createRef();
		return _this;
	}

	FieldsList.prototype._onButtonClick = function _onButtonClick(index) {
		if (this.props.onSelectField) {
			this.props.onSelectField(this.props.fields[index]);
		}
	};

	FieldsList.prototype._onDeleteField = function _onDeleteField(index) {
		if (this.props.onDeleteField) {
			this.props.onDeleteField(this.props.fields[index]);
		}
	};

	FieldsList.prototype.render = function render() {
		var _this2 = this;

		if (this.props.error) {
			return this._renderError();
		}

		return _react2.default.createElement(
			'div',
			{ className: 'fieldsListContainer' },
			this.props.title && _react2.default.createElement(
				'div',
				{ className: 'fieldsListTitle' },
				this.props.title
			),
			_react2.default.createElement(
				'div',
				{ className: 'fieldsList',
					onKeyDown: function onKeyDown(e) {
						return _this2._onKeyDown(e);
					},
					ref: this.fieldsListRef
				},
				this.props.fields.map(function (field, i) {
					var deletable = !!field.deletable;
					var onDelete = deletable ? _this2._onDeleteField.bind(_this2, i) : null;
					return _react2.default.createElement(_FieldButton2.default, {
						deletable: deletable,
						onDelete: onDelete,
						key: i,
						id: field.id,
						label: field.label,
						onClick: function onClick() {
							return _this2._onButtonClick(i);
						},
						activeDataSourceModule: _this2.props.activeDataSourceModule,
						shouldUseDisambiguatedPaths: _this2.props.shouldUseDisambiguatedPaths
					});
				})
			)
		);
	};

	FieldsList.prototype._renderError = function _renderError() {
		var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.error;

		return _react2.default.createElement(
			'div',
			{ className: 'fieldsListContainer' },
			_react2.default.createElement(
				'div',
				{ className: 'fieldsListTitle' },
				error.title
			),
			_react2.default.createElement(
				'div',
				{ className: 'fieldsListErrorMessage' },
				error.description
			)
		);
	};

	FieldsList.prototype._getFieldListNode = function _getFieldListNode() {
		return this.fieldsListRef.current;
	};

	FieldsList.prototype._onKeyDown = function _onKeyDown(event) {
		var fieldsListNode = this._getFieldListNode();
		var index = this.props.fields.findIndex(function (field) {
			return field.id === event.target.id;
		});
		if (index !== -1) {
			switch (event.key) {
				case 'ArrowLeft':
					if (index > 0) {
						this._setButtonTabIndex(fieldsListNode, index - 1, '0');
						this._focusFieldButtonNode(fieldsListNode, index - 1);
						this._blurFieldButtonNode(fieldsListNode, index);
					}
					event.preventDefault();
					break;
				case 'ArrowRight':
					if (index < this.props.fields.length - 1) {
						this._setButtonTabIndex(fieldsListNode, index + 1, '0');
						this._focusFieldButtonNode(fieldsListNode, index + 1);
						this._blurFieldButtonNode(fieldsListNode, index);
					}
					event.preventDefault();
					break;
				case 'Tab':
					for (var i = 0; i <= this.props.fields.length - 1; i++) {
						if (i !== index) {
							this._setButtonTabIndex(fieldsListNode, i, '-1');
						}
					}
					this._blurFieldButtonNode(fieldsListNode, index);
					break;
				default:
					break;
			}
		}
	};

	FieldsList.prototype._setButtonTabIndex = function _setButtonTabIndex(fieldsListNode, index, tabIndex) {
		fieldsListNode.children[index].children[0].tabIndex = tabIndex;
	};

	FieldsList.prototype._getButtonNode = function _getButtonNode(listNode, index) {
		return listNode.children[index].children[0];
	};

	FieldsList.prototype._blurFieldButtonNode = function _blurFieldButtonNode(listNode, index) {
		var node = this._getButtonNode(listNode, index);
		node.blur();
		node.classList.remove('is-active');
		node.classList.remove('is-focus');
	};

	FieldsList.prototype._focusFieldButtonNode = function _focusFieldButtonNode(listNode, index) {
		var node = this._getButtonNode(listNode, index);
		node.focus();
		node.classList.add('is-focus');
	};

	return FieldsList;
}(_react.Component)) || _class;

FieldsList.propTypes = {
	fields: _PropTypes2.default.arrayOf(_PropTypes2.default.shape({
		id: _PropTypes2.default.string,
		label: _PropTypes2.default.string,
		deletable: _PropTypes2.default.bool
	})),
	error: _PropTypes2.default.shape({
		title: _PropTypes2.default.string,
		description: _PropTypes2.default.string
	}),
	onSelectField: _PropTypes2.default.func,
	onDeleteField: _PropTypes2.default.func,
	title: _PropTypes2.default.string,
	activeDataSourceModule: _PropTypes2.default.observableObject,
	shouldUseDisambiguatedPaths: _PropTypes2.default.bool,
	relationshipVM: _PropTypes2.default.observableObject.isRequired
};

exports.default = FieldsList;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(377);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./fieldsList.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./fieldsList.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(383);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./fake.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./fake.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(384);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./startingPoints.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./startingPoints.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ALIGNMENTS = exports.PLACEMENTS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

__webpack_require__(393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * PLEASE try to use the Flyout in `ba-ui-toolkit` first!
 * 
 * This is a simpler flyout which supports `alignment`
 * Supports four `position, alignment` combinations now:
 * - top, left
 * - top, right
 * - bottom, left (default)
 * - bottom, right
 * 
 * Creating this because `ba-ui-toolkit` does not support `alignment`.
 */
var PLACEMENTS = exports.PLACEMENTS = {
	TOP: 'top',
	BOTTOM: 'bottom'
};
var ALIGNMENTS = exports.ALIGNMENTS = {
	LEFT: 'left',
	RIGHT: 'right'
};

var Flyout = function (_Component) {
	_inherits(Flyout, _Component);

	function Flyout(props) {
		_classCallCheck(this, Flyout);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			position: {
				x: 0,
				y: 0
			}
		};
		_this._flyout = _react2.default.createRef();
		return _this;
	}

	Flyout.prototype.componentDidMount = function componentDidMount() {
		this._updateLocation();
		window.addEventListener('resize', this._updateLocation.bind(this));
	};

	Flyout.prototype.componentWillUnmount = function componentWillUnmount() {
		window.removeEventListener('resize', this._updateLocation.bind(this));
	};

	Flyout.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			{
				ref: this._flyout,
				className: 'exploreFlyout ' + this.props.className,
				style: {
					top: this.state.position.y + 'px',
					left: this.state.position.x + 'px'
				}
			},
			this.props.children
		);
	};

	Flyout.prototype._updateLocation = function _updateLocation() {
		if (!this._flyout.current) {
			return;
		}
		var _props = this.props,
		    triggerNode = _props.triggerNode,
		    placement = _props.placement,
		    alignment = _props.alignment;

		var triggerNodeRect = triggerNode.getBoundingClientRect();
		var flyoutRect = this._flyout.current.getBoundingClientRect();
		var x = void 0,
		    y = void 0;
		if (alignment === ALIGNMENTS.LEFT) {
			x = triggerNodeRect.left;
			if (window.innerWidth - x < flyoutRect.width) {
				x = window.innerWidth - flyoutRect.width;
			}
		} else if (alignment === ALIGNMENTS.RIGHT) {
			x = triggerNodeRect.left + triggerNodeRect.width - flyoutRect.width;
			if (x < 0) {
				x = 0;
			}
		}

		if (placement === PLACEMENTS.TOP) {
			y = triggerNodeRect.top - flyoutRect.height - 1;
			if (y < 0) {
				y = 0;
			}
		} else if (placement === PLACEMENTS.BOTTOM) {
			y = triggerNodeRect.top + triggerNodeRect.height + 1;
			if (window.innerHeight - y < flyoutRect.height) {
				y = window.innerHeight - flyoutRect.height;
			}
		}

		this.setState({
			position: {
				x: x, y: y
			}
		});
	};

	return Flyout;
}(_react.Component);

Flyout.propTypes = {
	className: _PropTypes2.default.string,
	triggerNode: _PropTypes2.default.element.isRequired,
	children: _PropTypes2.default.node,
	placement: _PropTypes2.default.oneOf(Object.values(PLACEMENTS)),
	alignment: _PropTypes2.default.oneOf(Object.values(ALIGNMENTS))
};
Flyout.defaultProps = {
	className: '',
	placement: PLACEMENTS.BOTTOM,
	alignment: ALIGNMENTS.LEFT
};

exports.default = Flyout;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(5);

var _caUiToolkit = __webpack_require__(6);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HELP_DOC_URL = 'https://www.ibm.com/support/knowledgecenter/SSEP7J_11.1.0/com.ibm.swg.ba.cognos.ca_explorations.doc/ca_explore_relationship_strength_slider.html';

var RelationshipInfoTooltip = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(RelationshipInfoTooltip, _Component);

	function RelationshipInfoTooltip(props) {
		_classCallCheck(this, RelationshipInfoTooltip);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.componentDidMount = function () {
			_this._onScrollhandler = _this._onScroll;
			window.addEventListener('scroll', _this._onScrollhandler, true);
		};

		_this.componentWillUnmount = function () {
			if (_this._onScrollhandler) {
				window.removeEventListener('scroll', _this._onScrollhandler, true);
				_this._onScrollhandler = null;
			}
		};

		_this._onScroll = function () {
			_this._onFlyoutClose();
		};

		_this._onFlyoutClose = function () {
			if (_this.props.onClose) {
				_this.props.onClose();
			}
		};

		_this.render = function () {
			var content = null;
			if (_this.props.isOpen) {
				var triggerNode = _this.props.triggerNode;
				var textContent = _StringResources2.default.get('relationshipGraph_informationText');
				var readMoreText = _StringResources2.default.get('relationshipGraph_informationText_readMore');
				content = _react2.default.createElement(_caUiToolkit.Flyout, {
					title: _StringResources2.default.get('relationshipGraph_filterStrength_label'),
					placement: 'bottomCentred',
					showX: true,
					padding: 'default',
					domNodeToAttachTo: document.body,
					triggerNode: triggerNode,
					textContent: textContent,
					href: HELP_DOC_URL,
					linkName: readMoreText,
					onClose: _this._onFlyoutClose
				});
			}

			return content;
		};

		return _this;
	}

	return RelationshipInfoTooltip;
}(_react.Component)) || _class;

RelationshipInfoTooltip.propTypes = {
	isOpen: _propTypes2.default.boolean,
	triggerNode: _propTypes2.default.object.isRequired,
	onClose: _propTypes2.default.func
};

exports.default = RelationshipInfoTooltip;

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "get-information_16",
  "use": "get-information_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"get-information_16\"><path d=\"M8 0a8 8 0 100 16A8 8 0 008 0zm-.5 3a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 017.5 3zM9 12h1v1H6v-1h1V8H6V7h3v5z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _caUiToolkit = __webpack_require__(6);

var _noRelationshipDiagram_ = __webpack_require__(411);

var _noRelationshipDiagram_2 = _interopRequireDefault(_noRelationshipDiagram_);

var _dataRelationshipsCard_ = __webpack_require__(43);

var _dataRelationshipsCard_2 = _interopRequireDefault(_dataRelationshipsCard_);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Empty = __webpack_require__(18);

var _Empty2 = _interopRequireDefault(_Empty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var RelationshipVisErrorView = function (_Component) {
	_inherits(RelationshipVisErrorView, _Component);

	function RelationshipVisErrorView() {
		_classCallCheck(this, RelationshipVisErrorView);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	RelationshipVisErrorView.prototype.render = function render() {
		var strings = this.props.error && this.props.error.getUserStrings && this.props.error.getUserStrings() || {};
		var alignment = this.props.alignment;
		if (!alignment) {
			alignment = 'center';
		}
		var iconId = this.props.iconId;
		if (iconId === undefined) {
			iconId = this._getErrorIcon().id;
		}
		var suggestions = this.props.suggestions || strings.suggestions;
		if (suggestions === undefined) {
			suggestions = _StringResources2.default.get('startingPoints_unable_to_render_diagram_suggestions');
		}
		return _react2.default.createElement(_Empty2.default, {
			icon: this.props.iconId !== null ? _react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: iconId, size: 'xxlarge' }) : null,
			alignment: alignment,
			title: this.props.preferredTitle || strings.title || this.props.defaultTitle,
			description: this.props.preferredDescription || strings.message || this.props.defaultDescription,
			selectable: true,
			suggestions: suggestions
		});
	};

	RelationshipVisErrorView.prototype._getErrorIcon = function _getErrorIcon() {
		var error = this.props.error;
		if (error && error.id === 'RUN_REQUEST_IN_BACKGROUND') {
			return _dataRelationshipsCard_2.default;
		}
		return _noRelationshipDiagram_2.default;
	};

	return RelationshipVisErrorView;
}(_react.Component);

RelationshipVisErrorView.propTypes = {
	error: _PropTypes2.default.object,
	defaultTitle: _PropTypes2.default.string,
	defaultDescription: _PropTypes2.default.string,
	alignment: _PropTypes2.default.string,
	iconId: _PropTypes2.default.string,
	preferredTitle: _PropTypes2.default.string,
	preferredDescription: _PropTypes2.default.string,
	suggestions: _PropTypes2.default.bool
};

exports.default = RelationshipVisErrorView;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(432);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./CompareTable.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./CompareTable.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32);
module.exports = __webpack_require__(171);


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Links = exports.Deselection = exports.Selection = exports.VisPlaceholder = exports.ExploreWidget = exports.ExploreCardAuthoring = exports.ExploreCard = exports.ExploreContainer = exports.ExploreContainerAuthoring = undefined;

var _ExploreView = __webpack_require__(172);

var _ExploreView2 = _interopRequireDefault(_ExploreView);

var _VisPlaceholder = __webpack_require__(254);

var _VisPlaceholder2 = _interopRequireDefault(_VisPlaceholder);

var _ExploreContainerAuthoring = __webpack_require__(260);

var _ExploreContainerAuthoring2 = _interopRequireDefault(_ExploreContainerAuthoring);

var _ExploreContainer = __webpack_require__(261);

var _ExploreContainer2 = _interopRequireDefault(_ExploreContainer);

var _ExploreCardAuthoring = __webpack_require__(414);

var _ExploreCardAuthoring2 = _interopRequireDefault(_ExploreCardAuthoring);

var _ExploreCard = __webpack_require__(415);

var _ExploreCard2 = _interopRequireDefault(_ExploreCard);

var _ExploreWidget = __webpack_require__(455);

var _ExploreWidget2 = _interopRequireDefault(_ExploreWidget);

var _Selection = __webpack_require__(457);

var _Selection2 = _interopRequireDefault(_Selection);

var _Deselection = __webpack_require__(458);

var _Deselection2 = _interopRequireDefault(_Deselection);

var _LinksActionController = __webpack_require__(459);

var _LinksActionController2 = _interopRequireDefault(_LinksActionController);

__webpack_require__(460);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ExploreContainerAuthoring = _ExploreContainerAuthoring2.default;
exports.ExploreContainer = _ExploreContainer2.default;
exports.ExploreCard = _ExploreCard2.default;
exports.ExploreCardAuthoring = _ExploreCardAuthoring2.default;
exports.ExploreWidget = _ExploreWidget2.default;
exports.VisPlaceholder = _VisPlaceholder2.default;
exports.Selection = _Selection2.default;
exports.Deselection = _Deselection2.default;
exports.Links = _LinksActionController2.default; /*
                                                  *+------------------------------------------------------------------------+
                                                  *| Licensed Materials - Property of IBM
                                                  *| IBM Cognos Products: Explore
                                                  *| (C) Copyright IBM Corp. 2018
                                                  *|
                                                  *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                  *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                  *+------------------------------------------------------------------------+
                                                  */

exports.default = _ExploreView2.default;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _MSTLayoutModelFactory = __webpack_require__(173);

var _ExploreViewModel = __webpack_require__(35);

var _ExploreViewModel2 = _interopRequireDefault(_ExploreViewModel);

var _ExploreToolbarExtensions = __webpack_require__(215);

var _WidgetHostApp = __webpack_require__(217);

var _CopyPasteHandler = __webpack_require__(75);

var _CopyPasteHandler2 = _interopRequireDefault(_CopyPasteHandler);

var _EventChainLocal = __webpack_require__(218);

var _EventChainLocal2 = _interopRequireDefault(_EventChainLocal);

var _SmartsRecommenderWrapper = __webpack_require__(219);

var _SmartsRecommenderWrapper2 = _interopRequireDefault(_SmartsRecommenderWrapper);

var _CapabilityUtil = __webpack_require__(49);

var _CardNotificationController = __webpack_require__(229);

var _CardNotificationController2 = _interopRequireDefault(_CardNotificationController);

var _CopyPasteUtils = __webpack_require__(77);

var _ExploreController = __webpack_require__(232);

var _ExploreController2 = _interopRequireDefault(_ExploreController);

var _StartingPointsViewModel = __webpack_require__(82);

var _ExplorationAPI = __webpack_require__(248);

var _ExplorationAPI2 = _interopRequireDefault(_ExplorationAPI);

var _StartingPointsAPI = __webpack_require__(249);

var _StartingPointsAPI2 = _interopRequireDefault(_StartingPointsAPI);

var _CopyPasteAPI = __webpack_require__(252);

var _CopyPasteAPI2 = _interopRequireDefault(_CopyPasteAPI);

var _mobxStateTree = __webpack_require__(7);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _ExploreViewModel3 = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var BaseClass = __webpack_require__(253);

var ExploreView = BaseClass.extend({

	init: function init(options) {
		options.overrideDashboardController = _ExploreController2.default;
		ExploreView.inherited('init', this, [_extends({}, options, {
			// explore only supports authoring mode, no consume.
			// So we need to force the mode
			isAuthoringMode: true
		})]);

		this.createLayoutModel = this._createLayoutModel.bind(this);

		this.exploreContainerLayoutModel = null;
	},

	initialize: function initialize() {
		ExploreView.inherited('initialize', this, arguments);

		this._setupHostApplicationSvc();

		// register our string resource, top priority
		this.stringService.register(_StringResources2.default, 1);
	},

	_setupInstrumentation: function _setupInstrumentation() {
		var _this = this;

		this.getDashboardApi().getFeature('segment').registerInfoCallback(function () {
			var cards = _this.getDashboardApi().getCanvas().findContent({ type: 'exploreCard' });
			return {
				'custom.counts.tabs': cards.length
			};
		});
	},


	getExploreApi: function getExploreApi() {
		if (!this.api) {
			var startingPointsAPI = new _StartingPointsAPI2.default(this.exploreContainerLayoutModel.startingPointsModel);
			this.api = new _ExplorationAPI2.default(this.exploreContainerLayoutModel, startingPointsAPI, this._getCopyPasteAPI());
		}
		return this.api;
	},

	_getCopyPasteAPI: function _getCopyPasteAPI() {
		if (!this.copyPasteAPI) {
			this.copyPasteAPI = new _CopyPasteAPI2.default(this.performCopy.bind(this), this.performPaste.bind(this));
		}
		return this.copyPasteAPI;
	},

	getApplicationLabel: function getApplicationLabel() {
		return _StringResources2.default.get('explore');
	},

	getIcon: function getIcon() {
		return 'common-explore';
	},

	getIconTooltip: function getIconTooltip() {
		return _StringResources2.default.get('explore');
	},

	/**
  * When doing saveas or save an explore contenet view,
  * the ID of the content view is updated by the parent
  * BaseBoardView automatically. Explore relationship model
  * should keep sync with the content view ID update.
  *
  * @override BaseBoardView->setBoardId
  * @param  {string} id content view ID
  */
	setBoardId: function setBoardId(id) {
		ExploreView.inherited('setBoardId', this, arguments);
		if (this.exploreContainerLayoutModel && this.exploreContainerLayoutModel.startingPointsModel && this.exploreContainerLayoutModel.startingPointsModel.relationship) {
			this.exploreContainerLayoutModel.startingPointsModel.relationship.setExploreViewId(id);
		}
	},

	/**
  * NOTE: called from the base class.
  *
  * @returns whether the user has the exploration capability or not.
  */
	hasCapability: function hasCapability() {
		return (0, _CapabilityUtil.hasCapability)(this.glassContext);
	},

	/**
  * called by Glass when opening a new or existing explore which is not open in the background
  * @returns {Promise}
  */
	render: function render() {
		var _this2 = this;

		return ExploreView.inherited('render', this, arguments).then(function (result) {
			if (_this2.exploreContainerLayoutModel.exploreVM) {
				var exploreVM = _this2.exploreContainerLayoutModel.exploreVM;

				exploreVM.setLayoutController(_this2.boardController.layoutController);

				if (_this2.exploreContainerLayoutModel.findModel(_this2.subView)) {
					exploreVM.setDisplayedToCard(_this2.subView);
				} else if (_this2.addOnSpec || _this2.subView === _ExploreViewModel3.STARTING_POINTS) {
					//When adding a card and opening the exploration, select starting points so the card is added to the end of the list
					exploreVM.setDisplayedToStartingPoints();
				}
			}
			_this2._setupInstrumentation();
			_this2.boardController.layoutController.getTopLayoutView().onShow();
			_this2._mergeAddOnSpec(_this2);
			return result;
		});
	},

	/**
  * called by Glass when switching to an explore was open in the background
  * @param {Object} - content is passed from Glass that contains the info to create the current app view
  * @returns {Promise}
  */
	activate: function activate(content) {
		var _this3 = this;

		return ExploreView.inherited('activate', this, arguments).then(function (result) {
			if (_this3.exploreContainerLayoutModel.startingPointsModel) {
				var relationshipVM = _this3.exploreContainerLayoutModel.startingPointsModel.relationship;
				if (relationshipVM) {
					relationshipVM.setExploreViewActivated(true);
				}
			}

			_this3._mergeAddOnSpec(content);
			return result;
		});
	},

	deactivate: function deactivate() {
		var _this4 = this;

		return ExploreView.inherited('deactivate', this, arguments).then(function (result) {
			if (_this4.exploreContainerLayoutModel) {
				if (_this4.exploreContainerLayoutModel.startingPointsModel) {
					var relationshipVM = _this4.exploreContainerLayoutModel.startingPointsModel.relationship;
					if (relationshipVM) {
						relationshipVM.setExploreViewActivated(false);
					}
				}
			}
			return result;
		});
	},

	remove: function remove() {
		ExploreView.inherited('remove', this, arguments);
		if (!this._removed) {
			if (this.exploreContainerLayoutModel) {
				if (this.exploreContainerLayoutModel.exploreVM) {
					(0, _mobxStateTree.destroy)(this.exploreContainerLayoutModel.exploreVM);
				}
				(0, _mobxStateTree.destroy)(this.exploreContainerLayoutModel);
				this.exploreContainerLayoutModel = null;
			}
		}
		this.boardModel = null;
		this._removed = true;

		if (this.api) {
			this.api.destroy();
			this.api = null;
		}
		if (this.copyPasteAPI) {
			this.copyPasteAPI.destroy();
			this.copyPasteAPI = null;
		}
	},

	/**
  * merge add on spec if available
  * @param {Object} content - content is passed from Glass (in activate) or from the current view (in render case)
  * content: { perspective: xx, id: xx, content: xx }
  */
	_mergeAddOnSpec: function _mergeAddOnSpec(content) {
		if (content) {
			if (content.addOnSpec && !content.openAppViewCallback || !content.addOnSpec && content.openAppViewCallback) {
				this.logger.error('addOnSpec and openAppViewCallback should coexist');
			} else if (content.addOnSpec && content.openAppViewCallback) {
				content.openAppViewCallback(content.addOnSpec, this);
				delete content.addOnSpec; //Critical always remove addOnSpec
			}
		}
	},

	_createLayoutModel: function _createLayoutModel(model, env) {
		env.eventRouter = env.eventRouter || this.eventRouter;
		env.createLayoutModel = env.createLayoutModel || this.createLayoutModel;
		env.isFeatureEnabled = env.isFeatureEnabled || this.isFeatureEnabled.bind(this);

		var mstLayoutModel = (0, _MSTLayoutModelFactory.createMSTLayoutModel)(model, env);

		if (model.type === 'exploreContainer') {
			this._initExploreContainerLayoutModel(mstLayoutModel, env);
		}

		return mstLayoutModel;
	},

	/**
  * Centralized way to return whether a named feature is enabled.
  * The intent is to hide the underlying technique (currently feature flag but could be dev mode flag)
  * @param {string} featureName - The feature to check.
  * @param {string} [enabledValue='true'] - The value to check against to determine enablement is true.
  * @returns {boolean} - true if the feature is enabled...false otherwise.
  */
	isFeatureEnabled: function isFeatureEnabled(featureName) {
		var enabledValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'true';

		var dashboardApi = this.getDashboardApi();
		if (dashboardApi) {
			//Access featureChecker to check for new flag for compare table stats
			var featureChecker = dashboardApi.getGlassCoreSvc('.FeatureChecker');
			return featureChecker && featureChecker.checkValue('explore', featureName, enabledValue);
		}
		return false;
	},
	_initExploreContainerLayoutModel: function _initExploreContainerLayoutModel(mstLayoutModel, env) {
		var _this5 = this;

		var dashboardApi = this.getDashboardApi();

		this.exploreContainerLayoutModel = mstLayoutModel;
		var boardModel = this.exploreContainerLayoutModel.boardModel;


		var initExploreVM = {
			toolbar: {},
			canvasTabs: {
				tab: 'details'
			},
			notification: {
				active: false
			},
			thumbnails: {
				background: {}
			},
			selectedCards: {
				items: []
			},
			selectionSync: {}
		};

		// Set the initially displayed card.
		var initiallySelectedCard = this._getInitiallySelectedCard(this.exploreContainerLayoutModel);
		if (initiallySelectedCard) {
			initExploreVM.displayedCard = initiallySelectedCard;
			initExploreVM.selectionSync.displayedCard = initiallySelectedCard;
		}

		var exploreVM = _ExploreViewModel2.default.create(initExploreVM, _extends({}, env, {
			getToolBarItems: function getToolBarItems() {
				return (0, _ExploreToolbarExtensions.getToolBarItems)(dashboardApi, { glassContext: _this5.glassContext });
			},
			getThumbnailService: function getThumbnailService() {
				return dashboardApi.getDashboardSvc('.Thumbnail');
			},
			smartsRecommenderWrapper: new _SmartsRecommenderWrapper2.default({
				services: this.services,
				dashboardApi: dashboardApi
			}),
			getNotificationController: function getNotificationController() {
				return new _CardNotificationController2.default({
					glassContext: _this5.glassContext
				});
			},
			getItems: function getItems() {
				return _this5.exploreContainerLayoutModel.items.map(function (item) {
					return item.id;
				});
			}
		}));
		if (this.exploreContainerLayoutModel && this.exploreContainerLayoutModel.setExploreVM) {
			this.exploreContainerLayoutModel.setExploreVM(exploreVM);
		}
		exploreVM.setLayoutModel(this.exploreContainerLayoutModel);
		exploreVM.setBoardModel(boardModel);

		var startingPointsModel = this._setupStartingPointsModel({
			exploreVM: exploreVM,
			services: this.services,
			dashboardApi: dashboardApi,
			isFeatureEnabled: env.isFeatureEnabled,
			exploreViewId: this.id,
			isAlive: _mobxStateTree.isAlive
		});

		this.exploreContainerLayoutModel.setStartingPointsModel(startingPointsModel);

		// when user switches from 1 datasource to another one on the dataset panel or from datasource grid,
		// dashboard throws these events.
		// We should listen to these events and update activeDataSourceId in Explore view
		this.eventRouter.on('dataSourcePanel:dataSourceSelected', this._onDataSourceChange.bind(this, exploreVM));
		this.eventRouter.on('dataSourceGrid:dataSourceSelected', this._onDataSourceChange.bind(this, exploreVM));
		if (this.exploreContainerLayoutModel && this.exploreContainerLayoutModel.setDashboardApi) {
			this.exploreContainerLayoutModel.setDashboardApi(this.getDashboardApi());
		}
	},


	_setupStartingPointsModel: function _setupStartingPointsModel(env) {
		return _StartingPointsViewModel.StartingPointsViewModel.create({
			fields: {}, //FieldsModel
			relationship: {
				tooltip: {}
			}
		}, env);

		// env contains:
		// 	- exploreVM => env.exploreViewModel,
		// 	- services => env.services,
		// 	- dashboardApi => env.dashboardApi
	},

	_getInitiallySelectedCard: function _getInitiallySelectedCard(layout) {
		// Choose the first card as the selected card.
		if (layout.items && layout.items.length) {
			var card = layout.items[0];

			return card.id;
		}
	},

	_onDataSourceChange: function _onDataSourceChange(exploreVM, event) {
		if (event.sender) {
			exploreVM.setActiveDataSourceId(event.sender);
		}
	},

	_setupHostApplicationSvc: function _setupHostApplicationSvc() {
		this._hostInstance = new _WidgetHostApp.WidgetHostApp({ services: this.services });
		this._hostInstance.setup();
	},

	preprocessKeyDown: function preprocessKeyDown(event) {
		if ((event.ctrlKey || event.metaKey) && !event.shiftKey) {
			// Don't perform copy and paste when focused on input fields.
			if (event.target.tagName && event.target.tagName.match(/input|textarea|select/igm)) {
				return event;
			}

			var consumeEvent = false;
			switch (event.key) {
				case 'c':
				case 'C':
					if (!this.isTextSelected()) {
						var classes = this._getClasses(event.target);
						if (~classes.indexOf('pageexploreContainer')) {
							var exploreVM = this.exploreContainerLayoutModel.exploreVM;

							if (exploreVM.selectedWidget) {
								// Only perform the copy if exactly 1 widget is selected.
								this.performCopy();

								event.preventDefault();
							}
						} else {
							var matchedClassName = this._hasAncestorClass(event.target, ['widget', 'liveWidget', 'exploreContainer', 'card-layout']);
							if (matchedClassName) {
								if (matchedClassName === 'card-layout') {
									//Same as `~classes.indexOf('pageexploreContainer')` condition above
									var _exploreVM = this.exploreContainerLayoutModel.exploreVM;
									if (_exploreVM.selectedWidget) {
										// Only perform the copy if exactly 1 widget is selected.
										this.performCopy();

										event.preventDefault();
									}
								} else {
									//matchedClassName is 'widget', 'liveWidget'or 'exploreContainer'
									this.performCopy();

									event.preventDefault();
								}
							}
						}
						consumeEvent = true;
					}
					break;
				case 'v':
				case 'V':
					{
						var skipElements = !!this._hasAncestorClass(event.target, ['slotEditor__slots__slot']);
						if (!skipElements) {
							this.performPaste();

							event.preventDefault();
							consumeEvent = true;
						}
						break;
					}
				default:
					break;
			}

			// When set, prevent dashboard from handling the event. We cannot use preventDefault as we want the default
			// browser copy + paste handlers to execute.
			var eventProps = new _EventChainLocal2.default(event);
			eventProps.setProperty('doNotHandle', consumeEvent);
		}

		return event;
	},

	/**
  * Given an html element, return an array of its classes
  * @param {Element} element - HTML Element
  * @returns {Array} - Array of the element's classes
  */
	_getClasses: function _getClasses(element) {
		if (!element) {
			return [];
		}
		return element.getAttribute('class') ? element.getAttribute('class').split(' ') : [];
	},


	/**
  * Given a html element, find a parent node which has one of the given classes
  * @param {Element} element - HTML Element
  * @param {Array} classNames - A set of class names
  * @returns {String} - null if cannot find such a parent; if found, return matched class name
  */
	_hasAncestorClass: function _hasAncestorClass(element, classNames) {
		var _this6 = this;

		var _loop = function _loop() {
			var elementClasses = _this6._getClasses(element);
			var foundClass = _underscore2.default.find(classNames, function (className) {
				return ~elementClasses.indexOf(className);
			});
			if (foundClass) return {
					v: foundClass
				};
			element = element.parentNode;
		};

		while (element && element !== document) {
			var _ret = _loop();

			if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		}
		return null;
	},
	getExploreVM: function getExploreVM() {
		return this.exploreContainerLayoutModel && this.exploreContainerLayoutModel.exploreVM;
	},
	getExploreContainerLayoutModel: function getExploreContainerLayoutModel() {
		return this.exploreContainerLayoutModel;
	},


	/**
  * Copy the currently displayed widget(s) in explore into clipboard
  * @return {object} a promise which would be resolved when the action is done
  */
	performCopy: function performCopy() {
		var spec = void 0;
		var exploreVM = this.exploreContainerLayoutModel.exploreVM;
		if (!exploreVM.isStartingPointsDisplayed()) {
			// Only copy if not viewing starting points.
			var displayedCardId = exploreVM.getDisplayedCard();
			if (displayedCardId) {
				var exploreCopyPasteHandler = this.getCopyPasteHandler();
				spec = exploreCopyPasteHandler.doCopyWidgets(displayedCardId, this.exploreContainerLayoutModel.getSelectedWidgets());
			}
		}
		return Promise.resolve(spec);
	},
	performPaste: function performPaste() {
		var _this7 = this;

		return this.getCopyPasteHandler().doPaste().then(function (result) {
			return (0, _CopyPasteUtils.postPasteAction)(_this7.exploreContainerLayoutModel.exploreVM, result);
		});
	},
	getCopyPasteHandler: function getCopyPasteHandler() {
		return new _CopyPasteHandler2.default({
			dashboardApi: this.getDashboardApi(),
			boardModel: this.boardModel,
			exploreContainerLayoutModel: this.exploreContainerLayoutModel,
			glassContext: this.glassContext
		});
	},
	openCardListPane: function openCardListPane() {
		var plugin = this.glassContext.appController.findPlugin('com.ibm.bi.explore.thumbnailBtn');
		if (plugin && !plugin.isPressed()) {
			plugin.$el.trigger('click');
		}
	},
	addFragment: function addFragment(fragment) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		this.exploreContainerLayoutModel.addFragment(fragment, 'createCardFromFragment');
		if (options.selectAfterAdd) {
			var addedCardLayoutIds = fragment.model.layout.map(function (layoutItem) {
				return layoutItem.id;
			});

			if (addedCardLayoutIds) {
				this.exploreContainerLayoutModel.exploreVM.setDisplayedToCard(addedCardLayoutIds[addedCardLayoutIds.length - 1]);
			}
		}
	}
});

exports.default = ExploreView;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createMSTLayoutModel = createMSTLayoutModel;

var _MSTLayoutModel = __webpack_require__(174);

var _CardLayoutModelExt = __webpack_require__(179);

var _ExploreContainerLayoutModelExt = __webpack_require__(192);

var _WidgetLayoutModelExt = __webpack_require__(193);

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var layoutTypes = {
	'exploreContainer': _ExploreContainerLayoutModelExt.ExploreContainerLayoutModelExt,
	'exploreCard': _CardLayoutModelExt.CardLayoutModelExt,
	'widget': _WidgetLayoutModelExt.WidgetLayoutModelExt
};

function getItemsModelTypeFn(snapshot, env, getItemsModelTypeFn) {
	var modelType = void 0;

	if (snapshot && layoutTypes[snapshot.type]) {
		var extModel = layoutTypes[snapshot.type];
		modelType = (0, _MSTLayoutModel.composeMSTLayoutModel)(env, extModel, getItemsModelTypeFn).named(snapshot.type);
	} else {
		modelType = (0, _MSTLayoutModel.composeMSTLayoutModel)(env);
	}
	return modelType;
}

/**
 * This creates a MST LayoutModel instance
 *
 * @param {object} model the JSON spec for the model
 * @param {object} env the environment parameters used for creating the Model
 * @param {object} [env.whitelistAttrs] white list attributes allowed for the Model, optional
 * @param {object} [env.options] any options needed for preparing the Model, optional
 * @param {object} env.boardModel legacy BoardModel
 * @param {object} env.logger logger instance to be used
 */
function createMSTLayoutModel(model, env) {
	var idMap = {};
	var logger = env && env.logger;

	//Don't particularly like doing this here, mobx seems to allow models with duplicate ids in the passed snapshot
	//also, preProcessSnapshot does not work for this type of functionality as it calls preProcessSnapshot
	//for nested models again (from the original snapshot)
	function trimDuplicateModels(item) {
		var copy = {};
		Object.keys(item).forEach(function (key) {
			if (key !== 'items') {
				if (copy) {
					copy[key] = item[key];
				}
				if (key === 'id') {
					if (idMap[item.id]) {
						copy = null;
					} else {
						idMap[item.id] = true;
					}
				}
			} else {
				copy.items = [];
				for (var i = 0; item.items && i < item.items.length; i++) {
					var child = trimDuplicateModels(item.items[i]);
					if (child) {
						copy.items.push(child);
					} else {
						logger && logger.error('Found duplicate layout id "' + item.items[i].id + '" on initialization of layout "' + item.id + '".');
					}
				}
			}
		});
		return copy;
	}

	model = trimDuplicateModels(model);
	// Need to pass in the model for contentModel for copy/paste and launch
	env.addOnLayoutSpec = model;

	var PreparedLayoutModelType = void 0;
	if (model.type && layoutTypes[model.type]) {
		PreparedLayoutModelType = (0, _MSTLayoutModel.composeMSTLayoutModel)(env, layoutTypes[model.type], getItemsModelTypeFn).named(model.type);
	} else {
		PreparedLayoutModelType = (0, _MSTLayoutModel.prepareMSTLayoutModelType)(env, getItemsModelTypeFn);
	}

	var modelInstance = PreparedLayoutModelType.create(model, env);
	modelInstance.createLayoutModel = createMSTLayoutModel;
	return modelInstance;
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                   *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                   *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                   *| (C) Copyright IBM Corp. 2018, 2021
                                                                                                                                                                                                                                                                   *|
                                                                                                                                                                                                                                                                   *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                   *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                   */

exports.composeMSTLayoutModel = composeMSTLayoutModel;
exports.prepareMSTLayoutModelType = prepareMSTLayoutModelType;
exports.createMSTLayoutModelType = createMSTLayoutModelType;

var _mobx = __webpack_require__(11);

var mobx = _interopRequireWildcard(_mobx);

var _mobxStateTree = __webpack_require__(7);

var _MSTLayoutModelBase = __webpack_require__(175);

var _ModelAdapter = __webpack_require__(176);

var _utils = __webpack_require__(34);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _ = __webpack_require__(8); //TODO: should try to remove this dependency
var LayoutModel = __webpack_require__(177);
var ContentModel = __webpack_require__(178);

var priv = {
	replaceIds: function replaceIds(map, snapshot) {
		if (snapshot.id) {
			var newId = map[snapshot.id];
			if (!newId) {
				newId = (0, _utils.generateUniqueId)('model');
				map[snapshot.id] = newId;
			}
			snapshot.from = snapshot.id;
			snapshot.id = newId;
		}
		_.each(snapshot.items || [], function (item) {
			priv.replaceIds.call(item, map, item);
		});
	},

	/*
  * Used while cloning a 'LayoutModel'; Replaces any 'related layout' ids with those found in map.
  */
	replaceRelatedLayouts: function replaceRelatedLayouts(map) {
		if (this.relatedLayouts && this.relatedLayouts.length > 0) {
			var updated = '';
			if (this.relatedLayouts[0] === '|') {
				var related = this.relatedLayouts.split('|');
				updated += '|';
				_.each(related, function (rel) {
					if (rel.length > 0) {
						updated += (map[rel] ? map[rel] : rel) + '|';
					}
				});
			} else {
				updated = map[this.relatedLayouts] ? map[this.relatedLayouts] : this.relatedLayouts;
			}
			this.relatedLayouts = updated;
		}
		_.each(this.items, function (item) {
			priv.replaceRelatedLayouts.call(item, map);
		});
	},

	incrementTitleCount: function incrementTitleCount(count) {
		if (this.title && this.title.length > 0) {
			this.title = this.title + '-' + count;
		}
	},

	/**
  * Insert an item in the item array. If insertBeforeId is not provided, the item will be inserted at the end
  * @param options
  * 		options.model
  * 		options.insertBeforeId
  *
  * @param sender
  * @param payloadData
  */
	_insertItem: function _insertItem(options, sender, payloadData) {
		var item = options.model;
		var insertBeforeId = options.insertBeforeId;

		//not the best check for MST model
		if (!item.$mobx) {
			if (this.createLayoutModel) {
				item = this.createLayoutModel(item, (0, _mobxStateTree.getEnv)(this));
			} else {
				item = (0, _mobxStateTree.getType)(this).create(item, (0, _mobxStateTree.getEnv)(this)); //was new MSTLayoutModel($.extend(true, {}, item), self.boardModel);
			}
		}

		if (!this.items) {
			this.items = [];
		}

		var duplicateIndex = priv._getItemIndex.call(this, item.id);
		if (duplicateIndex !== -1) {
			// this should never occur since it would cause a layout  with a duplicate ID to be added.
			// this works around the issue in the hope that we can find the broken code eventually.
			this.logger.error('Found duplicate layout id "' + item.id + '" at index "' + duplicateIndex + '" in layout "' + this.id + '".');
			// this is not added to the undo/redo stack since undo of an insert should be a delete.
			// we are just working around the error condition of inserting a duplicate layout.
			this.items.splice(duplicateIndex, 1);
		}

		// Find insert position
		var idx = priv._getItemIndex.call(this, insertBeforeId);

		// Add to the items array
		if (idx !== -1) {
			this.items.splice(idx, 0, item);
		} else {
			this.items.push(item);
		}

		return priv._triggerEvent.call(this, 'insert:item', { op: '_insertItem', parameter: { model: item.toJSON(), insertBeforeId: insertBeforeId } }, { op: '_removeItem', parameter: item.id }, sender, payloadData);
	},

	/**
  * Remove the child model with the given id
  * @param id
  * @returns
  */
	_removeItem: function _removeItem(id) {
		var model = null;
		var idx = priv._getItemIndex.call(this, id);
		if (idx >= 0) {
			model = this.items[idx];
			(0, _mobxStateTree.detach)(model);
		}
		return model;
	},

	/**
  * Find the index of the child in the item array
  * @param {Object} item with an id attribute
  */
	_getItemIndex: function _getItemIndex(id) {
		if (this.items) {
			return this.items.findIndex(function (model) {
				return model.id === id;
			});
		}
		return -1;
	},

	checkPayloadData: function checkPayloadData(payloadData) {
		var data = payloadData;
		if (!data) {
			var undoRedoTransactionId = _.uniqueId('layoutModelTransaction'); //TODO: do we need this now
			data = { undoRedoTransactionId: undoRedoTransactionId };
		}
		return data;
	},

	/**
  * Helper function that will trigger an event
  * @param eventName
  * @param value
  * @param prevValue
  * @param sender
  * @param payloadData - Additional data that will be included in the event payload.
  */
	_triggerEvent: function _triggerEvent(eventName, value, prevValue, sender, payloadData) {
		var payload = {
			modelId: this.id,
			value: value,
			sender: sender ? sender : this
		};
		if (payloadData) {
			payload.data = payloadData;
		}
		// the event supports undo/redo
		if (prevValue) {
			payload.prevValue = prevValue;
			// Use the applyFn of the top level when we the operation is not a change operation on the current model.
			// if we delete the model and then undo, we don't want to use the applyFn of a deleted model.
			var layout = eventName.indexOf('change:') === 0 ? this : this.boardModel.layout;
			payload.senderContext = {
				applyFn: function applyFn(undoRedoParam, undoRedoSender) {
					priv.applyFn.call(layout, undoRedoParam, undoRedoSender, payloadData);
				}
			};
		}
		this.trigger(eventName, payload);
		return payload;
	},

	/**
  * function used for undo/redo.
  * @param value
  * @param sender
  * @param payloadData - Additional data that will be included in the event payload.
  */
	applyFn: function applyFn(value, sender, payloadData) {
		if (value && value.op && typeof this[value.op] === 'function') {
			var args = [value.parameter];
			args.push(sender);
			args.push(payloadData);
			this[value.op].apply(this, args);
		} else {
			this.inherited('applyFn', this, arguments); //?
		}
	},

	/**
  * Find a parent model based on the child id recursively.
  * @param {String} sId
  */
	findParentModel: function findParentModel(id) {
		var index = priv._getItemIndex.call(this, id);
		if (index !== -1) {
			return this;
		}

		var parent = null;
		if (this.items) {
			for (var i = 0; !parent && i < this.items.length; i++) {
				parent = priv.findParentModel.call(this.items[i], id);
			}
		}

		return parent;
	},

	/**
  * Get the style map using the names in the given map
  *
  * @param names - map with names
  * @returns {object} the styles object
  */
	_getStyles: function _getStyles(names) {
		var styles = {};
		for (var name in names) {
			if (names.hasOwnProperty(name)) {
				styles[name] = this.style && this.style[name] || '';
			}
		}
		return styles;
	},

	_getSiblingId: function _getSiblingId(step) {
		var parent = this.getParent();
		var next = null;
		if (parent) {
			var idx = parent.items.indexOf(this) + step;
			if (idx >= 0 && idx < parent.items.length) {
				next = parent.items[idx].id;
			}
		}
		return next;
	},

	/**
  * Helper function that updates a list of models.
  */
	_updateModelsProperties: function _updateModelsProperties(updateArray, sender, addedModels, payloadData) {
		var changes = { value: [], prevValue: [] };
		var info;
		for (var i = 0; i < updateArray.length; i++) {
			info = updateArray[i];
			var child = this.findModel(info.id);
			if (child) {
				var change = priv._updateModelProperties.call(this, child, info, sender, addedModels, payloadData);
				changes.value.push(change.value);
				changes.prevValue.unshift(change.prevValue);
			}
		}
		return changes;
	},

	/**
  * Helper function that updates the parent and the style of a model. Returns an object with value before and after the change.
  * @param model
  * @param options
  * @param sender
  * @param addedModels - a list of models that were added in the same operation
  * @param payloadData - Additional data that will be included in the event payload.
  */
	_updateModelProperties: function _updateModelProperties(model, options, sender, addedModels, payloadData) {
		var changes = {
			prevValue: { id: model.id },
			value: { id: model.id }
		};

		if (options.parentId) {
			var parentId = options.parentId;
			// For now, only support adding to the first added model
			if (parentId === '$addArray[0]' && addedModels && addedModels.length > 0) {
				parentId = addedModels[0].model.id;
			}
			// Update the parent
			var updateParent = model.updateParent({
				parentId: parentId,
				insertBefore: options.insertBefore
			}, sender, payloadData);
			if (updateParent !== null) {
				changes.prevValue = _.extend(changes.prevValue, updateParent.prevValue.parameter);
				changes.value = _.extend(changes.value, updateParent.value.parameter);
			}
		}

		// Update the style submodel
		var updateStyle = model.updateStyle(options.style, sender, payloadData);
		if (updateStyle) {
			changes.prevValue.style = updateStyle.prevValue.parameter;
			changes.value.style = updateStyle.value.parameter;
		}

		// Update the filters submodel
		if (options.filters) {
			var updateFilters = model.updateFilters(options.id, options.filters);
			if (updateFilters) {
				changes.prevValue.filters = updateFilters.prevValue.filters;
				changes.value.filters = updateFilters.value.filters;
			}
		}

		if (this.boardModel.layoutExtensions && this.boardModel.layoutExtensions.modelExtensions) {
			var modelExtensions = this.boardModel.layoutExtensions.modelExtensions;
			Object.keys(modelExtensions || {}).forEach(function (property) {
				var update = priv._callExtensionMethod.call(model, {
					property: property,
					value: options[property]
				}, sender, payloadData);
				if (update) {
					changes.prevValue[property] = update.prevValue.parameter.value;
					changes.value[property] = update.value.parameter.value;
				}
			}, this);
		}
		return changes;
	},

	/**
  * Helper to call extension update. Handles triggering an event and undo redo automatically
  * @param options {object} :
  * 		{
  * 			property: name of the property
  * 			value: value of the property
  * 		}
  * @param sender sender of the call
  * @param payloadData - Additional data that will be included in the event payload.
  */
	_callExtensionMethod: function _callExtensionMethod(options, sender, payloadData) {
		var modelExtension = this.boardModel.layoutExtensions.modelExtensions[options.property];
		if (modelExtension && typeof modelExtension.update === 'function') {
			var payload = modelExtension.update(this, options.value);
			if (payload) {
				return priv._triggerEvent.call(this, payload.event, {
					op: '_callExtensionMethod',
					parameter: {
						property: options.property,
						value: payload.value
					}
				}, {
					op: '_callExtensionMethod',
					parameter: {
						property: options.property,
						value: payload.previousValue
					}
				}, sender, payloadData);
			}
		}
		return null;
	},

	_isContainerType: function _isContainerType() {
		if (_.contains(['container'], this.type)) {
			return true;
		}

		return false;
	},

	/* recurse up the family tree until we find a parent that is not a "linkable" container type
  */
	_getLinkedLayoutTreeWorker: function _getLinkedLayoutTreeWorker(layout1, layout2, result) {
		result.push([layout1, layout2]);

		var oflinkableType = function oflinkableType(layout) {
			return layout.type === 'group';
		};

		var parent1 = layout1.getParent();
		var parent2 = layout2.getParent();

		if (!oflinkableType(parent1) && !oflinkableType(parent2)) {
			// both parents are not groups so the family tree could be the same.
			// and if we made it this far then they are the same.
			return result;
		}
		if (!oflinkableType(parent1) || !oflinkableType(parent2)) {
			// only 1 parent is not a group so definitely different family trees
			return null;
		}
		return priv._getLinkedLayoutTreeWorker.call(this, parent1, parent2, result);
	},

	_getModelList: function _getModelList(env) {

		var layoutModel = {
			newInstance: new LayoutModel({}, env.boardModel),
			methodList: ['getContentModel', '_initializeContentModel'],
			isBlocked: false
		};

		return [layoutModel];
	},

	/**
  *
  * Get the content model properties from board layout spec
  * @param {object} spec board layout spec
  * @param {object} contentMap
  * @returns an object of contents with related id
  * @example { 'model1': {'conditionalFormatting': {}}, 'model2': {'properties' : {}}}
  */
	_getContentFromSpec: function _getContentFromSpec(spec, contentMap) {
		var _this = this;

		if (spec.content) {
			contentMap[spec.id] = spec.content;
		} else {
			//since R7, widget content doesn't contain 'content' section anymore
			//please refer to defect explore-2939
			var specContent = {};
			if (spec.hasOwnProperty('properties') && spec.properties) {
				specContent.properties = spec.properties;
			}
			if (spec.hasOwnProperty('features') && spec.features) {
				specContent.features = spec.features;
			}
			if (Object.keys(specContent).length > 0) {
				contentMap[spec.id] = specContent;
			}
		}
		if (spec.items && spec.items.length > 0) {
			spec.items.forEach(function (item) {
				return priv._getContentFromSpec.call(_this, item, contentMap);
			});
		}
		return contentMap;
	}

}; //priv 


function constructLayoutExtensionProps(env) {
	var props = [];
	if (env.boardModel.layoutExtensions && env.boardModel.layoutExtensions.modelExtensions) {
		var modelExtensions = env.boardModel.layoutExtensions.modelExtensions;
		Object.keys(modelExtensions || {}).forEach(function (property) {
			props[property] = _mobxStateTree.types.union(_mobxStateTree.types.undefined, _mobxStateTree.types.number, _mobxStateTree.types.boolean, _mobxStateTree.types.Date, _mobxStateTree.types.string);
		});
	}
	return props;
}

/**
 * Creates a specialized Mobx State Tree Layout Model Type, composing in passed specializedType
 *
 * @param {object} env environment parameters passed to the Type
 * @param {object} env.whitelistAttrs white list attributes allowed for the Model
 * @param {object} env.options any options needed for preparing the Model
 * @param {object} specializedType specialized type which will extend MSTLayoutModel
 * @param {function} getItemsModelTypeFn dispatcher function for array member union type
 */
function composeMSTLayoutModel(env, specializedType, getItemsModelTypeFn) {
	if (specializedType) {
		return _mobxStateTree.types.compose(prepareMSTLayoutModelType(env, getItemsModelTypeFn), specializedType);
	}
	return prepareMSTLayoutModelType(env, getItemsModelTypeFn);
}
/**
 * Creates the Mobx State Tree Layout Model Type ie the class
 * MSTLayoutModel is composed of MSTLayoutModelBase & ModelAdapter(which provides legacy Model functionality)
 * This is a replacement for Dashboard Core LayoutModel, with the guts based on MobX state tree Model
 *
 * @param {object} env environment parameters passed to the Type
 * @param {object} env.whitelistAttrs white list attributes allowed for the Model
 * @param {object} env.options any options needed for preparing the Model
 * @param {function} getItemsModelTypeFn dispatcher function for array member union type
 */
function prepareMSTLayoutModelType(env, getItemsModelTypeFn) {
	var boardModel = env.boardModel,
	    logger = env.logger;


	function getItemsArrayMemberType(getLayoutModelType) {
		if (getLayoutModelType) {
			var dispFn = function dispFn(snapshot) {
				return getItemsModelTypeFn(snapshot, env, getItemsModelTypeFn);
			};
			var dispType = _mobxStateTree.types.union({ dispatcher: dispFn });
			dispType.validate = function () {
				return [];
			}; //TODO: fix hack
			return dispType;
		} else {
			return _mobxStateTree.types.late(function () {
				return MSTLayoutModel;
			});
		}
	}

	var additionalModelsToAdopt = priv._getModelList.call(this, env);

	var MSTLayoutModel = _mobxStateTree.types.compose(_MSTLayoutModelBase.MSTLayoutModelBase, (0, _ModelAdapter.prepareModelAdapterType)(env, additionalModelsToAdopt)).named('MSTLayoutModel').props(constructLayoutExtensionProps(env)).volatile(function () {
		return {
			boardModel: null,
			logger: null,
			selected: mobx.observable.array([]),
			contentMap: null
		};
	}).props({
		id: _mobxStateTree.types.optional(_mobxStateTree.types.identifier, (0, _utils.generateUniqueId)('model')),
		items: _mobxStateTree.types.union(_mobxStateTree.types.array(getItemsArrayMemberType(getItemsModelTypeFn)), _mobxStateTree.types.undefined)
	}).extend(function (self) {

		// public view functions

		function getParent() {
			return priv.findParentModel.call(self.boardModel.layout, self.id);
		}

		function getTopLayoutModel() {
			return self.boardModel.layout;
		}

		/**
   * Get the next sibling id
   * @returns
   */
		function getNextSiblingId() {
			return priv._getSiblingId.call(self, 1);
		}

		/**
   * Get the previous sibling id
   * @returns
   */
		function getPreviousSiblingId() {
			return priv._getSiblingId.call(self, -1);
		}

		/**
   * This method will return an object containing a list of drop zones found from the layout it is called from.
   * This can be every drop zone in a dashboard or story (all tabs or all scenes) or it can be a single tab/scene's
   * drop zones depending on how high up the model the search is done from.
   *
   * @returns undefined|{Object} Return early if not template layout. Otherwise return an object with an array of IDs
   * 	and the parent ID of the drop zones
   */
		function findDropZones() {
			if (!priv._isContainerType.call(self)) {
				return;
			}
			var dropZones = self.findDescendantsWithType('templateDropZone');

			var parentId = priv.findParentModel.call(self, dropZones[0].id).id;
			var dropZoneIds = [];
			for (var i = 0; i < dropZones.length; i++) {
				dropZoneIds.push(dropZones[i].id);
			}

			return {
				ids: dropZoneIds,
				parentId: parentId
			};
		}

		/**
   * Return the list of all the descendant layouts with the given type
   *
   * @param type - type of layout to search for.
   */
		function findDescendantsWithType(type) {
			var descendants = [];
			if (self.items) {
				for (var i = 0; i < self.items.length; i++) {
					if (type === self.items[i].type) {
						descendants.push(self.items[i]);
					} else {
						descendants.push.apply(descendants, self.items[i].findDescendantsWithType(type));
					}
				}
			}

			return descendants;
		}

		/**
   * Return the parent layouts that are groups
   * the returned object are the actual layouts and not the IDs
   *
   * @param layout1 the first layout.
   * @param layout2 the second layout.
   * @return [
   * 		[widget1, widget2],
   * 		[parent1, parent2],
   * 		[grandParent1, grandParent2],
   * 		... and so on ...
   * 		]
   */
		function getLinkedLayoutTree(layout1, layout2) {
			var result = [];
			return priv._getLinkedLayoutTreeWorker.call(self, layout1, layout2, result);
		}

		/**
   * Given any layout item, find its top level parent item (the item in the layout's root level item list that contains it).
   * @param id - the id of the model for a widget, templateDropZone etc.
   * @returns the parent object (ie tab) for this model id
   */
		function findTopLevelParentItem(id) {
			var itemFound = null;
			_.each(self.items, function (item) {
				if (item.id === id) {
					itemFound = this;
				} else if (self.findChildItem(item.items, id) !== null) {
					itemFound = item;
				}
			}.bind(this));
			return itemFound;
		}

		/**
   * Recursively search all layout items and their child items lists for an id which matches
   * the specified id
   * @param items - the items list whose subtree of items lists are to be searched
   * @param id - the id to search for.
   * @returns the item if found or null if this id does not exist in this items list or any child lists.
   */
		function findChildItem(items, id) {
			if (items) {
				for (var i = 0; i < items.length; ++i) {
					var item = items[i];
					if (item.id === id) {
						// found it!
						return item;
					} else if (item.items) {
						item = self.findChildItem(item.items, id);
						if (item) {
							// found it!
							return item;
						}
						// otherwise continue with the remaining siblings
					}
				}
			}
			return null;
		}

		// public actions

		function afterCreate() {
			self.boardModel = (0, _mobxStateTree.getEnv)(self).boardModel;
			self.logger = (0, _mobxStateTree.getEnv)(self).logger;
			var addOnLayoutSpec = (0, _mobxStateTree.getEnv)(self).addOnLayoutSpec;

			self.contentMap = boardModel.layout ? self.createContentModelMap(boardModel.layout, addOnLayoutSpec) : {};

			// layoutModel _initializeContentModel is not a MST action
			// so we need to do it here to initialize content from spec
			if (!self.content) {
				if (self.contentMap[self.id]) {
					self.content = new ContentModel(JSON.parse(JSON.stringify(self.contentMap[self.id])));
				} else if (self.contentMap[self.from]) {
					self.content = new ContentModel(JSON.parse(JSON.stringify(self.contentMap[self.from])));
				} else {
					self.content = new ContentModel({});
				}
			}

			var spec = (0, _mobxStateTree.getSnapshot)(self);
			//include this to allow legacy toJSON to work
			//Since R7, properties and features are in the whitelistattributes, for example, for widget content
			self.whitelistAttrs = ['properties', 'features', 'id', 'from', 'css', 'items', 'style', 'type', 'title', 'templateName', 'relatedLayouts', 'clones', 'fillColor', 'disableScrollDrop', 'content'];

			if (self.boardModel.layoutExtensions && self.boardModel.layoutExtensions.modelExtensions) {
				var modelExtensions = self.boardModel.layoutExtensions.modelExtensions;
				Object.keys(modelExtensions || {}).forEach(function (property) {
					self.whitelistAttrs.push(property);
					if (modelExtensions[property] && typeof modelExtensions[property].init === 'function') {
						modelExtensions[property].init(self, spec, boardModel, logger);
					}
				}, self);
			}

			// Notify the board model when there is a layout change to the items so that the event is propagated to the auto save and the undo/redo controller
			self.on('op', self.boardModel.onLayoutChange, self.boardModel);
			self.on('replace:items', self.boardModel.onLayoutChange, self.boardModel);
			self.on('change:title', self.boardModel.onLayoutChange, self.boardModel);
			self.on('change:css', self.boardModel.onLayoutChange, self.boardModel);
			self.on('change:type', self.boardModel.onLayoutChange, self.boardModel);
		}

		function beforeDestroy() {
			self.contentMap = null;
		}

		function createContentModelMap() {
			var layoutSpec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
			var addOnLayoutSpec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			var contentMap = priv._getContentFromSpec.call(this, layoutSpec, {});
			var addOnContentMap = priv._getContentFromSpec.call(this, addOnLayoutSpec, {});
			// Remove duplicated ids
			return _extends({}, addOnContentMap, contentMap);
		}

		function cloneLayout(idMap) {
			var snapshot = JSON.parse(JSON.stringify((0, _mobxStateTree.getSnapshot)(self)));
			priv.replaceIds.call(self, idMap, snapshot);
			var clone = (0, _mobxStateTree.getType)(self).create(snapshot, (0, _mobxStateTree.getEnv)(self)); //was new LayoutModel(self.toJSON(), self.boardModel);
			if (!self.clones) {
				self.clones = 0;
			}
			self.clones++;

			priv.replaceRelatedLayouts.call(self, idMap);
			priv.incrementTitleCount.call(self, self.clones);
			return clone;
		}

		function select(id, options) {
			var model = self.findModel(id);
			if (!model) {
				self.logger.warn('Attempting to select id (' + id + ') that is not an immediate child of the layout');
				return;
			}

			if (self.selected.indexOf(id) === -1) {
				// Creating a new array to ensure mobx observers will pick up the change.
				// Without this, the `selectedWidgets` computed property in ExploreViewModel
				// will not get recomputed. By creating a new array each time, we're changing
				// the actual reference, which will be observed properly.
				var selected = [];
				if (options && options.selectedNodes) {
					selected = options.selectedNodes.map(function (node) {
						return node.id;
					}); //TODO
				} else {
					selected = self.selected.slice();
					selected.push(id);
				}

				self.selected = selected;
			} else {
				self.selected = JSON.parse(JSON.stringify(self.selected));
			}
		}

		function deselect(id) {
			if (self.selected) {
				var index = self.selected.indexOf(id);

				if (index >= 0) {
					self.selected.splice(index, 1);

					// Creating a new array to ensure mobx observers will pick up the change.
					// Without this, the `selectedWidgets` computed property in ExploreViewModel
					// will not get recomputed. By creating a new array each time, we're changing
					// the actual reference, which will be observed properly.
					self.selected = self.selected.slice();
				}
			}

			// Recursively deselect all the way up to the root.
			var parent = self.getParent();
			parent && parent.deselect(self.id);
		}

		function getSelectedChildLayouts() {
			var items = [];

			if (self.selected) {
				self.selected.forEach(function (id) {
					var model = self.findModel(id);
					if (model) {
						items.push(model);
					}
				});

				if (self.items) {
					self.items.forEach(function (item) {
						var selected = item.getSelectedChildLayouts();
						if (selected) {
							items = items.concat(selected);
						}
					});
				}
			}

			return items;
		}

		function getSelectedWidgets() {
			var selected = self.getSelectedChildLayouts().filter(function (item) {
				return item.type === 'widget';
			});

			// For a non-compare layout, if there are no items, return the first widget as the selected child layout.
			if (!self.isCompareEnabled && !selected.length) {
				var widget = self.getWidgetByIndex(0);
				if (widget) {
					return [widget];
				}
			}

			return selected;
		}

		function getWidgetByIndex(index) {
			if (index < 0) {
				return;
			}

			function _getWidgetByIndex(item, index, cursor) {
				if (item.type === 'widget' && index === cursor.index++) {
					return item;
				}

				var items = item.items;
				if (items) {
					var length = items.length;
					// Cannot use _.find here. Noticed some weird behaviour using it in a recursive
					// setting. It would return the parent of the matched item (sharing env or something?).
					for (var i = 0; i < length; i++) {
						var subItem = items[i];
						var widget = _getWidgetByIndex(subItem, index, cursor);
						if (widget) {
							return widget;
						}
					}
				}
			}

			return _getWidgetByIndex(self, index, { index: 0 });
		}

		/**
   * Find a model based on its id recursively.
   * @param {String} sId
   */
		function findModel(sId) {
			var m = null;
			if (self.id === sId) {
				m = self;
			}
			if (!m && self.items) {
				for (var i = 0; !m && i < self.items.length; i++) {
					m = self.items[i].findModel(sId);
				}
			}
			return m;
		}

		/**
   * Return an array of the widget IDs contained in the layouts with the specified IDs.
   *
   * @param aIDs	Layout id array
   */
		function listWidgets(aIDs) {
			var widgetIdList = [];
			var sId;
			for (var i = 0; i < aIDs.length; i++) {
				sId = aIDs[i];
				var layout = self.findModel(sId);
				if (!layout) {
					continue;
				}

				if (layout.type === 'widget' || layout.type === 'appwidget') {
					widgetIdList.push(layout.id);
				} else if (layout.items) {
					for (var j = 0; j < layout.items.length; j++) {
						widgetIdList.push.apply(widgetIdList, layout.items[j].listWidgets([layout.items[j].id]));
					}
				}
			}

			return widgetIdList;
		}

		/**
   * Add a layout model as a child.
   * @param {object} add options
   *		options.model		-	model json
   *		options.insertBefore		-	insert location
   * @param sender - scope or identifier for the object doing the update
   * @param payloadData - Additional data that will be included in the event payload.
   *
   * @returns - Triggered event payload if available
   */
		function add(options, sender, payloadData) {
			payloadData = priv.checkPayloadData.call(self, payloadData);
			var modelJSON = options.model;
			if (!modelJSON) {
				return null;
			}

			var payload = priv._insertItem.call(self, { model: modelJSON, insertBeforeId: options.insertBefore }, sender, payloadData);

			var addedModel = payload.value.parameter.model;
			return priv._triggerEvent.call(self, 'add:item', { op: 'add', parameter: { model: addedModel, insertBefore: options.insertBefore } }, { op: 'remove', parameter: addedModel.id }, sender, payloadData);
		}

		/**
   * Add multiple layout models
   * @param {object[]} modelArray An array of add options
   * @param {string} modelArray[].parentId parent id. If not available, the model will be added to the current model.			 * @param {object} modelArray[].model model json
   * @param {string} modelArray[].insertBefore insert location
   * @param sender - scope or identifier for the object doing the update
   * @param payloadData - Additional data that will be included in the event payload.
   *
   * @returns - Triggered event payload if available
   */
		function addArray(modelArray, sender, payloadData) {
			payloadData = priv.checkPayloadData.call(self, payloadData);
			var modelIdArray = [];
			var addedModels = [];
			var addPayload, options, parent, parentId;
			for (var i = 0; i < modelArray.length; i++) {
				options = modelArray[i];
				parentId = options.parentId ? options.parentId : self.id;
				parent = self.findModel(parentId);
				addPayload = parent.add(modelArray[i], sender, payloadData);
				if (addPayload) {
					addedModels.push(_.extend({ parentId: parentId }, addPayload.value.parameter));
					modelIdArray.unshift(addPayload.prevValue.parameter);
				}
			}
			var payload = null;
			if (modelIdArray.length > 0) {
				payload = priv._triggerEvent.call(self, 'add:items', { op: 'addArray', parameter: addedModels }, { op: 'removeArray', parameter: modelIdArray }, sender, payloadData);
			}
			return payload;
		}

		/**
   * Remove a child from this Model.
   * @param {string} model id to remove.
   * @param sender - scope or identifier for the object doing the update
   * @param payloadData - Additional data that will be included in the event payload.
   *
   * @returns - Triggered event payload if available
   */
		function remove(id, sender, payloadData) {
			payloadData = priv.checkPayloadData.call(self, payloadData);
			//remove from current parent
			var payload = null;
			var oldSiblingId = self.findModel(id).getNextSiblingId();
			var model = priv._removeItem.call(self, id);
			if (model) {
				payload = priv._triggerEvent.call(self, 'remove:item', { op: 'remove', parameter: id }, { op: 'add', parameter: { model: model.toJSON(), insertBefore: oldSiblingId } }, sender, payloadData);
				model.off();
				(0, _mobxStateTree.destroy)(model);
			}
			return payload;
		}

		/**
   * Remove multiple children from the model.
   * @param {string} Array of model ids to remove.
   * @param sender - scope or identifier for the object doing the update
   * @param payloadData - Additional data that will be included in the event payload.
   *
   * @returns - Triggered event payload if available
   */
		function removeArray(idArray, sender, payloadData) {
			payloadData = priv.checkPayloadData.call(self, payloadData);
			var models = [];
			var removePayload;
			var id, parent;
			for (var i = 0; i < idArray.length; i++) {
				id = idArray[i];
				parent = priv.findParentModel.call(self, id);
				if (parent) {
					removePayload = parent.remove(idArray[i], sender, payloadData);
					if (removePayload) {
						models.unshift(_.extend({ parentId: parent.id }, removePayload.prevValue.parameter));
					}
				}
			}

			var payload = null;
			if (models.length > 0) {
				payload = priv._triggerEvent.call(self, 'remove:items', { op: 'removeArray', parameter: idArray }, { op: 'addArray', parameter: models }, sender, payloadData);
			}
			return payload;
		}

		function replaceArray(newArray, sender, payloadData) {
			var prevItems = self.items.slice();
			self.items.replace(newArray);
			priv._triggerEvent.call(self, 'replace:items', { op: 'replaceArray', parameter: newArray }, { op: 'replaceArray', parameter: prevItems }, sender, payloadData);
		}

		/**
   * Update the style property of a model. This function will merge the provided styles with the existing ones
   * @param style  - object containing the styles that we would like to update
   * @param sender - scope or identifier for the object doing the update
   * @param payloadData - Additional data that will be included in the event payload.
   *
   * @returns - Triggered event payload if available
   */
		function updateStyle(style, sender, payloadData) {
			payloadData = priv.checkPayloadData.call(self, payloadData);
			var payload = null;
			if (style) {
				if (!self.style) {
					self.style = {};
				}
				var prev = priv._getStyles.call(self, style);
				_.extend(self.style, style);
				payload = priv._triggerEvent.call(self, 'change:style', { op: 'updateStyle', parameter: style }, { op: 'updateStyle', parameter: prev }, sender, payloadData);
			}

			return payload;
		}

		/**
   * Util for incrementing a style value ( % or px ) by 5% or 25px
   * Moved from BoardModel to become common
   *
   * @param value - value to be incremented
   * @returns the incremented value
   */
		function incrementStyleValue(value) {
			if (value) {
				if (value[value.length - 1] === '%') {
					return parseFloat(value) + 5 + '%';
				} else if (value[value.length - 1] === 'x') {
					return parseFloat(value) + 25 + 'px';
				} else {
					return value;
				}
			}
			return value;
		}

		/**
   * Update the filters of a model given id
   * @param id
   * @param filters
   * @param sender - scope or identifier for the object doing the update
   * @param payloadData - Additional data that will be included in the event payload.
   *
   * @returns - Triggered event payload if available
   */
		function updateFilters(id, filters) {
			var changes = {
				prevValue: {},
				value: {}
			};
			var widgetModel = self.boardModel.getWidgetModel(id);
			if (widgetModel && widgetModel.filters) {
				var modelFilters = widgetModel.filters;
				widgetModel.filters = filters;
				changes.prevValue.filters = modelFilters;
				changes.value.filters = filters;
			}

			return changes;
		}

		/**
   * Update the parent of the model
   *
   * @param options
   *		options.parentId  - new parent id
   *		options.insertBefore	- Id of the next sibling. If not provided, the model will be appended at the end.
   * @param sender - scope or identifier for the object doing the update
   * @param payloadData - Additional data that will be included in the event payload.
   *
   * @returns - Triggered event payload if available
   */
		function updateParent(options, sender, payloadData) {
			payloadData = priv.checkPayloadData.call(self, payloadData);
			var payload = null;
			var newParent = self.boardModel.layout.findModel(options.parentId);
			if (newParent) {

				//remove from current parent
				var oldParent = self.getParent();
				var oldSiblingId = null;
				if (oldParent) {
					oldSiblingId = self.getNextSiblingId();
					priv._removeItem.call(oldParent, self.id);
				}

				priv._insertItem.call(newParent, { model: self, insertBeforeId: options.insertBefore }, sender, payloadData);
				payload = priv._triggerEvent.call(self, 'change:parent', {
					op: 'updateParent',
					parameter: options
				}, {
					op: 'updateParent',
					parameter: {
						parentId: oldParent ? oldParent.id : null,
						insertBefore: oldSiblingId
					}
				}, sender, payloadData);
			}

			return payload;
		}

		/**
   * Apply changes to the model using the update spec. This method can do add, remove and update in one operation.
   *
   * The order of the execution is the following:
   *
   *	- Add new models
   *	- Update models
   *	- Remove models
   *
   *
   *
   * @param {object} options that describe the operation
   *		options.addArray	- Array of options needed to add the model.
   *			{
   *				model: {},		// model to add
   *				parentId: 'parentId'  // If not available, the model will be added to the current model.
   *			}
   *
   *		options.removeArray	- Array of model IDs to remove
   *					 *
   *		options.updateArray	- Options used by the move operation.
   *			{
   *				id: 'model id',
   *				parentId:'parent id'	// If not available, then the model will be moved to the first model that is being added in this operation
   *				insertBefore: 'someId', // Id of the model where we need to insert
   *				style :{
   *					top:'10px',
   *					left:'10px'
   *				}
   *			}
   * @param sender - scope or identifier for the object doing the update
   * @param payloadData - Additional data that will be included in the event payload.
   *
   * @returns - Triggered event payload if available
   */
		function updateModel(options, sender, payloadData) {
			payloadData = priv.checkPayloadData.call(self, payloadData);

			var payload;
			var addPayload = null;
			var payloadValue = {};
			var payloadPreValue = {};
			if (options.addArray) {
				addPayload = self.addArray(options.addArray, sender, payloadData);
				if (addPayload) {
					payloadValue.addArray = addPayload.value.parameter;
					payloadPreValue.removeArray = addPayload.prevValue.parameter;
				}
			}

			if (options.updateArray) {
				var addedModels = addPayload ? addPayload.value.parameter : null;
				var updatePayload = priv._updateModelsProperties.call(self, options.updateArray, sender, addedModels, payloadData);
				if (updatePayload) {
					if (JSON.stringify(updatePayload.value) !== JSON.stringify(updatePayload.prevValue)) {
						payloadValue.updateArray = updatePayload.value;
						payloadPreValue.updateArray = updatePayload.prevValue;
					}
				}
			}

			if (options.removeArray) {
				var removePayload = self.removeArray(options.removeArray, sender, payloadData);
				if (removePayload) {
					payloadValue.removeArray = removePayload.value.parameter;
					payloadPreValue.addArray = removePayload.prevValue.parameter;
				}
			}

			// Maintain any payload data that the caller included in the options.
			if (options.payloadData) {
				payloadValue.info = options.payloadData;
				payloadPreValue.info = options.payloadData;
			}

			if (!_.isEmpty(payloadValue)) {
				payload = priv._triggerEvent.call(self, 'op:updateModel', {
					op: 'updateModel',
					parameter: payloadValue
				}, {
					op: 'updateModel',
					parameter: payloadPreValue
				}, sender, payloadData);
			}

			return payload;
		}

		//TODO jdocs
		function moveModel(options, sender, payloadData) {

			payloadData = priv.checkPayloadData.call(self, payloadData);

			var payload = null;

			var payloadValue = {};
			var payloadPreValue = {};

			if (options.removeArray) {
				var removePayload = self.removeArray(options.removeArray, sender, payloadData);
				if (removePayload) {
					payloadValue.removeArray = removePayload.value.parameter;
					payloadPreValue.addArray = removePayload.prevValue.parameter;
				}
			}

			if (options.addArray) {
				var addPayload = self.addArray(options.addArray, sender, payloadData);
				if (addPayload) {
					payloadValue.addArray = addPayload.value.parameter;
					payloadPreValue.removeArray = addPayload.prevValue.parameter;
				}
			}

			if (options.updateArray) {
				var updatePayload = priv._updateModelsProperties.call(self, options.updateArray, sender, payloadData);
				if (updatePayload) {
					payloadValue.updateArray = updatePayload.value;
					payloadPreValue.updateArray = updatePayload.prevValue;
				}
			}

			// Maintain any payload data that the caller included in the options.
			if (options.payloadData) {
				payloadValue.info = options.payloadData;
				payloadPreValue.info = options.payloadData;
			}

			payload = priv._triggerEvent.call(self, 'op:moveModel', {
				op: 'moveModel',
				parameter: payloadValue
			}, {
				op: 'moveModel',
				parameter: payloadPreValue
			}, sender, payloadData);

			return payload;
		}

		function setId(id) {
			self.id = id;
		}

		function getLayoutPositioning() {
			return undefined;
		}

		function setDisplayStyleOn() {
			if (self.style) {
				self.style.display = undefined;
			}
		}

		function setDisplayStyleOff() {
			if (!self.style) {
				self.style = {};
			}
			self.style.display = 'none';
		}

		/**
   * Get selected
   *
   * @returns array of selected id
   */
		function getSelected() {
			return self.selected;
		}

		function getValueFromSelfOrParent(prop) {
			var value = self.get(prop);
			if (value === undefined) {
				var parent = self.getParent();
				if (parent) {
					value = parent.getValueFromSelfOrParent(prop);
				}
			}
			return value;
		}

		return {
			views: {
				findModel: findModel,
				listWidgets: listWidgets,
				getParent: getParent,
				getTopLayoutModel: getTopLayoutModel,
				getNextSiblingId: getNextSiblingId,
				getPreviousSiblingId: getPreviousSiblingId,
				getSelectedChildLayouts: getSelectedChildLayouts,
				getSelectedWidgets: getSelectedWidgets,
				getWidgetByIndex: getWidgetByIndex,
				findDropZones: findDropZones,
				findDescendantsWithType: findDescendantsWithType,
				getLinkedLayoutTree: getLinkedLayoutTree,
				findTopLevelParentItem: findTopLevelParentItem,
				findChildItem: findChildItem,
				getLayoutPositioning: getLayoutPositioning,
				getSelected: getSelected,
				getValueFromSelfOrParent: getValueFromSelfOrParent
			},
			actions: {
				afterCreate: afterCreate,
				createContentModelMap: createContentModelMap,
				beforeDestroy: beforeDestroy,
				cloneLayout: cloneLayout,
				add: add,
				addArray: addArray,
				remove: remove,
				removeArray: removeArray,
				replaceArray: replaceArray,
				select: select,
				deselect: deselect,
				updateStyle: updateStyle,
				incrementStyleValue: incrementStyleValue,
				updateFilters: updateFilters,
				updateParent: updateParent,
				updateModel: updateModel,
				moveModel: moveModel,
				setId: setId,
				setDisplayStyleOn: setDisplayStyleOn,
				setDisplayStyleOff: setDisplayStyleOff
			}
		}; //return
	});
	return MSTLayoutModel;
}

/**
 * This creates a MST LayoutModel instance
 *
 * @param {object} model the JSON spec for the model
 * @param {object} env the environment parameters used for creating the Model
 * @param {object} [env.whitelistAttrs] white list attributes allowed for the Model, optional
 * @param {object} [env.options] any options needed for preparing the Model, optional
 * @param {object} env.boardModel legacy BoardModel
 * @param {object} env.logger logger instance to be used
 */
function createMSTLayoutModelType(model, env) {
	var idMap = {};
	var logger = env && env.logger;

	//Don't particularly like doing this here, mobx seems to allow models with duplicate ids in the passed snapshot
	//also, preProcessSnapshot does not work for this type of functionality as it calls preProcessSnapshot
	//for nested models again (from the original snapshot)
	function trimDuplicateModels(item) {
		var copy = {};
		Object.keys(item).forEach(function (key) {
			if (key !== 'items') {
				if (copy) {
					copy[key] = item[key];
				}
				if (key === 'id' && idMap[item.id]) {
					copy = null;
				} else {
					idMap[item.id] = true;
				}
			} else {
				copy.items = [];
				for (var i = 0; i < item.items.length; i++) {
					var child = trimDuplicateModels(item.items[i]);
					if (child) {
						copy.items.push(child);
					} else {
						logger && logger.error('Found duplicate layout id "' + item.items[i].id + '" on initialization of layout "' + item.id + '".');
					}
				}
			}
		});
		return copy;
	}

	model = trimDuplicateModels(model);

	var PreparedLayoutModelType = prepareMSTLayoutModelType(env);
	return PreparedLayoutModelType.create(model, env);
}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.MSTLayoutModelBase = undefined;

var _mobxStateTree = __webpack_require__(7);

var _utils = __webpack_require__(34);

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var Style = _mobxStateTree.types.model({
	top: _mobxStateTree.types.union(_mobxStateTree.types.string, _mobxStateTree.types.undefined),
	left: _mobxStateTree.types.union(_mobxStateTree.types.string, _mobxStateTree.types.undefined),
	height: _mobxStateTree.types.union(_mobxStateTree.types.string, _mobxStateTree.types.undefined),
	width: _mobxStateTree.types.union(_mobxStateTree.types.string, _mobxStateTree.types.undefined)
}).volatile(function () {
	return {
		display: undefined
	};
});

var MSTLayoutModelBase = exports.MSTLayoutModelBase = _mobxStateTree.types.model({
	id: _mobxStateTree.types.optional(_mobxStateTree.types.identifier, (0, _utils.generateUniqueId)('model')),
	type: _mobxStateTree.types.union(_mobxStateTree.types.string, _mobxStateTree.types.undefined),
	title: _mobxStateTree.types.union(_mobxStateTree.types.string, _mobxStateTree.types.undefined),
	from: _mobxStateTree.types.union(_mobxStateTree.types.string, _mobxStateTree.types.undefined),
	style: _mobxStateTree.types.union(Style, _mobxStateTree.types.undefined),
	templateName: _mobxStateTree.types.union(_mobxStateTree.types.string, _mobxStateTree.types.undefined),
	clones: _mobxStateTree.types.union(_mobxStateTree.types.number, _mobxStateTree.types.undefined),
	css: _mobxStateTree.types.union(_mobxStateTree.types.string, _mobxStateTree.types.undefined),
	relatedLayouts: _mobxStateTree.types.union(_mobxStateTree.types.string, _mobxStateTree.types.undefined),
	fillColor: _mobxStateTree.types.union(_mobxStateTree.types.string, _mobxStateTree.types.undefined),
	disableScrollDrop: _mobxStateTree.types.union(_mobxStateTree.types.boolean, _mobxStateTree.types.undefined),
	properties: _mobxStateTree.types.union(_mobxStateTree.types.frozen(), _mobxStateTree.types.undefined),

	items: _mobxStateTree.types.union(_mobxStateTree.types.array(_mobxStateTree.types.late(function () {
		return MSTLayoutModelBase;
	})), _mobxStateTree.types.undefined)
}).preProcessSnapshot(function (snapshot) {
	//sanity check, mobx does not like null snapshot
	if (snapshot === null) {
		return {};
	}
	return snapshot;
});

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ModelAdapter = exports._LegacyEvent$1 = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
                                                                                                                                                                                                                                                                               *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                               *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                               *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                               *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                                                                                                                                               *|
                                                                                                                                                                                                                                                                               *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                               *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                               *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                               */


exports.prepareModelAdapterType = prepareModelAdapterType;
exports.createModelAdapter = createModelAdapter;

var _mobxStateTree = __webpack_require__(7);

var _utils = __webpack_require__(34);

var CoreModelClass = __webpack_require__(68);

/**
 * The event that will be sent on a model change to who ever is listening to model changes
 * This is to support the legacy Model
 * @param {string} eventName the name of the triggered event e.g. change:title
 * @param {object} patch JSON patch for the change
 * @param {object} revPatch reverse JSON patch for the change (does the undo)
 * @param {string} modelId model identifier
 */
var _LegacyEvent$1 = exports._LegacyEvent$1 = function _LegacyEvent$1(eventName, patch, revPatch, modelId) {
	this.eventName = eventName;
	this.name = eventName;
	this.value = patch;
	this.prevValue = revPatch;
	this.model = modelId;
	this.sender = modelId;
	this.senderContext = {};
	this.collection = null;
	this.data = {};
};

var ModelAdapter = exports.ModelAdapter = _mobxStateTree.types.model({}).volatile(function (self) {
	return {
		attr: {},
		options: {},

		localizedProps: [],
		whitelistAttrs: [],
		nestedCollections: {},
		runtimeAttrs: [],
		nestedModels: {},
		contentReferences: [],
		colorProperties: [],

		_events: {},

		_lastSnapshot: null,
		_setValueCalled: false,

		//actions added will be responsible to trigger legacy events
		//this is a generic helper to trigger a legacy event
		triggerLegacyEvent: function triggerLegacyEvent(eventName, patch, reversePatch) {
			var event = new _LegacyEvent$1(eventName, patch, reversePatch, self.id);
			self.trigger(eventName, event);
		}
	};
});

/**
 * This creates a Model Adapter Type which mixes in Core Model into a MST Type
 * contructs props for the MST model dynamically based on passed white list attributes
 *
 * @param {object} env environment parameters passed to the Type
 * @param {object} env.whitelistAttrs white list attributes allowed for the Model
 * @param {object} env.options any options needed for preparing the Model
 * @param {Array} [modelList] an array of additional models needed for preparing the Model
 */
function prepareModelAdapterType(env, modelList) {
	var blocked = ['init', 'constructor', 'set', 'toJSON'];
	var coreModel = new CoreModelClass({}, env.options);

	var isFunction = function isFunction(v) {
		return typeof v === 'function';
	};

	var isArray = function isArray(v) {
		return Array.isArray(v);
	};

	var isObject = function isObject(v) {
		// null is typeof object
		return v && (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object';
	};

	return ModelAdapter.props((0, _utils.constructProps)(env)).actions(function (self) {
		(0, _utils.adoptFunctions)(coreModel, self, blocked, true); //these functions are not 'mst actions'
		if (modelList && modelList.length > 0) {
			modelList.map(function (model) {
				(0, _utils.adoptFunctions)(model.newInstance, self, model.methodList, model.isBlocked);
			});
		}
		return {
			afterCreate: function afterCreate() {
				self.whitelistAttrs = (0, _mobxStateTree.getEnv)(self).whitelistAttrs; //allow legacy toJSON to work
			},
			set: function set(values, options) {
				//expose set as an action
				if (values instanceof _LegacyEvent$1) {
					(0, _mobxStateTree.applyPatch)(self, values.value);
				} else {
					coreModel.set.call(self, values, options);
				}
			},
			toJSON: function toJSON(additionalAttrs, excludedAttrs) {
				var obj = {};
				var getJson = function getJson(value) {
					var json = void 0;
					if (!value) {
						json = value;
					} else {
						if (value.toJSON && isFunction(value.toJSON) && !value.$mobx) {
							// Call Model toJSON
							json = value.toJSON();
						} else if (value.toJSON && isFunction(value.toJSON) && value.$mobx && !value.map) {
							// Call mobx toJSON
							json = value.toJSON();
						} else if (value.$mobx && value.map && isArray(value.map(function (item) {
							return item;
						}))) {
							// Convert to an array by using mobx map
							value = value.map(function (item) {
								return item;
							});
							// ES6 map
							json = value.map(function (v) {
								return getJson(v);
							});
						} else if (isArray(value)) {
							json = value.map(function (v) {
								return getJson(v);
							});
						} else if (isObject(value)) {
							// Clone object
							json = _extends({}, value);
						} else {
							json = value;
						}
					}
					return json;
				};
				var filteredWhitelist = self.whitelistAttrs;
				if (excludedAttrs) {
					filteredWhitelist = self.whitelistAttrs.filter(function (attr) {
						return excludedAttrs.indexOf(attr) === -1;
					});
				}
				filteredWhitelist.forEach(function (attr) {
					if (self.runtimeAttrs.indexOf(attr) !== -1) {
						if (self._persistedRuntimeAttrs[attr] !== undefined) {
							obj[attr] = getJson(self._persistedRuntimeAttrs[self.resolvePropertyName(attr)]);
						}
					} else {
						if (self[attr] !== undefined) {
							obj[attr] = getJson(self[self.resolvePropertyName(attr)]);
						}
					}
				});
				if (additionalAttrs) {
					if (!isArray(additionalAttrs)) {
						additionalAttrs = [additionalAttrs];
					}
					additionalAttrs.forEach(function (attr) {
						if (self[self.resolvePropertyName(attr)] !== undefined) {
							obj[attr] = getJson(self[self.resolvePropertyName(attr)]);
						}
					});
				}
				return obj;
			}
		};
	});
}

/**
 * This creates a Model Adapter instance
 *
 * @param {object} model the JSON spec for the model
 * @param {object} env the environment parameters used for creating the Model
 * @param {object} env.whitelistAttrs white list attributes allowed for the Model
 * @param {object} env.options any options needed for preparing the Model
 * @param {Array} [modelList] an array of additional models needed for preparing the Model
 */
function createModelAdapter(model, env, modelList) {
	var PreparedModelAdapterType = prepareModelAdapterType(env, modelList);
	return PreparedModelAdapterType.create(model, env);
}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_177__;

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_178__;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.CardLayoutModelExt = undefined;

var _mobxStateTree = __webpack_require__(7);

var _CardModelUtil = __webpack_require__(69);

var _CardModelUtil2 = _interopRequireDefault(_CardModelUtil);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _CompareModel = __webpack_require__(180);

var _CompareModel2 = _interopRequireDefault(_CompareModel);

var _CometViewModel = __webpack_require__(189);

var _CometViewModel2 = _interopRequireDefault(_CometViewModel);

var _FilterDockModel = __webpack_require__(72);

var _FilterDockModel2 = _interopRequireDefault(_FilterDockModel);

var _CardAPI = __webpack_require__(191);

var _CardAPI2 = _interopRequireDefault(_CardAPI);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//TODO: Need a better name for comet card
var SubType = _mobxStateTree.types.union(_mobxStateTree.types.enumeration(['compare', 'comet']), _mobxStateTree.types.undefined); /*
                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                   *| Licensed Materials - Property of IBM
                                                                                                                                   *| IBM Cognos Products: Explore
                                                                                                                                   *| (C) Copyright IBM Corp. 2018, 2021
                                                                                                                                   *|
                                                                                                                                   *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                   *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                   *+------------------------------------------------------------------------+
                                                                                                                                   */

var CardLayoutModelExt = exports.CardLayoutModelExt = _mobxStateTree.types.model('CardLayoutModelExt', {
	type: _mobxStateTree.types.optional(_mobxStateTree.types.string, 'exploreCard'),
	isHidden: _mobxStateTree.types.optional(_mobxStateTree.types.boolean, false),
	isFavourite: _mobxStateTree.types.optional(_mobxStateTree.types.boolean, false),
	subType: SubType
}).volatile(function (self) {
	return {
		cardModelUtil: _CardModelUtil2.default,
		numberOfChildLayoutsReady: 0,
		showModalVisTypePicker: false,
		visDestination: null,
		compareModel: null,
		cometViewModel: null,
		filterDockModel: null,

		isDisplayed: false,
		filterDockInitialized: false,
		isNew: false,
		canvasTabs: null,
		canShowCanvasSidePanel: true,
		_mobxDisposeEvents: [],
		thumbnailsModel: null,
		isCurrentThumbnail: false,
		isDoneThumbnail: false,
		advancedVisualizationTypes: [],
		renderThumbnail: function renderThumbnail() {
			if (self.thumbnailsModel) {
				return self.thumbnailsModel.renderCard(self.id);
			}
		},
		api: null,
		getFeature: function getFeature(featureName) {
			var featureAPI = undefined;
			switch (featureName) {
				case 'compare':
					featureAPI = self.subType === 'compare' && self.compareModel.getAPI ? self.compareModel.getAPI() : undefined;
					break;
				case 'driverAnalysis':
					featureAPI = self.isDriverAnalysis() && self.cometViewModel && self.cometViewModel.getAPI ? self.cometViewModel.getAPI() : undefined;
					break;
				case 'thumbnails':
					featureAPI = self.thumbnailsModel && self.thumbnailsModel.getAPI ? self.thumbnailsModel.getAPI() : undefined;
					break;
			}
			return featureAPI;
		},
		isNewCompareDnDFeature: function isNewCompareDnDFeature() {
			var env = (0, _mobxStateTree.getEnv)(self);
			return env && env.isFeatureEnabled && !env.isFeatureEnabled('newCompareDnDEnabled', 'false');
		}
	};
}).views(function (self) {
	return {
		getVisualizations: function getVisualizations() {
			return self.cardModelUtil.getLayouts(self, self.boardModel);
		},
		getWidgets: function getWidgets() {
			return self.items.map(function (visLayout) {
				return self.boardModel.getWidgetModel(visLayout.id);
			});
		},

		get isCompareEnabled() {
			return self.subType && self.subType === 'compare' || false;
		},

		//todo: we are going to create a comet card view.
		isDriverAnalysis: function isDriverAnalysis() {
			var aVizs = self.getVisualizations();
			if (aVizs && aVizs.length > 0) {
				var vis = aVizs[0];
				var sID = vis.widgetLayout ? vis.widgetLayout.id : vis.placeholder.id;
				var aDriversAnalysisVizs = ['com.ibm.vis.rave2comet']; //Add more
				return aDriversAnalysisVizs.indexOf(self.boardModel.getWidgetModel(sID).visId) >= 0;
			}
			return false;
		}
	};
}).actions(function (self) {
	return {
		afterCreate: function afterCreate() {
			self.getAdvancedVisualizationTypes(); // get usage types from vis def manager so it's available for when view's render() needs it
			self.createLayoutModel = self.createLayoutModel || (0, _mobxStateTree.getEnv)(self).createLayoutModel;
			//Since R7, properties and features are in the whitelistAttrs, for example, for widget content
			self.whitelistAttrs = ['features', 'properties', 'id', 'from', 'css', 'items', 'style', 'type', 'title', 'templateName', 'relatedLayouts', 'clones', 'fillColor', 'disableScrollDrop', 'isHidden', 'isFavourite', 'subType', 'content'];
			//TODO delay instantiating compareModel, cometViewModel till they are needed
			self.compareModel = _CompareModel2.default.create({ statsModelMap: {}, selStatsModelMap: {} }, { isFeatureEnabled: (0, _mobxStateTree.getEnv)(self).isFeatureEnabled });
			self.cometViewModel = _CometViewModel2.default.create({ selections: [], visIndexToShow: 0 });
			self.cometViewModel.setCardModel(self);
			self.filterDockModel = _FilterDockModel2.default.create({ scopeId: self.id }, {
				dashboardApi: (0, _mobxStateTree.getEnv)(self).dashboardApi,
				logger: (0, _mobxStateTree.getEnv)(self).logger
			});
		},
		beforeDestroy: function beforeDestroy() {
			self.compareModel && (0, _mobxStateTree.destroy)(self.compareModel);
			self.cometViewModel && (0, _mobxStateTree.destroy)(self.cometViewModel);
			self.filterDockModel && (0, _mobxStateTree.destroy)(self.filterDockModel);

			// Remove the events.
			self._mobxDisposeEvents.forEach(function (dispose) {
				return dispose();
			});

			if (self.api) {
				self.api.destroy();
				self.api = null;
			}
		},
		_initializeFilterDockIfNecessary: function _initializeFilterDockIfNecessary(isDisplayed) {
			if (!self.filterDockInitialized && isDisplayed && !self.isDisplayed) {
				self.filterDockModel.initializeFilterDock();
				self.filterDockModel.switchDatasource(null);
				self.filterDockInitialized = true;
			}
		},

		/**
   * Gets and stores advanced visualization types so it's ready for when view's render() needs it
   */
		getAdvancedVisualizationTypes: function getAdvancedVisualizationTypes() {
			if (self.advancedVisualizationTypes.length > 0) {
				return self.advancedVisualizationTypes;
			}
			var visDef = (0, _mobxStateTree.getEnv)(self).dashboardApi.getFeature('VisDefinitions');
			var advancedTypes = [];
			// When opening a saved explore visDef is undefined that's why the check is needed
			visDef && visDef.getList().forEach(function (defElement) {
				var usage = defElement.getProperty('usages');
				if (usage && usage.indexOf('Advanced') !== -1) {
					advancedTypes.push(defElement.getId());
				}
			});
			self.setAdvancedVisualizationTypes(advancedTypes);
			return self.advancedVisualizationTypes;
		},


		/**
   * Checks if compare table should be shown
   * Current conditions:
   * 1. Widget is of advanced analytics type
   * 2. Widget has no data(template or placeholder)
   * 3. Combinations of conditions 1 and 2
   * Compare table should be shown/hidden once all widgets in the layout are evaluated
   * @param {Object} compareModel to check if widget has data
   * @return {boolean}
   */
		shouldShowCompareTable: function shouldShowCompareTable(compareModel) {
			var visualizations = self.getVisualizations();
			var unsupportedVisualizationCount = 0;
			if (visualizations && visualizations.length > 0) {
				visualizations.forEach(function (vis) {
					var widgetId = vis.widgetLayout ? vis.widgetLayout.id : vis.placeholder.id;
					var advancedVizTypes = self.getAdvancedVisualizationTypes();
					if (advancedVizTypes.indexOf(self.boardModel.getWidgetModel(widgetId).visId) >= 0 || !compareModel.widgetHasData(widgetId)) {
						unsupportedVisualizationCount++;
					}
				});
			}
			return unsupportedVisualizationCount !== visualizations.length;
		},
		getAPI: function getAPI() {
			if (!self.api) {
				self.api = new _CardAPI2.default(self);
			}
			return self.api;
		},
		updateViewState: function updateViewState(params) {
			self._initializeFilterDockIfNecessary(params.isDisplayed);
			self.isDisplayed = params.isDisplayed;
			self.canvasTabs = params.canvasTabs;
			self.canShowCanvasSidePanel = params.canShowCanvasSidePanel;
			if (!self.thumbnailsModel) {
				self.thumbnailsModel = params.thumbnailsModel;
			}
		},
		updateCanShowCanvasSidePanel: function updateCanShowCanvasSidePanel(flag) {
			self.canShowCanvasSidePanel = flag;
		},
		setCurrentThumbnailInfo: function setCurrentThumbnailInfo(isCurrentThumbnail, thumbnailsModel) {
			self.isCurrentThumbnail = isCurrentThumbnail;
			if (!self.thumbnailsModel) {
				self.thumbnailsModel = thumbnailsModel;
			}
		},
		setIsDoneThumbnail: function setIsDoneThumbnail(flag) {
			self.isDoneThumbnail = flag;
		},
		setAdvancedVisualizationTypes: function setAdvancedVisualizationTypes(types) {
			self.advancedVisualizationTypes = types;
		},
		incrChildReadyCount: function incrChildReadyCount() {
			self.numberOfChildLayoutsReady++;
		},
		incrStatsModelUpdateCount: function incrStatsModelUpdateCount() {
			self.statsModelUpdateCount++;
		},
		setCardModelUtil: function setCardModelUtil(util) {
			self.cardModelUtil = util;
		},
		getTitle: function getTitle() {
			var separator = ' / ';
			var title = self.getVisualizations().map(function (layout) {
				var widgetLayout = layout.widgetLayout;
				if (!widgetLayout) {
					return null;
				}
				var widgetModel = self.boardModel.getWidgetModel(widgetLayout.id);
				if (!widgetModel) {
					return null;
				}
				return widgetModel.name;
			}).filter(function (name) {
				return !!name;
			}).join(separator);
			return title !== separator ? title : '';
		},
		toggleFavourite: function toggleFavourite(state) {
			if (state === undefined) {
				self.isFavourite = !self.isFavourite;
			} else {
				self.isFavourite = state;
			}
		},
		toggleHidden: function toggleHidden(state) {
			if (state === undefined) {
				self.isHidden = !self.isHidden;
			} else {
				self.isHidden = state;
			}
		},
		setShowModalVisTypePicker: function setShowModalVisTypePicker(show, destination) {
			self.showModalVisTypePicker = show;
			self.visDestination = show ? destination : null;
		},
		setSelections: function setSelections(selections) {
			self.cometViewModel.setSelections(selections);
		},
		placeWidgetInCard: function placeWidgetInCard(widgetSpec, payloadData) {
			payloadData = _underscore2.default.isString(payloadData) ? {
				undoRedoTransactionId: _underscore2.default.uniqueId(payloadData)
			} : payloadData;

			widgetSpec.parentId = self.id; //appends widget under this layout
			widgetSpec.model.showTitle = undefined;
			widgetSpec.model.titleMode = 'smartTitle';

			self.boardModel.addWidget(widgetSpec, 'cardSender', payloadData);
		},


		//add data source, update modelRef, remove widget id
		_prepareWidgetSpec: function _prepareWidgetSpec(fragmentSpec, payloadData) {
			var boardModel = self.boardModel;
			var dataSourcesFeature = boardModel.dashboardApi.getFeature('dataSources.deprecated');
			var sourceCollection = dataSourcesFeature.getSourcesCollection();
			var sourceIdMap = sourceCollection.addSourcesForPin(fragmentSpec.model, {
				payloadData: payloadData
			});
			var widget = fragmentSpec.model.widgets[Object.keys(fragmentSpec.model.widgets)[0]];
			var dataViews = widget.data ? widget.data.dataViews : null;
			if (dataViews) {
				dataViews.forEach(function (dataView) {
					if (sourceIdMap[dataView.modelRef]) {
						dataView.modelRef = sourceIdMap[dataView.modelRef];
					}
				});
			}
			var widgetSpec = {};
			delete widget.id;
			widgetSpec.model = widget;
			return widgetSpec;
		},
		_addDataSource: function _addDataSource(spec, options) {
			var dashboard = (0, _mobxStateTree.getEnv)(self).dashboardApi;
			var dataSources = dashboard.getFeature('DataSources');
			var data = spec && spec.model && spec.model.data;
			if (data && data.dataViews && data.dataViews.length) {
				data.dataViews.forEach(function (view) {
					if (view.model) {
						view.modelRef = dataSources.addDataSource(view.model, false, options);
						delete view.model;
					}
				});
			}
		},
		replaceWidgetInCard: function replaceWidgetInCard(spec, layoutId, payloadData) {
			payloadData = _underscore2.default.isString(payloadData) ? {
				undoRedoTransactionId: _underscore2.default.uniqueId(payloadData)
			} : payloadData;

			var widgetSpec = JSON.parse(JSON.stringify(spec));
			if (widgetSpec.specType && widgetSpec.specType === 'fragment') {
				widgetSpec = self._prepareWidgetSpec(spec, payloadData);
			}

			self._addDataSource(widgetSpec);

			// Preserve Content model for pinning
			var widgetContentMap = self.createContentModelMap(spec.model.layout);
			var widgetContentProperties = Object.values(widgetContentMap);
			if (widgetContentProperties.length > 0) {
				widgetSpec.layoutProperties = { content: widgetContentProperties[0] };
			}

			widgetSpec.parentId = self.id;
			widgetSpec.insertBefore = layoutId; //adds widget in the place of layoutId layout
			widgetSpec.model.showTitle = undefined;
			widgetSpec.model.titleMode = 'smartTitle';
			// force setting label orientation and legend position prop in widget spec when compare enabled
			if (self.isCompareEnabled) {
				var extraWidgetOptions = {
					properties: [{
						id: 'itemAxis.labels.layoutMode',
						value: 'stagger'
					}, {
						id: 'widget.legend.position',
						value: 'right'
					}]
				};
				Object.assign(widgetSpec.model, extraWidgetOptions);
			}
			self.boardModel.addWidget(widgetSpec, 'cardSender', payloadData);
			// deselect the placeholder widget before removing it
			var dashboardApi = (0, _mobxStateTree.getEnv)(self).dashboardApi;
			dashboardApi && dashboardApi.getCanvas().deselectContent([layoutId]);
			self.boardModel.removeLayouts(layoutId, 'cardSender', payloadData); //and removes layoutId layout
		},
		addStatsModels: function addStatsModels(widgetId, initialModel, initialSelModel, measureLabel, widgetAlias) {
			self.compareModel.addStatsModels(widgetId, initialModel, initialSelModel, measureLabel, widgetAlias);
		},
		setupStatsModels: function setupStatsModels(widgetId, svc) {
			return self.compareModel.setupStatsModels(widgetId, svc);
		},
		setIsNew: function setIsNew(isNew) {
			self.isNew = isNew;
		}
	};
});

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.SelectionStatsModelMap = exports.StatsModelMap = undefined;

var _mobxStateTree = __webpack_require__(7);

var _mobx = __webpack_require__(11);

var mobx = _interopRequireWildcard(_mobx);

var _StatsModel = __webpack_require__(181);

var _StatsModel2 = _interopRequireDefault(_StatsModel);

var _RefChecker = __webpack_require__(70);

var _RefChecker2 = _interopRequireDefault(_RefChecker);

var _StatsProcessor = __webpack_require__(44);

var _StatsProcessor2 = _interopRequireDefault(_StatsProcessor);

var _MatchScaleProcessor = __webpack_require__(183);

var _MatchScaleProcessor2 = _interopRequireDefault(_MatchScaleProcessor);

var _SynchActionProcessor = __webpack_require__(184);

var _SynchActionProcessor2 = _interopRequireDefault(_SynchActionProcessor);

var _CompareTableSummary = __webpack_require__(185);

var _CompareTableSummary2 = _interopRequireDefault(_CompareTableSummary);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _CompareCardAPI = __webpack_require__(188);

var _CompareCardAPI2 = _interopRequireDefault(_CompareCardAPI);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var StatsModelMap = exports.StatsModelMap = _mobxStateTree.types.union(_mobxStateTree.types.map(_StatsModel2.default), _mobxStateTree.types.undefined); /*
                                                                                                                                                         *+------------------------------------------------------------------------+
                                                                                                                                                         *| Licensed Materials - Property of IBM
                                                                                                                                                         *| IBM Cognos Products: Explore
                                                                                                                                                         *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                         *|
                                                                                                                                                         *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                         *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                         *+------------------------------------------------------------------------+
                                                                                                                                                         */
var SelectionStatsModelMap = exports.SelectionStatsModelMap = _mobxStateTree.types.union(_mobxStateTree.types.map(_StatsModel.SelectionStatsModel), _mobxStateTree.types.undefined);

var disconnectWidgetsFromGroup = function disconnectWidgetsFromGroup(dashboardApi, widgetIds) {
	if (widgetIds && widgetIds.length > 0) {
		var feature = dashboardApi.getFeature('EventGroups');
		var oldGroupId = feature.getGroupId(widgetIds[0]);
		feature.removeFromGroup(widgetIds);
		var disposer = function disposer() {
			if (feature.groupExists(oldGroupId)) {
				feature.addToGroup(oldGroupId, widgetIds);
			} else {
				feature.createGroup(widgetIds);
			}
		};
		return disposer;
	} else {
		return function () {};
	}
};

/**
* Class representing comparison state
* It holds 2 maps statsModelMap, selStatsModelMap + other state
* statsModelMap -->  <widget id (string)> -> <StatsModel>
* 	It keeps stats received from live widget when there are no selections (default stats)
* selStatsModelMap -->  <widget id (string)> -> <StatsModel>
*	It keeps stats received from live widget when there are selections
*
* This class centralizes state for compare functionality, so that views can render the info
* Also, the selections info feeds into another model (SelectionGistModel) which provides 'computed view' on top of
* the selection data so Compare functionality can determine comparable data & compute additional calculated stats
* e.g. total, average etc..
*/
exports.default = _mobxStateTree.types.model({
	statsModelMap: StatsModelMap,
	selStatsModelMap: SelectionStatsModelMap
}).volatile(function (self) {
	return {
		showCompareTable: true,

		showCompareLine: true,
		showStats: true,
		matchingPoints: mobx.observable.map({}),
		renderCrosshairPopOver: '',
		syncWidgetSelectionsUpdated: 0, //A flag which changes whenever the synchSelections toggle needs to be updated.
		syncCompareLine: true,
		matchScale: true,
		isToggledBySyncAxisButton: false,
		syncActions: true,
		widgetMeasureNameMap: {}, //A map of widgetIds - selectedMeasureNames (as selected in the compare table summary.)
		eventGroups: null,
		widgetAliasMap: {},
		widgetIds: [],
		widgetContentApisMap: {}, //APIs for the widgets in this compare model (used for synchronized actions)
		synchActionProcessor: null,
		theMatchScaleProcessor: _MatchScaleProcessor2.default,
		theStatsProcessor: _StatsProcessor2.default,
		compareTableSummary: null,
		compareTableSelectionSummary: null,
		statsUpdated: 0,
		selectionUpdated: 0,
		widgetUpdatedCount: 0,
		refChecker: null,
		theStringResources: _StringResources2.default,
		_mobxDisposeEvents: [],
		_api: null,

		getAPI: function getAPI() {
			return self._api;
		}
	};
}).views(function (self) {
	return {
		getStatsModel: function getStatsModel(widgetId) {
			return self.statsModelMap && self.statsModelMap.get(widgetId);
		},
		getSelectionStatsModel: function getSelectionStatsModel(widgetId) {
			return self.selStatsModelMap && self.selStatsModelMap.get(widgetId);
		},
		getNewCompareTableStatsEnabled: function getNewCompareTableStatsEnabled() {
			var env = (0, _mobxStateTree.getEnv)(self);
			return env && env.isFeatureEnabled && !env.isFeatureEnabled('newCompareTableStatsEnabled', 'false');
		},
		getChartSummaryModel: function getChartSummaryModel(category) {
			if (category === 'summary') {
				return self.compareTableSummary;
			} else if (category === 'selections') {
				return self.compareTableSelectionSummary;
			}
			return undefined;
		},
		summaryStatsGetter: function summaryStatsGetter(category) {
			if (category === 'summary') {
				return self.getChartSummaryStats.bind(self);
			} else if (category === 'selections') {
				return self.getChartSelectionSummaryStats.bind(self);
			}
			return undefined;
		},
		summarySubHeaderGetter: function summarySubHeaderGetter(category) {
			if (category === 'selections') {
				return self.getSelectionContextLabel.bind(self);
			}
			return function () {
				return null;
			};
		},
		getChartSummaryStats: function getChartSummaryStats(widgetId, measureName) {
			var stats = null;
			var statsModel = self.getStatsModel(widgetId);
			if (statsModel) {
				var chartVsChart = self.chartVsChartTotalPercentStats[widgetId];
				var widgetAlias = self.getWidgetAlias(widgetId);
				var getString = _StringResources2.default.get.bind(_StringResources2.default);
				var newCompareTableStatsEnabled = self.getNewCompareTableStatsEnabled();
				stats = self.theStatsProcessor.getChartSummaryStats({ newCompareTableStatsEnabled: newCompareTableStatsEnabled, statsModel: statsModel, chartVsChart: chartVsChart, measureName: measureName, widgetAlias: widgetAlias, getString: getString });
			}
			return stats;
		},
		getChartSelectionSummaryStats: function getChartSelectionSummaryStats(widgetId, measureName) {
			var stats = null;
			var statsModel = self.getStatsModel(widgetId);
			var selStatsModel = self.getSelectionStatsModel(widgetId);
			if (statsModel) {
				var widgetAlias = self.getWidgetAlias(widgetId);
				var getString = self.theStringResources.get.bind(self.theStringResources);
				var newCompareTableStatsEnabled = self.getNewCompareTableStatsEnabled();
				stats = self.theStatsProcessor.getChartSelectionSummaryStats({ newCompareTableStatsEnabled: newCompareTableStatsEnabled, statsModel: statsModel, selStatsModel: selStatsModel, measureName: measureName, widgetAlias: widgetAlias, getString: getString });
			}
			return stats;
		},
		getSelectionContextLabel: function getSelectionContextLabel(widgetId, measureName) {
			var selStatsModel = self.getSelectionStatsModel(widgetId);
			if (selStatsModel) {
				var info = self.theStatsProcessor.getSelectionContextLabel(selStatsModel, measureName);
				var str = info.lastCategorySelectionLabel;
				if (info.numSelections > 1) {
					var params = { selection: info.lastCategorySelectionLabel, count: info.numSelections - 1 };
					str = self.theStringResources.get('compareTable_Selection_SubLabel', params);
				}
				return [str];
			}
			return undefined;
		},


		get chartVsChartTotalPercentStats() {
			return self.theStatsProcessor.getChartVsChartTotalPercentStats(self.statsModelMap);
		},

		getWidgetAlias: function getWidgetAlias(widgetId) {
			return self.widgetAliasMap[widgetId] || '';
		},
		getWidgetContentApis: function getWidgetContentApis() {
			return Object.values(self.widgetContentApisMap);
		},
		getWidgetMeasureName: function getWidgetMeasureName(widgetId) {
			return self.widgetMeasureNameMap[widgetId];
		},


		/**
   * @return {Object} the matching points for compare cards
   */
		getCrossHairMatchingPoints: function getCrossHairMatchingPoints() {
			return mobx.toJS(self.matchingPoints);
		},


		/**
   * Renders a popover with the given parameters when called.
   * @param {Object} crossHairInfo - the info to show inside the popover
   * @param {Object} renderNode - the node to reder the popover to
   * @param {Number} totalItems - the number of rows in the popover
   * @param {Boolean} footerinfo.showFooter - true to show footer, false to hide footer
   * @param {Object} containerNode - container node
   */
		renderPopOver: function renderPopOver(crossHairInfo, renderNode, totalItems, footerinfo, containerNode) {
			self.renderCrosshairPopOver && self.renderCrosshairPopOver(crossHairInfo, renderNode, totalItems, footerinfo, containerNode);
		},


		/**
   * check if the compare line is enabled. The compare line is only disabled when the flag is set to false specifically.
   * @returns {Boolean} true if enabled
   */
		isNewCompareLineFeatureEnabled: function isNewCompareLineFeatureEnabled() {
			return !(0, _mobxStateTree.getEnv)(self).isFeatureEnabled('newCompareLine', 'false');
		},
		isWidgetSelectionsSynced: function isWidgetSelectionsSynced() {
			if (self.syncWidgetSelectionsUpdated && self.eventGroups) {
				//Recalculate widget synched based on how many event groups the widgets are assigned to.
				//ie: if they're both assigned to 1 group, synch selections toggle should be true.
				var eventGroupSet = {};
				self.widgetIds.forEach(function (widgetId) {
					var group = self.eventGroups.findGroup(widgetId);
					if (group) {
						eventGroupSet[group.id] = true;
					}
				});
				return Object.keys(eventGroupSet).length < 2 ? true : false;
			}
			return true;
		},


		/**
   * @param widgetId - the widgetId.
   * @return true if widget with id widgetId has data.
   */
		widgetHasData: function widgetHasData(widgetId) {
			var mdl = self.statsModelMap.get(widgetId);
			return mdl && mdl.measures && mdl.measures.size > 0;
		},


		/**
   * @return the number of widgets in this compare card that currently have data to show.
   */
		get numberOfWidgetsWithData() {
			var widgetsWithDataCount = 0;
			if (self.statsUpdated) {
				self.widgetIds.forEach(function (widgetId) {
					widgetsWithDataCount += self.widgetHasData(widgetId) ? 1 : 0;
				});
			}
			return widgetsWithDataCount;
		},

		/**
   * The compareline is enabled when at least one widget supports a compare line
   * AND that widget has data.  Note: The compare line is also known as crosshairs.
   * Update the model based on the rules.
   */
		get compareLineEnabled() {
			if (self.statsUpdated) {
				return self.getWidgetContentApis().some(function (widgetContentApi) {
					var crosshairsFeature = widgetContentApi.getFeature('WidgetAPI.deprecated').getFeature('vis-crosshairs');
					if (crosshairsFeature && crosshairsFeature.isSupported()) {
						return self.widgetHasData(widgetContentApi.getId());
					}
				});
			}
			return false;
		},

		/**
   * @return true if the compare line should be enabled
   */
		isCompareLineEnabled: function isCompareLineEnabled() {
			return self.compareLineEnabled;
		},


		/**
   * @return true if the compare table should be enabled (ie: 1 widget has data)
   */
		isCompareTableEnabled: function isCompareTableEnabled() {
			return self.numberOfWidgetsWithData > 0;
		},


		/**
   * @return true if the sync menu should be enabled (ie: 2 widgets have data)
   */
		isSyncMenuEnabled: function isSyncMenuEnabled() {
			return self.numberOfWidgetsWithData > 1;
		},
		isScaleSynced: function isScaleSynced() {
			return self.matchScale;
		},
		isCompareLineSynced: function isCompareLineSynced() {
			return self.syncCompareLine;
		},
		isActionsSynced: function isActionsSynced() {
			return self.syncActions;
		},
		isCompareLineShown: function isCompareLineShown() {
			return self.showCompareLine;
		},


		//@TODO Story 271817
		isRelativeTime: function isRelativeTime() {
			return false;
		},
		getWidgetSubLabel: function getWidgetSubLabel(widgetId) {
			var filterInfo = self.widgetFilterInfo[widgetId];
			if (filterInfo) {
				var subLabel = [];
				filterInfo.forEach(function (item) {
					var itemStr = self.theStringResources.get('compareChartSubLabel', { title: item.title, description: item.description });
					subLabel.push(itemStr);
				});
				return subLabel.join(' , ');
			}
			return undefined;
		},


		/**
   * determines the sync match scale's button should be on or off by default
   * on if same measure and same aggregation or it is relative time
   * @param {object} domains - a map of domains
   * @param {object} widgetApi - widget api of the source widget
   * @returns {boolean}
   */
		getDefaultMatchScaleOption: function getDefaultMatchScaleOption(domains, widgetContentApi) {
			return self.theMatchScaleProcessor.shouldMatchingScaleByDefault(domains, widgetContentApi, self.widgetIds) || self.isRelativeTime();
		},


		/**
   * @returns if the matching scale is allowed (enable or disabled state for sync axis button UI)
   */
		get isMatchScaleEnabled() {
			return self.theMatchScaleProcessor.allowMatchingScale(self.domain, self.widgetIds);
		}
	};
}).actions(function (self) {
	return {
		afterCreate: function afterCreate() {
			self.refChecker = new _RefChecker2.default(self);
			self.synchActionProcessor = new _SynchActionProcessor2.default(self, self.refChecker);
			self.compareTableSummary = _CompareTableSummary2.default.create({ applicableCalcs: undefined, charts: undefined }, { isFeatureEnabled: (0, _mobxStateTree.getEnv)(self).isFeatureEnabled });
			self.compareTableSummary.setWidgetMeasureNameMap(self.widgetMeasureNameMap);
			self.compareTableSelectionSummary = _CompareTableSummary2.default.create({ applicableCalcs: undefined, charts: undefined }, { isFeatureEnabled: (0, _mobxStateTree.getEnv)(self).isFeatureEnabled });
			self.compareTableSelectionSummary.setWidgetMeasureNameMap(self.widgetMeasureNameMap);

			self.widgetFilterInfo = {};

			self.syncWidgetSelectionsDisposer = null;

			self._api = new _CompareCardAPI2.default(self);
		},
		setStatsProcessor: function setStatsProcessor(processor) {
			self.theStatsProcessor = processor;
		},
		setStringResources: function setStringResources(resources) {
			self.theStringResources = resources;
		},
		setShowCompareLine: function setShowCompareLine(flag) {
			self.matchingPoints.clear();
			self.showCompareLine = flag;
		},
		setShowStats: function setShowStats(flag) {
			self.showStats = flag;
		},
		setCompareLineSynced: function setCompareLineSynced(value) {
			self.syncCompareLine = value;
		},
		setScaleSynced: function setScaleSynced(value, isToggledBySyncAxisButton) {
			self.matchScale = value;
			self.isToggledBySyncAxisButton = isToggledBySyncAxisButton;
		},
		setActionsSynced: function setActionsSynced(value) {
			if (value) {
				self.synchActionProcessor.enable();
			} else {
				self.synchActionProcessor.disable();
			}
			self.syncActions = value;
		},
		setWidgetSelectionsSyncUpdated: function setWidgetSelectionsSyncUpdated() {
			//force a change of the value of this flag so that the isWidgetSelectionsSynced calculation will be performed.
			self.syncWidgetSelectionsUpdated = self.syncWidgetSelectionsUpdated + 1;
		},
		setEventGroups: function setEventGroups(eventGroups) {
			self.eventGroups = eventGroups;
		},


		/**
   * This action is called by the synch selections toggle (see exploreCompareOptions toolbar)
   * @param synchronizeState (bool) - false = split widgets into separate event groups...selections will not be synchronized.
   * 																	true - combine the widgets into one group (synchronizeState=true).
   * Once the event groups have been modified,
   * it calls setWidgetSelectionsSyncUpdated to ensure isWidgetSelectionSynced is recalculated
   * and the toggle for the compare option react control is updated immediately.
   * @returns a Promise which is resolved when event groups have been modified.
  */
		updateWidgetSelectionsSynced: function updateWidgetSelectionsSynced(synchronizeState) {
			if (synchronizeState === false || !self.syncWidgetSelectionsDisposer) {
				var widgetIds = self.widgetIds;
				var disconnect = function disconnect() {
					self.syncWidgetSelectionsDisposer = disconnectWidgetsFromGroup(self.dashboardApi, widgetIds);

					if (synchronizeState && self.syncWidgetSelectionsDisposer) {
						//If sync was off initially, the widgets are in different event groups.
						//disconnect them (to remove them from the multiple groups), then call connect to put them into the same group (group 1)
						self.syncWidgetSelectionsDisposer();
						self.syncWidgetSelectionsDisposer = null;
					}

					self.setWidgetSelectionsSyncUpdated();
					//The widgets may or may not have changed as a result of changing event groups.
					//
					self.getWidgetContentApis().forEach(function (widgetContentApi) {
						return widgetContentApi.getFeature('WidgetAPI.deprecated').render();
					});
					return {};
				};
				return disconnect();
			} else {
				if (self.syncWidgetSelectionsDisposer) {
					self.syncWidgetSelectionsDisposer();
					self.syncWidgetSelectionsDisposer = null;
					self.setWidgetSelectionsSyncUpdated();
					//The widgets may or may not have changed as a result of changing event groups.
					self.getWidgetContentApis().forEach(function (widgetContentApi) {
						return widgetContentApi.getFeature('WidgetAPI.deprecated').render();
					});
				}
				return Promise.resolve({});
			}
		},
		updateSyncAxisScale: function updateSyncAxisScale(value, isMatchScaleForcedByUser) {
			self.setScaleSynced(value, isMatchScaleForcedByUser);
			var taskCompletePromises = [];
			self.widgetIds.forEach(function (id) {
				return taskCompletePromises.push(self.taskComplete(id));
			}); // re-render
			return Promise.all(taskCompletePromises);
		},
		toggleShowCompareLine: function toggleShowCompareLine() {
			var oldValue = self.isCompareLineShown();
			self.setShowCompareLine(!oldValue);
			self.getWidgetContentApis().forEach(function (widgetContentApi) {
				var crosshairsFeature = widgetContentApi.getFeature('WidgetAPI.deprecated').getFeature('vis-crosshairs');
				if (crosshairsFeature) {
					if (oldValue) {
						crosshairsFeature.deactivate();
					} else {
						var widgetContentId = widgetContentApi.getId();
						self._activateCrosshairs(widgetContentId);
						if (crosshairsFeature.isSupported()) {
							crosshairsFeature.renderCrosshairs();
							// calling renderCrosshairs rendered compare line into the position which value is `crosshairsFeature.getOptimalLineValue()`
							// so, after rendering compare line into the position, we render the popover which shows the matching points of this position
							self._setupPopover(crosshairsFeature, widgetContentId, crosshairsFeature.getOptimalLineValue());
						}
					}
				}
			});
		},
		toggleShowCompareTable: function toggleShowCompareTable() {
			self.showCompareTable = !self.showCompareTable;
		},
		addStatsModels: function addStatsModels(widgetId, initialModel, initialSelModel, measureLabel) {
			var widgetAlias = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

			var env = {
				measureLabel: measureLabel,
				showStats: function showStats() {
					return self.showStats;
				},
				matchScale: function matchScale() {
					return self.matchScale;
				}
			};

			if (!(self.widgetIds.indexOf(widgetId) !== -1)) {
				self.widgetIds.push(widgetId);
			}
			self.widgetAliasMap[widgetId] = widgetAlias;
			var initModel = {
				header: initialModel.header,
				_env: env
			};
			var initSelModel = {
				header: initialSelModel.header,
				_env: env
			};
			self.statsModelMap.set(widgetId, _StatsModel2.default.create(initModel));
			self.selStatsModelMap.set(widgetId, _StatsModel.SelectionStatsModel.create(initSelModel));
		},


		/**
   * initialize 'synchronization' for a widget which is part of a compare card.
   * When enabled from the menu, this widget will have synchronized crosshairs and synchronized actions(sort, topN, format)
   * @param widgetApi - The widgetApi for a widget in this comparison.
   */
		initializeSynch: function initializeSynch(widgetContentApi) {
			var widgetId = widgetContentApi.getId();
			//Synchronized actions
			self.synchActionProcessor.initialize(widgetContentApi);

			//Synchronized crosshairsFeature
			self._activateCrosshairs(widgetId);
		},
		initializeWidgetSelectionsSynced: function initializeWidgetSelectionsSynced(eventGroups) {
			//This method is called whenever a new widgetAPI is added to the comparison.
			//Mark the widgetSelectionsSyncUpdated flag so that we recalculate (isWidgetSelectionsSynced)
			//which notifies the syncSelections toggle of the new comparison structure.
			self.setEventGroups(eventGroups);
			self.setWidgetSelectionsSyncUpdated();
		},
		initializeWidgetApis: function initializeWidgetApis(widgetContentApi) {
			var widgetId = widgetContentApi.getId();
			if (!(self.widgetIds.indexOf(widgetId) !== -1)) {
				self.widgetIds.push(widgetId);
			}
			self.widgetContentApisMap[widgetId] = widgetContentApi;
		},
		beforeDestroy: function beforeDestroy() {
			self.refChecker.remove();

			//If synchronized actions were initialized, make sure to cleanup the event handlers.
			self.synchActionProcessor.destroy();
			self._mobxDisposeEvents.forEach(function (dispose) {
				return dispose();
			});

			self.compareTableSummary && (0, _mobxStateTree.destroy)(self.compareTableSummary);
			self.compareTableSelectionSummary && (0, _mobxStateTree.destroy)(self.compareTableSelectionSummary);
		},


		/**
   * setup callbacks into widgets to get the stats
   * @param {string} widgetId
   * @param {Object} svc The host application service
   */
		setupStatsModels: function setupStatsModels(widgetId, summarizerFeature) {
			self.widgetId = widgetId;
			if (summarizerFeature && summarizerFeature.activate) {
				summarizerFeature.activate({
					cb: self.updateData.bind(self, self.refChecker, widgetId),
					cbSel: self.updateSelectionData.bind(self, self.refChecker, widgetId),
					cbDomain: self.updateDomain.bind(self, self.refChecker, widgetId),
					cbDeactivate: self.cleanData.bind(self, self.refChecker, widgetId)
				});
			}
		},


		/**
   * If the crosshairs feature is enabled, setup callbacks into widgets needed when synchronizing crosshairs.
   * @param {string} widgetId - the widgetId to activateCrosshairs for.
   */
		_activateCrosshairs: function _activateCrosshairs(widgetId) {
			var matchingWidgetContentApi = self.widgetContentApisMap[widgetId];
			var crosshairsFeature = matchingWidgetContentApi && matchingWidgetContentApi.getFeature('WidgetAPI.deprecated').getFeature('vis-crosshairs');
			crosshairsFeature && crosshairsFeature.activate({
				cbOnMoveCrosshairs: self.onMoveCrosshairs.bind(self, self.refChecker, widgetId)
			});
		},


		/**
   * Track when a widget has moved its crosshairs and synchronize that move to other widgets in the comparison.
   * @param refChecker - RefChecker
   * @param sourceWidgetId - the sourceWidget...crosshairs need to be synched on other widgets only.
   * @param data - where to move the crosshairs too.
   */
		onMoveCrosshairs: function onMoveCrosshairs(refChecker, sourceWidgetId, data) {
			if (!refChecker.isValid(self)) {
				return;
			}
			//TODO: For now, we're on and synched (ie: default for compare)
			//When menu toggles for synchronize are available, this function can be modified.
			//(ie: only synch when synchCrosshairs is on)
			var widgetID = void 0;
			self.getWidgetContentApis().forEach(function (widgetContentApi) {
				widgetID = widgetContentApi.getId();
				var crosshairsFeature = widgetContentApi.getFeature('WidgetAPI.deprecated').getFeature('vis-crosshairs');
				if (widgetID !== sourceWidgetId) {
					//NOTE: When a feature is disabled, getFeature should not return it.....we may be able to remove the enabled check.
					if (crosshairsFeature && crosshairsFeature.isActivated() && self.isCompareLineSynced()) {
						crosshairsFeature.renderCrosshairs(data.value);
					}
				}
				//if isCompareLineSynced() returns false then we render the popover only for the source widget
				//if isCompareLineSynced() returns true then we render the popover for both the compare cards
				if (self.isNewCompareLineFeatureEnabled()) {
					var shouldSetupPopOver = self.isCompareLineSynced() ? true : sourceWidgetId === widgetID;
					if (shouldSetupPopOver && crosshairsFeature) {
						self._setupPopover(crosshairsFeature, widgetID, data.value);
					}
				}
			});
			return;
		},


		/**
   * Sets up the base for creating a popover by
   * Setting the matching points when the compare line is moved and
   * Setting a reference to the function to create the popover
   */
		_setupPopover: function _setupPopover(crosshairsFeature, widgetContentID, value) {
			self.matchingPoints.set(widgetContentID, crosshairsFeature.getCrossHairMatchingPoints(value));
			if (!self.renderCrosshairPopOver) {
				self.renderCrosshairPopOver = crosshairsFeature.renderPopOver;
			}
		},


		/**
   * updates default stats model on receiving stats from live widget
   * @param {object} refChecker
   * @param {string} widgetId
   * @param {object} data
   * @returns {Promise}
   */
		updateData: function updateData(refChecker, widgetId, data) {
			if (!refChecker.isValid(self)) {
				return;
			}
			var mdl = self.statsModelMap.get(widgetId);
			if (mdl) {
				mdl.updateData(data);
			}

			self.statsUpdated++;
			self._updateMatchingPoints(widgetId);

			self.compareTableSummary.computeSummaryInfo(self.statsModelMap, self.widgetAliasMap, self.widgetContentApisMap, widgetId);
			return self.populateWidgetFilterInfo(widgetId);
		},


		/**
   * computes and updates domain on receiving stats from live widget
   * @param {object} refChecker
   * @param {string} widgetId
   * @param {object} data
   * @returns {Promise}
   */
		updateDomain: function updateDomain(refChecker, widgetId, data) {
			var result = void 0;
			if (!refChecker.isValid(self)) {
				return;
			}
			var sourceWidgetContentApi = void 0;
			var isMatchScaleForcedByUser = self.isToggledBySyncAxisButton && self.matchScale;
			self.getWidgetContentApis().forEach(function (widgetContentApi) {
				if (widgetContentApi.getId() === widgetId) {
					sourceWidgetContentApi = widgetContentApi;
					result = self.theMatchScaleProcessor.getDomainAndNotifyWidgetId(data.measures, self.domain, widgetContentApi, self.widgetIds, isMatchScaleForcedByUser);
				}
			});
			/* once the user toggles the sync axis button, the choice is respected within the session */
			if (self.isToggledBySyncAxisButton) {
				if (self.matchScale) {
					self.domain = result.domain;
					return self.taskComplete(result.notifyWidgetId, widgetId /*sourceWidgetId*/);
				} else {
					return Promise.resolve(true);
				}
			} else {
				/**
     * Before the user manually toggles the sync axis button, the sync axis scale button is
    		- on: if there is a same measure with same aggregation in the same slot
    		- off: if there is no same measure with same aggregation and matching axis scale does not make sense
     */
				var defaultOption = self.getDefaultMatchScaleOption(result.domain, sourceWidgetContentApi);
				if (defaultOption === false) {
					self.setScaleSynced(false, false /*isToggledBySyncAxisButton*/);
					if (result.notifyWidgetId) {
						return self.taskComplete(result.notifyWidgetId, widgetId /*sourceWidgetId*/);
					}
					return Promise.resolve(true);
				}
				self.setScaleSynced(true, false /*isToggledBySyncAxisButton*/);
				self.domain = result.domain;

				return self.taskComplete(result.notifyWidgetId, widgetId /*sourceWidgetId*/);
			}
		},


		/**
   * Called when the vis-summarizer is deactivated, clean data related to widgetId
   * @param {object} refChecker
   * @param {string} widgetId the widgetId being removed
   */
		cleanData: function cleanData(refChecker, widgetId) {
			if (!refChecker.isValid(self)) {
				return;
			}
			var widgetContentApi = self.widgetContentApisMap[widgetId];

			//--Remove widgetId from widgetIds, widgetContentApisMap, widgetAliasMap and widgetMeasureNameMap
			var indexofWidget = self.widgetIds.indexOf(widgetId);
			if (~indexofWidget) {
				self.widgetIds.splice(indexofWidget, 1);
			}
			delete self.widgetAliasMap[widgetId];
			delete self.widgetContentApisMap[widgetId];
			delete self.widgetMeasureNameMap[widgetId];

			//--Remove widgetId from statsModelMap
			self.statsModelMap.delete(widgetId);
			self.compareTableSummary.computeSummaryInfo(self.statsModelMap, self.widgetAliasMap, self.widgetContentApisMap, widgetId);
			self.statsUpdated++;

			//--Remove widgetId from widgetFilterInfo
			delete self.widgetFilterInfo[widgetId];
			self.incrWidgetUpdatedCount();

			//--Update domain
			if (self.matchScale) {
				var result = self.theMatchScaleProcessor.getDomainAndNotifyWidgetId({}, self.domain, widgetContentApi, self.widgetIds);
				self.domain = result.domain;
				if (result.notifyWidgetId) {
					var otherWidgetContentApi = self.widgetContentApisMap[result.notifyWidgetId];
					var otherWidgetApi = otherWidgetContentApi.getFeature('WidgetAPI.deprecated');
					if (otherWidgetApi && otherWidgetApi.getVisApi) {
						var otherWidgetVisApi = otherWidgetApi.getVisApi();
						otherWidgetVisApi && otherWidgetVisApi.reRender();
					}
				}
			}
			//Remove widgetId from domain
			if (self.domain) {
				delete self.domain[widgetId];
			}

			//--Remove widgetId from selStatsModelMap
			self.selStatsModelMap.delete(widgetId);
			self.compareTableSelectionSummary.computeSummaryInfo(self.selStatsModelMap, self.widgetAliasMap, self.widgetContentApisMap, widgetId, 'selections');
			self.selectionUpdated++;
		},


		/**
   * two widgets update data in compare stats model which can be synchronous
   * we first check if the domain is fulfilled (i.e. the domain was updated by both widgets)
   * 		-> if so, resolve the promise immediately with the domain
   * 		-> if no, waits for 1 second and hopefully both stats have been updated in stats model then callback to stats feature which will re-render the other widget
   * @param {string} notifyWidgetId
   * @param {string} [sourceWidgetId] Optional - the source widget id
   * @returns {Promise} resolved with the computed domain
   */
		taskComplete: function taskComplete(notifyWidgetId) {
			var sourceWidgetId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			var delay = 1000;
			var promise = new Promise(function (resolve) {
				/* no need to go through the rest of function if no domain is set, the domain is undefined in this case */
				if (!self.domain) {
					resolve(self.domain);
					return;
				}

				var isDomainFullFilled = self.domain && Object.keys(self.domain).length > 1;
				if (!isDomainFullFilled) {
					if (self.delayingFastestRender) {
						self.delayingFastestRender = null;
						self._reRenderWidget(notifyWidgetId, resolve);
					} else {
						self.delayingFastestRender = setTimeout(function () {
							self._reRenderWidget(notifyWidgetId, resolve);
							/* if resize happens before setData task completes, resize can make the render sequence stale
       as a workaround, we are resizing the source widget before the resize is a render sequence task
       see defect */
							if (sourceWidgetId && self.widgetContentApisMap[sourceWidgetId]) {
								self.widgetContentApisMap[sourceWidgetId].getFeature('WidgetAPI.deprecated').render({ resize: true });
							}
						}, delay);
					}
				} else {
					if (notifyWidgetId) {
						self._reRenderWidget(notifyWidgetId, resolve);
					} else {
						resolve(self.domain);
					}
				}
			});
			return promise;
		},


		/**
   * updates selection stats model on receiving stats from live widget
   */
		updateSelectionData: function updateSelectionData(refChecker, widgetId, data) {
			if (!refChecker.isValid(self)) {
				return;
			}
			var mdl = self.selStatsModelMap.get(widgetId);
			mdl.updateData(data);
			self.selectionUpdated++;
			self.compareTableSelectionSummary.computeSummaryInfo(self.selStatsModelMap, self.widgetAliasMap, self.widgetContentApisMap, widgetId, 'selections');
		},


		setDashboardApi: function setDashboardApi(dashboardApi) {
			self.dashboardApi = dashboardApi;
		},

		_reRenderWidget: function _reRenderWidget(widgetId, resolve) {
			resolve(self.domain);

			if (widgetId) {
				return self.dashboardApi.getCanvasWhenReady().then(function (canvas) {
					return canvas.getWidgetWhenReady(widgetId);
				}).then(function (widgetApi) {
					if (widgetApi) {
						// call a render only after the widget has completed the current render sequence
						return widgetApi.whenRenderComplete().then(function () {
							return widgetApi.render();
						});
					} else {
						return true;
					}
				});
			}
			return Promise.resolve(true);
		},

		/**
   * update matching points with the latest matching points from crosshair feature
   * @param {String} widgetId - the id of the widget
   */
		_updateMatchingPoints: function _updateMatchingPoints(widgetContentId) {
			var widgetContentApi = self.widgetContentApisMap[widgetContentId];
			if (widgetContentApi && widgetContentApi.getFeature) {
				var widgetApi = widgetContentApi.getFeature('WidgetAPI.deprecated');
				if (widgetApi) {
					var crosshairsFeature = widgetApi.getFeature('vis-crosshairs');
					if (crosshairsFeature && crosshairsFeature.isSupported() && crosshairsFeature.isActivated()) {
						self._setupPopover(crosshairsFeature, widgetContentId, crosshairsFeature.getOptimalLineValue());
					}
				}
			}
		},

		populateWidgetFilterInfo: function populateWidgetFilterInfo(widgetContentId) {
			var widgetContent = self.widgetContentApisMap[widgetContentId];
			var widgetApi = widgetContent && widgetContent.getFeature('WidgetAPI.deprecated');
			if (widgetApi && widgetApi.whenRenderComplete) {
				return widgetApi.whenRenderComplete().then(function () {
					var visApi = widgetApi.getVisApi();
					var filterInfo = visApi.getLocalFilterAndTopBottomInfo();
					self.setWidgetFilterInfo(widgetContentId, filterInfo);
					self.incrWidgetUpdatedCount();
					return filterInfo;
				});
			} else {
				return Promise.resolve([]);
			}
		},
		setWidgetFilterInfo: function setWidgetFilterInfo(widgetId, filterInfo) {
			self.widgetFilterInfo[widgetId] = filterInfo;
		},
		incrWidgetUpdatedCount: function incrWidgetUpdatedCount() {
			self.widgetUpdatedCount++;
		}
	};
});

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.SelectionStatsModel = undefined;

var _mobxStateTree = __webpack_require__(7);

var HeaderItem = _mobxStateTree.types.model({
	id: _mobxStateTree.types.string,
	name: ''
}); /*
     *+------------------------------------------------------------------------+
     *| Licensed Materials - Property of IBM
     *| IBM Cognos Products: Explore
     *| (C) Copyright IBM Corp. 2018, 2019
     *|
     *| US Government Users Restricted Rights - Use, duplication or disclosure
     *| restricted by GSA ADP Schedule Contract with IBM Corp.
     *+------------------------------------------------------------------------+
     */


var DefaultStatValues = _mobxStateTree.types.map(_mobxStateTree.types.frozen());

/**
* Class representing model for live widget stats
*
* Essentially, the structure of the data being held is:
*  {
*	header:[ 									--> describes the header to use when displaying stats
*		{ id: 'min', name: 'Min' },				--> each statistic has an id and a display name
*		{ id: 'max', name: 'Max' },
*		{ id: 'avg', name: 'Average' },
*		{ id: 'total', name: 'Total' },
*		{ id: 'totalPercent', name: '%Total' }
*	],
*	measures: {
*		measure: {								--> for each measure, provide the stats
*			min: '',							--> for each stat id, provide the value
*			max: '',
*			avg: '',
*			total: '',
*			totalPercent: ''
*		}
*	}
*}
*/
var StatsModel = _mobxStateTree.types.model({
	header: _mobxStateTree.types.union(_mobxStateTree.types.array(HeaderItem), _mobxStateTree.types.undefined),
	measures: _mobxStateTree.types.union(_mobxStateTree.types.map(DefaultStatValues), _mobxStateTree.types.undefined),
	_env: _mobxStateTree.types.frozen() //workaround - can't use env which is different from parent's env
}).views(function (self) {
	return {
		get headers() {
			var headers = [self.measureLabel];
			var itemHeaders = self.header || [];
			itemHeaders.forEach(function (entry) {
				headers.push(entry.name);
			});
			return headers;
		},

		/**
      * return stats in a format that makes it easy to render
      */
		get orderedValues() {
			var values = [];
			var itemHeaders = self.header || [];
			var itemValuesMap = self.measures;

			//compute stats rows
			itemValuesMap.forEach(function (measureDetail /*, measureName*/) {
				var row = [];
				var meta = measureDetail.get('metadata') || {};
				row.push(meta.label); //first column is measure name, rest are the values
				itemHeaders.forEach(function (header) {
					var statId = header.id;
					if (statId !== 'metadata' && statId !== 'totalPercent') {
						var val = measureDetail.get(statId);
						if (typeof val === 'string' || val instanceof String) {
							row.push(val || '-');
						} else {
							row.push(Math.round(val) || '-');
						}
					}
					if (statId === 'totalPercent' && measureDetail.get('totalUse') && measureDetail.get('summaryValueUse')) {
						var totalPercent = Math.round(measureDetail.get('totalUse') / measureDetail.get('summaryValueUse') * 100);
						row.push(totalPercent);
					} else if (statId === 'totalPercent') {
						row.push('-');
					}
				});
				values.push({ row: row });
			});
			return values;
		}
	};
}).volatile(function () {
	return {
		widgetId: 0,
		showStats: function showStats() {
			return true;
		},
		statsModelUpdateCount: 0,
		newCompareTableStatsEnabled: false
	};
}).actions(function (self) {
	return {
		afterCreate: function afterCreate() {
			self.measureLabel = self._env && self._env.measureLabel || '';
			self.showStats = self._env && self._env.showStats || self.showStats;
			self.newCompareTableStatsEnabled = self._env && self._env.newCompareTableStatsEnabled;
		},
		updateData: function updateData(data) {
			if (data && data.header && data.measures) {
				self.header = data.header;
				self.measures = data.measures;
				self.lastCategorySelection = data.lastCategorySelection;
			}
		}
	};
});

exports.default = StatsModel;


var SelectionValues = _mobxStateTree.types.model({
	values: _mobxStateTree.types.array(_mobxStateTree.types.maybeNull(_mobxStateTree.types.number)),
	metadata: _mobxStateTree.types.union(_mobxStateTree.types.frozen(), _mobxStateTree.types.undefined),
	//detailRowCount > 0 should be checked to determine if weightedAvg is valid.
	detailRowCountUse: _mobxStateTree.types.optional(_mobxStateTree.types.number, 0),
	detailSumUse: _mobxStateTree.types.optional(_mobxStateTree.types.number, 0),
	filteredSummaryValue: _mobxStateTree.types.optional(_mobxStateTree.types.string, '-'),
	filteredSummaryValueUse: _mobxStateTree.types.maybeNull(_mobxStateTree.types.number),
	weightedAvgUse: _mobxStateTree.types.optional(_mobxStateTree.types.number, 0)
});

var LastCategorySelection = _mobxStateTree.types.array(_mobxStateTree.types.union(_mobxStateTree.types.string, _mobxStateTree.types.number, _mobxStateTree.types.null));

var SelectionStatsModel = exports.SelectionStatsModel = StatsModel.named('SelectionStatsModel').props({
	measures: _mobxStateTree.types.union(_mobxStateTree.types.map(SelectionValues), _mobxStateTree.types.undefined),
	lastCategorySelection: _mobxStateTree.types.union(LastCategorySelection, _mobxStateTree.types.undefined)
}).actions(function (self) {
	return {
		updateData: function updateData(data) {
			self.header = data.header;
			self.measures = data.measures;
			self.lastCategorySelection = data.lastCategorySelection;
		}
	};
});

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_182__;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ArrayOperations = __webpack_require__(25);

/**
 * computes the domain from the measures in stats and set notify widget id if needed
 * @param {Object} measures - measures from stats data
 * @param {Object} existingDomain - cached domain from compared model
 * eg. existing domain - note dataMax and ScaleMax can be different. Same with dataMin and ScaleMin
 * {
 *      widgetId1: {
 *          Quantityavg: {
 *		 		dataMax: xx,
 *              dataMin: xx,
 *		 	    (Scale) max: xx,
 *              (Scale) min: xx
 *		  	},
 *          UnitCostsum: {
 *              dataMax: xx,
 *		 	    dataMin: xx,
 *		 	    (Scale) max: xx,
 *              (Scale) min: xx
 *          }
 *      }
 * }
 * @param {String} widgetApi - the widget api
 * @param {Array<String>} widgetIds - the list of widget ids in compare model
 * @param {boolean} isForcedByUser - a flag to indicate if the matching scale operation is forced by user
 * @returns {Object} result
 * eg.{ notifyWidgetId: xx,
 *		domain: {
 *			widgetId1: {
 *			{
 *					Quantityavg: {
 *		 				dataMax: xx,
 *		 				dataMin: xx,
 *						(Scale) max: xx,
 *						(Scale) min: xx
 *					}, {
 *					UnitCostsum: {
 *						dataMax: xx,
 *						dataMin: xx,
 *						(Scale) max: xx,
 *						(Scale) min: xx
 * 					}
 *		  		 }
 *           },
 *			widgetId2: {
 *			{
 *					Quantityavg: {
 *		 				dataMax: xx,
 *		 				dataMin: xx,
 *						(Scale) max: xx,
 *						(Scale) min: xx
 *					}, {
 *					Marginsum: {
 *						dataMax: xx,
 *						dataMin: xx,
 *						(Scale) max: xx,
 *						(Scale) min: xx
 * 					}
 *		  		 }
 *           }
 *			}
 */
function getDomainAndNotifyWidgetId(measures, existingDomain, widgetContentApi, widgetIds, isForcedByUser) {
	var widgetContentId = widgetContentApi && widgetContentApi.getId();
	var otherWidgetId = _findTargetWidgetId(widgetContentId, widgetIds);
	/* first check matching scale eligibility at widgets level -> then we check matching scale eligibility at slot level
 eg. bar chart - we should match scale for all of the measures if applies; 
 tree map - we should not match scale unless same data items are used in heat slots are filled for both widgets
 */
	var isWidgetEligible = _isWidgetEligibleForMatchingScale(widgetContentApi);
	if (isWidgetEligible) {
		return _computeDomainAndNotifyWidgetId(measures, existingDomain, widgetContentApi, otherWidgetId, undefined /**dataItemItemIds */, isForcedByUser);
	} else {
		var dataItemItemIds = _findDataItemsInEligibleSlotsForMatchingScale(widgetContentApi);
		if (dataItemItemIds.length) {
			return _computeDomainAndNotifyWidgetId(measures, existingDomain, widgetContentApi, otherWidgetId, dataItemItemIds, isForcedByUser);
		} else {
			return _cleanUpUnprojectedDataItemsFromDomain(measures, existingDomain, widgetContentId, otherWidgetId, undefined /*notifyWidgetId*/, widgetContentApi);
		}
	}
}

/**
 * get the target widget id from the source widget id and the ids array
 * @param {String} sourceWidgetId - the source widget id
 * @param {Array<String>} widgetIds - the array of the widget ids
 * @returns {String} the id of target widget id
 */
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
function _findTargetWidgetId(sourceWidgetId, widgetIds) {
	return widgetIds.find(function (widgetId) {
		return widgetId !== sourceWidgetId;
	});
}

/**
 * determine if we should compute scale
 * a) If two visualizations have the same measure projected, ensure that the axis scales only synchronize if the measure is in the same slot.
 * b) If the other visualization is composite chart and the current slotId is values
 * @param {Object} targetDomain - the domain of the other widget
 *	eg. 
 * 	{targetWidgetId: {
 *		Quantityavg: {
 *		 	dataMax: xx,
 *		 	dataMin: xx,
 *			(Scale) max: xx,
 *			(Scale) min: xx
 *			}, {
 *			UnitCostsum: {
 *				dataMax: xx,
 *				dataMin: xx,
 *				(Scale) max: xx,
 *				(Scale) min: xx
 * 			}
 * }}
 * @param {String} itemKey - the item key of from the column in the source widget. ItemKey is item id plus aggregation type plus layerId. eg. 'revenueSumData'
 * @param {String} itemSlotId - the item slot id from the column in the source widget
 * @returns {Boolean} true if we should compute scale
 */
function _shouldComputeScaleFromSlotId(targetDomain, itemKey, itemSlotId) {
	var shouldComputeScale = false;
	// the same measure exists in the target widget
	if (targetDomain && targetDomain[itemKey]) {
		var matchToComboChart = targetDomain[itemKey].isCompositeChart && itemSlotId === 'values';
		var matchToSameMeasureSameSlotId = targetDomain[itemKey].slotId && targetDomain[itemKey].slotId === itemSlotId;
		shouldComputeScale = matchToComboChart || matchToSameMeasureSameSlotId;
	}
	return shouldComputeScale;
}
/**
 * returns true as long as there exists a measure in the same slot id
 * @param {String} slotId - the desired slot id
 * @param {Object} domain - the domain of a widget to be examined
 */
function _existsMeasuresInSameSlot(slotId, domain) {
	var existsMeasuresInSameSlot = false;
	if (domain) {
		existsMeasuresInSameSlot = Object.keys(domain).some(function (itemKey) {
			return domain[itemKey].slotId === slotId;
		});
	}
	return existsMeasuresInSameSlot;
}

function _isWidgetEligibleForMatchingScale(widgetContentApi) {
	var visualization = widgetContentApi.getFeature('Visualization');
	return visualization.getDefinition().getProperty('supportsMaintainAxisScale');
}

function _findDataItemsInEligibleSlotsForMatchingScale(widgetContentApi) {
	var slots = widgetContentApi.getFeature('Visualization').getSlots().getMappedSlotList();
	var dataItems = void 0;
	var dataItemItemIds = [];
	if (slots && slots.length) {
		slots.forEach(function (slotApi) {
			if (slotApi.getDefinition().getProperty('supportsMaintainAxisScale')) {
				dataItems = slotApi.getDataItemList();
			}
		});
	}
	if (dataItems) {
		dataItems.forEach(function (dataItem) {
			dataItemItemIds.push(dataItem.getId());
		});
	}
	return dataItemItemIds;
}

/**
 * clean up unused data items from domain if any of them have been removed from the visualization or the aggregation has changed 
 * so there is no common data item with the same aggregation across two visualizations
 * 
 * @param {Object} measures - raw measures from data
 * @param {Object} domain - the computed domain it is as a set of ranges for each measure
 * eg. domain {revenue: { max: xx, min }, profit: { max: xx, min: xx } }
 * @param {String} widgetId - current widget id
 * @param {String} otherWidgetId - the other widget id in compare card
 * @param {String} notifyWidgetId - the widget id to be notified. It can be undefined
 * @returns {Object} {domain: domain, notifyWidgetId: notifyWidgetId}
 */
function _cleanUpUnprojectedDataItemsFromDomain(measures, domain, widgetId, otherWidgetId, notifyWidgetId, sourceWidgetContentApi) {
	if (measures && domain && domain[widgetId]) {
		Object.keys(domain[widgetId]).forEach(function (key) {
			var measureKey = domain[widgetId][key].measureKey;
			var doesMeasureExist = measures[measureKey];
			// slot id is different in measures (process data task) vs the domains because the slot was previously eligible for matching scale but is no longer eligible
			var hasSlotIdChanged = doesMeasureExist ? measures[measureKey].metadata.slotId !== domain[widgetId][key].slotId : false;
			if (!doesMeasureExist || hasSlotIdChanged) {
				delete domain[widgetId][key];
				// needs to re-render the other widget as its scale was based on this widget
				if (domain[otherWidgetId] && domain[otherWidgetId][key] && domain[otherWidgetId][key].max !== domain[otherWidgetId][key].dataMax && !notifyWidgetId) {
					notifyWidgetId = otherWidgetId;
				}
			}
		});
		// delete the domain from domains map if the widget is no longer eligible and no slot is eligible for matching axis
		var shouldDeleteWidgetDomain = !_isWidgetEligibleForMatchingScale(sourceWidgetContentApi) && _findDataItemsInEligibleSlotsForMatchingScale(sourceWidgetContentApi).length === 0;
		if (shouldDeleteWidgetDomain) {
			delete domain[widgetId];
		}
	}
	return {
		domain: domain,
		notifyWidgetId: notifyWidgetId
	};
}

function _computeDomainAndNotifyWidgetId(measures, existingDomain, widgetContentApi, otherWidgetId, dataItemItemIds, isForcedByUser) {
	var notifyWidgetId = void 0;
	var domain = existingDomain || {};
	var widgetId = widgetContentApi && widgetContentApi.getId();
	// When deleting cards Visualization feature is destroyed before the WidgetAPI.deprecated feature so this check is needed
	// The proper destroying feature sequence should be WidgetAPI.deprecated --> Visualization feature which is done in livewidget-cleanup branch
	var visualization = widgetContentApi && widgetContentApi.getFeature('Visualization');
	// composite chart is the only special case where a combined scale is computed
	var isCompositeChart = visualization && visualization.getType() === 'DualAxis';
	if (measures) {
		Object.keys(measures).forEach(function (key) {
			domain[widgetId] = domain[widgetId] || {};
			//For stacked charts only (area, stackedbar, stackedcolumn),
			//a stackedDomainMax and stackedDomainMin will be present which should be used for the domain.
			var itemDataMax = measures[key].stackedDomainMax === undefined ? measures[key].maxUse : measures[key].stackedDomainMax;
			var itemDataMin = measures[key].stackedDomainMin === undefined ? measures[key].minUse : measures[key].stackedDomainMin;

			// when unable to get data min and max values, don't include it as part of the domain
			// one possible scenario is that we don't have data in the chart
			if (itemDataMax === undefined && itemDataMin === undefined) {
				return;
			}

			var itemScaleMax = itemDataMax;
			var itemScaleMin = itemDataMin;

			// domain item key needs to match the format in vipr data: itemId + aggregationType
			var itemKey = measures[key].metadata.itemId + measures[key].metadata.aggregationType + measures[key].metadata.layerId;
			var itemSlotId = measures[key].metadata.slotId;
			var maxResult = { itemScaleMax: itemScaleMax, itemDataMax: itemDataMax };
			var minResult = { itemScaleMin: itemScaleMin, itemDataMin: itemDataMin };
			var columnMinMaxInfo = {
				itemScaleMax: itemScaleMax,
				itemDataMax: itemDataMax,
				itemScaleMin: itemScaleMin,
				itemDataMin: itemDataMin,
				itemKey: itemKey,
				itemSlotId: itemSlotId,
				isCompositeChart: isCompositeChart
			};
			if (isCompositeChart) {
				var overallDataMaxMin = _getMaxMinInCompositeChart(measures);
				columnMinMaxInfo.itemDataMax = overallDataMaxMin.dataMax;
				columnMinMaxInfo.itemDataMin = overallDataMaxMin.dataMin;

				columnMinMaxInfo.itemScaleMax = columnMinMaxInfo.itemDataMax;
				columnMinMaxInfo.itemScaleMin = columnMinMaxInfo.itemDataMin;

				if (domain[otherWidgetId] && domain[otherWidgetId][itemKey] || isForcedByUser) {
					maxResult = _computeDataMax(columnMinMaxInfo, domain, widgetContentApi, otherWidgetId, notifyWidgetId, isForcedByUser);
					notifyWidgetId = maxResult.notifyWidgetId;

					minResult = _computeDataMin(columnMinMaxInfo, domain, widgetContentApi, otherWidgetId, notifyWidgetId, isForcedByUser);
					notifyWidgetId = minResult.notifyWidgetId;
				} else {
					maxResult = { itemScaleMax: itemScaleMax, itemDataMax: itemDataMax };
					minResult = { itemScaleMin: itemScaleMin, itemDataMin: itemDataMin };
				}
			} else if (_shouldComputeScaleFromSlotId(domain[otherWidgetId], itemKey, itemSlotId) || _existsMeasuresInSameSlot(itemSlotId, domain[otherWidgetId])) {
				maxResult = _computeDataMax(columnMinMaxInfo, domain, widgetContentApi, otherWidgetId, notifyWidgetId, isForcedByUser);
				notifyWidgetId = maxResult.notifyWidgetId;

				minResult = _computeDataMin(columnMinMaxInfo, domain, widgetContentApi, otherWidgetId, notifyWidgetId, isForcedByUser);
				notifyWidgetId = minResult.notifyWidgetId;
			}

			if (!dataItemItemIds || dataItemItemIds.indexOf(measures[key].metadata.itemUniqueId) !== -1) {
				/**
     * (scale) max/min - The computed max and min to apply to the scales (axis, heat, size etc.)
     * dataMax/dataMin - raw maxUse and minUse returned in the JSON from the summarizer.
     * scaleMax can be bigger than dataMax and scaleMin can be smaller than dataMin
     * slotId - The slot id for the data item
     */
				domain[widgetId][itemKey] = {
					max: maxResult.itemScaleMax,
					min: minResult.itemScaleMin,
					dataMax: maxResult.itemDataMax,
					dataMin: minResult.itemDataMin,
					aggregate: measures[key].metadata.aggregationType, // needed by the new query api
					columnId: measures[key].metadata.itemId, // needed by the new query api
					slotId: itemSlotId,
					measureKey: key, // save the key from measure to help avoid O(n^2) lookup when cleaning up unprojected data items
					isCompositeChart: isCompositeChart, // save isCompositeChart flag for other visualizations to match scale
					layerId: measures[key].metadata.layerId // needed by the new query api. A min max query result will be added per layer
				};
			}
		});
	}
	return _cleanUpUnprojectedDataItemsFromDomain(measures, domain, widgetId, otherWidgetId, notifyWidgetId, widgetContentApi);
}

/**
 * gets the overall max and min from composite chart
 * eg. line and columns chart: line's range is [-100, 50], column's range is [-50, 150]
 * the returned overall max and min range is [-100, 150]
 * @param {object} measures - measures from stats data
 * @returns {object} result
 * eg. 
 * {
 * 	dataMax: 150,
 * 	dataMin: 100
 * }
 * 
 */
function _getMaxMinInCompositeChart(measures) {
	var maxOfMeasuresInCompositeChart = void 0;
	var minOfMeasuresInCompositeChart = void 0;

	measures && Object.keys(measures).forEach(function (key) {
		var measure = measures[key];
		maxOfMeasuresInCompositeChart = maxOfMeasuresInCompositeChart === undefined ? measure.maxUse : maxOfMeasuresInCompositeChart;
		maxOfMeasuresInCompositeChart = Math.max(maxOfMeasuresInCompositeChart, measure.maxUse);

		minOfMeasuresInCompositeChart = minOfMeasuresInCompositeChart === undefined ? measure.minUse : minOfMeasuresInCompositeChart;
		minOfMeasuresInCompositeChart = Math.min(minOfMeasuresInCompositeChart, measure.minUse);
	});
	return {
		dataMax: maxOfMeasuresInCompositeChart,
		dataMin: minOfMeasuresInCompositeChart
	};
}

/**
 * finds the max and min of the measures that assigned to the target slot
 * @param {Object} domain - target domain
 * @param {string} slotId - target slot id
 * @returns {object} - a map of {dataMax: xx, dataMin: xx, scaleMax: xx, scaleMin: xx}
 */
function _findMaxMinOfMeasuresAssignedToTargetSlot(domain, slotId) {
	var maxMinCrossMeasuresInOneWidget = {};
	// itemKey is item id plus aggregation type plus layerId for each measure. eg. 'revenueSumData'
	var domainsOfMeasuresAssignedToSlot = domain && Object.keys(domain).filter(function (itemKey) {
		return domain[itemKey].slotId === slotId || domain[itemKey].isCompositeChart;
	});
	domainsOfMeasuresAssignedToSlot && domainsOfMeasuresAssignedToSlot.forEach(function (itemKey) {
		if (domain[itemKey].slotId === slotId || domain[itemKey].isCompositeChart) {
			var dataMax = domain[itemKey].dataMax;
			var dataMin = domain[itemKey].dataMin;
			var scaleMax = domain[itemKey].max;
			var scaleMin = domain[itemKey].min;
			if (maxMinCrossMeasuresInOneWidget.dataMax !== undefined) {
				maxMinCrossMeasuresInOneWidget.dataMax = maxMinCrossMeasuresInOneWidget.dataMax > dataMax ? maxMinCrossMeasuresInOneWidget.dataMax : dataMax;
			} else {
				maxMinCrossMeasuresInOneWidget.dataMax = dataMax;
			}
			if (maxMinCrossMeasuresInOneWidget.scaleMax !== undefined) {
				maxMinCrossMeasuresInOneWidget.scaleMax = maxMinCrossMeasuresInOneWidget.scaleMax > scaleMax ? maxMinCrossMeasuresInOneWidget.scaleMax : scaleMax;
			} else {
				maxMinCrossMeasuresInOneWidget.scaleMax = scaleMax;
			}
			if (maxMinCrossMeasuresInOneWidget.dataMin !== undefined) {
				maxMinCrossMeasuresInOneWidget.dataMin = maxMinCrossMeasuresInOneWidget.dataMin < dataMin ? maxMinCrossMeasuresInOneWidget.dataMin : dataMin;
			} else {
				maxMinCrossMeasuresInOneWidget.dataMin = dataMin;
			}
			if (maxMinCrossMeasuresInOneWidget.scaleMin !== undefined) {
				maxMinCrossMeasuresInOneWidget.scaleMin = maxMinCrossMeasuresInOneWidget.scaleMin < scaleMin ? maxMinCrossMeasuresInOneWidget.scaleMin : scaleMin;
			} else {
				maxMinCrossMeasuresInOneWidget.scaleMin = scaleMin;
			}
		}
	});
	return maxMinCrossMeasuresInOneWidget;
}

function _computeDataMax(columnMinMaxInfo, domain, widgetContentApi, otherWidgetId, notifyWidgetId, isForcedByUser) {
	var itemScaleMax = columnMinMaxInfo.itemScaleMax,
	    itemSlotId = columnMinMaxInfo.itemSlotId;
	var itemDataMax = columnMinMaxInfo.itemDataMax,
	    itemKey = columnMinMaxInfo.itemKey,
	    isCompositeChart = columnMinMaxInfo.isCompositeChart;

	var otherItemDataMax = void 0;
	var otherItemScaleMax = void 0;
	var targetDomain = domain[otherWidgetId];
	var isSlotIdSame = itemSlotId && targetDomain && targetDomain[itemKey] && targetDomain[itemKey].slotId === itemSlotId;
	// the domain of other widget was set

	if (targetDomain && isForcedByUser) {
		// there is no common measure in the other widget
		// then find the data max and scale max from the other widget
		itemSlotId = isCompositeChart ? 'values' : itemSlotId;
		otherItemDataMax = _findMaxMinOfMeasuresAssignedToTargetSlot(targetDomain, itemSlotId).dataMax;
		otherItemScaleMax = _findMaxMinOfMeasuresAssignedToTargetSlot(targetDomain, itemSlotId).scaleMax;
	} else if (targetDomain && targetDomain[itemKey] && (isSlotIdSame || isCompositeChart)) {
		otherItemDataMax = targetDomain[itemKey].dataMax;
		otherItemScaleMax = targetDomain[itemKey].max;
	} else {
		// the domain of the other widget was not set yet
		return {
			itemScaleMax: itemScaleMax,
			itemDataMax: itemDataMax,
			notifyWidgetId: undefined
		};
	}

	var otherItemMaxOfDataAndScale = Math.max(otherItemDataMax, otherItemScaleMax);

	/* we do not need to notify the other widget if both max are negative and the visualization has zero origin property 
 	* eg. two bar charts which has zero origin property
 	* chart A's data range is from -100 to -20
 	* chart B's data range is from -100 to -30
 	* When A's max changes from -20 to -10, B should not be rendered as it is no visual effect on chart B */
	var areBothScalesMaxNegative = itemDataMax <= 0 && otherItemMaxOfDataAndScale <= 0;
	var notNotifyOtherWidgetDueToMaxChange = widgetContentApi.getFeature('WidgetAPI.deprecated').getVisApi().getPropertyById('valueAxis.zeroOrigin') && areBothScalesMaxNegative;

	/* 
 case 1 - itemDataMax > BOTH the otherItemDataMax AND otherItemScaleMax
 eg. This itemDataMax is now 120; otherItemScaleMax is 100 and the otherItemDataMax is 20
 the other widget needs to be notified and make its scale grow to 120
 	case 2 - itemDataMax is < otherItemMaxOfDataAndScale but > otherItemDataMax
 eg. This itemDataMax is 80; this otherItemScaleMax is 100 and the otherItemDataMax is 20
 the other widget needs to be notified and make its scale shrink to 80
 	case 3 - itemDataMax is less or equal than otherItemDataMax AND otherItemDataMax does not equal to otherItemMaxOfDataAndScale
 eg. itemDataMax is 10; otherItemScaleMax is 100 and otherItemDataMax is 80
 set this itemScaleMax to match otherItemDataMax; The other widget should be notified because the new scale max is 80
 	case 4 - itemDataMax is smaller than otherItemDataMax AND otherItemDataMax equals to otherItemMaxOfDataAndScale
 eg. itemDataMax is 10; otherItemScaleMax is 100 and otherItemDataMax is 100
 set this itemScaleMax to match otherItemDataMax; The other widget should not be notified as scale does not change
 */
	if (itemDataMax !== otherItemMaxOfDataAndScale) {
		if (itemDataMax > otherItemMaxOfDataAndScale) {
			notifyWidgetId = notNotifyOtherWidgetDueToMaxChange ? notifyWidgetId : otherWidgetId;
		} else if (itemDataMax > otherItemDataMax) {
			notifyWidgetId = notNotifyOtherWidgetDueToMaxChange ? notifyWidgetId : otherWidgetId;
		} else if (otherItemDataMax !== otherItemMaxOfDataAndScale) {
			notifyWidgetId = notNotifyOtherWidgetDueToMaxChange ? notifyWidgetId : otherWidgetId;
			itemScaleMax = otherItemDataMax;
		} else {
			itemScaleMax = otherItemDataMax;
		}
	}

	return {
		itemScaleMax: itemScaleMax,
		itemDataMax: itemDataMax,
		notifyWidgetId: notifyWidgetId
	};
}

function _computeDataMin(columnMinMaxInfo, domain, widgetContentApi, otherWidgetId, notifyWidgetId, isForcedByUser) {
	var itemScaleMin = columnMinMaxInfo.itemScaleMin,
	    itemSlotId = columnMinMaxInfo.itemSlotId;
	var itemDataMin = columnMinMaxInfo.itemDataMin,
	    itemKey = columnMinMaxInfo.itemKey,
	    isCompositeChart = columnMinMaxInfo.isCompositeChart;

	var otherItemDataMin = void 0;
	var otherItemScaleMin = void 0;
	var targetDomain = domain[otherWidgetId];
	var isSlotIdSame = itemSlotId && targetDomain && targetDomain[itemKey] && targetDomain[itemKey].slotId === itemSlotId;

	if (targetDomain && isForcedByUser) {
		// domain of other widget is not empty.
		// find the max/min from the same slot in the other widget's domain if the button is forced turning on by the user
		itemSlotId = isCompositeChart ? 'values' : itemSlotId;
		otherItemDataMin = _findMaxMinOfMeasuresAssignedToTargetSlot(targetDomain, itemSlotId).dataMin;
		otherItemScaleMin = _findMaxMinOfMeasuresAssignedToTargetSlot(domain[otherWidgetId], itemSlotId).scaleMin;
	} else if (targetDomain && targetDomain[itemKey] && (isSlotIdSame || isCompositeChart)) {
		otherItemDataMin = targetDomain[itemKey].dataMin;
		otherItemScaleMin = targetDomain[itemKey].min;
	} else {
		return {
			itemScaleMin: itemScaleMin,
			itemDataMin: itemDataMin,
			notifyWidgetId: undefined
		};
	}
	var otherItemMinOfDataAndScale = Math.min(otherItemDataMin, otherItemScaleMin);
	var areBothScalesMinsPositive = itemDataMin >= 0 && otherItemMinOfDataAndScale >= 0;
	var notNotifyOtherWidgetDueToMinChange = widgetContentApi.getFeature('WidgetAPI.deprecated').getVisApi().getPropertyById('valueAxis.zeroOrigin') && areBothScalesMinsPositive;

	if (itemDataMin !== otherItemMinOfDataAndScale) {
		if (itemDataMin < otherItemMinOfDataAndScale) {
			notifyWidgetId = notNotifyOtherWidgetDueToMinChange ? notifyWidgetId : otherWidgetId;
		} else if (itemDataMin < otherItemDataMin) {
			notifyWidgetId = notNotifyOtherWidgetDueToMinChange ? notifyWidgetId : otherWidgetId;
		} else if (otherItemDataMin !== otherItemMinOfDataAndScale) {
			notifyWidgetId = notNotifyOtherWidgetDueToMinChange ? notifyWidgetId : otherWidgetId;
			itemScaleMin = otherItemDataMin;
		} else {
			itemScaleMin = otherItemDataMin;
		}
	}
	return {
		itemScaleMin: itemScaleMin,
		itemDataMin: itemDataMin,
		notifyWidgetId: notifyWidgetId
	};
}
function _existComboChartInDomains(domains) {
	var existComboChartInDomains = void 0;
	if (domains) {
		Object.keys(domains).forEach(function (widgetId) {
			existComboChartInDomains = existComboChartInDomains || Object.values(domains[widgetId]).some(function (item) {
				return item.isCompositeChart;
			});
		});
	}

	return existComboChartInDomains;
}
/**
 * 
 * @param {Object} existingDomains - a map of existing domains 
 * @param {Object} sourceWidgetApi - the widget api of the source widget 
 * @param {Array} widgetIds - the array of widget ids
 * @returns {boolean} - true if both target and source widgets are eligible for matching scale by default
 */
function shouldMatchingScaleByDefault(existingDomains, sourceWidgetContentApi, widgetIds) {
	var sourceWidgetId = sourceWidgetContentApi && sourceWidgetContentApi.getId();
	var otherWidgetId = _findTargetWidgetId(sourceWidgetId, widgetIds);
	var sourceDomain = existingDomains && existingDomains[sourceWidgetContentApi.getId()];
	var targetDomain = existingDomains && existingDomains[otherWidgetId];
	var shouldMatchingScaleByDefault = Boolean(_isWidgetEligibleForMatchingScale(sourceWidgetContentApi) || _findDataItemsInEligibleSlotsForMatchingScale(sourceWidgetContentApi).length);
	// we can only be sure if the target domain has been set
	// We default the synch scale option as true (on) as long as there exists at least one common measure (same column id, same slot id and same aggregation) between the widgets
	if (shouldMatchingScaleByDefault && targetDomain) {
		var existsSameMeasureInTargetSlot = void 0;
		sourceDomain && Object.keys(sourceDomain).some(function (key) {
			var column = sourceDomain[key];
			// the key includes column Id, aggregation type and layerId info
			existsSameMeasureInTargetSlot = targetDomain[key] && targetDomain[key].slotId === column.slotId;
			return existsSameMeasureInTargetSlot;
		});
		shouldMatchingScaleByDefault = existsSameMeasureInTargetSlot;
	}
	return shouldMatchingScaleByDefault;
}
/**
 * determines whether the matching scale option makes sense and should be in the enabled state
 * We allow matching scale in the following scenarios 
 * a) there exists a combo chart in the domains
 * b) every measure in one widget shares the same slot id as the other widget
 * @param {Object} domains - the map of the domains
 * @param {Array} widgetIds - the widget ids
 */
function allowMatchingScale(domains, widgetIds) {
	var allowToggling = true;
	if (domains) {
		// should be enabled if there exists combo chart in the compare card
		if (_existComboChartInDomains(domains) && Object.keys(domains).length === 2) {
			return allowToggling;
		} else {
			var slotIdsMap = {};
			Object.keys(domains).forEach(function (widgetId) {
				var domain = domains[widgetId];
				domain && Object.keys(domain).forEach(function (itemKey) {
					if (!slotIdsMap[widgetId]) {
						slotIdsMap[widgetId] = [];
					}
					slotIdsMap[widgetId].push(domain[itemKey].slotId);
				});
			});
			if (widgetIds && widgetIds.length === 2) {
				var slotIdsIntersection = (0, _ArrayOperations.intersectArrays)(slotIdsMap[widgetIds[0]] || [], slotIdsMap[widgetIds[1]] || []);
				allowToggling = Boolean(slotIdsIntersection.length);
			}
		}
	}
	return allowToggling;
}

exports.default = {
	getDomainAndNotifyWidgetId: getDomainAndNotifyWidgetId,
	shouldMatchingScaleByDefault: shouldMatchingScaleByDefault,
	allowMatchingScale: allowMatchingScale
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
var SynchActionProcessor = function () {
	//The role of the SynchActionProcessor is to apply the same action across the set of widgets in a compare model.
	function SynchActionProcessor(compareModel, refChecker) {
		_classCallCheck(this, SynchActionProcessor);

		this.compareModel = compareModel;
		this.refChecker = refChecker;

		//A list of actionListeners for all widgetApi's in the comparison.
		this._actionListeners = [];
	}

	SynchActionProcessor.prototype.initialize = function initialize(widgetContentApi) {
		this._addWidgetApiListeners(widgetContentApi);
	};

	SynchActionProcessor.prototype.destroy = function destroy() {
		this.disable();
	};

	/**
  * call enable() to listen on widgetApi synchronized action events.
  */


	SynchActionProcessor.prototype.enable = function enable() {
		var _this = this;

		this.compareModel.getWidgetContentApis().forEach(function (widgetContentApi) {
			_this._addWidgetApiListeners(widgetContentApi);
		});
	};

	/**
  * call disable() to stop listening on all widgetApi synchronized action events.
  */


	SynchActionProcessor.prototype.disable = function disable() {
		this._actionListeners.forEach(function (listener) {
			listener.remove();
		});
		this._actionListeners = [];
	};

	/**
  * perform a synchronized sort: sort items in both compare widgets the same way according to some selection rules (see synchAction):
  * @param sourceWidgetId - the widgetId that initiated the action.
  * @param data - the data (from the widgetApi event that includes this standard information:
  *		itemContext: what item the action was applied to
  *		params:	the action-specific parameters
  *		options: options
  */


	SynchActionProcessor.prototype.synchSort = function synchSort(sourceWidgetId, data) {
		var cbSort = function cbSort(targetDataItemInfo) {
			var dataItemList = targetDataItemInfo.slotAPI.getDataItemList();
			if (dataItemList && targetDataItemInfo.indexInSlot >= 0 && targetDataItemInfo.indexInSlot < dataItemList.length) {
				var dataItem = dataItemList[targetDataItemInfo.indexInSlot];
				if (dataItem) {
					dataItem.setSort(data.info.value, data.transactionToken);
				}
			}
		};
		return this._synchAction(sourceWidgetId, cbSort, data);
	};

	/**
  * perform a synchronized format: Format items in both compare widgets the same way according to selection rules (see synchAction):
  * @param sourceWidgetId - the widgetId that initiated the action.
  * @param data - the data (from the widgetApi event that includes this standard information:
  *		itemContext: what item the action was applied to
  *		params:	the action-specific parameters
  *		options: options
  */


	SynchActionProcessor.prototype.synchFormat = function synchFormat(sourceWidgetId, data) {
		var cbFormat = function cbFormat(targetDataItemInfo) {
			var dataItemList = targetDataItemInfo.slotAPI.getDataItemList();
			if (dataItemList && targetDataItemInfo.indexInSlot >= 0 && targetDataItemInfo.indexInSlot < dataItemList.length) {
				var dataItem = dataItemList[targetDataItemInfo.indexInSlot];
				if (dataItem) {
					dataItem.setFormat(data.info.value, data.transactionToken);
				}
			}
		};
		return this._synchAction(sourceWidgetId, cbFormat, data);
	};

	/**
  * perform a synchronized topBottom: Top/BottomN items in both compare widgets the same way according to selection rules (see synchAction):
  * @param sourceWidgetId - the widgetId that initiated the action.
  * @param data - the data (from the widgetApi event that includes this standard information:
  *		itemContext: what item the action was applied to
  *		params:	the action-specific parameters
  *		options: options
  */


	SynchActionProcessor.prototype.synchTopBottom = function synchTopBottom(sourceWidgetId, data) {
		var cbTopBottom = function cbTopBottom(targetDataItemInfo) {
			if (data.info.value) {
				targetDataItemInfo.mappedDataItemAPI && targetDataItemInfo.mappedDataItemAPI.setTopBottom(data.info.value, data.transactionToken);
			} else {
				var dataItemList = targetDataItemInfo.slotAPI.getDataItemList();
				if (dataItemList && targetDataItemInfo.indexInSlot >= 0 && targetDataItemInfo.indexInSlot < dataItemList.length) {
					var dataItem = dataItemList[targetDataItemInfo.indexInSlot];
					if (dataItem) {
						dataItem.setTopBottom(null, data.transactionToken);
					}
				}
			}
		};

		//Contextual topBottom shouldn't be done if widgets aren't from the same module.
		return data && data.info && data.info.value && data.info.value.context && this._widgetsAreFromDifferentModules() ? false : this._synchAction(sourceWidgetId, cbTopBottom, data);
	};

	SynchActionProcessor.prototype._widgetsAreFromDifferentModules = function _widgetsAreFromDifferentModules() {
		var firstWidgetModule = null;
		return this.compareModel.getWidgetContentApis().find(function (widgetContentApi) {
			if (!firstWidgetModule) {
				firstWidgetModule = widgetContentApi.getFeature('Visualization').getDataSource().getModule();
			} else {
				return widgetContentApi.getFeature('Visualization').getDataSource().getModule() !== firstWidgetModule;
			}
		});
	};

	//Synchronize an action from source widget "widgetId" to any OTHER widgets in the compare model
	//(currently this means the 1 other widget in the compare card but could be more in future)
	//Using a standard set of rules....
	// rule1: if the same itemId appears in both widgets, the action (sort/topBottom/format) will be applied to that itemId wherever it is.
	// rule2: if the same slotId appears in both widgets, the action (sort/topBottom/format) will be applied to the item in that slot.


	SynchActionProcessor.prototype._synchAction = function _synchAction(sourceWidgetId, cbAction, data) {
		var _this2 = this;

		if (this._isSynchInProgress) {
			return false;
		}

		if (!this.refChecker.isValid(this.compareModel)) {
			return false;
		}

		this._isSynchInProgress = true;
		var actionApplied = false;
		this.compareModel.getWidgetContentApis().forEach(function (targetWidgetContentApi) {
			if (targetWidgetContentApi.getId() !== sourceWidgetId) {
				var targetDataItemInfo = _this2._findCorrespondingItem(data.info, targetWidgetContentApi);
				if (!targetDataItemInfo) {
					targetDataItemInfo = _this2._findCorrespondingSlotItem(data.info, targetWidgetContentApi);
				}
				if (targetDataItemInfo) {
					//augment the targetDataItemInfo with the mappedDataItemAPI.
					targetDataItemInfo.mappedDataItemAPI = _this2._getMappedDataItem(targetWidgetContentApi, targetDataItemInfo);
					cbAction(targetDataItemInfo);
					actionApplied = true;
				}
			}
		});
		this._isSynchInProgress = false;
		return actionApplied;
	};

	//TODO: Change this for R5!
	//Augment the target dataItemInfo payload with the corresponding mappedDataItem
	//The R4 data payload from LiveWidget includes a legacy SlotAPI and index
	//but should change to send a mapped DataItem.
	//Story RTC282463 is in place to do the work to change LW and respond to the change (for all synch actions)
	//We need to use the new setTopBottom API for contextual topN
	//because the context parameter structure changed
	//(and we don't want to know anything about how!)


	SynchActionProcessor.prototype._getMappedDataItem = function _getMappedDataItem(targetWidgetContentApi, targetDataItemInfo) {
		var dataItemAPI = targetDataItemInfo.dataItemAPI;
		if (dataItemAPI) {
			var visualizationAPI = targetWidgetContentApi.getFeature('Visualization');
			var slotsAPI = visualizationAPI && visualizationAPI.getSlots();
			var mappedDataItemAPI = slotsAPI && slotsAPI.getDataItemList().find(function (mappedDataItemAPI) {
				return mappedDataItemAPI.getId() === dataItemAPI.getId();
			});
			return mappedDataItemAPI;
		}
		return null;
	};

	//synchAction helper: Given a "sourceItemContext" (slotAPI and index in the slot)
	//find a corresponding item (by itemId) in the specified targetWidgetApi (if one exists)


	SynchActionProcessor.prototype._findCorrespondingItem = function _findCorrespondingItem(sourceItemContext, targetWidgetContentApi) {
		var itemIdToFind = sourceItemContext && sourceItemContext.dataItemId;
		if (!itemIdToFind) {
			return null;
		}
		//Is this itemId found anywhere in the other widget?
		var slotList = targetWidgetContentApi.getFeature('Visualization').getSlots().getSlotList();
		var found = null;
		for (var _iterator = slotList, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;

			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}

			var slot = _ref;

			var index = slot.getDataItemList().findIndex(function (dataItemAPI) {
				return dataItemAPI.getId() === itemIdToFind || dataItemAPI.getColumnId() === itemIdToFind;
			});
			if (index !== -1) {
				found = {
					slotAPI: slot,
					indexInSlot: index,
					dataItemAPI: slot.getDataItemList()[index]
				};
				break;
			}
		}
		return found;
	};

	//synchAction helper: Given a "sourceItemContext" (slotAPI and index in the slot)
	//find a corresponding item (by slotId) in the specified target widgetApi (if one exists)


	SynchActionProcessor.prototype._findCorrespondingSlotItem = function _findCorrespondingSlotItem(sourceItemContext, targetWidgetContentApi) {
		var mappingInfo = sourceItemContext && targetWidgetContentApi.getFeature('Visualization').getSlots().getMappingInfo(sourceItemContext.dataItemId);
		var targetSlotAPI = mappingInfo && mappingInfo.slot;
		if (!targetSlotAPI) {
			return null;
		}
		return {
			slotAPI: targetSlotAPI,
			indexInSlot: 0, //Perform the action on the first item assigned to the slot.
			dataItemAPI: targetSlotAPI.getDataItem()
		};
	};

	//Note: in order to properly remove bindings, we need to store the .bind (currently Events.js only supports a single object as context.)


	SynchActionProcessor.prototype._addWidgetApiListeners = function _addWidgetApiListeners(widgetContentApi) {
		var visualization = widgetContentApi.getFeature('Visualization');
		this._actionListeners.push(visualization.on('change:slots:dataitem:sort', this.synchSort.bind(this, widgetContentApi.getId())));
		this._actionListeners.push(visualization.on('change:slots:dataitem:format', this.synchFormat.bind(this, widgetContentApi.getId())));
		this._actionListeners.push(visualization.on('change:slots:dataitem:topbottom', this.synchTopBottom.bind(this, widgetContentApi.getId())));
	};

	return SynchActionProcessor;
}();

exports.default = SynchActionProcessor;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.CalcType = undefined;
exports.getWidgetInfoList = getWidgetInfoList;
exports.getMeasuresList = getMeasuresList;

var _mobxStateTree = __webpack_require__(7);

var _StatsProcessor = __webpack_require__(44);

var _StatsProcessor2 = _interopRequireDefault(_StatsProcessor);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _WidgetContextChecker = __webpack_require__(186);

var _WidgetContextChecker2 = _interopRequireDefault(_WidgetContextChecker);

var _CompareTableAPI = __webpack_require__(187);

var _CompareTableAPI2 = _interopRequireDefault(_CompareTableAPI);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalcType = exports.CalcType = _mobxStateTree.types.string; /*
                                                                *+------------------------------------------------------------------------+
                                                                *| Licensed Materials - Property of IBM
                                                                *| IBM Cognos Products: Explore
                                                                *| (C) Copyright IBM Corp. 2018, 2019
                                                                *|
                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                *+------------------------------------------------------------------------+
                                                                */


var ChartInfo = _mobxStateTree.types.model({
	widgetId: '',
	widgetAlias: '',
	measureName: '',
	measureLabel: '',
	measureList: _mobxStateTree.types.frozen()
});

function getWidgetInfoList(statsModelMap, widgetAliasMap) {
	var widgetAliasStart = 65;
	return Array.from(statsModelMap.entries()).map(function (entry) {
		return { widgetId: entry[0], widgetAlias: widgetAliasMap && widgetAliasMap[entry[0]] || String.fromCharCode(widgetAliasStart++) };
	});
}

/*
 * @return {Array.<Object>} Object is of the form
 * { measureName :<string>, metadata: <object> }
 */
function getMeasuresList(statsModelMap, widgetId) {
	var statsModel = statsModelMap.get(widgetId);
	var measuresMap = statsModel.measures || new Map();
	var measures = [];
	measuresMap.forEach(function (measureDetail, measureName) {
		measures.push({ measureName: measureName, metadata: measureDetail.metadata || measureDetail.get('metadata') });
	});

	return measures;
}

var WidgetContextProcessState = _mobxStateTree.types.enumeration('WidgetContextProcessState', ['pending', 'ready', 'error']);

var CompareTableSummary = _mobxStateTree.types.model({
	applicableCalcs: _mobxStateTree.types.union(_mobxStateTree.types.array(CalcType), _mobxStateTree.types.undefined),
	charts: _mobxStateTree.types.union(_mobxStateTree.types.array(ChartInfo), _mobxStateTree.types.undefined),
	updated: 0,
	widgetContextProcessState: _mobxStateTree.types.optional(WidgetContextProcessState, 'pending')
}).volatile(function () {
	return {
		theStatsProcessor: _StatsProcessor2.default,
		combinedSummaryValueMap: {},
		theWidgetContextChecker: _WidgetContextChecker2.default,
		getApplicableCalcTypes: _StatsProcessor2.default.getApplicableSummaryCalcTypes,
		widgetMeasureNameMap: {}, //A map of widgetId -> measureName (owned by compareModel - shared by compareTableSummary and compareTableSelectionSummary)
		widgetContextCheckResult: {},
		widgetDataVersions: {}, //A map by id that tracks when widget data changes or is recomputed (computeSummaryInfo/recomputeSummaryInfo)
		fnSpyNewStats: null, //A function that uses widgetDataVersions to track changes to stats (and potentially resolve the waitForNewStats promise)
		fnSpyNewCalcs: null
	};
}).views(function (self) {
	return {
		getNewCompareTableStatsEnabled: function getNewCompareTableStatsEnabled() {
			var env = (0, _mobxStateTree.getEnv)(self);
			return env && env.isFeatureEnabled && !env.isFeatureEnabled('newCompareTableStatsEnabled', 'false');
		},


		/**
   * @returns the compareTableAPI object for this compare table summary model.
   */
		getAPI: function getAPI() {
			return self._api;
		},


		/*
   * @param {number} row row index into applicableCalcs
   * @param {object} chartStats chart summary stats object that holds all calculation results
   * @return calculation result
   */
		getData: function getData(row, chartStats) {
			var data = { value: '' };

			var calc = self.applicableCalcs[row];
			if (calc && chartStats) {
				data.value = chartStats.stats && chartStats.stats[calc] || '';
				data.valueUse = chartStats.statsUse && chartStats.statsUse[calc] || '';
				data.toolTip = chartStats.toolTip && chartStats.toolTip[calc];
				data.formatSpec = chartStats.meta && chartStats.meta.format && chartStats.meta.format || '';

				//If the dataset has negative values, apply an indicator to any calculations in the set listed (eg: TOTAL_SEL and PERCENT_SELvsALLDATA for selections.)
				var showHasNegativeValuesIndicatorCalcs = chartStats.statsUse && chartStats.statsUse.hasNegativeValues;
				if (showHasNegativeValuesIndicatorCalcs && showHasNegativeValuesIndicatorCalcs.indexOf(calc) >= 0) {
					data.hasNegativeValuesIndicator = ' *';
				}
			}
			return data;
		},


		/**
   * @param widgetId - the widgetId of interest.
   * @returns the selected measure name for the given widgetId
   */
		getSelectedMeasureName: function getSelectedMeasureName(widgetId) {
			return self.widgetMeasureNameMap[widgetId] || null;
		},


		/*
   * @param {object} chartStatsList list of chartStats (array has 1 entry for each widget on compare card)
   *
   * @return combined calculation results
   * 			i.e. given stats for widget A, B, return combined calculations for A and B
   */
		getCalculatedData: function getCalculatedData(chartStatsList) {
			self.fnSpyNewStats && self.fnSpyNewStats(chartStatsList);

			var params = {
				statsInfoList: chartStatsList,
				applicableCalcs: self.applicableCalcs,
				getString: _StringResources2.default.get.bind(_StringResources2.default),
				widgetContextCheckResult: self.widgetContextCheckResult,
				newCompareTableStatsEnabled: self.getNewCompareTableStatsEnabled(),
				combinedSummaryValueMap: self.combinedSummaryValueMap
			};

			if (chartStatsList.length < 2) {
				self.setCombinedSummaryValues(null);
			}

			if (self.widgetContextProcessState === 'ready' || chartStatsList.length < 2) {
				var calculatedData = self.theStatsProcessor.getCalculatedSummaryData(params);
				self.fnSpyNewCalcs && self.fnSpyNewCalcs(calculatedData);
				return calculatedData;
			} else {
				if (self.widgetContextProcessState === 'pending' && !self._checker) {
					self._checker = new self.theWidgetContextChecker(self.widgetContentMap);
					//TODO use mobx utils
					var isSelectionStats = !!chartStatsList[0].statsUse.numSelections;
					self._checker.process(params.newCompareTableStatsEnabled, isSelectionStats).then(function (result) {
						params.combinedSummaryValueMap = result.combinedSummaryResponse && result.combinedSummaryResponse.measures;
						self.setCombinedSummaryValues(params.combinedSummaryValueMap);
						if (self._checker) {
							self.setWidgetContextProcessInfo('ready', result);
							self._checker = null;
							self._processedCheck && self._processedCheck(); //for unit testing
						}
					});
				}
				return self.theStatsProcessor.getCalculatedSummaryData(params);
			}
		},


		/**
   * @returns the widgetDataVersions for each widget alias in the comparison eg: { 'A': 3, 'B': 1 }
   * 			how many times the summary column data has changed (by computeSummaryInfo or recomputeSummaryInfo)
   */
		getWidgetDataVersions: function getWidgetDataVersions() {
			return self.widgetDataVersions;
		},


		/**
   * @returns true if calculations are in a ready state.
   */
		areCalculationsReady: function areCalculationsReady() {
			return self.widgetContextProcessState === 'ready';
		}
	};
}).actions(function (self) {
	return {
		afterCreate: function afterCreate() {
			self._api = new _CompareTableAPI2.default(self);
		},
		beforeDestroy: function beforeDestroy() {
			self._api.destroy();
			self._api = null;
			self._checker = null;
		},


		/**
   * This function allows a caller to "spy on" updates to widget data in the compare table.
   * BACKGROUND:
   * There are 2 phases to ensuring data in the compare table has been updated
   * Phase1 is driven by having new data in one or both widgets (computeSummaryInfo) (updateData/updateSelectionData)
   * 					OR user changing the focus measure (recomputeSummaryInfo)
   * The second phase (driven by REACT rendering) is getCalculatedData which is called when the stats have been processed
   * and the combined column is being rendered (getCalculatedData)
   * NOTE: Since getting data for the compareTable/calculatedData can execute queries that are independent 
   * of the widget render sequence, the best way to test widget/calculated data is available is to
   * spy on those updates
   * @param {function} fnSpyNewStats - a function which will be invoked when stats for widgets have data (possibly unchanged)
   * 									Use: getWidgetDataVersions() to determine the state of each widget.
  */
		setSpyNewStats: function setSpyNewStats(fnSpyNewStats) {
			self.fnSpyNewStats = fnSpyNewStats;
		},


		/**
   * This function allows a caller to "spy on" requests to get calculation data.
   * @param {function} fnSpyNewCalcs - a function which will be invoked when calculations are requested.
   * 									Use: areCalculationsReady() to determine if they're up-to-date.
  */
		setSpyNewCalcs: function setSpyNewCalcs(fnSpyNewCalcs) {
			self.fnSpyNewCalcs = fnSpyNewCalcs;
		},


		/**  
   * This function is used to count and store the number of times each widget in this summary
   * has been computed (ie: data changed) (via computeSummaryInfo or recomputeSummaryInfo)
   * @param {string} widgetAlias - 'A' or 'B' for the current compare card but could be any alias.
   * Examples:
   * initial - {}.  
   * computeSummaryInfo on A - { 'A': 1 }, 	- from updateData or updateSelectionData
   * computeSummaryInfo on B - { 'A':1, 'B':1 }
   * recomputeSummaryInfo on B - { 'A':1, 'B':2 } - user changes the measure selector on B.
  */
		updateWidgetDataVersion: function updateWidgetDataVersion(widgetAlias) {
			if (widgetAlias) {
				if (!self.widgetDataVersions[widgetAlias]) {
					self.widgetDataVersions[widgetAlias] = 0;
				}
				self.widgetDataVersions[widgetAlias]++;
			}
		},
		setCombinedSummaryValues: function setCombinedSummaryValues(values) {
			self.combinedSummaryValueMap = values;
		},
		setStatsProcessor: function setStatsProcessor(processor) {
			self.theStatsProcessor = processor;
		},
		setWidgetContextChecker: function setWidgetContextChecker(checker) {
			self.theWidgetContextChecker = checker;
		},
		setWidgetContextProcessInfo: function setWidgetContextProcessInfo(state, result) {
			self.widgetContextCheckResult = result;
			self.widgetContextProcessState = state;
		},


		/**
   * called by compareModel to establish a map of selected measures by widgetId.
   * @param widgetMeasureNameMap - a map of widgetId - measureName
   * (shared by compareTableSummary and selectedCompareTableSummary)
   */
		setWidgetMeasureNameMap: function setWidgetMeasureNameMap(widgetMeasureNameMap) {
			self.widgetMeasureNameMap = widgetMeasureNameMap;
		},


		/*
   * populates Model based on provided stats models
   * if modelType === 'selections', sets it up for selections
   *
   * @param { object } statsModelMap - the current stats models
   * @param { object } widgetAliasMap - a map of widgetId to alias (ie: 'A' or 'B')
   * @param { object } widgetContentMap - a map of widgetId to widgetApi
   * @param { string } widgetId - the widgetId being updated (ie: this function is alled by updateData/updateSelectionData)
   * @param { string } modelType - one of 'selections' or 'summary' depending on the type of model.
   * populating model entails creating a 'frame of reference' where self.charts & self.applicableCalcs
   * are set in a way that makes sense for a summary view
   * 		self.charts to indicate measure considered for each widget (+ additional info)
   *		self.applicableCalcs list the applicable calculations to show given the set of measures from the 2 widgets
   */
		computeSummaryInfo: function computeSummaryInfo(statsModelMap, widgetAliasMap, widgetContentMap, widgetId, modelType) {
			var newCompareTableStatsEnabled = self.getNewCompareTableStatsEnabled();
			var summary = {
				applicableCalcs: [],
				charts: [] //contains {widgetId, widgetAlias, measureName, measureList}, {widgetId, widgetAlias, measureName}
			};
			self.widgetContentMap = widgetContentMap;
			self.widgetContextProcessState = 'pending';

			widgetAliasMap = widgetAliasMap || {};
			var widgets = getWidgetInfoList(statsModelMap, widgetAliasMap);

			//The 'primary widget' is the first by default.
			var primary = widgets && widgets[0];

			//If the primary widget has a list of measures, check if the measure has been set (by recompute)
			//otherwise, consider the first measure of the primary widget as the primary measure
			var currentPrimaryChartMeasureName = primary && self.getSelectedMeasureName(primary.widgetId);
			var primaryMeasures = primary && getMeasuresList(statsModelMap, primary.widgetId);
			var primaryMeasure = primaryMeasures && (primaryMeasures.find(function (measureInfo) {
				return measureInfo.measureName === currentPrimaryChartMeasureName;
			}) || primaryMeasures[0]);
			//Synchronize the widgetMeasureName to ensure data changes work.
			if (primaryMeasure) {
				self.widgetMeasureNameMap[primary.widgetId] = primaryMeasure.measureName;
			}

			var measuresToCheck = primaryMeasure && [primaryMeasure] || [];

			var restOfTheWidgets = widgets.filter(function (w) {
				return w.widgetId !== primary.widgetId;
			});

			var otherWidgetInfo = restOfTheWidgets.map(function (otherWidget) {
				var otherWidgetMeasures = otherWidget && getMeasuresList(statsModelMap, otherWidget.widgetId) || [];
				//If this widget has a list of measures, check if the measure has been set (by recompute)
				//next, try to set the measure to match the primary widget measure.
				//If neither are available, consider the first measure of the widget as the selected measure
				var otherWidgetMeasureName = self.getSelectedMeasureName(otherWidget.widgetId);
				var otherWidgetSelectedMeasure = otherWidgetMeasures.find(function (measureInfo) {
					return measureInfo.measureName === otherWidgetMeasureName;
				});
				var otherWidgetMeasure = otherWidgetSelectedMeasure || primaryMeasure && otherWidgetMeasures.find(function (measureInfo) {
					return measureInfo.measureName === primaryMeasure.measureName;
				}) || otherWidgetMeasures[0];
				//Synchronize the widgetMeasureName to ensure data changes work.
				if (otherWidgetMeasure) {
					self.widgetMeasureNameMap[otherWidget.widgetId] = otherWidgetMeasure.measureName;
				}

				var matchingMeasure = otherWidgetMeasure && otherWidgetMeasures.find(function (m) {
					return m.measureName === otherWidgetMeasure.measureName;
				});
				matchingMeasure = matchingMeasure || otherWidgetMeasures.length > 0 && otherWidgetMeasures[0];
				matchingMeasure && measuresToCheck.push(matchingMeasure);

				return { otherWidget: otherWidget, matchingMeasure: matchingMeasure, otherWidgetMeasures: otherWidgetMeasures };
			});

			//measuresToCheck is a list of all of the selected measures in the comparison table. Find out what calculations apply.
			var fn = modelType && modelType === 'selections' ? 'getApplicableSelectionSummaryCalcTypes' : 'getApplicableSummaryCalcTypes';
			self.getApplicableCalcTypes = fn;
			summary.applicableCalcs = self.theStatsProcessor[fn](measuresToCheck, newCompareTableStatsEnabled) || [];

			if (primary && primaryMeasure) {
				summary.charts.push({
					widgetId: primary.widgetId,
					widgetAlias: primary.widgetAlias,
					measureName: primaryMeasure.measureName,
					measureLabel: primaryMeasure.metadata.label,
					measureList: primaryMeasures
				});
			}

			otherWidgetInfo.forEach(function (widgetInfo) {
				var otherWidget = widgetInfo.otherWidget;
				if (otherWidget && widgetInfo.matchingMeasure) {
					summary.charts.push({
						widgetId: otherWidget.widgetId,
						widgetAlias: otherWidget.widgetAlias,
						measureName: widgetInfo.matchingMeasure.measureName,
						measureLabel: widgetInfo.matchingMeasure.metadata.label,
						measureList: widgetInfo.otherWidgetMeasures
					});
				}
			});

			self.applicableCalcs = summary.applicableCalcs;
			self.charts = summary.charts;

			//Keep track of a "widgetDataVersion" for widgets so we can track changes.
			var widgetAlias = widgetAliasMap[widgetId];
			self.updateWidgetDataVersion(widgetAlias);
		},


		/*
   * computeSummaryInfo() provided the initial/default summary view
   * when user changes the measure for a widget in the summary view, recomputeSummaryInfo() figures out
   * the a new list of applicable calculations
   * @param { object } newChartInfo
   * @param { string } newChartInfo.widgetId - the widgetId
   * @param { string } measureName - a unique id for the measure, (currently: itemId_aggregation_layer)
   */
		recomputeSummaryInfo: function recomputeSummaryInfo(newChartInfo) {
			var currentSummaryInfo = self;
			var summary = {
				applicableCalcs: [],
				charts: [] //contains {widgetId, widgetAlias, measureName}, {widgetId, widgetAlias, measureName}
			};

			//update summary.charts to include baseChart into currentCharts
			//user picked one measure in one chart, find summary.applicableCalcs
			var widgetId = newChartInfo.widgetId,
			    measureName = newChartInfo.measureName;

			summary.charts = JSON.parse(JSON.stringify(currentSummaryInfo.charts)); //copy
			var index = summary.charts.findIndex(function (entry) {
				return entry.widgetId === widgetId;
			});

			var chart = summary.charts[index];
			chart.measureName = measureName;
			var measure = chart.measureList.find(function (e) {
				return e.measureName === measureName;
			});
			chart.measureLabel = measure.metadata.label;

			var measuresToCheck = [measure];

			var restOfTheWidgets = summary.charts.filter(function (w) {
				return w.widgetId !== widgetId;
			});

			restOfTheWidgets.map(function (otherWidget) {
				var otherWidgetMeasures = otherWidget.measureList || [];
				var matchingMeasure = otherWidgetMeasures.find(function (m) {
					return m.measureName === otherWidget.measureName;
				});
				matchingMeasure = matchingMeasure || otherWidgetMeasures.length > 0 && otherWidgetMeasures[0];
				matchingMeasure && measuresToCheck.push(matchingMeasure);

				return { otherWidget: otherWidget, matchingMeasure: matchingMeasure, otherWidgetMeasures: otherWidgetMeasures };
			});

			var fn = self.getApplicableCalcTypes;

			var newCompareTableStatsEnabled = self.getNewCompareTableStatsEnabled();
			summary.applicableCalcs = self.theStatsProcessor[fn](measuresToCheck, newCompareTableStatsEnabled) || [];

			self.applicableCalcs = summary.applicableCalcs;
			self.charts = summary.charts;

			//Update the measure name for the widget we just changed.
			self.widgetMeasureNameMap[widgetId] = measureName;

			//Keep track of a "widgetDataVersion" for widgets so we can track changes.
			self.updateWidgetDataVersion(chart.widgetAlias);
		}
	};
});

exports.default = CompareTableSummary;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */

/**
 * Helper to do checks to confirm if combined calculations in compare table are valid or not.
 * In a few applicable cases, valid combined calculation results can be queried for.  In other cases, it
 * checks the following:
 *	- whether there is overlap in data covered in the compare card visualizations
 *  - whether the category context in the compare card visualizations is the same
 * if there is data overlap, there is a risk of double counting, so combined calculations should not be shown
 * if category Contexts are different, then comparison is not apples to apples, so combined calculations should not be shown
 */
var WidgetContextChecker = function () {
	function WidgetContextChecker(widgetContentApisMap) {
		_classCallCheck(this, WidgetContextChecker);

		this.widgetContentApisMap = widgetContentApisMap;
	}

	WidgetContextChecker.prototype.process = function process(newCompareTableStatsEnabled) {
		var _this = this;

		var isSelectionStats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		var isCategoryContextSame = this.checkIfCategoryContextIsSame();

		return this.queryForCombinedSummariesIfApplicable(newCompareTableStatsEnabled, isSelectionStats).then(function (combinedSummaryResponse) {
			if (combinedSummaryResponse && !combinedSummaryResponse.hasUnprocessedItems) {
				var canCombineCalculations = combinedSummaryResponse.measures !== null;
				return { isCategoryContextSame: isCategoryContextSame, canCombineCalculations: canCombineCalculations, combinedSummaryResponse: combinedSummaryResponse };
			}
			return _this.checkIfSummariesCanBeCombined().then(function (canCombineCalculations) {
				return { isCategoryContextSame: isCategoryContextSame, canCombineCalculations: canCombineCalculations, combinedSummaryResponse: combinedSummaryResponse };
			});
		});
	};

	WidgetContextChecker.prototype.checkIfSummariesCanBeCombined = function checkIfSummariesCanBeCombined() {
		var widgetContentApis = Object.values(this.widgetContentApisMap);
		if (widgetContentApis.length === 2) {
			var summarizer = widgetContentApis[0].getFeature('WidgetAPI.deprecated').getFeature('vis-summarizer');

			var combinedSummaryValidator = summarizer && summarizer.getCombinedSummaryValidator();
			combinedSummaryValidator && combinedSummaryValidator.combineSummariesWith(widgetContentApis[1].getFeature('WidgetAPI.deprecated'));

			return combinedSummaryValidator.isInitialized() && combinedSummaryValidator.validate().then(function (testResult) {
				return testResult;
			});
		}
		return Promise.resolve(false);
	};

	/**
  * Some combined calculations can't be determined by adding the values of the two individual charts
  * BUT they can be determined using a single row query.  This handler passes the widgetId's to the summarizer
  * and, if it determines a query can be done to find some common, combined measure results, it will perform it to get the values of all applicable measures.
  * It also returns a flag stating whether there are more common measures to be handled for the regular overlap test or not.
  * NOTE: currently, this query is only done for countdistinct usecases but could be extended to other aggregation types in future where data overlaps.
  * @param {boolean} newCompareTableStatsEnabled - We never query unless the new calculations flag is true.
  * @returns A promise whose value is null if no query is helpful or a queryResult with the set of measures and their values and the status flag.
  */


	WidgetContextChecker.prototype.queryForCombinedSummariesIfApplicable = function queryForCombinedSummariesIfApplicable(newCompareTableStatsEnabled, isSelectionStats) {
		if (!newCompareTableStatsEnabled) {
			return Promise.resolve(null);
		}

		var widgetContentApis = Object.values(this.widgetContentApisMap);
		if (widgetContentApis.length === 2) {
			var summarizer = widgetContentApis[0].getFeature('WidgetAPI.deprecated').getFeature('vis-summarizer');

			var widgetApis = widgetContentApis.map(function (widgetContentApi) {
				return widgetContentApi.getFeature('WidgetAPI.deprecated');
			});
			var combinedSummaryValueQuery = summarizer && summarizer.createCombinedSummaryValueQuery(widgetApis, isSelectionStats);
			if (!combinedSummaryValueQuery) {
				return Promise.resolve(null);
			}

			return combinedSummaryValueQuery.execute().then(function (valueQueryResult) {
				var summaryTableJSON = valueQueryResult && valueQueryResult.getSummaryTableJSON();
				return {
					measures: summaryTableJSON && summaryTableJSON.measures,
					hasUnprocessedItems: combinedSummaryValueQuery.hasUnprocessedItems()
				};
			});
		}
		return Promise.resolve(null);
	};

	WidgetContextChecker.prototype.checkIfCategoryContextIsSame = function checkIfCategoryContextIsSame() {
		var widgetContentApis = Object.values(this.widgetContentApisMap);
		var categoryContexts = {};

		widgetContentApis.forEach(function (widgetContentApi) {
			var widgetId = widgetContentApi.getId();

			var visApi = widgetContentApi.getFeature('Visualization');
			if (visApi) {
				var items = visApi.getSlots().getMappingInfoList().filter(function (mappingInfo) {
					return mappingInfo && mappingInfo.slot && mappingInfo.slot.getDefinition().getType() === 'category';
				});
				items = items.map(function (dataItemInfo) {
					return dataItemInfo.dataItem.getId();
				});
				items.sort();
				categoryContexts[widgetId] = items.join(',');
			}
		});

		var foundMismatch = false;

		var last = null;
		Object.values(categoryContexts).forEach(function (categoryContext) {
			if (!last) {
				last = categoryContext;
			} else {
				if (categoryContext && last !== categoryContext) {
					foundMismatch = true;
				}
			}
		});

		return !foundMismatch;
	};

	return WidgetContextChecker;
}();

exports.default = WidgetContextChecker;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _mobxStateTree = __webpack_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2019, 2020
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

/**
 * a set of APIs to evaluate and change compare table content (access the compareTableSummary model)
 * @module CompareTableAPI
 */
var CompareTableAPI = function CompareTableAPI(compareTableSummary) {
	_classCallCheck(this, CompareTableAPI);

	/**
  * To be invoked by the product only.
  */
	this.destroy = function () {
		compareTableSummary = null;
	};

	/**
  * @return {object} Snapshot of the state
  */
	this.getState = function () {
		return (0, _mobxStateTree.getSnapshot)(compareTableSummary);
	};

	/**
  *  @return the applicable calcs as an array (eg. ['min', 'max', 'percentVsAllData', 'total'])
  */
	this.getApplicableCalcs = function () {
		return compareTableSummary.applicableCalcs.toJSON();
	};

	/**
  * Get the data for row from the chartStats table (where row is the nth row of the table and the value corresponds to the nth applicable calc)
  * @param {integer} row - a number from 0 to the number of applicable calcs (as returned by getApplicableCalcs)
  * @param {object} chartStats - the stats for one chart (eg. as returned by waitForNewStats)
  * @return a JSON object that stores data for fields such as value, valueUse and tooltip
  */
	this.getData = function (row, chartStats) {
		return compareTableSummary.getData(row, chartStats);
	};

	/**
  * This function allows a caller to "spy on" updates to data for a particular widget in the compare table.
  * See details in CompareTableSummary.
  * @param {function} fnSpyNewStats - a function which will be invoked when stats for widgets have data (possibly unchanged)
  * 									Use: getWidgetDataVersions() to determine the state of each widget.
 */
	this.setSpyNewStats = function (fnSpyNewStats) {
		compareTableSummary.setSpyNewStats(fnSpyNewStats);
	};

	/**
  * This function allows a caller to "spy on" requests to get calculation data.
  * @param {function} fnSpyNewCalcs - a function which will be invoked when calculations are requested.
  * 									Use: areCalculationsReady() to determine if they're up-to-date.
 */

	this.setSpyNewCalcs = function (fnSpyNewCalcs) {
		compareTableSummary.setSpyNewCalcs(fnSpyNewCalcs);
	};

	/**
  * @returns the widgetDataVersions which is a map of widgetAlias to version (count of updates)
  */
	this.getWidgetDataVersions = function () {
		return compareTableSummary.getWidgetDataVersions();
	};

	/**
  * @returns true if calculations are in a ready state.
  */
	this.areCalculationsReady = function () {
		return compareTableSummary.areCalculationsReady();
	};

	/** 
  * Equivalent api to selecting a new measure from the measures droplist on the compareTable.
  * @param widgetId - the widgetId of the droplist to change
  * @param measureName - a measureName (id) of form columnId_aggregate_layer
 */
	this.recomputeSummaryInfo = function (widgetId, measureName) {
		return compareTableSummary.recomputeSummaryInfo({ widgetId: widgetId, measureName: measureName });
	};
};

exports.default = CompareTableAPI;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _mobxStateTree = __webpack_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

/**
 * a set of APIs for compare card operations
 * @module CompareCardAPI
 */
var CompareCardAPI = function CompareCardAPI(compareModel) {
	_classCallCheck(this, CompareCardAPI);

	/**
  * To be invoked by the product only.
  */
	this.destroy = function () {
		compareModel = null;
	};

	/**
  * @return {object} Snapshot of the state
  */
	this.getState = function () {
		return (0, _mobxStateTree.getSnapshot)(compareModel);
	};

	/**
  * toggle show compare line
  */
	this.toggleShowCompareLine = function () {
		compareModel.toggleShowCompareLine();
	};

	/**
  * verify if compare line enabled
  * @return if compare line enabled
  */
	this.isCompareLineEnabled = function () {
		return compareModel.isCompareLineEnabled();
	};

	/**
  * verify if comapre line shown
  * @return if compare line shown
  */
	this.isCompareLineShown = function () {
		return compareModel.isCompareLineShown();
	};

	/**
  * Modify whether compare lines are synced
  * @param {boolean} sync - whether to sync compare lines
  */
	this.setSyncCompareLine = function (sync) {
		compareModel.setCompareLineSynced(sync);
	};

	/**
  * Check whether compare lines are synced
  * @return {boolean} whether compare lines are synced
  */
	this.isCompareLineSynced = function () {
		return compareModel.isCompareLineSynced();
	};

	/**
  * Get points which match the current position of the crosshair
  * @return {array} points matching crosshair
  */
	this.getCrossHairMatchingPoints = function () {
		return compareModel.getCrossHairMatchingPoints();
	};

	/**
  * Modify position of crosshair
  * @param {string} widgetId - which widget's crosshair to move
  * @param {number} value - new crosshair value
  */
	this.onMoveCrosshairs = function (widgetId, value) {
		return compareModel.onMoveCrosshairs(compareModel.refChecker, widgetId, { value: value });
	};

	/**
  * get the chart summary model owned by this compareModel.
  * @return the summary model for summary stats
  */
	this.getChartSummaryModel = function () {
		return compareModel.getChartSummaryModel('summary');
	};

	this.getCompareTableAPI = function () {
		var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'summary';

		var compareTableSummary = compareModel.getChartSummaryModel(type);
		return compareTableSummary && compareTableSummary.getAPI();
	};

	/**
  * Assemble a call to the stats processor for the summary stats
  * to test the statsProcessor transforms on this compareModel and its contained statsModels.
  * Example Return Value:
  * [{
  *		visId: 'viz1',
  *		measures: [{
  *			measureName: 'salesAndMarketing_csv.Revenue_countdistinct_data',
  *			stats: { total: '24,009', totalSelection: '-', percentVsAllData: '52.7%', ... },
  *			statsUse: { total: 24009, difference: 0, percentVsAllData: 52.7, summaryUse: 24009, ... },
  *			toolTip: {
  *				percentVsAllData: 'compareTable_tip_countdistinct_percentVsAllData',
  *				percentChartVsChart: '',
  *				total: 'compareTable_tip_countdistinct_total'
  *			},
  *			aggregationType": 'countdistinct',
  *			meta: { itemId: 'salesAndMarketing_csv.Revenue', label: 'Revenue', format ... }
  *		}]
  *	},
  *	{
  *		visId: 'viz2',
  *		measures: [{
  *			measureName: 'salesAndMarketing_csv.Revenue_countdistinct_data', ...
  *		},
  *		{
  *			measureName: 'salesAndMarketing_csv.Quantity_sum_data', ...
  *		}]
  *	}]
  *
  * @return An array by widgetid/measures in the compare model
  * (each entry in widget measures array is the result of calling the statsProcessor getChartSummaryStats())
  */
	this.getChartSummaryStats = function () {
		var results = [];
		compareModel.statsModelMap.keys().forEach(function (visId) {
			var statsModelForVis = compareModel.statsModelMap.get(visId);
			var thisResult = { visId: visId, measures: [] };
			statsModelForVis.measures.keys().forEach(function (measureId) {
				thisResult.measures.push(compareModel.theStatsProcessor.getChartSummaryStats({
					newCompareTableStatsEnabled: compareModel.getNewCompareTableStatsEnabled(),
					measureName: measureId,
					statsModel: statsModelForVis,
					getString: function getString(str) {
						return str;
					}
				}));
			});
			results.push(thisResult);
		});
		return results;
	};
};

exports.default = CompareCardAPI;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _mobxStateTree = __webpack_require__(7);

var _RefChecker = __webpack_require__(70);

var _RefChecker2 = _interopRequireDefault(_RefChecker);

var _ArrayOperations = __webpack_require__(25);

var _DriverAnalysisCardAPI = __webpack_require__(190);

var _DriverAnalysisCardAPI2 = _interopRequireDefault(_DriverAnalysisCardAPI);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var COMET_VISID = 'com.ibm.vis.rave2comet';
var DECISIONTREE_VISID = 'com.ibm.vis.decisiontree';

exports.default = _mobxStateTree.types.model({
	show: _mobxStateTree.types.optional(_mobxStateTree.types.boolean, false),
	selections: _mobxStateTree.types.array(_mobxStateTree.types.frozen()),
	recommendations: _mobxStateTree.types.optional(_mobxStateTree.types.array(_mobxStateTree.types.frozen()), []),
	visIndexToShow: _mobxStateTree.types.number
}).views(function (self) {
	return {
		/* Return the selection array */
		getSelections: function getSelections() {
			return self.selections;
		},

		/* Return local filters for this visualization */
		getLocalFilters: function getLocalFilters() {
			var localFiltersJSON = void 0;
			if (self.getVisApi()) {
				var localFiltersModel = self.getVisApi().getLocalFilters();
				localFiltersJSON = localFiltersModel && localFiltersModel.toJSON && localFiltersModel.toJSON();
			}
			return localFiltersJSON;
		},
		getRecommendations: function getRecommendations() {
			return self.recommendations;
		},
		getFooterRenderData: function getFooterRenderData() {
			return self.renderData;
		},

		/**Return a selection by index**/
		getSelectionByIndex: function getSelectionByIndex(index) {
			if (self.selections && index >= 0 && index < self.selections.length) {
				return self.selections[index];
			}
			return undefined;
		},
		getVisIndexToShow: function getVisIndexToShow() {
			return self.visIndexToShow;
		},
		getVisApi: function getVisApi() {
			return self.visApi;
		}
	};
}).volatile(function (self) {
	return {
		renderData: null,
		drivers: null,
		refChecker: null,
		cardModel: null,
		_api: null,
		getAPI: function getAPI() {
			return self._api;
		},
		addSpecToRecommendation: function addSpecToRecommendation(recommendation) {
			var widgetSpec = recommendation && recommendation.widgets && recommendation.widgets[0] && recommendation.widgets[0].spec;
			if (self.drivers && widgetSpec) {
				//TODO: CardModel should not have cometViewModel if it's not comet, ideally isDriverAnalysis() should not be needed
				if (widgetSpec.visId === DECISIONTREE_VISID && self.cardModel.isDriverAnalysis()) {
					widgetSpec.possibleKeyDrivers = self.drivers;
				}
			}
		},

		/**
   * Given an recomendation, return the coverted widget spec
   * @param {object} recommendation
   * @example
   * the recommendation example
   *	{
   *		widgets: [
   *			{
   *				spec: {
   *					visId: 'com.ibm.vis.*',
   *					data: {
   *						dataViews: [{
   *
   *						}]
   *					},
   *					...
   *				}
   *			}
   *		]
   *	}
   * @return {object} widget spec
   */
		covertRecommendationToWidgetSpec: function covertRecommendationToWidgetSpec(recommendation) {
			var activeDataSourceId = self.cardModel.boardModel.layout.exploreVM.activeDataSourceId;
			if (!recommendation || !recommendation.widgets || !recommendation.widgets[0]) {
				return;
			}
			self.addSpecToRecommendation(recommendation);
			var clonedSpec = JSON.parse(JSON.stringify(recommendation.widgets[0].spec)); // to make the spec mutable
			var widgetSpec = {
				model: Object.assign({
					type: 'live',
					visTypeLocked: true,
					showTitle: undefined,
					titleMode: 'smartTitle'
				}, clonedSpec)
			};
			//modelRef in smart recommendation is not correct, replace it with activeDataSourceId for now
			widgetSpec.model.data.dataViews.forEach(function (dataView) {
				return dataView.modelRef = activeDataSourceId;
			});
			return widgetSpec;
		},
		_getPromptsMap: function _getPromptsMap(savedPrompts) {
			if (savedPrompts) {
				//TODO: SavedPrompts API changes in R7, as a result, Recommendations Spec could adapt the new getPromptSpecList() returned data structure
				//before that here we will have to do the conversion below
				var specArray = savedPrompts.getPromptSpecList();
				if (specArray && specArray.length) {
					return specArray.reduce(function (map, spec) {
						map[spec.name] = spec;
						return map;
					}, {});
				}
			}
		},


		/**
   * @return {Object} 
   * @example
   * {
   * 	'quantity': 
   * 		{
   * 			columnId: '[great_outdoors_sales_DB2].[SLS_SALES_FACT].[QUANTITY]',
   * 			name: 'quantity',
   * 			...
   * 		}
   * }
  */
		getSavedPrompts: function getSavedPrompts() {
			var dashboardApi = self.cardModel.boardModel.dashboardApi;
			return dashboardApi.getCanvasWhenReady().then(function (canvas) {
				return canvas.getSelectedWidgets();
			}).then(function (widgetAPIs) {
				if (widgetAPIs && widgetAPIs.length > 0) {
					//comet view has only 1 widget
					var id = widgetAPIs[0].getId();
					var widgetContent = dashboardApi.getCanvas().getContent(id);
					if (widgetContent) {
						var vis = widgetContent.getFeature('Visualization');
						return self._getPromptsMap(vis.getSavedPrompts());
					}
				}
				return null;
			});
		}
	};
}).actions(function (self) {
	var listeners = [];

	function cleanupListeners() {
		listeners.forEach(function (entry) {
			return entry.remove();
		});
		listeners = [];
	}

	function updateShow() {
		self.setShow(self.cardModel.isDriverAnalysis());
	}

	function setupShowResponse(visApi) {
		updateShow();
		/* preview needs to be updated for both change dataSlots and localFilters events
  we do not need listen to change:filters events because it can only happens in compare card
  comet does not show preview in compare card*/
		listeners.push(
		//TODO: Verify this when slots editor panel is working
		visApi.on('change:dataSlot', function () {
			return updateShow();
		}), visApi.on('change:localFilters', function () {
			return updateShow();
		}));
		var visLayouts = self.cardModel.getVisualizations();
		if (visLayouts && visLayouts.length) {
			var visLayout = visLayouts[0];
			var id = visLayout.widgetLayout && visLayout.widgetLayout.id;
			if (id) {
				var content = self.cardModel.boardModel.dashboardApi.getCanvas().getContent(id);
				if (content) {
					var visualization = content.getFeature('Visualization');
					visualization.on('change:type', updateShow);
					listeners.push({
						remove: function remove() {
							visualization.off('change:type', updateShow);
						}
					});
				}
			}
		}
	}

	return {
		afterCreate: function afterCreate() {
			self.refChecker = new _RefChecker2.default(self);
			self._api = new _DriverAnalysisCardAPI2.default(self);
		},
		setCardModel: function setCardModel(cardModel) {
			self.cardModel = cardModel;
		},
		setVisApi: function setVisApi(visApi) {
			cleanupListeners();
			setupShowResponse(visApi);
			self.visApi = visApi;
		},
		setShow: function setShow(show) {
			self.show = show;
		},
		setDrivers: function setDrivers(drivers) {
			self.drivers = drivers;
		},
		setSelections: function setSelections(selections) {
			self.selections = selections;
		},

		/**
  * For comet View model, when we set the render data for footer view,
  * we only set the first element of comet chart's render data results
  * array.
  */
		setFooterRenderData: function setFooterRenderData(data, visId) {
			if (visId === COMET_VISID && data && data.results && data.results.length > 0) {
				var newData = JSON.parse(JSON.stringify(data)); // make sure the recommendation is mutable
				self.renderData = newData;
			}
		},
		setRecommendations: function setRecommendations(recommendations) {
			self.recommendations = recommendations;
			self.setVisIndexToShow(0);
		},
		setVisIndexToShow: function setVisIndexToShow(index) {
			self.visIndexToShow = index;
		},
		beforeDestroy: function beforeDestroy() {
			self.refChecker.remove();
			cleanupListeners();
			self.visApi = null;
		},
		hookupCustomDataHandler: function hookupCustomDataHandler() {
			self.setSelections([]);
			cleanupListeners();
			var widgets = self.cardModel.getVisualizations();
			widgets.forEach(function (widget) {
				if (widget.widgetLayout) {
					self._hookupCustomDataHandler(widget.widgetLayout.id);
				}
			});
		},
		_hookupCustomDataHandler: function _hookupCustomDataHandler(widgetId) {
			var dashboardApi = self.cardModel.boardModel.dashboardApi;
			return dashboardApi.getCanvasWhenReady().then(function (canvas) {
				return canvas.getWidgetWhenReady(widgetId);
			}).then(function (widgetApi) {
				if (widgetApi.getVisApi) {
					self.setVisApi(widgetApi.getVisApi());
				}
				var listenerRenderComplete = widgetApi.on('renderComplete', function () {
					self._loadDefaultCustomDataSelections(widgetApi);
				});
				listeners.push(listenerRenderComplete);
				var listenerPredictData = widgetApi.on('widgetFPDDataReady', function (event) {
					self.setDrivers(self.visApi.getPossibleKeyDrivers());
					self.setFooterRenderData(event.data, event.visId);
				});
				listeners.push(listenerPredictData);
			});
		},
		_loadDefaultCustomDataSelections: function _loadDefaultCustomDataSelections(widgetApi) {
			if (self.cardModel.isDriverAnalysis() && widgetApi.getVisApi) {
				var selectedCustomData = widgetApi.getVisApi().getDecoratedCustomData('selected');
				var selections = selectedCustomData.map(function (item) {
					return {
						key: item.id,
						type: 'customdata',
						source: {},
						values: [{ payload: item, customType: item.type }]
					};
				});
				var newSelections = [];
				(0, _ArrayOperations.replaceArray)(newSelections, Array.isArray(selections) ? selections : [selections]);
				self.setSelections(newSelections);
			} else {
				self.setSelections([]);
			}
		}
	};
});

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _mobxStateTree = __webpack_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

/**
 * a set of APIs for driver analysis card operations
 * @module DriverAnalysisCardAPI
 */
var DriverAnalysisCardAPI = function DriverAnalysisCardAPI(cometCardModel) {
	_classCallCheck(this, DriverAnalysisCardAPI);

	/**
  * To be invoked by the product only.
  */
	this.destroy = function () {
		cometCardModel = null;
	};

	/**
  * @return {object} Snapshot of the state
  */
	this.getState = function () {
		return (0, _mobxStateTree.getSnapshot)(cometCardModel);
	};

	/**
  * get driver selections of a driver analysis vis
  * @return {array} current driver selections of a driver analysis vis
  */
	this.getSelections = function () {
		return cometCardModel.getSelections();
	};

	/**
  * get recommendations
  * @return {array} recommendations on a driver;
  */
	this.getRecommendations = function () {
		return cometCardModel.getRecommendations();
	};

	/**
  * get associated predict data that used for footer view rendering
  * @return {object} the predict data used to render footer view;
  */
	this.getAssociatedPredictData = function () {
		return cometCardModel.getFooterRenderData();
	};

	/**
  * Given an recomendation, return the coverted widget spec
  * @param {object} recommendation
  * @example
  * the recommendation example
  *	{
  *		widgets: [
  *			{
  *				spec: {
  *					visId: 'com.ibm.vis.*',
  *					data: {
  *						dataViews: [{
  *
  *						}]
  *					},
  *					...
  *				}
  *			}
  *		]
  *	}
  *
  * @return {object} widget spec (In more details, the returned widget spec will contain the key drivers from the source widget if the recommended widget is decision tree chart)
  */
	this.covertRecommendationToWidgetSpec = function (recommendation) {
		return cometCardModel.covertRecommendationToWidgetSpec(recommendation);
	};
};

exports.default = DriverAnalysisCardAPI;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _mobxStateTree = __webpack_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

/**
 * a set of APIs for card operations
 * @module CardAPI
 */
var CardAPI = function CardAPI(cardModel) {
	_classCallCheck(this, CardAPI);

	/**
  * To be invoked by the product only.
  */
	this.destroy = function () {
		cardModel = null;
	};

	/**
  * @return {string} id of this card
  */
	this.getId = function () {
		return cardModel.id;
	};

	/**
  * @return {string} type of this card
  */
	this.getType = function () {
		return cardModel.type;
	};

	/**
  * @return {boolean} whether this card is 'hidden'
  */
	this.isHidden = function () {
		return cardModel.isHidden;
	};

	/**
  * @return {LiveWidget[]} LiveWidget APIs of the widgets in this card
  */
	this.getWidgetIds = function () {
		return cardModel.getWidgets().map(function (widget) {
			return widget.getId();
		});
	};

	/**
  * @return {} feature API
  */
	this.getFeature = function (featureName) {
		return cardModel.getFeature(featureName);
	};

	/**
  * @param {string} id - id of the widget
  * @return {LiveWidget[]} LiveWidget APIs of the widgets in this card
  */
	this.getExploreWidgetApi = function (id) {
		var widget = (cardModel.items || []).find(function (widget) {
			return widget.id === id;
		});
		return widget ? widget.getAPI() : undefined;
	};

	/**
  * @return {object} Snapshot of the state
  */
	this.getState = function () {
		return (0, _mobxStateTree.getSnapshot)(cardModel);
	};
};

exports.default = CardAPI;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ExploreContainerLayoutModelExt = exports.syncExploreVMStateToCards = undefined;

var _mobxStateTree = __webpack_require__(7);

var _mobx = __webpack_require__(11);

var mobx = _interopRequireWildcard(_mobx);

var _CardModelUtil = __webpack_require__(69);

var _CardModelUtil2 = _interopRequireDefault(_CardModelUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//TODO: move to utility class
// syncExploreVMStateToCards
//
// Track thumbnail model related items & exploreVM related items
// and set properties in card model appropriate to those items
// this is so that ExploreContainerItem view can observe its own Card Model instance
// instead of a shared exploreVM
// Issue with shared exploreVM model is that all views observing it will get rendered
// if displayedCard changes, we don't want to render all explore container items
//
var syncExploreVMStateToCards = exports.syncExploreVMStateToCards = function syncExploreVMStateToCards(self) {
	var exploreVM = self.exploreVM;
	var thumbnailsModel = exploreVM.thumbnails;

	var findModel = function findModel(id) {
		var items = self.items || [];
		var model = null;
		items.forEach(function (item) {
			if (item.id === id) {
				model = item;
			}
		});
		return model;
	};

	//track current thumbnail
	self._mobxDisposeEvents.push(mobx.reaction(function () {
		return thumbnailsModel.current.length;
	}, function () {
		if (thumbnailsModel.current && thumbnailsModel.current.length > 0) {
			thumbnailsModel.current.forEach(function (current) {
				var model = current && findModel(current);
				if (model && model.setCurrentThumbnailInfo) {
					model.setCurrentThumbnailInfo(true, thumbnailsModel);
				}
			});
		}
	}));

	//track done thumbnails
	self._mobxDisposeEvents.push(mobx.reaction(function () {
		return thumbnailsModel.done.length;
	}, function () {
		var done = undefined;
		if (thumbnailsModel.done && thumbnailsModel.done.length > 0) {
			done = thumbnailsModel.done;
		}
		done && done.forEach(function (item) {
			var model = findModel(item);
			if (model && model.setCurrentThumbnailInfo && model.setIsDoneThumbnail) {
				model.setCurrentThumbnailInfo(false, thumbnailsModel);
				model.setIsDoneThumbnail(true);
			}
		});
	}));

	var _updateViewStateInCard = function _updateViewStateInCard(displayedCard, model) {
		var viewState = {
			canvasTabs: exploreVM.canvasTabs,
			canShowCanvasSidePanel: exploreVM.canShowCanvasSidePanel && exploreVM.canShowCanvasSidePanel(), //TODO:unit test
			thumbnailsModel: thumbnailsModel
		};
		if (model.isDisplayed === true) {
			viewState.isDisplayed = false;
		} else if (model.id === displayedCard) {
			viewState.isDisplayed = true;
		} else {
			viewState.isDisplayed = false;
		}

		if (model && model.updateViewState) {
			model.updateViewState(viewState);
		}
	};

	var updateViewStateInCard = function updateViewStateInCard(displayedCard) {
		self.items.forEach(function (model) {
			_updateViewStateInCard(displayedCard, model);
		});
	};

	//update explore VM state for displayed card when exploration is open
	updateViewStateInCard(exploreVM.displayedCard);

	//track displayed card and update corresponding card model with the state
	self._mobxDisposeEvents.push(mobx.reaction(function () {
		return self.exploreVM.displayedCard;
	}, function (displayedCard) {
		updateViewStateInCard(displayedCard);
	}));

	self._mobxDisposeEvents.push(mobx.reaction(function () {
		return self.exploreVM.canShowCanvasSidePanel();
	}, function (flag) {
		var displayedCardModel = findModel(exploreVM.displayedCard);
		if (displayedCardModel && displayedCardModel.updateCanShowCanvasSidePanel) {
			displayedCardModel.updateCanShowCanvasSidePanel(flag);
		}
	}));
}; /*
    *+------------------------------------------------------------------------+
    *| Licensed Materials - Property of IBM
    *| IBM Cognos Products: Explore
    *| (C) Copyright IBM Corp. 2018, 2020
    *|
    *| US Government Users Restricted Rights - Use, duplication or disclosure
    *| restricted by GSA ADP Schedule Contract with IBM Corp.
    *+------------------------------------------------------------------------+
    */
var ExploreContainerLayoutModelExt = exports.ExploreContainerLayoutModelExt = _mobxStateTree.types.model({}).named('ExploreContainerLayoutModelExt').props({
	type: _mobxStateTree.types.optional(_mobxStateTree.types.string, 'exploreContainer')
}).volatile(function () {
	return {
		exploreVM: null,
		cardModelUtil: _CardModelUtil2.default,
		dashboardApi: null,
		itemCount: 0,
		_mobxDisposeEvents: [],
		api: null
	};
}).actions(function (self) {

	function getCardsFromIds(ids) {
		return ids.map(function (id) {
			return self.findModel(id);
		});
	}

	function getCardIndices(cardIds) {
		var items = self.items;
		return getCardsFromIds(cardIds).map(function (card) {
			return items.indexOf(card);
		});
	}

	function getSuitableInsertBeforeId(ids) {
		var indices = getCardIndices(ids);

		var insertBefore = void 0;
		if (indices.length) {
			// Return the id AFTER the current selection.
			var index = Math.max.apply(Math, indices) + 1;
			var items = self.items;
			if (index < items.length) {
				insertBefore = items[index].id;
			}
		}
		return insertBefore;
	}

	function getNewCardOptions(options) {
		options = options || {};
		// Specify where to insert the new card.
		options.insertBefore = options.insertBefore || getSuitableInsertBeforeId(self.exploreVM.selectedCards.items);
		return options;
	}

	return {
		afterCreate: function afterCreate() {
			//when opening exploration, hide all cards except the first one
			if (self.items) {
				self.items.forEach(function (item, index) {
					if (index !== 0) {
						item.setDisplayStyleOff();
					}
				});
			}
		},
		beforeDestroy: function beforeDestroy() {
			// Remove the events.
			self._mobxDisposeEvents.forEach(function (dispose) {
				return dispose();
			});
			if (self.api) {
				self.api.destroy();
				self.api = null;
			}
		},
		setStartingPointsModel: function setStartingPointsModel(startingPointsModel) {
			self.startingPointsModel = startingPointsModel;
		},
		setCardModelUtil: function setCardModelUtil(cardModelUtil) {
			self.cardModelUtil = cardModelUtil;
		},
		addVisCard: function addVisCard(widgetSpecs, payload, options) {
			options = getNewCardOptions(options);

			var id = self.cardModelUtil.createCardFromSpec(self, widgetSpecs, {
				payload: payload || 'addVisCard',
				extraLayoutPayload: options
			});
			if (id) {
				self.itemCount++;
				if (options.selectAfterAdd) {
					self.exploreVM.setDisplayedToCard(id);
				} else {
					self.exploreVM.markCardAsNew(id);
				}
			}
			return id;
		},


		//TODO: Is this function called?
		duplicateCard: function duplicateCard(card, payload, options) {
			options = getNewCardOptions(options);
			if (card.isCompareEnabled) {
				options.model = options.model || {};
				options.model.subType = 'compare';
			}
			var id = self.cardModelUtil.createCardFromExistingCards(self, [card], {
				payload: payload || 'duplicateCard',
				extraLayoutPayload: options
			});
			if (card.isCompareEnabled) {
				self.cardModelUtil.copyPageContextAndRescope(self, {
					layoutId: card.id,
					cloneId: id
				});
			}
			if (id) {
				self.itemCount++;
			}
			return id;
		},
		duplicateCards: function duplicateCards(cards) {
			var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'duplicateCards';

			var _extraLayoutPayload = getNewCardOptions(opts);

			var options = cards.map(function (card) {
				var extraLayoutPayload = Object.assign({}, _extraLayoutPayload);
				if (card.isCompareEnabled) {
					extraLayoutPayload.model = extraLayoutPayload.model || {};
					extraLayoutPayload.model.subType = 'compare';
				}
				return {
					card: card,
					options: {
						payload: payload,
						extraLayoutPayload: extraLayoutPayload
					}
				};
			});

			var ids = self.cardModelUtil.duplicateCards(self, options);

			if (ids) {
				self.itemCount = self.itemCount + ids.length;
			}

			return ids;
		},


		/**
  * Add a comet card for the selected correlation entry.
  * This function will look for an existing comet card that matches the target and the filters used by the correlation entry
  * If one is found, we switch to it and update the selected driver
  * If none is found, then we create a new comet card using the widget spec supplied by the correlation entry
  * @param {Object} correlationEntry - object representing the correlation entry returned by the badges feature
  */
		addCometCardForCorrelation: function addCometCardForCorrelation(correlationEntry) {
			var widgetSpec = correlationEntry.widgetSpec;
			var widgets = self.dashboardApi.getCanvas().findContent();
			var compareContent = {
				visId: 'com.ibm.vis.rave2comet',
				localFilters: widgetSpec.localFilters
			};
			var matchingWidget = widgets.find(function (widget) {
				var visualization = widget.getFeature('Visualization');
				if (visualization && visualization.matches(compareContent)) {
					var dataItems = visualization.getSlots().getSlot('values').getDataItemList();
					if (dataItems && dataItems.length) {
						return correlationEntry.target === dataItems[0].getMetadataColumn().getId();
					}
				}
			});

			if (matchingWidget) {
				var model = self.findModel(matchingWidget.getId());
				// the widget id exist.. switch to the parent card
				self.exploreVM.setDisplayedToCard(model.getParent().getId());
				// Update the selections
				if (widgetSpec.customData && widgetSpec.customData.selected) {
					matchingWidget.getFeature('WidgetAPI.deprecated').getVisApi().setCustomDataDecoration('selected', widgetSpec.customData.selected);
				}
			} else {
				self.addVisCard([{ model: widgetSpec }], 'exploreSelectCometRecommendation', { selectAfterAdd: true });
			}
		},
		addCompareCardFromExisting: function addCompareCardFromExisting(card1, card2, options) {
			options = getNewCardOptions(options);
			var extraWidgetPayload = {
				properties: [{
					id: 'itemAxis.labels.layoutMode',
					value: 'stagger'
				}, {
					id: 'widget.legend.position',
					value: 'right'
				}]
			};
			options.model = options.model || {};
			options.model.subType = 'compare';
			var id = self.cardModelUtil.createCardFromExistingCards(self, [card1, card2], {
				payload: 'addCompareCardFromExisting',
				extraLayoutPayload: options,
				extraWidgetPayload: extraWidgetPayload,
				widgetIgnoredProps: ['thumbnailId']
			});
			if (id) {
				self.itemCount++;
			}
			return id;
		},
		setExploreVM: function setExploreVM(exploreVM) {
			self.exploreVM = exploreVM;

			syncExploreVMStateToCards(self);

			self._mobxDisposeEvents.push(mobx.reaction(function () {
				return self.items.length;
			}, function (len) {
				if (len === 0) {
					self.exploreVM.setDisplayedToStartingPoints();
				}
			}));
		},


		/**
   * Add cards and datasources by pasting spec from clipboard
   * @param {object} options
   * optioins example:
   * {
   * 	parentId: 'page0',
   * 	insertBefore: 'second card id',
   * 	model: {
   * 		layout: [], // array of cards
   * 		widgets: [...], //array of widgets
   *		dataSources: {}
  * 	}
  * }
  * @param {string} sender
  * @param {object} payloadData
  * @returns {object} - trigger event {eventName, value, preValue, sender, payloadData}
  */

		addFragment: function addFragment(options, sender, payloadData) {
			if (!Array.isArray(options.model.widgets)) {
				options.model.widgets = Object.values(options.model.widgets);
			}

			if (options.model.layout.items) {
				options.model.layout = Object.values(options.model.layout.items);
			}

			return self.boardModel.addFragment(getNewCardOptions(options), sender, payloadData);
		},


		/**
   * Delete an array of cards by given IDs
   *
   * @param {string[]} ids - Array of card IDs to delete
   *
   * @return {boolean} TRUE if the deletion succeeded and FALSE if the deletion failed
   */
		deleteCards: function deleteCards(ids) {
			var result = self.cardModelUtil.deleteCards(self, ids);
			//TODO: Currently we assume all ids are deleted successfully
			if (result && ids && ids.length > 0) {
				self.itemCount = self.itemCount - ids.length;
			}
			return result;
		},
		deleteVis: function deleteVis(ids) {
			var result = self.cardModelUtil.deleteVisAndSelectRemainingVis(self, ids);
			return result;
		},
		setDashboardApi: function setDashboardApi(api) {
			self.dashboardApi = api;
		},
		getDashboardApi: function getDashboardApi() {
			return self.dashboardApi;
		}
	};
});

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.WidgetLayoutModelExt = undefined;

var _mobxStateTree = __webpack_require__(7);

var _BadgeTooltipModel = __webpack_require__(194);

var _BadgeTooltipModel2 = _interopRequireDefault(_BadgeTooltipModel);

var _NaturalLanguageTextModel = __webpack_require__(73);

var _NaturalLanguageTextModel2 = _interopRequireDefault(_NaturalLanguageTextModel);

var _ImageCaptureModel = __webpack_require__(196);

var _ImageCaptureModel2 = _interopRequireDefault(_ImageCaptureModel);

var _WidgetAPI = __webpack_require__(197);

var _WidgetAPI2 = _interopRequireDefault(_WidgetAPI);

var _mobxUtils = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var WidgetLayoutModelExt = exports.WidgetLayoutModelExt = _mobxStateTree.types.model({}).volatile(function () {
	return {
		renderId: 0,
		badgesTooltipModel: null,
		nlt: null,
		imageCapture: null,
		badgesFeature: null
	};
}).views(function (self) {
	return {
		getBadgesTooltipModel: function getBadgesTooltipModel() {
			return self.badgesTooltipModel;
		},
		getImageCaptureModel: function getImageCaptureModel() {
			return self.imageCapture;
		},

		/**
   * @param {slotId} slot id of the widget, -1 means title
   * @return {object} promise with badge info
   */
		getBadgeInfoWhenReady: function getBadgeInfoWhenReady(slotId) {
			return (0, _mobxUtils.fromPromise)(self.badgesFeature ? self.badgesFeature.getBadgeDataWhenReady(slotId) : Promise.resolve([]));
		}
	};
}).actions(function (self) {
	return {
		afterCreate: function afterCreate() {
			self.badgesTooltipModel = _BadgeTooltipModel2.default.create({
				isOpen: false,
				badgesInfo: {},
				position: {}
			});

			self.nlt = _NaturalLanguageTextModel2.default.create({
				id: self.id
			}, (0, _mobxStateTree.getEnv)(self));

			self.imageCapture = _ImageCaptureModel2.default.create({
				id: self.id
			}, (0, _mobxStateTree.getEnv)(self));

			var _getEnv = (0, _mobxStateTree.getEnv)(self),
			    dashboardApi = _getEnv.dashboardApi;

			// Attach a listener to monitor the badge info change in the widget


			if (dashboardApi) {
				dashboardApi.getCanvasWhenReady().then(function (canvas) {
					return canvas.getWidgetWhenReady(self.id);
				}).then(function (widget) {
					var widgetModel = self.boardModel.findWidgetById(self.id);
					if (widgetModel && self.imageCapture) {
						self.imageCapture.setModel_HACK(widgetModel);
					}
					if (widget.getFeature) {
						var badgesFeature = widget.getFeature('vis-badges');
						if (badgesFeature) {
							badgesFeature.onBadgeSelect(self.toggleBadgeTooltip);
							self.setBadgeFeature(badgesFeature);
						}
					}
				});
			}
		},
		beforeDestroy: function beforeDestroy() {
			[self.badgesTooltipModel, self.nlt, self.imageCapture].forEach(function (model) {
				if (model) {
					(0, _mobxStateTree.destroy)(model);
				}
			});
		},
		toggleBadgeTooltip: function toggleBadgeTooltip(badgesInfo, position) {
			if (self.badgesTooltipModel.isTooltipOpen()) {
				self.badgesTooltipModel.closeTooltip();
			} else {
				self.badgesTooltipModel.openTooltip(position);
				self.badgesTooltipModel.setBadgesInfo(badgesInfo);
			}
		},
		forceRender_HACK: function forceRender_HACK() {
			self.renderId++;
		},
		setStaticWidget: function setStaticWidget(value) {
			self.isStaticWidget = value;
		},
		setBadgeFeature: function setBadgeFeature(feature) {
			self.badgesFeature = feature;
		},
		getAPI: function getAPI() {
			if (!self.api) {
				self.api = new _WidgetAPI2.default(self);
			}
			return self.api;
		}
	};
}).named('WidgetLayoutModelExt').props({
	type: _mobxStateTree.types.optional(_mobxStateTree.types.string, 'widget'),
	isStaticWidget: _mobxStateTree.types.optional(_mobxStateTree.types.boolean, false)
});

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _mobxStateTree = __webpack_require__(7);

exports.default = _mobxStateTree.types.model({
	badgesInfo: _mobxStateTree.types.frozen(),
	isOpen: _mobxStateTree.types.boolean,
	position: _mobxStateTree.types.frozen()
}).views(function (self) {
	return {
		getPosition: function getPosition() {
			return self.position;
		},
		isTooltipOpen: function isTooltipOpen() {
			return self.isOpen;
		},
		getBadgesInfo: function getBadgesInfo() {
			return self.badgesInfo;
		}
	};
}).actions(function (self) {
	return {
		closeTooltip: function closeTooltip() {
			self.isOpen = false;
		},
		openTooltip: function openTooltip(position) {
			self.isOpen = true;
			self.position = position;
		},
		setBadgesInfo: function setBadgesInfo(badgesInfo) {
			self.badgesInfo = badgesInfo;
		}
	};
}); /*
     *+------------------------------------------------------------------------+
     *| Licensed Materials - Property of IBM
     *| IBM Cognos Products: Explore
     *| (C) Copyright IBM Corp. 2018
     *|
     *| US Government Users Restricted Rights - Use, duplication or disclosure
     *| restricted by GSA ADP Schedule Contract with IBM Corp.
     *+------------------------------------------------------------------------+
     */

/***/ }),
/* 195 */,
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
                                                                                                                                                                                                                                                                               *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                               *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                               *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                               *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                               *|
                                                                                                                                                                                                                                                                               *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                               *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                               *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                               */

var _mobxStateTree = __webpack_require__(7);

exports.default = _mobxStateTree.types.model('ImageCaptureModel', {
	id: _mobxStateTree.types.string
}).volatile(function () {
	return {
		thumbnail: undefined,
		isMappingIncomplete: false,
		isDisabled: false,
		error: undefined,
		warning: undefined,

		// HACK
		// model here is temporary
		// the thumbnail service needs the model to update the thumbnail id
		// ideally there should be a clear API between this model and the service
		// (maybe through a callback or something like that).
		// ex: When the service needs to update something on the model, it
		// delegates that here and the widget model picks it up through a reaction
		model: undefined,

		readyPromise: undefined,
		feature: undefined
	};
}).views(function (self) {
	return {
		isThumbnailReady: function isThumbnailReady() {
			// a thumbnail is considered ready when:
			// 1. we have a thumbnail - our job is done
			// 2. we don't have a thumbnail because the slot mapping is incomplete
			// 3. thumbnail is disabled on purpose
			// 4. we don't have a thumbnail because there's a warning or error when capturing the thumbnail
			return !!self.thumbnail || self.isMappingIncomplete || self.isDisabled || !!self.warning || !!self.error;
		}
	};
}).actions(function (self) {
	function fetchFeature() {
		var _getEnv = (0, _mobxStateTree.getEnv)(self),
		    dashboardApi = _getEnv.dashboardApi;

		var widgetId = self.id;
		return dashboardApi.getCanvasWhenReady().then(function (canvas) {
			return canvas.getWidgetWhenReady(widgetId);
		}).then(function (widget) {
			if (widget) {
				return widget.getFeature('vis-image-capture');
			}
		});
	}

	function getService() {
		var _getEnv2 = (0, _mobxStateTree.getEnv)(self),
		    dashboardApi = _getEnv2.dashboardApi;

		return dashboardApi.getDashboardSvc('.Thumbnail');
	}

	return {
		beforeDestroy: function beforeDestroy() {
			if (self.feature) {
				if (self.feature.isActivated()) {
					self.feature.deactivate();
				}
				self.feature = undefined;
			}
			self.setModel_HACK(undefined);
			self.readyPromise = undefined;
		},
		setThumbnail: function setThumbnail(thumbnail) {
			self.thumbnail = thumbnail;
		},
		setIsMappingIncomplete: function setIsMappingIncomplete(isMappingIncomplete) {
			self.isMappingIncomplete = isMappingIncomplete;
		},
		setIsDisabled: function setIsDisabled(isDisabled) {
			self.isDisabled = isDisabled;
		},
		setError: function setError(error) {
			self.error = error;
		},
		setWarning: function setWarning(warning) {
			self.warning = warning;
		},
		setFeature: function setFeature(feature) {
			self.feature = feature;
		},


		// HACK
		// model here is temporary
		// the thumbnail service needs the model to update the thumbnail id
		// ideally there should be a clear API between this model and the service
		// (maybe through a callback or something like that).
		// ex: When the service needs to update something on the model, it
		// delegates that here and the widget model picks it up through a reaction
		setModel_HACK: function setModel_HACK(model) {
			self.model = model;
			if (model) {
				self.activateFeature();
			}
		},


		/**
   * Activate feature
   */
		activateFeature: function activateFeature() {
			self.readyPromise = fetchFeature().then(function (feature) {
				if (feature) {
					self.setFeature(feature);
					return feature.activate({
						captureHandlers: {
							success: function success(result) {

								if (!(0, _mobxStateTree.isAlive)(self)) {
									return Promise.resolve();
								}

								var thumbnail = void 0;
								var isMappingIncomplete = void 0;
								var isDisabled = void 0;
								if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object') {
									thumbnail = result.thumbnail;
									isMappingIncomplete = !!result.isMappingIncomplete;
									isDisabled = !!result.isDisabled;
								} else {
									thumbnail = result;
									isMappingIncomplete = false;
									isDisabled = false;
								}

								self.setError(undefined);
								self.setIsMappingIncomplete(isMappingIncomplete);
								self.setIsDisabled(isDisabled);
								self.setThumbnail(thumbnail);

								return getService().then(function (service) {
									return service.sync(self.model, thumbnail);
								});
							},
							error: function error(_error) {

								if (!(0, _mobxStateTree.isAlive)(self)) {
									return Promise.resolve();
								}

								self.setError(_error);
								return getService().then(function (service) {
									return service.setError(self.id, _error);
								});
							},
							warning: function warning(_warning) {
								if (!(0, _mobxStateTree.isAlive)(self)) {
									return Promise.resolve();
								}

								self.setWarning(_warning);
								return getService().then(function (service) {
									return service.setWarning(self.id, _warning);
								});
							},
							clear: function clear() {

								if (!(0, _mobxStateTree.isAlive)(self)) {
									return;
								}

								if (self.model) {
									// void the cache id
									var cacheId = undefined;
									var options = {
										payloadData: {
											runtimeOnly: true
										}
									};
									self.model.set({
										thumbnailId: cacheId
									}, options);
								}
							},
							relink: function relink() {
								if (!(0, _mobxStateTree.isAlive)(self)) {
									return;
								}

								if (self.model && self.model.thumbnailId) {
									// Wipe out the cache id when relink	
									self.model.set({
										thumbnailId: undefined
									});
								}
							}
						}
					});
				}
			});
		}
	};
});

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _mobxStateTree = __webpack_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

/**
 * a set of APIs for widget operations in Exploration
 * @module WidgetAPI
 */
var WidgetAPI = function WidgetAPI(widgetModel) {
	_classCallCheck(this, WidgetAPI);

	/**
  * To be invoked by the product only.
  */
	this.destroy = function () {
		widgetModel = null;
	};

	/**
  * @return {string} id of this card
  */
	this.getId = function () {
		return widgetModel.id;
	};

	/**
  * @return {object} Snapshot of the state
  */
	this.getState = function () {
		return (0, _mobxStateTree.getSnapshot)(widgetModel);
	};

	/**
  * @return {object} promise with nlt items
  */
	this.getInsights = function () {
		return widgetModel.nlt.fetchItems();
	};

	/**
  * @param {slotId} slot id of the widget, -1 means title
  * @return {object} promise with badge info
  */
	this.getBadgeInfoWhenReady = function (slotId) {
		return widgetModel.getBadgeInfoWhenReady(slotId);
	};
};

exports.default = WidgetAPI;

/***/ }),
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getToolBarItems = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LegacyComponent = __webpack_require__(216);

var _LegacyComponent2 = _interopRequireDefault(_LegacyComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

function getToolBarContributions(dashboardApi) {
	var collectionId = 'com.ibm.bi.explore.toolbar';

	return dashboardApi.findGlassCollection(collectionId).then(function (collection) {
		return collection || [];
	});
}

function requireItem(item) {
	var view = item.view;


	return new Promise(function (resolve, reject) {
		// Use require on window to satisfy webpack. Webpack needs to know the full tree of dependencies
		// at build time. In this case, we don't know the module path that contributers will provide through
		// their toolbar contributions so we can't 'externalize' these in webpack so that they can be ignored.
		//
		// To get around this, use window.require so that webpack sees we're just accessing some global and
		// thinks everything is fine and dandy.
		window.require([view], resolve, reject);
	});
}

function createItem(item, context, requireItemFn) {
	return requireItemFn(item).then(function (View) {
		if (isReactComponent(View)) {
			return _react2.default.createElement(View, null);
		} else {
			var view = new View(context);

			return _react2.default.createElement(_LegacyComponent2.default, {
				className: 'explore-vis-toolbar__item__container',
				item: view
			});
		}
	});
}

/**
 * Get toolbar items
 *
 * @param {DashboardAPI} dashboardApi - dashboard API
 * @param {any} context - context passed into the created toolbar item views
 * @param {Function} [requireItemFn=requireItem] - require item factory method called on each one of the toolbar items before creation; defaults to the default implementation of requireItem
 *
 * @return {Promise} resolved on success and rejected on failure
 */
function getToolBarItems(dashboardApi, context) {
	var requireItemFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : requireItem;

	return getToolBarContributions(dashboardApi).then(function (collection) {
		return Promise.all(collection.map(function (item) {
			return createItem(item, context, requireItemFn).then(function (component) {
				return {
					component: component,
					data: item
				};
			});
		}));
	});
}

// Helpers to determine if a component is a React component.

function isReactComponent(component) {
	return typeof component === 'function' && !!component.prototype.isReactComponent;
}

exports.getToolBarItems = getToolBarItems;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * A React component that wraps a legacy view; ensuring that the legacy view's render()
 * is only called when the component mounts and not every time the React component renders.
 */
var LegacyComponent = function (_Component) {
	_inherits(LegacyComponent, _Component);

	function LegacyComponent() {
		_classCallCheck(this, LegacyComponent);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	LegacyComponent.prototype.componentDidMount = function componentDidMount() {
		var _props$item = this.props.item,
		    view = _props$item === undefined ? {} : _props$item;

		if (!view.render || typeof view.render !== 'function') {
			return;
		}

		view.render();
	};

	LegacyComponent.prototype.componentWillUnmount = function componentWillUnmount() {
		var _props$item2 = this.props.item,
		    view = _props$item2 === undefined ? {} : _props$item2;

		if (!view.remove || typeof view.remove !== 'function') {
			return;
		}

		view.remove();
	};

	LegacyComponent.prototype.render = function render() {
		var _this2 = this;

		if (!this.props.item) {
			return;
		}
		return _react2.default.createElement('div', { className: this.props.className, ref: function ref(node) {
				return node && _this2.onNodeRef(node);
			} });
	};

	LegacyComponent.prototype.onNodeRef = function onNodeRef(node) {
		var _props$item3 = this.props.item,
		    view = _props$item3 === undefined ? {} : _props$item3;


		if (view.$el && view.$el.length) {
			node.appendChild(view.$el[0]);
		}
	};

	return LegacyComponent;
}(_react.Component);

LegacyComponent.propTypes = {
	item: _PropTypes2.default.object,
	className: _PropTypes2.default.string
};

exports.default = LegacyComponent;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var EXPLOREHOSTAPP = exports.EXPLOREHOSTAPP = '.ExploreHost';
var EXPLOREHOSTAPP_CONTROLLER = exports.EXPLOREHOSTAPP_CONTROLLER = '.ExploreHostAppController';

var WidgetHostApp = exports.WidgetHostApp = function () {
	function WidgetHostApp(params) {
		_classCallCheck(this, WidgetHostApp);

		this.services = params.services || {};
		this._widgetFeatures = {};
		this._idx2 = {};
	}

	WidgetHostApp.prototype.setup = function setup() {
		this.services.register(EXPLOREHOSTAPP, {
			deregisterWidget: this.deregisterWidget.bind(this),
			registerFeature: this.registerFeature.bind(this),
			deregisterFeature: this.deregisterFeature.bind(this)
		});

		this.services.register(EXPLOREHOSTAPP_CONTROLLER, {
			activateFeature: this.activateFeature.bind(this),
			getFeature: this.getFeature.bind(this)
		});
	};

	WidgetHostApp.prototype.cleanup = function cleanup() {
		this.services.deregister(EXPLOREHOSTAPP);
		this.services.deregister(EXPLOREHOSTAPP_CONTROLLER);
	};

	WidgetHostApp.prototype.deregisterWidget = function deregisterWidget(widgetId) {
		var featureNameList = this._idx2[widgetId];
		for (var key in featureNameList) {
			if (featureNameList.hasOwnProperty(key)) {
				delete this._widgetFeatures[featureNameList[key]];
			}
		}
		delete this._idx2[widgetId];
	};

	WidgetHostApp.prototype.registerFeature = function registerFeature(widgetId, featureName, api) {
		var key = this._key(widgetId, featureName);

		if (!this._widgetFeatures[key] || this._widgetFeatures[key] && !this._widgetFeatures[key].api) {

			this._idx2[widgetId] = this._idx2[widgetId] || [];
			if (this._idx2[widgetId].indexOf(key) === -1) {
				this._idx2[widgetId].push(key);
			}
			this._widgetFeatures[key] = this._widgetFeatures[key] || {};
			this._widgetFeatures[key].api = api; //TODO: use WeakMap
		}

		if (this._widgetFeatures[key].promise) {
			this._widgetFeatures[key].resolve(true);
			this._widgetFeatures[key].resolve = null;
			this._widgetFeatures[key].promise = null;
		}
	};

	WidgetHostApp.prototype.deregisterFeature = function deregisterFeature(widgetId, featureName) {
		var key = this._key(widgetId, featureName);
		if (this._widgetFeatures[key]) {
			delete this._widgetFeatures[key];
			var featureNameList = this._idx2[widgetId];
			var i = featureNameList.indexOf(key);
			if (i !== -1) {
				featureNameList.splice(i);
			}
			if (featureNameList.length === 0) {
				delete this._idx2[widgetId];
			}
		}
	};

	WidgetHostApp.prototype.activateFeature = function activateFeature(widgetId, featureName, params) {
		var _this = this;

		var key = this._key(widgetId, featureName);
		var _activate = function _activate() {
			var feature = _this._widgetFeatures[key];
			return feature && feature.api && feature.api.activate(params);
		};

		if (this._hasFeature(key)) {
			return Promise.resolve(_activate());
		}

		return this._onFeatureAvailable(key, _activate);
	};

	WidgetHostApp.prototype.getFeature = function getFeature(widgetId, featureName) {
		var _this2 = this;

		var key = this._key(widgetId, featureName);
		var _getFeature = function _getFeature() {
			return _this2._widgetFeatures[key].api;
		};

		if (this._hasFeature(key)) {
			return Promise.resolve(_getFeature());
		}

		return this._onFeatureAvailable(key, _getFeature);
	};

	WidgetHostApp.prototype._onFeatureAvailable = function _onFeatureAvailable(featureName, actionToCall) {
		var prom = new Promise(function (resolve) {
			var entry = { api: null, resolve: resolve };
			this._widgetFeatures[featureName] = entry;
		}.bind(this)).then(actionToCall);
		this._widgetFeatures[featureName].promise = prom;
		return prom;
	};

	WidgetHostApp.prototype._key = function _key(widgetId, featureName) {
		return widgetId + featureName;
	};

	WidgetHostApp.prototype._hasFeature = function _hasFeature(key) {
		return this._widgetFeatures[key];
	};

	return WidgetHostApp;
}();

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_218__;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _SmartsInterestingFieldRecommender = __webpack_require__(220);

var _SmartsInterestingFieldRecommender2 = _interopRequireDefault(_SmartsInterestingFieldRecommender);

var _SmartsRelationshipStrengthService = __webpack_require__(223);

var _SmartsRelationshipStrengthService2 = _interopRequireDefault(_SmartsRelationshipStrengthService);

var _Config = __webpack_require__(16);

var _Config2 = _interopRequireDefault(_Config);

var _SmartsPredictRecommenderService = __webpack_require__(228);

var _SmartsPredictRecommenderService2 = _interopRequireDefault(_SmartsPredictRecommenderService);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */


var SmartsRecommenderWrapper = function () {
	function SmartsRecommenderWrapper(options) {
		var _this = this;

		_classCallCheck(this, SmartsRecommenderWrapper);

		this.getRelationshipStrength = function (requestParams, context, cancel) {
			//TODO: Recreate this after Explore Error Class is created
			var cancelError = {
				'id': 'RUN_REQUEST_IN_BACKGROUND',
				getUserStrings: function getUserStrings() {
					return {
						'title': _StringResources2.default.get('startingPoints_relationship_cancel_title'),
						'message': _StringResources2.default.get('startingPoints_relationship_cancel_description'),
						'suggestions': _StringResources2.default.get('startingPoints_relationship_cancel_suggestions')
					};
				}
			};
			cancel = cancel.catch(function () {
				return Promise.reject(cancelError);
			});
			return Promise.race([_this._getRelationshipStrength(requestParams, context), cancel]);
		};

		this.dashboardApi = options.dashboardApi;
		this.services = options.services;
		this.smartsInterestingFieldRecommender = options.smartsInterestingFieldRecommender || new _SmartsInterestingFieldRecommender2.default({
			dashboardApi: options.dashboardApi,
			requestName: 'SmartsInterestingFieldRecommender'
		});
		this.smartsRelationshipStrengthService = options.smartsRelationshipStrengthService || new _SmartsRelationshipStrengthService2.default({
			dashboardApi: options.dashboardApi,
			requestName: 'SmartsRelationshipStrengthService'
		});
		this.smartsPredictRecommenderService = options.smartsPredictRecommenderService || new _SmartsPredictRecommenderService2.default({
			dashboardApi: options.dashboardApi,
			requestName: 'SmartsPredictRecommenderService'
		});
		this.logger = options.logger || {
			debug: function debug() {},
			error: function error() {}
		};
	}

	SmartsRecommenderWrapper.prototype.getModule = function getModule(dataSourceId) {
		return this.dashboardApi.getFeature('dataSources.deprecated').getModule(dataSourceId);
	};

	SmartsRecommenderWrapper.prototype.getMetadataColumns = function getMetadataColumns(dataSourceId) {
		return this.getModule(dataSourceId).then(function (module) {
			return module.getMetadataColumns(function (col) {
				return !col.isHidden() && (col.getType() === 'fact' || col.getType() === 'attribute');
			});
		});
	};

	SmartsRecommenderWrapper.prototype.recommendInterestingFields = function recommendInterestingFields(dataSourceId) {
		var fieldRecommender = this.smartsInterestingFieldRecommender;
		return this.getModule(dataSourceId).then(function (module) {
			return fieldRecommender.recommendInterestingFields({
				module: module
			});
		});
	};

	/*
  * @param {object} payload
  * 	{
  * 		dataSourceId: xxx,
  * 		targetId: xxx,
  * 		maxInfluencerFields: xxx,
  * 		showConcepts: xxx,
  * 		transformOptions: {}
  * 		context: {
  * 			relationshipVM: obj
  * 		}
  * 	}
  */
	SmartsRecommenderWrapper.prototype._getRelationshipStrength = function _getRelationshipStrength(payload) {
		var _this2 = this;

		return this.getModule(payload.dataSourceId).then(function (module) {
			var requestParams = {
				sourceModuleId: module.getAssetId(),
				sourceType: module.getSourceType(),
				targetFieldIDForExpression: payload.targetId,
				maxInfluencerFields: payload.maxInfluencerFields ? payload.maxInfluencerFields : _Config2.default.max_nodes_to_display,
				showConcepts: payload.showConcepts,
				// for debugger purpose (when set to true, Smarts will add the section "exploreSpec" that contains all influencer nodes that Smarts send to Predict before any filtering)
				includeSmartsExploreSpec: false,
				shapedModule: !!module.getShapingId(), //indicates that there is shaping
				requestId: payload.requestId
			};
			_this2._addRequestParams(requestParams, payload);
			var tempSessionModuleJSON = module.getTemporarySessionModuleJSON();
			if (tempSessionModuleJSON) {
				requestParams.tempModule = JSON.stringify(tempSessionModuleJSON);
			}
			return _this2.smartsRelationshipStrengthService.getRelationshipStrength(requestParams, {
				moduleAPI: module,
				glassContext: _this2.services.biGlass.glassContext,
				model: payload.context.relationshipVM,
				transformOptions: payload.context.transformOptions,
				dataSourceId: payload.dataSourceId
			});
		});
	};

	SmartsRecommenderWrapper.prototype._addRequestParams = function _addRequestParams(requestParams, payload) {
		if (payload && payload.context && payload.context.transformOptions && payload.context.transformOptions.lastAddedField) {
			requestParams = _extends({}, requestParams, payload.context.transformOptions);
		}
	};

	SmartsRecommenderWrapper.prototype.recommendRelatedVisualizationsAsWidgetSpecs = function recommendRelatedVisualizationsAsWidgetSpecs(dataSourceId) {
		var columnIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
		var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

		var smartsRecommender = this.dashboardApi.getFeature('SmartsRecommender.deprecated');
		var visDefinitions = this.dashboardApi.getFeature('VisDefinitions');
		return smartsRecommender.recommendRelatedVisualizationsAsWidgetSpecs(dataSourceId, columnIds, !!options.includeBestVisForTargetFields).then(function (items) {
			return items.map(function (item) {
				return {
					widgets: [{
						spec: item.spec,
						visDefinition: visDefinitions.getById(item.spec.visId)
					}],
					name: item.name
				};
			});
		});
	};

	SmartsRecommenderWrapper.prototype.getAlternativeVisualizations = function getAlternativeVisualizations(widget) {
		var _this3 = this;

		if (!this._hasDataItems(widget)) {
			return Promise.resolve([]);
		}

		var smartVisRecommender = this._getSmartVisRecommender(widget);
		if (!smartVisRecommender || !smartVisRecommender.recommendAlternateVisualizationsAsWidgetSpecs) {
			return Promise.resolve([]);
		}

		return smartVisRecommender.recommendAlternateVisualizationsAsWidgetSpecs().then(function (recommendations) {
			var visDefinitions = _this3.dashboardApi.getFeature('VisDefinitions');
			// alternative vis means everything except the current select widget vis type
			// TODO: ideally we would send an arg to the recommender to tell what charts to include and exclude so we don't have to do that
			return recommendations.filter(function (item) {
				return item.spec.visId !== widget.getVisId();
			}).map(function (item) {
				// enhance the alternative recommendations response with more data needed by the view
				return {
					widgets: [{
						spec: item.spec,
						visDefinition: visDefinitions.getById(item.spec.visId)
					}],
					name: item.name
				};
			});
		});
	};

	SmartsRecommenderWrapper.prototype.getRelatedVisualizations = function getRelatedVisualizations(widget) {
		var _this4 = this;

		if (!this._hasDataItems(widget)) {
			return Promise.resolve([]);
		}

		var smartVisRecommender = this._getSmartVisRecommender(widget);
		if (!smartVisRecommender || !smartVisRecommender.recommendRelatedVisualizationsAsWidgetSpecs) {
			return Promise.resolve([]);
		}

		return smartVisRecommender.recommendRelatedVisualizationsAsWidgetSpecs().then(function (recommendations) {
			var visDefinitions = _this4.dashboardApi.getFeature('VisDefinitions');
			return recommendations.map(function (item) {
				// enhance the recommended response with more data needed by the view
				return {
					widgets: [{
						spec: item.spec,
						visDefinition: visDefinitions.getById(item.spec.visId)
					}],
					name: item.name
				};
			});
		});
	};

	SmartsRecommenderWrapper.prototype._getSmartVisRecommender = function _getSmartVisRecommender(widget) {
		return this._getWidgetContent(widget).getFeature('Visualization.SmartsRecommender.deprecated');
	};

	SmartsRecommenderWrapper.prototype._hasDataItems = function _hasDataItems(widget) {
		if (widget) {
			var vis = this._getWidgetContent(widget).getFeature('Visualization');
			if (vis) {
				var slots = vis.getSlots();
				var itemList = slots && slots.getDataItemList();
				return Array.isArray(itemList) && itemList.length > 0;
			}
			return false;
		}
		return false;
	};

	SmartsRecommenderWrapper.prototype._getWidgetContent = function _getWidgetContent(widget) {
		return this.dashboardApi.getCanvas().getContent(widget.getId());
	};

	SmartsRecommenderWrapper.prototype.fetchRecommendations = function fetchRecommendations(widget, type) {
		var fetch = {
			'alternative': this.getAlternativeVisualizations.bind(this),
			'related': this.getRelatedVisualizations.bind(this)
		}[type];

		if (fetch) {
			return fetch(widget);
		} else {
			return Promise.resolve();
		}
	};

	SmartsRecommenderWrapper.prototype.fetchPredictRecommendations = function fetchPredictRecommendations(dataSourceId, targetId) {
		var _this5 = this;

		return this.getModule(dataSourceId).then(function (module) {
			return _this5.smartsPredictRecommenderService.fetchPredictRecommendations({
				moduleAPI: module,
				targetId: targetId
			});
		});
	};

	return SmartsRecommenderWrapper;
}();

exports.default = SmartsRecommenderWrapper;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _SmartsInterestingFieldRecommenderService = __webpack_require__(221);

var _SmartsInterestingFieldRecommenderService2 = _interopRequireDefault(_SmartsInterestingFieldRecommenderService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Dashboard
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */


var _ = __webpack_require__(8);
var DEFAULT_LIMIT_INTETRESTING_FIELDS = 20;

var SmartsInterestingFieldRecommender = function () {
	function SmartsInterestingFieldRecommender(params) {
		_classCallCheck(this, SmartsInterestingFieldRecommender);

		this.dashboardApi = params.dashboardApi;

		this.logger = params.logger || {
			debug: function debug() {},
			error: function error() {}
		};

		this.recommenderService = params.smartsInterestingFieldRecommenderService || new _SmartsInterestingFieldRecommenderService2.default({
			ajaxSvc: this.dashboardApi.getGlassCoreSvc('.Ajax'),
			logger: this.logger,
			requestName: 'SmartsInterestingFieldRecommender'
		});
	}

	SmartsInterestingFieldRecommender.prototype._addCommonRequestParameters = function _addCommonRequestParameters(requestParameters, options) {

		var module = options.module;

		var commonRequestParameters = {
			moduleId: module.getAssetId(),
			numResults: options.numResults || DEFAULT_LIMIT_INTETRESTING_FIELDS,
			sourceType: module.getSourceType(),
			shapedModule: !!module.getShapingId() //indicates that there is shaping
		};

		var tempSessionModuleJSON = module.getTemporarySessionModuleJSON();
		if (tempSessionModuleJSON) {
			commonRequestParameters.tempModule = JSON.stringify(tempSessionModuleJSON);
		}

		return module.saveTemporaryModule().then(function (shapingModuleId) {
			if (module.getAssetId() !== shapingModuleId) {
				commonRequestParameters.tempModuleId = shapingModuleId;
			}
			return _.extend({}, requestParameters, commonRequestParameters);
		});
	};

	SmartsInterestingFieldRecommender.prototype.recommendInterestingFields = function recommendInterestingFields(options) {
		var _this = this;

		var requestParameters = {};

		return this._addCommonRequestParameters(requestParameters, options).then(function (requestParameters) {
			return _this.recommenderService.recommendInterestingFields(requestParameters);
		}).then(function (recommendedFields) {
			return _this._transformRecommendationListResponse(recommendedFields, options);
		});
	};

	SmartsInterestingFieldRecommender.prototype._transformRecommendationListResponse = function _transformRecommendationListResponse(recommendedFields, options) {
		var _this2 = this;

		return Promise.all(recommendedFields.map(function (field) {
			return _this2._transformRecommendationResponse(field, options);
		}));
	};

	SmartsInterestingFieldRecommender.prototype._transformRecommendationResponse = function _transformRecommendationResponse(field, options) {
		var column = options.module.getMetadataColumn(field.fieldIDForExpression);
		return {
			name: column.getLabel(),
			id: column.getId()
		};
	};

	return SmartsInterestingFieldRecommender;
}();

exports.default = SmartsInterestingFieldRecommender;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _SmartsRecommenderService = __webpack_require__(46);

var _SmartsRecommenderService2 = _interopRequireDefault(_SmartsRecommenderService);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Dashboard
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2017, 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var USER_MESSAGES = {
	'Smarts-IFR-49': {
		'title': _StringResources2.default.get('error_something_unexpected'),
		'description': _StringResources2.default.get('startingPoints_unsupported_source_type_toast')
	},
	'Smarts-IFR-21': {
		'title': _StringResources2.default.get('error_something_unexpected'),
		'description': _StringResources2.default.get('startingPoints_unenriched_package_toast')
	},
	'Smarts-IFR-45': {
		'title': _StringResources2.default.get('startingPoints_error_title_relationshipDiagram_missingSmartsModule'),
		'description': _StringResources2.default.get('startingPoints_error_instructions_missingSmartsModule')
	},
	'Smarts-IFR-48': {
		'title': _StringResources2.default.get('startingPoints_error_title_relationshipDiagram_missingSmartsModule'),
		'description': _StringResources2.default.get('startingPoints_error_instructions_missingSmartsModule')
	}
};

var SmartsInterestingFieldRecommenderService = function (_SmartsRecommenderSer) {
	_inherits(SmartsInterestingFieldRecommenderService, _SmartsRecommenderSer);

	function SmartsInterestingFieldRecommenderService(options) {
		_classCallCheck(this, SmartsInterestingFieldRecommenderService);

		return _possibleConstructorReturn(this, _SmartsRecommenderSer.call(this, options));
	}

	SmartsInterestingFieldRecommenderService.prototype.recommendInterestingFields = function recommendInterestingFields(requestParams) {
		var SMARTS_ROOT = 'v1/smarts';
		var INTERESTING_FIELDS_URL = SMARTS_ROOT + '/insights/interesting-fields';
		this.logger.debug('recommendInterestingFields');

		return this._executeRequest(requestParams, INTERESTING_FIELDS_URL).catch(this._handleError.bind(this)).then(this._processResponse.bind(this));
	};
	/**
  * @override getErrorCodeMappings from SmartsRecommenderService
  * @return {Object} a map that contains map of <error_Code> : { 'title' : xxx, 'description': xxx}
  */


	SmartsInterestingFieldRecommenderService.prototype.getErrorCodeMappings = function getErrorCodeMappings() {
		return USER_MESSAGES;
	};

	return SmartsInterestingFieldRecommenderService;
}(_SmartsRecommenderService2.default);

exports.default = SmartsInterestingFieldRecommenderService;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Error for when there's an issue getting a response from the smarts service
 * @param {object} options
 * @param {string} options.requestName - name of smarts request
 * @param {string} options.responseMessage - description of error from http response / smarts payload
 * @param {string} [options.httpCode] - in case of http error, the error code
 * @param {string} [options.smartsCode] - in case of smarts service error, the smarts error code
 */
function SmartsRecommenderError(options) {
  this.name = 'SmartsRecommenderError';
  this.message = options.message || 'Error executing ' + options.requestName + ' - ' + (options.httpCode || options.smartsCode) + ': ' + options.responseMessage;

  this.requestName = options.requestName;
  this.httpCode = options.httpCode;
  this.smartsCode = options.smartsCode;
  this.responseMessage = options.responseMessage;
}

SmartsRecommenderError.prototype = Object.create(Error.prototype);

SmartsRecommenderError.prototype.setUserStrings = function (title, message, suggestions) {
  this.userTitle = title;
  this.userMessage = message;
  this.suggestions = suggestions;
};

SmartsRecommenderError.prototype.getUserStrings = function () {
  return this.userTitle || this.userMessage || this.suggestions ? {
    title: this.userTitle,
    message: this.userMessage,
    suggestions: this.suggestions
  } : null;
};

exports.default = SmartsRecommenderError;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Config = __webpack_require__(16);

var _Config2 = _interopRequireDefault(_Config);

var _SmartsRecommenderService = __webpack_require__(46);

var _SmartsRecommenderService2 = _interopRequireDefault(_SmartsRecommenderService);

var _RelationshipBaseRequestHandler = __webpack_require__(48);

var _RelationshipBaseRequestHandler2 = _interopRequireDefault(_RelationshipBaseRequestHandler);

var _RelationshipScopeRequestHandler = __webpack_require__(224);

var _RelationshipScopeRequestHandler2 = _interopRequireDefault(_RelationshipScopeRequestHandler);

var _ShowRelationshipRequestHandler = __webpack_require__(225);

var _ShowRelationshipRequestHandler2 = _interopRequireDefault(_ShowRelationshipRequestHandler);

var _StartingPointsRequestError = __webpack_require__(226);

var _StartingPointsRequestError2 = _interopRequireDefault(_StartingPointsRequestError);

var _RelationshipUtil = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Dashboard
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * This class fetches relationship digram raw data. If enabled, it caches
 * a hard-coded number of entries of fetched data for each target ID.
 * The cache is cleared upon a new request made for a new source model ID.
 *
 * @extends SmartsRecommenderService
 */
var SmartsRelationshipStrengthService = function (_SmartsRecommenderSer) {
	_inherits(SmartsRelationshipStrengthService, _SmartsRecommenderSer);

	function SmartsRelationshipStrengthService(options) {
		_classCallCheck(this, SmartsRelationshipStrengthService);

		var _this = _possibleConstructorReturn(this, _SmartsRecommenderSer.call(this, options));

		_this._dataCache = null;
		return _this;
	}

	/**
 * @param {JSONObject} requestParams Query specifications (request payload)
 * @param {JSONObject} context Context of the query, such as the associatd module API
 */


	SmartsRelationshipStrengthService.prototype.getRelationshipStrength = function getRelationshipStrength(requestParams, context) {
		context.targetModel = context.model.getTargetModel();
		this.logger.debug('getRelationshipStrength');
		var requestOptions = {
			groupingNode: requestParams.showConcepts === true,
			lowestConcept: true
		};
		this._setTimeout(requestOptions, context);
		return this.fetchData(requestParams, requestOptions, context).catch(this._handleError.bind(this));
	};

	SmartsRelationshipStrengthService.prototype._setTimeout = function _setTimeout(requestOptions, context) {
		if (context.model && context.model.allowLongRunningRequest && !context.model.allowLongRunningRequest()) {
			requestOptions.timeout = _Config2.default.max_request_waiting_time;
		}
	};

	//handle error specifically, if cannot handel, then call parent's _handleError


	SmartsRelationshipStrengthService.prototype._handleError = function _handleError(ajaxResponse) {
		if (ajaxResponse) {
			//handle specifically
			//1. handle abandoned request
			if (ajaxResponse.code === _RelationshipBaseRequestHandler.ABANDONED_RELATIONSHIP_REQUEST) {
				var abandonedError = _StartingPointsRequestError2.default.getErrorObject(_RelationshipBaseRequestHandler.ABANDONED_RELATIONSHIP_REQUEST);
				abandonedError.abandonedRequest = ajaxResponse.abandonedRequest;
				throw abandonedError;
			}

			//
			var error = ajaxResponse.data && ajaxResponse.data.errors && ajaxResponse.data.errors[0];
			if (error) {
				var code = error.code; //External HTTP request Error

				if (code) {
					var handledError = _StartingPointsRequestError2.default.getErrorObject(code); //Get Internal Error
					if (handledError) {
						throw handledError;
					}
				}
			}
		}
		//if cannot handel,  call parent's _handleError
		_SmartsRecommenderSer.prototype._handleError.call(this, ajaxResponse);
	};

	/**
  * Resolve data from data cache as long as cache is enabled and data is available.
  * Otherwise, fetch data via Ajax call made to /relationship endpoint
  *
  * @param{object} querySpec	Query specifications (request payload)
  * @param{object} requestOptions request opions, such as { timeout : 120000, xxx: xxxx, ...}
  * @param{object} context	context such as Model APIs
  * @return {promise}
  */


	SmartsRelationshipStrengthService.prototype.fetchData = function fetchData(querySpec, requestOptions, context) {
		// Regardless of we go to network or using cache, if it is the case that `diagramData` is used,
		// then we need to access `diagramData` inside `context`, so anyway set `diagramData` to context,
		// if we `_needDiagramData` is true
		this._setDiagramData(context);
		if (_Config2.default.use_cached_data) {
			var cachedData = null;
			var targetRawData = this._getCachedRawData(querySpec, context);
			var isFilterStrengthFeatureEnabled = context.model.getIsFilterStrengthFeatureEnabled();

			if (targetRawData) {
				if (!isFilterStrengthFeatureEnabled) {
					// R2 behavior: return cached raw data
					cachedData = targetRawData;
				} else {
					// R3 behavior
					var transformOptions = context && context.transformOptions;
					context.rawData = targetRawData;
					if (!this._ignoreCacheData(context.rawData, transformOptions, querySpec)) {
						cachedData = targetRawData;
					}
				}
			}
			if (cachedData) {
				if (isFilterStrengthFeatureEnabled) {
					cachedData = (0, _RelationshipUtil.applyTransforms)(context);
				}
				return Promise.resolve(cachedData);
			}
		}
		return this._sendRequest(querySpec, requestOptions, context);
	};

	SmartsRelationshipStrengthService.prototype._sendRequest = function _sendRequest(querySpec, requestOptions, context) {
		return this._getRequestHandler(context)._sendRequest(querySpec, requestOptions, context, this);
	};

	/**
  * Provide the right request handler for the given context of actions
  * TODO: Currently, the base service of this servie has embedded logic to handle request
  * In the future, we should do more refacotoring to make the flow clear and more tiered.
  */


	SmartsRelationshipStrengthService.prototype._getRequestHandler = function _getRequestHandler(context) {
		if (context && context.transformOptions) {
			var transformOptions = context.transformOptions;
			if (transformOptions.lastAddedFields || transformOptions.scopedFields) {
				return _RelationshipScopeRequestHandler2.default;
			} else if (transformOptions.lastShowRelationshipsField) {
				return _ShowRelationshipRequestHandler2.default;
			} else {
				return _RelationshipBaseRequestHandler2.default;
			}
		}
		return _RelationshipBaseRequestHandler2.default;
	};

	/**
  * Determine if we should ignore the cached data we found
  * @param {object} cache
  * @param {object} transformOptions
  * @param {object} querySpec
  */


	SmartsRelationshipStrengthService.prototype._ignoreCacheData = function _ignoreCacheData(cache, transformOptions, querySpec) {
		if (transformOptions.lastAddedFields || transformOptions.scopedFields || transformOptions.lastShowRelationshipsField) {
			if (cache) {
				if (transformOptions.lastAddedFields) {
					var fieldsToSearch = transformOptions.lastAddedFields;
					var result = (0, _RelationshipUtil.findNodesFromCache)(fieldsToSearch, cache);
					//if any of the searched fields is not found, then we ignore cache
					if (result.unfoundNodeIds.length > 0) {
						transformOptions.unfoundNodes = result.unfoundNodeIds;
						return true;
					} else {
						return false;
					}
				} else if (transformOptions.scopedFields) {
					return true;
				} else if (transformOptions.lastShowRelationshipsField) {
					var lastShowRelationshipsField = transformOptions.lastShowRelationshipsField;
					var from = lastShowRelationshipsField.from,
					    to = lastShowRelationshipsField.to;
					// we first find the direct link from the raw data of current target
					// if we cannot find it, we then find it in the raw data of `from` and `to`
					// when they are the target, if we found it then we should not ignore raw cache
					// if we cannot find, then we should go to network

					var _result = (0, _RelationshipUtil.findDirectLink)(from, to, cache) || this._findDirectLinkInRawDataOfTwoNodes(from, to, querySpec.sourceModuleId);
					if (_result) {
						lastShowRelationshipsField.relationship = {
							toNode: _result.nodeTwo,
							link: _result.link
						};
						return false;
					} else {
						return true;
					}
				}
			} else {
				return true;
			}
		}
		return false;
	};

	/**
  * Find direct link between raw data of the two nodes(i.e., the raw data when they are the target)
  * @param {string} from - from field id
  * @param {string} to - to field id
  * @param {string} sourceModuleId - sourceModuleId
  * @returns {Object} {nodeOne, nodeTwo, link: link} - nodeOne is the node for`from` field, nodeTwo is the node for`to` field
  */


	SmartsRelationshipStrengthService.prototype._findDirectLinkInRawDataOfTwoNodes = function _findDirectLinkInRawDataOfTwoNodes(nodeOne, nodeTwo, sourceModuleId) {
		var _this2 = this;

		var foundDirectRelationship = null;
		if (this._dataCache && this._dataCache.length) {
			[nodeOne, nodeTwo].find(function (field) {
				var dataCacheEntry = _this2._dataCache.find(function (entry) {
					return entry.sourceModuleId === sourceModuleId && entry.targetId === field;
				});
				var rawData = dataCacheEntry && dataCacheEntry.rawData;
				var result = rawData && (0, _RelationshipUtil.findDirectLink)(nodeOne, nodeTwo, rawData);
				if (result) {
					foundDirectRelationship = result;
					return true;
				} else {
					return false;
				}
			});
		}
		return foundDirectRelationship;
	};

	/**
  * @private
  * set `diagramData` to context if needed
  * @param {object} context - contains information for data transformation
  */


	SmartsRelationshipStrengthService.prototype._setDiagramData = function _setDiagramData(context) {
		if (context && context.transformOptions && this._needDiagramData(context.transformOptions)) {
			context.diagramData = context.targetModel && context.targetModel.getDiagramData();
		}
	};

	/**
  * get cached raw data
  * @param {object} querySpec - querySpec
  */


	SmartsRelationshipStrengthService.prototype._getCachedRawData = function _getCachedRawData(querySpec, context) {
		var _this3 = this;

		var sourceModuleId = querySpec.sourceModuleId,
		    targetId = querySpec.targetFieldIDForExpression,
		    maxInfluencerFields = querySpec.maxInfluencerFields;

		if (this._dataCache && this._dataCache.length > 0) {
			var targetData = this._dataCache.find(function (entry) {
				return entry.targetId === targetId && entry.sourceModuleId === sourceModuleId && (_this3._isAddFieldOrScopeFeatureEnabled(context.model) ? true : entry.maxInfluencerFields === maxInfluencerFields);
			});
			return targetData && targetData.rawData;
		}
		return null;
	};

	SmartsRelationshipStrengthService.prototype.getDataCache = function getDataCache() {
		return this._dataCache;
	};

	/**
  * Determine if the `diagramData` is needed
  * @param {object} transformOptions
  */


	SmartsRelationshipStrengthService.prototype._needDiagramData = function _needDiagramData(transformOptions) {
		if (transformOptions.deletedFields || transformOptions.lastAddedFields || transformOptions.lastShowRelationshipsField) {
			return true;
		}
	};

	SmartsRelationshipStrengthService.prototype._isAddFieldOrScopeFeatureEnabled = function _isAddFieldOrScopeFeatureEnabled(relationpVM) {
		if (relationpVM) {
			return relationpVM.isAddFieldFeatureEnabled() || relationpVM.isEditScopeFeatureEnabled();
		} else {
			return false;
		}
	};

	/**
  * Add fetcehd data to data cache if cache is enabled
  *
  * @private
  */


	SmartsRelationshipStrengthService.prototype._addRawDataToCache = function _addRawDataToCache(querySpec, response, context) {
		if (!_Config2.default.use_cached_data) {
			return;
		}
		if (this._dataCache == null) {
			this.initDataCache();
		}
		//do format relationship strength before we add the data to cache
		this._formatRelationshipStrengthFormat(response);

		if (querySpec.sourceModuleId && querySpec.targetFieldIDForExpression) {
			this.removeDatedEntriesFromCache(querySpec.sourceModuleId, querySpec.targetFieldIDForExpression);
			this._removeOldestEntryWhenMaxReaches(context);
			var cacheEntry = { sourceModuleId: querySpec.sourceModuleId, dataSourceId: context.dataSourceId, targetId: querySpec.targetFieldIDForExpression, rawData: response };
			if (!this._isAddFieldOrScopeFeatureEnabled(context.model)) {
				cacheEntry.maxInfluencerFields = querySpec.maxInfluencerFields;
			}
			this._dataCache.push(cacheEntry);
		}
	};

	SmartsRelationshipStrengthService.prototype._formatRelationshipStrengthFormat = function _formatRelationshipStrengthFormat(rawData) {
		var linkDataset = rawData && rawData.relationshipStrength && rawData.relationshipStrength.results && rawData.relationshipStrength.results.length ? rawData.relationshipStrength.results[0].relationships : [];
		linkDataset.forEach(function (link) {
			(0, _RelationshipUtil.formatLinkStrength)(link);
		});
	};

	SmartsRelationshipStrengthService.prototype.initDataCache = function initDataCache() {
		this._dataCache = [];
	};

	/**
  * Remove entries that contain the passed source module Id
  * if source
  * @param{string} sourceModuleId
  */


	SmartsRelationshipStrengthService.prototype.removeEntriesFromCache = function removeEntriesFromCache(sourceModuleId) {
		if (this._dataCache && this._dataCache.length > 0) {
			var index = this._dataCache.length;
			while (index--) {
				if (this._dataCache[index].sourceModuleId === sourceModuleId) {
					this._dataCache.splice(index, 1);
				}
			}
		}
	};

	/**
  * Remove the cached entries that have the passed in source module ID, targetID
  * @param{string} sourceModuleId source module ID
  * @param {string} tagetId Target ID
  */


	SmartsRelationshipStrengthService.prototype.removeDatedEntriesFromCache = function removeDatedEntriesFromCache(sourceModuleId, targetId) {
		if (this._dataCache && this._dataCache.length > 0) {
			var index = this._dataCache.length;
			var entry = void 0;
			while (index--) {
				entry = this._dataCache[index];
				if (entry.sourceModuleId === sourceModuleId && entry.targetId === targetId) {
					this._dataCache.splice(index, 1);
				}
			}
		}
	};

	SmartsRelationshipStrengthService.prototype._removeOldestEntryWhenMaxReaches = function _removeOldestEntryWhenMaxReaches(context) {
		/*We remove the oldest entry if before adding a new entry, the cache length reaches limits*/
		if (this._dataCache && this._dataCache.length === _Config2.default.max_cached_data_pool_length) {
			var removedDataCache = this._dataCache.shift();
			var relationshipVM = context.model;
			relationshipVM.destroyTargetModel(removedDataCache.dataSourceId, removedDataCache.targetId);
		}
	};

	SmartsRelationshipStrengthService.prototype._handlePredictStatus = function _handlePredictStatus(smartsResponse) {
		var predictStatus = smartsResponse.relationshipStrength && smartsResponse.relationshipStrength.predictStatus ? smartsResponse.relationshipStrength.predictStatus : null;
		if (predictStatus) {
			if (predictStatus.errors && predictStatus.errors.length) {
				this.logger.error('Predict error:' + JSON.stringify(predictStatus.errors));
			}
			if (predictStatus.warnings && predictStatus.warnings.length) {
				this.logger.error('Predict warning:' + JSON.stringify(predictStatus.warnings));
			}
		}
	};

	return SmartsRelationshipStrengthService;
}(_SmartsRecommenderService2.default);

exports.default = SmartsRelationshipStrengthService;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _RelationshipBaseRequestHandler = __webpack_require__(48);

var _RelationshipBaseRequestHandler2 = _interopRequireDefault(_RelationshipBaseRequestHandler);

var _RelationshipUtil = __webpack_require__(24);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Dashboard
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 *
 * This class handles scoping related request, such as addedField, Scoped Fields
 *
 * @extends RelationshipBaseRequestHandler
 */
var RelationshipScopeRequestHandler = function (_RelationshipBaseRequ) {
	_inherits(RelationshipScopeRequestHandler, _RelationshipBaseRequ);

	function RelationshipScopeRequestHandler() {
		_classCallCheck(this, RelationshipScopeRequestHandler);

		return _possibleConstructorReturn(this, _RelationshipBaseRequ.apply(this, arguments));
	}

	/*Add query parameters based on the context*/
	RelationshipScopeRequestHandler._addQueryParams = function _addQueryParams(querySpec, context) {
		// Add common parameters for all cases first
		return _RelationshipBaseRequ._addQueryParams.call(this, querySpec, context).then(function () {
			var fields = [];
			var lastAddedFields = context.transformOptions.lastAddedFields;
			var scopedFields = context.transformOptions.scopedFields;
			if (lastAddedFields) {
				var rawData = context.rawData;
				if (rawData) {
					fields = (0, _RelationshipUtil.getAllFieldNodesFromDiagramCache)(rawData, true /*exclude focus field*/) || [];
					lastAddedFields.forEach(function (field) {
						if (fields.indexOf(field) === -1) {
							fields.push(field);
						}
					});
				}
			} else if (scopedFields) {
				fields = scopedFields;
			}
			querySpec.exploreAnalysisScope = JSON.stringify({ inScopeTables: context.targetModel.buildScopedFields(fields) });
		});
	};

	/**
  * @Overriden RelationshipBaseRequestHandler._callback
  * TODO: verify if this function is really needed
  */


	RelationshipScopeRequestHandler._callback = function _callback(response, context) {
		var lastAddedFields = context.transformOptions.lastAddedFields;
		if (lastAddedFields) {
			var result = (0, _RelationshipUtil.addFields)(context.diagramData, response, { addedFields: lastAddedFields, targetId: context.model.getCurrentTargetId(), showPrimaryRelationshipView: true });
			if (result && result.unfoundNodeIds.length) {
				context.targetModel.setActionInfoStatus(_StringResources2.default.get('startingPoints_no_direct_relationship', { columndIDAndLabel: JSON.stringify(result.unfoundNodeIds) }));
			}
		}
	};

	return RelationshipScopeRequestHandler;
}(_RelationshipBaseRequestHandler2.default);

exports.default = RelationshipScopeRequestHandler;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _RelationshipBaseRequestHandler = __webpack_require__(48);

var _RelationshipBaseRequestHandler2 = _interopRequireDefault(_RelationshipBaseRequestHandler);

var _RelationshipUtil = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Dashboard
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 *
 * This class handles show relationship request
 *
 * @extends RelationshipBaseRequestHandler
 */
var ShowRelationshipRequestHandler = function (_RelationshipBaseRequ) {
	_inherits(ShowRelationshipRequestHandler, _RelationshipBaseRequ);

	function ShowRelationshipRequestHandler() {
		_classCallCheck(this, ShowRelationshipRequestHandler);

		return _possibleConstructorReturn(this, _RelationshipBaseRequ.apply(this, arguments));
	}

	/**
  * @Overriden RelationshipBaseRequestHandler._sendRequest
  */
	ShowRelationshipRequestHandler._sendRequest = function _sendRequest(querySpec, requestOptions, context, service) {
		var lastShowRelationshipsField = context.transformOptions.lastShowRelationshipsField;
		if (lastShowRelationshipsField) {
			//do a request to get data for field `from
			querySpec.targetFieldIDForExpression = lastShowRelationshipsField.from;
		}
		return _RelationshipBaseRequ._sendRequest.call(this, querySpec, requestOptions, context, service);
	};

	ShowRelationshipRequestHandler._callback = function _callback(ajaxResponseData, context) {
		var lastShowRelationshipsField = context.transformOptions.lastShowRelationshipsField;
		if (lastShowRelationshipsField) {
			var result = (0, _RelationshipUtil.findDirectLink)(lastShowRelationshipsField.from, lastShowRelationshipsField.to, ajaxResponseData);
			if (result) {
				lastShowRelationshipsField.relationship = {
					toNode: result.nodeTwo,
					link: (0, _RelationshipUtil.formatLinkStrength)(result.link)
				};
			}
		}
	};

	/**
  * @Overriden RelationshipBaseRequestHandler._handleResponse
  */


	ShowRelationshipRequestHandler._handleResponse = function _handleResponse(querySpec, ajaxResponse, context, service) {
		var ajaxResponseData = ajaxResponse.data;
		if (service._isSucessfulResponse(ajaxResponseData)) {
			service._handlePredictStatus(ajaxResponseData);
			this._callback(ajaxResponseData, context);
			ajaxResponseData = (0, _RelationshipUtil.applyTransforms)(context);
			return Promise.resolve(ajaxResponseData);
		} else {
			throw service._createError({
				smartsCode: ajaxResponseData.status.statusCode,
				responseMessage: ajaxResponseData.status.message
			});
		}
	};

	return ShowRelationshipRequestHandler;
}(_RelationshipBaseRequestHandler2.default);

exports.default = ShowRelationshipRequestHandler;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _SmartsRecommenderStatus = __webpack_require__(47);

var _SmartsRecommenderStatus2 = _interopRequireDefault(_SmartsRecommenderStatus);

var _ExploreError = __webpack_require__(227);

var _ExploreError2 = _interopRequireDefault(_ExploreError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */
/**
 * This class provides a mapping between the error code returned from HTTP request
 * in Startingpoint and the Explore product internal error code
 */


var ERRORS_MAPPING = [{
	REQUEST_ERROR_CODE: _SmartsRecommenderStatus2.default.NOT_JOINED_ERROR,
	EXPLORE_ERROR_CODE: 'REL_002'
}, {
	REQUEST_ERROR_CODE: 'CQE-801',
	EXPLORE_ERROR_CODE: 'REL_001'
}, {
	REQUEST_ERROR_CODE: 'ABANDONED_RELATIONSHIP_REQUEST', //abandoned Request Error
	EXPLORE_ERROR_CODE: 'REL_003'
}];

var StartingPointsError = function () {
	function StartingPointsError() {
		_classCallCheck(this, StartingPointsError);
	}

	/**
  * Return the interal ExploreError Object for the given HTTP Request Service Error Code
  */
	StartingPointsError.getErrorObject = function getErrorObject(requstErrorCode) {
		var result = ERRORS_MAPPING.find(function (entry) {
			return entry.REQUEST_ERROR_CODE === requstErrorCode;
		});
		if (result) {
			return new _ExploreError2.default(result.EXPLORE_ERROR_CODE);
		}
		return null; //All known HTTP errors should be handled in Explore
	};

	return StartingPointsError;
}();

exports.default = StartingPointsError;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */
/**
 * This class provides a dictionary of Explore Errors object, Explore Warnings object etc.
 * By design, for consistency, UI should only consume this Object when rendering messages
 */


var _ERROR$WARN$INFO$DEBU = { ERROR: 'Error', WARN: 'Warning', INFO: 'Info', DEBUG: 'Debug' },
    ERROR = _ERROR$WARN$INFO$DEBU.ERROR,
    WARN = _ERROR$WARN$INFO$DEBU.WARN;


var EXPLORE_MESSAGES = [{
	code: 'REL_001', //Please input the entry sorted by error code
	severity: ERROR,
	title: 'relationshipGraph_ambiguous_connection_errorTitle', //Message key defined in ExploreResources
	message: 'relationshipGraph_ambiguous_connection_errorMessage', //Message key defined in ExploreResources
	suggestions: null
}, {
	code: 'REL_002',
	severity: ERROR,
	title: 'relationshipGraph_not_joined_errorTitle', //Message key defined in ExploreResources
	message: 'relationshipGraph_not_joined_errorMessage', //Message key defined in ExploreResources
	suggestions: null
}, {
	code: 'REL_003', // for abandoned Request Error
	severity: WARN,
	title: 'relationshipGraph_abandoned_errorTitle', //Message key defined in ExploreResources
	message: 'relationshipGraph_abandoned_errorMessage', //Message key defined in ExploreResources
	suggestions: null
	//TODO Expand
}];

var ExploreError = function () {
	/**
  * Get an ExploreError object for the given error code
  * @param  {string} the unique ExploreError's code
  * @return {object} the Explore Error object
  */
	function ExploreError(code) {
		_classCallCheck(this, ExploreError);

		var result = EXPLORE_MESSAGES.find(function (entry) {
			return entry.code === code;
		});
		if (result) {
			this.errObj = {
				code: 'CA_EXPLORE_' + result.code,
				severity: result.severity,
				title: _StringResources2.default.get(result.title),
				message: _StringResources2.default.get(result.message),
				suggestions: result.suggestions ? _StringResources2.default.get(result.suggestions) : result.suggestions
			};
		}
	}

	/**
 	@return {object} return the Error object
  */


	ExploreError.prototype.getUserStrings = function getUserStrings() {
		return this.errObj || {}; //Guard it with default Error
	};

	return ExploreError;
}();

exports.default = ExploreError;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _SmartsRecommenderService = __webpack_require__(46);

var _SmartsRecommenderService2 = _interopRequireDefault(_SmartsRecommenderService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Dashboard
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var SmartsPredictRecommenderService = function (_SmartsRecommenderSer) {
	_inherits(SmartsPredictRecommenderService, _SmartsRecommenderSer);

	function SmartsPredictRecommenderService(options) {
		_classCallCheck(this, SmartsPredictRecommenderService);

		return _possibleConstructorReturn(this, _SmartsRecommenderSer.call(this, options));
	}

	/**
  * Fetch prediction recommendations so called default scope
  * @param {Object} options including moduleAPI and targetId
  * @returns {Promise} promise object represents array of recommendations
  */


	SmartsPredictRecommenderService.prototype.fetchPredictRecommendations = function fetchPredictRecommendations(options) {
		var _this2 = this;

		var PREDICT_RECOMMENDATIONS_URL = 'v1/predict/recommendations';
		return this._getRequestParameters(options).then(function (requestParams) {
			return _this2._executeRequest(requestParams, PREDICT_RECOMMENDATIONS_URL);
		}).then(this._processPredictRecommendationsData.bind(this));
	};

	SmartsPredictRecommenderService.prototype._isSucessful = function _isSucessful(response) {
		return response.predictStatus.state === 'SUCCESS';
	};

	SmartsPredictRecommenderService.prototype._processPredictRecommendationsData = function _processPredictRecommendationsData(ajaxResponse) {
		var recommenderResponse = ajaxResponse.data;
		if (this._isSucessful(recommenderResponse)) {
			return recommenderResponse.results.recommendedFields.fields;
		} else {
			this.logger.debug(ajaxResponse);
			return [];
		}
	};

	SmartsPredictRecommenderService.prototype._getRequestParameters = function _getRequestParameters(options) {
		var moduleAPI = options.moduleAPI;
		var tempModule = moduleAPI.getTemporarySessionModuleJSON();
		var requestParameters = {
			targetFieldIDForExpression: options.targetId,
			moduleId: moduleAPI.getAssetId(),
			shapedModule: !!moduleAPI.getShapingId(),
			tuningParams: {
				allowCategoryTarget: true,
				noCorrelationLimit: true
			}
		};
		if (tempModule) {
			requestParameters.tempModule = JSON.stringify(tempModule);
		}
		return moduleAPI.saveTemporaryModule().then(function (shapingModuleId) {
			if (moduleAPI.getAssetId() !== shapingModuleId) {
				requestParameters.tempModuleId = shapingModuleId;
			}
			return requestParameters;
		});
	};

	return SmartsPredictRecommenderService;
}(_SmartsRecommenderService2.default);

exports.default = SmartsPredictRecommenderService;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(230);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */


var DEFAULT_PLUGIN_ID = 'com.ibm.bi.explore.thumbnailBtn';
var BADGE_NOTIFICATION_CLASS = 'card-notification';
var BADGE_NOTIFICATION_SELECTOR = '.' + BADGE_NOTIFICATION_CLASS;

var CardNotificationController = function () {
	function CardNotificationController(_ref) {
		var glassContext = _ref.glassContext,
		    _ref$pluginId = _ref.pluginId,
		    pluginId = _ref$pluginId === undefined ? DEFAULT_PLUGIN_ID : _ref$pluginId;

		_classCallCheck(this, CardNotificationController);

		this.glassContext = glassContext;
		this.pluginId = pluginId;
	}

	CardNotificationController.prototype.findGlassPlugin = function findGlassPlugin() {
		return this.glassContext.appController.findPlugin(this.pluginId);
	};

	CardNotificationController.prototype.findNotificationContainer = function findNotificationContainer() {
		var plugin = this.findGlassPlugin();
		if (!plugin) {
			return;
		}

		var $el = plugin.$el;
		if (!$el) {
			return;
		}

		return $el;
	};

	CardNotificationController.prototype.makeBadge = function makeBadge() {
		return (0, _jquery2.default)('<div class="' + BADGE_NOTIFICATION_CLASS + '"></div>');
	};

	CardNotificationController.prototype.activate = function activate() {
		var $container = this.findNotificationContainer();
		if (!$container) {
			return;
		}

		var $badge = $container.find(BADGE_NOTIFICATION_SELECTOR);
		if ($badge.length === 0) {
			$container.append(this.makeBadge());
		}
	};

	CardNotificationController.prototype.deactivate = function deactivate() {
		var $container = this.findNotificationContainer();
		if (!$container) {
			return;
		}

		$container.find(BADGE_NOTIFICATION_SELECTOR).remove();
	};

	return CardNotificationController;
}();

exports.default = CardNotificationController;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(231);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./CardNotification.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./CardNotification.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".explore-card-list {\n  position: relative;\n}\n\n.explore-card-list .card-notification {\n  background: #00aa5e;\n  position: absolute;\n  border-radius: 50%;\n  top: 11px;\n  right: 11px;\n  width: 10px;\n  height: 10px;\n  border-style: solid;\n  border-color: #00aa5e;\n  border-width: thick;\n}\n\n", ""]);

// exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var BaseClass = __webpack_require__(233);

/**
 * This class is needed because the DashboardController that is responsible for adding the widget after the keypress (Shift + ->)
 * does not include logic that we need for replacing the placeholder widget and making a new card from starting points. We use this
 * class to override the DashboardController in BaseBoardView.
 */

var ExploreController = function (_BaseClass) {
	_inherits(ExploreController, _BaseClass);

	function ExploreController() {
		_classCallCheck(this, ExploreController);

		return _possibleConstructorReturn(this, _BaseClass.apply(this, arguments));
	}

	/**
  * This function determines whether to replace a placeholder widget with a live widget, create a new card, or add the columns to an existing widget
  * @param {Array} columnInfo - contains the data for each column that was selected
  * @returns {Promise} used by unit test
  */
	ExploreController.prototype.addContentToCanvas = function addContentToCanvas(columnInfo) {
		var _this2 = this;

		var selectedWidgetId = this.view.exploreContainerLayoutModel.getSelectedWidgets()[0] ? this.view.exploreContainerLayoutModel.getSelectedWidgets()[0].id : null;
		var canvasController = this.view.boardController;
		var dashboardApi = this.view.getDashboardApi();
		var canvasAPI = dashboardApi.getCanvas();
		var widgetAPI = canvasAPI.getWidget(selectedWidgetId);
		return canvasController.getWidgetSpecFromDragObject(columnInfo).then(function (widgetSpec) {
			if (widgetAPI && widgetAPI.getType() === 'placeholder') {
				var card = _this2.view.boardModel.layout.getSelectedChildLayouts()[0].getParent();
				card.replaceWidgetInCard(widgetSpec, selectedWidgetId, 'cardCreate');
			} else if (_this2.view.exploreContainerLayoutModel.exploreVM.isStartingPointsDisplayed()) {
				var cardId = _this2.view.exploreContainerLayoutModel.exploreVM.layoutModel.addVisCard([widgetSpec], 'startingPointsCreate');
				_this2.view.exploreContainerLayoutModel.exploreVM.setDisplayedToCard(cardId);
			} else {
				_BaseClass.prototype.addContentToCanvas.call(_this2, columnInfo);
			}
		});
	};

	return ExploreController;
}(BaseClass);

exports.default = ExploreController;

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_233__;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.FieldsModel = undefined;

var _mobxStateTree = __webpack_require__(7);

var _ArrayOperations = __webpack_require__(25);

var _FetchSmartsData = __webpack_require__(83);

var _mobxUtils = __webpack_require__(15);

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var MAX_RECENT_FIELDS = 5;

var maybeNull = function maybeNull(type) {
	return _mobxStateTree.types.union(type, _mobxStateTree.types.undefined);
};

var FieldsMapEntry = _mobxStateTree.types.model({
	focusFieldId: maybeNull(_mobxStateTree.types.string),
	recentFields: _mobxStateTree.types.optional(_mobxStateTree.types.array(_mobxStateTree.types.string), [])
}).volatile(function () {
	return {
		all: null,
		interesting: null,
		originalInteresting: null //Deprecated - remove with newStartingPoints flag
	};
}).views(function (self) {
	return {
		/**
   * Utility to get all fields - throws error if promise is not resolved
   * @return {object[]} all fields
   */
		getAll: function getAll() {
			if (self.all.state !== _mobxUtils.FULFILLED) {
				throw new Error('Cannot get all fields');
			}
			return self.all.value;
		},
		/**
  * Utility to get interesting fields - throws error if promise is not resolved
  * @return {object[]} interesting fields
  */
		getInteresting: function getInteresting() {
			if (self.interesting.state !== _mobxUtils.FULFILLED) {
				throw new Error('Cannot get interesting fields');
			}
			return self.interesting.value;
		},

		_getField: function _getField(fieldId) {
			return self.getAll().find(function (_ref) {
				var id = _ref.id;
				return id === fieldId;
			});
		},
		getRecentFields: function getRecentFields() {
			return self.recentFields.map(function (id) {
				return self._getField(id);
			});
		}
	};
}).actions(function (self) {
	return {
		setFocusField: function setFocusField(fieldId) {
			self.focusFieldId = fieldId;
		},
		setAll: function setAll(all) {
			self.all = all;
		},
		setInteresting: function setInteresting(interesting) {
			self.interesting = interesting;
		},
		setOriginalInteresting: function setOriginalInteresting(original) {
			self.originalInteresting = original;
		},
		addRecentField: function addRecentField(fieldId) {
			var index = self.recentFields.indexOf(fieldId);

			/* if the field is already in the list
   * splice removes it from its position and shifts the list
   */
			if (~index) {
				self.recentFields.splice(index, 1);
			}
			/*always add new field to the beginning of the list*/
			self.recentFields.unshift(fieldId);
			if (self.recentFields.length > MAX_RECENT_FIELDS) {
				self.recentFields.splice(MAX_RECENT_FIELDS);
			}
			return true;
		}
	};
});

var FieldsMap = _mobxStateTree.types.map(FieldsMapEntry);

var FieldsModel = exports.FieldsModel = _mobxStateTree.types.model('FieldsModel', {
	//clearInput is used to trigger a reaction in the fieldInput, when it is set to true, we will clear the input box
	clearInput: _mobxStateTree.types.optional(_mobxStateTree.types.boolean, false),
	fields: _mobxStateTree.types.maybeNull(FieldsMap, _mobxStateTree.types.undefined)
}).volatile(function () {
	return {
		_mobxDisposeEvents: []
	};
}).extend(function (self) {
	function getDataSourceId() {
		return (0, _mobxStateTree.getEnv)(self).exploreVM.activeDataSourceId;
	}

	function setDefaultFocusFieldId() {
		self.setFocusFieldIndex(self.isNewStartingPointsFeatureEnabled() ? null : 0);
	}

	return {
		views: {
			isNewStartingPointsFeatureEnabled: function isNewStartingPointsFeatureEnabled() {
				return !(0, _mobxStateTree.getEnv)(self).isFeatureEnabled('newStartingPoints', 'false');
			},
			_getFocusFieldId: function _getFocusFieldId() {
				var fields = self.getFields();
				if (fields && fields.focusFieldId) {
					return fields.focusFieldId;
				}
				//When turning off newStartingPoints flag, delete this clause:
				if (!self.isNewStartingPointsFeatureEnabled() && fields.interesting.state === _mobxUtils.FULFILLED) {
					return fields.getInteresting()[0];
				}
				return null;
			},
			_getField: function _getField(fieldId) {
				return self.getFields()._getField(fieldId);
			},


			/**
    * @return {number} the index of focused interesting field for the active datasource ID
    * @deprecated Use getFocusField(), this will be going away when newStartingPoints flag is removed
    */
			getFocusFieldIndex: function getFocusFieldIndex() {
				var focusId = self._getFocusFieldId();
				if (!focusId) {
					return -1;
				}
				return self.getFieldIndex(focusId);
			},


			/**
    *
    * @return {Object} the focused interesting field for the active datasource ID
    */
			getFocusField: function getFocusField() {
				var focusId = self._getFocusFieldId();
				return focusId && self._getField(focusId);
			},


			/**
    * For a given datasource ID, get a JSON object that has all column fields, interesting fields, original
    * interesting fields and focused field index
    * @param [string] dataSourceId data source module ID, by default it is the active DataSource Id
    * @return {Object}
    */
			getFields: function getFields() {
				var dataSourceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDataSourceId();

				if (!dataSourceId) {
					return {};
				}
				var fields = self.fields.get(dataSourceId);
				if (!fields) {
					var _fetchFieldPromises = (0, _FetchSmartsData.fetchFieldPromises)((0, _mobxStateTree.getEnv)(self).exploreVM, dataSourceId),
					    all = _fetchFieldPromises.all,
					    interesting = _fetchFieldPromises.interesting;

					fields = FieldsMapEntry.create({});
					fields.setAll((0, _mobxUtils.fromPromise)(all));
					fields.setInteresting((0, _mobxUtils.fromPromise)(interesting));
					fields.setOriginalInteresting((0, _mobxUtils.fromPromise)(interesting));

					if (!self.isNewStartingPointsFeatureEnabled()) {
						interesting.then(setDefaultFocusFieldId);
					}

					self._setFields(dataSourceId, fields);
				}
				return fields;
			},
			isSetFocusFieldFeatureEnabled: function isSetFocusFieldFeatureEnabled() {
				return !(0, _mobxStateTree.getEnv)(self).isFeatureEnabled('setFocusField', 'false');
			},


			/**
    * @param {string} fieldId
    * @return `true` iff `fieldId` is the id of a known field in the currently selected data source
    */
			isValidField: function isValidField(fieldId) {
				return !!self._getField(fieldId);
			},


			/**
    * @param {string} fieldId
    * @return `true` iff `fieldId` can be set as the focus field
    */
			canSetFocusField: function canSetFocusField(fieldId) {
				if (!self.isSetFocusFieldFeatureEnabled()) {
					return false;
				}
				if (!self.isValidField(fieldId)) {
					return false;
				}
				return fieldId !== self._getFocusFieldId();
			},


			/**
    * @param {string} fieldId
    * @return the index in the displayed fields of `fieldId`, or `-1` if not displayed
    * @deprecated this will be going away when the newStartingPoints flag is removed
    */
			getFieldIndex: function getFieldIndex(fieldId) {
				return self.getFields().getInteresting().map(function (_ref2) {
					var id = _ref2.id;
					return id;
				}).indexOf(fieldId);
			},
			hasFetchedFields: function hasFetchedFields() {
				return self.fields.has(getDataSourceId());
			}
		},
		actions: {
			afterCreate: function afterCreate() {
				if (!self.fields) {
					self.fields = FieldsMap.create({});
				}
			},
			beforeDestroy: function beforeDestroy() {
				// Remove the events.
				self._mobxDisposeEvents.forEach(function (dispose) {
					return dispose();
				});
			},


			/**
    * @deprecated Use setFocusField(), this will be going away when newStartingPoints flag is removed
    */
			setFocusFieldIndex: function setFocusFieldIndex(fieldIndex) {
				var fields = self.getFields();
				if (fields.interesting.state === _mobxUtils.FULFILLED) {
					var field = fields.getInteresting()[fieldIndex];
					if (field) {
						fields.setFocusField(field.id);
					}
				}
			},


			/**
    * Makes the specified field the focus field; adds it to the list of
    * displayed fields if necessary.
    * @param {string} fieldId
    */
			setFocusField: function setFocusField(fieldId) {
				var fields = self.getFields();
				if (self.canSetFocusField(fieldId)) {
					fields.setFocusField(fieldId);
					fields.addRecentField(fieldId);
					return true;
				}
				return false;
			},


			/**
    * @deprecated This will be going away when newStartingPoints flag is removed
    */
			setInterestingFields: function setInterestingFields(newFields) {
				(0, _ArrayOperations.replaceArray)(self.getFields().getInteresting(), newFields);
				if (newFields.length > 0) {
					// The first field is the focus field by default
					self.setFocusFieldIndex(0);
				}
			},


			/**
    * @deprecated not used except in tests - remove post-R4
    */
			setAllFields: function setAllFields(newFields) {
				(0, _ArrayOperations.replaceArray)(self.getFields().getAll(), newFields);
			},
			_setFields: function _setFields(dataSourceId, entry) {
				self.fields.set(dataSourceId, entry);
			},


			//Note: When newStartingPoints feature flag is removed, addField()
			//      should be removed. When this happens, we could rename this to
			//      addField(), which would be more consistent with deleteField()
			addToAllFields: function addToAllFields(newField) {
				self.getFields().getAll().push(newField);
			},
			deleteField: function deleteField(id) {
				//Delete from all fields
				var fields = self.getFields();
				var all = fields.getAll();
				(0, _ArrayOperations.deleteFromArray)(all, function (field) {
					return field.id === id;
				});

				//Delete from recent fields
				(0, _ArrayOperations.deleteFromArray)(fields.recentFields, function (fieldId) {
					return fieldId === id;
				});

				//Delete from interesting fields
				var focusFieldIndex = self.getFocusFieldIndex();
				var interestingFields = fields.getInteresting();
				var indexInInterestingFields = (0, _ArrayOperations.deleteFromArray)(interestingFields, function (field) {
					return field.id === id;
				});
				if (~indexInInterestingFields) {
					if (indexInInterestingFields === focusFieldIndex) {
						//The deleted field is target field
						setDefaultFocusFieldId();
					}
				}
			},


			/**
    * @deprecated This will be going away when newStartingPoints flag is removed - we will no longer need to add interesting fields
    */
			addField: function addField(id) {
				var fields = self.getFields();
				var interestingFields = fields.getInteresting();
				var fieldIndex = interestingFields.findIndex(function (field) {
					return field.id === id;
				});
				if (fieldIndex > -1) {
					if (id !== self._getFocusFieldId()) {
						self.setFocusField(id);
					}
					return true;
				} else {
					var field = self._getField(id);
					if (field) {
						interestingFields.unshift({ name: field.name, id: id });
						self.setFocusField(id);
						//Fields is a volatile object, which can do a shallow observer. instantiate new object can work around this.
						return true;
					}
					return false;
				}
			},
			setClearInput: function setClearInput(value) {
				self.clearInput = value;
			},
			resetData: function resetData() {
				self.clearInput = true;
			},
			clearFields: function clearFields() {
				self.fields.delete(getDataSourceId());
			}
		}
	};
});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _mobxStateTree = __webpack_require__(7);

var _mobx = __webpack_require__(11);

var mobx = _interopRequireWildcard(_mobx);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _RelationshipTooltipModel = __webpack_require__(236);

var _RelationshipTooltipModel2 = _interopRequireDefault(_RelationshipTooltipModel);

var _RelationshipTargetModel = __webpack_require__(50);

var _RelationshipTargetModel2 = _interopRequireDefault(_RelationshipTargetModel);

var _Config = __webpack_require__(16);

var _Config2 = _interopRequireDefault(_Config);

var _RelationshipInfoTooltipModel = __webpack_require__(237);

var _RelationshipInfoTooltipModel2 = _interopRequireDefault(_RelationshipInfoTooltipModel);

var _utils = __webpack_require__(34);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _Logger = __webpack_require__(37);

var _Logger2 = _interopRequireDefault(_Logger);

var _mobxUtils = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function uniqueTargetIdIsInDataSource(uniqueId, dataSourceId) {
	return uniqueId.startsWith(dataSourceId + '.');
} /*
   *+------------------------------------------------------------------------+
   *| Licensed Materials - Property of IBM
   *| IBM Cognos Products: Explore
   *| (C) Copyright IBM Corp. 2018, 2019
   *|
   *| US Government Users Restricted Rights - Use, duplication or disclosure
   *| restricted by GSA ADP Schedule Contract with IBM Corp.
   *+------------------------------------------------------------------------+
   */


function generateUniqueTargetId(dataSourceId, targetId) {
	return dataSourceId + '.' + targetId;
}

var DEFAULT_NODES_LIMIT = 10;

exports.default = _mobxStateTree.types.model('RelationshipVisViewModel', {
	tooltip: _RelationshipTooltipModel2.default,
	targetIds: _mobxStateTree.types.optional(_mobxStateTree.types.array(_mobxStateTree.types.frozen()), []), /** current selected targeted column ID in the whole model*/
	dataSourceId: _mobxStateTree.types.maybeNull(_mobxStateTree.types.string), /** dataSource unique ID */
	selectedFields: _mobxStateTree.types.optional(_mobxStateTree.types.array(_mobxStateTree.types.frozen()), []),
	contextMenuField: _mobxStateTree.types.optional(_mobxStateTree.types.frozen())
}).volatile(function () {
	return {
		isFilterStrengthFeatureEnabled: false,
		targetInfo: [], //TODO Remove this when the StartingPoints APIs are in place
		messagePayload: null, /** message object that stores information at different levels, such as warngin, error, info, etc. */
		nodesLimit: DEFAULT_NODES_LIMIT, /** max number of nodes */
		showConcepts: _Config2.default.default_show_concepts, /** when true, each node is layed out as single field group, when false, nodes will be grouped, such as concepts group */
		visLoader: null, /** a VisLoader object loads the visualization bunbles, sets the data and renders the visualization. By design, it could be any interfaced visLoader */
		widget: null /** an object to contain an abstraction of the current widget */
		, conceptsViewEnabled: false /** Set to true to enable the concepts view, False, disabled*/
		, datasourcesStatus: {},
		contextMenuElement: null,
		targetModels: {},
		infoTooltipModel: null,
		filterCount: null,
		maxRequestsReached: false,
		exploreViewActivated: true,
		exploreViewId: null,
		logger: null,
		data: null
	};
}).views(function (self) {
	return {
		/**
   * @return {String} return the first target Id (Currently explore actually supports only one target ID)
   */
		getCurrentTargetId: function getCurrentTargetId() {
			if (self.targetIds && self.targetIds.length) {
				return self.targetIds[0];
			}
			return null;
		},
		getTargetIds: function getTargetIds() {
			return self.targetIds;
		},
		isConceptsViewEnabled: function isConceptsViewEnabled() {
			return self.conceptsViewEnabled;
		},
		isDatasourceErrorHandledOnce: function isDatasourceErrorHandledOnce(dataSourceId) {
			return self.datasourcesStatus[dataSourceId];
		},

		/**
   * @return {object} - data promise
   */
		whenRelationshipDataReady: function whenRelationshipDataReady() {
			var targetModel = self.getTargetModel();
			var data = targetModel && targetModel.data;
			if (data) {
				return data;
			}
			return Promise.resolve(null);
		},

		/**
   * @param {object} options
   *                 options.datasourceId, model ref id for datasource options.targetId, unique ID for targetId
   * @return {object} - the RelationshipTargetModel currently in use
   */
		getTargetModel: function getTargetModel() {
			var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			var currentTargetId = options.targetId || self.getCurrentTargetId();
			if (currentTargetId) {
				return self.targetModels[generateUniqueTargetId(options.dataSourceId || self.dataSourceId, currentTargetId)];
			}
			return null;
		},
		getIsFilterStrengthFeatureEnabled: function getIsFilterStrengthFeatureEnabled() {
			return true;
		},
		isNewStartingPointsFeatureEnabled: function isNewStartingPointsFeatureEnabled() {
			return !(0, _mobxStateTree.getEnv)(self).isFeatureEnabled('newStartingPoints', 'false');
		},
		isFilterStartingPointsEnabled: function isFilterStartingPointsEnabled() {
			var env = (0, _mobxStateTree.getEnv)(self);
			return env && env.isFeatureEnabled && env.isFeatureEnabled('filterStartingPoints');
		},
		isRemoveFieldFeatureEnabled: function isRemoveFieldFeatureEnabled() {
			return (0, _mobxStateTree.getEnv)(self).isFeatureEnabled('addRemoveField');
		},
		isAddFieldFeatureEnabled: function isAddFieldFeatureEnabled() {
			return (0, _mobxStateTree.getEnv)(self).isFeatureEnabled('addRemoveField');
		},
		isEditScopeFeatureEnabled: function isEditScopeFeatureEnabled() {
			return !(0, _mobxStateTree.getEnv)(self).isFeatureEnabled('editScope', 'false');
		},
		isShowRelationshipsFeatureEnabled: function isShowRelationshipsFeatureEnabled() {
			return (0, _mobxStateTree.getEnv)(self).isFeatureEnabled('showRelationships');
		},


		//When ON, we add timeout queryspec to the request payload
		isTimeoutFeatureEnabled: function isTimeoutFeatureEnabled() {
			return (0, _mobxStateTree.getEnv)(self).isFeatureEnabled('relationshipsRequestTimeout');
		},


		//When ON, the underneath promise will call be aborted when it times out
		allowLongRunningRequest: function allowLongRunningRequest() {
			return !(0, _mobxStateTree.getEnv)(self).isFeatureEnabled('allowLongRunningRelationshipRequest', false);
		},


		//When ON, we only allow N concurrent requests (Number N is defined in config)
		limitConcurrentRequests: function limitConcurrentRequests() {
			return !(0, _mobxStateTree.getEnv)(self).isFeatureEnabled('limitConcurrentRequests', false);
		},
		isOverrideListFeatureEnabled: function isOverrideListFeatureEnabled() {
			return (0, _mobxStateTree.getEnv)(self).isFeatureEnabled('relationshipDiagramOverrideList');
		},
		getInfoTooltipModel: function getInfoTooltipModel() {
			return self.infoTooltipModel;
		},
		getFilterCount: function getFilterCount() {
			return self.filterCount;
		},


		/**
   * Check if the given target has the fulfilled relationshipData
   * @param {*} targetId
   * @return {boolean}
   */
		isTargetHasNonRejectedRelationshipData: function isTargetHasNonRejectedRelationshipData(targetId) {
			var targetModel = self.getTargetModel({ targetId: targetId });
			return !!(targetModel && targetModel.data && targetModel.data.state !== _mobxUtils.REJECTED);
		},
		getRunningRequestsTargetIds: function getRunningRequestsTargetIds() {
			var dataSourceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.dataSourceId;

			return Object.keys(self.targetModels).filter(function (uniqueTargetId) {
				return uniqueTargetIdIsInDataSource(uniqueTargetId, dataSourceId);
			}).filter(function (uniqueTargetId) {
				return self.targetModels[uniqueTargetId].data && self.targetModels[uniqueTargetId].data.state === _mobxUtils.PENDING;
			}).map(function (uniqueTargetId) {
				return self.targetModels[uniqueTargetId].id;
			});
		},


		/**
   * Get running relationship request for given datasource, default to current datasource
   * @param {string} [datasourceId=self.dataSourceId] datasourceId
   */
		getNumOfRunningRequests: function getNumOfRunningRequests() {
			var dataSourceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.dataSourceId;

			var runningRequests = self.getRunningRequestsTargetIds(dataSourceId);
			return runningRequests ? runningRequests.length : 0;
		},


		/**
   * if can fetch data for the target
   * @param {string} targetId
   * @param {string} action
   * @return {object}
   */
		canFetchData: function canFetchData(targetId, action) {
			//if feature is off, then directly return true
			if (!self.limitConcurrentRequests()) {
				return {
					canFetchData: true
				};
			}
			if (action === 'changeTarget') {
				// if max requsts reached and the target does not has the non rejected data(means need to send a new request), then cannot set target
				if (!(self.getNumOfRunningRequests() < _Config2.default.max_number_of_concurrent_requests || self.isTargetHasNonRejectedRelationshipData(targetId))) {
					return {
						canFetchData: false,
						infoDialogContent: {
							title: _StringResources2.default.get('max_running_relationship_requests_reached_title', { max_number_of_concurrent_requests: _Config2.default.max_number_of_concurrent_requests }),
							body: _StringResources2.default.get('max_running_relationship_requests_reached_body')
						}
					};
				}
			} else if (action === 'editScope') {
				if (!(self.getNumOfRunningRequests() < _Config2.default.max_number_of_concurrent_requests || self.getRunningRequestsTargetIds().indexOf(targetId) != -1)) {
					return {
						canFetchData: false,
						infoDialogContent: {
							title: _StringResources2.default.get('max_running_relationship_requests_reached_title'),
							body: _StringResources2.default.get('max_running_relationship_requests_reached_body', { max_number_of_concurrent_requests: _Config2.default.max_number_of_concurrent_requests })
						}
					};
				}
			}

			return {
				canFetchData: true
			};
		}
	};
}).actions(function (self) {
	var disposeFunctions = [];

	return {
		afterCreate: function afterCreate() {
			//There is only one relationship vis view model per perspective
			self.logger = new _Logger2.default('CA_EXPLORE_RELATIONSHIP_VISVIEW_MODEL');
			self.cancelRequestDelegator = function () {
				return true;
			};
			self.uid = (0, _utils.generateUniqueId)('relationshipVis_');
			self.infoTooltipModel = _RelationshipInfoTooltipModel2.default.create({
				isOpen: false
			});
			/*When target column ID changes, go fetch the data for the new target id*/
			disposeFunctions.push(mobx.reaction(function () {
				if (self.targetIds.length) {
					return generateUniqueTargetId(self.dataSourceId, self.targetIds[0]);
				} else {
					//When empty fields of interest returned, `setTargetIds([])` will be called,
					//but the `targetIds` is [] initially, so in order to react to this, so that
					//fetchData() can be called to show the `No field of interest` message, we
					//directly return `self.targetIds` when it is an empty array, cause [] !== []
					//TODO: A better way would be seting `targetIds` to null on initialization.
					return self.targetIds;
				}
			}, function () {
				if (self.targetIds.length > 0) {
					var uniqueTargetId = generateUniqueTargetId(self.dataSourceId, self.targetIds[0]);
					if (!self.targetModels[uniqueTargetId] && self.getIsFilterStrengthFeatureEnabled()) {
						self.targetModels[uniqueTargetId] = _RelationshipTargetModel2.default.create(undefined, { exploreVM: (0, _mobxStateTree.getEnv)(self).exploreVM,
							relationshipVM: self,
							id: self.targetIds[0],
							label: self.targetInfo[0].label });
					}
				}
				if (self.getIsFilterStrengthFeatureEnabled()) {
					self.fetchData({
						setTarget: true, // this flag is to indicate current action is switiching to different target
						transformOptions: {
							filterStrength: null // just to trigger the transformation, the real min, max will be picked up in transformation code
						}
					});
				} else {
					self.fetchData();
				}
			}));

			disposeFunctions.push(mobx.reaction(function () {
				return self.dataSourceId;
			}, function (dataSourceId) {
				if (dataSourceId) {
					self.setDatasourceHandledStatus(dataSourceId, false);
					if (self.isFilterStartingPointsEnabled()) {
						self._fetchFilterCount(); // Fetch filter count on reaction to change in datasourceId
					}
				}
				if (!self.getIsFilterStrengthFeatureEnabled()) {
					self.reset(); //It is no longer appropriate to do a reset when changing data sources - using separate target models replaces this.
				}
			}));

			/*When nodes limit changes, go fetch the data for the new nodes limit*/
			disposeFunctions.push(mobx.reaction(function () {
				return self.nodesLimit;
			}, function () {
				self.fetchData();
			}));

			/*When showConcepts changes to true or false, go fetch the data */
			disposeFunctions.push(mobx.reaction(function () {
				return self.showConcepts;
			}, function () {
				self.fetchData();
			}));

			/*When fetched data changes, update visLoader */
			disposeFunctions.push(mobx.reaction(function () {
				var targetModel = self.getTargetModel();
				return {
					hasWidget: self.widget ? true : false,
					targetModel: targetModel,
					state: targetModel && targetModel.data ? targetModel.data.state : null
				};
			}, function () {
				var targetModel = self.getTargetModel();
				if (self.widget && self.widget.setData) {
					var state = targetModel && targetModel.data && targetModel.data.state;
					if (state === _mobxUtils.FULFILLED) {
						//Before diagram change, dismiss the context menu
						self.setContextMenu({ element: null, field: null });
						self.widget.setData(targetModel.data.value);
					}
				}
			}));

			disposeFunctions.push(mobx.autorun(function () {
				(0, _mobxStateTree.getEnv)(self).dashboardApi.on('pagecontext:filterContextUpdated', function () {
					self._fetchFilterCount();
				});
			}));
		},
		beforeDestroy: function beforeDestroy() {
			disposeFunctions.forEach(function (dispose) {
				return dispose();
			});
			if (self.visLoader) {
				self.visLoader.unload();
			}
			if (self.infoTooltipModel) {
				(0, _mobxStateTree.destroy)(self.infoTooltipModel);
			}
			var targetModels = _underscore2.default.values(self.targetModels);
			if (targetModels.length) {
				targetModels.forEach(function (model) {
					return (0, _mobxStateTree.destroy)(model);
				});
				self.targetModels = {};
			}
		},
		destroyTargetModel: function destroyTargetModel(dataSourceId, targetId) {
			var uniqueTargetId = generateUniqueTargetId(dataSourceId, targetId);
			var targetModel = self.targetModels[uniqueTargetId];
			if (targetModel) {
				(0, _mobxStateTree.destroy)(targetModel);
				delete self.targetModels[uniqueTargetId];
			}
		},
		setFilterCount: function setFilterCount(count) {
			self.filterCount = count;
		},
		_fetchFilterCount: function _fetchFilterCount() {
			var selector = {
				scope: 'starting points',
				origin: 'filter',
				sourceId: self.dataSourceId,
				_strictMatch: true
			};
			var filterCount = (0, _mobxStateTree.getEnv)(self).dashboardApi.getFeature('GlobalFilters').getFilterList(selector).length;
			self.setFilterCount(filterCount);
		},
		setWidget: function setWidget(widget) {
			self.widget = widget;
		},

		/**
   * @param e DOM node widget is being loaded into
   */
		setElement: function setElement(e) {
			return self.visLoader.load(e).then(function (o) {
				var setData = o.setData;

				self.setWidget({ setData: setData }); //The only part of the widget abstraction we need is the function to set its data
				return o;
			});
		},


		/**
   * @param {string[]} targetIds  set targetIds to model
   * @param {[string[]]} target information such as metadata info, default value is {label: targetId}
   */
		setTargetIds: function setTargetIds(targetIds) {
			var targetInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [{ label: targetIds[0] }];

			self.targetIds = targetIds;
			self.targetInfo = targetInfo;
		},
		resetTargetModels: function resetTargetModels() {
			Object.keys(self.targetModels).filter(function (id) {
				return uniqueTargetIdIsInDataSource(id, self.dataSourceId);
			}).forEach(function (id) {
				return self.targetModels[id].reset();
			});
		},


		/**
   *@param {String} targetIds  set targetIds to model
   **/
		setDataSourceId: function setDataSourceId(dataSourceId) {
			self.dataSourceId = dataSourceId;
		},


		/**
   *@param {Object} wrapper pass the recommenderWrapper to relationship model
   **/
		setSmartsRecommenderWrapper: function setSmartsRecommenderWrapper(wrapper) {
			self.smartsRecommenderWrapper = wrapper;
		},
		setShowConcepts: function setShowConcepts(value) {
			self.showConcepts = value;
		},
		setVisLoader: function setVisLoader(loader) {
			self.visLoader = loader;
		},
		setNodesLimit: function setNodesLimit(limit) {
			self.nodesLimit = limit;
		},
		setIsFilterStrengthFeatureEnabled: function setIsFilterStrengthFeatureEnabled(value) {
			self.isFilterStrengthFeatureEnabled = value;
		},


		/**
   * Set a flag for each datasource ID to indicate if the datasource has been handled
   * Currently it is used for error handling cases only
   */
		setDatasourceHandledStatus: function setDatasourceHandledStatus(dataSourceId, handled) {
			self.datasourcesStatus[dataSourceId] = handled;
		},


		/**
   * Set the explore content view activation status
   * @param {boolean} value True means the content view is visible
   */
		setExploreViewActivated: function setExploreViewActivated(value) {
			self.exploreViewActivated = value;
		},


		/**
   * Set the explore content view unqiue Id
   * @param {string} value
   */
		setExploreViewId: function setExploreViewId(value) {
			self.exploreViewId = value;
		},


		/**
   * Set glassContext
   * //TODO: When there are API to return glassContext, this shouldn't be needed
   * @param {object} context
   */
		setGlassContext: function setGlassContext(context) {
			self.glassContext = context;
		},


		/**
   * Main function that 'fetches' raw data for the relationship vis view model
   * This raw data will be processed and parsed into the data structure that is accepted
   * by the relationship widget.
   *
   * Depending on the scenario, underneapth, the raw data might be returned from an external service
   * via HTTP request, or from a browser end data cache.
   *
   * @param {object} fetchDataContext
   * 	transformationOptions: {
   * 		'addedField': <column id>,  //TODO Support multiple fields
   * 		'deletedField': <column id>
   * 	}
   */
		fetchData: function fetchData(fetchDataContext) {
			if (!self.targetIds || !self.targetIds.length) {
				self.logger.warn('CA_EXPLORE_TARGET_ID_NOT_SET');
			} else if (self.targetIds.length === 1) {
				var nodesLimit = void 0;
				if (self.getIsFilterStrengthFeatureEnabled()) {
					nodesLimit = _Config2.default.max_nodes_to_fetch;
				} else {
					nodesLimit = self.nodesLimit;
				}
				self._sendRequest(nodesLimit, fetchDataContext);
			}
		},
		_sendRequest: function _sendRequest(nodesLimit, fetchDataContext) {
			var targetModel = self.getTargetModel();
			var fetchDataAnyway = self._isFetchingScopedData(fetchDataContext);
			/**
    we need to send new request when
    1. we need to fetch data anyway
    2. or current data is not in pending state
    */
			if (targetModel && (fetchDataAnyway || !targetModel.data || targetModel.data.state !== _mobxUtils.PENDING)) {
				if (!fetchDataAnyway) {
					fetchDataContext = targetModel.modifyFetchDataContextIfNeeded(fetchDataContext);
				}
				//When the request cancel delegator is called, it will cause a 'request cancel'
				//please find SmartsRecommenderWrapper for more details
				var cancelPromise = new Promise(function (resolve, reject) {
					self.cancelRequestDelegator = reject;
				});
				//build query params for fecthing data
				var queryParams = {
					dataSourceId: self.dataSourceId,
					targetId: self.getCurrentTargetId(), //only allow one target ID currently
					maxInfluencerFields: nodesLimit,
					showConcepts: self.showConcepts,
					context: {
						relationshipVM: self,
						transformOptions: fetchDataContext && fetchDataContext.transformOptions || {}
					}
				};
				targetModel.resetRequestTimer();
				targetModel.startRequestTimer();

				// if there is a currently running request for this target, we abandon it
				if (targetModel.data && targetModel.data.state === _mobxUtils.PENDING) {
					targetModel.abandonRequest();
				}
				var getRelStrengthPromise = self.smartsRecommenderWrapper.getRelationshipStrength(queryParams, null, cancelPromise);
				targetModel.setData((0, _mobxUtils.fromPromise)(getRelStrengthPromise));
			}
		},
		_isFetchingScopedData: function _isFetchingScopedData(fetchDataContext) {
			return !!(fetchDataContext && fetchDataContext.transformOptions && fetchDataContext.transformOptions.scopedFields);
		},


		/**
   * @param {object[]} items - fields to add to the list of deleted fields, so that they're suppressed from the relationship diagram
   */
		deleteFields: function deleteFields(items) {
			self.getTargetModel().deleteFields(items.map(function (_ref) {
				var itemId = _ref.itemId;
				return itemId;
			}));
			self.setSelectedFields([]);
		},


		/**
   * @param {object[]} items
   * @return {boolean} indicates whether it is possible to delete the specified fields
   */
		canDeleteFields: function canDeleteFields(items) {
			if (!self.isRemoveFieldFeatureEnabled()) {
				return false;
			}
			var itemIds = items.map(function (_ref2) {
				var itemId = _ref2.itemId;
				return itemId;
			});
			return _underscore2.default.intersection(self.targetIds || [], itemIds).length === 0;
		},
		cleanup: function cleanup() {
			if (self.widget && self.widget.setData) {
				self.widget.setData(null);
				self.setWidget(null);
			}
		},
		reset: function reset() {
			self.setNodesLimit(DEFAULT_NODES_LIMIT);
			self.setShowConcepts(_Config2.default.default_show_concepts);
			if (self.getIsFilterStrengthFeatureEnabled()) {
				self.resetTargetModels();
			}
		},

		/**
   * Set which fields have been selected by the user
   * @param {object[]} selectedFields
   */
		setSelectedFields: function setSelectedFields(selectedFields) {
			self.selectedFields = selectedFields.slice();
		},


		/**
   * Set information for the context menu
   * @param {object} options
   * @param {object} options.field - which field the context menu will perform operations on
   * @param {Element} options.element - which element the context menu should appear next \to
   */
		setContextMenu: function setContextMenu(_ref3) {
			var element = _ref3.element,
			    field = _ref3.field;

			self.contextMenuElement = element;
			self.contextMenuField = field;
		},
		toggleInfoTooltip: function toggleInfoTooltip(triggerNode) {
			if (self.infoTooltipModel.isTooltipOpen()) {
				self.infoTooltipModel.closeTooltip();
			} else {
				self.infoTooltipModel.openTooltip(triggerNode);
			}
		},


		/**
   * If can show the show relationships button on the context menu
   */
		canShowRelationships: function canShowRelationships() {
			return self.isShowRelationshipsFeatureEnabled();
		}
	};
});

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _mobxStateTree = __webpack_require__(7);

exports.default = _mobxStateTree.types.model('RelationshipTooltipModel', {}).volatile(function () {
	return {
		tooltipInfo: null
	};
}).views(function (self) {
	return {
		/**
  	*@return tooltipInfo
   **/
		getTooltipInfo: function getTooltipInfo() {
			return self.tooltipInfo;
		}
	};
}).actions(function (self) {
	return {
		/**
  *@param {String} tooltipInfo set the tooltip to model
  **/
		showTooltip: function showTooltip(tooltipInfo) {
			self.tooltipInfo = tooltipInfo;
		}
	};
}); /*
     *+------------------------------------------------------------------------+
     *| Licensed Materials - Property of IBM
     *| IBM Cognos Products: Explore
     *| (C) Copyright IBM Corp. 2018
     *|
     *| US Government Users Restricted Rights - Use, duplication or disclosure
     *| restricted by GSA ADP Schedule Contract with IBM Corp.
     *+------------------------------------------------------------------------+
     */

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _mobxStateTree = __webpack_require__(7);

exports.default = _mobxStateTree.types.model({
	isOpen: _mobxStateTree.types.boolean
}).volatile(function () {
	return {
		triggerNode: _mobxStateTree.types.frozen()
	};
}).views(function (self) {
	return {
		getTriggerNode: function getTriggerNode() {
			return self.triggerNode;
		},
		isTooltipOpen: function isTooltipOpen() {
			return self.isOpen;
		}
	};
}).actions(function (self) {
	return {
		closeTooltip: function closeTooltip() {
			self.isOpen = false;
		},
		openTooltip: function openTooltip(triggerNode) {
			self.isOpen = true;
			self.triggerNode = triggerNode;
		}
	};
}); /*
     *+------------------------------------------------------------------------+
     *| Licensed Materials - Property of IBM
     *| IBM Cognos Products: Explore
     *| (C) Copyright IBM Corp. 2019
     *|
     *| US Government Users Restricted Rights - Use, duplication or disclosure
     *| restricted by GSA ADP Schedule Contract with IBM Corp.
     *+------------------------------------------------------------------------+
     */

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _DataProvider = __webpack_require__(239);

var _DataProvider2 = _interopRequireDefault(_DataProvider);

var _RelationshipGraphEventHandler = __webpack_require__(247);

var _RelationshipGraphEventHandler2 = _interopRequireDefault(_RelationshipGraphEventHandler);

var _ModuleLoader = __webpack_require__(84);

var _Config = __webpack_require__(16);

var _Config2 = _interopRequireDefault(_Config);

var _RelationshipTargetModel = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

var VIPR = null;
var VIPR3Provider = null;
var VIDA = null;

var NETWORK_BUNDLE_ID = 'com.ibm.vis.rave2bundlenetwork';
var VIDA_RENDER_MODE_CLIENT = 'client';
var FOCUS_FIELD_GROUP_ID_PREFIX = 'focusField×none_';
var FIELD_GROUP_ID_PREFIX = 'field×none_';
var DATA_NOES_DATASET_ID = 'data.nodes';
var HIGHLIGHTED = 'highlighted';

var RelationshipVisLoader = function () {
	/**
  * @constructor
  */
	function RelationshipVisLoader(params) {
		_classCallCheck(this, RelationshipVisLoader);

		this._dashboardApi = params.dashboardApi;
		this.startingPointsVM = params.startingPointsVM;
		this.viprData = null;
	}

	RelationshipVisLoader.prototype._loadViprModules = function _loadViprModules() {
		return new Promise(function (resolve, reject) {
			(0, _ModuleLoader.loadModules)(['dashboard-analytics/visualizations/vipr/VIPR', /*Though currently VIPR is prefetched by glass, as well as VIPRUtils VIDA etc.*/
			'dashboard-analytics/visualizations/definitions/providers/VIPR3Provider', 'com/ibm/vida/control/vida'], function (VIPRModule, VIPR3ProviderModule, VIDAModule) {
				VIPR = VIPRModule;
				VIPR3Provider = VIPR3ProviderModule;
				VIDA = VIDAModule;
				resolve(true);
			}, reject);
		});
	};

	RelationshipVisLoader.prototype._getAjaxService = function _getAjaxService() {
		return this._dashboardApi && this._dashboardApi.getGlassCoreSvc ? this._dashboardApi.getGlassCoreSvc('.Ajax') : null;
	};

	RelationshipVisLoader.prototype.load = function load(el) {
		var _this = this;

		return this._loadViprModules().then(_DataProvider.loadDataProviderDeps).then(function () {
			_this._viprPromise = VIPR.initialize({ 'dashboardApi': _this._dashboardApi });
			return _this._load(el);
		});
	};

	RelationshipVisLoader.prototype._load = function _load(el) {
		var _this2 = this;

		return this._viprPromise.then(function () {
			return VIPR.loadBundle(NETWORK_BUNDLE_ID);
		}).then(function (relationshipBundle) {
			var widget = VIPR.createWidget(el.id);
			_this2._widget = widget;
			_this2._vidaActionHandler = VIDA ? new VIDA.ActionHandler(widget) : null; //VIDA Gesture Action Handler Initialization
			return widget.newViz(NETWORK_BUNDLE_ID, VIDA_RENDER_MODE_CLIENT).then(function () {
				var setData = function setData(data) {
					var vipr3Provider = new VIPR3Provider({ dashboardApi: _this2._dashboardApi });
					return _this2._setData(relationshipBundle, vipr3Provider, widget, data);
				};
				var addHighlight = function addHighlight(columnId, targetId) {
					return _this2._decorateNode({ columnId: columnId, targetId: targetId, widget: widget, enableHighlight: true, decorationType: HIGHLIGHTED });
				};
				var removeHighlight = function removeHighlight(columnId, targetId) {
					return _this2._decorateNode({ columnId: columnId, targetId: targetId, widget: widget, enableHighlight: false, decorationType: HIGHLIGHTED });
				};
				return {
					widget: widget,
					getEventHandler: function getEventHandler() {
						return _this2.eventHandler;
					},
					setData: setData,
					addHighlight: addHighlight,
					removeHighlight: removeHighlight
				};
			});
		});
	};

	RelationshipVisLoader.prototype._setData = function _setData(relationshipBundle, vipr3Provider, widget, data) {
		var _this3 = this;

		var relationship = this.startingPointsVM.relationship;

		var targetId = relationship.targetIds[0];
		if (this._isStaleRequest(data, targetId)) {
			return;
		}
		var targetModel = relationship.getTargetModel();
		var lastAddedFields = targetModel && targetModel.lastAddedFields;
		var dataOptions = {
			'showConcepts': relationship.showConcepts === true,
			'targetId': targetId,
			'addedField': lastAddedFields // seems not be used anywhere
		};
		var oDefinition = vipr3Provider.createDefinition(relationshipBundle);
		var fields = this.startingPointsVM.fields.getFields();
		var metadataInfo = fields && fields.all && fields.all.value;
		//New data provider instance
		var oDataProvider = new _DataProvider2.default(data, oDefinition, metadataInfo, dataOptions);
		var oViprData = oDataProvider.getData();
		var oSlotMapping = oDataProvider.getSlotMapping();
		if (!oViprData) {
			throw new Error('Data provider gave no data');
		}
		widget.setData(oViprData, oSlotMapping);
		var enableHighlight = true;

		//highlight field
		var fieldsToHighlight = null;
		var changedProperty = targetModel && targetModel.changedProperty;
		if (changedProperty === 'lastAddedFields') {
			fieldsToHighlight = lastAddedFields;
		} else if (changedProperty === 'lastShowRelationshipsField') {
			var _targetModel$lastShow = targetModel.lastShowRelationshipsField,
			    from = _targetModel$lastShow.from,
			    to = _targetModel$lastShow.to;

			var showRelationshipsMap = targetModel.showRelationshipsMap;
			if (showRelationshipsMap[from]) {
				var found = showRelationshipsMap[from].find(function (entry) {
					return entry.to === to;
				});
				if (found && found.relationship) {
					fieldsToHighlight = [from, to];
				}
			}
		} else if (changedProperty === 'cancelAction') {
			var lastCanceledAction = targetModel.lastCanceledAction;
			if (lastCanceledAction.canceledAction === _RelationshipTargetModel.OVERRIDE_ACTIONS.DELETED) {
				fieldsToHighlight = [lastCanceledAction.fieldID];
			}
		}
		if (fieldsToHighlight && fieldsToHighlight.length) {
			fieldsToHighlight.forEach(function (fieldToHighlight) {
				_this3._decorateNode({ columnId: fieldToHighlight, targetId: targetId, widget: widget, enableHighlight: enableHighlight, decorationType: HIGHLIGHTED });
			});
		}

		this._setWidgetProperties(widget);
		widget.render('client');

		var options = {
			widget: widget,
			startingPointsVM: this.startingPointsVM,
			nodeDataset: oViprData.getDataSetAt(1),
			dataProvider: oDataProvider
		};
		this.eventHandler = new _RelationshipGraphEventHandler2.default(options);
	};

	/*Highlight the node for the given column ID by decorating the corresponding datapoint*/


	RelationshipVisLoader.prototype._decorateNode = function _decorateNode(options) {
		var columnId = options.columnId,
		    targetId = options.targetId,
		    widget = options.widget,
		    enableHighlight = options.enableHighlight,
		    decorationType = options.decorationType;

		if (!columnId) {
			return false;
		}
		var nodeDecorated = false;
		var lookupKey = (targetId === columnId ? FOCUS_FIELD_GROUP_ID_PREFIX : FIELD_GROUP_ID_PREFIX) + columnId;
		widget._data.getDataSet(DATA_NOES_DATASET_ID).getDataPoints().filter(function (entry) {
			return entry.key === lookupKey;
		}).forEach(function (entry) {
			nodeDecorated = true; //TODO Optimmize this when we support multiple added fields*/
			entry.source.decorate(decorationType, enableHighlight);
		});
		return nodeDecorated;
	};

	/*
  * Set properites such as legend, colors
  */


	RelationshipVisLoader.prototype._setWidgetProperties = function _setWidgetProperties(widget) {
		widget.setProperty('widget.legend.display', _Config2.default.legend_display);
		widget.setProperty('color_node_cat', _Config2.default.themes.default.palette.colors);
		widget.setProperty('network.links.color', _Config2.default.links_color);
		widget.setProperty('border.color', _Config2.default.border_color);
		widget.setProperty('network.nodes.size.min', _Config2.default.network_nodes_size_min);
		widget.setProperty('network.links.thickness.min', _Config2.default.network_links_thickness_min);
		widget.setProperty('network.links.thickness.max', _Config2.default.network_links_thickness_max);
	};

	RelationshipVisLoader.prototype.unload = function unload() {
		if (this._widget) {
			this._widget.destroy();
			this._widget = null;
		}
	};

	RelationshipVisLoader.prototype._isStaleRequest = function _isStaleRequest(data, targetId) {
		return data && data.nodesDataset && data.nodesDataset.targetId !== targetId;
	};

	return RelationshipVisLoader;
}();

exports.default = RelationshipVisLoader;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.loadDataProviderDeps = undefined;

var _VisAPIAdapter = __webpack_require__(240);

var _VisAPIAdapter2 = _interopRequireDefault(_VisAPIAdapter);

var _NodeDataset = __webpack_require__(242);

var _NodeDataset2 = _interopRequireDefault(_NodeDataset);

var _LinkDataset = __webpack_require__(243);

var _LinkDataset2 = _interopRequireDefault(_LinkDataset);

var _RelationshipUtil = __webpack_require__(24);

var _Config = __webpack_require__(16);

var _Config2 = _interopRequireDefault(_Config);

var _ModuleLoader = __webpack_require__(84);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

var VIPRUtils = null;
var QueryResultData = null;
var QueryResultObject = null;

/*External dependencies on dashboard-livewidget*/

//disabledLoader is used for unit testing scenario, so that dependencies are loaded upfront
if (_ModuleLoader.disabledLoader) {
	VIPRUtils = __webpack_require__(244);
	QueryResultData = __webpack_require__(245);
	QueryResultObject = __webpack_require__(246);
}

/**
 *  This helper function should be called before instantiating/using DataProvider
 *  It loads Live Widget 3rd party dependencies used by DataProvider implementation
 **/
var loadDataProviderDeps = function loadDataProviderDeps() {
	return new Promise(function (resolve, reject) {
		(0, _ModuleLoader.loadModules)(['dashboard-analytics/visualizations/vipr/VIPRUtils', 'dashboard-analytics/widgets/livewidget/query/QueryResultData', 'dashboard-analytics/widgets/livewidget/query/QueryResultObject'], function (VIPRUtilsModule, QueryResultDataModule, QueryResultObjectModule) {
			VIPRUtils = VIPRUtilsModule;
			QueryResultData = QueryResultDataModule;
			QueryResultObject = QueryResultObjectModule;
			resolve(true);
		}, reject);
	});
};

exports.loadDataProviderDeps = loadDataProviderDeps;


var NODE_DATASET_LAYER = 'data.nodes';
var LINK_DATASET_LAYER = 'data.links';

/**
 * This class parses the data returned from upstream services, such as predict services and smart Services.
 * After that it reassembles the data as VIPRData structure that is used to render a VIDA Widget. (not 'live widget')
 **/

var DataProvider = function () {

	/**
  * @constructor
  * @param {JSONObject} rawData, Data in original format that is returned from upstream services
  * @param {Object} definition, definition object that is returned from VIDA APIs
  * @param {Object} metadataInfo, metadata informaiton
  * @param {Object} options, options to customize data on demand
  */
	function DataProvider(rawData, definition, metadataInfo, options) {
		_classCallCheck(this, DataProvider);

		this._verifyData(rawData, options);
		this.visAPI = new _VisAPIAdapter2.default(definition);
		this.rawData = rawData;
		this.rawNodeDataset = new _NodeDataset2.default(rawData, metadataInfo, options);
		this.rawLinkDataset = new _LinkDataset2.default(rawData, metadataInfo, options);
		//Cache the converted query result object
		this.nodeDataset = this.rawNodeDataset.getNodeDatasetQueryResult();
		this.linkDataset = this.rawLinkDataset.getLinkDatasetQueryResult();
	}
	/**
  * @return Get the normalized data structure that can be consumed by VIPRUtils.
  **/


	DataProvider.prototype.getData = function getData() {
		return VIPRUtils.createData(this.getNormalizedData(), this.visAPI);
	};

	DataProvider.prototype._verifyData = function _verifyData(rawData, options) {
		var results = this.getDataVerificationResults(rawData, options);
		if (results) {
			(0, _RelationshipUtil.printMsg)(results.linkDataset);
			(0, _RelationshipUtil.printMsg)(results.nodeDataset);
		}
	};

	/**
 *@return {JSONObject} information about the data verification, such as descriptive information or warnings, errors
 */


	DataProvider.prototype.getDataVerificationResults = function getDataVerificationResults(rawData, options) {
		if (rawData) {
			return (0, _RelationshipUtil.getDataVerificationResults)(rawData, options);
		}
		return null;
	};

	/**
  * @return return the raw node dataset from the response
  */


	DataProvider.prototype.getRawNodeDataset = function getRawNodeDataset() {
		return this.rawNodeDataset;
	};

	/**
  * Get the normalized slot mapping that can be consumed by VIPRUtils.
  **/


	DataProvider.prototype.getSlotMapping = function getSlotMapping() {
		return VIPRUtils.createSlotMapping(this.visAPI);
	};

	/*TODO: This function should call smart service and predict service to get the insights data*/


	DataProvider.prototype.getNormalizedData = function getNormalizedData() {
		return this.getQueryResultObject().getQueryResults();
	};

	DataProvider.prototype.getQueryResultObject = function getQueryResultObject() {
		var oLinksData = new QueryResultData(this.linkDataset);
		var oNodesData = new QueryResultData(this.nodeDataset);
		var oQueryResultObject = new QueryResultObject();
		oQueryResultObject.addQueryResultObject(NODE_DATASET_LAYER, oNodesData);
		oQueryResultObject.addQueryResultObject(LINK_DATASET_LAYER, oLinksData);
		this._setDomain(oQueryResultObject, _Config2.default.domain_setting_dataItem, 1);
		return oQueryResultObject;
	};

	/*
  *@param {Object} queryResultObject
  *@param {String} mappedDataItem the data item name
  *@param {Number} datasetIndex
   *@private
  *Set the min and max value for strength data item in the dataset
  */


	DataProvider.prototype._setDomain = function _setDomain(queryResultObject, mappedDataItem, datasetIndex) {
		var domainSettings = {};
		domainSettings[mappedDataItem] = {
			min: _Config2.default.default_min_strength,
			max: _Config2.default.default_max_strength
		};
		queryResultObject.setTopBottomMappings(domainSettings, datasetIndex);
	};

	return DataProvider;
}();

exports.default = DataProvider;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _SlotAPIAdapter = __webpack_require__(241);

var _SlotAPIAdapter2 = _interopRequireDefault(_SlotAPIAdapter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Licensed Materials - Property of IBM
                                                                                                                                                           *
                                                                                                                                                           * "Restricted Materials of IBM"
                                                                                                                                                           *
                                                                                                                                                           * (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                           *
                                                                                                                                                           * US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           * restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           */


var _ = __webpack_require__(8);

/**
 * This class works as an apdater of VisAPI Class (please find VisAPI in dashboard-livewidget for more informaiton)
 * This adapter is needed when creating VIPRData for Relationship Diagram
 * //TODO: visAPI should be deprecated
 */

var VisAPIAdapter = function () {
	/**
  *@constructor
  *@param {Object} definition - The Vis definition object
  */
	function VisAPIAdapter(definition) {
		_classCallCheck(this, VisAPIAdapter);

		this.definition = definition;
	}

	/**
  *Return the mapped slots list
  */


	VisAPIAdapter.prototype.getSlots = function getSlots() {
		var _this = this;

		return {
			getMappedSlotList: function getMappedSlotList() {
				return _this.definition.dataSlots.map(function (slot) {
					return new _SlotAPIAdapter2.default(slot);
				});
			}
		};
	};

	/**
  *Return the livewidget vis definition object
  */


	VisAPIAdapter.prototype.getDefinition = function getDefinition() {
		var _this2 = this;

		return {
			getId: function getId() {
				return _this2.definition.id;
			},
			getDatasetList: function getDatasetList() {
				return _.map(_this2.definition.datasets, function (dataset) {
					return {
						id: dataset.name,
						caption: dataset.caption,
						optional: dataset.optional,
						suppressMissing: dataset.suppressMissing,
						needsSorted: dataset.needsSorted,
						requiresValues: dataset.requiresValues
					};
				});
			}
		};
	};

	/**
 * @param {String} dataViewId - the data view ID of the dataset
 */


	VisAPIAdapter.prototype.getDataSlotsForViewId = function getDataSlotsForViewId(dataViewId) {
		var aSlotAPIAdapter = [];
		if (this.definition) {
			_.each(this.definition.dataSlots, function (slot) {
				if (slot.datasetIdList[0] === dataViewId) {
					aSlotAPIAdapter.push(new _SlotAPIAdapter2.default(slot));
				}
			});
		}
		return aSlotAPIAdapter;
	};

	return VisAPIAdapter;
}();

exports.default = VisAPIAdapter;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 *
 * "Restricted Materials of IBM"
 *
 * (C) Copyright IBM Corp. 2018, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 *  This class works as an apdater of SlotAPI Class (please find SlotAPI in dashboard-livewidget for more informaiton)
 *  This adapter is needed when creating VIPRData for Relationship Diagram
 **/
var SlotAPIAdapter = function () {
	/**
  *@constructor
  *@param slotDef - Original Slot definition returned from VIDA Vis definition
  */
	function SlotAPIAdapter(slotDef) {
		_classCallCheck(this, SlotAPIAdapter);

		this.slotDef = slotDef;
		if (slotDef.datasetIdList[0] === 'data.nodes') {
			if ('nodeColor' === slotDef.id && 'any' === slotDef.type) {
				slotDef.type = 'category';
			}
		}
	}

	/**
  *@return the ID of the slot
  */


	SlotAPIAdapter.prototype.getId = function getId() {
		return this.slotDef.id;
	};

	/*
  * called in visualizations/vipr/VIPRData->VIPRDataSet->init()
  */


	SlotAPIAdapter.prototype.getDataItemList = function getDataItemList() {
		var _this = this;

		return [{
			getId: function getId() {},
			getColumnId: function getColumnId() {},
			getType: function getType() {
				if (_this.slotDef.type === 'category') {
					return 'attribute'; //Legacy 'final type' in R5
				}
				return _this.slotDef.type;
			},
			getFormat: function getFormat() {}
		}];
	};

	SlotAPIAdapter.prototype.isStacked = function isStacked() {
		return false;
	};

	SlotAPIAdapter.prototype.getType = function getType() {
		return this.slotDef.type;
	};

	/*
  * called in visualizations/vipr/VIPRData->SlotAPIHelper->getMappedSlotListByDataset()
  */


	SlotAPIAdapter.prototype.getDefinition = function getDefinition() {
		var _this2 = this;

		return {
			getDataset: function getDataset() {
				return _this2.slotDef.dataset;
			},
			getDatasetIdList: function getDatasetIdList() {
				return _this2.slotDef.datasetIdList;
			},
			isMultiMeasureSupported: function isMultiMeasureSupported() {
				return false;
			}
		};
	};

	/*
  * called in visualizations/vipr/VIPRData->getItem()
  */


	SlotAPIAdapter.prototype.isCaptionAsUniqueName = function isCaptionAsUniqueName() {
		return false;
	};

	return SlotAPIAdapter;
}();

exports.default = SlotAPIAdapter;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _RelationshipUtil = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Licensed Materials - Property of IBM
                                                                                                                                                           *
                                                                                                                                                           * 'Restricted Materials of IBM'
                                                                                                                                                           *
                                                                                                                                                           * (C) Copyright IBM Corp. 2018
                                                                                                                                                           *
                                                                                                                                                           * US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           * restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           */


var SUPPORTED_GROUP_TYPES = ['none', 'hierarchy', 'concept'];

var GROUPING_TYPES = ['focusField', 'field', 'hierarchy', 'concept'];
var FIELDS_ONLY_GROUPING_TYPES = ['focusField', 'field'];
var FOCUSFIELD = 'focusField';
var FIELD = 'field';
var GROUP_TYPE_NONE = 'none';
var GROUP_TYPE_NONE_PREFIX = 'none_';
var ITEMCLASS_SET_INDEX = { PARENT_ONLY: 0, PARENT_CHILD: 1, CHILD_ONLY: 2 };
/**
 * This class converts the smart module response from smart explore service into the Query Result data structure
 * that can be used to populate VIPRDATA
 */

var NodeDataset = function () {
	function NodeDataset(rawData, metadataInfo, options) {
		_classCallCheck(this, NodeDataset);

		this.dataset = rawData ? rawData.nodesDataset : { groupings: [] };
		this.metadataInfo = metadataInfo;
		this.options = options;
		this.groupingTypes = options.showConcepts ? GROUPING_TYPES : FIELDS_ONLY_GROUPING_TYPES;
		this.context = { 'targetId': this.dataset.targetId };
		this.reset();
	}

	NodeDataset.prototype.reset = function reset() {
		this.nodeItemsList = []; /** Array that holds the frist mapped slot's data items*/
		this.colorItemsList = []; /** Array that holds the second mapped slot's data items*/
		this.dataPoints = []; /** Array that holds datapoints*/
		this.hierarchyInfos = {}; // used to display tooltip for hierarchy node
	};

	/**
 * @return {Object} return the context information of the node dataset
 */


	NodeDataset.prototype.getContext = function getContext() {
		return this.context;
	};

	/**
 *@return {Object} return the options information of the node dataset
 */


	NodeDataset.prototype.getOptions = function getOptions() {
		return this.options;
	};

	NodeDataset.prototype._createItemClass_nodes = function _createItemClass_nodes() {
		return { 'itemClass': [{
				'h': [{
					'u': 'groupId',
					'd': 'groupLabel'
				}]
			}, {
				'h': [{
					'u': 'groupId',
					'd': 'groupLabel'
				}, {
					'u': 'memberId',
					'd': 'memberLabel'
				}]
			}, {
				'h': [{
					'u': 'memberId',
					'd': 'memberLabel'
				}]
			}] };
	};

	NodeDataset.prototype._createItemClass_confidence = function _createItemClass_confidence() {
		return { 'itemClass': {
				'h': [{
					'u': 'Confidence',
					'd': 'Confidence',
					'aggregate': 'sum'
				}]
			} };
	};

	NodeDataset.prototype._createItemClass_groupingType = function _createItemClass_groupingType() {
		return { 'itemClass': {
				'h': [{
					'u': 'groupingTypeId',
					'd': 'Legend'
				}]
			} };
	};

	/**
 * Create data items list and datapoints from group node inside smart explore service response
 *
 * @param {JSONObject} groupNode
 * @param {String} groupType
 **/


	NodeDataset.prototype.createItemsFromGroups = function createItemsFromGroups(groupNode) {
		var _this = this;

		if (groupNode && groupNode.members && groupNode.members.length > 0) {
			var oFieldItem = void 0;
			var nNodeIndex = void 0;

			var hierarchyLevels = [];
			var isHierarchy = groupNode.groupType === 'hierarchy';
			if (isHierarchy) {
				this.hierarchyInfos[groupNode.groupId] = hierarchyLevels;
			}
			//Create data item for each field under the group (child)
			groupNode.members.forEach(function (memberEntry /*,memberIndex*/) {
				oFieldItem = groupNode.groupType === GROUP_TYPE_NONE ? _this._createFieldOnlyItem(memberEntry.id) : _this._createFieldItem(groupNode.groupId, groupNode.groupType, groupNode.groupLabel, memberEntry.id);
				nNodeIndex = _this.nodeItemsList.push(oFieldItem) - 1;
				/*For Endor Release, the node confidence value will not be used, memberEntry.confidence
    *All node will have the same value 1
    */
				_this.addDatapoint(nNodeIndex, 1, _this._isFocusedField(memberEntry) ? FOCUSFIELD : FIELD);
				if (isHierarchy) {
					hierarchyLevels.push({
						levelNumber: memberEntry.level,
						levelLabel: _this._getMetadataLabel(memberEntry.id)
					});
				}
			});
			if (groupNode.groupType !== GROUP_TYPE_NONE) {
				var oGroupItem = this._createGroupItem(groupNode.groupId, groupNode.groupType, groupNode.groupLabel);
				nNodeIndex = this.nodeItemsList.push(oGroupItem) - 1;
				//Group Node has NULl size
				this.addDatapoint(nNodeIndex, null, groupNode.groupType);
				if (isHierarchy) {
					hierarchyLevels.sort(function (lvl1, lvl2) {
						return lvl1.levelNumber - lvl2.levelNumber;
					});
				}
			}
		}
	};

	NodeDataset.prototype.getHierarchyLevels = function getHierarchyLevels(hierarchyNodeId) {
		var levels = this.hierarchyInfos[hierarchyNodeId];
		if (levels && levels.length > 1) {
			return levels[0].levelLabel + ' - ' + levels[levels.length - 1].levelLabel;
		}
		return '';
	};

	NodeDataset.prototype._isFocusedField = function _isFocusedField(memberEntry) {
		return memberEntry.type === 'focusField';
	};

	/**
 *Create group data item using the passed in group data item
 *
 *@private
 *@param {String} groupUid	group data item unique ID
 *@param {String} groupType	group data item group type
 *@param {String} groupLabel	group data item group label
 **/


	NodeDataset.prototype._createGroupItem = function _createGroupItem(groupUid, groupType, groupLabel) {
		return {
			't': [{
				'u': groupUid,
				'd': this._getGroupLabel(groupUid, groupType, groupLabel)
			}],
			itemClassSetIndex: ITEMCLASS_SET_INDEX.PARENT_ONLY //parent node itself
		};
	};

	NodeDataset.prototype._createGroupingTypeItem = function _createGroupingTypeItem(groupingType) {
		return {
			't': [{
				'u': groupingType,
				'd': _StringResources2.default.get(groupingType)
			}]
		};
	};

	NodeDataset.prototype._getGroupLabel = function _getGroupLabel(groupUid, groupType, groupLabel) {
		if (groupType === 'hierarchy' || groupType === 'concept') {
			return groupLabel;
		}
		return this._getMetadataLabel(groupLabel);
	};

	NodeDataset.prototype._createFieldItem = function _createFieldItem(groupUid, groupType, groupLabel, fieldUid) {
		return {
			't': [{
				'u': groupUid,
				'd': this._getGroupLabel(groupUid, groupType, groupLabel)
			}, {
				'u': fieldUid,
				'd': this._getMetadataLabel(fieldUid)
			}],
			itemClassSetIndex: ITEMCLASS_SET_INDEX.PARENT_CHILD //Field node and its parent node
		};
	};

	NodeDataset.prototype._createFieldOnlyItem = function _createFieldOnlyItem(fieldUid) {
		return {
			't': [{
				'u': GROUP_TYPE_NONE_PREFIX + fieldUid,
				'd': this._getMetadataLabel(fieldUid)
			}],
			itemClassSetIndex: ITEMCLASS_SET_INDEX.CHILD_ONLY //Field node without parent node
		};
	};

	NodeDataset.prototype._getMetadataLabel = function _getMetadataLabel(uid) {
		if (this.metadataInfo) {
			var field = this.metadataInfo.find(function (field) {
				return field.id === uid;
			});
			if (field) {
				return field.name;
			}
		}
		return uid;
	};

	NodeDataset.prototype.addDatapoint = function addDatapoint(nodeIndex, sizeValue, colorType) {
		var nColorType = this._findColorTypeIndex(colorType);
		this.dataPoints.push({ pt: [nodeIndex, { v: sizeValue }, nColorType] });
	};

	NodeDataset.prototype._findColorTypeIndex = function _findColorTypeIndex(colorType) {
		var nIndex = -1;
		this.groupingTypes.some(function (grouping, groupingIndex) {
			if (colorType.toLowerCase().startsWith(grouping.toLowerCase())) {
				nIndex = groupingIndex;
				return true;
			}
		});
		return nIndex === -1 ? this.groupingTypes.length - 1 : nIndex;
	};

	NodeDataset.prototype._createGroupingTypeItemsList = function _createGroupingTypeItemsList() {
		var _this2 = this;

		this.groupingTypes.forEach(function (colorEntry) {
			_this2.colorItemsList.push(_this2._createGroupingTypeItem(colorEntry));
		});
	};

	NodeDataset.prototype._createGroupingTypeItemsListSection = function _createGroupingTypeItemsListSection() {
		return Object.assign(this._createItemClass_groupingType(), { items: this.colorItemsList });
	};

	NodeDataset.prototype._createNodeItemsListSection = function _createNodeItemsListSection() {
		return Object.assign(this._createItemClass_nodes(), { items: this.nodeItemsList });
	};

	NodeDataset.prototype._createQueryResult = function _createQueryResult() {
		var aDataItemsList = [this._createNodeItemsListSection(), this._createItemClass_confidence(), this._createGroupingTypeItemsListSection()];
		return Object.assign({ dataItems: aDataItemsList }, { data: this.dataPoints });
	};

	NodeDataset.prototype._isSupported_groupType = function _isSupported_groupType(groupType) {
		return !!(groupType && SUPPORTED_GROUP_TYPES.indexOf(groupType) > -1);
	};

	/**
 * @return the converted JSON Object that can be consumed directly to create VIPRDATA
 */


	NodeDataset.prototype.getNodeDatasetQueryResult = function getNodeDatasetQueryResult() {
		var _this3 = this;

		this.dataset.groupings.forEach(function (groupingEntry /*,groupingIndex*/) {
			groupingEntry.groups.forEach(function (groupEntry /*,groupsIndex*/) {
				if (!groupEntry.groupType) {
					// Deduct groupType & groupLabel from groupId if Smarts doesn't provide these infos
					var res = (0, _RelationshipUtil.getGroupTypeAndGroupLabel)(groupEntry.groupId);
					groupEntry.groupType = res.groupType;
					groupEntry.groupLabel = res.groupLabel;
				}
				if (_this3._isSupported_groupType(groupEntry.groupType)) {
					_this3.createItemsFromGroups(groupEntry);
				}
			});
		});
		this._createGroupingTypeItemsList();
		return this._createQueryResult();
	};

	return NodeDataset;
}();

exports.default = NodeDataset;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _RelationshipUtil = __webpack_require__(24);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Licensed Materials - Property of IBM
                                                                                                                                                           *
                                                                                                                                                           * "Restricted Materials of IBM"
                                                                                                                                                           *
                                                                                                                                                           * (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                           *
                                                                                                                                                           * US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           * restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           */


var ITEMCLASS_FROM_UID = 'From';
var ITEMCLASS_TO_UID = 'To';
var ITEMCLASS_STRENGTH_UID = 'Strength';
var ITEMCLASS_AGGREGATE_SUM = 'sum';

/**
* This class converts the Predict Response of smart explore service into the Query Result Data structure
* that can be used to populate VIPRDATA
**/

var LinkDataset = function () {
	function LinkDataset(rawData, metadataInfo, options) {
		_classCallCheck(this, LinkDataset);

		this.dataset = rawData && rawData.relationshipStrength && rawData.relationshipStrength.results ? rawData.relationshipStrength.results[0].relationships : [];
		this.metadataInfo = metadataInfo;
		this.options = options;
		this._resetData();
	}

	LinkDataset.prototype._resetData = function _resetData() {
		this._fromItemsList = []; //Array that stores the virtual 'From' column data items
		this._toItemsList = []; //Array that stores the virtual 'To' column data items
		this.dataPoints = []; //Array that stroes the datapoints array
	};

	LinkDataset.prototype._createItemClass_from = function _createItemClass_from() {
		return { 'itemClass': {
				'h': [{
					'u': ITEMCLASS_FROM_UID,
					'd': ITEMCLASS_FROM_UID
				}]
			} };
	};

	LinkDataset.prototype._createItemClass_to = function _createItemClass_to() {
		return { 'itemClass': {
				'h': [{
					'u': ITEMCLASS_TO_UID,
					'd': ITEMCLASS_TO_UID
				}]
			} };
	};

	/**
 * Create a single data item JSON object using the passed in data item ID
 *
 * @param {String} Item unique name
 **/


	LinkDataset.prototype.createSingleItem = function createSingleItem(groupUid) {
		return {
			't': [{
				'u': groupUid,
				'd': (0, _RelationshipUtil.getGroupLabel)(groupUid, this.metadataInfo)
			}]
		};
	};

	LinkDataset.prototype._createItemClass_strength = function _createItemClass_strength() {
		return { 'itemClass': {
				'h': [{
					'u': ITEMCLASS_STRENGTH_UID,
					'd': ITEMCLASS_STRENGTH_UID,
					'aggregate': ITEMCLASS_AGGREGATE_SUM
				}]
			} };
	};

	/**
 * Add one data item to the 'From' or 'To' data items list
 *
 * @param {String} itemId  The unique ID of the data item to be added
 * @param {Array of JONObject} itemList  Array that holds the data items for either 'From' or 'To' columns
 **/


	LinkDataset.prototype.addSingleItem = function addSingleItem(groupUid, itemsList) {
		var bFound = false;
		var nIndex = -1;
		itemsList.some(function (itemEntry, itemIndex) {
			if (itemEntry.t[0].u === groupUid) {
				//Group has only one tuple
				bFound = true;
				nIndex = itemIndex;
				return bFound;
			}
		});
		if (nIndex === -1) {
			nIndex = itemsList.push(this.createSingleItem(groupUid)) - 1;
		}
		return nIndex;
	};

	/**
 * Add one data point
 *
 * @param {Number} fromIndex
 * @param {Number} toIndex
 * @param {value} value	Strength column value
 **/


	LinkDataset.prototype.addDatapoint = function addDatapoint(fromIndex, toIndex, value) {
		this.dataPoints.push({ pt: [fromIndex, toIndex, { v: value }] });
	};

	/**
 * @return The converted JSON Object that can be consumed directly to create VIPRDATA
 */


	LinkDataset.prototype.getLinkDatasetQueryResult = function getLinkDatasetQueryResult() {
		var _this = this;

		this.dataset.forEach(function (entry) {
			var nFromIndex = void 0,
			    nToIndex = null;
			// If relationship is primary, make sure the target node is on FROM node side to have pretty arc in diagram (VIDA recommendation)
			if (entry.fieldA === _this.options.targetId || entry.fieldB !== _this.options.targetId) {
				nFromIndex = _this.addSingleItem(entry.a, _this._fromItemsList);
				nToIndex = _this.addSingleItem(entry.b, _this._toItemsList);
			} else {
				nFromIndex = _this.addSingleItem(entry.b, _this._fromItemsList);
				nToIndex = _this.addSingleItem(entry.a, _this._toItemsList);
			}
			_this.addDatapoint(nFromIndex, nToIndex, entry.strength);
		});
		var oFromItemsSection = Object.assign(this._createItemClass_from(), { items: this._fromItemsList });
		var oToItemsSection = Object.assign(this._createItemClass_to(), { items: this._toItemsList });
		var oDataItems = { 'dataItems': [oFromItemsSection, oToItemsSection, this._createItemClass_strength()] };
		return Object.assign(oDataItems, { 'data': this.dataPoints });
	};

	return LinkDataset;
}();

exports.default = LinkDataset;

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_244__;

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_245__;

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_246__;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _RelationshipUtil = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           *------------------------------------------------------------------------
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Dashboard
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *------------------------------------------------------------------------
                                                                                                                                                           */


var LONGPRESSTIME = 500;
var DATASET_NODES = 'data.nodes';
var DATASET_LINK = 'data.link';
var HIGHLIGHTED = 'highlighted';
var SELECTED = 'selected';
var HAS_SELECTION = 'hasSelection';
var MAP_GROUPTYPES_TO_LOCALIZED_GROUPTYPES = {
	group: _StringResources2.default.get('group'),
	hierarchy: _StringResources2.default.get('hierarchy'),
	concept: _StringResources2.default.get('concept'),
	fact: _StringResources2.default.get('fact')
};

var RelationshipGraphEventHandler = function () {
	function RelationshipGraphEventHandler(props) {
		var _this = this;

		_classCallCheck(this, RelationshipGraphEventHandler);

		this.onTouchStart = function (event) {
			if (!event.touches || event.touches.length !== 1) {
				return;
			}
			_this.removeTooltip();

			// Convert touch event coordinates to be event.clientX and event.clientY which is used by VIDA
			event = _this._normalizeTouchEvents(event);

			// Persist the event target for accessing the event properties in an asynchronous way
			var target = event.target;

			var dataPointItems = _this._getEventItems(event);
			if (!dataPointItems) {
				return;
			}
			var dataPointItem = dataPointItems[0];
			if (dataPointItem.dataset === DATASET_NODES && dataPointItem.isFieldNode) {
				var isSelected = _this._isSelected(dataPointItem);
				_this.pressTimer = setTimeout(function () {
					_this._isLongPress = true;
					if (_this._touchSameNode(dataPointItem)) {
						if (!isSelected) {
							if (_this._selectedDataPoints && _this._selectedDataPoints.length === 0) {
								// User long presses an unselected node when no nodes were selected: node is selected and context menu shows
								_this._setContextMenu({ event: { target: target }, field: dataPointItem });
								_this.removeTooltip();
							} else {
								// User long presses an unselected node when at least one node was already selected: existing selection is preserved, node is now also selected, context menu is not shown
								_this._hideContextMenu();
							}
							_this._enableSelection([dataPointItem]);
						} else {
							_this._disableSelection([dataPointItem]);
							_this.removeTooltip();
							_this._hideContextMenu();
						}
					}
				}, LONGPRESSTIME);
			}

			_this._displayTooltip(event, dataPointItems[0]);
			event.preventDefault();
		};

		this.onTouchEnd = function (event) {
			clearTimeout(_this.pressTimer);

			event = _this._normalizeTouchEvents(event);

			if (_this._isLongPress) {
				_this._isLongPress = false;
				return;
			}

			var dataPointItems = _this._getEventItems(event);
			if (!dataPointItems) {
				// NOTE: Do not remove the node selection here!
				// Removing the node selection will make it impossible to interact with the recommended visualization menu on iPad.
				// To remove a selected node on iPad, you simply have to press and hold the node and it will be deselected.
				_this._hideContextMenu();
				_this.removeTooltip();
				return;
			}

			var dataPointItem = dataPointItems[0];
			if (dataPointItem.dataset === DATASET_NODES && dataPointItem.isFieldNode) {
				if (_this._selectedDataPoints.length > 0) {
					_this._disableSelection(_this._selectedDataPoints);
				}

				// Any touch on any node closes context menu
				_this._hideContextMenu();
				_this._enableSelection(dataPointItems);
			}
		};

		this.widget = props.widget;
		this.startingPointsVM = props.startingPointsVM;
		this._selectedDataPoints = [];
		this._lastHoverItem = null;
		this.nodeDataset = props.nodeDataset;
		if (this.nodeDataset && this.widget) {
			// the initial state of the relationship diagram should not have selected nodes
			this.nodeDataset.decorate(HAS_SELECTION, false);
			this.widget.render('client');
		}
		this.dataProvider = props.dataProvider;
		this._isLongPress = false;
	}

	RelationshipGraphEventHandler.prototype._getClientX = function _getClientX(event) {
		return event.hasOwnProperty('clientX') ? event.clientX : null;
	};

	RelationshipGraphEventHandler.prototype._getClientY = function _getClientY(event) {
		return event.hasOwnProperty('clientY') ? event.clientY : null;
	};

	RelationshipGraphEventHandler.prototype._getEventTargets = function _getEventTargets(event) {
		var visCoord = this._getClientX(event) && this._getClientY(event) ? this.widget.getVisCoordinate(this._getClientX(event), this._getClientY(event)) : null;
		var items = visCoord && this.widget.getItemsAtPoint(visCoord);
		return items && items.length ? items : null;
	};

	RelationshipGraphEventHandler.prototype._processItems = function _processItems(items) {
		var dataPointItems = [];
		if (items.length === 1) {
			dataPointItems = this._processNode(items[0]);
		} else if (items.length === 3) {
			dataPointItems = this._processLink(items);
		}
		return dataPointItems && dataPointItems.length ? dataPointItems : null;
	};

	RelationshipGraphEventHandler.prototype._processNode = function _processNode(item) {
		var dataPointItems = [];
		var values = this._itemRowToTargetValues(item.row);
		if (!values) {
			return null;
		}
		var isFieldNode = this._isFieldNode(values);
		dataPointItems.push({
			dataset: DATASET_NODES,
			index: item.index,
			source: item.source,
			values: values,
			itemId: this._getNodeId(values[0], isFieldNode),
			isFieldNode: isFieldNode
		});
		return dataPointItems;
	};

	/**
 * Check if the current node is a Field node
 **/


	RelationshipGraphEventHandler.prototype._isFieldNode = function _isFieldNode(values) {
		return !this.dataProvider.getRawNodeDataset().getOptions().showConcepts || values[2] && values[2][0] && values[2][0].u === 'field' || values[0].length === 2;
	};

	RelationshipGraphEventHandler.prototype._getNodeId = function _getNodeId(values, isFieldNode) {
		var result = values.length === 1 ? values[0].u : values[1].u;
		if (isFieldNode) {
			result = this._trimFieldPrefix(result);
		}
		return result;
	};

	RelationshipGraphEventHandler.prototype._processLink = function _processLink(items) {
		var dataPointItems = [];
		// VIPR returns 3 items for a link: 1st item is from node, 2nd is to node and 3rd item is the link.
		// The 3rd item contains all information that we need, so process only the 3rd item
		var values = this._itemRowToTargetValues(items[2].row);
		if (!values) {
			return null;
		}
		dataPointItems.push({
			dataset: DATASET_LINK,
			source: items[2].source,
			values: values[2],
			itemId: { fromNode_id: this._getNodeId(values[0]), toNode_id: this._getNodeId(values[1]) }
		});
		return dataPointItems;
	};

	RelationshipGraphEventHandler.prototype._itemRowToTargetValues = function _itemRowToTargetValues(row) {
		if (!row || !row.length) {
			return null;
		}
		return row.map(function (data) {
			if (data.infoType === 'value') {
				var values = [];
				var index = data.index || 0;
				values[index] = data.value;
				return values;
			}
			return data.items.map(function (item) {
				return {
					u: item.source.getUniqueName(),
					d: item.source.item.d,
					p: item.source.item.p
				};
			});
		});
	};

	RelationshipGraphEventHandler.prototype._getEventItems = function _getEventItems(event) {
		var viprItems = this._getEventTargets(event);
		if (viprItems) {
			return this._processItems(viprItems);
		}
		return null;
	};

	RelationshipGraphEventHandler.prototype._setContextMenu = function _setContextMenu(_ref) {
		var event = _ref.event,
		    field = _ref.field;

		this.startingPointsVM.relationship.setContextMenu({ element: event.target, field: field });
	};

	RelationshipGraphEventHandler.prototype._hideContextMenu = function _hideContextMenu() {
		this.startingPointsVM.relationship.setContextMenu({ element: null, field: null });
	};

	RelationshipGraphEventHandler.prototype._enableSelection = function _enableSelection(dataPointItems) {
		var _this2 = this;

		dataPointItems.forEach(function (dataPoint) {
			dataPoint.source.decorate(HIGHLIGHTED);
			dataPoint.source.decorate(SELECTED, true);
			// add selected item in the list of selected items
			_this2._selectedDataPoints.push({
				itemId: dataPoint.itemId,
				source: dataPoint.source
			});
		});
		this.nodeDataset.decorate(HAS_SELECTION, true);
		this.widget.render('client');
		this.startingPointsVM.relationship.setSelectedFields(this._selectedDataPoints);
		var influencers = this._getDistinctInfluencers(this._selectedDataPoints).map(function (id) {
			return {
				id: id,
				label: _this2._getFieldLabel(id)
			};
		});
		this.startingPointsVM.setSelectedInfluencers(influencers);
	};

	// We can have the same field in different groups, this is to avoid sending Smarts many nodes with same Id.
	// Otherwise Smarts will return visualization "relationship between Quantity and Quantity"


	RelationshipGraphEventHandler.prototype._getDistinctInfluencers = function _getDistinctInfluencers(selectedItems) {
		var influencers = {};
		selectedItems.forEach(function (selected) {
			if (!influencers[selected.itemId]) {
				influencers[selected.itemId] = selected.itemId;
			}
		});
		return Object.keys(influencers);
	};

	RelationshipGraphEventHandler.prototype._disableSelection = function _disableSelection(dataPointItems) {
		var _this3 = this;

		dataPointItems.forEach(function (dataPoint) {
			dataPoint.source.clearDecorations();
			_this3._selectedDataPoints = _this3._selectedDataPoints.filter(function (selected) {
				return selected.source !== dataPoint.source;
			});
		});
		if (!this._selectedDataPoints.length) {
			this.nodeDataset.decorate(HAS_SELECTION, false);
		}
		this.widget.render('client');
		this.startingPointsVM.relationship.setSelectedFields(this._selectedDataPoints);
		var influencers = this._getDistinctInfluencers(this._selectedDataPoints).map(function (id) {
			return {
				id: id,
				label: _this3._getFieldLabel(id)
			};
		});
		this.startingPointsVM.setSelectedInfluencers(influencers);
	};

	RelationshipGraphEventHandler.prototype._isSelected = function _isSelected(dataPointItem) {
		return dataPointItem.source.getDecoration(SELECTED);
	};

	RelationshipGraphEventHandler.prototype._disableHighlight = function _disableHighlight(item) {
		item.source.decorate(HIGHLIGHTED, false);
		this._lastHoverItem = null;
		this.widget.render('client');
	};

	RelationshipGraphEventHandler.prototype._enableHighlight = function _enableHighlight(item) {
		if (this._lastHoverItem && !this._isSelected(this._lastHoverItem)) {
			this._lastHoverItem.source.decorate(HIGHLIGHTED, false);
		}
		item.source.decorate(HIGHLIGHTED);
		this._lastHoverItem = item;
		this.widget.render('client');
	};

	// We want to display tooltip on top and center of the node


	RelationshipGraphEventHandler.prototype._getAdjustedCoordinatesForNodes = function _getAdjustedCoordinatesForNodes(dataPointItem, event) {
		var coord = {};
		if (dataPointItem.dataset === DATASET_NODES) {
			var rec = event.target.getBoundingClientRect();
			if (rec) {
				coord.y = rec.top;
				coord.x = (rec.left + rec.right) / 2;
			}
		}
		return coord;
	};

	RelationshipGraphEventHandler.prototype.removeTooltip = function removeTooltip() {
		if (this._lastHoverItem && !this._isSelected(this._lastHoverItem)) {
			this._disableHighlight(this._lastHoverItem);
		}
		this.startingPointsVM.relationship.tooltip.showTooltip(null);
	};

	// Event handler


	RelationshipGraphEventHandler.prototype.onClick = function onClick(event) {
		var dataPointItems = this._getEventItems(event);
		if (!dataPointItems || !this._acceptClick(dataPointItems)) {
			return;
		}
		// multi-selection mode flag
		var bCtrlClick = event.ctrlKey || event.metaKey;
		var isSelected = this._isSelected(dataPointItems[0]);
		if (isSelected) {
			// select a selected node triggers de-select this node

			this._disableSelection(dataPointItems);
		} else {
			if (bCtrlClick) {
				// multi-selection mode: enable newly selected
				this._enableSelection(dataPointItems);
			} else {
				// single-selection mode: disable previous selected and enable newly selected
				if (this._selectedDataPoints.length > 0) {
					this._disableSelection(this._selectedDataPoints);
				}
				this._enableSelection(dataPointItems);
			}
		}
	};

	/**
  * Handle context menu event
  * @param {object} event
  */


	RelationshipGraphEventHandler.prototype.onRightClick = function onRightClick(event) {
		var dataPointItems = this._getEventItems(event);
		if (!dataPointItems || !this._acceptClick(dataPointItems)) {
			return;
		}
		this._setContextMenu({ event: event, field: dataPointItems[0] });
	};

	// Accept only node element in the graph which is a field node (not a group/concept/hierarchy node)


	RelationshipGraphEventHandler.prototype._acceptClick = function _acceptClick(dataPointItems) {
		// user can only click 1 element at a time.
		var item = dataPointItems[0];
		return item.dataset === DATASET_NODES && item.isFieldNode;
	};

	RelationshipGraphEventHandler.prototype.onMouseOver = function onMouseOver(event) {
		var dataPointItems = this._getEventItems(event);
		if (!dataPointItems) {
			return null;
		}
		this._displayTooltip(event, dataPointItems[0]);
	};

	RelationshipGraphEventHandler.prototype.onMouseOut = function onMouseOut() {
		this.removeTooltip();
	};

	RelationshipGraphEventHandler.prototype.onKeyDown = function onKeyDown(event) {
		if (event.key === 'Delete' || event.key === 'Backspace') {
			var relationshipVM = this.startingPointsVM.relationship;
			var selectedFields = relationshipVM.selectedFields;
			if (selectedFields && selectedFields.length === 1) {
				relationshipVM.canDeleteFields(selectedFields) && relationshipVM.deleteFields(selectedFields);
			}
			event.stopPropagation();
		} else if (event.key === 'Enter') {
			var _event$target$getBoun = event.target.getBoundingClientRect(),
			    left = _event$target$getBoun.left,
			    top = _event$target$getBoun.top,
			    width = _event$target$getBoun.width,
			    height = _event$target$getBoun.height;

			event.clientX = left + width / 2;
			event.clientY = top + height / 2;
			var dataPointItems = this._getEventItems(event);
			if (dataPointItems && dataPointItems.length) {
				var dataPointItem = dataPointItems[0];
				if (dataPointItem.dataset === DATASET_NODES && dataPointItem.isFieldNode) {
					this._setContextMenu({ event: event, field: dataPointItem });
					event.stopPropagation();
				}
			}
		}
	};

	RelationshipGraphEventHandler.prototype._normalizeTouchEvents = function _normalizeTouchEvents(e) {
		var event = e;
		event.isTouch = true;
		var coords = e.touches[0];

		if (coords && coords.clientX !== undefined) {
			event.clientX = coords.clientX;
			event.clientY = coords.clientY;
			event.pageX = coords.pageX;
			event.pageY = coords.pageY;
		}
		return event;
	};

	RelationshipGraphEventHandler.prototype._touchSameNode = function _touchSameNode(dataPointItem) {
		return this._lastHoverItem && this._lastHoverItem.source === dataPointItem.source;
	};

	RelationshipGraphEventHandler.prototype._displayTooltip = function _displayTooltip(event, item) {
		var tooltipInfo = this._buildTooltipInfo(event, item);
		if (tooltipInfo) {
			this._enableHighlight(item);
			this.startingPointsVM.relationship.tooltip.showTooltip(tooltipInfo);
		}
	};

	RelationshipGraphEventHandler.prototype._buildTooltipInfo = function _buildTooltipInfo(event, item) {
		var tooltipTitle = this._buildTooltipTitle(item);
		event.persist(); // keep target for tooltip's flyout node
		if (tooltipTitle) {
			var adjustedCoord = this._getAdjustedCoordinatesForNodes(item, event);
			return {
				title: tooltipTitle,
				coordinates: {
					top: adjustedCoord.y || event.clientY,
					left: adjustedCoord.x || event.clientX,
					width: 0
				},
				eventTarget: event.target,
				itemId: item.itemId
			};
		} else {
			return null;
		}
	};

	RelationshipGraphEventHandler.prototype._buildTooltipTitle = function _buildTooltipTitle(dataPointItem) {
		if (dataPointItem.dataset === DATASET_NODES) {
			if (dataPointItem.isFieldNode) {
				return this._buildTooltipTitleForFieldNode(dataPointItem);
			} else {
				return this._buildTooltipTitleForGroupNode(dataPointItem);
			}
		}
		return this._buildTooltipTitleForLink(dataPointItem);
	};

	// For Field node, tooltip should look like:
	// Parent: parentId (ex: Table1)
	// Field label
	// Relevance: confidence value, in format nn% (ex: 85%)


	RelationshipGraphEventHandler.prototype._buildTooltipTitleForFieldNode = function _buildTooltipTitleForFieldNode(dataPointItem) {
		var itemId = this._trimFieldPrefix(dataPointItem.itemId);
		return [{
			label: _StringResources2.default.get('parent') + ': ',
			value: '' + this._getParentId(itemId)
		}, {
			label: '',
			value: '' + this._getFieldLabel(itemId)
		}];
	};

	/*
  * Before relationship API have an ideal way to indicate a column is a field.
  * we will need to do this trimming since a field column is always fixed width
  * none_ prefix
  */


	RelationshipGraphEventHandler.prototype._trimFieldPrefix = function _trimFieldPrefix(itemId) {
		if (itemId && itemId.indexOf('none_') === 0) {
			//TODO: By the new design, we always prefix none_ for field ID,
			//The workaround should be removed after server end
			//introduces a new indicator for field. The background
			//of this is that 'predict' is currently still analyzing group nodes
			//while those nodes do not exist any more from node datasets.
			itemId = itemId.substr(5, itemId.length);
		}
		return itemId;
	};

	/**
  * For group node, tooltip should look like:
  * {groupType}: {groupId}
  * Ex: "Concept: Geography"
  * For hierarchy, the tooltip should look like:
  * Hierarchy: <highest level label> - <lowest level label>
  * Ex: "Hierarchy: Product Line - Product"
  */


	RelationshipGraphEventHandler.prototype._buildTooltipTitleForGroupNode = function _buildTooltipTitleForGroupNode(dataPointItem) {
		var groupType = this._getGroupType(dataPointItem);
		var localizedGroupType = MAP_GROUPTYPES_TO_LOCALIZED_GROUPTYPES[groupType];
		var groupLabel = this._getGroupLabel(dataPointItem);
		if (groupType === 'hierarchy') {
			var levelString = this.dataProvider.rawNodeDataset.getHierarchyLevels(dataPointItem.itemId);
			return [{
				label: localizedGroupType + ': ',
				value: '' + (levelString || groupLabel)
			}];
		}
		return [{
			label: localizedGroupType + ': ',
			value: '' + groupLabel
		}];
	};

	// For link, tooltip should look like:
	// fromGroup_name - toGroup_name: name of 2 groups at 2 ends of the link
	// Strength: 57% (strongest relationship between 2 groups calculated by Predicts)


	RelationshipGraphEventHandler.prototype._buildTooltipTitleForLink = function _buildTooltipTitleForLink(dataPointItem) {
		return [{
			label: '',
			value: this._getGroupLabelFromGroupId(dataPointItem.itemId.fromNode_id) + ' - ' + this._getGroupLabelFromGroupId(dataPointItem.itemId.toNode_id)
		}, {
			label: _StringResources2.default.get('strength') + ': ',
			value: '' + this._format(dataPointItem.values[0])
		}];
	};

	RelationshipGraphEventHandler.prototype._getGroupLabelFromGroupId = function _getGroupLabelFromGroupId(groupUid) {
		var fields = this.startingPointsVM.fields.getFields().getAll();
		return (0, _RelationshipUtil.getGroupLabel)(groupUid, fields);
	};

	RelationshipGraphEventHandler.prototype._getFieldLabel = function _getFieldLabel(fieldId) {
		var fields = this.startingPointsVM.fields.getFields().getAll();
		return (0, _RelationshipUtil.getFieldLabel)(fieldId, fields);
	};

	RelationshipGraphEventHandler.prototype._getParentId = function _getParentId(fieldId) {
		return fieldId.substr(0, fieldId.lastIndexOf('.'));
	};

	// Format the confidence and strength value
	// Ex: value = 0.6677797 => return 67%


	RelationshipGraphEventHandler.prototype._format = function _format(value) {
		if (!this.startingPointsVM.relationship.getIsFilterStrengthFeatureEnabled()) {
			if (!isNaN(value)) {
				return Math.round(value * 100) + '%';
			}
		}
		return value + '%';
	};

	RelationshipGraphEventHandler.prototype._getGroupType = function _getGroupType(dataPointItem) {
		return dataPointItem.values[2][0].u;
	};

	RelationshipGraphEventHandler.prototype._getGroupLabel = function _getGroupLabel(dataPointItem) {
		return dataPointItem.values[0][0].d;
	};

	RelationshipGraphEventHandler.prototype.onDestroy = function onDestroy() {
		this.startingPointsVM.setSelectedInfluencers();
	};

	return RelationshipGraphEventHandler;
}();

exports.default = RelationshipGraphEventHandler;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

function generateAddCardOptions(options) {
	var selectAfterAdd = options && options.selectAfterAdd !== undefined ? options.selectAfterAdd : true;
	return options && Object.assign(options, { insertBefore: options.insertBefore, selectAfterAdd: selectAfterAdd, model: options.model });
}
/**
 * a set of APIs for exploration operations (eg. add card, delete card)
 * @module ExplorationAPI
 */

var ExplorationAPI = function ExplorationAPI(exploreModel, startingPointsAPI, copyPasteAPI) {
	_classCallCheck(this, ExplorationAPI);

	/**
  * To be invoked by the product only.
  */
	this.destroy = function () {
		exploreModel = null;
		startingPointsAPI = null;
	};

	/**
  * @param {string} id - id of card
  * @return {CardAPI} represented by the supplied id
  */
	this.getCard = function (id) {
		return exploreModel.findModel(id).getAPI();
	};

	/**
  * @return {CardAPI[]} all cards, in order
  */
	this.getCards = function () {
		return exploreModel.items.map(function (cardModel) {
			return cardModel.getAPI();
		});
	};

	/**
  * Adds a new card
  * @param {object} params - parameters of operation, includes widgets and model
  * @param {array}  params.widgetSpecs - widgets spec of card
  * @param {object} [params.layoutSpec] - layout model of card, if omitted single/regular card will be created
  * @param {object} [options] - additional options for add operation
  * @param {string} [options.insertBefore] - id of card to add this card before - if omitted, new card will be last card
  * @return {string} model id for new card
  */
	this.addCard = function (params, options) {
		var cardOptions = options;
		if (params.layoutSpec) {
			if (cardOptions) {
				cardOptions.model = params.layoutSpec;
			} else {
				cardOptions = { model: params.layoutSpec };
			}
		}
		return exploreModel.addVisCard(params.widgetSpecs, null, generateAddCardOptions(cardOptions));
	};

	/**
  * Delete an array of card(s) for the given card IDs
  * @param  {string[]} cards IDs
  * @return {boolean} True if it successfully deleted passed in cards
  */
	this.deleteCards = function (ids) {
		return exploreModel.deleteCards(ids);
	};

	/**
  * Duplicates an existing card
  * @param {string} cardID - card to duplicate
  * @param {object} [options] - additional operations for duplicate operation
  * @param {string} [options.insertBefore] - id of card ot add this card before
  */
	this.duplicateCard = function (cardId, options) {
		return exploreModel.duplicateCard(exploreModel.findModel(cardId), null, generateAddCardOptions(options));
	};

	/**
 * Add a driver analysis card for the selected correlation entry.
 * This function will look for an existing driver analysis card that matches the target and the filters used by the correlation entry
 * If one is found, we switch to it and update the selected driver
 * If none is found, then we create a new driver analysis card using the widget spec supplied by the correlation entry
 * @param {Object} correlationEntry - object representing the correlation entry returned by the badges feature
 */
	this.addDriverAnalysisCardForCorrelation = function (correlationEntry) {
		exploreModel.addCometCardForCorrelation(correlationEntry);
	};

	/**
  * Get related widgets of current selected widget
  * @return {object} promise with recommended widgets
  */
	this.getRelatedVis = function () {
		var widget = exploreModel.exploreVM.selectedWidget;
		if (!widget) {
			throw new Error('No widget is selected');
		}
		return exploreModel.exploreVM.relatedRecommendationVM.recommender.fetchRecommendations(widget, 'related');
	};

	/**
  * Get recommended viz of current selected widget
  * @return {object} promise with recommended widgets
  */
	this.getRecommendedVisualizations = function () {
		var widget = exploreModel.exploreVM.selectedWidget;
		if (!widget) {
			throw new Error('No widget is selected');
		}
		return exploreModel.exploreVM.alternativeRecommendationVM.fetchRecommendations(widget, 'alternative').then(function () {
			return exploreModel.exploreVM.alternativeRecommendationVM.getRecommendations();
		});
	};

	/**
  * Get compare card recommendations of current selected widget
  * @return {object} promise with recommended compare cards
  */
	this.getCompareCardRecommendations = function () {
		var widget = exploreModel.exploreVM.selectedWidget;
		if (!widget) {
			throw new Error('No widget is selected');
		}
		var widgetModel = exploreModel.exploreVM.selectedWidgetModel;
		return exploreModel.exploreVM.getCompareCardRecommendations({ widgetApi: widget, widgetModel: widgetModel });
	};

	/**
  * Change the vis type either by doing recommendation and manual choose
  * @param {object} recommendation - recommended viz
  * @param {boolean} isSetByAuto - automatically recommendation or manually choose
  * @return {object} a promise which would be resolved when the action is done
  */
	this.changeVisType = function (recommendation, isSetByAuto) {
		return exploreModel.exploreVM.changeVisType(recommendation, isSetByAuto);
	};

	/**
  * Change to a fixed vis type for a selected widget
  * @param {string} visId - the id of a vis
  * @return {object} a promise
  */
	this.changeFixedVisualizationTypeForSelectedWidget = function (visId) {
		return exploreModel.exploreVM.changeFixedVisType(visId);
	};

	/**
  * Copy the currently displayed widget(s) in explore into clipboard
  * @return {object} a promise which would be resolved when the action is done
  */
	this.copy = function () {
		return copyPasteAPI.copy();
	};

	/**
  * Paste the copied widget(s) to explore
  * @return {object} a promise which would be resolved when the action is done
  */
	this.paste = function () {
		return copyPasteAPI.paste();
	};

	/**
  * select cards with range or single selection
  * @param {string} id - id card id to select
  * @param {object} [options] - select options
  * @param {boolean} [options.multiSelect] - true, multi select on top of current selections; otherwise, false
  * @param {boolean} [options.rangeSelect] - true, range select between current card id and current selection; otherwise, false
  * @return {string} model id for new card
  */
	this.selectCards = function (id) {
		var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
		    _ref$rangeSelect = _ref.rangeSelect,
		    rangeSelect = _ref$rangeSelect === undefined ? false : _ref$rangeSelect,
		    _ref$multiSelect = _ref.multiSelect,
		    multiSelect = _ref$multiSelect === undefined ? false : _ref$multiSelect;

		var options = void 0;
		if (rangeSelect) {
			options = { shift: true };
		} else if (multiSelect) {
			options = { control: true };
		}
		exploreModel.exploreVM.selectedCards.select(id, options);
	};

	/**
  * delete all selected cards
  * @return {boolean} True if it successfully deleted passed in cards
  */
	this.deleteSelectedCards = function () {
		var selectedCardIds = this.getSelectedCardIds();
		return exploreModel.deleteCards(selectedCardIds);
	};

	/**
  * get cards being selected
  * @return {string[]} array of card ids
  */
	this.getSelectedCardIds = function () {
		return exploreModel.exploreVM.selectedCards.items.map(function (item) {
			return item;
		});
	};

	/**
  * @return {boolean} true if starting points view is opened
  */
	this.isStartingPointsDisplayed = function () {
		return exploreModel.exploreVM.isStartingPointsDisplayed();
	};

	/**
  * Get current displayed card id
  * @return {string} current displayed card id
  */
	this.getDisplayedCard = function () {
		return exploreModel.exploreVM.getDisplayedCard();
	};

	/**
  * Set display to card
  * @param {string} id card id
  */
	this.setDisplayedToCard = function (id) {
		return exploreModel.exploreVM.setDisplayedToCard(id);
	};
	/**
  * get starting point api;
  * @return {object} starting point api
  */
	this.getStartingPointsAPI = function () {
		return startingPointsAPI;
	};

	/**
  * Set the current active data source with a given data source Id
  * @param {string} dataSourceId Data Source Id
  */
	this.setActiveDataSourceId = function (dataSourceId) {
		if (!dataSourceId) {
			throw new Error('No dataSourceId is specified');
		}
		exploreModel.exploreVM.setActiveDataSourceId(dataSourceId);
	};

	/**
  * @return {string} the active data source id
  */
	this.getActiveDatasourceId = function () {
		return exploreModel.exploreVM.activeDataSourceId;
	};

	/**
  * get the current active data source module
  * @return {Promise<Module>} Return a promise resolved with the data source Module
  */
	this.getActiveDataSourceModule = function () {
		var activeDataSourceModule = exploreModel.exploreVM.activeDataSourceModule;
		if (activeDataSourceModule) {
			return activeDataSourceModule;
		} else {
			return Promise.resolve(null);
		}
	};
};

exports.default = ExplorationAPI;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _mobxStateTree = __webpack_require__(7);

var _ErrorUtils = __webpack_require__(250);

var _ScopeModel = __webpack_require__(51);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

/**
 * a set of APIs for starting point operations
 * @module StartingPointsAPI
 */
var StartingPointsAPI = function StartingPointsAPI(startingPointsModel) {
	_classCallCheck(this, StartingPointsAPI);

	/**
  * To be invoked by the product only.
  */
	this.destroy = function () {
		startingPointsModel = null;
	};
	/**
  * @return {string} the active data source id
  */
	this.getActiveDatasourceId = function () {
		return startingPointsModel.exploreVM.activeDataSourceId;
	};

	this.getFieldsByModelId = function (modelId) {
		if (startingPointsModel) {
			return startingPointsModel.fields.fields.get(modelId);
		}
		return Promise.reject(new Error('No StartingPoints Model'));
	};
	/**;
  * @return {object} - current snapshot of starting point model if it exists; or rejects with an error if starting point model does not exist.
  */
	this.getState = function () {
		if (startingPointsModel) {
			return (0, _mobxStateTree.getSnapshot)(startingPointsModel);
		} else {
			throw new Error('No StartingPoints Model');
		}
	};

	/**
  * @return {object} - a promise resolves when relationship data has been loaded
  */
	this.whenRelationshipDataReady = function () {
		if (startingPointsModel) {
			return startingPointsModel.relationship.whenRelationshipDataReady();
		} else {
			return Promise.reject(new Error('No StartingPoints Model'));
		}
	};

	/**
  * @param {array} [fields] - an array of column ids
  * @returns a promise resolves with widgetSpecs
  */
	this.getRecommendations = function (fields) {
		var smartsRecommender = startingPointsModel.exploreVM.relatedRecommendationVM.recommender;
		if (fields) {
			return smartsRecommender.recommendRelatedVisualizationsAsWidgetSpecs(this.getActiveDatasourceId(), fields, { includeBestVisForTargetFields: true });
		}
		throw new Error('Invalid arguments!');
	};

	/**
  * @param {string} dataSourceId active data source id
  * @returns an array of all the field IDs
  */
	this.getAllFieldIds = function (dataSourceId) {
		var allFields = startingPointsModel.fields.getFields(dataSourceId).getAll();
		return allFields.map(function (_ref) {
			var id = _ref.id;
			return id;
		});
	};
	/**
  * @param {string} dataSourceId active data source id
  * @returns an array of the interesting field IDs
  */
	this.getInterestingFieldIds = function (dataSourceId) {
		var interestingFields = startingPointsModel.fields.getFields(dataSourceId).getInteresting();
		return interestingFields.map(function (_ref2) {
			var id = _ref2.id;
			return id;
		});
	};
	/**
  * Function to satisfy wizard conditions by selecting the first field as focus field
  * @param {string} dataSourceId active data source id
  * @return the id of focus field selected
  */
	this.skipWizard = function (dataSourceId) {
		var _startingPointsModel$ = startingPointsModel.fields.getFields(dataSourceId),
		    _startingPointsModel$2 = _startingPointsModel$.all,
		    state = _startingPointsModel$2.state,
		    allFields = _startingPointsModel$2.value;

		if (state === 'fulfilled' && allFields.length) {
			//Usual case: select first field
			return this.setFocusField(allFields[0].id).then(this.getFocusField.bind(this));
		} else {
			throw (0, _ErrorUtils.createApiError)('No focus field was set');
		}
	};

	/**
  * @return the current focus field id
  */
	this.getFocusField = function () {
		var focusField = startingPointsModel.fields.getFocusField();
		if (focusField) {
			return focusField.id;
		}
		return null;
	};

	/**
  * @param {number} id - set the focus field to the field with this id
  */
	this.setFocusField = function (id) {
		var fieldsPromise = startingPointsModel.fields.getFields().interesting;
		return fieldsPromise.then(function () {
			startingPointsModel.fields.setFocusField(id);
			var focusField = startingPointsModel.fields.getFocusField();
			if (!focusField || focusField.id !== id) {
				throw (0, _ErrorUtils.createApiError)('Invalid id', 'STARTP_INVALID_FOCUS_FIELD_ID');
			}
		});
	};

	/**
  * @deprecated field list is going away
  * @param {number} index - set the focus field to the field that is at the given index of the interesting fields
  */
	this.setFocusFieldIndex = function (index) {
		var fieldsPromise = startingPointsModel.fields.getFields().interesting;
		return fieldsPromise.then(function () {
			var interesting = startingPointsModel.fields.getFields().getInteresting() || [];
			if (!(index >= 0 && index < interesting.length)) {
				throw (0, _ErrorUtils.createApiError)('Invalid index', 'STARTP_INVALID_FOCUS_FIELD_INDEX');
			}
			startingPointsModel.fields.setFocusFieldIndex(index);
		});
	};

	/**
  * Add a field to relationship diagram
  * @param {String[]} field ID list
  * @return {boolean} True means the set action is executed, False otherwise
  */
	this.addRelationshipDiagramFields = function (fields) {
		if (fields && fields.length) {
			var relationshipVM = startingPointsModel.relationship;
			var targetModel = relationshipVM && relationshipVM.getTargetModel();
			if (targetModel) {
				targetModel.setLastAddedFields(fields);
				return true;
			}
		}
		return false;
	};

	/**
  * Prevent fields from being shown in the relationship diagram
  * @param {string[]} fields - array of field ids to remove
  */
	this.removeRelationshipDiagramFields = function (fields) {
		fields = (fields || []).map(function (itemId) {
			return { itemId: itemId };
		});
		startingPointsModel.relationship.deleteFields(fields);
	};

	/**
  * Controls the relationship type (primary/secondary) displayed in the relationship diagram
  * @param {boolean} bValue - true/false
  * @return {boolean} true when the API can set the input parameter value to the property 'showPrimaryRelationshipView'
  * and false when the set doesn't happen
  */
	this.setShowPrimaryRelationshipView = function (bValue) {
		var targetModel = startingPointsModel.relationship.getTargetModel();
		if (targetModel && targetModel.setShowPrimaryRelationshipView) {
			targetModel.setShowPrimaryRelationshipView(bValue);
			return true;
		} else {
			return false;
		}
	};

	/**
  * Set the relationship strength range to filter relationships in the relationship diagram
  * @param {Object} filterStrength - strength range (min, max) value to filter relationship strength
  * @return {boolean} true/false - true when the set function happens and the property value is updated and false when the set doesn't happen.
  */
	this.setRelationshipFilterStrength = function (filterStrength) {
		var targetModel = startingPointsModel.relationship.getTargetModel();
		if (targetModel && targetModel.setFilterStrength) {
			targetModel.setFilterStrength(filterStrength);
			return true;
		} else {
			return false;
		}
	};
	/**
 * Reset relationship diagram
 */
	this.resetRelationshipDiagram = function () {
		startingPointsModel.relationship.reset();
	};

	/**
  * Set the relationship diagram scope to given fields list
  * @param {object[]} fields field id list
  * @returns {boolean} true if successfully set scoped fields, false if not
  */
	this.setScope = function (fields) {
		if (!(fields && fields.length)) {
			throw (0, _ErrorUtils.createApiError)('Invalid fields list', 'STARTP_INVALID_SCOPE_FIELDS_LIST');
		}

		var targetModel = startingPointsModel.relationship.getTargetModel();
		if (targetModel) {
			targetModel.setScope(fields.map(_ScopeModel.parseFieldIDForExpression));
			return true;
		} else {
			return false;
		}
	};

	/**
  * Show the relationship between `from` node and `to` node
  * @param {string} from - field id
  * @param {string} to - field id
  */
	this.showRelationshipsBetween = function (from, to) {
		if (!(from && to && from.length && to.length)) {
			throw (0, _ErrorUtils.createApiError)('Invalid `from` or `to` field id', 'STARTP_INVALID_FROM_TO_FIELD_ID');
		}

		var targetModel = startingPointsModel.relationship.getTargetModel();
		if (targetModel) {
			targetModel.showRelationshipsBetween(from, to);
			return true;
		} else {
			return false;
		}
	};

	/**
  * Get Number Of RunningRequest
  * @param {string} dataSourceId - defaut to current data source
  * @return {number}
  */
	this.getNumberOfRunningRequests = function (dataSourceId) {
		return startingPointsModel.relationship.getNumOfRunningRequests(dataSourceId);
	};

	/**
  * If we can fetch data for the target Id. eg, the number of running requests are reached limit, we then cannot fetch data for a new target
  * @param {string} targetId - targetId
  * @param {string} action - `changeTarget` or `editScope`
  * @return {boolean}
  */
	this.canFetchData = function (targetId, action) {
		var result = startingPointsModel.relationship.canFetchData(targetId, action);
		return !!(result && result.canFetchData);
	};
};

exports.default = StartingPointsAPI;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createApiError = createApiError;

var _ErrorCodes = __webpack_require__(251);

var _ErrorCodes2 = _interopRequireDefault(_ErrorCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Build an API error
 * @param {string} message - error message
 * @param {string} errCode - error code
 * @returns {Error} Error 
 */
function createApiError(message, errCode) {
  var error = new Error(message);
  error.code = _ErrorCodes2.default[errCode];
  return error;
} /*
   *+------------------------------------------------------------------------+
   *| Licensed Materials - Property of IBM
   *| IBM Cognos Products: Dashboard
   *| (C) Copyright IBM Corp. 2019
   *|
   *| US Government Users Restricted Rights - Use, duplication or disclosure
   *| restricted by GSA ADP Schedule Contract with IBM Corp.
   *+------------------------------------------------------------------------+
  */

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * This is an error codes map used by explore apis
 */
exports.default = {
  STARTP_INVALID_FOCUS_FIELD_INDEX: 'CA-EXP-STARTP-2000', // StartingPointsAPI::setFocusFieldIndex
  STARTP_INVALID_FOCUS_FIELD_ID: 'CA-EXP-STARTP-2001', // StartingPointsAPI::setFocusField
  STARTP_INVALID_SCOPE_FIELDS_LIST: 'CA-EXP-STARTP-2002', // StartingPointsAPI::setScopedFields
  STARTP_INVALID_FROM_TO_FIELD_ID: 'CA-EXP-STARTP-2003' // StartingPointsAPI::showRelationshipsBetween
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/**
 * a set of APIs for copy and paste operations
 * @module CopyPasteAPI
 */
var CopyPasteAPI = function CopyPasteAPI(copyImp, pasteImp) {
	_classCallCheck(this, CopyPasteAPI);

	/**
  * To be invoked by the product only.
  */
	this.destroy = function () {
		this.copy = function () {};
		this.paste = function () {};
	};

	/**
  * Copy the currently displayed widget(s) in explore into clipboard
  * @return {object} a promise which would be resolved when the action is done
  */
	this.copy = copyImp;

	/**
  * Paste the copied widget(s) to explore
  * @return {object} a promise which would be resolved when the action is done
  */
	this.paste = pasteImp;
};

exports.default = CopyPasteAPI;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_253__;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.VisPlaceholderView = undefined;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _LayoutBase2 = __webpack_require__(38);

var _CreateExplorationLayout = __webpack_require__(52);

var _CreateExplorationLayout2 = _interopRequireDefault(_CreateExplorationLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//This should be not starting points-specific

var VisPlaceholderView = exports.VisPlaceholderView = (0, _mobxReact.observer)(_class = function (_ReactLayoutImplBase) {
	_inherits(VisPlaceholderView, _ReactLayoutImplBase);

	function VisPlaceholderView(props) {
		_classCallCheck(this, VisPlaceholderView);

		var _this = _possibleConstructorReturn(this, _ReactLayoutImplBase.call(this, props));

		_this.boardModel = _this.props.layoutController.boardModel;

		_this.services = props.services;

		_this.Component = VisPlaceholder;
		return _this;
	}

	VisPlaceholderView.prototype.render = function render() {
		var _this2 = this;

		return _react2.default.createElement(_CreateExplorationLayout2.default, {
			fill: true,
			services: this.props.services,
			activeDataSourceId: this.boardModel.layout.exploreVM.activeDataSourceId,
			handleShowVisTypesClick: function handleShowVisTypesClick() {
				return _this2._showVisTypesDialog();
			},
			createVis: function createVis(visModel) {
				return _this2.createVis(visModel);
			}
		});
	};

	VisPlaceholderView.prototype._showVisTypesDialog = function _showVisTypesDialog() {
		this.layoutOwner.parentLayout.showVisTypesDialog(this.model.id);
	};

	VisPlaceholderView.prototype.createVis = function createVis(widgetSpec) {
		this.layoutOwner.parentLayout.createVis(widgetSpec, this.model.id);
	};

	return VisPlaceholderView;
}(_LayoutBase2.ReactLayoutImplBase)) || _class;

var VisPlaceholder = function (_LayoutBase) {
	_inherits(VisPlaceholder, _LayoutBase);

	function VisPlaceholder(props) {
		_classCallCheck(this, VisPlaceholder);

		var _this3 = _possibleConstructorReturn(this, _LayoutBase.call(this, props));

		_this3.Component = VisPlaceholderView;
		_this3.parentLayout.addChildRenderMarkup(_this3.id, _this3.getRenderMarkup());
		return _this3;
	}

	VisPlaceholder.prototype.getRenderMarkup = function getRenderMarkup() {
		return _react2.default.createElement(VisPlaceholderView, { layoutOwner: this, model: this.model, layoutController: this.layoutController, services: this.services });
	};

	return VisPlaceholder;
}(_LayoutBase2.LayoutBase);

exports.default = VisPlaceholder;

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_255__;

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "drag-fields_128",
  "use": "drag-fields_128-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"drag-fields_128\"><defs><linearGradient id=\"drag-fields_128_a\" x1=\"100\" y1=\"157.11\" x2=\"100\" y2=\"-3.02\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#fff\" /><stop offset=\".01\" stop-color=\"#fff\" stop-opacity=\".99\" /><stop offset=\".23\" stop-color=\"#fff\" stop-opacity=\".7\" /><stop offset=\".43\" stop-color=\"#fff\" stop-opacity=\".45\" /><stop offset=\".62\" stop-color=\"#fff\" stop-opacity=\".25\" /><stop offset=\".78\" stop-color=\"#fff\" stop-opacity=\".12\" /><stop offset=\".91\" stop-color=\"#fff\" stop-opacity=\".03\" /><stop offset=\"1\" stop-color=\"#fff\" stop-opacity=\"0\" /></linearGradient></defs><circle class=\"ba-graphics-gray40\" cx=\"100\" cy=\"100\" r=\"100\" /><path class=\"ba-graphics-white\" d=\"M33.09 60.78h134v109.26h-134z\" /><path class=\"ba-graphics-gray80\" d=\"M6.83 172.06H2.07a2 2 0 110-4h4.76a2 2 0 110 4z\" /><path style=\"opacity:.75;fill:url(#drag-fields_128_a)\" d=\"M171.29 170.11a100 100 0 10-142.58 0z\" /><circle class=\"ba-graphics-white\" cx=\"101.64\" cy=\"21.45\" r=\"2\" /><path class=\"ba-graphics-white\" d=\"M78 39.17a4 4 0 004-4 1 1 0 012 0 4 4 0 004 4 1 1 0 010 2 4 4 0 00-4 4 1 1 0 01-2 0 4 4 0 00-4-4 1 1 0 010-2z\" /><path class=\"ba-graphics-gray80\" d=\"M167.12 172.08h-11a2 2 0 010-4h9v-3a2 2 0 014 0v5a2 2 0 01-2 2zm-21 0h-11a2 2 0 010-4h11a2 2 0 010 4zm-21 0h-11a2 2 0 010-4h11a2 2 0 110 4zm-21 0h-11a2 2 0 010-4h11a2 2 0 110 4zm-21 0h-11a2 2 0 010-4h11a2 2 0 010 4zm-21 0h-11a2 2 0 010-4h11a2 2 0 110 4zm-21 0h-8.28a2 2 0 01-2-2v-2.72a2 2 0 114 0v.72h6.28a2 2 0 110 4zm-8.28-12.72a2 2 0 01-2-2v-11a2 2 0 114 0v11a2 2 0 01-2 2zm134.28-2.25a2 2 0 01-2-2v-11a2 2 0 014 0v11a2 2 0 01-2 2zM32.84 138.36a2 2 0 01-2-2v-11a2 2 0 114 0v11a2 2 0 01-2 2zm134.28-2.25a2 2 0 01-2-2v-11a2 2 0 014 0v11a2 2 0 01-2 2zM32.84 117.36a2 2 0 01-2-2v-11a2 2 0 114 0v11a2 2 0 01-2 2zm134.28-2.25a2 2 0 01-2-2v-11a2 2 0 014 0v11a2 2 0 01-2 2zM32.84 96.36a2 2 0 01-2-2v-11a2 2 0 114 0v11a2 2 0 01-2 2zm134.28-2.25a2 2 0 01-2-2v-11a2 2 0 014 0v11a2 2 0 01-2 2zM32.84 75.36a2 2 0 01-2-2v-11a2 2 0 114 0v11a2 2 0 01-2 2zm134.28-2.25a2 2 0 01-2-2v-9.74a2.07 2.07 0 01-.26-1 2 2 0 012-2h.26a2 2 0 012 2v10.74a2 2 0 01-2 2zm-10.26-10.74h-11a2 2 0 010-4h11a2 2 0 010 4zm-21 0h-11a2 2 0 010-4h11a2 2 0 010 4zm-21 0h-11a2 2 0 010-4h11a2 2 0 010 4zm-21 0h-11a2 2 0 010-4h11a2 2 0 010 4zm-21 0h-11a2 2 0 010-4h11a2 2 0 010 4zm-21 0h-11a2 2 0 010-4h11a2 2 0 010 4z\" /><path class=\"ba-graphics-gray80\" d=\"M100 4a96 96 0 11-96 96 96.11 96.11 0 0196-96m0-4a100 100 0 10100 100A100 100 0 00100 0z\" /><path class=\"ba-graphics-gray80\" d=\"M198 172.06H14.92a2 2 0 110-4H198a2 2 0 010 4z\" /><rect class=\"ba-graphics-gray80\" x=\"131.95\" y=\"29.21\" width=\"53.69\" height=\"22.71\" rx=\"2\" transform=\"rotate(-19.12 158.791 40.574)\" /><path class=\"ba-graphics-gray80\" d=\"M189.82 17.64a2 2 0 01-.48-3.94l6.89-1.7a2 2 0 011 3.88l-6.89 1.72a2.05 2.05 0 01-.52.04zm-4.75-4.83a2 2 0 01-1.71-3l4.89-8.14a2 2 0 113.43 2.05l-4.89 8.15a2 2 0 01-1.72.94zm-6.49-1.92a2 2 0 01-1.94-1.51l-1.72-6.89a2 2 0 013.88-1l1.72 6.89a2 2 0 01-1.45 2.42 1.69 1.69 0 01-.49.09z\" /><rect class=\"ba-graphics-white\" x=\"134.42\" y=\"24.13\" width=\"53.69\" height=\"22.71\" rx=\"2\" transform=\"rotate(-19.12 161.265 35.495)\" /><path class=\"ba-graphics-gray80\" d=\"M180.44 21.06L185.26 35l-43.17 15-4.82-14 43.17-15m1.23-4.55a2.16 2.16 0 00-.65.11l-47 16.28a2 2 0 00-1.24 2.54L139 53.12a2 2 0 001.89 1.35 2.17 2.17 0 00.66-.11l47-16.28a2 2 0 001.23-2.54l-6.13-17.68a2 2 0 00-1.89-1.35z\" /><path class=\"ba-graphics-highlight\" d=\"M112.33 110.13h-9.11V101a3.08 3.08 0 00-6.16 0v9.11H88a3.08 3.08 0 000 6.15h9.11v9.11a3.08 3.08 0 006.16 0v-9.11h9.11a3.08 3.08 0 100-6.15z\" /><circle class=\"ba-graphics-white\" cx=\"52.27\" cy=\"33.67\" r=\"2\" /><ellipse class=\"ba-graphics-gray40\" cx=\"146.41\" cy=\"40.48\" rx=\"2.96\" ry=\"3.04\" transform=\"rotate(-45 146.401 40.489)\" /><path class=\"ba-graphics-gray40\" d=\"M155.07 39.52a2 2 0 01-.67-3.89l23.13-8.16a2 2 0 011.33 3.78l-23.13 8.15a1.92 1.92 0 01-.66.12z\" /><g style=\"opacity:.1\"><path class=\"ba-graphics-gray80\" d=\"M151.5 79.79h5.35a8.19 8.19 0 005.75-2.22c1.58-1.56 3.14-3 4.6-4.67a11.25 11.25 0 000-14.88l-10.38-10.57a1.65 1.65 0 00-1.71-.37c-1.41.4-1.75 1.85-.78 3.22a1.88 1.88 0 01-.14 2.63 1.82 1.82 0 01-2.62-.12c-.55-.51-1.06-1.06-1.6-1.58a2 2 0 00-2.77-.14 1.89 1.89 0 000 2.76c.48.54 1 1 1.51 1.54a1.89 1.89 0 01.19 2.8c-.82.83-1.86.76-2.86-.21-.76-.73-1.5-1.49-2.25-2.23a2 2 0 00-2.82-.2 1.85 1.85 0 00.11 2.8c1.38 1.43 2.8 2.85 4.2 4.27a1.8 1.8 0 01.57 1.81 1.86 1.86 0 01-3.16.85c-1.24-1.16-2.41-2.39-3.61-3.58a2 2 0 00-3-.24 1.94 1.94 0 00.21 2.88c1.4 1.43 2.84 2.82 4.25 4.23q2.46 2.43 4.83 4.79a1.73 1.73 0 01.45 1.91 1.86 1.86 0 01-3.23.56c-1.2-1.19-2.37-2.42-3.54-3.63-.26-.27-.25.13-.25.13v2.39c.14 2.71 2 5 4.5 5.09z\" /><path class=\"ba-graphics-gray80\" d=\"M155.7 47a1.52 1.52 0 011.12.46L167.2 58a11.25 11.25 0 010 14.88c-1.46 1.63-3 3.11-4.6 4.67a8.23 8.23 0 01-5.6 2.24h-13.69c-2.47-.1-4.36-2.38-4.5-5.09v-2.39s0-.23.1-.23.08 0 .15.1c1.17 1.21 2.34 2.44 3.54 3.63a2.22 2.22 0 001.55.7 1.79 1.79 0 001.68-1.26 1.73 1.73 0 00-.45-1.91Q143 71 140.62 68.57c-1.41-1.41-2.85-2.8-4.25-4.23a1.94 1.94 0 01-.21-2.88 1.76 1.76 0 011.26-.54 2.47 2.47 0 011.69.78c1.2 1.19 2.37 2.42 3.61 3.58a2 2 0 001.38.58 1.85 1.85 0 001.78-1.43 1.8 1.8 0 00-.57-1.81c-1.4-1.42-2.82-2.84-4.2-4.27a1.85 1.85 0 01-.11-2.8 1.79 1.79 0 011.25-.51 2.3 2.3 0 011.57.71c.75.74 1.49 1.5 2.25 2.23a2.39 2.39 0 001.61.78 1.74 1.74 0 001.25-.57 1.89 1.89 0 00-.19-2.8c-.49-.52-1-1-1.51-1.54a1.89 1.89 0 010-2.76 1.8 1.8 0 011.26-.5 2.19 2.19 0 011.51.64c.54.52 1.05 1.07 1.6 1.58a2.1 2.1 0 001.42.62 1.78 1.78 0 001.2-.5 1.88 1.88 0 00.14-2.63c-1-1.37-.63-2.82.78-3.22a2.06 2.06 0 01.59-.09m0-3.77a6 6 0 00-1.62.23 5.47 5.47 0 00-3.76 3.46 1.07 1.07 0 00-.07.19 5.69 5.69 0 00-1.79-.29 5.66 5.66 0 00-5.51 4.5 5.48 5.48 0 00-.7 0 5.57 5.57 0 00-3.85 1.55 5.51 5.51 0 00-1.76 3.9v.48a5.62 5.62 0 00-3.15 1.58 5.71 5.71 0 00.18 8.21c.82.83 1.65 1.66 2.49 2.48a4 4 0 00-1.19 2.85v2.56c.25 4.77 3.75 8.49 8.13 8.66H157a12 12 0 008.2-3.24l.93-.92c1.26-1.24 2.58-2.53 3.82-3.93a15 15 0 000-19.9l-.06-.07-.07-.07-10.31-10.64a5.21 5.21 0 00-3.81-1.59z\" /></g><path class=\"ba-graphics-white\" d=\"M153.62 75.91h5.07a7.81 7.81 0 005.46-2.1c1.49-1.48 3-2.88 4.35-4.43a10.66 10.66 0 000-14.11l-9.83-10a1.6 1.6 0 00-1.63-.35c-1.33.38-1.66 1.75-.73 3.05a1.78 1.78 0 01-.13 2.49 1.73 1.73 0 01-2.49-.11c-.52-.48-1-1-1.52-1.5a1.87 1.87 0 00-2.62-.13 1.8 1.8 0 000 2.62c.45.5 1 1 1.43 1.46a1.79 1.79 0 01.18 2.65c-.77.78-1.76.72-2.71-.2-.72-.69-1.42-1.41-2.13-2.11a1.86 1.86 0 00-2.68-.19 1.76 1.76 0 00.1 2.65c1.32 1.36 2.66 2.7 4 4a1.69 1.69 0 01.53 1.72 1.75 1.75 0 01-3 .8c-1.17-1.1-2.28-2.27-3.42-3.4a1.91 1.91 0 00-2.79-.22 1.84 1.84 0 00.2 2.73c1.32 1.35 2.69 2.67 4 4 1.51 1.5 3 3 4.5 4.54a1.62 1.62 0 01.43 1.81 1.76 1.76 0 01-3.06.53c-1.14-1.13-2.24-2.29-3.36-3.44-.24-.26-.23.12-.23.12v2.26c.13 2.57 1.93 4.74 4.27 4.82z\" /><path class=\"ba-graphics-gray80\" d=\"M157.61 44.83a1.43 1.43 0 011.06.43l9.83 10a10.66 10.66 0 010 14.11c-1.38 1.55-2.86 3-4.35 4.43a7.83 7.83 0 01-5.33 2.1h-12.95c-2.34-.08-4.14-2.25-4.27-4.82v-2.26s0-.21.09-.21a.21.21 0 01.14.09c1.12 1.15 2.22 2.31 3.36 3.44a2.08 2.08 0 001.47.66 1.69 1.69 0 001.59-1.19 1.62 1.62 0 00-.43-1.81c-1.49-1.52-3-3-4.5-4.54-1.33-1.34-2.7-2.66-4-4a1.84 1.84 0 01-.2-2.73 1.66 1.66 0 011.2-.51 2.33 2.33 0 011.59.73c1.14 1.13 2.25 2.3 3.42 3.4a1.93 1.93 0 001.31.55 1.74 1.74 0 001.68-1.35 1.69 1.69 0 00-.53-1.72c-1.33-1.35-2.67-2.69-4-4a1.77 1.77 0 011.08-3.14 2.17 2.17 0 011.5.68c.71.7 1.41 1.42 2.13 2.11a2.22 2.22 0 001.5.72 1.65 1.65 0 001.18-.54 1.79 1.79 0 00-.18-2.65c-.47-.5-1-.95-1.43-1.46a1.8 1.8 0 010-2.62 1.72 1.72 0 011.19-.48 2.09 2.09 0 011.43.61c.52.49 1 1 1.52 1.5a2 2 0 001.34.59 1.68 1.68 0 001.15-.48 1.78 1.78 0 00.13-2.49c-.93-1.3-.6-2.67.73-3.05a2.24 2.24 0 01.57-.08m0-4a6.33 6.33 0 00-1.66.23 5.63 5.63 0 00-3.77 3.35 5.8 5.8 0 00-1.44-.18 5.72 5.72 0 00-3.94 1.57 5.8 5.8 0 00-1.61 2.66h-.34a5.71 5.71 0 00-3.95 1.52 5.64 5.64 0 00-1.8 4v.12a5.72 5.72 0 00-2.85 1.55 5.81 5.81 0 00.16 8.37l2.08 2.08a4.2 4.2 0 00-.92 2.72v2.45c.25 4.74 3.74 8.44 8.12 8.6h13.1a11.78 11.78 0 008.06-3.18l.88-.86c1.2-1.18 2.45-2.41 3.65-3.75a14.62 14.62 0 000-19.42l-.07-.08-.07-.07-9.83-10a5.37 5.37 0 00-3.91-1.63z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_257__;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var emptyWidgetWithVisType = function emptyWidgetWithVisType(visTypeId) {
	return {
		model: {
			type: 'live',
			visId: visTypeId,
			visTypeLocked: true,
			data: {}
		}
	};
};

/**
 * @param {Object} dashboardApi
 * @param {String} widgetId - ID of the widget
 * @return {Object} - the internal widget model object or null when not found
 */
var getWidgetSpec = function getWidgetSpec(dashboardApi, widgetId) {
	var canvas = dashboardApi.getFeature('Canvas');
	if (canvas) {
		var widgetContent = canvas.getContent(widgetId);
		if (widgetContent) {
			return widgetContent.getFeature('Models.internal').getWidgetModel().toJSON();
		}
	}
	return null;
};

/**
 * @param {Object} card
 * @param {Object} dashboardApi
 * @return {object} a promise which is resolved with new spec for given card without id, titleHtml and thumbnailId props
 */
var getWidgetSpecForCompareCard = function getWidgetSpecForCompareCard(card, dashboardApi) {
	var widgetSpec = null;
	var widgetModel = null;
	if (card && card.items.length) {
		var widgetId = card.items[0].id;
		widgetModel = getWidgetSpec(dashboardApi, widgetId);
		if (widgetModel) {
			delete widgetModel.id;
			delete widgetModel.titleHtml;
			delete widgetModel.thumbnailId;
			widgetSpec = {
				model: widgetModel,
				specType: 'widget'
			};
			var extraWidgetOptions = {
				properties: [{
					id: 'itemAxis.labels.layoutMode',
					value: 'stagger'
				}, {
					id: 'widget.legend.position',
					value: 'right'
				}]
			};
			Object.assign(widgetSpec.model, extraWidgetOptions);
		}
	}
	return Promise.resolve(widgetSpec);
};

exports.default = {
	getWidgetSpec: getWidgetSpec,
	emptyWidgetWithVisType: emptyWidgetWithVisType,
	getWidgetSpecForCompareCard: getWidgetSpecForCompareCard
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.create-exploration {\n  position: relative;\n  margin: 0 1px;\n  color: #393939;\n  color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n  text-align: center;\n  -ms-flex: auto;\n      flex: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 100%;\n  /*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n  /*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n  /*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n}\n\n.create-exploration__container {\n  margin: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  overflow: hidden;\n}\n\n.create-exploration svg {\n  margin-bottom: 24px;\n}\n\n.create-exploration h3 {\n  font-size: 0.875rem;\n  font-weight: 700;\n  margin-top: 0;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n.create-exploration p {\n  max-width: 250px;\n  margin: auto;\n  padding: 0 64px;\n  font-size: 0.875rem;\n  line-height: 16px;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n.create-exploration button {\n  margin: 20px auto 0 auto;\n}\n\n.create-exploration .explore-empty-create-layout-dnd {\n  outline-style: solid;\n  outline-width: 1px;\n  outline-color: #161616;\n  outline-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #161616;\n  background-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n  opacity: 0.1;\n  z-index: 1000;\n}\n\n.create-exploration--droptarget {\n  border: 1px dashed;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.create-exploration--droptarget.dndHover {\n  border-color: #0f62fe;\n  border-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  border-style: solid;\n  outline-style: solid;\n  outline-width: 1px;\n  outline-color: #0f62fe;\n  outline-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.create-exploration.explorationWidget {\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.create-exploration.explorationWidget .widgetContent {\n  height: 100%;\n  width: 100%;\n}\n\n@media only screen and (max-height: 900px) {\n  .create-exploration-icon {\n    display: none;\n  }\n}\n\n", ""]);

// exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _LayoutBaseAuthoring = __webpack_require__(88);

var _LayoutBaseAuthoring2 = _interopRequireDefault(_LayoutBaseAuthoring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExploreContainerAuthoring = _LayoutBaseAuthoring2.default.extend({

	init: function init() {
		ExploreContainerAuthoring.inherited('init', this, arguments);
	},
	/**
  * Called when a new item is added to the layout model.
  * after the view is created, get the node and add it to the parent view.
  * Select the card iff the sender is undoRedoController and the operation is add
  * @param {Object} - layoutView the created layout module
  * @param {String} - insertBefore id
  * @param {Object} - payload is the event payload that contains the model to be added.
  */
	add: function add(layoutView, insertBefore, payload) {
		this.consumeView.addChildRenderMarkup(layoutView.id, layoutView.getRenderMarkup());

		var _ref = payload || {},
		    _ref$value = _ref.value;

		_ref$value = _ref$value === undefined ? {} : _ref$value;
		var operation = _ref$value.op,
		    sender = _ref.sender;

		if (operation === 'add' && sender === 'UndoRedoController') {
			this.consumeView.model.exploreVM.setDisplayedToCard(layoutView.id);
		}
	}
}); /*
     *+------------------------------------------------------------------------+
     *| Licensed Materials - Property of IBM
     *| IBM Cognos Products: Explore
     *| (C) Copyright IBM Corp. 2018, 2019
     *|
     *| US Government Users Restricted Rights - Use, duplication or disclosure
     *| restricted by GSA ADP Schedule Contract with IBM Corp.
     *+------------------------------------------------------------------------+
     */
exports.default = ExploreContainerAuthoring;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class, _desc, _value, _class2, _descriptor; /*
                                                  *+------------------------------------------------------------------------+
                                                  *| Licensed Materials - Property of IBM
                                                  *| IBM Cognos Products: Explore
                                                  *| (C) Copyright IBM Corp. 2018, 2020
                                                  *|
                                                  *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                  *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                  *+------------------------------------------------------------------------+
                                                  */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(11);

var mobx = _interopRequireWildcard(_mobx);

var _CSSHidingTransition = __webpack_require__(89);

var _CSSHidingTransition2 = _interopRequireDefault(_CSSHidingTransition);

var _Slideout = __webpack_require__(54);

var _Slideout2 = _interopRequireDefault(_Slideout);

var _SlideoutContent = __webpack_require__(55);

var _SlideoutContent2 = _interopRequireDefault(_SlideoutContent);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _visTypeChooser = __webpack_require__(91);

var _visTypeChooser2 = _interopRequireDefault(_visTypeChooser);

var _compareChooser = __webpack_require__(300);

var _compareChooser2 = _interopRequireDefault(_compareChooser);

var _RelatedInsights = __webpack_require__(309);

var _RelatedInsights2 = _interopRequireDefault(_RelatedInsights);

var _mobxReact = __webpack_require__(5);

var _LayoutBase2 = __webpack_require__(38);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _ExploreContainerDnDHandler = __webpack_require__(312);

var _ExploreContainerDnDHandler2 = _interopRequireDefault(_ExploreContainerDnDHandler);

var _SidePanelUtil = __webpack_require__(59);

var _EmptyExploreContainer = __webpack_require__(313);

var _EmptyExploreContainer2 = _interopRequireDefault(_EmptyExploreContainer);

var _RECOMMENDATION_PROPERTIES = __webpack_require__(40);

var _RECOMMENDATION_PROPERTIES2 = _interopRequireDefault(_RECOMMENDATION_PROPERTIES);

var _ExploreContainerToolbar = __webpack_require__(315);

var _ExploreContainerToolbar2 = _interopRequireDefault(_ExploreContainerToolbar);

var _ExploreContainerContent = __webpack_require__(346);

var _ExploreContainerContent2 = _interopRequireDefault(_ExploreContainerContent);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
	if (!descriptor) return;
	Object.defineProperty(target, property, {
		enumerable: descriptor.enumerable,
		configurable: descriptor.configurable,
		writable: descriptor.writable,
		value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	});
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

function _initializerWarningHelper(descriptor, context) {
	throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * Class representing view implementation (using react) for ExploreContainer layout view
 * @extends ReactLayoutImplBase
 */
var ExploreContainerView = (0, _mobxReact.observer)(_class = (_class2 = function (_ReactLayoutImplBase) {
	_inherits(ExploreContainerView, _ReactLayoutImplBase);

	function ExploreContainerView(props) {
		_classCallCheck(this, ExploreContainerView);

		var _this = _possibleConstructorReturn(this, _ReactLayoutImplBase.call(this, props));

		_initDefineProp(_this, 'activateDropTarget', _descriptor, _this);

		_this.onAddCard = function (event) {
			var layoutModel = _this.layoutController.topLayoutModel;

			var createCard = function createCard() {
				var id = layoutModel.addVisCard.apply(layoutModel, arguments);

				if (id) {
					var exploreVM = _this.props.model.exploreVM;
					_this.props.model.exploreVM.canvasTabs.showTab('slots');
					exploreVM.setDisplayedToNewCard(id);
					_this.domNode.focus();
				}
			};

			var action = {
				'single': function single() {
					return createCard([null], 'addBlankSingleCard');
				},
				'compare': function compare() {
					return createCard([null, null], 'addBlankCompareCard', { model: { subType: 'compare' } });
				},
				'startingPoints': function startingPoints() {
					var exploreVM = _this.props.model.exploreVM;
					exploreVM.setDisplayedToStartingPoints();
				}
			}[event.type];

			action();
		};

		_this._addCompareCard = function (item) {
			return _this.layoutController.topLayoutModel.addVisCard(item.widgets.map(function (_ref) {
				var spec = _ref.spec;

				if (spec) {
					return {
						model: spec
					};
				} else {
					return {
						model: {
							type: 'placeholder',
							placeHolder: true,
							showTitle: undefined,
							titleMode: 'smartTitle',
							name: ''
						}
					};
				}
			}), 'exploreSelectRelatedRecommendation', {
				model: { subType: 'compare' }
			});
		};

		_this.onCompareCardItemAdded = function (item) {
			var id = _this._addCompareCard(item);

			if (!id) {
				return;
			}

			(0, _SidePanelUtil.openCardsPane)(_this.props.dashboardApi);
		};

		_this.onCompareCardItemSelected = function (item) {

			var id = _this._addCompareCard(item);

			if (!id) {
				return;
			}

			var exploreVM = _this.props.model.exploreVM;
			_this.props.model.exploreVM.canvasTabs.showTab('slots');
			exploreVM.setDisplayedToNewCard(id);
			(0, _SidePanelUtil.openCardsPane)(_this.props.dashboardApi);
			_this._closeCompareSlideout();
		};

		_this.addVisCard = function (widgetSpecs, transactionIdPrefix) {
			var tabDisplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'details';

			if (!_underscore2.default.isArray(widgetSpecs)) {
				widgetSpecs = [widgetSpecs];
			}

			var selectAfterAdd = ['exploreSelectRelatedRecommendation', 'exploreSelectCometRecommendation', 'startingPointsSelectRecommendation', 'startingPointsCreate'].indexOf(transactionIdPrefix) !== -1;

			var options = {
				sender: transactionIdPrefix,
				selectAfterAdd: selectAfterAdd
			};
			_this.props.model.exploreVM.canvasTabs.showTab(tabDisplay);
			_this.props.model.addVisCard(widgetSpecs, transactionIdPrefix, options);
		};

		_this._closeVisTypeChooser = function () {
			_this.props.model.exploreVM.setShowModalVisTypePicker(false);
		};

		_this._closeRelatedVisPicker = function () {
			_this.props.model.exploreVM.setShowModalRelatedVisPicker(false);
		};

		_this._closeCompareSlideout = function () {
			_this.props.model.exploreVM.setShowCompareSlideout(false);
		};

		_this._onAddRelatedRecommendation = function (recommendation) {
			if (recommendation && recommendation.widgets && recommendation.widgets[0]) {
				_this._addCardByRecommendation(recommendation.widgets[0], 'addRelatedRecommendation');
				(0, _SidePanelUtil.openCardsPane)(_this.props.dashboardApi);
			}
		};

		_this._onRelatedRecommendationSelected = function (recommendation, index) {
			_this._closeRelatedVisPicker();
			var selectedRecommendation = _this.props.model.exploreVM.relatedRecommendationVM.getRecommendations()[index];
			if (selectedRecommendation && recommendation.widgets && recommendation.widgets[0]) {
				_this._addCardByRecommendation(recommendation.widgets[0], 'exploreSelectRelatedRecommendation');
				return (0, _SidePanelUtil.openCardsPane)(_this.props.dashboardApi);
			}
		};

		_this._onRecommendationSelected = function (recommendation) {
			_this._closeVisTypeChooser();
			_this._closeRelatedVisPicker();
			var isSetAuto = recommendation.isAutoModeSwitcher;
			var visTypeLocked = true;
			var widgetModel = _this.props.model.exploreVM.selectedWidgetModel;
			if (widgetModel) {
				visTypeLocked = !!widgetModel.get('visTypeLocked');
			}
			//Change vis type if user is now manually selecting a viz Or
			//the current viz was manually selected and auto-recommend mode is on
			var shouldChangeVisType = isSetAuto ? visTypeLocked : true;
			if (shouldChangeVisType) {
				_this.props.model.exploreVM.changeVisType(recommendation, isSetAuto);
			}
		};

		_this._onVisTypeSelected = function (visTypeId) {
			_this._closeVisTypeChooser();
			_this.props.model.exploreVM.changeFixedVisType(visTypeId);
		};

		_this._onVisTypeSelectedVisWidget = function (visTypeId) {
			_this._closeVisTypeChooser();
			var visDestination = _this.layoutOwner.model.items[0].visDestination;
			_this.createVisFromVisType(visTypeId, visDestination);
			_this.model.boardModel._hookupCustomDataHandler();
			var dashboardApi = _this.props.dashboardApi;
			(0, _SidePanelUtil.openDatasetPane)(dashboardApi);
		};

		_this.boardModel = _this._initBoardModel(props);
		_this.cardListRef = null;
		_this.listeners = [];

		_this.logger = props.services.biGlass.glassContext.getCoreSvc('.Logger');

		_this.startingPointsVM = props.model.startingPointsModel;
		_this._initDataSource();
		_this._initVisTypes();

		//Trigger resize when slots shown/hidden
		mobx.reaction(function () {
			return _this.props.model.exploreVM.showSlots;
		}, function () {
			_this.layoutOwner.resizeChildren(350); //Animation is 300ms - add 50ms for refresh time
		});
		return _this;
	}

	ExploreContainerView.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		var options = {
			domNode: this.domNode,
			className: 'dndHover',
			dashboardApi: this.props.dashboardApi,
			addFragment: this.model.addFragment.bind(this.model),
			fragmentParentId: this.layoutOwner.id,
			exploreVM: this.model.exploreVM,
			activate: function activate() {
				return _this2.activateDropTarget = true;
			},
			deactivate: function deactivate() {
				return _this2.activateDropTarget = false;
			},
			glassContext: this.props.services.biGlass.glassContext
		};
		this.props.services.getSvc('.DndManager').then(function (dndManager) {
			_this2._dropTargetHandle = dndManager && dndManager.addDropTarget(_this2.domNode, new _ExploreContainerDnDHandler2.default(options));
		});
		this.model.exploreVM.setExploreContainerNode(this.domNode);
	};

	ExploreContainerView.prototype.componentWillUnmount = function componentWillUnmount() {
		if (this._dropTargetHandle) {
			this._dropTargetHandle.remove();
		}
	};

	ExploreContainerView.prototype._handleDeleteKey = function _handleDeleteKey(event) {

		//This is needed to prevent the event from being reused. Without this, the handled property will always be true once it is set.
		event.persist();

		//If the event has been previously handled, we want to ignore the event
		if (event.handled || event.target.tagName && event.target.tagName.match(/input|textarea|select/igm)) {
			return;
		}

		var canDelete = false;
		//We will prevent delete action if we are on the StartingPoints card
		switch (event.key) {
			case 'Delete':
			case 'Backspace':
				canDelete = !this.model.exploreVM.isStartingPointsDisplayed();
				break;
		}

		if (canDelete) {
			var containsLiveWidget = this.model.exploreVM.selectedWidgets.find(function (widget) {
				return widget.getType() !== 'placeholder';
			});
			if (containsLiveWidget && this.model.exploreVM.isCompare()) {
				var visIds = this.model.exploreVM.selectedWidgets.map(function (widget) {
					return widget.getId();
				});
				this.model.deleteVis(visIds);
			} else {
				this.model.deleteCards([this.model.exploreVM.displayedCard]);
			}
			this.model.exploreVM.setFocusOnExploreContainer();
		}
	};

	// TODO: [livewidget_cleanup] refactoring
	// (a)should refactor to not access boardModel / (b) should be sync


	ExploreContainerView.prototype._initBoardModel = function _initBoardModel(props) {
		return Promise.resolve(props.layoutController.boardModel);
	};

	ExploreContainerView.prototype._initDataSource = function _initDataSource() {
		var _this3 = this;

		this.boardModel.then(function (boardModel) {
			var sourceList = _this3._getSourceModels(boardModel);
			sourceList && sourceList.forEach(function (sourceModel) {
				var shapingModel = sourceModel.get('shaping');
				shapingModel.on('shapingmodel:changed', _this3._onShapingChanges, _this3);
			});
			if (_this3.props.dashboardApi && !_this3.props.dashboardApi.getActiveDataSourceId()) {
				// We are in constructor of ExploreView and do not know yet if there are cards to display or not.
				// If the dashboard spec has multiple data sources, by default take the first one.
				var useFirstDataSourceAsActive = true;
				_this3._updateDataSources(boardModel, useFirstDataSourceAsActive);
			}
			// This event is fired when data source changes
			boardModel.on('change:dataSources', _this3._onDataSourcesChanges.bind(_this3, boardModel), _this3);
		});
	};

	ExploreContainerView.prototype._onDataSourcesChanges = function _onDataSourcesChanges(boardModel, event) {
		if (event.name) {
			if (event.name === 'add') {
				if (event.value) {
					// --Add a datasource case
					//First register shaping event
					var shapingModel = event.value.get && event.value.get('shaping');
					shapingModel && shapingModel.on('shapingmodel:changed', this._onShapingChanges, this);

					// The new source is added at the end of of the source list,
					// so the active data source in this case is the last data source
					this._updateDataSources(boardModel);
				}
			} else if (event.name === 'remove') {
				if (event.value) {
					// --Remove a datasource case
					// If the removed datasource is not current active datasource, do nothing
					// If the removed datasource is current active datasource, update active datasource
					if (event.value.id === this.props.model.exploreVM.activeDataSourceId) {
						this._updateDataSources(boardModel);
					}
				}
			} else if (event.name === 'state' && event.value === 'ready') {
				if (event.sender) {
					// --reload a dataset case
					// If the reloaded datasource is not current active datasource, do nothing
					// If the reloaded datasource is current active datasource, fetch fields again
					if (event.sender.id === this.props.model.exploreVM.activeDataSourceId) {
						this.startingPointsVM.refreshStartingPoints();
					}
				}
			}
		}
	};

	ExploreContainerView.prototype._onShapingChanges = function _onShapingChanges(event) {
		//If fields has not been fetched, we do nothing with the calculation changes
		if (!this.startingPointsVM.fields.hasFetchedFields()) return;

		if (event.action) {
			switch (event.action) {
				case 'ADD':
					this._addColumn(event.notification);
					this._clearDataSmartsServiceCache();
					break;
				case 'SET':
					this._changeProperties(event.notification);
					this._clearDataSmartsServiceCache();
					break;
				case 'REMOVE':
					this._removeColumn(event.notification);
					this._clearDataSmartsServiceCache();
					break;
				default:
					break;
			}
		}
	};

	ExploreContainerView.prototype._clearDataSmartsServiceCache = function _clearDataSmartsServiceCache() {
		var module = this.props.model.exploreVM.activeDataSourceModule;
		var sourceModuleId = module ? module.value.getAssetId() : null;
		if (sourceModuleId) {
			this.props.model.exploreVM.getSmartsRecommenderWrapper().smartsRelationshipStrengthService.removeEntriesFromCache(sourceModuleId);
		}
	};

	ExploreContainerView.prototype._jsonParseString = function _jsonParseString(value) {
		// Refer to `_createDebouncedShapingNotification` in shapingModelManager.js in Dashboard-livewidget
		// The value might be a JSON string or just a string - we have no way of knowing.
		if (typeof value === 'string') {
			try {
				return JSON.parse(value.trim());
			} catch (e) {
				return value;
			}
		}

		return value;
	};

	ExploreContainerView.prototype._addColumn = function _addColumn(notification) {
		var _ref2 = notification || {},
		    _ref2$newValue = _ref2.newValue,
		    newValue = _ref2$newValue === undefined ? {} : _ref2$newValue;

		var newItem = this._jsonParseString(newValue);
		if (newItem.queryItem) {
			newItem = newItem.queryItem;
		}

		var id = newItem.idForExpression;
		var name = newItem.label;
		if (id && name) {
			this.startingPointsVM.fields.addToAllFields({
				id: id,
				name: name
			});
		}
	};

	ExploreContainerView.prototype._changeProperties = function _changeProperties(notification) {
		if (notification && notification.notifier) {
			this.startingPointsVM.refreshStartingPoints();
		}
	};

	ExploreContainerView.prototype._removeColumn = function _removeColumn(notification) {
		var _ref3 = notification || {},
		    _ref3$oldValue = _ref3.oldValue,
		    oldValue = _ref3$oldValue === undefined ? {} : _ref3$oldValue;

		var removedItem = this._jsonParseString(oldValue);
		if (removedItem.queryItem) {
			removedItem = removedItem.queryItem;
		}
		var id = removedItem.idForExpression;
		if (id) {
			this.startingPointsVM.fields.deleteField(id);
		}
	};

	/**
  * @TODO livewisget_cleanup - not to access boardModel though service to thet the id - should use feature instead
  */


	ExploreContainerView.prototype._getSourceModels = function _getSourceModels(boardModel) {
		var dataSources = boardModel.get('dataSources');
		var sources = dataSources && dataSources.get('sources');
		return sources && sources.getModels();
	};

	ExploreContainerView.prototype._updateDataSources = function _updateDataSources(boardModel) {
		var useFirstDataSourceAsActive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		//MRB: boardModel is not yet MobX, so need to track changes to data sources manually
		var activeDataSourceId = this._getActiveDataSourceId(this._getSourceModels(boardModel), useFirstDataSourceAsActive);

		//Assume on a new data source being added that it's the one the user wishes to see
		this.props.model.exploreVM.setActiveDataSourceId(activeDataSourceId);

		if (activeDataSourceId) {
			this.props.dashboardApi.setActiveDataSourceId(activeDataSourceId);
		}
	};

	ExploreContainerView.prototype._getActiveDataSourceId = function _getActiveDataSourceId(sourceList, useFirstDataSourceAsActive) {
		if (sourceList && sourceList.length) {
			return useFirstDataSourceAsActive ? sourceList[0].id : sourceList[sourceList.length - 1].id;
		}
		return '';
	};

	ExploreContainerView.prototype.render = function render() {
		return this.getRenderMarkup();
	};

	ExploreContainerView.prototype.getRenderMarkup = function getRenderMarkup() {
		var _this4 = this;

		var showVisTypePicker = this.props.model.exploreVM.showModalVisTypePicker;
		var toolBarVisPicker = this.props.model.exploreVM.toolbarVisPicker;
		var showRelatedVisPicker = this.props.model.exploreVM.showModalRelatedVisPicker;
		var showCompareSlideout = this.props.model.exploreVM.showCompareSlideout;

		var visTypeChooserMarkup = void 0;
		if (toolBarVisPicker) {
			var hasDataInActiveWidgets = this.props.model.exploreVM.hasDataInActiveWidgets();
			var selectedWidgetModel = this.props.model.exploreVM.selectedWidgetModel;

			var isVisTypeLocked = true;
			var selectedVisId = null;

			if (selectedWidgetModel) {
				isVisTypeLocked = selectedWidgetModel.get('visTypeLocked');
				selectedVisId = selectedWidgetModel.get('visId');
			}

			var recommendationVM = null;
			if (hasDataInActiveWidgets) {
				recommendationVM = this.props.model.exploreVM.alternativeRecommendationVM;
			}

			visTypeChooserMarkup = _react2.default.createElement(_visTypeChooser2.default, {
				active: showVisTypePicker,
				className: 'explore__animation--slideDown',
				dashboardApi: this.props.dashboardApi,
				recommendationVM: recommendationVM,
				isVizTypeLocked: isVisTypeLocked,
				selectedVisId: selectedVisId,
				services: this.props.services,
				onVisTypeSelected: this._onVisTypeSelected,
				onRecommendationSelected: this._onRecommendationSelected,
				onClose: this._closeVisTypeChooser,
				additionalProperties: _RECOMMENDATION_PROPERTIES2.default
			});
		} else {
			visTypeChooserMarkup = _react2.default.createElement(_visTypeChooser2.default, {
				dashboardApi: this.props.dashboardApi,
				active: showVisTypePicker,
				className: 'explore__animation--slideDown',
				services: this.props.services,
				onVisTypeSelected: this._onVisTypeSelectedVisWidget
				//TODO _alive - VisTypeChooser refers to layoutOwner where object might not be available, introduce this flag to indicate if the view is destroyed or not. perhaps we can use a more proper way to address this
				, onClose: this._closeVisTypeChooser
			});
		}

		return _react2.default.createElement(
			'div',
			{ tabIndex: '-1', className: 'ba-theme-waca explore', ref: function ref(node) {
					_this4.domNode = node;
				}, onKeyDown: function onKeyDown(event) {
					return _this4._handleDeleteKey(event);
				} },
			this.activateDropTarget ? _react2.default.createElement(_EmptyExploreContainer2.default, null) : undefined,
			_react2.default.createElement(_ExploreContainerToolbar2.default, {
				exploreVM: this.props.model.exploreVM,
				boardModel: this.props.model.boardModel,
				dashboardApi: this.props.dashboardApi,
				onAddCard: this.onAddCard
			}),
			_react2.default.createElement(
				'div',
				{ className: 'explore-content' },
				_react2.default.createElement(
					_CSSHidingTransition2.default,
					{
						'in': !showVisTypePicker,
						classNames: 'explore__animation--fade',
						onEnter: function onEnter() {},
						onExited: function onExited() {} },
					_react2.default.createElement(_ExploreContainerContent2.default, {
						model: this.props.model,
						startingPointsVM: this.startingPointsVM,
						services: this.props.services,
						layoutOwner: this.layoutOwner,
						addVisCard: this.addVisCard,
						dashboardApi: this.props.dashboardApi
					})
				),
				visTypeChooserMarkup,
				_react2.default.createElement(
					_Slideout2.default,
					{
						active: showRelatedVisPicker,
						className: 'explore__animation--slideDown',
						onClickOutside: this._closeRelatedVisPicker
					},
					_react2.default.createElement(
						_SlideoutContent2.default,
						{
							title: _StringResources2.default.get('related_visualizations'),
							contentClassName: 'related-slideout'
						},
						_react2.default.createElement(
							'div',
							{ className: 'vis-recommender-explore__content' },
							_react2.default.createElement(_RelatedInsights2.default, {
								dashboardApi: this.props.dashboardApi,
								recommendationVM: this.props.model.exploreVM.relatedRecommendationVM,
								onClickItem: this._onRelatedRecommendationSelected,
								onAddItem: this._onAddRelatedRecommendation,
								additionalProperties: _RECOMMENDATION_PROPERTIES2.default,
								onPromptingError: this._onPromptingError,
								logger: this.logger
							})
						)
					)
				),
				_react2.default.createElement(_compareChooser2.default, {
					dashboardApi: this.props.dashboardApi,
					customRecommendationVM: this.props.model.exploreVM.compareCardCustomRecommendationVM,
					smartsRecommendationVM: this.props.model.exploreVM.compareCardSmartsRecommendationVM,
					selectedWidgetModel: this.props.model.exploreVM.selectedWidgetModel,
					active: showCompareSlideout,
					onItemSelected: this.onCompareCardItemSelected,
					onItemAdded: this.onCompareCardItemAdded,
					onClose: this._closeCompareSlideout,
					logger: this.logger
				})
			)
		);
	};

	/**
  * Add compare card
  *
  * @param {object} item - compare card item
  * @param {array} item.widgets - widgets in the compare card
  *
  * @return {string} newly added compare card id
  */


	ExploreContainerView.prototype._initVisTypes = function _initVisTypes() {
		// TODO: we shouldn't be setting types on the model(from the view), need to improve
		var visDefinitions = this.props.dashboardApi.getFeature('VisDefinitions');
		this.props.model.exploreVM.setVisTypes(visDefinitions.getList());
	};

	/**
  * Add one or more visualizations to the exploration, in their own new tab
  * @param {object|object[]} widgetSpecs - specs for the new visualization(s)
  * @param {string} transactionIdPrefix - description of this operation
  * @param {string} tabDisplay - specifies tab to display (slots/details)
  */


	ExploreContainerView.prototype._onPromptingError = function _onPromptingError(recommendation) {
		recommendation.isStaticWidget = true;
	};

	ExploreContainerView.prototype._addCardByRecommendation = function _addCardByRecommendation(recommendation, transactionIdPrefix) {
		var widgetSpecs = {
			model: Object.assign({
				type: 'live',
				visTypeLocked: true
			}, recommendation.spec),
			layoutProperties: {
				isStaticWidget: recommendation.isStaticWidget
			}
		};
		return this.addVisCard(widgetSpecs, transactionIdPrefix);
	};
	// we only support recommendation visulization for the first selected widget vis for now


	//handle only the first vis for now


	ExploreContainerView.prototype.createVisFromVisType = function createVisFromVisType(visTypeId) {
		var widgetSpec = {
			model: {
				type: 'live',
				visId: visTypeId,
				visTypeLocked: true
			}
		};
		this.props.model.exploreVM.widgetInstance.createVis(widgetSpec);
		this.props.model.exploreVM.setToolBarVisTypePicker(true, null);
	};

	return ExploreContainerView;
}(_LayoutBase2.ReactLayoutImplBase), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'activateDropTarget', [_mobx.observable], {
	enumerable: true,
	initializer: function initializer() {
		return false;
	}
})), _class2)) || _class;

var ExploreContainer = function (_LayoutBase) {
	_inherits(ExploreContainer, _LayoutBase);

	function ExploreContainer(props) {
		_classCallCheck(this, ExploreContainer);

		var _this5 = _possibleConstructorReturn(this, _LayoutBase.call(this, props));

		_this5.Component = ExploreContainerView;
		return _this5;
	}

	return ExploreContainer;
}(_LayoutBase2.LayoutBase);

exports.default = ExploreContainer;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(263);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(264));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 263 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(9));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(17));

var _reactLifecyclesCompat = __webpack_require__(267);

var _PropTypes = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(269);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./slideout.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./slideout.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore__slideout {\n  background: white;\n  box-shadow: 0 5px 25px -10px #00000036;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  display: inherit;\n  z-index: 100;\n}\n\n.explore__slideout--fullHeight {\n  bottom: 0;\n}\n\n", ""]);

// exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(271);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./slideoutContent.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./slideoutContent.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2019\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore-slideout-content {\n  -ms-flex-direction: column;\n      flex-direction: column;\n  background: #f4f4f4;\n  background: hsla(var(--ui-background-h, 0), var(--ui-background-s, 0%), var(--ui-background-l, 95.68627%), 1);\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n\n.explore-slideout-content__header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 24px 64px;\n  background: white;\n  background: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  border-bottom: 1px solid;\n  border-bottom-color: #e0e0e0;\n  border-bottom-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.explore-slideout-content__header__section {\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.explore-slideout-content__header__section__title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #393939;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 22.35294%), 1);\n}\n\n.explore-slideout-content__header__section__subTitle {\n  margin-top: 4px;\n}\n\n.explore-slideout-content__header__close-button button {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n}\n\n.explore-slideout-content__header__close-button button:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.explore-slideout-content__header__close-button button:hover,\n.explore-slideout-content__header__close-button button:focus {\n  opacity: 1;\n}\n\n.explore-slideout-content__content {\n  border-top: 2px solid #eaeaea;\n  padding: 0 48px;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n\n.explore-slideout-content__related-slideout {\n  min-height: 30vh;\n  max-height: 70vh;\n}\n\n.explore__slideout--fullHeight .explore-slideout-content__content {\n  -ms-flex: 1;\n      flex: 1;\n}\n\n", ""]);

// exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Recommended = __webpack_require__(273);

var _Recommended2 = _interopRequireDefault(_Recommended);

var _VisTypeContainer = __webpack_require__(292);

var _VisTypeContainer2 = _interopRequireDefault(_VisTypeContainer);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _ExtVisUtil = __webpack_require__(45);

__webpack_require__(298);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var VisTypeChooser = function (_Component) {
	_inherits(VisTypeChooser, _Component);

	function VisTypeChooser(props) {
		_classCallCheck(this, VisTypeChooser);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.visTypeExcludeChartIds = ['dataPlayer'];
		_this.visTypeClassName = 'create-exploration__vis-type-picker-container';
		_this.logger = props.services.biGlass.glassContext.getCoreSvc('.Logger');
		_this.visDefinitions = _this.props.dashboardApi.getFeature('VisDefinitions').getList();
		return _this;
	}

	VisTypeChooser.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			{ className: 'vis-recommender-explore__vis-recommender-picker' },
			this.props.recommendationVM && this._renderRecommended(),
			_react2.default.createElement(
				'div',
				{ className: 'vis-recommender-explore__vis-type-picker' },
				this._renderVisTypePicker()
			)
		);
	};

	/**
  * Render the vis type picker panel.
  */


	VisTypeChooser.prototype._renderVisTypePicker = function _renderVisTypePicker() {
		var _this2 = this;

		return _react2.default.createElement(_VisTypeContainer2.default, {
			onVisTypeSelected: function onVisTypeSelected(visTypeId) {
				return _this2.props.onVisTypeSelected(visTypeId);
			},
			services: this.props.services,
			filter: this.visTypeExcludeChartIds,
			visTypeClassName: this.visTypeClassName,
			selectedVisId: this.props.selectedVisId,
			isVizTypeLocked: this.props.isVizTypeLocked,
			isExtVis: _ExtVisUtil.isExtVis,
			visDefinitions: this.visDefinitions,
			iconsFeature: this.props.dashboardApi.getFeature('Icons')
		});
	};

	VisTypeChooser.prototype._renderRecommended = function _renderRecommended() {
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				'div',
				{ className: 'vis-recommender-explore__title' },
				_StringResources2.default.get('recommended_visualizations')
			),
			_react2.default.createElement(
				'div',
				{ className: 'vis-recommender-explore__content' },
				_react2.default.createElement(_Recommended2.default, {
					isVizTypeLocked: this.props.isVizTypeLocked,
					dashboardApi: this.props.dashboardApi,
					recommendationVM: this.props.recommendationVM,
					onClickItem: this.props.onRecommendationSelected,
					additionalProperties: this.props.additionalProperties,
					selectedVisId: this.props.selectedVisId,
					logger: this.logger
				})
			)
		);
	};

	return VisTypeChooser;
}(_react.Component);

VisTypeChooser.propTypes = {
	services: _PropTypes2.default.object.isRequired,
	dashboardApi: _PropTypes2.default.object.isRequired,
	recommendationVM: _PropTypes2.default.object,
	isVizTypeLocked: _PropTypes2.default.bool,
	selectedVisId: _PropTypes2.default.string,
	onRecommendationSelected: _PropTypes2.default.func,
	onVisTypeSelected: _PropTypes2.default.func,
	additionalProperties: _PropTypes2.default.arrayOf(_PropTypes2.default.object),
	recommendFilters: _PropTypes2.default.array
};
VisTypeChooser.defaultProps = {
	onRecommendationSelected: function onRecommendationSelected() {},
	onVisTypeSelected: function onVisTypeSelected() {},
	additionalProperties: []
};
exports.default = VisTypeChooser;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(27);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _RecommendedCommon = __webpack_require__(92);

var _RecommendedCommon2 = _interopRequireDefault(_RecommendedCommon);

__webpack_require__(290);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var Recommendation = function (_Component) {
	_inherits(Recommendation, _Component);

	function Recommendation(props) {
		_classCallCheck(this, Recommendation);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	Recommendation.prototype.render = function render() {
		return _react2.default.createElement(_RecommendedCommon2.default, _extends({}, this.props, {
			className: 'vis-recommended',
			title: _StringResources2.default.get('recommended_visualizations'),
			enableSeeMore: false,
			isVizTypeLocked: this.props.isVizTypeLocked,
			recommendationFilter: this.props.recommendationFilter,
			selectedVisId: this.props.selectedVisId,
			logger: this.props.logger
		}));
	};

	return Recommendation;
}(_react.Component);

Recommendation.propTypes = {
	dashboardApi: _propTypes2.default.object.isRequired,
	onClickItem: _propTypes2.default.func,
	isVizTypeLocked: _propTypes2.default.bool,
	recommendationFilter: _propTypes2.default.string,
	selectedVisId: _propTypes2.default.string,
	recommendationVM: _propTypes2.default.object.isRequired,
	additionalProperties: _propTypes2.default.arrayOf(_propTypes2.default.object),
	logger: _propTypes2.default.object
};
Recommendation.defaultProps = {
	onClickItem: function onClickItem() {},
	additionalProperties: []
};

exports.default = Recommendation;

/***/ }),
/* 274 */
/***/ (function(module, exports) {

var amdi18n={"__root":{"add":"Add card","add_label":"Add","viewAdd":"Add and view card","added_to_cards":"Added to cards","remove":"Remove","autoVis":"Automatic","see_more":"See more","see_more_aria_label":"See more ... Display more related visualizations link.","widget_recommender_fail":"No recommendations found","change_vis":"Change visualization"},"__cs":{"add":"Přidat kartu","add_label":"Přidat","viewAdd":"Přidat a zobrazit kartu","added_to_cards":"Přidáno ke kartám","remove":"Odebrat","autoVis":"Automatické","see_more":"Zobrazit více","see_more_aria_label":"Zobrazit více... Zobrazit odkaz na další související vizualizace.","widget_recommender_fail":"Nebyla nalezena žádná doporučení","change_vis":"Změnit vizualizace"},"__da":{"add":"Tilføj kort","add_label":"Tilføj","viewAdd":"Tilføj og vis kort","added_to_cards":"Tilføjet til kort","remove":"Fjern","autoVis":"Automatisk","see_more":"Vis mere","see_more_aria_label":"Vis mere... Vis flere relaterede visualiseringslink.","widget_recommender_fail":"Ingen anbefalinger","change_vis":"Skift visualisering"},"__de":{"add":"Karte hinzufügen","add_label":"Hinzufügen","viewAdd":"Karte hinzufügen und anzeigen","added_to_cards":"Zu Karten hinzugefügt","remove":"Entfernen","autoVis":"Automatisch","see_more":"Weitere Informationen anzeigen","see_more_aria_label":"Weitere Informationen anzeigen... Link zum Anzeigen weiterer zugehöriger Visualisierungen.","widget_recommender_fail":"Keine Empfehlungen gefunden","change_vis":"Visualisierung ändern"},"__es":{"add":"Añadir carta","add_label":"Añadir","viewAdd":"Añadir y ver tarjeta ","added_to_cards":"Añadido a tarjetas","remove":"Eliminar","autoVis":"Automático","see_more":"Más información","see_more_aria_label":"Ver más ... Enlace Visualizar más visualizaciones relacionadas.","widget_recommender_fail":"No se han encontrado recomendaciones","change_vis":"Cambiar visualización"},"__fi":{"add":"Lisää kortti","add_label":"Lisää","viewAdd":"Lisää ja näytä kortti","added_to_cards":"Lisätty kortteihin","remove":"Poista","autoVis":"Automaattinen","see_more":"Näytä enemmän","see_more_aria_label":"Näytä enemmän... Näytä lisää liittyvien visualisointien linkkejä.","widget_recommender_fail":"Suosituksia ei löytynyt","change_vis":"Vaihda visualisointi"},"__fr":{"add":"Ajouter une carte","add_label":"Ajouter","viewAdd":"Ajouter et afficher une carte","added_to_cards":"Ajouté à des cartes","remove":"Retirer","autoVis":"Automatique","see_more":"Voir plus","see_more_aria_label":"Voir plus ... Affichez un lien présentant d'autres visualisations connexes.","widget_recommender_fail":"Aucune recommandation trouvée","change_vis":"Changer de visualisation"},"__hr":{"add":"Dodaj karticu","add_label":"Dodaj","viewAdd":"Dodaj i pogledaj karticu","added_to_cards":"Dodano u kartice","remove":"Ukloni","autoVis":"Automatski","see_more":"Pogledaj više","see_more_aria_label":"Pogledaj više ... Prikaži bolju poveznicu vizualizacije.","widget_recommender_fail":"Preporuke nisu nađene","change_vis":"Promijeni vizualizaciju"},"__hu":{"add":"Kártya hozzáadása","add_label":"Hozzáadás","viewAdd":"Kártya hozzáadása és megjelenítése","added_to_cards":"Hozzáadva a kartonokhoz","remove":"Eltávolítás","autoVis":"Automatikus","see_more":"Továbbiak megtekintése","see_more_aria_label":"Több megjelenítése... További kapcsolódó megjelenítési hivatkozások mutatása.","widget_recommender_fail":"Nincs ajánlás","change_vis":"Megjelenítés módosítása"},"__it":{"add":"Aggiungi scheda","add_label":"Aggiungi","viewAdd":"Aggiungi e visualizza scheda","added_to_cards":"Aggiunto alle schede","remove":"Rimuovi","autoVis":"Automatico","see_more":"Visualizza altro","see_more_aria_label":"Vedi di più ... Visualizza il collegamento delle visualizzazioni più correlate.","widget_recommender_fail":"Nessun consiglio trovato","change_vis":"Cambia visualizzazione"},"__ja":{"add":"カードの追加","add_label":"追加","viewAdd":"カードの追加と表示","added_to_cards":"カードに追加されました","remove":"削除","autoVis":"自動","see_more":"さらに表示","see_more_aria_label":"さらに表示 ... 関連する視覚化リンクをさらに表示します。","widget_recommender_fail":"推奨情報が見つかりません","change_vis":"視覚化の変更"},"__kk":{"add":"Карта қосу","add_label":"Қосу","viewAdd":"Картаны қосыңыз және қараңыз","added_to_cards":"Карталарға қосылды","remove":"Жою","autoVis":"Автоматты","see_more":"Толығырақ көру","see_more_aria_label":"Толығырақ көру ... Тиісті көрнекілендіру сілтемесін көрсету.","widget_recommender_fail":"Ұсыныстар табылмады","change_vis":"Көрнекі бейнелерді өзгертіңіз"},"__ko":{"add":"카드 추가","add_label":"추가","viewAdd":"카드 추가 및 보기","added_to_cards":"카드에 추가됨","remove":"제거","autoVis":"자동","see_more":"자세히 보기","see_more_aria_label":"자세히 보기 ... 관련성이 높은 시각화 링크를 표시합니다.","widget_recommender_fail":"권장사항이 없음","change_vis":"시각화 변경"},"__nb":{"add":"Legg til kort","add_label":"Legg til","viewAdd":"Legg til og vis kort","added_to_cards":"Lagt til i kort","remove":"Fjern","autoVis":"Automatisk","see_more":"Se mer","see_more_aria_label":"Se mer ... Vis flere beslektede visualiseringslinker.","widget_recommender_fail":"Fant ingen anbefalinger","change_vis":"Endre visualisering"},"__nl":{"add":"Kaart toevoegen","add_label":"Optellen","viewAdd":"Kaart toevoegen en bekijken","added_to_cards":"Toegevoegd aan kaarten","remove":"Verwijderen","autoVis":"Automatisch","see_more":"Meer afbeelden","see_more_aria_label":"Meer afbeelden ... Link met meer gerelateerde visualisaties tonen.","widget_recommender_fail":"Geen aanbevelingen gevonden","change_vis":"Visualisatie wijzigen"},"__no":{"add":"Legg til kort","add_label":"Legg til","viewAdd":"Legg til og vis kort","added_to_cards":"Lagt til i kort","remove":"Fjern","autoVis":"Automatisk","see_more":"Se mer","see_more_aria_label":"Se mer ... Vis flere beslektede visualiseringslinker.","widget_recommender_fail":"Fant ingen anbefalinger","change_vis":"Endre visualisering"},"__pl":{"add":"Dodaj kartę","add_label":"Dodaj","viewAdd":"Dodaj i wyświetl kartę","added_to_cards":"Dodano do kart","remove":"Usuń","autoVis":"Automatycznie","see_more":"Pokaż więcej","see_more_aria_label":"Pokaż więcej... Wyświetl więcej odsyłaczy do powiązanych wizualizacji.","widget_recommender_fail":"Nie znaleziono zaleceń","change_vis":"Zmień wizualizację"},"__pt":{"add":"Incluir Placa","add_label":"Incluir","viewAdd":"Incluir e visualizar cartão","added_to_cards":"Incluído em cartões","remove":"Remover","autoVis":"Automática","see_more":"Veja mais","see_more_aria_label":"Veja mais ... Exiba o link de visualizações mais relacionadas.","widget_recommender_fail":"Nenhuma recomendação localizada","change_vis":"Alterar visualização"},"__pt-br":{"add":"Incluir Placa","add_label":"Incluir","viewAdd":"Incluir e visualizar cartão","added_to_cards":"Incluído em cartões","remove":"Remover","autoVis":"Automática","see_more":"Veja mais","see_more_aria_label":"Veja mais ... Exiba o link de visualizações mais relacionadas.","widget_recommender_fail":"Nenhuma recomendação localizada","change_vis":"Alterar visualização"},"__ro":{"add":"Adăugare card","add_label":"Adăugare","viewAdd":"Adăugare şi vizualizare card","added_to_cards":"Adăugat la carduri","remove":"Înlăturare","autoVis":"Automat","see_more":"Vedeţi mai mult","see_more_aria_label":"Vedeţi mai mult ... Legătură pentru afişarea altor vizualizări înrudite.","widget_recommender_fail":"Nu au fost găsite recomandări.","change_vis":"Modificare vizualizare"},"__ru":{"add":"Добавить карточку","add_label":"Добавить","viewAdd":"Добавить и просмотреть карту","added_to_cards":"Добавлено в карты","remove":"Удалить","autoVis":"Автоматически","see_more":"Узнать больше","see_more_aria_label":"Увидеть больше ... Показать больше связанных визуализаций.","widget_recommender_fail":"Рекомендации не найдены","change_vis":"Изменить визуализацию"},"__sl":{"add":"Dodaj kartico","add_label":"Dodaj","viewAdd":"Dodaj in prikaži kartico","added_to_cards":"Dodano v kartice","remove":"Odstrani","autoVis":"Samodejno","see_more":"Prikaži več","see_more_aria_label":"Prikaži več ... povezava za prikaz več povezanih vizualizacij.","widget_recommender_fail":"Najdeno ni bilo nobeno priporočilo","change_vis":"Spremeni vizualizacijo"},"__sv":{"add":"Lägg till kort","add_label":"Lägg till","viewAdd":"Lägg till och visa kort","added_to_cards":"Tillagt till kort","remove":"Ta bort","autoVis":"Automatisk","see_more":"Visa mer","see_more_aria_label":"Läs mer... Fler relaterade visualiseringar.","widget_recommender_fail":"Inga rekommendationer hittades","change_vis":"Ändra visualisering"},"__th":{"add":"เพิ่มการ์ด","add_label":"เพิ่ม","viewAdd":"เพิ่มและดูการ์ด","added_to_cards":"เพิ่มในการ์ด","remove":"ลบออก","autoVis":"อัตโนมัติ","see_more":"ดูเพิ่มเติม","see_more_aria_label":"ดูเพิ่มเติม ... แสดงลิงก์วิชวลไลเซชันที่เกี่ยวข้องเพิ่มเติม","widget_recommender_fail":"ไม่พบคำแนะนำ","change_vis":"เปลี่ยนวิชวลไลเซชัน"},"__tr":{"add":"Kart ekle","add_label":"Ekle","viewAdd":"Kart ekle ve görüntüle","added_to_cards":"Kartlara eklendi","remove":"Kaldır","autoVis":"Otomatik","see_more":"Daha fazla göster","see_more_aria_label":"Daha fazla göster... Daha fazla ilgili görselleştirme bağlantısını görüntüleyin.","widget_recommender_fail":"Bir öneri bulunamadı","change_vis":"Görselleştirmeyi değiştir"},"__zh":{"add":"添加卡片","add_label":"添加","viewAdd":"查看并添加卡片","added_to_cards":"已添加到卡片","remove":"移除","autoVis":"自动","see_more":"查看更多信息","see_more_aria_label":"查看更多信息... 显示更多相关的可视化链接。","widget_recommender_fail":"找不到任何建议","change_vis":"更改可视化"},"__zh-cn":{"add":"添加卡片","add_label":"添加","viewAdd":"查看并添加卡片","added_to_cards":"已添加到卡片","remove":"移除","autoVis":"自动","see_more":"查看更多信息","see_more_aria_label":"查看更多信息... 显示更多相关的可视化链接。","widget_recommender_fail":"找不到任何建议","change_vis":"更改可视化"},"__zh-tw":{"add":"新增卡片","add_label":"新增","viewAdd":"新增和檢視卡片","added_to_cards":"已新增至卡片","remove":"移除","autoVis":"自動","see_more":"查看更多","see_more_aria_label":"查看更多 ... 顯示更多相關的視覺化鏈結。","widget_recommender_fail":"找不到任何建議","change_vis":"變更視覺化"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class, _desc, _value, _class2, _descriptor; /**
                                                  * Licensed Materials - Property of IBM
                                                  * IBM Watson (C) Copyright IBM Corp. 2018, 2020
                                                  * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                  */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _caUiToolkit = __webpack_require__(6);

var _StringResources = __webpack_require__(27);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _VisualizationContainer = __webpack_require__(276);

var _VisualizationContainer2 = _interopRequireDefault(_VisualizationContainer);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _classnames4 = __webpack_require__(10);

var _classnames5 = _interopRequireDefault(_classnames4);

var _add_ = __webpack_require__(282);

var _add_2 = _interopRequireDefault(_add_);

var _confirm_ = __webpack_require__(283);

var _confirm_2 = _interopRequireDefault(_confirm_);

var _CSSTransition = __webpack_require__(26);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _mobx = __webpack_require__(11);

__webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
	if (!descriptor) return;
	Object.defineProperty(target, property, {
		enumerable: descriptor.enumerable,
		configurable: descriptor.configurable,
		writable: descriptor.writable,
		value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	});
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

function _initializerWarningHelper(descriptor, context) {
	throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var CLASS_NAME = 'vis-recommender__preview';

var cloneItem = function cloneItem(item) {
	return JSON.parse(JSON.stringify(item));
};

var VisualizationPreview = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
	_inherits(VisualizationPreview, _Component);

	function VisualizationPreview(props) {
		_classCallCheck(this, VisualizationPreview);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_initDefineProp(_this, 'name', _descriptor, _this);

		_this.onTitleChange = function (title) {
			if (_this.name === '' && title) {
				_this.name = title;
			}
		};

		_this.handleClickAdd = function (e) {
			e.preventDefault();
			_this.handleAdd();
			var item = cloneItem(_this.props.item);
			_this.props.add(item);
		};

		_this.handleKeyAdd = function (e) {
			if (e.key === 'Enter') {
				e.preventDefault();
				_this.handleAdd();
				var item = cloneItem(_this.props.item);
				_this.props.add(item);
			}
		};

		_this.handleAdd = function () {
			_this.setState({
				adding: true
			});
			if (_this._pendingAddTimeoutId) {
				clearTimeout(_this._pendingAddTimeoutId);
			}
			_this._pendingAddTimeoutId = setTimeout(function () {
				_this.setState({
					adding: false
				});
			}, 2000);
		};

		_this._onPromptingError = function () {
			_this.props.onPromptingError(_this.props.item);
		};

		_this.name = _this.props.item.name;

		_this._pendingAddTimeoutId = undefined;

		_this.state = {
			adding: _this.props.adding
		};
		return _this;
	}

	VisualizationPreview.prototype.render = function render() {

		var isHorizontal = this.props.horizontal;

		var top = this.renderTop();
		var bottom = this.renderBottom();

		if (this.props.isNewLayoutEnabled) {
			var _classnames, _classnames2;

			var wrapperClassNames = (0, _classnames5.default)((_classnames = {}, _classnames[CLASS_NAME + '--wrapper__horizontal'] = isHorizontal, _classnames[CLASS_NAME + '--wrapper'] = !isHorizontal, _classnames));

			var classNames = (0, _classnames5.default)(CLASS_NAME, CLASS_NAME + '__size-' + this.props.size, (_classnames2 = {}, _classnames2[CLASS_NAME + '--horizontal'] = isHorizontal, _classnames2[CLASS_NAME + '--vertical'] = !isHorizontal, _classnames2));
			var tooltipText = this.props.add ? _StringResources2.default.get('viewAdd') : _StringResources2.default.get('change_vis');
			return _react2.default.createElement(
				'div',
				{ className: wrapperClassNames },
				this.renderStaticTitle(),
				_react2.default.createElement(
					_caUiToolkit.Tooltip,
					{
						title: tooltipText,
						orient: 'top',
						display: 'block'
					},
					_react2.default.createElement(
						'div',
						{ className: classNames,
							onClick: this._onSelect.bind(this),
							onKeyDown: this._onKeyDown.bind(this),
							tabIndex: 0,
							'appcues-data-id': 'vis-recommender-preview-' + this.props.index
						},
						top,
						this._renderCompoundPreviewItem(),
						bottom
					)
				),
				this.name && _react2.default.createElement(_caUiToolkit.Multilinetruncatedtext, { className: 'vis-recommender__preview__visTitle', numLines: 2, value: this.name })
			);
		} else {
			var _classnames3;

			var _classNames = (0, _classnames5.default)(CLASS_NAME, CLASS_NAME + '__size-' + this.props.size, (_classnames3 = {}, _classnames3[CLASS_NAME + '--horizontal'] = isHorizontal, _classnames3[CLASS_NAME + '--old_vertical'] = !isHorizontal, _classnames3));

			return _react2.default.createElement(
				'div',
				{ className: _classNames,
					onClick: this._onSelect.bind(this),
					onKeyDown: this._onKeyDown.bind(this),
					tabIndex: 0
				},
				top,
				this._renderCompoundPreviewItem(),
				bottom
			);
		}
	};

	VisualizationPreview.prototype.renderStaticTitle = function renderStaticTitle() {
		var staticTitle = this.props.item.staticTitle;


		if (!staticTitle) {
			return;
		}

		return _react2.default.createElement(
			'div',
			{ className: CLASS_NAME + '__static-title' },
			staticTitle
		);
	};

	VisualizationPreview.prototype._renderCompoundPreviewItem = function _renderCompoundPreviewItem() {
		var _this2 = this;

		var _props$item$widgets = this.props.item.widgets,
		    widgets = _props$item$widgets === undefined ? [] : _props$item$widgets;


		var classNames = (0, _classnames5.default)(CLASS_NAME + '__preview-box');

		return _react2.default.createElement(
			'div',
			{ className: classNames },
			widgets.map(function (widget, index) {
				if (widget.spec) {
					return _this2._renderSinglePreviewItem(widget, index);
				} else {
					return _this2._renderSingleEmptyItem();
				}
			})
		);
	};

	VisualizationPreview.prototype._renderSingleEmptyItem = function _renderSingleEmptyItem() {
		return _react2.default.createElement(
			'div',
			{ className: 'vis-recommender__container' },
			_react2.default.createElement('div', { className: 'vis-recommender__container__empty' })
		);
	};

	VisualizationPreview.prototype._renderSinglePreviewItem = function _renderSinglePreviewItem(_ref, index) {
		var spec = _ref.spec,
		    _ref$isHighlighted = _ref.isHighlighted,
		    isHighlighted = _ref$isHighlighted === undefined ? false : _ref$isHighlighted;
		var _props = this.props,
		    predictData = _props.predictData,
		    isPredictPreview = _props.isPredictPreview,
		    spinnerSize = _props.spinnerSize,
		    featureSet = _props.featureSet,
		    additionalProperties = _props.additionalProperties,
		    dashboardApi = _props.dashboardApi,
		    logger = _props.logger;


		var context = {
			dashboardApi: dashboardApi,
			spec: spec
		};

		return _react2.default.createElement(_VisualizationContainer2.default, {
			context: context,
			predictData: predictData,
			isPredictPreview: isPredictPreview,
			onTitleChange: this.onTitleChange,
			spinnerSize: spinnerSize,
			featureSet: featureSet,
			logger: logger,
			onPromptingError: this._onPromptingError,
			additionalProperties: additionalProperties,
			isHighlighted: isHighlighted,
			key: index
		});
	};

	VisualizationPreview.prototype.renderTop = function renderTop() {

		if (this.props.isNewLayoutEnabled) {
			return;
		} else {
			if (this.props.titleOnBottom) {
				return;
			}

			return _react2.default.createElement(
				'div',
				{ className: 'vis-recommender__preview__top' },
				_react2.default.createElement(_caUiToolkit.Label, { label: this.name, ellipsis: true })
			);
		}
	};

	VisualizationPreview.prototype.renderBottom = function renderBottom() {
		var title = void 0;
		if (!this.props.noBottomTitle) {
			if (!this.props.isNewLayoutEnabled && this.props.titleOnBottom) {
				title = _react2.default.createElement(
					_CSSTransition2.default,
					{
						'in': !this.state.adding,
						classNames: 'vis-recommender__animation--fade',
						timeout: 200,
						appear: true,
						mountOnEnter: true,
						unmountOnExit: true
					},
					_react2.default.createElement(_caUiToolkit.Label, { className: 'vis-recommender__preview__bottom__container__title', label: this.name, ellipsis: true })
				);
			}
		}

		var notification = _react2.default.createElement(
			_CSSTransition2.default,
			{
				'in': this.state.adding,
				classNames: 'vis-recommender__animation--fade',
				timeout: 200,
				appear: true,
				mountOnEnter: true,
				unmountOnExit: true
			},
			_react2.default.createElement(
				'div',
				{ className: CLASS_NAME + '__bottom__container__notification', onClick: function onClick(e) {
						return e.preventDefault();
					} },
				_react2.default.createElement(_caUiToolkit.SVGIcon, { className: CLASS_NAME + '__bottom__container__notification__icon', intent: 'positive', iconId: _confirm_2.default.id, size: 'small' }),
				_react2.default.createElement(
					'span',
					{ className: CLASS_NAME + '__bottom__container__notification__text' },
					_StringResources2.default.get('added_to_cards')
				)
			)
		);

		var addButton = this.renderAddButton();

		if (title || addButton) {
			return _react2.default.createElement(
				'div',
				{ className: 'vis-recommender__preview__bottom' },
				_react2.default.createElement(
					'div',
					{ className: CLASS_NAME + '__bottom__container' },
					title ? title : undefined,
					notification
				),
				_react2.default.createElement('div', { className: 'vis-recommender__preview__bottom__spacer' }),
				addButton
			);
		}
	};

	VisualizationPreview.prototype.renderAddButton = function renderAddButton() {
		if (this.props.add) {
			return _react2.default.createElement(
				_caUiToolkit.Link,
				{
					className: CLASS_NAME + '__bottom__add',
					href: '#',
					tabIndex: '0',
					onKeyDown: this.handleKeyAdd,
					onClick: this.handleClickAdd,
					title: _StringResources2.default.get('add'),
					'aria-label': _StringResources2.default.get('add')
				},
				_react2.default.createElement(_caUiToolkit.Label, {
					className: CLASS_NAME + '__bottom__add__text',
					label: _StringResources2.default.get('add_label')
				}),
				_react2.default.createElement(_caUiToolkit.SVGIcon, {
					size: 'small',
					iconId: _add_2.default.id
				})
			);
		}
	};

	VisualizationPreview.prototype._onSelect = function _onSelect(e) {
		if (_underscore2.default.isFunction(this.props.onClick) && !e.isDefaultPrevented()) {
			e.preventDefault();
			var item = cloneItem(this.props.item);
			this.props.onClick(item, this.props.index);
		}
	};

	VisualizationPreview.prototype._onKeyDown = function _onKeyDown(e) {
		if (e.keyCode === 13 || e.keyCode === 32) {
			this._onSelect(e);
		}
	};

	return VisualizationPreview;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'name', [_mobx.observable], {
	enumerable: true,
	initializer: function initializer() {
		return '';
	}
})), _class2)) || _class;

VisualizationPreview.propTypes = {
	add: _propTypes2.default.func,
	delete: _propTypes2.default.func,
	isVizTypeLocked: _propTypes2.default.bool,
	predictData: _propTypes2.default.object,
	isPredictPreview: _propTypes2.default.bool,
	item: _propTypes2.default.shape({
		name: _propTypes2.default.string,
		staticTitle: _propTypes2.default.string,
		widgets: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			spec: _propTypes2.default.object
		}))
	}),
	index: _propTypes2.default.number,
	dashboardApi: _propTypes2.default.object.isRequired,
	onClick: _propTypes2.default.func,
	titleOnBottom: _propTypes2.default.bool,
	horizontal: _propTypes2.default.bool,
	spinnerSize: _propTypes2.default.oneOf(['small', 'normal', 'large']),
	featureSet: _propTypes2.default.array,
	logger: _propTypes2.default.object,
	onPromptingError: _propTypes2.default.func,
	adding: _propTypes2.default.bool,
	isNewLayoutEnabled: _propTypes2.default.bool,
	additionalProperties: _propTypes2.default.arrayOf(_propTypes2.default.object),
	noBottomTitle: _propTypes2.default.bool,
	size: _propTypes2.default.oneOf(['small', 'medium', 'large'])
};

VisualizationPreview.defaultProps = {
	noBottomTitle: false,
	titleOnBottom: true,
	horizontal: false,
	spinnerSize: 'normal',
	featureSet: [],
	adding: false,
	additionalProperties: [],
	size: 'small'
};
exports.default = VisualizationPreview;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class, _desc, _value, _class2, _descriptor, _descriptor2; /**
                                                                * Licensed Materials - Property of IBM
                                                                * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModuleLoader = __webpack_require__(277);

var _reactMeasure = __webpack_require__(20);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _caUiToolkit = __webpack_require__(6);

var _mobxUtils = __webpack_require__(15);

var _StringResources = __webpack_require__(27);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _mobx = __webpack_require__(11);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _uniq = __webpack_require__(278);

var _uniq2 = _interopRequireDefault(_uniq);

var _union = __webpack_require__(279);

var _union2 = _interopRequireDefault(_union);

__webpack_require__(280);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
	if (!descriptor) return;
	Object.defineProperty(target, property, {
		enumerable: descriptor.enumerable,
		configurable: descriptor.configurable,
		writable: descriptor.writable,
		value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	});
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

function _initializerWarningHelper(descriptor, context) {
	throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var PROMPT_ERROR_MESSAGE = 'promptingIsDisabled';
var VIS_DISABLED_FOR_THUMBNAIL = {
	'com.ibm.vis.rave2bundletiledmap': 'dashboard-analytics/images/placeholders/map.svg',
	'com.ibm.vis.snippetlistbundle': 'dashboard-analytics/images/placeholders/snippetlist.svg'
};

var VisualizationContainer = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
	_inherits(VisualizationContainer, _Component);

	function VisualizationContainer(props) {
		_classCallCheck(this, VisualizationContainer);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_initDefineProp(_this, 'progress', _descriptor, _this);

		_initDefineProp(_this, 'placeholderIcon', _descriptor2, _this);

		_this.liveWidgetPreview = null;
		return _this;
	}

	VisualizationContainer.prototype._cleanSpec = function _cleanSpec(spec) {
		if (!spec) {
			return;
		}
		return Object.assign({}, spec, {
			properties: (0, _uniq2.default)((0, _union2.default)(this.props.additionalProperties, spec.properties || []), function (item) {
				return item.id;
			})
		});
	};

	VisualizationContainer.prototype._loadLiveWidgetPreview = function _loadLiveWidgetPreview() {
		return new Promise(function (resolve, reject) {
			(0, _ModuleLoader.loadModule)(['dashboard-analytics/preview/LiveWidgetPreview'], resolve, reject);
		});
	};

	VisualizationContainer.prototype._createLiveWidget = function _createLiveWidget(LiveWidgetPreview) {
		var payload = {
			node: this.el,
			dashboardApi: this.props.context.dashboardApi,
			spec: this._cleanSpec(this.props.context.spec),
			// TODO: Remove when the livewidget preview is updated to user the dashboardApi in the main options
			runtimeEnv: {
				dashboardApi: this.props.context.dashboardApi
			},
			featureSet: this.props.featureSet
		};
		payload.predictData = this.props.predictData;
		payload.tabNavigation = false;
		payload.isPredictPreview = this.props.isPredictPreview;
		var renderWidget = this._renderLiveWidget(LiveWidgetPreview, payload);

		this.progress = (0, _mobxUtils.fromPromise)(renderWidget);
		return renderWidget;
	};

	VisualizationContainer.prototype._renderLiveWidget = function _renderLiveWidget(LiveWidgetPreview, payload) {
		var _this2 = this;

		this.liveWidgetPreview = new LiveWidgetPreview(payload);

		if (this._renderStaticPreview()) {
			return Promise.resolve(true);
		}
		return this.liveWidgetPreview.render().then(function () {
			if (_this2.liveWidgetPreview.getTitle) {
				_this2.props.onTitleChange(_this2.liveWidgetPreview.getTitle());
			}
			return true;
		}).catch(function (error) {
			var message = error && error.message;
			if (message && message === PROMPT_ERROR_MESSAGE) {
				return _this2._getPlaceHolderIcon(_this2.liveWidgetPreview.spec.visId).then(function (placeholder) {
					_this2.placeholderIcon = placeholder.placeholderIcon;
					_this2.props.onPromptingError();
					return true;
				});
			} else {
				_this2.props.logger && _this2.props.logger.warn(error);
				return false;
			}
		});
	};

	VisualizationContainer.prototype.componentDidMount = function componentDidMount() {
		var _this3 = this;

		var prom = this._loadLiveWidgetPreview().then(function (LiveWidgetPreview) {
			return _this3._createLiveWidget(LiveWidgetPreview);
		});
		this._loadPreviewPromise = prom;
		prom.then(null, function () {}); //already handled in render when progress is rejected, close the promise chain
	};

	VisualizationContainer.prototype.componentWillUnmount = function componentWillUnmount() {
		if (this.liveWidgetPreview) {
			this.liveWidgetPreview.destroy && this.liveWidgetPreview.destroy();
		}
		if (this.el && this.el.parentNode) {
			this.el.parentNode.removeChild(this.el);
		}
		this._loadPreviewPromise = null;
	};

	VisualizationContainer.prototype._getPlaceHolderIcon = function _getPlaceHolderIcon(visId) {
		var visDefinitions = this.liveWidgetPreview.runtimeEnv.dashboardApi.getFeature('VisDefinitions');
		if (visDefinitions) {
			return visDefinitions.loadById(visId);
		} else {
			return Promise.resolve(null);
		}
	};

	VisualizationContainer.prototype._renderStaticPreview = function _renderStaticPreview() {
		var visId = this.props.context && this.props.context.spec && this.props.context.spec.visId;
		if (visId) {
			var staticIcon = VIS_DISABLED_FOR_THUMBNAIL[visId];
			if (staticIcon) {
				this.placeholderIcon = staticIcon;
				return true;
			}
		}
		return false;
	};

	VisualizationContainer.prototype.render = function render() {
		var _this4 = this;

		var progressView = void 0;
		var spinner = _react2.default.createElement(
			'div',
			{ className: 'vis-recommender__container__content__pending_or_fail__spinner' },
			_react2.default.createElement(_caUiToolkit.ProgressIndicator, { size: this.props.spinnerSize })
		);
		if (!this.progress) {
			progressView = _react2.default.createElement(
				'div',
				{ className: 'vis-recommender__container__content__pending_or_fail' },
				spinner
			);
		} else if (this.progress.state === _mobxUtils.PENDING) {
			// When progress state is pending set progressView to null because livewidget now handles the rendering state with a wave-like loading
			progressView = null;
		} else if (this.progress.state === _mobxUtils.REJECTED) {
			var message = this.progress.value && this.progress.value.message || _StringResources2.default.get('widget_recommender_fail');
			progressView = _react2.default.createElement(
				'div',
				{ className: 'vis-recommender__container__content__pending_or_fail' },
				_react2.default.createElement(_caUiToolkit.Label, { label: message, ellipsis: true })
			);
		} else if (this.progress.state === _mobxUtils.FULFILLED) {
			if (this.placeholderIcon) {
				progressView = _react2.default.createElement(
					'div',
					{ className: 'vis-recommender__container__content__placeHolderIcon' },
					_react2.default.createElement('img', { className: 'vis-recommender__container__content__placeHolderIcon__img', src: this.placeholderIcon })
				);
			}
		}

		var classNames = (0, _classnames2.default)('vis-recommender__container', {
			'vis-recommender__container__highlighted': this.props.isHighlighted
		});

		return _react2.default.createElement(
			_reactMeasure2.default,
			{
				onResize: function onResize() {
					return _this4.onResize();
				}
			},
			function (_ref) {
				var measureRef = _ref.measureRef;
				return _react2.default.createElement(
					'div',
					{ className: classNames, ref: measureRef },
					_react2.default.createElement(
						'div',
						{ className: 'vis-recommender__container__content', ref: function ref(el) {
								_this4.el = el;
							} },
						progressView
					)
				);
			}
		);
	};

	VisualizationContainer.prototype.onResize = function onResize() {
		if (this._isVisible()) {
			this.liveWidgetPreview && this.liveWidgetPreview.resize();
		}
	};

	VisualizationContainer.prototype._isVisible = function _isVisible() {
		return this.progress && this.progress.state === _mobxUtils.FULFILLED && this.el && this.el.offsetHeight > 0 && this.el.offsetWidth > 0;
	};

	return VisualizationContainer;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'progress', [_mobx.observable], {
	enumerable: true,
	initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'placeholderIcon', [_mobx.observable], {
	enumerable: true,
	initializer: function initializer() {
		return null;
	}
})), _class2)) || _class;

VisualizationContainer.propTypes = {
	context: _propTypes2.default.object.isRequired,
	onTitleChange: _propTypes2.default.func,
	spinnerSize: _propTypes2.default.oneOf(['small', 'normal', 'large']),
	featureSet: _propTypes2.default.array,
	predictData: _propTypes2.default.object,
	logger: _propTypes2.default.object,
	isPredictPreview: _propTypes2.default.bool,
	isHighlighted: _propTypes2.default.bool,
	onPromptingError: _propTypes2.default.func,
	additionalProperties: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

VisualizationContainer.defaultProps = {
	onTitleChange: function onTitleChange() {},
	additionalProperties: [],
	isHighlighted: false,
	onPromptingError: function onPromptingError() {}
};

exports.default = VisualizationContainer;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var loadModule = function loadModule(arrModule, cb, cbErr) {
  var reqFn = 'require';
  window[reqFn](arrModule, cb, cbErr);
};
exports.loadModule = loadModule;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Licensed Materials - Property of IBM
 * IBM Watson (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var uniq = function uniq(array, iteratee) {
  return array.filter(function (item, i, self) {
    return self.findIndex(function (it) {
      return iteratee(it) === iteratee(item);
    }) === i;
  });
};

exports.default = uniq;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Licensed Materials - Property of IBM
 * IBM Watson (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var union = function union() {
  for (var _len = arguments.length, arrays = Array(_len), _key = 0; _key < _len; _key++) {
    arrays[_key] = arguments[_key];
  }

  return arrays.reduce(function (acc, curr) {
    acc.push.apply(acc, curr);
    return acc;
  }, []);
};

exports.default = union;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(281);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./visContainer.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./visContainer.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018, 2019\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.vis-recommender__container {\n  -ms-flex: 0 1 auto;\n      flex: 0 1 auto;\n  padding: 5px;\n  width: 100%;\n  border: 2px solid transparent;\n}\n\n.vis-recommender__container:not(:only-child) {\n  width: calc(50% - 15px);\n}\n\n.vis-recommender__container__empty {\n  border: 2px dashed #eaeaea;\n  height: calc(100% - 4px);\n}\n\n.vis-recommender__container__highlighted {\n  border: 2px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.vis-recommender__container__content {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.vis-recommender__container__content__pending_or_fail {\n  position: absolute;\n  opacity: 1;\n  z-index: 100;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  vertical-align: middle;\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  -ms-flex-align: center;\n      align-items: center;\n  display: -ms-flexbox;\n  display: flex;\n  pointer-events: all;\n}\n\n.vis-recommender__container__content__pending_or_fail__spinner {\n  margin: auto;\n}\n\n.vis-recommender__container__content__placeHolderIcon {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.vis-recommender__container__content__placeHolderIcon__img {\n  width: 100%;\n  height: 100%;\n}\n\n", ""]);

// exports


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "add_32",
  "use": "add_32-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"add_32\"><path d=\"M17 15V7h-2v8H7v2h8v8h2v-8h8v-2h-8z\" /><path style=\"fill:none\" d=\"M0 0h32v32H0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "confirm_16",
  "use": "confirm_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"confirm_16\"><path d=\"M8 0a8 8 0 100 16A8 8 0 008 0zM7 12L3.5 8.5 5 7l2 2 4.042-4.042L12.5 6.5 7 12z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.vis-recommender__animation--fade-appear,\n.vis-recommender__animation--fade-enter {\n  opacity: 0.1;\n}\n\n.vis-recommender__animation--fade-appear-active,\n.vis-recommender__animation--fade-enter-active {\n  opacity: 1;\n  transition: opacity 200ms ease-in;\n}\n\n.vis-recommender__animation--fade-exit {\n  opacity: 1;\n}\n\n.vis-recommender__animation--fade-exit-active {\n  opacity: 0.1;\n  transition: opacity 200ms ease-out;\n}\n\n.vis-recommender__preview {\n  cursor: pointer;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.vis-recommender__preview * {\n  cursor: pointer;\n}\n\n.vis-recommender__preview__static-title {\n  padding: 0 0 8px 0;\n  font-weight: 600;\n}\n\n.vis-recommender__preview__size-small {\n  height: 140px;\n  width: 190px;\n}\n\n.vis-recommender__preview__size-medium {\n  height: 150px;\n  width: 260px;\n}\n\n.vis-recommender__preview__size-large {\n  width: 298px;\n}\n\n.vis-recommender__preview--wrapper__horizontal {\n  margin: 0px 8px 8px 8px;\n}\n\n.vis-recommender__preview__top {\n  font-size: 0.75rem;\n  padding: 8px;\n  padding-bottom: 0px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.vis-recommender__preview__bottom {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 0 8px;\n}\n\n.vis-recommender__preview__bottom__spacer {\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.vis-recommender__preview__bottom__add {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.vis-recommender__preview__bottom__add:link,\n.vis-recommender__preview__bottom__add:visited {\n  text-decoration: none;\n}\n\n.vis-recommender__preview__bottom__add__text {\n  padding-right: 8px;\n  color: #393939;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 22.35294%), 1);\n  width: 100%;\n}\n\n.vis-recommender__preview__bottom__add:hover .vis-recommender__preview__bottom__add__text {\n  fill: #0f62fe;\n  fill: hsla(var(--link-01-h, 219.16318), var(--link-01-s, 99.17012%), var(--link-01-l, 52.7451%), 1);\n}\n\n.vis-recommender__preview__bottom__container {\n  position: relative;\n  width: calc(100% - 32px);\n  text-align: left;\n  height: 16px;\n  padding: 10px 0;\n}\n\n.vis-recommender__preview__bottom__container__notification {\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  position: absolute;\n  bottom: 8px;\n  left: 0;\n  padding: 0 8px;\n  line-height: 16px;\n}\n\n.vis-recommender__preview__bottom__container__notification__text {\n  margin: 8px;\n}\n\n.vis-recommender__preview__bottom__container__visType {\n  padding: 0 8px;\n}\n\n.vis-recommender__preview__bottom__container__title {\n  padding: 0 8px;\n}\n\n.vis-recommender__preview__preview-box {\n  margin: 4px;\n  -ms-flex: 1;\n      flex: 1;\n  overflow: hidden;\n  pointer-events: none;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n\n.vis-recommender__preview--old_vertical {\n  height: 154px;\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  color: #343334;\n  text-align: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  margin-top: 20px;\n}\n\n.vis-recommender__preview--old_vertical:hover,\n.vis-recommender__preview--old_vertical:active {\n  outline-style: solid;\n  outline-width: 1px;\n  outline-color: #161616;\n  outline-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n  border-color: #161616;\n  border-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n}\n\n.vis-recommender__preview--vertical {\n  border: 1px solid #eaeaea;\n  color: #343334;\n  text-align: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  margin-top: 20px;\n}\n\n.vis-recommender__preview--vertical:hover,\n.vis-recommender__preview--vertical:active {\n  outline-style: solid;\n  outline-width: 1px;\n  outline-color: #161616;\n  outline-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n  border-color: #161616;\n  border-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n}\n\n.vis-recommender__preview--horizontal {\n  padding: 0;\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  text-align: center;\n}\n\n.vis-recommender__preview--horizontal:hover,\n.vis-recommender__preview--horizontal:active {\n  outline-style: solid;\n  outline-width: 2px;\n  outline-color: #161616;\n  outline-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n}\n\n.vis-recommender__preview__autoIcon {\n  margin-bottom: 8px;\n  margin-top: 24px;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.vis-recommender__preview--selected {\n  outline-style: solid;\n  outline-width: 2px;\n  outline-color: #161616;\n  outline-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n}\n\n.vis-recommender__preview__visTitle {\n  padding-top: 8px;\n  padding-bottom: 20px;\n  font-size: 0.875rem;\n  width: 100%;\n  color: #393939;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 22.35294%), 1);\n}\n\n@media only screen and (max-width: 1200px) {\n  .vis-recommender__preview--vertical {\n    width: inherit;\n  }\n}\n\n", ""]);

// exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _caUiToolkit = __webpack_require__(6);

var _StringResources = __webpack_require__(27);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _classnames4 = __webpack_require__(10);

var _classnames5 = _interopRequireDefault(_classnames4);

var _changeVisualization_ = __webpack_require__(286);

var _changeVisualization_2 = _interopRequireDefault(_changeVisualization_);

__webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var CLASS_NAME = 'vis-recommender__preview';

var VisualizationAutoMode = function (_Component) {
	_inherits(VisualizationAutoMode, _Component);

	function VisualizationAutoMode() {
		var _temp, _this, _ret;

		_classCallCheck(this, VisualizationAutoMode);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._onSelect = function (e) {
			// TODO: do we need this?
			if (!e.isDefaultPrevented()) {
				e.preventDefault();
				_this.props.onSelect();
			}
		}, _this._onKeyDown = function (e) {
			if (e.keyCode === 13 || e.keyCode === 32) {
				_this._onSelect(e);
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	VisualizationAutoMode.prototype.render = function render() {
		var _classnames, _classnames2, _classnames3;

		var _props = this.props,
		    isHorizontal = _props.isHorizontal,
		    isSelected = _props.isSelected,
		    size = _props.size;


		var wrapperClassNames = (0, _classnames5.default)((_classnames = {}, _classnames[CLASS_NAME + '--wrapper__horizontal'] = isHorizontal, _classnames[CLASS_NAME + '--wrapper'] = !isHorizontal, _classnames));

		var classNames = (0, _classnames5.default)(CLASS_NAME, [CLASS_NAME + '__size-' + size], (_classnames2 = {}, _classnames2[CLASS_NAME + '--horizontal'] = isHorizontal, _classnames2[CLASS_NAME + '--vertical'] = !isHorizontal, _classnames2[CLASS_NAME + '--selected'] = isSelected, _classnames2));

		var visBoxClassNames = (0, _classnames5.default)(CLASS_NAME + '__preview-box', CLASS_NAME + '__autoIcon', (_classnames3 = {}, _classnames3[CLASS_NAME + '--horizontal__preview-box'] = isHorizontal, _classnames3[CLASS_NAME + '--vertical__preview-box'] = !isHorizontal, _classnames3));

		var label = _StringResources2.default.get('autoVis');

		return _react2.default.createElement(
			'div',
			{ className: wrapperClassNames },
			_react2.default.createElement(
				'div',
				{ className: classNames,
					onClick: this._onSelect,
					onKeyDown: this._onKeyDown,
					tabIndex: 0
				},
				_react2.default.createElement(
					'div',
					{ className: visBoxClassNames },
					_react2.default.createElement(
						'div',
						{ className: CLASS_NAME + '__autoIcon' },
						_react2.default.createElement(_caUiToolkit.SVGIcon, { intent: 'primary', iconId: _changeVisualization_2.default.id, size: 'large' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'ba-common-truncatedText__text', 'aria-label': label },
						label
					)
				)
			)
		);
	};

	return VisualizationAutoMode;
}(_react.Component);

VisualizationAutoMode.propTypes = {
	isHorizontal: _propTypes2.default.bool,
	isSelected: _propTypes2.default.bool,
	onSelect: _propTypes2.default.func,
	size: _propTypes2.default.oneOf(['small', 'medium'])
};

VisualizationAutoMode.defaultProps = {
	isHorizontal: true,
	isSelected: false,
	onSelect: function onSelect() {},
	size: 'small'
};

exports.default = VisualizationAutoMode;

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "change-visualization_32",
  "use": "change-visualization_32-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"change-visualization_32\"><path d=\"M10 2h2v12h-2V2zM6 6h2v8H6V6zm-4 4h2v4H2v-4zm5 8c-2.6.4-4.7 2.5-5 5.2h5V18zm1.8 0v6.8H2c.5 3.3 3.5 5.6 6.8 5.2 3.3-.5 5.6-3.5 5.2-6.8-.4-2.7-2.5-4.8-5.2-5.2zM24.2 7.4l2.4 1.4 4.2-6.2-1.6-1.2L26 6l-2.2-1.4-6.6 8.8 1.6 1.2 5.4-7.2zM27 16c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3c0-1.6-1.4-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1c0 .5-.4 1-.9 1H27zm-5 2c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018, 2020\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.vis-recommender__preview-list--vertical {\n  width: 100%;\n  padding: 0;\n}\n\n.vis-recommender__preview-list--vertical__items {\n  height: 100%;\n}\n\n.vis-recommender__preview-list--vertical .vis-recommender__preview-list__see-more {\n  text-align: center;\n  margin-top: 16px;\n}\n\n.vis-recommender__preview-list--horizontal__items {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  padding: 1px;\n}\n\n.vis-recommender__preview-list--horizontal .vis-recommender__preview-list__see-more {\n  margin-top: 24px;\n  margin-left: 8px;\n}\n\n.vis-recommender__preview-list--horizontal .vis-recommender__preview-list__see-more a {\n  color: #0f62fe;\n  color: hsla(var(--link-01-h, 219.16318), var(--link-01-s, 99.17012%), var(--link-01-l, 52.7451%), 1);\n}\n\n.vis-recommender__preview-list--horizontal .vis-recommender__preview-list__see-more a:hover {\n  text-decoration: underline;\n  color: #0043ce;\n  color: hsla(var(--hover-primary-text-h, 220.48544), var(--hover-primary-text-s, 100%), var(--hover-primary-text-l, 40.39216%), 1);\n}\n\n.vis-recommender__preview-list--horizontal .vis-recommender__preview-list__see-more a:active {\n  text-decoration: underline;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n.vis-recommender__preview-list__see-more--hidden {\n  visibility: hidden;\n}\n\n", ""]);

// exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(289);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./recommendedCommon.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./recommendedCommon.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.vis-recommendation-common {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.vis-recommendation-common__header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 24px 64px;\n}\n\n.vis-recommendation-common__header__title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #393939;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 22.35294%), 1);\n}\n\n.vis-recommendation-common__progress-indicator-container,\n.vis-recommendation-common__recommender-message {\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  text-align: center;\n  vertical-align: middle;\n  margin: auto;\n}\n\n.vis-recommendation-common__progress-indicator-container :first-child,\n.vis-recommendation-common__recommender-message :first-child {\n  margin: auto;\n}\n\n", ""]);

// exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(291);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./recommended.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./recommended.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.vis-recommended {\n  min-height: 180px;\n}\n\n.vis-recommended .vis-recommender__preview {\n  font-size: 0.875rem;\n  font-weight: 700;\n}\n\n", ""]);

// exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _VisTypeModel = __webpack_require__(93);

var _VisTypePicker = __webpack_require__(295);

var _VisTypePicker2 = _interopRequireDefault(_VisTypePicker);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisTypeContainer = function (_Component) {
	_inherits(VisTypeContainer, _Component);

	function VisTypeContainer(props) {
		_classCallCheck(this, VisTypeContainer);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.visTypeModel = _VisTypeModel.VisTypeModel.create({
			filter: _this.props.filter
		}, {
			visDefinitions: _this.props.visDefinitions
		});
		return _this;
	}

	VisTypeContainer.prototype.render = function render() {
		var _this2 = this;

		return _react2.default.createElement(_VisTypePicker2.default, {
			className: this.props.visTypeClassName,
			onVisTypeSelected: function onVisTypeSelected(visTypeId) {
				return _this2.props.onVisTypeSelected(visTypeId);
			},
			model: this.visTypeModel,
			isVizTypeLocked: this.props.isVizTypeLocked,
			selectedVisId: this.props.selectedVisId,
			isExtVis: this.props.isExtVis,
			iconsFeature: this.props.iconsFeature
		});
	};

	return VisTypeContainer;
}(_react.Component);

VisTypeContainer.propTypes = {
	onVisTypeSelected: _propTypes2.default.func,
	filter: _propTypes2.default.array,
	visTypeClassName: _propTypes2.default.string,
	isVizTypeLocked: _propTypes2.default.bool,
	selectedVisId: _propTypes2.default.string,
	isExtVis: _propTypes2.default.func,
	visDefinitions: _propTypes2.default.array.isRequired,
	iconsFeature: _propTypes2.default.object.isRequired
};

exports.default = VisTypeContainer;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _VisTypePickerResources = __webpack_require__(294);

var _VisTypePickerResources2 = _interopRequireDefault(_VisTypePickerResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Licensed Materials - Property of IBM
                                                                                                                                                           * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
                                                                                                                                                           * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           */

var Polyglot = __webpack_require__(22);

var StringResources = function () {
	function StringResources() {
		_classCallCheck(this, StringResources);

		/**
   * Module which provides simple access to string resources.
   */
		this.polyglot = new Polyglot({
			phrases: _VisTypePickerResources2.default
		});
	}

	/**
  * Get the string resource for the given key and interpolation options
  *
  * @param key						The  key of the string to return
  * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
  * @returns							The string to display
  */


	StringResources.prototype.get = function get(key, interpolationOptions) {
		return this.polyglot.t(key, interpolationOptions);
	};

	return StringResources;
}();

exports.default = new StringResources();

/***/ }),
/* 294 */
/***/ (function(module, exports) {

var amdi18n={"__root":{"visUsageComparison":"Comparison","visUsageRelationships":"Relationships","visUsageTrend":"Trend","visUsagePartsToWhole":"Parts to whole","visUsageGeospatial":"Geospatial","visUsageAdvanced":"Advanced analytics","visUsageTablesAndSummary":"Tables and summary","visUsageSocialInsights":"Social insights","visUsageOther":"Other"},"__cs":{"visUsageComparison":"Porovnání","visUsageRelationships":"Vztahy","visUsageTrend":"Trend","visUsagePartsToWhole":"Části k celku","visUsageGeospatial":"Geoprostorová vizualizace","visUsageAdvanced":"Rozšířená analýza","visUsageTablesAndSummary":"Tabulky a souhrn","visUsageSocialInsights":"Náhledy sociálních sítí","visUsageOther":"Ostatní"},"__da":{"visUsageComparison":"Sammenligning","visUsageRelationships":"Relationer","visUsageTrend":"Tendens","visUsagePartsToWhole":"Dele til hele","visUsageGeospatial":"Geospatial","visUsageAdvanced":"Avancerede analyser","visUsageTablesAndSummary":"Tabeller og resumé","visUsageSocialInsights":"Social insights","visUsageOther":"Andet"},"__de":{"visUsageComparison":"Vergleich","visUsageRelationships":"Beziehungen","visUsageTrend":"Trend","visUsagePartsToWhole":"Teile zum Ganzen","visUsageGeospatial":"Geografisch-räumlich","visUsageAdvanced":"Erweiterte Analyse","visUsageTablesAndSummary":"Tabellen und Zusammenfassung","visUsageSocialInsights":"Social Insights","visUsageOther":"Sonstige"},"__es":{"visUsageComparison":"Comparación","visUsageRelationships":"Relaciones","visUsageTrend":"Tendencia","visUsagePartsToWhole":"Componentes del conjunto","visUsageGeospatial":"Geoespacial","visUsageAdvanced":"Análisis avanzado","visUsageTablesAndSummary":"Tablas y resumen","visUsageSocialInsights":"Social insights","visUsageOther":"Otros"},"__fi":{"visUsageComparison":"Vertailu","visUsageRelationships":"Suhteet","visUsageTrend":"Suuntaus","visUsagePartsToWhole":"Osien suhde kokonaisuuteen","visUsageGeospatial":"Paikkatiedot","visUsageAdvanced":"Edistyksellinen analytiikka","visUsageTablesAndSummary":"Taulukot ja yhteenveto","visUsageSocialInsights":"Sosiaalinen oivallustoiminto","visUsageOther":"Muut"},"__fr":{"visUsageComparison":"Comparaison","visUsageRelationships":"Relations","visUsageTrend":"Tendance","visUsagePartsToWhole":"De partie à tout","visUsageGeospatial":"Géospatial","visUsageAdvanced":"Analyse avancée","visUsageTablesAndSummary":"Tableaux et récapitulatif","visUsageSocialInsights":"Informations sociales","visUsageOther":"Autres"},"__hr":{"visUsageComparison":"Usporedba","visUsageRelationships":"Relacije","visUsageTrend":"Trend","visUsagePartsToWhole":"Dijelova prema cjelini","visUsageGeospatial":"Geoprostorni podaci","visUsageAdvanced":"Napredna analitika","visUsageTablesAndSummary":"Tablice i sumiranje","visUsageSocialInsights":"Društveni uvidi","visUsageOther":"Ostalo"},"__hu":{"visUsageComparison":"Összehasonlítás","visUsageRelationships":"Kapcsolatok","visUsageTrend":"Trend","visUsagePartsToWhole":"Részek - egész","visUsageGeospatial":"Térinformatikai","visUsageAdvanced":"Speciális elemzések","visUsageTablesAndSummary":"Táblák és összegzés","visUsageSocialInsights":"Közösségi betekintések","visUsageOther":"Egyéb"},"__it":{"visUsageComparison":"Confronto","visUsageRelationships":"Relazioni","visUsageTrend":"Tendenza","visUsagePartsToWhole":"Parti rispetto all'intero","visUsageGeospatial":"Geospaziale","visUsageAdvanced":"Analisi avanzate","visUsageTablesAndSummary":"Tabelle e riepilogo","visUsageSocialInsights":"Informazioni social","visUsageOther":"Altro"},"__ja":{"visUsageComparison":"比較","visUsageRelationships":"関係","visUsageTrend":"トレンド","visUsagePartsToWhole":"部分と全体の関係","visUsageGeospatial":"地理情報","visUsageAdvanced":"拡張分析","visUsageTablesAndSummary":"表と集計","visUsageSocialInsights":"ソーシャル・インサイト","visUsageOther":"その他"},"__kk":{"visUsageComparison":"Салыстыру","visUsageRelationships":"Қатынастар","visUsageTrend":"Тренд","visUsagePartsToWhole":"Толық бөліктер","visUsageGeospatial":"Геокеңістіктік","visUsageAdvanced":"Жетілдірілген талдаулар","visUsageTablesAndSummary":"Кестелер және жиынтық","visUsageSocialInsights":"Әлеуметтік түсініктер","visUsageOther":"Басқа"},"__ko":{"visUsageComparison":"비교","visUsageRelationships":"관계","visUsageTrend":"추세","visUsagePartsToWhole":"일부 대 전부","visUsageGeospatial":"지리공간적","visUsageAdvanced":"고급 분석","visUsageTablesAndSummary":"테이블 및 요약","visUsageSocialInsights":"소셜 인사이트","visUsageOther":"기타"},"__nb":{"visUsageComparison":"Sammenlikning","visUsageRelationships":"Relasjoner","visUsageTrend":"Trend","visUsagePartsToWhole":"Deler til hele","visUsageGeospatial":"Georom","visUsageAdvanced":"Avansert analyse","visUsageTablesAndSummary":"Tabeller og sammendrag","visUsageSocialInsights":"Sosial innsikt","visUsageOther":"Annet"},"__nl":{"visUsageComparison":"Vergelijking","visUsageRelationships":"Relaties","visUsageTrend":"Trend","visUsagePartsToWhole":"Delen t.o.v. geheel","visUsageGeospatial":"Georuimtelijk","visUsageAdvanced":"Advanced Analytics","visUsageTablesAndSummary":"Tabellen en overzicht","visUsageSocialInsights":"Sociale inzichten","visUsageOther":"Overige"},"__no":{"visUsageComparison":"Sammenlikning","visUsageRelationships":"Relasjoner","visUsageTrend":"Trend","visUsagePartsToWhole":"Deler til hele","visUsageGeospatial":"Georom","visUsageAdvanced":"Avansert analyse","visUsageTablesAndSummary":"Tabeller og sammendrag","visUsageSocialInsights":"Sosial innsikt","visUsageOther":"Annet"},"__pl":{"visUsageComparison":"Porównanie","visUsageRelationships":"Relacje","visUsageTrend":"Trend","visUsagePartsToWhole":"Części całości","visUsageGeospatial":"Geoprzestrzennie","visUsageAdvanced":"Zaawansowana analiza","visUsageTablesAndSummary":"Tabele i podsumowanie","visUsageSocialInsights":"Social Insights","visUsageOther":"Inne"},"__pt":{"visUsageComparison":"Comparação","visUsageRelationships":"Relacionamentos","visUsageTrend":"Tendência","visUsagePartsToWhole":"Peças para toda","visUsageGeospatial":"Geoespacial","visUsageAdvanced":"Analítica Avançada","visUsageTablesAndSummary":"Tabelas e resumo","visUsageSocialInsights":"Insights sociais","visUsageOther":"Outros"},"__pt-br":{"visUsageComparison":"Comparação","visUsageRelationships":"Relacionamentos","visUsageTrend":"Tendência","visUsagePartsToWhole":"Peças para toda","visUsageGeospatial":"Geoespacial","visUsageAdvanced":"Analítica Avançada","visUsageTablesAndSummary":"Tabelas e resumo","visUsageSocialInsights":"Insights sociais","visUsageOther":"Outros"},"__ro":{"visUsageComparison":"Comparaţie","visUsageRelationships":"Relaţii","visUsageTrend":"Tendinţă","visUsagePartsToWhole":"Părţi - întreg","visUsageGeospatial":"Geospaţială","visUsageAdvanced":"Analize avansate","visUsageTablesAndSummary":"Tabele şi sumare","visUsageSocialInsights":"Insight-uri sociale","visUsageOther":"Altul"},"__ru":{"visUsageComparison":"Сравнение","visUsageRelationships":"Взаимосвязи","visUsageTrend":"Тенденция","visUsagePartsToWhole":"Части к целому","visUsageGeospatial":"Геопространственные","visUsageAdvanced":"Расширенная аналитика","visUsageTablesAndSummary":"Таблицы и сводка","visUsageSocialInsights":"Социальное интуитивное понимание","visUsageOther":"Другое"},"__sl":{"visUsageComparison":"Primerjava","visUsageRelationships":"Razmerja","visUsageTrend":"Trendni","visUsagePartsToWhole":"Deli do celote","visUsageGeospatial":"Geoprostorski","visUsageAdvanced":"Napredna analitika","visUsageTablesAndSummary":"Tabele in povzetek","visUsageSocialInsights":"Družabni vpogledi","visUsageOther":"Drugo"},"__sv":{"visUsageComparison":"Jämförelse","visUsageRelationships":"Relationer","visUsageTrend":"Trend","visUsagePartsToWhole":"Delar till helheten","visUsageGeospatial":"Rumsanalys","visUsageAdvanced":"Avancerad analys","visUsageTablesAndSummary":"Tabeller och summering","visUsageSocialInsights":"Sociala insikter","visUsageOther":"Annan"},"__th":{"visUsageComparison":"การเปรียบเทียบ","visUsageRelationships":"ความสัมพันธ์","visUsageTrend":"แนวโน้ม","visUsagePartsToWhole":"ส่วนต่อทั้งหมด","visUsageGeospatial":"ภูมิสารสนเทศเชิงพื้นที่","visUsageAdvanced":"การวิเคราะห์ขั้นสูง","visUsageTablesAndSummary":"ตารางและสรุป","visUsageSocialInsights":"ข้อมูลเชิงลึกทางสังคม","visUsageOther":"อื่นๆ"},"__tr":{"visUsageComparison":"Karşılaştırma","visUsageRelationships":"İlişkiler","visUsageTrend":"Eğilim","visUsagePartsToWhole":"Parçaların bütüne oranı","visUsageGeospatial":"Jeo-uzamsal","visUsageAdvanced":"Gelişmiş analitik","visUsageTablesAndSummary":"Tablolar ve özet","visUsageSocialInsights":"Sosyal öngörüler","visUsageOther":"Daha Fazla"},"__zh":{"visUsageComparison":"比较","visUsageRelationships":"关系","visUsageTrend":"趋势","visUsagePartsToWhole":"部分对整体","visUsageGeospatial":"地理空间","visUsageAdvanced":"高级分析","visUsageTablesAndSummary":"表和摘要","visUsageSocialInsights":"社交洞察","visUsageOther":"其他"},"__zh-cn":{"visUsageComparison":"比较","visUsageRelationships":"关系","visUsageTrend":"趋势","visUsagePartsToWhole":"部分对整体","visUsageGeospatial":"地理空间","visUsageAdvanced":"高级分析","visUsageTablesAndSummary":"表和摘要","visUsageSocialInsights":"社交洞察","visUsageOther":"其他"},"__zh-tw":{"visUsageComparison":"比較","visUsageRelationships":"關係","visUsageTrend":"趨勢","visUsagePartsToWhole":"部分至整體","visUsageGeospatial":"地理空間","visUsageAdvanced":"進階分析","visUsageTablesAndSummary":"表格及摘要","visUsageSocialInsights":"Social insights","visUsageOther":"其他"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _caUiToolkit = __webpack_require__(6);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _js = __webpack_require__(64);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(296);

var _VisTypeModel = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * The VisTypePicker component is responsible for requesting/rendering a selection of visTypes grouped by 'usage' (eg: Trend/Comparison)
 * Its
 */
var VisTypePicker = function (_Component) {
	_inherits(VisTypePicker, _Component);

	function VisTypePicker(props) {
		_classCallCheck(this, VisTypePicker);

		//An ordered list of visualization "UsageIds"
		//A usage for a visualization describes what the visualization is used for.
		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.visUsageDisplayOrder = ['Comparison', 'PartsToWhole', 'Trend', 'Relationships', 'TablesAndSummary', 'Advanced', 'SocialInsights', 'Geospatial', 'Other'];

		_this.a11y = new _js.A11YCollections({
			direction: [_js.A11YDirection.UP_DOWN, _js.A11YDirection.LEFT_RIGHT],
			handlers: {
				elements: function elements(element) {
					return _this._getChartItems(element);
				}
			}
		});
		// allow only 1 tap event at a time from mobile browsers
		_this.handleSelectVisType = _underscore2.default.debounce(_this.handleSelectVisType, 2000, true);
		return _this;
	}

	/**
  * Render all usages in the visUsageDisplayOrder
  */


	VisTypePicker.prototype._displayChartTypesByUsage = function _displayChartTypesByUsage() {
		var _this2 = this;

		return this.visUsageDisplayOrder.map(function (visUsageId, idx) {
			var visUsage = _this2.props.model.getChartSpecs(visUsageId);
			if (visUsage) {
				return _react2.default.createElement(
					'div',
					{ className: 'vis-type-picker__usage',
						key: 'usage' + idx,
						'data-usage-id': visUsageId,
						onKeyPress: function onKeyPress(event) {
							return _this2.handleKeyPress(event);
						},
						onKeyDown: function onKeyDown(event) {
							return _this2.handleKeyDown(event);
						} },
					visUsage.usageLabel,
					_react2.default.createElement(
						'div',
						{ className: 'vis-type-picker__usage__list' },
						_this2._addChartListToUsage(visUsage)
					)
				);
			}
		});
	};

	/**
  * process a single usage by rendering the icons and localized name for each chart in the usage.
  * @param visUsage - the usage entry which contains the id and list of charts for that usage (as returned by the visDefinition service API)
  */


	VisTypePicker.prototype._addChartListToUsage = function _addChartListToUsage(visUsage) {
		var _this3 = this;

		return visUsage.chartTypes.map(function (chartType, index) {
			if (_this3.props.isExtVis && _this3.props.isExtVis(chartType.id)) {
				return null;
			}
			var chartTypeLabel = chartType.name;
			var listItemClasses = (0, _classnames2.default)({
				'vis-type-picker__usage__list__item': true,
				'vis-type-picker__usage__list__item--selected': _this3._isSelected(chartType)
			});
			var chartID = chartType.id || 'customVisual';
			var icon = _this3.props.iconsFeature.getIcon(chartID) || {};
			var iconID = icon.id || _this3.props.iconsFeature.getIcon('customVisual').id; //customVisual is the default fall back
			return _react2.default.createElement(
				_caUiToolkit.Tooltip,
				{ key: visUsage.usageId + chartType.id, orient: 'top', title: chartTypeLabel },
				_react2.default.createElement(
					'div',
					{ className: listItemClasses,
						'data-vis-id': chartType.id,
						tabIndex: index === 0 ? '0' : '-1',
						onClick: function onClick(event) {
							return _this3.handleSelectVisType(chartType.id, event);
						} },
					_react2.default.createElement(
						'div',
						{ className: 'vis-type-picker__usage__list__item__icon' },
						_react2.default.createElement(_caUiToolkit.SVGIcon, { intent: 'primary', iconId: iconID, size: 'large' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'vis-type-picker__usage__list__item__title' },
						_react2.default.createElement(_caUiToolkit.Multilinetruncatedtext, { numLines: 2, value: chartTypeLabel, disableTooltip: true, style: { width: 74, justifyContent: 'center' } })
					)
				)
			);
		});
	};

	/*Select the chart item if it matches the passed in SelectedVisID prop*/


	VisTypePicker.prototype._isSelected = function _isSelected(chartType) {
		return chartType && this.props.selectedVisId === chartType.id;
	};

	/**
  * render the visTypePicker control.
  * The render could occur inside a dialog or other div.
  */


	VisTypePicker.prototype.render = function render() {
		var usageJSX = this._displayChartTypesByUsage();
		return _react2.default.createElement(
			'div',
			{ className: 'vis-type-picker', tabIndex: '-1' },
			usageJSX
		);
	};

	VisTypePicker.prototype.handleKeyPress = function handleKeyPress(event) {
		if (event.key === 'Enter') {
			this.handleSelectVisType(this.focusedChartId());
		}
	};

	VisTypePicker.prototype.handleKeyDown = function handleKeyDown(event) {
		this.a11y.onKeyDown(event);
	};

	VisTypePicker.prototype.handleSelectVisType = function handleSelectVisType(id) {
		var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		if ((!event.detail || event.detail === 1) && id) {
			// prevent superfluous click
			this.props.onVisTypeSelected(id);
		}
	};

	VisTypePicker.prototype.focusedChartId = function focusedChartId() {
		var id = document.activeElement.dataset.visId;

		this.handleSelectVisType(id);
	};

	VisTypePicker.prototype._getChartItems = function _getChartItems(element) {
		return (0, _jquery2.default)(element).closest('.vis-type-picker__usage').find('.vis-type-picker__usage__list__item');
	};

	return VisTypePicker;
}(_react.Component);

VisTypePicker.propTypes = {
	model: _PropTypes2.default.stateTree(_VisTypeModel.VisTypeModel).isRequired,
	onVisTypeSelected: _PropTypes2.default.func,
	isVizTypeLocked: _PropTypes2.default.bool, /*True means vis-picker is in auto recommend mode*/
	selectedVisId: _PropTypes2.default.string,
	isExtVis: _PropTypes2.default.func,
	iconsFeature: _PropTypes2.default.object.isRequired
};

exports.default = VisTypePicker;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(297);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./visTypePicker.scss", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./visTypePicker.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018, 2020\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.vis-type-picker {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row wrap;\n      flex-flow: row wrap;\n  overflow-y: auto;\n  padding-top: 32px;\n}\n\n.vis-type-picker__usage {\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  -ms-flex-flow: column;\n      flex-flow: column;\n  margin: 0 16px 24px 16px;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.vis-type-picker__usage__list {\n  margin-top: 8px;\n  -ms-flex-flow: row wrap;\n      flex-flow: row wrap;\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  padding: 16px;\n  box-sizing: border-box;\n}\n\n.vis-type-picker__usage__list__item {\n  -ms-flex-flow: column;\n      flex-flow: column;\n  text-align: center;\n  font-size: 0.875rem;\n  font-weight: 700;\n  width: 90px;\n  height: 104px;\n  padding-bottom: 8px;\n  padding-top: 8px;\n  cursor: pointer;\n}\n\n.vis-type-picker__usage__list__item:hover {\n  background-color: #e5e5e5;\n  background-color: hsla(var(--hover-ui-h, 0), var(--hover-ui-s, 0%), var(--hover-ui-l, 89.80392%), 1);\n}\n\n.vis-type-picker__usage__list__item:active {\n  background-color: #c6c6c6;\n  background-color: hsla(var(--active-ui-h, 0), var(--active-ui-s, 0%), var(--active-ui-l, 77.64706%), 1);\n}\n\n.vis-type-picker__usage__list__item:active {\n  border-color: #a8c0f3;\n  border-color: hsla(var(--focus-h, 220.8), var(--focus-s, 75.75758%), var(--focus-l, 80.58824%), 1);\n}\n\n.vis-type-picker__usage__list__item--selected {\n  background-color: #e0e0e0;\n  background-color: hsla(var(--selected-ui-h, 0), var(--selected-ui-s, 0%), var(--selected-ui-l, 87.84314%), 1);\n}\n\n.vis-type-picker__usage__list__item__icon {\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.vis-type-picker__usage__list__item__icon svg {\n  fill: #161616;\n  fill: hsla(var(--icon-01-h, 0), var(--icon-01-s, 0%), var(--icon-01-l, 8.62745%), 1);\n}\n\n.vis-type-picker__usage__list__item__title {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n\n", ""]);

// exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(299);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./visTypeChooser.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./visTypeChooser.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore__animation--fade-appear,\n.explore__animation--fade-enter {\n  opacity: 0.1;\n}\n\n.explore__animation--fade-appear-active,\n.explore__animation--fade-enter-active {\n  opacity: 1;\n  transition: opacity 300ms ease-in;\n}\n\n.explore__animation--fade-exit {\n  opacity: 1;\n  transform: scale(1, 1);\n}\n\n.explore__animation--fade-exit-active {\n  opacity: 0.1;\n  transition: opacity 300ms ease-out;\n}\n\n.explore__animation--slideDown-appear,\n.explore__animation--slideDown-enter {\n  opacity: 0.1;\n  transform: translateY(-100%);\n}\n\n.explore__animation--slideDown-appear-active,\n.explore__animation--slideDown-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n}\n\n.explore__animation--slideDown-exit {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.explore__animation--slideDown-exit-active {\n  opacity: 0.1;\n  transform: translateY(-100%);\n  transition: opacity 300ms ease-out, transform 300ms ease-out;\n}\n\n.explore__animation--slideUp-appear,\n.explore__animation--slideUp-enter {\n  opacity: 0.1;\n  transform: translateY(100%);\n}\n\n.explore__animation--slideUp-appear-active,\n.explore__animation--slideUp-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n}\n\n.explore__animation--slideUp-exit {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.explore__animation--slideUp-exit-active {\n  opacity: 0.1;\n  transform: translateY(100%);\n  transition: opacity 300ms ease-out, transform 300ms ease-out;\n}\n\n.explore__animation--slideLeft-appear,\n.explore__animation--slideLeft-enter {\n  opacity: 0.1;\n  transform: translateX(100%);\n}\n\n.explore__animation--slideLeft-appear-active,\n.explore__animation--slideLeft-enter-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n}\n\n.explore__animation--slideLeft-exit {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.explore__animation--slideLeft-exit-active {\n  opacity: 0.1;\n  transform: translateX(100%);\n  transition: opacity 300ms ease-out, transform 300ms ease-out;\n}\n\n.vis-recommender-explore {\n  -ms-flex-direction: column;\n      flex-direction: column;\n  min-height: 100%;\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-background-h, 0), var(--ui-background-s, 0%), var(--ui-background-l, 95.68627%), 1);\n}\n\n.vis-recommender-explore__header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 24px 64px;\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n}\n\n.vis-recommender-explore__header__title {\n  -ms-flex: 1;\n      flex: 1;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #393939;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 22.35294%), 1);\n}\n\n.vis-recommender-explore__header__close-button button {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n}\n\n.vis-recommender-explore__header__close-button button:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.vis-recommender-explore__header__close-button button:hover,\n.vis-recommender-explore__header__close-button button:focus {\n  opacity: 1;\n}\n\n.vis-recommender-explore__title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #393939;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 22.35294%), 1);\n  padding: 32px 16px 16px 16px;\n}\n\n.vis-recommender-explore__content {\n  padding: 0 16px;\n}\n\n.vis-recommender-explore__vis-recommendation-view {\n  margin-left: 64px;\n  margin-right: 64px;\n}\n\n.vis-recommender-explore__vis-type-picker {\n  position: relative;\n  -ms-flex: 1;\n      flex: 1;\n  padding-bottom: 8px;\n}\n\n.vis-recommender-explore__vis-recommender-picker {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding-bottom: 96px;\n}\n\n", ""]);

// exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Slideout = __webpack_require__(54);

var _Slideout2 = _interopRequireDefault(_Slideout);

var _SlideoutContent = __webpack_require__(55);

var _SlideoutContent2 = _interopRequireDefault(_SlideoutContent);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _CustomComparison = __webpack_require__(301);

var _CustomComparison2 = _interopRequireDefault(_CustomComparison);

var _ComparisonRecommendations = __webpack_require__(304);

var _ComparisonRecommendations2 = _interopRequireDefault(_ComparisonRecommendations);

__webpack_require__(307);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var CLASS_NAME = 'explore-slideout-compareChooser';

var CompareChooser_Slideout = function (_Component) {
	_inherits(CompareChooser_Slideout, _Component);

	function CompareChooser_Slideout() {
		_classCallCheck(this, CompareChooser_Slideout);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	CompareChooser_Slideout.prototype.render = function render() {
		var _props = this.props,
		    active = _props.active,
		    onClose = _props.onClose;


		return _react2.default.createElement(
			_Slideout2.default,
			{
				active: active,
				className: 'explore__animation--slideDown',
				fullHeight: true,
				onClickOutside: onClose
			},
			_react2.default.createElement(
				_SlideoutContent2.default,
				{
					title: _StringResources2.default.get('compareChooser_title'),
					subTitle: _StringResources2.default.get('compareChooser_subTitle'),
					onClose: onClose,
					className: CLASS_NAME
				},
				_react2.default.createElement(_CustomComparison2.default, {
					recommendationVM: this.props.customRecommendationVM,
					dashboardApi: this.props.dashboardApi,
					logger: this.props.logger,
					onItemSelected: this.props.onItemSelected,
					onItemAdded: this.props.onItemAdded
				}),
				_react2.default.createElement(_ComparisonRecommendations2.default, {
					recommendationVM: this.props.smartsRecommendationVM,
					dashboardApi: this.props.dashboardApi,
					logger: this.props.logger,
					onItemSelected: this.props.onItemSelected,
					onItemAdded: this.props.onItemAdded
				})
			)
		);
	};

	return CompareChooser_Slideout;
}(_react.Component);

CompareChooser_Slideout.propTypes = {
	active: _PropTypes2.default.bool,
	onClose: _PropTypes2.default.func,
	dashboardApi: _PropTypes2.default.object.isRequired,
	logger: _PropTypes2.default.object.isRequired,
	customRecommendationVM: _PropTypes2.default.object.isRequired,
	smartsRecommendationVM: _PropTypes2.default.object.isRequired,
	selectedWidgetModel: _PropTypes2.default.object.isRequired,
	onItemSelected: _PropTypes2.default.func.isRequired,
	onItemAdded: _PropTypes2.default.func
};

CompareChooser_Slideout.defaultProps = {
	active: false,
	onClose: function onClose() {}
};

exports.default = CompareChooser_Slideout;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _RECOMMENDATION_PROPERTIES = __webpack_require__(40);

var _RECOMMENDATION_PROPERTIES2 = _interopRequireDefault(_RECOMMENDATION_PROPERTIES);

var _VisualizationPreviewList = __webpack_require__(29);

var _VisualizationPreviewList2 = _interopRequireDefault(_VisualizationPreviewList);

var _caUiToolkit = __webpack_require__(6);

__webpack_require__(302);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var CLASS_NAME = 'custom-comparison';

var CustomComparison = function (_Component) {
	_inherits(CustomComparison, _Component);

	function CustomComparison() {
		var _temp, _this, _ret;

		_classCallCheck(this, CustomComparison);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._onClickItem = function (item) {
			_this.props.onItemSelected(item);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	CustomComparison.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			{ className: CLASS_NAME },
			_react2.default.createElement(
				'div',
				{ className: CLASS_NAME + '__title' },
				_StringResources2.default.get('compareChooser_customComparison_title')
			),
			_react2.default.createElement(
				'div',
				{ className: CLASS_NAME + '__content' },
				_react2.default.createElement(
					'div',
					{ className: CLASS_NAME + '__common' },
					_react2.default.createElement(
						'div',
						{ className: CLASS_NAME + '__preview-list--horizontal' },
						this.renderContent()
					)
				)
			)
		);
	};

	CustomComparison.prototype.renderContent = function renderContent() {
		var recommendationVM = this.props.recommendationVM;

		switch (recommendationVM.state) {
			case 'pending':
				return _react2.default.createElement(
					'div',
					{ className: CLASS_NAME + '__progress-indicator__container' },
					_react2.default.createElement(_caUiToolkit.ProgressIndicator, null)
				);
			case 'done':
				return this.renderList();
			case 'error':
				return _react2.default.createElement(
					'div',
					{ className: CLASS_NAME + '__error__container' },
					_StringResources2.default.get('error_cannot_load_recommended')
				);
		}
	};

	CustomComparison.prototype.renderList = function renderList() {
		var recommendationVM = this.props.recommendationVM;

		var isNewLayoutEnabled = true;
		return _react2.default.createElement(_VisualizationPreviewList2.default, {
			items: recommendationVM.getRecommendations(),
			dashboardApi: this.props.dashboardApi,
			onClickItem: this._onClickItem,
			onAddItem: this.props.onItemAdded,
			additionalProperties: _RECOMMENDATION_PROPERTIES2.default,
			logger: this.props.logger,
			isNewLayoutEnabled: isNewLayoutEnabled,
			horizontal: true,
			noBottomTitle: true,
			itemSize: 'medium'
		});
	};

	return CustomComparison;
}(_react.Component);

CustomComparison.propTypes = {
	dashboardApi: _PropTypes2.default.object.isRequired,
	logger: _PropTypes2.default.object.isRequired,
	recommendationVM: _PropTypes2.default.object.isRequired,
	onItemSelected: _PropTypes2.default.func,
	onItemAdded: _PropTypes2.default.func
};
CustomComparison.defaultProps = {
	onItemSelected: function onItemSelected() {}
};

exports.default = CustomComparison;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(303);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./CustomComparison.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./CustomComparison.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2019\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.custom-comparison {\n  min-height: 180px;\n  padding: 32px 0 16px 0;\n}\n\n", ""]);

// exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _caUiToolkit = __webpack_require__(6);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _RECOMMENDATION_PROPERTIES = __webpack_require__(40);

var _RECOMMENDATION_PROPERTIES2 = _interopRequireDefault(_RECOMMENDATION_PROPERTIES);

var _VisualizationPreviewList = __webpack_require__(29);

var _VisualizationPreviewList2 = _interopRequireDefault(_VisualizationPreviewList);

var _UnescapedString = __webpack_require__(53);

var _UnescapedString2 = _interopRequireDefault(_UnescapedString);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

__webpack_require__(305);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CLASS_NAME = 'recommended-comparison';

var ComparisonRecommendations = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(ComparisonRecommendations, _Component);

	function ComparisonRecommendations() {
		var _temp, _this, _ret;

		_classCallCheck(this, ComparisonRecommendations);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._onClickItem = function (item) {
			_this.props.onItemSelected(item);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	ComparisonRecommendations.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			{ className: CLASS_NAME },
			_react2.default.createElement(
				'div',
				{ className: CLASS_NAME + '__title' },
				_StringResources2.default.get('compareChooser_recommendedComparison_title')
			),
			_react2.default.createElement(
				'div',
				{ className: CLASS_NAME + '__content' },
				_react2.default.createElement(
					'div',
					{ className: CLASS_NAME + '__common' },
					this.renderContent()
				)
			)
		);
	};

	ComparisonRecommendations.prototype.renderContent = function renderContent() {
		var recommendationVM = this.props.recommendationVM;

		switch (recommendationVM.state) {
			case 'pending':
				return _react2.default.createElement(
					'div',
					{ className: CLASS_NAME + '__progress-indicator__container' },
					_react2.default.createElement(_caUiToolkit.ProgressIndicator, null)
				);
			case 'done':
				return this.renderSections();
			case 'error':
				return _react2.default.createElement(
					'div',
					{ className: CLASS_NAME + '__error__container' },
					_StringResources2.default.get('error_cannot_load_recommended')
				);
		}
	};

	ComparisonRecommendations.prototype.renderSections = function renderSections() {
		var _this2 = this;

		var recommendationVM = this.props.recommendationVM;

		var recommendations = recommendationVM.getRecommendations();

		var allSectionsEmpty = recommendations.every(function (recommendation) {
			return recommendation.items.length === 0;
		});
		if (allSectionsEmpty) {
			return this.renderEmptyMessage();
		}

		return _react2.default.createElement(
			_react.Fragment,
			null,
			recommendations.map(function (recommendation, index) {
				var items = recommendation.items,
				    section = recommendation.section;

				if (items.length > 0) {
					return _this2.renderSection(index, section, items);
				}
			})
		);
	};

	ComparisonRecommendations.prototype.renderEmptyMessage = function renderEmptyMessage() {
		return _react2.default.createElement(
			'div',
			{ className: CLASS_NAME + '__empty__list' },
			_StringResources2.default.get('compareChooser_recommenations_no_recommendations_found')
		);
	};

	ComparisonRecommendations.prototype.renderSection = function renderSection(index, section, items) {

		var headerText = _underscore2.default.escape(section.headerText(items));

		return _react2.default.createElement(
			'div',
			{ key: index, className: CLASS_NAME + '__section' },
			_react2.default.createElement(
				'div',
				{ className: CLASS_NAME + '__section__header__container' },
				_react2.default.createElement(
					'div',
					null,
					_StringResources2.default.get('compareChooser_recommendations_headers_columnRelated')
				),
				_react2.default.createElement(
					_UnescapedString2.default,
					null,
					_react2.default.createElement(
						'div',
						{ className: CLASS_NAME + '__section__header__container__column' },
						headerText
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: CLASS_NAME + '__section__body' },
				this.renderList(items)
			)
		);
	};

	ComparisonRecommendations.prototype.renderList = function renderList(items) {
		var isNewLayoutEnabled = true;

		return _react2.default.createElement(
			'div',
			{ className: CLASS_NAME + '__preview-list--horizontal' },
			_react2.default.createElement(_VisualizationPreviewList2.default, {
				items: items,
				dashboardApi: this.props.dashboardApi,
				onClickItem: this._onClickItem,
				onAddItem: this.props.onItemAdded,
				additionalProperties: _RECOMMENDATION_PROPERTIES2.default,
				logger: this.props.logger,
				isNewLayoutEnabled: isNewLayoutEnabled,
				horizontal: true,
				noBottomTitle: true,
				enableSeeMore: false,
				itemSize: 'medium',
				hasFocus: false
			})
		);
	};

	return ComparisonRecommendations;
}(_react.Component)) || _class;

ComparisonRecommendations.propTypes = {
	dashboardApi: _PropTypes2.default.object.isRequired,
	logger: _PropTypes2.default.object.isRequired,
	recommendationVM: _PropTypes2.default.object.isRequired,
	onItemSelected: _PropTypes2.default.func.isRequired,
	onItemAdded: _PropTypes2.default.func
};
ComparisonRecommendations.defaultProps = {};

exports.default = ComparisonRecommendations;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(306);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./ComparisonRecommendations.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./ComparisonRecommendations.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2019\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.recommended-comparison {\n  min-height: 180px;\n  padding-bottom: 16px;\n}\n\n.recommended-comparison__section__header__container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  padding: 16px 0 8px 8px;\n}\n\n.recommended-comparison__section__header__container__column {\n  padding-left: 3px;\n  font-weight: bold;\n}\n\n", ""]);

// exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(308);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./index.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2019\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore-slideout-compareChooser {\n  background: none;\n}\n\n.explore-slideout-compareChooser .explore-slideout-content__header {\n  padding: 0 0 16px 0;\n  margin: 48px 48px 0 48px;\n}\n\n.explore-slideout-compareChooser .explore-slideout-content__header__section__title {\n  font-size: 28px;\n  font-weight: 250;\n}\n\n.explore-slideout-compareChooser .explore-slideout-content__content {\n  border-top: none;\n}\n\n.explore-slideout-compareChooser .explore-slideout-content__content .vis-recommender__preview {\n  border: 1px solid #eaeaea;\n}\n\n.explore-slideout-compareChooser .explore-slideout-content__content .vis-recommender__preview-list__see-more--hidden {\n  display: none;\n}\n\n.explore-slideout-compareChooser .custom-comparison__title,\n.explore-slideout-compareChooser .recommended-comparison__title {\n  font-size: 1.1rem;\n  font-weight: 300;\n}\n\n.explore-slideout-compareChooser .custom-comparison__content,\n.explore-slideout-compareChooser .recommended-comparison__content {\n  margin-top: 8px;\n}\n\n.explore-slideout-compareChooser .custom-comparison__common,\n.explore-slideout-compareChooser .recommended-comparison__common {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding: 8px 0;\n}\n\n.explore-slideout-compareChooser .custom-comparison__common__header,\n.explore-slideout-compareChooser .recommended-comparison__common__header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 24px 64px;\n}\n\n.explore-slideout-compareChooser .custom-comparison__common__header__title,\n.explore-slideout-compareChooser .recommended-comparison__common__header__title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #343334;\n}\n\n.explore-slideout-compareChooser .custom-comparison__preview-list--horizontal,\n.explore-slideout-compareChooser .recommended-comparison__preview-list--horizontal {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n", ""]);

// exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RecommendedCommon = __webpack_require__(92);

var _RecommendedCommon2 = _interopRequireDefault(_RecommendedCommon);

__webpack_require__(310);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var RelatedInsights = function (_Component) {
	_inherits(RelatedInsights, _Component);

	function RelatedInsights(props) {
		_classCallCheck(this, RelatedInsights);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	RelatedInsights.prototype.render = function render() {
		return _react2.default.createElement(_RecommendedCommon2.default, _extends({}, this.props, {
			className: 'vis-related-insights',
			enableSeeMore: true,
			maxDisplayedItems: 3,
			logger: this.props.logger
		}));
	};

	return RelatedInsights;
}(_react.Component);

RelatedInsights.propTypes = {
	dashboardApi: _propTypes2.default.object.isRequired,
	onClickItem: _propTypes2.default.func,
	recommendationVM: _propTypes2.default.object.isRequired,
	additionalProperties: _propTypes2.default.arrayOf(_propTypes2.default.object),
	logger: _propTypes2.default.object
};
RelatedInsights.defaultProps = {
	onClickItem: function onClickItem() {},
	additionalProperties: []
};
exports.default = RelatedInsights;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(311);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./relatedInsights.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./relatedInsights.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.vis-related-insights {\n  min-height: 180px;\n  padding: 32px 16px 16px 16px;\n}\n\n", ""]);

// exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _DnDHandler2 = __webpack_require__(86);

var _DnDHandler3 = _interopRequireDefault(_DnDHandler2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var ExploreContainerDnDHandler = function (_DnDHandler) {
	_inherits(ExploreContainerDnDHandler, _DnDHandler);

	function ExploreContainerDnDHandler(options) {
		_classCallCheck(this, ExploreContainerDnDHandler);

		var _this = _possibleConstructorReturn(this, _DnDHandler.call(this, options));

		_this.dashboardApi = options.dashboardApi;
		_this.addFragment = options.addFragment;
		_this.fragmentParentId = options.fragmentParentId;
		_this.exploreVM = options.exploreVM;
		_this.glassContext = options.glassContext;
		return _this;
	}

	ExploreContainerDnDHandler.prototype.accepts = function accepts(dragObject) {
		if (this.isPinObject(dragObject)) {
			var liveWidgets = this.getPinWidgets(dragObject);

			//When the dragged pin has only one vis and it is showing marketing page (i.e. showing startingpoints
			//and no active source selected yet), accepts and does adding a new card for the pinned vis
			if (liveWidgets.length === 1 && this.exploreVM.isStartingPointsDisplayed() && !this.exploreVM.activeDataSourceModule) {
				return true;
			}

			return liveWidgets.length > 1;
		}
		return false;
	};

	ExploreContainerDnDHandler.prototype.onDrop = function onDrop(dragObject) {
		var _this2 = this;

		return this.getSpecfromPin(dragObject, this.dashboardApi).then(function (spec) {
			return _this2._addFragment(spec);
		});
	};

	ExploreContainerDnDHandler.prototype._addFragment = function _addFragment(spec) {
		var payloadData = {
			undoRedoTransactionId: _underscore2.default.uniqueId('exploreContainerDnDHandler')
		};
		var options = {
			insertBefore: null,
			parentId: this.fragmentParentId,
			model: spec
		};
		return this.addFragment(options, 'exploreContainerDnDHandler', payloadData);
	};

	return ExploreContainerDnDHandler;
}(_DnDHandler3.default);

exports.default = ExploreContainerDnDHandler;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _caUiToolkit = __webpack_require__(6);

var _upload_ = __webpack_require__(314);

var _upload_2 = _interopRequireDefault(_upload_);

var _Empty = __webpack_require__(18);

var _Empty2 = _interopRequireDefault(_Empty);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var EmptyExploreContainer = function (_Component) {
	_inherits(EmptyExploreContainer, _Component);

	function EmptyExploreContainer() {
		_classCallCheck(this, EmptyExploreContainer);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	EmptyExploreContainer.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			{ className: 'explore-empty-container-dnd' },
			_react2.default.createElement(_Empty2.default, {
				icon: _react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _upload_2.default.id, width: 32, height: 32 }),
				title: _StringResources2.default.get('dnd_create_cards')
			})
		);
	};

	return EmptyExploreContainer;
}(_react.Component);

exports.default = EmptyExploreContainer;

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "upload_32",
  "use": "upload_32-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"upload_32\"><path d=\"M6 17l1.41 1.41L15 10.83V30h2V10.83l7.59 7.58L26 17 16 7 6 17z\" /><path d=\"M6 8V4h20v4h2V4a2 2 0 00-2-2H6a2 2 0 00-2 2v4z\" /><path style=\"fill:none\" d=\"M0 0h32v32H0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2020
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(5);

var _caUiToolkit = __webpack_require__(6);

var _openPanelFilledRight_ = __webpack_require__(316);

var _openPanelFilledRight_2 = _interopRequireDefault(_openPanelFilledRight_);

var _compare_ = __webpack_require__(317);

var _compare_2 = _interopRequireDefault(_compare_);

var _relatedVisualization_ = __webpack_require__(318);

var _relatedVisualization_2 = _interopRequireDefault(_relatedVisualization_);

var _referenceLine_ = __webpack_require__(319);

var _referenceLine_2 = _interopRequireDefault(_referenceLine_);

var _FilterDock = __webpack_require__(320);

var _FilterDock2 = _interopRequireDefault(_FilterDock);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _ExploreCompareOptions = __webpack_require__(335);

var _ExploreCompareOptions2 = _interopRequireDefault(_ExploreCompareOptions);

var _AddNewCardToolbarItem = __webpack_require__(336);

var _AddNewCardToolbarItem2 = _interopRequireDefault(_AddNewCardToolbarItem);

var _Navigation = __webpack_require__(339);

var _Navigation2 = _interopRequireDefault(_Navigation);

var _Toolbar = __webpack_require__(342);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _ToolbarSection = __webpack_require__(345);

var _ToolbarSection2 = _interopRequireDefault(_ToolbarSection);

var _items = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExploreContainerToolbar = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(ExploreContainerToolbar, _Component);

	function ExploreContainerToolbar(props) {
		_classCallCheck(this, ExploreContainerToolbar);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.onCompareButtonClick = function () {
			if (_this.props.exploreVM.isNewCompareCardRecommendationsEnabled()) {
				_this._onCompareButtonClick_newBehaviour();
			} else {
				_this._onCompareButtonClick_oldBehaviour();
			}
		};

		_this.state = {
			toolbarSize: undefined
		};
		return _this;
	}

	ExploreContainerToolbar.prototype.render = function render() {
		var _this2 = this;

		var _props = this.props,
		    exploreVM = _props.exploreVM,
		    dashboardApi = _props.dashboardApi;


		var toolbarIsHidden = exploreVM.toolbar.getIsHidden();
		if (toolbarIsHidden) {
			return null;
		}

		var selectedCardIds = exploreVM.selectedCards.items;
		var selectedCards = selectedCardIds.map(function (id) {
			return _this2._getCard(id);
		});
		var isRelatedVizToolbarItemEnabled = exploreVM.isRelatedVizToolbarItemEnabled();

		var cardActionSpec = exploreVM.toolbar.getCardActions(selectedCards);
		var widgets = exploreVM.selectedWidgets;
		var visTypeLabel = '';
		var visTypes = [];

		widgets && widgets.forEach(function (widget) {
			var visId = widget && widget.getVisId && widget.getVisId();
			var visType = visId && _this2._getVisType(visId);
			if (visType) {
				visTypeLabel = visType.getLabel();
				visTypes.push(visType);
			}
		}, this);
		var isRecommendedHidden = visTypes.length != 1;
		var widgetActionSpec = visTypes.length >= 1 ? exploreVM.toolbar.getWidgetActions() : [];

		var navigationButtons = this.renderNavigationButtons();
		var compareButton = this.renderCompareButton();
		var cardActions = this._renderActions(cardActionSpec);
		var widgetActions = this._renderActions(widgetActionSpec);
		var actionSeparator = cardActionSpec.length && widgetActionSpec.length ? _react2.default.createElement(_caUiToolkit.Separator, { className: 'explore-vis-toolbar__separator', orientation: 'vertical' }) : null;
		var items = this.getItems(exploreVM.toolbar.getItems());

		var compareModel = this._getCompareModelOnSelectedCard();
		var filterDockModel = this._getFilterDockModelOnSelectedCard();
		var showFilterDock = filterDockModel && this._showFilterDock();

		var filterDock = null;
		if (showFilterDock) {
			filterDock = _react2.default.createElement(_FilterDock2.default, {
				filterDockModel: filterDockModel,
				dashboardApi: dashboardApi
			});
		}

		var compareTooltipTitle = void 0;
		if (compareModel && compareModel.showStats) {
			compareTooltipTitle = _StringResources2.default.get('exploreToolbar_hide_compare');
		} else {
			compareTooltipTitle = _StringResources2.default.get('exploreToolbar_show_compare');
		}

		var refLineTooltipMessage = void 0;
		if (compareModel && compareModel.isCompareLineShown()) {
			refLineTooltipMessage = _StringResources2.default.get('exploreToolbar_hide_refLine');
		} else {
			refLineTooltipMessage = _StringResources2.default.get('exploreToolbar_show_refLine');
		}

		var tooltipMessage = void 0;
		if (exploreVM.showCanvasSidePanel) {
			tooltipMessage = _StringResources2.default.get('exploreToolbar_hide_fields');
		} else {
			tooltipMessage = _StringResources2.default.get('exploreToolbar_show_fields');
		}

		return _react2.default.createElement(
			_Toolbar2.default,
			{ onResize: function onResize(toolbarSize) {
					return _this2.setState({ toolbarSize: toolbarSize });
				} },
			_react2.default.createElement(
				_ToolbarSection2.default,
				{ align: 'left' },
				_react2.default.createElement(_AddNewCardToolbarItem2.default, {
					onAddCard: function onAddCard() {
						var _props2;

						return (_props2 = _this2.props).onAddCard.apply(_props2, arguments);
					},
					exploreVM: exploreVM
				}),
				navigationButtons,
				_react2.default.createElement(_items.CaretToolbarItem, {
					icon: _react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: 'visualizations-changeVisualization' }),
					label: visTypeLabel,
					title: visTypeLabel,
					hidden: isRecommendedHidden,
					selected: exploreVM.showModalVisTypePicker,
					onPrimaryAction: this._handleShowVisTypesClick.bind(this),
					size: this.state.toolbarSize,
					id: 'changeVisType'
				}),
				_react2.default.createElement(_items.CaretToolbarItem, {
					iconId: _relatedVisualization_2.default.id,
					label: _StringResources2.default.get('exploreToolbar_related'),
					title: _StringResources2.default.get('exploreToolbar_related'),
					hidden: !isRelatedVizToolbarItemEnabled || isRecommendedHidden,
					selected: exploreVM.showModalRelatedVisPicker,
					onPrimaryAction: this._handleShowRelatedVisClick.bind(this),
					size: this.state.toolbarSize,
					id: 'relatedVis'
				}),
				compareButton,
				widgetActions,
				actionSeparator,
				cardActions
			),
			_react2.default.createElement(
				_ToolbarSection2.default,
				{ align: 'right' },
				_react2.default.createElement(_items.ToolbarItem, {
					iconId: _referenceLine_2.default.id,
					hidden: !compareModel,
					title: refLineTooltipMessage,
					enabled: !!compareModel && compareModel.isCompareLineEnabled(),
					selected: !!compareModel && compareModel.isCompareLineShown(),
					onPrimaryAction: function onPrimaryAction() {
						return _this2.onCompareCrosshairClick();
					}
				}),
				_react2.default.createElement(_items.ToolbarItem, {
					iconId: _compare_2.default.id,
					hidden: !compareModel,
					title: compareTooltipTitle,
					enabled: !!compareModel && compareModel.isCompareTableEnabled(),
					selected: !!compareModel && compareModel.showStats,
					onPrimaryAction: function onPrimaryAction() {
						return _this2.onCompareStatsClick();
					}
				}),
				filterDock,
				compareModel && _react2.default.createElement(_ExploreCompareOptions2.default, {
					model: compareModel,
					enabled: !!compareModel && compareModel.isSyncMenuEnabled(),
					hidden: !compareModel
				}),
				_react2.default.createElement(_items.ToolbarItem, {
					iconId: _openPanelFilledRight_2.default.id,
					title: tooltipMessage,
					className: 'showHideDetailsSlots',
					hidden: exploreVM.isStartingPointsDisplayed(),
					selected: exploreVM.showCanvasSidePanel,
					onPrimaryAction: this._handleShowCanvasSidePanelClick.bind(this)
				})
			),
			_react2.default.createElement(
				_ToolbarSection2.default,
				{ align: 'extright' },
				items
			)
		);
	};

	ExploreContainerToolbar.prototype._getCompareModelOnSelectedCard = function _getCompareModelOnSelectedCard() {
		var selectedCardId = this._getSelectedCard();
		return (this._getCompareCard(selectedCardId) || {}).compareModel;
	};

	ExploreContainerToolbar.prototype._getFilterDockModelOnSelectedCard = function _getFilterDockModelOnSelectedCard() {
		var selectedCardId = this._getSelectedCard();
		return (this._getCompareCard(selectedCardId) || this._getStartingPointsModel() || {}).filterDockModel;
	};

	ExploreContainerToolbar.prototype._showFilterDock = function _showFilterDock() {
		var selectedCardId = this._getSelectedCard();

		var _ref = this._getCompareCard(selectedCardId) || this._getStartingPointsModel() || {},
		    showFilterDock = _ref.showFilterDock;

		return !showFilterDock || showFilterDock();
	};

	ExploreContainerToolbar.prototype._getCompareCard = function _getCompareCard(id) {
		if (id) {
			var item = this._getCard(id);
			if (item && item.subType === 'compare') {
				return item;
			}
		}
	};

	ExploreContainerToolbar.prototype._getStartingPointsModel = function _getStartingPointsModel() {
		if (this.props.exploreVM.isStartingPointsDisplayed() && this.props.exploreVM.isFilterStartingPointsEnabled()) {
			return this.props.boardModel.layout.startingPointsModel;
		}
	};

	ExploreContainerToolbar.prototype._getCard = function _getCard(id) {
		return id && this.props.boardModel.layout.findModel(id);
	};

	ExploreContainerToolbar.prototype._getSelectedCard = function _getSelectedCard() {
		var exploreVM = this.props.exploreVM;
		return !exploreVM.isStartingPointsDisplayed() ? exploreVM.getDisplayedCard() : undefined;
	};

	ExploreContainerToolbar.prototype.onCompareCrosshairClick = function onCompareCrosshairClick() {
		var compareModel = this._getCompareModelOnSelectedCard();
		if (compareModel) {
			compareModel.toggleShowCompareLine();
		}
	};

	ExploreContainerToolbar.prototype.onCompareStatsClick = function onCompareStatsClick() {
		var compareModel = this._getCompareModelOnSelectedCard();
		if (compareModel) {
			compareModel.setShowStats(!compareModel.showStats);
		}
	};

	ExploreContainerToolbar.prototype.onCompareOptionsClick = function onCompareOptionsClick() {
		this.props.exploreVM.toolbar.toggleCompareOptionsContextMenu();
	};

	ExploreContainerToolbar.prototype._onCompareButtonClick_newBehaviour = function _onCompareButtonClick_newBehaviour() {
		this.props.exploreVM.setShowCompareSlideout(!this.props.exploreVM.showCompareSlideout);
	};

	ExploreContainerToolbar.prototype._onCompareButtonClick_oldBehaviour = function _onCompareButtonClick_oldBehaviour() {
		var _this3 = this;

		var id = this._getSelectedCard();
		if (id) {
			var card = this._getCard(id);
			var newCompareCardId = this.props.exploreVM.layoutModel.addCompareCardFromExisting(card, card);
			if (newCompareCardId) {
				this.props.exploreVM.setDisplayedToCard(newCompareCardId);
				var _card = this.props.exploreVM.layoutModel.findModel(newCompareCardId);
				if (_card && _card.items.length === 2) {
					var widget = _card.items[1];
					// We need to explicilty select the widget and slots tab of the compare card
					// when widget becomes visible because by default compare card will deselect all widgets;
					this.props.exploreVM.setItemInCardToSelectWhenVisible({ widgetId: widget.id, tabId: 'slots' });
					var dashboardApi = this.props.dashboardApi;

					if (dashboardApi) {
						dashboardApi.getCanvasWhenReady().then(function (canvasApi) {
							return canvasApi.getWidgetsWhenRendered(_card.items.map(function (item) {
								return item.id;
							}));
						}).then(function () {
							return _this3.props.exploreVM.selectItemInCardWhenVisible();
						});
					}
				}
				// should never come here;
			}
		}
	};

	ExploreContainerToolbar.prototype.renderNavigationButtons = function renderNavigationButtons() {
		var exploreVM = this.props.exploreVM;

		var currentCardIndex = exploreVM.displayedCardIndex;
		var numberOfCards = exploreVM.numberOfCards;

		if (currentCardIndex < 0 || numberOfCards <= 0) {
			return;
		}

		return _react2.default.createElement(
			_items.CustomToolbarItem,
			null,
			_react2.default.createElement(_Navigation2.default, {
				index: currentCardIndex,
				count: numberOfCards,
				onNavigatePrevious: this._handleNavigatePrevious.bind(this),
				onNavigateNext: this._handleNavigateNext.bind(this)
			})
		);
	};

	ExploreContainerToolbar.prototype.renderCompareButton = function renderCompareButton() {
		if (!this._isMappingComplete() || this.props.exploreVM.isCompare()) {
			return;
		}

		return _react2.default.createElement(_items.ToolbarItem, {
			selected: false,
			label: _StringResources2.default.get('exploreToolbar_compare'),
			title: _StringResources2.default.get('exploreToolbar_compare_tooltip'),
			onPrimaryAction: this.onCompareButtonClick
		});
	};

	ExploreContainerToolbar.prototype.getItems = function getItems(items) {
		if (items) {
			return items.map(function (item, index) {
				var component = item.component,
				    _item$data = item.data,
				    data = _item$data === undefined ? {} : _item$data;

				return _react2.default.createElement(
					_items.CustomToolbarItem,
					{ key: index, id: data.id },
					component
				);
			});
		}
	};

	ExploreContainerToolbar.prototype._isMappingComplete = function _isMappingComplete() {
		var exploreVM = this.props.exploreVM;

		return exploreVM.isSelectedWidgetMappingComplete();
	};

	ExploreContainerToolbar.prototype._renderActions = function _renderActions(actions) {
		var _this4 = this;

		if (actions) {
			return actions.map(function (action, key) {
				var icon = _this4._renderIcon(action.icon);

				return _react2.default.createElement(_items.ToolbarItem, {
					key: key,
					icon: icon,
					title: action.label,
					className: action.className,
					onPrimaryAction: function onPrimaryAction(event) {
						return _this4._onPrimaryAction(action, event);
					}
				});
			});
		}
	};

	ExploreContainerToolbar.prototype._renderIcon = function _renderIcon(id) {
		return _react2.default.createElement(
			'svg',
			{ style: { width: '16px' }, className: 'ba-common-svgIcon is-normal', role: 'img', focusable: false },
			_react2.default.createElement('use', { xmlnsXlink: 'http://www.w3.org/1999/xlink', xlinkHref: '#' + id })
		);
	};

	ExploreContainerToolbar.prototype._getVisType = function _getVisType(visId) {
		var vis = this.props.exploreVM.visTypes && this.props.exploreVM.visTypes.filter(function (vis) {
			return vis.getId() === visId;
		});
		return vis ? vis[0] : null;
	};

	ExploreContainerToolbar.prototype._handleNavigatePrevious = function _handleNavigatePrevious() {
		this.props.exploreVM.navigatePreviousCard();
	};

	ExploreContainerToolbar.prototype._handleNavigateNext = function _handleNavigateNext() {
		this.props.exploreVM.navigateNextCard();
	};

	ExploreContainerToolbar.prototype._handleShowVisTypesClick = function _handleShowVisTypesClick() {
		this.props.exploreVM.setShowModalVisTypePicker(!this.props.exploreVM.showModalVisTypePicker);
	};

	ExploreContainerToolbar.prototype._handleShowRelatedVisClick = function _handleShowRelatedVisClick() {
		this.props.exploreVM.setShowModalRelatedVisPicker(!this.props.exploreVM.showModalRelatedVisPicker);
	};

	ExploreContainerToolbar.prototype._handleShowCanvasSidePanelClick = function _handleShowCanvasSidePanelClick() {
		this.props.exploreVM.toggleCanvasSidePanel();
	};

	ExploreContainerToolbar.prototype._onPrimaryAction = function _onPrimaryAction(_ref2, event) {
		var action = _ref2.action;

		if (action) {
			action(event);
		}
	};

	return ExploreContainerToolbar;
}(_react.Component)) || _class;

ExploreContainerToolbar.propTypes = {
	exploreVM: _propTypes2.default.object.isRequired,
	boardModel: _propTypes2.default.object.isRequired,
	dashboardApi: _propTypes2.default.object.isRequired,
	onAddCard: _propTypes2.default.func.isRequired
};

exports.default = ExploreContainerToolbar;

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "open-panel--filled--right_32",
  "use": "open-panel--filled--right_32-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"open-panel--filled--right_32\"><path d=\"M28 4H4a2 2 0 00-2 2v20a2 2 0 002 2h24a2 2 0 002-2V6a2 2 0 00-2-2zM4 6h16v20H4z\" /><path style=\"fill:none\" d=\"M0 0h32v32H0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "compare_32",
  "use": "compare_32-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"compare_32\"><path d=\"M28 6H18V4a2 2 0 00-2-2H4a2 2 0 00-2 2v20a2 2 0 002 2h10v2a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2zM4 15h6.17l-2.58 2.59L9 19l5-5-5-5-1.41 1.41L10.17 13H4V4h12v20H4zm12 13v-2a2 2 0 002-2V8h10v9h-6.17l2.58-2.59L23 13l-5 5 5 5 1.41-1.41L21.83 19H28v9z\" /><path style=\"fill:none\" d=\"M0 0h32v32H0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "related-visualization_16",
  "use": "related-visualization_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"related-visualization_16\"><path d=\"M10.5 11V6h1v5h-1zm-2 0V4h-1v7h1zm-3 0V7h-1v4h1zM14 3H2v9h1.4l.3.3L5 13.6l1.3-1.3.3-.3H14V3m0-1c.6 0 1 .4 1 1v9c0 .6-.4 1-1 1H7l-2 2-2-2H2c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h12z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "reference-line_16",
  "use": "reference-line_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"reference-line_16\"><path d=\"M1 9.5h14v1H1v-1zM11.5 4h3v4.5h-3V4zm0 7.5h3V15h-3v-3.5zM6.5 1h3v7.5h-3V1zm0 10.5h3V15h-3v-3.5zm-5-6h3v3h-3v-3zm0 6h3V15h-3v-3.5z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(5);

var _Badge = __webpack_require__(321);

var _Badge2 = _interopRequireDefault(_Badge);

var _items = __webpack_require__(30);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _filter_ = __webpack_require__(97);

var _filter_2 = _interopRequireDefault(_filter_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilterDock = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(FilterDock, _Component);

	function FilterDock(props) {
		_classCallCheck(this, FilterDock);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}
	/**
     * renders explore filter dock. It shows in compare card mode
     */


	FilterDock.prototype.render = function render() {
		var badge = this._renderBadge();
		return _react2.default.createElement(
			_items.ToolbarItem,
			{
				iconId: _filter_2.default.id,
				hidden: !this.props.filterDockModel,
				onPrimaryAction: this._handleFilterDockClick.bind(this),
				title: _StringResources2.default.get('exploreFilterDock_Title')
			},
			badge
		);
	};

	/**
  * renders a badge if number is defined and not zero
  */


	FilterDock.prototype._renderBadge = function _renderBadge() {
		var number = this.props.filterDockModel && this.props.filterDockModel.getFilterCount();
		if (number) {
			return _react2.default.createElement(_Badge2.default, { number: number });
		}
	};

	FilterDock.prototype._handleFilterDockClick = function _handleFilterDockClick() {
		var canvasExtensions = this.props.dashboardApi.getDashboardCoreSvc('.CanvasExtensions');
		if (canvasExtensions) {
			var filterDockExtensionView = canvasExtensions.getExtension('filterDock');
			var filterDockCollapseView = canvasExtensions.getExtension('filterDockCollapseControl');
			// attach the extensions to the dom node for canvasExtensions and expand the filter dock
			var dom = document.getElementsByClassName('canvasExtensionTop');
			if (dom[0]) {
				dom[0].appendChild(filterDockExtensionView.$el.get(0));
				dom[0].appendChild(filterDockCollapseView.$el.get(0));
				this.props.dashboardApi.triggerDashboardEvent('filterDock:expand');
			}
		}
	};

	return FilterDock;
}(_react.Component)) || _class;

FilterDock.propTypes = {
	dashboardApi: _propTypes2.default.object.isRequired,
	filterDockModel: _propTypes2.default.object
};

exports.default = FilterDock;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(5);

__webpack_require__(322);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Badge = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(Badge, _Component);

	function Badge(props) {
		_classCallCheck(this, Badge);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {};
		return _this;
	}

	Badge.prototype.render = function render() {
		var value = this.props.number;
		return _react2.default.createElement(
			'span',
			{ className: 'explore__badge' },
			value
		);
	};

	return Badge;
}(_react.Component)) || _class;

Badge.propTypes = {
	number: _propTypes2.default.number
};

Badge.defaultProps = {
	number: 0
};

exports.default = Badge;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(323);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./Badge.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./Badge.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".explore__badge {\n  display: inline-block;\n  position: absolute;\n  min-width: 4px;\n  padding: 1px 4px;\n  font-size: 12px;\n  line-height: 1;\n  color: #e0e0e0;\n  color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  background-color: #161616;\n  background-color: hsla(var(--icon-01-h, 0), var(--icon-01-s, 0%), var(--icon-01-l, 8.62745%), 1);\n  border-radius: 10px;\n  top: 0px;\n  right: -2px;\n}\n\n.explore__badge_empty {\n  visibility: hidden;\n}\n\n", ""]);

// exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames2 = __webpack_require__(10);

var _classnames3 = _interopRequireDefault(_classnames2);

var _caUiToolkit = __webpack_require__(6);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

__webpack_require__(325);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ToolbarItem = function (_Component) {
	_inherits(ToolbarItem, _Component);

	function ToolbarItem(props) {
		_classCallCheck(this, ToolbarItem);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	ToolbarItem.prototype.render = function render() {
		var _classnames,
		    _this2 = this;

		if (this.props.hidden) {
			return null;
		}

		var forwardedProps = _underscore2.default.omit(this.props, 'children', 'onPrimaryAction', 'enabled', 'selected', 'hidden', 'icon', 'iconId', 'label', 'className');

		var classes = (0, _classnames3.default)((_classnames = {
			'explore-vis-toolbar__item': true,
			'explore-vis-toolbar__item--selected': this.props.selected,
			'explore-vis-toolbar__item--enabled': this.isEnabled(),
			'explore-vis-toolbar__item--actionable': this.isActionable()
		}, _classnames['' + this.props.className] = this.props.className, _classnames));

		var icon = this.renderIcon(this.props.icon) || this.renderIconId(this.props.iconId);
		var label = this.renderLabel(this.props.label);
		var tabIndex = this.isActionable() ? 0 : -1;
		/* use ariaLabel in props if it is defined. Otherwise use title
  when both of them are falsy, react is smart enough not to render an undefined attribute */
		var ariaLabel = this.props.ariaLabel || this.props.title;

		return _react2.default.createElement(
			'div',
			_extends({
				className: classes,
				onMouseDown: function onMouseDown() {
					return _this2.performAction.apply(_this2, arguments);
				},
				onTouchStart: function onTouchStart() {
					return _this2.performAction.apply(_this2, arguments);
				}
				// ↓ on mobile to suppress the default behavior of a tap - eliminate the superfluous mousedown event
				, onTouchEnd: function onTouchEnd(event) {
					return event.preventDefault();
				},
				onKeyPress: function onKeyPress() {
					return _this2.onKeyPress.apply(_this2, arguments);
				},
				tabIndex: tabIndex,
				'aria-label': ariaLabel
			}, forwardedProps),
			icon,
			label,
			this.props.children
		);
	};

	ToolbarItem.prototype.renderIcon = function renderIcon(icon) {
		if (!icon) {
			return;
		}

		return _react2.default.createElement(
			'div',
			{ className: 'explore-vis-toolbar__item__icon' },
			icon
		);
	};

	ToolbarItem.prototype.renderIconId = function renderIconId(id) {
		if (!id) {
			return;
		}

		return this.renderIcon(_react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: id }));
	};

	ToolbarItem.prototype.renderLabel = function renderLabel(text) {
		if (!text) {
			return;
		}

		return _react2.default.createElement(
			'div',
			{ className: 'explore-vis-toolbar__item__text' },
			text
		);
	};

	ToolbarItem.prototype.isEnabled = function isEnabled() {
		return this.props.enabled;
	};

	ToolbarItem.prototype.isActionable = function isActionable() {
		return this.isEnabled() && this.props.onPrimaryAction;
	};

	ToolbarItem.prototype.onEnter = function onEnter(event) {
		this.performAction(event);
	};

	ToolbarItem.prototype.onKeyPress = function onKeyPress(event) {
		var _this3 = this;

		var handler = {
			'Enter': function Enter() {
				return _this3.onEnter(event);
			}
		}[event.key];

		handler && handler();
	};

	ToolbarItem.prototype.performAction = function performAction(event) {
		if (this.isActionable()) {
			this.props.onPrimaryAction(event);
		}
	};

	return ToolbarItem;
}(_react.Component);

ToolbarItem.propTypes = {
	children: _PropTypes2.default.any,
	className: _PropTypes2.default.string,
	icon: _PropTypes2.default.object,
	iconId: _PropTypes2.default.string,
	ariaLabel: _PropTypes2.default.string,
	label: _PropTypes2.default.string,
	title: _PropTypes2.default.string,
	hidden: _PropTypes2.default.bool,
	enabled: _PropTypes2.default.bool,
	selected: _PropTypes2.default.bool,
	onPrimaryAction: _PropTypes2.default.func
};

ToolbarItem.defaultProps = {
	children: [],
	hidden: false,
	enabled: true,
	selected: false
};

exports.default = ToolbarItem;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(326);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./toolbarItem.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./toolbarItem.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore-vis-toolbar__item {\n  padding: 0 8px;\n  margin-right: 8px;\n  height: 32px;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  display: -ms-flexbox;\n  display: flex;\n  white-space: nowrap;\n  position: relative;\n  -ms-flex-align: center;\n      align-items: center;\n  color: #161616;\n  color: hsla(var(--icon-01-h, 0), var(--icon-01-s, 0%), var(--icon-01-l, 8.62745%), 1);\n  opacity: 0.5;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.explore-vis-toolbar__item--enabled {\n  opacity: 1;\n}\n\n.explore-vis-toolbar__item--actionable {\n  cursor: pointer;\n}\n\n.explore-vis-toolbar__item--actionable:hover {\n  background-color: #e5e5e5;\n  background-color: hsla(var(--hover-ui-h, 0), var(--hover-ui-s, 0%), var(--hover-ui-l, 89.80392%), 1);\n}\n\n.explore-vis-toolbar__item--actionable:focus {\n  border-color: #a8c0f3;\n  border-color: hsla(var(--focus-h, 220.8), var(--focus-s, 75.75758%), var(--focus-l, 80.58824%), 1);\n}\n\n.explore-vis-toolbar__item--selected,\n.explore-vis-toolbar__item.selected {\n  background-color: #e0e0e0;\n  background-color: hsla(var(--selected-ui-h, 0), var(--selected-ui-s, 0%), var(--selected-ui-l, 87.84314%), 1);\n}\n\n.explore-vis-toolbar__item--selected:hover,\n.explore-vis-toolbar__item.selected:hover {\n  background-color: #e5e5e5;\n  background-color: hsla(var(--hover-ui-h, 0), var(--hover-ui-s, 0%), var(--hover-ui-l, 89.80392%), 1);\n}\n\n.explore-vis-toolbar__item--selected:focus,\n.explore-vis-toolbar__item.selected:focus {\n  border-color: #a8c0f3;\n  border-color: hsla(var(--focus-h, 220.8), var(--focus-s, 75.75758%), var(--focus-l, 80.58824%), 1);\n}\n\n.explore-vis-toolbar__item__icon {\n  text-align: center;\n  -ms-flex: auto;\n      flex: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.explore-vis-toolbar__item__text {\n  font-size: 0.875rem;\n  font-weight: 700;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n", ""]);

// exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(328);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./caretToolbarItem.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./caretToolbarItem.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore-vis-toolbar.small .explore-vis-toolbar__caret-item__icon {\n  margin-right: 8px;\n}\n\n.explore-vis-toolbar__caret-item {\n  padding: 0 8px;\n  margin-right: 8px;\n  height: 38px;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  display: -ms-flexbox;\n  display: flex;\n  white-space: nowrap;\n  position: relative;\n  -ms-flex-align: center;\n      align-items: center;\n  color: #595859;\n  border: 1px solid transparent;\n  opacity: 0.5;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.explore-vis-toolbar__caret-item--enabled {\n  opacity: 1;\n}\n\n.explore-vis-toolbar__caret-item--actionable {\n  cursor: pointer;\n}\n\n.explore-vis-toolbar__caret-item--actionable:hover {\n  background-color: #e5e5e5;\n  background-color: hsla(var(--hover-ui-h, 0), var(--hover-ui-s, 0%), var(--hover-ui-l, 89.80392%), 1);\n}\n\n.explore-vis-toolbar__caret-item--selected,\n.explore-vis-toolbar__caret-item--has-text {\n  border-color: #f4f4f4;\n  border-color: hsla(var(--ui-02-h, 0), var(--ui-02-s, 0%), var(--ui-02-l, 95.68627%), 1);\n}\n\n.explore-vis-toolbar__caret-item__icon,\n.explore-vis-toolbar__caret-item__caret {\n  text-align: center;\n  -ms-flex: auto;\n      flex: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.explore-vis-toolbar__caret-item__text {\n  font-size: 0.875rem;\n  font-weight: 700;\n  padding: 0 8px;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n", ""]);

// exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(330);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var CustomToolbarItem = function (_Component) {
	_inherits(CustomToolbarItem, _Component);

	function CustomToolbarItem(props) {
		_classCallCheck(this, CustomToolbarItem);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	CustomToolbarItem.prototype.render = function render() {
		if (this.props.hidden) {
			return null;
		}

		var classes = (0, _classnames2.default)({
			'explore-vis-toolbar__full-item': true,
			'explore-vis-toolbar__full-item--enabled': this.isEnabled()
		});
		/* use ariaLabel in props if it is defined. Otherwise use title
  +		when both of them are falsy, react is smart enough not to render an undefined attribute */
		var ariaLabel = this.props.ariaLabel || this.props.title;
		var id = this.props.id;

		return _react2.default.createElement(
			'div',
			{
				className: classes,
				'aria-label': ariaLabel,
				'data-id': id
			},
			this.props.children
		);
	};

	CustomToolbarItem.prototype.isEnabled = function isEnabled() {
		return this.props.enabled;
	};

	return CustomToolbarItem;
}(_react.Component);

CustomToolbarItem.propTypes = {
	children: _PropTypes2.default.any,
	hidden: _PropTypes2.default.bool,
	enabled: _PropTypes2.default.bool,
	ariaLabel: _PropTypes2.default.string,
	title: _PropTypes2.default.string,
	id: _PropTypes2.default.string
};

CustomToolbarItem.defaultProps = {
	children: [],
	hidden: false,
	enabled: true
};

exports.default = CustomToolbarItem;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(331);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./customToolbarItem.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./customToolbarItem.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore-vis-toolbar__full-item {\n  height: 100%;\n  margin-right: 8px;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  display: -ms-flexbox;\n  display: flex;\n  white-space: nowrap;\n  position: relative;\n  -ms-flex-align: center;\n      align-items: center;\n  color: #393939;\n  color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n  opacity: 0.5;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.explore-vis-toolbar__full-item--enabled {\n  opacity: 1;\n}\n\n", ""]);

// exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _CaretToolbarItem = __webpack_require__(94);

var _CaretToolbarItem2 = _interopRequireDefault(_CaretToolbarItem);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(333);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var DropDownToolbarItem = function (_Component) {
	_inherits(DropDownToolbarItem, _Component);

	function DropDownToolbarItem(props) {
		_classCallCheck(this, DropDownToolbarItem);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	DropDownToolbarItem.prototype.render = function render() {
		var _this2 = this;

		this._bindUnbindEvents();

		if (this.props.hidden) {
			return null;
		}

		var forwardedProps = _underscore2.default.omit(this.props, 'children', 'onClickOutside');

		return _react2.default.createElement(
			'div',
			{ className: 'explore-vis-toolbar__dropdown-item' },
			_react2.default.createElement(_CaretToolbarItem2.default, _extends({}, forwardedProps, {
				selected: this.props.selected,
				onPrimaryAction: function onPrimaryAction() {
					return _this2.props.onPrimaryAction();
				}
			})),
			this.renderContent()
		);
	};

	DropDownToolbarItem.prototype.renderContent = function renderContent() {
		if (this.props.selected) {
			return _react2.default.createElement(
				'div',
				{ className: 'explore-vis-toolbar__dropdown-item__container' },
				_react2.default.createElement(
					'div',
					{ className: 'explore-vis-toolbar__dropdown-item__content' },
					this.props.children
				)
			);
		}
	};

	DropDownToolbarItem.prototype.componentWillUnmount = function componentWillUnmount() {
		this._unbindEvents();

		// Trigger the on close even when this component unmounts.
		// This allows the consuming component to update the model to reflect the closed state.
		this.props.onClickOutside();
	};

	DropDownToolbarItem.prototype._handleOutsideClick = function _handleOutsideClick(event) {
		if (!(0, _jquery2.default)(event.target).closest('.explore-vis-toolbar__dropdown-item__content').length) {
			this.props.onClickOutside();
		}
	};

	DropDownToolbarItem.prototype._bindEvents = function _bindEvents() {
		if (!this._outsideClickListener) {
			this._outsideClickListener = this._handleOutsideClick.bind(this);

			document.addEventListener('mousedown', this._outsideClickListener);
		}
	};

	DropDownToolbarItem.prototype._unbindEvents = function _unbindEvents() {
		if (this._outsideClickListener) {
			document.removeEventListener('mousedown', this._outsideClickListener);

			this._outsideClickListener = null;
		}
	};

	DropDownToolbarItem.prototype._bindUnbindEvents = function _bindUnbindEvents() {
		if (this.props.selected) {
			this._bindEvents();
		} else {
			this._unbindEvents();
		}
	};

	return DropDownToolbarItem;
}(_react.Component);

DropDownToolbarItem.propTypes = {
	children: _PropTypes2.default.any,
	hidden: _PropTypes2.default.bool,
	selected: _PropTypes2.default.bool,
	onPrimaryAction: _PropTypes2.default.func,
	onClickOutside: _PropTypes2.default.func
};

DropDownToolbarItem.defaultProps = {
	children: [],
	hidden: false,
	selected: false,
	onPrimaryAction: function onPrimaryAction() {},
	onClickOutside: function onClickOutside() {}
};

exports.default = DropDownToolbarItem;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(334);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./dropDownToolbarItem.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./dropDownToolbarItem.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore-vis-toolbar__dropdown-item {\n  position: relative;\n}\n\n.explore-vis-toolbar__dropdown-item__container {\n  z-index: 100;\n  position: absolute;\n  overflow: hidden;\n  padding: 0 24px 24px 24px;\n  margin-left: -24px;\n}\n\n.explore-vis-toolbar__dropdown-item__content {\n  background: white;\n  box-shadow: 0 5px 25px -10px #00000036;\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n", ""]);

// exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _caUiToolkit = __webpack_require__(6);

var _items = __webpack_require__(30);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExploreCompareOptions = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(ExploreCompareOptions, _Component);

	function ExploreCompareOptions(props) {
		_classCallCheck(this, ExploreCompareOptions);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			open: false
		};
		return _this;
	}

	ExploreCompareOptions.prototype.render = function render() {
		var _this2 = this;

		var forwardedProps = _underscore2.default.omit(this.props, 'model');

		return _react2.default.createElement(
			'div',
			{ ref: function ref(node) {
					return _this2.domNode = node;
				} },
			_react2.default.createElement(_items.CaretToolbarItem, _extends({}, forwardedProps, {
				label: _StringResources2.default.get('exploreToolbar_compare_options'),
				title: _StringResources2.default.get('exploreToolbar_compare_options'),
				selected: this.state.open,
				onPrimaryAction: function onPrimaryAction(event) {
					return _this2.onClick(event);
				}
			})),
			this.renderContextMenu()
		);
	};

	ExploreCompareOptions.prototype.renderContextMenu = function renderContextMenu() {
		var _this3 = this;

		if (!this.state.open) {
			return;
		}
		var syncSelections = this.props.model.isWidgetSelectionsSynced();
		var syncCompareLine = this.props.model.isCompareLineEnabled() && this.props.model.isCompareLineSynced();
		var syncMatchScale = this.props.model.isScaleSynced();
		var syncActions = this.props.model.isActionsSynced();

		var checkboxContent = this.getCompareOptionsMenuItems();
		var selection = {
			toggleswitch: {
				syncSelections: syncSelections,
				syncCompareLine: syncCompareLine,
				syncMatchScale: syncMatchScale,
				syncActions: syncActions
			}
		};

		var placement = 'bottomRight';

		return _react2.default.createElement(
			_caUiToolkit.ContextMenu,
			{
				className: 'explore-compare-options__menu',
				theme: true,
				onClose: function onClose() {
					return _this3.onClose();
				},
				domNodeToAttachTo: document.body,
				onChange: function onChange() {
					return _this3.onContextMenuChange.apply(_this3, arguments);
				},
				selected: selection,
				triggerNode: this.domNode,
				placement: placement,
				align: 'left'
			},
			_react2.default.createElement(_caUiToolkit.ContextMenu.ToggleSwitch, {
				content: checkboxContent,
				name: 'toggleswitch',
				label: _StringResources2.default.get('exploreToolbar_compare_options_menu_title')
			})
		);
	};

	ExploreCompareOptions.prototype.isEnabled = function isEnabled() {
		return this.props.enabled;
	};

	ExploreCompareOptions.prototype.onClick = function onClick(event) {
		// Check if the click originated from within the context menu, ignore it.
		if (this.isEnabled() && (0, _jquery2.default)(event.target).closest('.explore-compare-options__menu').length === 0) {
			this.setState({
				open: !this.state.open
			});
		}
	};

	ExploreCompareOptions.prototype.onClose = function onClose() {
		this.setState({
			open: false
		});
	};

	/**
  * called when any of the toggle switch changes by the user
  * @param {string} name - name of the control 'toggleSwitch'
  * @param {object} selection - a map of selection eg. {syncSelections: true, syncCompareLine: false}
  */


	ExploreCompareOptions.prototype.onContextMenuChange = function onContextMenuChange(name, selection) {
		/* only set on compare model on the updated value */
		if (selection.syncSelections !== this.props.model.isWidgetSelectionsSynced()) {
			this.props.model.updateWidgetSelectionsSynced(selection.syncSelections);
		} else if (selection.syncCompareLine !== (this.props.model.isCompareLineEnabled() && this.props.model.isCompareLineSynced())) {
			this.props.model.setCompareLineSynced(selection.syncCompareLine);
		} else if (selection.syncMatchScale !== this.props.model.isScaleSynced()) {
			this.props.model.updateSyncAxisScale(selection.syncMatchScale, true /* isToggledByUser */);
		} else if (selection.syncActions !== this.props.model.isActionsSynced()) {
			this.props.model.setActionsSynced(selection.syncActions);
		}
	};

	/* Compare Options Context menu */

	ExploreCompareOptions.prototype.getCompareOptionsMenuItems = function getCompareOptionsMenuItems() {
		// these might have to fetch dynamically, until then...
		return [{
			label: _StringResources2.default.get('exploreToolbar_compare_options_menuItem_sync_selections'),
			value: 'syncSelections'
		}, {
			label: _StringResources2.default.get('exploreToolbar_compare_options_menuItem_sync_compare_line'),
			value: 'syncCompareLine',
			/* the flag used in toolkit to disable a single menu item in a toggle menu group */
			disabledSingular: !this.props.model.isCompareLineEnabled()
		}, {
			label: _StringResources2.default.get('exploreToolbar_compare_options_menuItem_sync_axis_scale'),
			value: 'syncMatchScale',
			/* the flag used in toolkit to disable a single menu item in a toggle menu group */
			disabledSingular: !this.props.model.isMatchScaleEnabled
		}, {
			label: _StringResources2.default.get('exploreToolbar_compare_options_menuItem_sync_actions'),
			value: 'syncActions'
		}];
	};

	return ExploreCompareOptions;
}(_react.Component)) || _class;

ExploreCompareOptions.propTypes = {
	model: _PropTypes2.default.object,
	hidden: _PropTypes2.default.bool,
	enabled: _PropTypes2.default.bool,
	selected: _PropTypes2.default.bool
};

ExploreCompareOptions.defaultProps = {
	hidden: false,
	enabled: true,
	selected: false
};

exports.default = ExploreCompareOptions;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _items = __webpack_require__(30);

var _AddNewCard = __webpack_require__(337);

var _AddNewCard2 = _interopRequireDefault(_AddNewCard);

__webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var AddNewCardToolbarItem = function (_Component) {
	_inherits(AddNewCardToolbarItem, _Component);

	function AddNewCardToolbarItem(props) {
		_classCallCheck(this, AddNewCardToolbarItem);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			open: false
		};
		return _this;
	}

	AddNewCardToolbarItem.prototype.render = function render() {
		var _this2 = this;

		return _react2.default.createElement(
			_items.DropDownToolbarItem,
			{
				selected: this.state.open,
				label: _StringResources2.default.get('exploreToolbar_new'),
				title: _StringResources2.default.get('exploreToolbar_new'),
				onPrimaryAction: function onPrimaryAction() {
					return _this2.onPrimaryAction();
				},
				onClickOutside: function onClickOutside() {
					return _this2.onClickOutside();
				},
				'data-usage': 'newCard'
			},
			_react2.default.createElement(_AddNewCard2.default, {
				onClick: function onClick() {
					return _this2.onAddCard.apply(_this2, arguments);
				},
				excluded: this.getExcludedTypes()
			})
		);
	};

	AddNewCardToolbarItem.prototype.onPrimaryAction = function onPrimaryAction() {
		// Toggle the dropdown.
		this.setState({
			open: !this.state.open
		});
	};

	AddNewCardToolbarItem.prototype.onClickOutside = function onClickOutside() {
		// Close the dropdown.
		this.setState({
			open: false
		});
	};

	AddNewCardToolbarItem.prototype.onAddCard = function onAddCard(event) {
		// Close the dropdown.
		this.setState({
			open: false
		});

		this.props.onAddCard(event);
	};

	AddNewCardToolbarItem.prototype.getExcludedTypes = function getExcludedTypes() {
		var excluded = [];
		if (this.props.exploreVM.isStartingPointsDisplayed()) {
			excluded.push('startingPoints');
		}

		return excluded;
	};

	return AddNewCardToolbarItem;
}(_react.Component);

AddNewCardToolbarItem.propTypes = {
	onAddCard: _PropTypes2.default.func,
	exploreVM: _PropTypes2.default.object
};

AddNewCardToolbarItem.defaultProps = {
	onAddCard: function onAddCard() {}
};

exports.default = AddNewCardToolbarItem;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _caUiToolkit = __webpack_require__(6);

var _dataRelationshipsCard_ = __webpack_require__(43);

var _dataRelationshipsCard_2 = _interopRequireDefault(_dataRelationshipsCard_);

var _BlankCardView = __webpack_require__(66);

var _BlankCardView2 = _interopRequireDefault(_BlankCardView);

__webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddNewCard = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(AddNewCard, _Component);

	function AddNewCard(props) {
		_classCallCheck(this, AddNewCard);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	AddNewCard.prototype.render = function render() {
		var menuItems = this.getMenuSpec();

		return _react2.default.createElement(
			'div',
			{ className: 'explore-add-new__content' },
			menuItems
		);
	};

	AddNewCard.prototype.renderItem = function renderItem(item, key) {
		var _this2 = this;

		var menuItem = void 0;
		if (item.icon) {
			menuItem = _react2.default.createElement(
				'div',
				{
					className: 'explore-add-new__content__item',
					onClick: function onClick() {
						return _this2.onClick(item.type);
					},
					key: key,
					'data-type': item.type
				},
				_react2.default.createElement(
					'div',
					{
						className: 'explore-add-new__content__item__icon',
						onKeyPress: function onKeyPress() {
							for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
								params[_key] = arguments[_key];
							}

							return _this2.onKeyPress.apply(_this2, [item.type].concat(params));
						},
						tabIndex: 0
					},
					_react2.default.createElement(_caUiToolkit.SVGIcon, { className: '' + (item.className ? item.className : ''), width: 128, height: 100, iconId: item.icon.id })
				),
				_react2.default.createElement(_caUiToolkit.Label, { className: 'explore-add-new__content__item__caption', label: item.caption })
			);
		} else {
			menuItem = item.element(key);
		}

		return menuItem;
	};

	AddNewCard.prototype.onClick = function onClick(type) {
		this.performAction(type);
	};

	AddNewCard.prototype.onEnter = function onEnter(type) {
		this.performAction(type);
	};

	AddNewCard.prototype.onKeyPress = function onKeyPress(type, event) {
		var _this3 = this;

		var handler = {
			'Enter': function Enter() {
				return _this3.onEnter(type);
			}
		}[event.key];

		handler && handler();
	};

	AddNewCard.prototype.performAction = function performAction(type) {
		this.props.onClick({ type: type });
	};

	AddNewCard.prototype.getMenuSpec = function getMenuSpec() {
		var _this4 = this;

		var spec = [{
			element: function element(key) {
				return _react2.default.createElement(
					'div',
					{
						className: 'explore-add-new__content__item explore-add-new__content__item__single',
						onClick: function onClick() {
							return _this4.onClick('single');
						}
					},
					_react2.default.createElement(
						'div',
						{
							className: 'explore-add-new__content__item__icon',
							onKeyPress: function onKeyPress() {
								for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
									params[_key2] = arguments[_key2];
								}

								return _this4.onKeyPress.apply(_this4, ['single'].concat(params));
							},
							tabIndex: 0
						},
						_react2.default.createElement(_BlankCardView2.default, {
							classPrefix: 'explore-add-new__content__item__icon__card',
							key: key
						})
					),
					_react2.default.createElement(_caUiToolkit.Label, { className: 'explore-add-new__content__item__caption', label: _StringResources2.default.get('flyout_add-new-card_single') })
				);
			},
			type: 'single'
		}, {
			element: function element(key) {
				return _react2.default.createElement(
					'div',
					{
						className: 'explore-add-new__content__item explore-add-new__content__item__compare',
						onClick: function onClick() {
							return _this4.onClick('compare');
						}
					},
					_react2.default.createElement(
						'div',
						{
							className: 'explore-add-new__content__item__icon',
							onKeyPress: function onKeyPress() {
								for (var _len3 = arguments.length, params = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
									params[_key3] = arguments[_key3];
								}

								return _this4.onKeyPress.apply(_this4, ['compare'].concat(params));
							},
							tabIndex: 0
						},
						_react2.default.createElement(_BlankCardView2.default, {
							classPrefix: 'explore-add-new__content__item__icon__card',
							key: key + '_1'
						}),
						_react2.default.createElement(_BlankCardView2.default, {
							classPrefix: 'explore-add-new__content__item__icon__card',
							key: key + '_2'
						})
					),
					_react2.default.createElement(_caUiToolkit.Label, { className: 'explore-add-new__content__item__caption', label: _StringResources2.default.get('flyout_add-new-card_compare') })
				);
			},
			type: 'compare'
		}, {
			caption: '',
			element: function element(key) {
				return _react2.default.createElement('div', { className: 'explore-add-new__separator', key: key });
			},
			type: 'separator'
		}, {
			caption: '',
			element: function element(key) {
				return _react2.default.createElement(_caUiToolkit.Label, { className: 'explore-add-new__label', label: _StringResources2.default.get('flyout_add-new-card_goTo_startingPoints'), key: key });
			},
			type: 'label'
		}, {
			caption: _StringResources2.default.get('startingPoints_data_relationships_thumbnail_title'),
			icon: _dataRelationshipsCard_2.default,
			className: 'startingPointsThumb',
			type: 'startingPoints'
		}];

		var excluded = this.props.excluded;
		excluded.length > 0 && excluded.push('separator', 'label'); // removing separator and label

		return this._excludeTypes(spec, excluded).map(function (item, index) {
			return _this4.renderItem(item, index);
		}) || [];
	};

	AddNewCard.prototype._excludeTypes = function _excludeTypes(spec, excludedTypes) {
		return this.props.excluded.length > 0 && spec.filter(function (item) {
			return excludedTypes.indexOf(item.type) === -1;
		}) || spec;
	};

	return AddNewCard;
}(_react.Component)) || _class;

AddNewCard.propTypes = {
	onClick: _PropTypes2.default.func,
	excluded: _PropTypes2.default.array
};

AddNewCard.defaultProps = {
	onClick: function onClick() {},
	excluded: []
};

exports.default = AddNewCard;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore-add-new__label {\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.125rem;\n}\n\n.explore-add-new__separator {\n  border-bottom: 1px solid #eaeaea;\n  margin: 16px 0;\n  width: 100%;\n}\n\n.explore-add-new__label {\n  margin-bottom: 8px;\n}\n\n.explore-add-new__content {\n  padding: 24px;\n}\n\n.explore-add-new__content__item {\n  cursor: pointer;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.explore-add-new__content__item * {\n  cursor: pointer;\n}\n\n.explore-add-new__content__item:hover .explore-add-new__content__item__icon,\n.explore-add-new__content__item:active .explore-add-new__content__item__icon {\n  outline-style: solid;\n  outline-width: 2px;\n  outline-color: #161616;\n  outline-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n  border-color: transparent;\n}\n\n.explore-add-new__content__item:last-child {\n  margin-bottom: 0px;\n}\n\n.explore-add-new__content__item__icon {\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  padding: 10px;\n  width: 142px;\n  height: 96px;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.explore-add-new__content__item__icon__card {\n  border: 1px dashed;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  height: 100%;\n  width: 100%;\n}\n\n.explore-add-new__content__item__icon__card:nth-child(2) {\n  margin-left: 5px;\n}\n\n.explore-add-new__content__item__caption {\n  padding: 5px;\n}\n\n.explore-add-new__content__add-icon {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  color: #161616;\n  color: hsla(var(--icon-01-h, 0), var(--icon-01-s, 0%), var(--icon-01-l, 8.62745%), 1);\n}\n\n", ""]);

// exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _caUiToolkit = __webpack_require__(6);

var _items = __webpack_require__(30);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

__webpack_require__(340);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navigation = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(Navigation, _Component);

	function Navigation(props) {
		_classCallCheck(this, Navigation);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	Navigation.prototype.render = function render() {
		var _this2 = this;

		var label = this.renderLabel(this.props.index, this.props.count);

		return _react2.default.createElement(
			'div',
			{ className: 'explore-card-navigation' },
			_react2.default.createElement(_items.CaretToolbarItem, {
				arrow: 'up',
				title: _StringResources2.default.get('card_navigation_previous'),
				enabled: this.canNavigatePrevious(),
				onPrimaryAction: function onPrimaryAction() {
					return _this2.onNavigateLeftClick();
				}
			}),
			_react2.default.createElement(
				_items.ToolbarItem,
				null,
				label
			),
			_react2.default.createElement(_items.CaretToolbarItem, {
				arrow: 'down',
				title: _StringResources2.default.get('card_navigation_next'),
				enabled: this.canNavigateNext(),
				onPrimaryAction: function onPrimaryAction() {
					return _this2.onNavigateRightClick();
				}
			})
		);
	};

	Navigation.prototype.renderLabel = function renderLabel(index, count) {
		if (index >= count) {
			// throw new Error(`Out of bounds. Guarding condition failed: 'props.index < props.count'. ${index} >= ${count}`);
			return;
		}
		if (count > 0 && index < 0) {
			// throw new Error(`Out of bounds. Guarding condition failed: 'props.index >= 0'. ${index} < 0`);
			return;
		}

		var label = void 0;
		if (count > 0) {
			label = index + 1 + '/' + count;
		} else {
			label = '' + count;
		}
		return _react2.default.createElement(_caUiToolkit.Label, { label: label });
	};

	Navigation.prototype.isEmpty = function isEmpty() {
		return this.props.count <= 0;
	};

	Navigation.prototype.canNavigatePrevious = function canNavigatePrevious() {
		return !this.isEmpty() && this.props.index > 0;
	};

	Navigation.prototype.canNavigateNext = function canNavigateNext() {
		return !this.isEmpty() && this.props.index < this.props.count - 1;
	};

	Navigation.prototype.onNavigateLeftClick = function onNavigateLeftClick() {
		this.props.onNavigatePrevious();
	};

	Navigation.prototype.onNavigateRightClick = function onNavigateRightClick() {
		this.props.onNavigateNext();
	};

	return Navigation;
}(_react.Component)) || _class;

Navigation.propTypes = {
	index: _PropTypes2.default.number,
	count: _PropTypes2.default.number,
	onNavigatePrevious: _PropTypes2.default.func.isRequired,
	onNavigateNext: _PropTypes2.default.func.isRequired
};

Navigation.defaultProps = {
	index: 0,
	count: 0,
	onNavigatePrevious: function onNavigatePrevious() {},
	onNavigateNext: function onNavigateNext() {}
};

exports.default = Navigation;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(341);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./navigation.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./navigation.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore-card-navigation {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 0.875rem;\n}\n\n", ""]);

// exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _reactMeasure = __webpack_require__(20);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(343);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var SIZES = {
	'small': [0, 950],
	'large': [951, Infinity]
};

var Toolbar = function (_Component) {
	_inherits(Toolbar, _Component);

	function Toolbar(props) {
		_classCallCheck(this, Toolbar);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			size: undefined
		};
		return _this;
	}

	Toolbar.prototype.render = function render() {
		var _this2 = this;

		var size = this.state.size;

		var classes = (0, _classnames2.default)({
			'explore-vis-toolbar': true,
			'small': size === 'small',
			'large': size === 'large'
		});

		return _react2.default.createElement(
			_reactMeasure2.default,
			{
				onResize: function onResize(contentRect) {
					return _this2.onResize(contentRect);
				}
			},
			function (_ref) {
				var measureRef = _ref.measureRef;
				return _react2.default.createElement(
					'div',
					{ className: classes, ref: measureRef },
					_react2.default.createElement(
						'div',
						{ className: 'explore-vis-toolbar__container' },
						_this2.props.children
					)
				);
			}
		);
	};

	Toolbar.prototype.onResize = function onResize() {
		var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
		    _ref2$entry = _ref2.entry;

		_ref2$entry = _ref2$entry === undefined ? {} : _ref2$entry;
		var width = _ref2$entry.width;

		if (width) {
			var size = Object.keys(SIZES).find(function (key) {
				var _SIZES$key = SIZES[key],
				    min = _SIZES$key[0],
				    max = _SIZES$key[1];

				return width >= min && width <= max;
			});

			if (size) {
				this.setState({
					size: size
				});
				this.props.onResize(size);
			}
		}
	};

	return Toolbar;
}(_react.Component);

Toolbar.propTypes = {
	children: _PropTypes2.default.any,
	onResize: _PropTypes2.default.func
};

Toolbar.defaultProps = {
	children: [],
	onResize: function onResize() {}
};

exports.default = Toolbar;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(344);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./toolbar.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./toolbar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore-vis-toolbar.small .explore-vis-toolbar__container .explore-vis-toolbar__items.explore-vis-toolbar__items--extright {\n  padding-left: 0px;\n}\n\n.explore-vis-toolbar {\n  position: relative;\n  width: 100%;\n  min-height: 60px;\n  -ms-flex-align: center;\n      align-items: center;\n  z-index: 200;\n  border-bottom: 1px solid;\n  border-bottom-color: #e0e0e0;\n  border-bottom-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.explore-vis-toolbar__container {\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  padding: 0 16px;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n\n.explore-vis-toolbar__item__container {\n  width: 100%;\n}\n\n.explore-vis-toolbar__full-item[data-id=\"com.ibm.bi.smarts.conversation.conversationCompact\"] {\n  width: 100%;\n  max-width: calc(100% - 16px);\n}\n\n.explore-vis-toolbar__items {\n  -ms-flex-align: center;\n      align-items: center;\n  height: 60px;\n}\n\n.explore-vis-toolbar__items--left {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  -ms-flex: 1 0 auto;\n      flex: 1 0 auto;\n}\n\n.explore-vis-toolbar__items--right {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  -ms-flex: 0 1 auto;\n      flex: 0 1 auto;\n}\n\n.explore-vis-toolbar__items--extright {\n  padding-left: 8px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex: 0 1 auto;\n      flex: 0 1 auto;\n}\n\n.explore-vis-toolbar__items--center {\n  margin: 0 16px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex: 1 0 auto;\n      flex: 1 0 auto;\n}\n\n.explore-vis-toolbar__items > :last-child {\n  margin-right: 0;\n}\n\n.explore-vis-toolbar__items .explore-vis-toolbar__separator {\n  height: 32px;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.explore-vis-toolbar .ba-common-searchInput .ba-common-baseInput {\n  width: 100%;\n}\n\n.explore-vis-toolbar .ba-common-searchInput .ba-common-baseInput input {\n  padding-top: 0px;\n}\n\n", ""]);

// exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToolbarSection = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(ToolbarSection, _Component);

	function ToolbarSection(props) {
		_classCallCheck(this, ToolbarSection);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	ToolbarSection.prototype.render = function render() {
		var alignment = this.props.align;

		var classes = (0, _classnames2.default)({
			'explore-vis-toolbar__items': true,
			'explore-vis-toolbar__items--left': alignment === 'left',
			'explore-vis-toolbar__items--center': alignment === 'center',
			'explore-vis-toolbar__items--right': alignment === 'right',
			'explore-vis-toolbar__items--extright': alignment === 'extright' //extreme right
		});

		return _react2.default.createElement(
			'div',
			{ className: classes },
			this.props.children
		);
	};

	return ToolbarSection;
}(_react.Component)) || _class;

ToolbarSection.propTypes = {
	align: _PropTypes2.default.string,
	children: _PropTypes2.default.any
};

ToolbarSection.defaultProps = {
	align: 'left',
	children: []
};

exports.default = ToolbarSection;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _ExploreContainerItem = __webpack_require__(99);

var _ExploreContainerItem2 = _interopRequireDefault(_ExploreContainerItem);

var _ExploreContainerItemList = __webpack_require__(358);

var _ExploreContainerItemList2 = _interopRequireDefault(_ExploreContainerItemList);

var _mobxStateTree = __webpack_require__(7);

var _CSSTransition = __webpack_require__(26);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _StartingPointsLayout = __webpack_require__(359);

var _StartingPointsLayout2 = _interopRequireDefault(_StartingPointsLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Class representing view implementation (using react) for ExploreContainer layout view
 * @extends ReactLayoutImplBase
 */
var ExploreContainerContent = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(ExploreContainerContent, _Component);

	function ExploreContainerContent(props) {
		_classCallCheck(this, ExploreContainerContent);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	ExploreContainerContent.prototype.render = function render() {
		return this.getRenderMarkup();
	};

	ExploreContainerContent.prototype.isModelAlive = function isModelAlive() {
		return (0, _mobxStateTree.isAlive)(this.props.model);
	};

	ExploreContainerContent.prototype.componentDidUpdate = function componentDidUpdate() {
		var displayStartingPoints = this.props.model.exploreVM.isStartingPointsDisplayed();
		if (displayStartingPoints === false && this.isModelAlive()) {
			this.props.layoutOwner._callChildrenFunction('triggerWidgetRender');
		}
	};

	ExploreContainerContent.prototype.getRenderMarkup = function getRenderMarkup() {
		var _this2 = this;

		var displayStartingPoints = this.props.model.exploreVM.isStartingPointsDisplayed();
		var item = {
			displayed: displayStartingPoints,
			render: function render(displayed) {
				return _this2.renderStartingPoints(displayed);
			},
			id: 'starting points'
		};
		return _react2.default.createElement(
			'div',
			{ className: 'explore-content__cards' },
			_react2.default.createElement(_ExploreContainerItem2.default, {
				services: this.props.services,
				item: item
			}),
			_react2.default.createElement(_ExploreContainerItemList2.default, {
				layoutOwner: this.props.layoutOwner,
				services: this.props.services,
				model: this.props.model
			})
		);
	};

	ExploreContainerContent.prototype.renderStartingPoints = function renderStartingPoints(selected) {
		return _react2.default.createElement(
			_CSSTransition2.default,
			{
				'in': selected,
				classNames: 'starting-points-page',
				appear: true,
				mountOnEnter: true,
				unmountOnExit: false },
			_react2.default.createElement(_StartingPointsLayout2.default, {
				dashboardApi: this.props.dashboardApi,
				model: this.props.startingPointsVM,
				activeDataSourceId: this.props.model.exploreVM.activeDataSourceId,
				activeDataSourceModule: this.props.model.exploreVM.activeDataSourceModule,
				services: this.props.services,
				addVisCard: this.props.addVisCard })
		);
	};

	return ExploreContainerContent;
}(_react.Component)) || _class;

ExploreContainerContent.propTypes = {
	model: _PropTypes2.default.object,
	startingPointsVM: _PropTypes2.default.object,
	services: _PropTypes2.default.object,
	dashboardApi: _PropTypes2.default.object,
	layoutOwner: _PropTypes2.default.object.isRequired,
	addVisCard: _PropTypes2.default.func
};

exports.default = ExploreContainerContent;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _caUiToolkit = __webpack_require__(6);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tabs = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(Tabs, _Component);

	function Tabs() {
		_classCallCheck(this, Tabs);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Tabs.prototype.render = function render() {
		var _this2 = this;

		var forwardedProps = _underscore2.default.omit(this.props, 'children', 'model');
		var selectedTab = this.props.model.getTab();

		return _react2.default.createElement(
			'div',
			_extends({}, forwardedProps, { onKeyDown: function onKeyDown(e) {
					return _this2.onKeyDown(e);
				} }),
			_react2.default.createElement(
				_caUiToolkit.Tabs,
				{
					selected: selectedTab,
					onChange: function onChange(tabId) {
						return _this2.onTabChange(tabId);
					}
				},
				this.props.children
			)
		);
	};

	Tabs.prototype.onTabChange = function onTabChange(id) {
		this.props.model.showTab(id);
	};

	Tabs.prototype.onKeyDown = function onKeyDown() {
		var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		//Defect 279835: Using Delete key when tabbed above or below the slot deletes whole card
		var shouldHandle = event.key === 'Delete' || event.key === 'Backspace';

		if (shouldHandle) {
			//This will be used in the keyDown handler in ExploreContainer
			event.handled = true;
		}
	};

	return Tabs;
}(_react.Component)) || _class;

Tabs.propTypes = {
	model: _PropTypes2.default.object.isRequired,
	children: _PropTypes2.default.any,
	onTabChange: _PropTypes2.default.func
};

Tabs.defaultProps = {
	children: [],
	onTabChange: function onTabChange() {}
};

exports.default = Tabs;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.TAB_STATE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var TAB_STATE = exports.TAB_STATE = {
	SHOW_SLOTS: 'show_slots',
	SHOW_DATA: 'show_data'
};

var SlotsContainer = function (_Component) {
	_inherits(SlotsContainer, _Component);

	function SlotsContainer() {
		_classCallCheck(this, SlotsContainer);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	SlotsContainer.prototype.componentDidMount = function componentDidMount() {
		this.renderSlots();
	};

	SlotsContainer.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
		if (this.props.widget !== prevProps.widget) {
			this.renderSlots();
		}
	};

	SlotsContainer.prototype.componentWillUnmount = function componentWillUnmount() {
		this.exploreSlotsRef = null;
	};

	SlotsContainer.prototype.render = function render() {
		var _this2 = this;

		return _react2.default.createElement('div', { className: 'explore-slots', ref: function ref(node) {
				return _this2.exploreSlotsRef = node;
			} });
	};

	SlotsContainer.prototype.renderSlots = function renderSlots() {
		var dashboardApi = this.props.dashboardApi;

		var slotDOMFeature = dashboardApi.getFeature('SlotEditorDOM');
		var parentNode = this.exploreSlotsRef;
		if (parentNode && slotDOMFeature) {
			slotDOMFeature.render({ parentNode: parentNode });
		}
	};

	return SlotsContainer;
}(_react.Component);

SlotsContainer.propTypes = {
	widget: _propTypes2.default.object.isRequired,
	dashboardApi: _propTypes2.default.object.isRequired
};

exports.default = SlotsContainer;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _mobxUtils = __webpack_require__(15);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames2 = __webpack_require__(10);

var _classnames3 = _interopRequireDefault(_classnames2);

var _NaturalLanguageTextModel = __webpack_require__(73);

var _NaturalLanguageTextModel2 = _interopRequireDefault(_NaturalLanguageTextModel);

var _caUiToolkit = __webpack_require__(6);

var _Empty = __webpack_require__(18);

var _Empty2 = _interopRequireDefault(_Empty);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _UnescapedString = __webpack_require__(53);

var _UnescapedString2 = _interopRequireDefault(_UnescapedString);

var _detailsError_ = __webpack_require__(350);

var _detailsError_2 = _interopRequireDefault(_detailsError_);

var _noDetail_ = __webpack_require__(351);

var _noDetail_2 = _interopRequireDefault(_noDetail_);

__webpack_require__(352);

var _CanvasTabs = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NaturalLanguageText = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(NaturalLanguageText, _Component);

	function NaturalLanguageText(props) {
		_classCallCheck(this, NaturalLanguageText);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	NaturalLanguageText.prototype.render = function render() {
		var _props = this.props,
		    model = _props.model,
		    tabState = _props.tabState;

		var content = void 0;

		if (model && model.items && tabState === _CanvasTabs.TAB_STATE.SHOW_DATA) {
			switch (model.items.state) {
				case _mobxUtils.PENDING:
					content = _react2.default.createElement(
						'div',
						{ className: 'explore-nlt__container card-layout-content__side-panel__empty-container' },
						_react2.default.createElement(
							'div',
							{ className: 'explore-nlt__loading' },
							_react2.default.createElement(_caUiToolkit.ProgressIndicator, { size: 'normal' }),
							_react2.default.createElement(
								'div',
								{ className: 'explore-nlt__loading__text' },
								_StringResources2.default.get('details_loading')
							)
						)
					);
					break;
				case _mobxUtils.FULFILLED:
					content = this.renderItems();
					break;
				case _mobxUtils.REJECTED:
					content = _react2.default.createElement(
						'div',
						{ className: 'explore-nlt__container card-layout-content__side-panel__empty-container' },
						_react2.default.createElement(_Empty2.default, {
							icon: _react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _detailsError_2.default.id, size: 'xxlarge' }),
							title: _StringResources2.default.get('details_error_title'),
							description: _StringResources2.default.get('details_error_description')
						})
					);
					break;
			}
		} else if (tabState !== _CanvasTabs.TAB_STATE.SHOW_DATA) {
			var _classnames;

			var classes = (0, _classnames3.default)((_classnames = {
				'explore-nlt__container': true,
				'card-layout-content__side-panel__empty-container': true
			}, _classnames['explore-nlt__container_' + tabState] = true, _classnames));
			content = _react2.default.createElement(
				'div',
				{ className: classes },
				_react2.default.createElement(_Empty2.default, {
					icon: _react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _noDetail_2.default.id, size: 'xxlarge' }),
					title: _StringResources2.default.get('details_' + tabState + '_title'),
					description: _StringResources2.default.get('details_' + tabState + '_description')
				})
			);
		}

		if (!content || Array.isArray(content) && !content.length) {
			// If the content is an array, but it's empty, then still show the empty view.
			content = _react2.default.createElement(
				'div',
				{ className: 'explore-nlt__container card-layout-content__side-panel__empty-container' },
				_react2.default.createElement(_Empty2.default, {
					icon: _react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _noDetail_2.default.id, size: 'xxlarge' }),
					title: _StringResources2.default.get('details_none_title'),
					description: _StringResources2.default.get('details_none_description')
				})
			);
		}

		return _react2.default.createElement(
			'div',
			{ className: 'explore-nlt' },
			content
		);
	};

	NaturalLanguageText.prototype.renderItems = function renderItems() {
		var _this2 = this;

		return this.props.model.getItems().map(function (item, index) {
			return _this2.renderText(item, index);
		});
	};

	NaturalLanguageText.prototype.renderText = function renderText(item, key) {
		return _react2.default.createElement(
			'div',
			{ className: 'explore-nlt__item', key: key },
			_react2.default.createElement(
				_UnescapedString2.default,
				null,
				_react2.default.createElement(
					'span',
					null,
					item.label
				)
			)
		);
	};

	return NaturalLanguageText;
}(_react.Component)) || _class;

NaturalLanguageText.propTypes = {
	model: _PropTypes2.default.stateTree(_NaturalLanguageTextModel2.default),
	tabState: _PropTypes2.default.string.isRequired
};

exports.default = NaturalLanguageText;

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "details-error_128",
  "use": "details-error_128-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"details-error_128\"><path class=\"ba-graphics-gray1\" d=\"M23.1 8.3h72v104h-72z\" /><path class=\"ba-graphics-white\" d=\"M34.1 17.3h70v102h-70z\" /><path class=\"ba-graphics-gray20\" d=\"M69.1 54.2c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14-6.3-14-14-14zm0 20.7c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3zm1.3-10.7l-.7 6.7h-1.3l-.7-6.7v-2.7h2.7v2.7zm-1.3-10c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14-6.3-14-14-14zm0 20.7c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3zm1.3-10.7l-.7 6.7h-1.3l-.7-6.7v-2.7h2.7v2.7zm-1.3-10c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14-6.3-14-14-14zm0 20.7c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3zm1.3-10.7l-.7 6.7h-1.3l-.7-6.7v-2.7h2.7v2.7zm-37.3-48v104h72v-104h-72zm70 102h-68v-100h68v100zm-34-36c7.7 0 14-6.3 14-14s-6.3-14-14-14-14 6.3-14 14c0 7.8 6.2 14 14 14zm-1.3-20.6h2.7v2.7l-.7 6.7h-1.3l-.7-6.7v-2.7zm1.3 10.6c.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3-.7 0-1.3-.6-1.3-1.3 0-.7.5-1.3 1.3-1.3zm0-18c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14-6.3-14-14-14zm0 20.7c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3zm1.3-10.7l-.7 6.7h-1.3l-.7-6.7v-2.7h2.7v2.7z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "no-detail_128",
  "use": "no-detail_128-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"no-detail_128\"><circle class=\"ba-graphics-neutral-white4\" cx=\"100\" cy=\"100\" r=\"100\" /><path class=\"ba-graphics-white\" d=\"M14.97 170.08h135.66\" /><path class=\"ba-graphics-gray60\" d=\"M150.63 172.08H15a2 2 0 110-4h135.63a2 2 0 010 4z\" /><path class=\"ba-graphics-white\" d=\"M2 170.08h4.97\" /><path class=\"ba-graphics-gray60\" d=\"M7 172.08H2a2 2 0 010-4h5a2 2 0 010 4z\" /><path class=\"ba-graphics-white\" d=\"M179.03 170.08H198\" /><path class=\"ba-graphics-gray60\" d=\"M198 172.08h-19a2 2 0 010-4h19a2 2 0 010 4z\" /><rect class=\"ba-graphics-gray80\" style=\"opacity:.1\" x=\"79.35\" y=\"45.75\" width=\"87.73\" height=\"107.48\" rx=\"4\" transform=\"rotate(6.89 123.277 99.528)\" /><rect class=\"ba-graphics-white\" x=\"76.15\" y=\"41.66\" width=\"87.73\" height=\"107.48\" rx=\"4\" transform=\"rotate(6.89 120.115 95.467)\" /><path class=\"ba-graphics-gray60\" d=\"M86.4 37.24v3.82l79.15 9.57a.18.18 0 01.16.2l-12 98.76a.18.18 0 01-.19.16l-79.15-9.57a.17.17 0 01-.15-.2l12.01-98.76a.18.18 0 01.17-.16v-3.82m0 0a4 4 0 00-4 3.52l-12 98.76A4 4 0 0074 144l79.15 9.57a3.87 3.87 0 00.48 0 4 4 0 004-3.52l11.94-98.76a4 4 0 00-3.57-4.45l-79.11-9.57h-.49z\" /><path class=\"ba-graphics-white\" d=\"M97.8 59.92l50.31 6.05\" /><path class=\"ba-graphics-gray40\" d=\"M148.11 68h-.24l-50.31-6a2 2 0 11.48-4l50.31 6a2 2 0 01-.24 4z\" /><path class=\"ba-graphics-white\" d=\"M95.88 75.78l44.61 5.39\" /><path class=\"ba-graphics-gray40\" d=\"M140.49 83.17h-.24l-44.61-5.41a2 2 0 01.48-4l44.61 5.39a2 2 0 01-.24 4z\" /><path class=\"ba-graphics-white\" d=\"M93.97 91.63l47.68 5.77\" /><path class=\"ba-graphics-gray40\" d=\"M141.65 99.4h-.24l-47.68-5.78a2 2 0 11.48-4l47.68 5.76a2 2 0 01-.24 4z\" /><path class=\"ba-graphics-white\" d=\"M90.14 123.35l27.78 3.35\" /><path class=\"ba-graphics-gray40\" d=\"M117.92 128.7h-.24l-27.78-3.37a2 2 0 11.48-4l27.77 3.36a2 2 0 01-.23 4z\" /><path class=\"ba-graphics-white\" d=\"M92.05 107.49l34.35 4.15\" /><path class=\"ba-graphics-gray40\" d=\"M126.4 113.64h-.24l-34.35-4.15a2 2 0 01.48-4l34.35 4.15a2 2 0 01-.24 4z\" /><path class=\"ba-graphics-white\" d=\"M158.63 170.08h12.4\" /><path class=\"ba-graphics-gray60\" d=\"M171 172.08h-12.4a2 2 0 010-4H171a2 2 0 010 4z\" /><rect class=\"ba-graphics-gray80\" style=\"opacity:.1\" x=\"46.02\" y=\"39.26\" width=\"91.22\" height=\"111.76\" rx=\"4\" transform=\"rotate(-7.43 91.57 95.108)\" /><rect class=\"ba-graphics-white\" x=\"41.75\" y=\"35.97\" width=\"91.22\" height=\"111.76\" rx=\"4\" transform=\"rotate(-7.43 87.3 91.815)\" /><path class=\"ba-graphics-gray60\" d=\"M121.91 34.84a.19.19 0 01.18.16l13.41 102.89a.18.18 0 01-.16.2L52.8 148.85a.19.19 0 01-.18-.16L39.21 45.8a.18.18 0 01.16-.2l82.51-10.76m0-3.82a3.12 3.12 0 00-.52 0L38.87 41.81a4 4 0 00-3.45 4.49l13.41 102.88a4 4 0 004 3.49 3.12 3.12 0 00.52 0l82.51-10.75a4 4 0 003.45-4.48L125.87 34.51a4 4 0 00-4-3.49z\" /><path class=\"ba-graphics-white\" d=\"M55.84 61.77l52.24-6.85\" /><path class=\"ba-graphics-gray40\" d=\"M55.84 63.77a2 2 0 01-.26-4l52.24-6.84a2 2 0 01.52 4L56.1 63.75z\" /><path class=\"ba-graphics-white\" d=\"M57.99 78.23l46.32-6.04\" /><path class=\"ba-graphics-gray40\" d=\"M58 80.23a2 2 0 01-.25-4l46.32-6a2 2 0 11.52 4l-46.33 6z\" /><path class=\"ba-graphics-white\" d=\"M60.13 94.7l49.52-6.46\" /><path class=\"ba-graphics-gray40\" d=\"M60.13 96.7a2 2 0 01-.26-4l49.52-6.46a2 2 0 01.52 4l-49.52 6.44z\" /><path class=\"ba-graphics-white\" d=\"M64.43 127.63l28.85-3.76\" /><path class=\"ba-graphics-gray40\" d=\"M64.43 129.63a2 2 0 01-.26-4L93 121.89a2 2 0 01.52 4l-28.85 3.77z\" /><path class=\"ba-graphics-white\" d=\"M62.28 111.17l35.67-4.65\" /><path class=\"ba-graphics-gray40\" d=\"M62.28 113.17a2 2 0 01-.26-4l35.67-4.65a2 2 0 01.52 4l-35.67 4.65z\" /><circle class=\"ba-graphics-gray60\" cx=\"119.33\" cy=\"13.5\" r=\"2\" /><circle class=\"ba-graphics-gray60\" cx=\"26.56\" cy=\"87.62\" r=\"2\" /><path class=\"ba-graphics-gray60\" d=\"M80.16 19.25a2.1 2.1 0 002.09-2.09.52.52 0 011 0 2.1 2.1 0 002.09 2.09.52.52 0 110 1 2.1 2.1 0 00-2.09 2.09.52.52 0 11-1 0 2.1 2.1 0 00-2.09-2.09.52.52 0 110-1z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(353);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./NaturalLanguageText.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./NaturalLanguageText.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore-nlt__loading {\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.25rem;\n}\n\n.explore-nlt__item {\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.125rem;\n}\n\n.explore-nlt {\n  padding-top: 16px;\n  width: 100%;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n.explore-nlt__container {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.explore-nlt__item {\n  padding-top: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid;\n  border-bottom-color: #e0e0e0;\n  border-bottom-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.explore-nlt__loading {\n  text-align: center;\n}\n\n.explore-nlt__loading__text {\n  margin-top: 16px;\n}\n\n.explore-nlt .insight-field-name {\n  font-weight: bold;\n}\n\n", ""]);

// exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _caUiToolkit = __webpack_require__(6);

var _noProperties_ = __webpack_require__(60);

var _noProperties_2 = _interopRequireDefault(_noProperties_);

var _Empty = __webpack_require__(18);

var _Empty2 = _interopRequireDefault(_Empty);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _ExploreLayoutPropertiesProvider = __webpack_require__(101);

var _PropertiesPanel = __webpack_require__(355);

var _PropertiesPanel2 = _interopRequireDefault(_PropertiesPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var PropertiesContainer = function (_Component) {
	_inherits(PropertiesContainer, _Component);

	function PropertiesContainer() {
		_classCallCheck(this, PropertiesContainer);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	PropertiesContainer.prototype.render = function render() {
		var _props = this.props,
		    widgetId = _props.widgetId,
		    widgetType = _props.widgetType,
		    dashboardApi = _props.dashboardApi,
		    isDisplayed = _props.isDisplayed;


		if (_ExploreLayoutPropertiesProvider.PROFILE_PROPERTIES.types.indexOf(widgetType) === -1) {
			// empty container for widgets with no available properties
			return _react2.default.createElement(
				'div',
				{ className: 'card-layout-content__side-panel__empty-container' },
				_react2.default.createElement(_Empty2.default, {
					icon: _react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _noProperties_2.default.id, width: 192, height: 111 }),
					title: _StringResources2.default.get('properties_panel_no_props_title'),
					description: _StringResources2.default.get('properties_panel_no_props_description')
				})
			);
		} else {
			return _react2.default.createElement(_PropertiesPanel2.default, {
				widgetId: widgetId,
				widgetType: widgetType,
				dashboardApi: dashboardApi,
				isDisplayed: isDisplayed
			});
		}
	};

	return PropertiesContainer;
}(_react.Component);

PropertiesContainer.propTypes = {
	dashboardApi: _PropTypes2.default.object.isRequired,
	widgetId: _PropTypes2.default.string.isRequired,
	widgetType: _PropTypes2.default.string.isRequired,
	isDisplayed: _PropTypes2.default.boolean
};

exports.default = PropertiesContainer;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Empty = __webpack_require__(18);

var _Empty2 = _interopRequireDefault(_Empty);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _caUiToolkit = __webpack_require__(6);

var _noProperties_ = __webpack_require__(60);

var _noProperties_2 = _interopRequireDefault(_noProperties_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var PropertiesPanel = function (_Component) {
	_inherits(PropertiesPanel, _Component);

	function PropertiesPanel() {
		_classCallCheck(this, PropertiesPanel);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	PropertiesPanel.prototype.componentDidMount = function componentDidMount() {
		var _props = this.props,
		    dashboardApi = _props.dashboardApi,
		    widgetId = _props.widgetId;

		this.content = dashboardApi.getCanvas().getContent(widgetId);
		this.propertiesManager = dashboardApi.getFeature('propertiesManager');
		this._children = [];
		this._checkNewConditionalFormatting();
		this._renderProperties();
		this.props.dashboardApi.on('properties:refreshPane', this._onRefreshPropertiesPane, this);
	};

	// This event is triggered by live widget when there is a change in widget that needs to refresh properties pane.
	// If we are in child view, do not clear anything as we need to go back to previous view. 


	PropertiesPanel.prototype._onRefreshPropertiesPane = function _onRefreshPropertiesPane() {
		var child = this.propertiesManager.getCurrentChild();
		if (!child) {
			// Clear all loaded properties to reload the updated one.
			this._clearExistingProperties();
			if (this.ref) {
				this.ref.innerHTML = '';
			}
			this._renderProperties();
		}
	};

	PropertiesPanel.prototype._checkNewConditionalFormatting = function _checkNewConditionalFormatting() {
		var dashboardApi = this.props.dashboardApi;

		var featureChecker = dashboardApi.getGlassCoreSvc('.FeatureChecker');
		var isNewCFForXtabTable = this._isNewCFForXtabTable(dashboardApi);
		var isNewCFForKPI = !featureChecker.checkValue('dashboard', 'condFormat', 'disabled');
		this._isNewCFEnabled = isNewCFForXtabTable || isNewCFForKPI;
	};

	PropertiesPanel.prototype._clearExistingProperties = function _clearExistingProperties() {
		if (this._children && this._children.length) {
			var countViews = this._children.length;
			if (countViews === 1) {
				// only main properties, do not need to call PropertiesManager.closeChild
				this._children.pop();
			} else {
				var onCloseCb = this._removeChild.bind(this);
				for (var i = 1; i < this._children.length; ++i) {
					this.propertiesManager.closeChild(onCloseCb);
				}
				this._children.pop();
			}
		}
	};

	PropertiesPanel.prototype._removeChild = function _removeChild() {
		this._children.pop();
	};

	PropertiesPanel.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
		// change vis type case: content is the same but vis type will be changed, need to clear previous properties
		if (this.props.widgetType && this.props.widgetType !== nextProps.widgetType) {
			this._clearExistingProperties();
			if (this.ref) {
				this.ref.innerHTML = '';
			}
		}
	};

	PropertiesPanel.prototype.componentWillUnmount = function componentWillUnmount() {
		this._clearExistingProperties();
		this.ref = null;
		this._children = null;
		this.content = null;
		this._isNewCFForXtabTableEnabled = null;
		if (this.condFormatting && this._isNewCFEnabled) {
			this.condFormatting.deregisterProvider('explore');
			this.condFormatting = null;
		}
		this._isNewCFEnabled = null;
		this.props.dashboardApi.off('properties:refreshPane', this._onRefreshPropertiesPane, this);
	};

	PropertiesPanel.prototype.render = function render() {
		var _this2 = this;

		var _props2 = this.props,
		    dashboardApi = _props2.dashboardApi,
		    widgetType = _props2.widgetType;

		var isEmpty = false;

		if (this._isTableWidget(widgetType)) {
			isEmpty = !this._isNewCFForXtabTable(dashboardApi);
		}
		return isEmpty ? _react2.default.createElement(
			'div',
			{ className: 'card-layout-content__side-panel__empty-container' },
			_react2.default.createElement(_Empty2.default, {
				icon: _react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _noProperties_2.default.id, width: 192, height: 111 }),
				title: _StringResources2.default.get('properties_panel_no_props_title'),
				description: _StringResources2.default.get('properties_panel_no_props_description')
			})
		) : _react2.default.createElement('div', { className: 'explore-properties', ref: function ref(node) {
				_this2.ref = node;
			} });
	};

	PropertiesPanel.prototype._isVisSupportNewCF = function _isVisSupportNewCF(visType) {
		return ['Crosstab', 'List', 'KPI'].indexOf(visType) > -1;
	};

	PropertiesPanel.prototype._renderProperties = function _renderProperties() {
		var _this3 = this;

		var _props3 = this.props,
		    widgetId = _props3.widgetId,
		    isDisplayed = _props3.isDisplayed,
		    widgetType = _props3.widgetType;


		if (!isDisplayed) {
			return null;
		}

		if (!this.condFormatting && this._isNewCFEnabled && this._isVisSupportNewCF(widgetType)) {
			this.condFormatting = this.content.getFeature('ConditionalFormatting');
			this.condFormatting && this.condFormatting.registerProvider('explore', {
				addChildPropertyPanel: this.renderChildProperties.bind(this)
			});
		}

		var state = this.content.getFeature('state');
		state.whenStatusChanges(state.STATUS.RENDERED).then(function () {
			_this3.propertiesManager.getPropertiesView(widgetId).then(function (result) {
				if (result.el && _this3.ref) {
					var view = result.el;
					_this3._renderView(view);
				}
			});
		});
	};

	PropertiesPanel.prototype._renderView = function _renderView(view) {
		this._filterProperties(view);
		this._children.push(view);
		this._clearAndAppendChild(this.ref, view);
	};

	PropertiesPanel.prototype.renderChildProperties = function renderChildProperties(options) {
		var _this4 = this;

		if (this._isNewCFEnabled) {
			options.content.onCloseCb = this.onCloseChildCb.bind(this);
		}
		this.propertiesManager.getChildPropertiesView(options.content).then(function (result) {
			var childView = result.$el && result.$el.get(0);
			if (childView && _this4.ref) {
				_this4._renderView(childView);
			}
		});
	};

	PropertiesPanel.prototype.onCloseChildCb = function onCloseChildCb() {
		// clear child view and go back to parent panel view
		this._children.pop();
		if (this.ref && this._children.length) {
			var nextView = this._children[this._children.length - 1];
			this._clearAndAppendChild(this.ref, nextView);
		}
	};

	PropertiesPanel.prototype._filterProperties = function _filterProperties(element) {
		// removes the banner, tabs and collapsible headers
		var tab = element.querySelector('ul.nav.nav-tabs');
		tab && tab.parentNode.removeChild(tab);

		var banner = element.querySelector('.propertyRow.banner.flex.property_banner');
		banner && banner.parentNode.removeChild(banner);
		var _props4 = this.props,
		    dashboardApi = _props4.dashboardApi,
		    widgetType = _props4.widgetType;

		if (!(this._isCrosstabWidget(widgetType) && this._isNewCFForXtabTable(dashboardApi))) {
			// When new conditional-formatting is on, do not remove section title for crosstab (same as dashboard)
			var collapsible = element.querySelectorAll('.simpleCollapsibleSectionTitle.propertyRow');
			if (collapsible.length) {
				// IE 11 doesn't like for of
				for (var i = 0; i < collapsible.length; i++) {
					collapsible[i].parentNode.removeChild(collapsible[i]);
				}
			}
		}
		// make sure all collapsible properties are visible
		var properties = element.querySelectorAll('.collapsibleSection.property_chart.propertyUIControl');
		if (properties) {
			for (var _i = 0; _i < properties.length; _i++) {
				// classList.add is not supported in IE 11
				properties[_i].className += ' visible';
			}
		}
	};

	PropertiesPanel.prototype._clearAndAppendChild = function _clearAndAppendChild(node, child) {
		node.innerHTML = '';
		node.appendChild(child);
	};

	PropertiesPanel.prototype._isTableWidget = function _isTableWidget(widgetType) {
		return widgetType == 'List';
	};

	PropertiesPanel.prototype._isCrosstabWidget = function _isCrosstabWidget(widgetType) {
		return widgetType == 'Crosstab';
	};

	PropertiesPanel.prototype._isNewCFForXtabTable = function _isNewCFForXtabTable(dashboardApi) {
		if (typeof this._isNewCFForXtabTableEnabled === 'boolean') {
			return this._isNewCFForXtabTableEnabled;
		}
		this._isNewCFForXtabTableEnabled = !dashboardApi.getGlassCoreSvc('.FeatureChecker').checkValue('dashboard', 'xtabcondFormat', 'disabled');
		return this._isNewCFForXtabTableEnabled;
	};

	return PropertiesPanel;
}(_react.Component);

PropertiesPanel.propTypes = {
	dashboardApi: _PropTypes2.default.object.isRequired,
	widgetId: _PropTypes2.default.string.isRequired,
	widgetType: _PropTypes2.default.string.isRequired,
	isDisplayed: _PropTypes2.default.boolean
};

exports.default = PropertiesPanel;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(357);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./canvasTabs.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./canvasTabs.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore .explore-slots {\n  height: 100%;\n}\n\n.explore .explore-details {\n  height: 100%;\n  overflow-y: auto;\n}\n\n.explore .explore-properties {\n  height: 100%;\n  overflow-y: auto;\n}\n\n.card-layout-content__side-panel__empty-container {\n  min-height: 360px;\n  width: 100%;\n  height: 100%;\n}\n\n", ""]);

// exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _ExploreContainerItem = __webpack_require__(99);

var _ExploreContainerItem2 = _interopRequireDefault(_ExploreContainerItem);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExploreContainerItemList = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(ExploreContainerItemList, _Component);

	function ExploreContainerItemList() {
		_classCallCheck(this, ExploreContainerItemList);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	ExploreContainerItemList.prototype.render = function render() {
		return this.getRenderMarkup();
	};

	ExploreContainerItemList.prototype.getRenderMarkup = function getRenderMarkup() {
		var _this2 = this;

		void this.props.layoutOwner.renderTracker.shouldRenderCount; //only render when items list is ready

		var allChildren = this.props.layoutOwner.getChildrenRenderMarkup();

		var items = allChildren.map(function (entry) {
			return {
				render: function render() {
					return entry.value;
				},
				id: entry.id
			};
		});

		return _react2.default.createElement(
			'div',
			{ className: 'explore-content__cards' },
			items.map(function (item) {
				return _react2.default.createElement(_ExploreContainerItem2.default, {
					key: item.id,
					services: _this2.props.services,
					containerModel: _this2.props.model,
					exploreVM: _this2.props.model.exploreVM,
					item: item
				});
			})
		);
	};

	return ExploreContainerItemList;
}(_react.Component)) || _class;

ExploreContainerItemList.propTypes = {
	model: _PropTypes2.default.object.isRequired,
	services: _PropTypes2.default.object.isRequired,
	layoutOwner: _PropTypes2.default.object.isRequired
};

exports.default = ExploreContainerItemList;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


exports._getInterestingFieldNames = _getInterestingFieldNames;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _caUiToolkit = __webpack_require__(6);

var _unknownWarning_ = __webpack_require__(360);

var _unknownWarning_2 = _interopRequireDefault(_unknownWarning_);

var _InfoDialog = __webpack_require__(361);

var _InfoDialog2 = _interopRequireDefault(_InfoDialog);

var _VisualizationPreviewList = __webpack_require__(29);

var _VisualizationPreviewList2 = _interopRequireDefault(_VisualizationPreviewList);

var _FakeVisualizationPreviewList = __webpack_require__(362);

var _FakeVisualizationPreviewList2 = _interopRequireDefault(_FakeVisualizationPreviewList);

var _mobxReact = __webpack_require__(5);

var _mobxUtils = __webpack_require__(15);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _SidePanelUtil = __webpack_require__(59);

var _EditDiagramDropDown = __webpack_require__(368);

var _EditDiagramDropDown2 = _interopRequireDefault(_EditDiagramDropDown);

var _FieldInput = __webpack_require__(371);

var _FieldInput2 = _interopRequireDefault(_FieldInput);

var _FieldsList = __webpack_require__(106);

var _FieldsList2 = _interopRequireDefault(_FieldsList);

var _FakeFieldsList = __webpack_require__(380);

var _FakeFieldsList2 = _interopRequireDefault(_FakeFieldsList);

var _FieldsListLayout = __webpack_require__(381);

var _FieldsListLayout2 = _interopRequireDefault(_FieldsListLayout);

var _FakeFields = __webpack_require__(382);

var _FakeFields2 = _interopRequireDefault(_FakeFields);

var _Marketing = __webpack_require__(385);

var _Marketing2 = _interopRequireDefault(_Marketing);

var _StartingPointsViewModel = __webpack_require__(82);

var _visTypeChooser = __webpack_require__(91);

var _visTypeChooser2 = _interopRequireDefault(_visTypeChooser);

var _Empty = __webpack_require__(18);

var _Empty2 = _interopRequireDefault(_Empty);

var _Loading = __webpack_require__(67);

var _Loading2 = _interopRequireDefault(_Loading);

var _CSSHidingTransition = __webpack_require__(89);

var _CSSHidingTransition2 = _interopRequireDefault(_CSSHidingTransition);

var _CreateExplorationLayout = __webpack_require__(52);

var _CreateExplorationLayout2 = _interopRequireDefault(_CreateExplorationLayout);

var _FakeCreateExplorationLayout = __webpack_require__(389);

var _FakeCreateExplorationLayout2 = _interopRequireDefault(_FakeCreateExplorationLayout);

var _RelationshipViewWrapper = __webpack_require__(390);

var _RelationshipViewWrapper2 = _interopRequireDefault(_RelationshipViewWrapper);

var _RelationshipVisErrorView = __webpack_require__(113);

var _RelationshipVisErrorView2 = _interopRequireDefault(_RelationshipVisErrorView);

var _RECOMMENDATION_PROPERTIES = __webpack_require__(40);

var _RECOMMENDATION_PROPERTIES2 = _interopRequireDefault(_RECOMMENDATION_PROPERTIES);

var _Config = __webpack_require__(16);

var _Config2 = _interopRequireDefault(_Config);

var _ScopeModel = __webpack_require__(51);

__webpack_require__(109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ERROR_DEFAULT_TITLE = _StringResources2.default.get('error_something_unexpected');
var ERROR_DEFAULT_DESCRIPTION = _StringResources2.default.get('startingPoints_error_description_relationshipDiagram');

var QUERY_ITEM = 'QueryItem';
var CALCULATION = 'Calculation';

/*
 * Extract unique field names from interesting fields.
 * @param {object[]} interestingFields
 * @return {string[]} unique interesting field names
 */
function _getInterestingFieldNames(interestingFields) {
	return _underscore2.default.chain(interestingFields).map(function (_ref) {
		var name = _ref.name;
		return name;
	}).uniq().value();
}

var StartingPointsLayout = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(StartingPointsLayout, _Component);

	function StartingPointsLayout(props) {
		_classCallCheck(this, StartingPointsLayout);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._setFieldsListLayoutRef = function (node) {
			if (node) {
				_this.fieldsListLayoutRef = node;
			}
		};

		_this.services = props.services;
		_this.logger = _this.services.biGlass.glassContext.getCoreSvc('.Logger');
		_this.isNewStartingPoints = _this.props.model.isNewStartingPointsFeatureEnabled();
		_this.shouldUseDisambiguatedPaths = _this.props.model.shouldUseDisambiguatedPaths();
		_this.wizardContainerRef = _react2.default.createRef();
		_this.wizardInputSectionRef = _react2.default.createRef();
		_this.relationshipSectionRef = _react2.default.createRef();
		_this.fieldsRef = _react2.default.createRef();
		_this.state = {
			showInfoDialog: false,
			infoDialogContent: {}
		};
		return _this;
	}

	/**
  * @deprecated use {@link #renderFieldsSection}
  */


	StartingPointsLayout.prototype.renderOldFieldsSection = function renderOldFieldsSection() {
		var _this2 = this;

		var fields = this.props.model.fields.getFields();
		var allFields = fields.getAll();
		var interestingFields = fields.getInteresting();
		var toopltipID = _StringResources2.default.get('tooltipId');
		var fieldsValues = allFields.map(function (field) {
			return {
				'value': field.id,
				'label': field.name,
				'title': field.name + ' (' + toopltipID + ': ' + field.id + ')'
			};
		});
		return _react2.default.createElement(
			'div',
			{ className: 'starting-points-fields' },
			_react2.default.createElement(
				'div',
				{ className: 'starting-points-old-header' },
				_react2.default.createElement(
					'h1',
					null,
					_StringResources2.default.get('startingPoints_title')
				),
				_react2.default.createElement(
					'p',
					null,
					_StringResources2.default.get('startingPoints_subtitle')
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'old-focusField' },
				_react2.default.createElement(
					'div',
					{ className: 'focusFieldTitle' },
					_StringResources2.default.get('startingPoints_focusField')
				),
				_react2.default.createElement(
					'div',
					{ className: 'reset-button-container' },
					_react2.default.createElement(
						'button',
						{ className: 'reset-button', onClick: this.reset.bind(this) },
						_react2.default.createElement(
							'span',
							{ className: 'reset-button-mounse-focus-indicator', tabIndex: '-1' },
							_StringResources2.default.get('reset')
						)
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'old-fields-control' },
				_react2.default.createElement(_FieldInput2.default, {
					relationshipVM: this.props.model.relationship,
					values: fieldsValues,
					fields: this.props.model.fields,
					recommendedFields: interestingFields,
					module: this.props.activeDataSourceModule.value,
					onChange: function onChange() {
						return _this2.onFieldInputChange_old.apply(_this2, arguments);
					},
					getDropdownMaxHeight: function getDropdownMaxHeight() {
						return _this2._getDropdownMaxHeight_mainPage();
					}
				}),
				_react2.default.createElement(_FieldsListLayout2.default, {
					fields: interestingFields,
					focus: this.props.model.fields.getFocusField(),
					onClick: function onClick(field) {
						_this2._handleSetFocusField(field);
					},
					onFieldsChanged: function onFieldsChanged(newFields) {
						_this2.props.model.fields.setInterestingFields(newFields);
					}
				})
			)
		);
	};

	StartingPointsLayout.prototype.renderFieldsSection = function renderFieldsSection() {
		var _this3 = this;

		var _props$model$fields$g = this.props.model.fields.getFields(),
		    interesting = _props$model$fields$g.interesting;

		var interestingFields = interesting.state === _mobxUtils.FULFILLED ? interesting.value : [];
		var focusField = this.props.model.fields.getFocusField();
		var dataSourceName = this.props.model.getActiveDataSourceName();

		var fields = this.props.activeDataSourceModule.value ? _react2.default.createElement(
			'div',
			{ className: 'fields-control' },
			_react2.default.createElement(_FieldInput2.default, {
				relationshipVM: this.props.model.relationship,
				glassContext: this.services.biGlass.glassContext,
				fields: this.props.model.fields,
				module: this.props.activeDataSourceModule.value,
				recentFields: this.props.model.fields.getFields().getRecentFields(),
				recommendedFields: interestingFields,
				unfocusedPlaceholder: focusField && focusField.name || '',
				focusedPlaceholder: _StringResources2.default.get('startingPoints_fieldInputPlaceHolder'),
				onChange: function onChange() {
					return _this3.onFieldInputChange.apply(_this3, arguments);
				},
				getDropdownMode: function getDropdownMode(_ref2) {
					var userTextInput = _ref2.userTextInput;

					if (userTextInput && userTextInput.length) {
						return _FieldInput.FIELD_INPUT_DROPDOWN_MODES.METADATA_TREE;
					} else {
						return _FieldInput.FIELD_INPUT_DROPDOWN_MODES.INTERESTING_FIELDS;
					}
				},
				getDropdownMaxHeight: function getDropdownMaxHeight() {
					return _this3._getDropdownMaxHeight_mainPage();
				},
				activeDataSourceModule: this.props.activeDataSourceModule,
				shouldUseDisambiguatedPaths: this.shouldUseDisambiguatedPaths
			}),
			_react2.default.createElement(_EditDiagramDropDown2.default, {
				relationshipVM: this.props.model.relationship,
				onChangeScopeClick: this.onEditScopeClick.bind(this)
			})
		) : null;

		return _react2.default.createElement(
			'div',
			{ className: 'starting-points-fields', ref: this.fieldsRef },
			_react2.default.createElement(
				'div',
				{ className: 'starting-points-header' },
				_react2.default.createElement(
					'h1',
					null,
					_StringResources2.default.get('startingPoints_newtitle')
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'focusField' },
				_react2.default.createElement(
					'div',
					{ className: 'datasourceTitle' },
					dataSourceName
				),
				_react2.default.createElement(
					'div',
					{ className: 'reset-button-container' },
					_react2.default.createElement(
						'button',
						{ className: 'reset-button', onClick: this.reset.bind(this) },
						_react2.default.createElement(
							'span',
							{ className: 'reset-button-mounse-focus-indicator', tabIndex: '-1' },
							_StringResources2.default.get('reset')
						)
					)
				)
			),
			fields
		);
	};

	StartingPointsLayout.prototype.renderFakeFields = function renderFakeFields() {
		return _react2.default.createElement(_FakeFields2.default, null);
	};

	StartingPointsLayout.prototype.renderResetButton = function renderResetButton() {
		return _react2.default.createElement(
			'div',
			{ className: 'reset-button-container' },
			_react2.default.createElement(
				'button',
				{ className: 'reset-button', onClick: this.reset.bind(this) },
				_react2.default.createElement(
					'span',
					{ className: 'reset-button-mounse-focus-indicator', tabIndex: '-1' },
					_StringResources2.default.get('reset')
				)
			)
		);
	};

	StartingPointsLayout.prototype.renderRelationshipGraph = function renderRelationshipGraph() {
		return _react2.default.createElement(_RelationshipViewWrapper2.default, { module: this.props.activeDataSourceModule.value, startingPointsVM: this.props.model, services: this.services, fields: this.props.model.fields, shouldUseDisambiguatedPaths: this.shouldUseDisambiguatedPaths });
	};
	/**
  * Render the relationship diagram loading icon, enable the cancel button
  * Show alternate label after 3 seconds
  */


	StartingPointsLayout.prototype.renderRelationshipGraphLoader = function renderRelationshipGraphLoader(message) {
		return _react2.default.createElement(_Loading2.default, {
			enableTimer: this.props.model.relationship.allowLongRunningRequest(),
			enableCancel: _Config2.default.enable_cancel,
			cancelHandler: this._cancelRequest.bind(this),
			description: message,
			suggestions: _StringResources2.default.get('startingPoints_relationship_background_running_suggestions'),
			timerInterval: _Config2.default.request_progressive_status_timer_interval,
			alternateDescription: _StringResources2.default.get('startingPoints_relationship_timed_description')
		});
	};

	StartingPointsLayout.prototype.render = function render() {
		var _this4 = this;

		if (!this.props.activeDataSourceId) {
			return _react2.default.createElement(
				'div',
				{ className: 'starting-points-static', tabIndex: -1 },
				_react2.default.createElement(
					'div',
					{ className: 'starting-points-static__content' },
					_react2.default.createElement(_Marketing2.default, null)
				)
			);
		} else if (this.props.activeDataSourceModule.state === _mobxUtils.REJECTED) {
			return _react2.default.createElement(_Empty2.default, {
				tabIndex: -1,
				icon: _react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _unknownWarning_2.default.id, size: 'xxlarge' }),
				title: _StringResources2.default.get('error_unexpected'),
				description: _StringResources2.default.get('error_cannot_load_exploration')
			});
		} else if (this.props.activeDataSourceModule.state === _mobxUtils.FULFILLED) {
			var isSuccess = true;
			if (this.isNewStartingPoints) {
				return _react2.default.createElement(
					'div',
					{ className: 'starting-points-page', tabIndex: -1 },
					_react2.default.createElement(
						'div',
						{ className: 'starting-points-page-content' },
						this.props.model.fields.getFocusField() ? this.renderStartingPoints(isSuccess) : this.renderWizard(isSuccess),
						this.renderStartingPointsInfoDialog()
					)
				);
			}
			return _react2.default.createElement(
				'div',
				{ className: 'starting-points-page', tabIndex: -1 },
				_react2.default.createElement(
					_CSSHidingTransition2.default,
					{
						'in': !this.props.model.showModalVisTypePicker,
						classNames: 'explore__animation--fade' },
					_react2.default.createElement(
						'div',
						{ className: 'old-starting-points-page-content' },
						this.renderStartingPoints(isSuccess)
					)
				),
				_react2.default.createElement(_visTypeChooser2.default, {
					active: this.props.model.showModalVisTypePicker,
					className: 'explore__animation--slideDown',
					services: this.props.services,
					dashboardApi: this.props.dashboardApi,
					onVisTypeSelected: function onVisTypeSelected(id) {
						return _this4.onVisTypeSelected(id);
					},
					onClose: function onClose() {
						return _this4.closeVisTypeChooser();
					}
				})
			);
		} else {
			return _react2.default.createElement(_Loading2.default, { description: _StringResources2.default.get('startingPoints_wizard_data_loadingTitle') });
		}
	};

	StartingPointsLayout.prototype.renderStartingPointsInfoDialog = function renderStartingPointsInfoDialog() {
		var _this5 = this;

		if (this.state.showInfoDialog) {
			var _ref3 = this.state.infoDialogContent || {},
			    title = _ref3.title,
			    body = _ref3.body;

			var closeDialog = function closeDialog() {
				return _this5.setState({
					showInfoDialog: false,
					infoDialogContent: {}
				});
			};
			return _react2.default.createElement(_InfoDialog2.default, {
				title: title,
				body: body,
				onClose: closeDialog,
				onClickOk: closeDialog
			});
		} else {
			return null;
		}
	};

	StartingPointsLayout.prototype.renderWizard = function renderWizard(isSuccess) {
		if (isSuccess) {
			var fields = this.props.model.fields.getFields();
			var state = fields.interesting.state;


			if (state === _mobxUtils.FULFILLED) {
				return _react2.default.createElement(
					'div',
					{ className: 'wizard', ref: this.wizardContainerRef },
					_react2.default.createElement(
						'h1',
						null,
						_StringResources2.default.get('startingPoints_wizard_title')
					),
					_react2.default.createElement(
						'div',
						{ className: 'wizard-instructions' },
						_StringResources2.default.get('startingPoints_wizard_subtitle')
					),
					_react2.default.createElement(
						'div',
						{ className: 'wizardSections' },
						this.renderWizardTextInput(),
						this.renderWizardRecommendations(),
						this.renderWizardSkip()
					)
				);
			} else if (state === _mobxUtils.PENDING) {
				return _react2.default.createElement(_Loading2.default, { description: _StringResources2.default.get('startingPoints_wizard_recommended_loadingTitle') });
			} else if (state === _mobxUtils.REJECTED) {
				return this.renderErrorOnGettingFields(fields.interesting.value);
			} else {
				return _react2.default.createElement(_Loading2.default, { description: _StringResources2.default.get('startingPoints_wizard_loadingDataSource') });
			}
		}
	};

	StartingPointsLayout.prototype.renderWizardTextInput = function renderWizardTextInput() {
		var _this6 = this;

		var fields = this.props.model.fields.getFields();
		var _fields$interesting = fields.interesting,
		    state = _fields$interesting.state,
		    interestingFields = _fields$interesting.value;

		var instructionText = _StringResources2.default.get('startingPoints_wizard_columnField_placeholder_noFields');
		var wizardSectionTitle = _StringResources2.default.get('startingPoints_wizard_columnField_title', { dataSourceName: this.props.model.getActiveDataSourceName() });

		if (state === _mobxUtils.FULFILLED && interestingFields) {
			var interestingFieldNames = _getInterestingFieldNames(interestingFields);
			if (interestingFieldNames.length === 1) {
				instructionText = _StringResources2.default.get('startingPoints_wizard_columnField_placeholder_suggestedField', {
					suggestedField: interestingFieldNames[0]
				});
			} else if (interestingFieldNames.length > 1) {
				instructionText = _StringResources2.default.get('startingPoints_wizard_columnField_placeholder_suggestedFields', {
					suggestedField1: interestingFieldNames[0],
					suggestedField2: interestingFieldNames[1]
				});
			}
		}

		return _react2.default.createElement(
			'div',
			{ className: 'wizard-section wizard-text-input', ref: this.wizardInputSectionRef },
			_react2.default.createElement(
				'div',
				{ className: 'wizard-section-title' },
				wizardSectionTitle
			),
			_react2.default.createElement(_FieldInput2.default, {
				relationshipVM: this.props.model.relationship,
				close: true,
				fields: this.props.model.fields,
				module: this.props.activeDataSourceModule.value,
				unfocusedPlaceholder: instructionText,
				focusedPlaceholder: instructionText,
				onChange: function onChange() {
					return _this6.onFieldInputChange.apply(_this6, arguments);
				},
				getDropdownMode: function getDropdownMode() {
					return _FieldInput.FIELD_INPUT_DROPDOWN_MODES.METADATA_TREE;
				},
				getDropdownMaxHeight: function getDropdownMaxHeight() {
					return _this6._getDropdownMaxHeight_wizard();
				},
				activeDataSourceModule: this.props.activeDataSourceModule,
				shouldUseDisambiguatedPaths: this.shouldUseDisambiguatedPaths
			})
		);
	};

	StartingPointsLayout.prototype.renderWizardRecommendations = function renderWizardRecommendations() {
		var _this7 = this;

		var fields = this.props.model.fields.getFields();
		var _fields$interesting2 = fields.interesting,
		    state = _fields$interesting2.state,
		    interestingFields = _fields$interesting2.value;

		if (state === _mobxUtils.PENDING) {
			return _react2.default.createElement(
				'div',
				{ className: 'wizard-section' },
				_react2.default.createElement(
					'div',
					{ className: 'wizard-section-title' },
					_StringResources2.default.get('startingPoints_wizard_recommended_loadingTitle')
				),
				_react2.default.createElement(_FakeFieldsList2.default, { numberOfFields: 5 })
			);
		} else if (state === _mobxUtils.FULFILLED) {
			if (!interestingFields || interestingFields.length === 0) {
				var title = _StringResources2.default.get('startingPoints_recommended_fields_unavailable');
				var desc = _StringResources2.default.get('startingPoints_wizard_recommendations_enter_column');
				var options = {
					error: {},
					preferredTitle: title,
					preferredDescription: desc,
					textAlign: 'left',
					iconId: null,
					suggestions: null
				};
				return _react2.default.createElement(
					'div',
					{ className: 'wizard-section' },
					this._renderErrorView(options)
				);
			} else {
				return _react2.default.createElement(
					'div',
					{ className: 'wizard-section' },
					_react2.default.createElement(
						'div',
						{ className: 'wizard-section-title' },
						_StringResources2.default.get('startingPoints_wizard_recommended_title')
					),
					_react2.default.createElement(_FieldsList2.default, {
						fields: interestingFields && interestingFields.length ? interestingFields.map(function (_ref4) {
							var id = _ref4.id,
							    name = _ref4.name;
							return { id: id, label: name };
						}) : [],
						onSelectField: function onSelectField(_ref5) {
							var id = _ref5.id;
							return _this7.onSetFocusField(id);
						},
						activeDataSourceModule: this.props.activeDataSourceModule,
						shouldUseDisambiguatedPaths: this.shouldUseDisambiguatedPaths,
						relationshipVM: this.props.model.relationship
					})
				);
			}
		}
	};

	/**
  * Render the error message when siganificant error happens on wizard
  * @param  {Object} Error object
  * @return {Object} return the relationship vis error view
  */


	StartingPointsLayout.prototype.renderErrorOnGettingFields = function renderErrorOnGettingFields(error) {
		//TODO: Cleaning up, moving the following out
		var title = _StringResources2.default.get('startingPoints_recommended_fields_unavailable');
		var msgDescription_unenriched = _StringResources2.default.get('startingPoints_unable_to_fetch_recommendations_unenriched_datasource');
		var msgDescription_unsupported = _StringResources2.default.get('startingPoints_unable_to_fetch_recommendations_unsupported_datasource');
		var sevreErrors = {
			'Smarts-IFR-49': {
				severity: 1,
				msgTitle: title,
				msgDesc: msgDescription_unsupported
			},
			'Smarts-IFR-21': {
				msgTitle: title,
				severity: 1,
				msgDesc: msgDescription_unenriched
			}
		};
		if (error) {
			var smartsErrorCode = error.smartsCode;
			var smartsError = sevreErrors[smartsErrorCode];
			if (!smartsError) {
				return this._renderErrorView({ error: error });
			}
			if (smartsError.severity === 1) {
				var options = {
					error: smartsError,
					preferredTitle: smartsError.msgTitle,
					preferredDescription: smartsError.msgDesc,
					textAlign: 'center'
				};
				return this._renderErrorView(options);
			} else if (smartsError.severity === 2) {
				var _title = _StringResources2.default.get('startingPoints_recommended_fields_unavailable');
				var desc = _StringResources2.default.get('startingPoints_wizard_recommendations_enter_column');
				var _options = {
					error: smartsError,
					preferredTitle: _title,
					preferredDescription: desc,
					textAlign: 'left',
					iconId: null,
					suggestions: null
				};
				return _react2.default.createElement(
					'div',
					{ className: 'wizard', ref: this.wizardContainerRef },
					_react2.default.createElement(
						'h1',
						null,
						_StringResources2.default.get('startingPoints_wizard_title')
					),
					_react2.default.createElement(
						'div',
						{ className: 'wizard-instructions' },
						_StringResources2.default.get('startingPoints_wizard_subtitle')
					),
					_react2.default.createElement(
						'div',
						{ className: 'wizardSections' },
						this.renderWizardTextInput(),
						this._renderErrorView(_options)
					)
				);
			}
		} else {
			return this._renderErrorView({ error: error });
		}
	};

	StartingPointsLayout.prototype.renderWizardSkip = function renderWizardSkip() {
		var _this8 = this;

		var fields = this.props.model.fields.getFields();
		var interestingFields = fields.interesting.value;

		return !interestingFields || interestingFields.length === 0 ?
		//Do not render wizard skip, if there are no interesting field
		null : _react2.default.createElement(
			'div',
			{ className: 'wizard-section' },
			_react2.default.createElement(
				'span',
				{
					className: 'wizard-link',
					tabIndex: '0',
					onClick: function onClick() {
						return _this8._skipLinkOnClick();
					},
					onKeyDown: function onKeyDown(e) {
						return _this8._skipLinkOnKeyDown(e);
					}
				},
				_StringResources2.default.get('startingPoints_wizard_skip_link')
			)
		);
	};

	StartingPointsLayout.prototype._renderErrorView = function _renderErrorView(_ref6) {
		var error = _ref6.error,
		    preferredTitle = _ref6.preferredTitle,
		    preferredDescription = _ref6.preferredDescription,
		    textAlign = _ref6.textAlign,
		    iconId = _ref6.iconId,
		    suggestions = _ref6.suggestions;

		return _react2.default.createElement(_RelationshipVisErrorView2.default, {
			alignment: textAlign,
			tabIndex: -1,
			iconId: iconId,
			error: error,
			preferredTitle: preferredTitle,
			preferredDescription: preferredDescription,
			suggestions: suggestions
		});
	};

	StartingPointsLayout.prototype._skipLinkOnClick = function _skipLinkOnClick() {
		this._setAnyFocusField();
	};

	StartingPointsLayout.prototype._skipLinkOnKeyDown = function _skipLinkOnKeyDown(event) {
		switch (event.key) {
			case ' ': // space
			case 'Enter':
				this._setAnyFocusField();
				break;
		}
	};

	StartingPointsLayout.prototype._setAnyFocusField = function _setAnyFocusField() {
		var _props$model$fields$g2 = this.props.model.fields.getFields(),
		    _props$model$fields$g3 = _props$model$fields$g2.interesting,
		    state = _props$model$fields$g3.state,
		    interestingFields = _props$model$fields$g3.value;

		if (state === _mobxUtils.FULFILLED && interestingFields.length) {
			//Usual case: select first interesting field
			this.onSetFocusField(interestingFields[0].id);
		} else {
			//If there's a delay loading interesting fields, select first column
			var allColumns = this.props.activeDataSourceModule.value.getMetadataColumns();
			this.onSetFocusField(allColumns[0].getId());
		}
	};

	StartingPointsLayout.prototype.renderStartingPoints = function renderStartingPoints(isSuccess) {
		if (this.isNewStartingPoints) {
			return [this.renderRelationshipSection(isSuccess), this.renderVisualizationsSection(isSuccess)];
		}
		return [this.renderVisualizationsSectionOld(isSuccess), this.renderRelationshipSectionOld(isSuccess)];
	};

	StartingPointsLayout.prototype.renderRelationshipSectionOld = function renderRelationshipSectionOld(isSuccess) {
		var relationshipSupportedState = this.props.model.relationshipSupported && this.props.model.relationshipSupported.state;
		var contents = [];

		if (relationshipSupportedState === _mobxUtils.REJECTED) {
			contents.push(_react2.default.createElement(_RelationshipVisErrorView2.default, {
				error: this.props.model.relationshipSupported.error,
				defaultTitle: ERROR_DEFAULT_TITLE,
				defaultDescription: ERROR_DEFAULT_DESCRIPTION
			}));
		} else if (!isSuccess /* i.e., loading data source */) {
				contents.push(this.renderFakeFields());
				contents.push(this.renderRelationshipGraphLoader(_StringResources2.default.get('startingPoints_loadingPage')));
			} else if (!relationshipSupportedState || relationshipSupportedState === _mobxUtils.PENDING /* i.e., loading relationships */) {
				contents.push(this.renderFakeFields());
				contents.push(this.renderRelationshipGraphLoader(_StringResources2.default.get('startingPoints_loadingRelationships')));
			} else /* i.e., relationships loaded */{
				contents.push(this.renderOldFieldsSection());
				contents.push(this.renderRelationshipGraph());
			}

		return _react2.default.createElement(
			'div',
			{ className: 'starting-points-page__oldRelationshipSection' },
			contents
		);
	};

	StartingPointsLayout.prototype.renderRelationshipSection = function renderRelationshipSection() {
		var targetModel = this.props.model.relationship.getTargetModel();
		var relationshipSupportedState = targetModel && targetModel.data && targetModel.data.state;
		return _react2.default.createElement(
			'div',
			{ className: 'starting-points-page__relationshipSection', ref: this.relationshipSectionRef },
			this.renderFieldsSection(),
			relationshipSupportedState === _mobxUtils.PENDING ? this._renderPendingUI() : this.renderRelationshipGraph()
		);
	};

	StartingPointsLayout.prototype._renderPendingUI = function _renderPendingUI() {
		return _react2.default.createElement(
			'div',
			{ className: 'starting-points-page__relationshipSection__pendingUI' },
			this.renderRelationshipGraphLoader(_StringResources2.default.get('startingPoints_loadingRelationshipGaph'))
		);
	};

	StartingPointsLayout.prototype._cancelRequest = function _cancelRequest() {
		this.props.model.relationship.cancelRequestDelegator();
	};

	/**
  * @deprecated use {@link #renderVisualizationsSection}
  */


	StartingPointsLayout.prototype.renderVisualizationsSectionOld = function renderVisualizationsSectionOld(isSuccess) {
		var _this9 = this;

		var contents = [];

		if (isSuccess) {
			contents.push(_react2.default.createElement(_CreateExplorationLayout2.default
			// Show icon when there are no recommended vis list to render
			, { fill: this.renderRecommendedVisList(maxVisualizations) === null,
				services: this.props.services,
				activeDataSourceId: this.props.activeDataSourceId,
				handleShowVisTypesClick: function handleShowVisTypesClick() {
					return _this9._showVisTypesDialog();
				},
				createVis: function createVis(widgetSpecs) {
					return _this9.addVisCard(widgetSpecs);
				},
				dashboardApi: this.props.dashboardApi,
				key: 'create'
			}));

			var maxVisualizations = this.props.maxDisplayedItems || 3;
			contents.push(this.renderRecommendedVisList(maxVisualizations));
		} else {
			contents.push(_react2.default.createElement(_FakeCreateExplorationLayout2.default, { fill: true }));
		}

		return _react2.default.createElement(
			'div',
			{ className: 'starting-points-visualizations', key: 'visualizations' },
			contents
		);
	};

	StartingPointsLayout.prototype.renderVisualizationsSection = function renderVisualizationsSection(isSuccess) {
		var contents = [];
		var maxVisualizations = this.props.maxDisplayedItems || 3;

		if (isSuccess) {
			contents.push(this.renderRecommendedVisList(maxVisualizations));
			var influencers = this.props.model.getSelectedInfluencers();
			if (influencers) {
				var influencerLabel = influencers.map(function (_ref7) {
					var label = _ref7.label;
					return label;
				}).join(', ');
				return _react2.default.createElement(
					'div',
					{ className: 'starting-points-visualizations' },
					_react2.default.createElement(
						'div',
						{ className: 'vis-preview-list-header' },
						_react2.default.createElement(
							'h2',
							null,
							_StringResources2.default.get('startingPoints_chooseVis')
						),
						_react2.default.createElement(
							'h3',
							null,
							_StringResources2.default.get('startingPoints_selectCard')
						),
						_react2.default.createElement(
							'h4',
							null,
							_StringResources2.default.get('startingPoints_exploreVisRelated') + (' \'' + influencerLabel + '\'')
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'vis-preview-list-wrapper', key: 'visualizations' },
						contents
					)
				);
			} else {
				return _react2.default.createElement(
					'div',
					{ className: 'starting-points-visualizations' },
					_react2.default.createElement(
						'div',
						{ className: 'vis-preview-list-wrapper', key: 'visualizations' },
						contents
					)
				);
			}
		} else {
			contents.push(_react2.default.createElement(_FakeCreateExplorationLayout2.default, { fill: true }));
		}
		return;
	};

	StartingPointsLayout.prototype._showVisTypesDialog = function _showVisTypesDialog() {
		this.props.model.setShowModalVisTypePicker(true);
	};

	StartingPointsLayout.prototype.onEditScopeClick = function onEditScopeClick() {
		var _this10 = this;

		var target = this.props.model.relationship.getTargetModel();
		var scope = target && target.scope;
		if (!scope) {
			return;
		}
		var dataSourcesFeature = this.props.dashboardApi.getFeature('DataSources');
		return dataSourcesFeature.getDataSource(this.props.activeDataSourceId).getModule().then(function (module) {
			var mapIdToMoserObject = function mapIdToMoserObject(id) {
				return module.getMetadataColumn(id).getMoserObject();
			};
			var recommendedFieldIds = void 0;
			var scopedFieldIds = void 0;
			var recommendedItems = void 0;
			var initialItems = void 0;
			return scope.getDefaultRecommendations().then(function (recommendations) {
				recommendedFieldIds = recommendations.map(function (item) {
					return item.fieldIDForExpression;
				});
				recommendedItems = recommendedFieldIds.map(mapIdToMoserObject);
				var scopedFields = scope.getScopedFields();
				if (scopedFields) {
					scopedFieldIds = scopedFields.map(function (item) {
						return item.fieldIDForExpression;
					});
					initialItems = scopedFieldIds.map(mapIdToMoserObject);
				} else {
					scopedFieldIds = recommendedFieldIds;
					initialItems = recommendedItems;
				}
			}).then(function () {
				return module.getShapingHelper().openItemPicker({
					labels: {
						title: _StringResources2.default.get('edit_scope_title'),
						subTitle: _StringResources2.default.get('edit_scope_subtitle')
					},
					initialItems: initialItems,
					recommendedItems: recommendedItems,
					max: _Config2.default.max_scoped_columns,
					transformDroppedItems: _this10._transformDroppedItems.bind(_this10),
					canDrop: _this10._canDrop.bind(_this10)
				}).then(function (selectedItems) {
					// when click cancel or close the dialog, selectedItems will be null
					if (!selectedItems || !selectedItems.length) {
						return;
					}
					var relationshipVM = _this10.props.model.relationship;
					//if cannot set scope, then show dialog
					var result = relationshipVM.canFetchData(target.id, 'editScope' /* action */);
					if (!result.canFetchData) {
						var _result$infoDialogCon = result.infoDialogContent,
						    title = _result$infoDialogCon.title,
						    body = _result$infoDialogCon.body;
						//show dialog

						_this10.setState({
							infoDialogContent: {
								title: title,
								body: body
							},
							showInfoDialog: true
						});
						return;
					}
					var mapMoserObjectToId = function mapMoserObjectToId(item) {
						return item.getIdForExpression();
					};
					var selectedColumnIds = selectedItems.map(mapMoserObjectToId);
					//build scoped columns
					var scopedColumns = selectedColumnIds.map(_ScopeModel.parseFieldIDForExpression);
					target.setScope(scopedColumns);
				});
			});
		});
	};

	StartingPointsLayout.prototype._transformDroppedItems = function _transformDroppedItems(items) {
		if (items && items.length) {
			var currentTargetId = this.props.model.relationship.getCurrentTargetId();
			var allowedTypes = [QUERY_ITEM, CALCULATION];
			items = items.filter(function (item) {
				return allowedTypes.indexOf(item.getObjectType()) !== -1 && item.getIdForExpression() !== currentTargetId;
			});
		}
		return items;
	};

	StartingPointsLayout.prototype._canDrop = function _canDrop(items) {
		if (!items || items.length === 0) {
			return false;
		} else {
			return true;
		}
	};

	StartingPointsLayout.prototype.onVisTypeSelected = function onVisTypeSelected(visTypeId) {
		this.closeVisTypeChooser();
		this.addVisCardFromVisType(visTypeId);
		(0, _SidePanelUtil.openDatasetPane)(this.props.dashboardApi);
	};

	StartingPointsLayout.prototype.closeVisTypeChooser = function closeVisTypeChooser() {
		this.props.model.setShowModalVisTypePicker(false);
	};

	StartingPointsLayout.prototype.addVisCard = function addVisCard(widgetSpecs, tabDisplay) {
		var transactionIdPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'startingPointsCreate';

		this.props.addVisCard(widgetSpecs, transactionIdPrefix, tabDisplay);
	};

	StartingPointsLayout.prototype.addVisCardFromVisType = function addVisCardFromVisType(visTypeId) {
		var widgetSpec = {
			model: {
				type: 'live',
				visId: visTypeId,
				visTypeLocked: true,
				data: {}
			}
		};
		return this.addVisCard(widgetSpec, 'slots', 'startingPointsCreate');
	};

	StartingPointsLayout.prototype._onPromptingError = function _onPromptingError(recommendationItem) {
		this.props.model.addRecommendationsOfStaticType(recommendationItem.key);
	};

	StartingPointsLayout.prototype.renderRecommendedVisList = function renderRecommendedVisList(maxDisplayedItems) {
		var fields = this.props.model.getSelectedInfluencers();

		if (!fields) {
			return null;
		}

		var fieldIds = fields.map(function (_ref8) {
			var id = _ref8.id;
			return id;
		});

		var content = null;
		var recommendations = this.props.model.getRecommendations(fieldIds);
		if (recommendations.state === _mobxUtils.PENDING) {
			content = _react2.default.createElement(_FakeVisualizationPreviewList2.default, { numberOfItems: maxDisplayedItems, isNewLayout: this.isNewStartingPoints, showTextPending: !this.isNewStartingPoints, itemSize: this.isNewStartingPoints ? 'medium' : 'large' });
		} else if (recommendations.state === _mobxUtils.FULFILLED && recommendations.value.length) {
			var items = recommendations.value;
			content = _react2.default.createElement(_VisualizationPreviewList2.default, {
				maxDisplayedItems: maxDisplayedItems,
				items: items,
				dashboardApi: this.props.dashboardApi,
				onClickItem: this._onSelectVisualization.bind(this),
				onAddItem: this._onAddVisualization.bind(this),
				additionalProperties: _RECOMMENDATION_PROPERTIES2.default,
				logger: this.logger,
				isNewLayoutEnabled: this.isNewStartingPoints,
				onPromptingError: this._onPromptingError.bind(this),
				itemSize: this.isNewStartingPoints ? 'medium' : 'large'
			});
		} else {
			//TODO: This should be moved to @waca/vis-recommender
			content = _react2.default.createElement(
				'div',
				{ className: 'vis-preview-list-wrapper__error' },
				_react2.default.createElement(_Empty2.default, {
					icon: _react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _unknownWarning_2.default.id, size: 'normal', intent: 'danger' }),
					description: _StringResources2.default.get('error_cannot_load_recommended')
				})
			);
		}
		if (this.isNewStartingPoints) {
			return content;
		}
		return _react2.default.createElement(
			'div',
			{ className: 'vis-preview-list-wrapper' },
			content
		);
	};

	StartingPointsLayout.prototype._renderRefreshButton = function _renderRefreshButton() {
		return _react2.default.createElement(
			'button',
			{ className: 'vis-preview-list-wrapper__error__refresh-button', onClick: this._refreshVisualizations.bind(this) },
			_react2.default.createElement(
				'span',
				{ className: 'refresh-button-mouse-focus-indicator', tabIndex: '-1' },
				_StringResources2.default.get('refresh_visualizations')
			)
		);
	};

	StartingPointsLayout.prototype._handleSetFocusField = function _handleSetFocusField(focusFieldId) {
		this.props.model.fields.setFocusField(focusFieldId);
	};

	StartingPointsLayout.prototype.onFieldInputChange_old = function onFieldInputChange_old(value) {
		return this.props.model.fields.addField && this.props.model.fields.addField(value);
	};

	StartingPointsLayout.prototype.onFieldInputChange = function onFieldInputChange(value) {
		this.onSetFocusField(value);
	};

	StartingPointsLayout.prototype.onSetFocusField = function onSetFocusField(focusFieldId) {
		var relationshipVM = this.props.model.relationship;
		var result = relationshipVM.canFetchData(focusFieldId, 'changeTarget' /* action */);
		if (result.canFetchData === true) {
			this.props.model.fields.setFocusField(focusFieldId);
		} else {
			var _result$infoDialogCon2 = result.infoDialogContent,
			    title = _result$infoDialogCon2.title,
			    body = _result$infoDialogCon2.body;
			//show dialog

			this.setState({
				infoDialogContent: {
					title: title,
					body: body
				},
				showInfoDialog: true
			});
		}
	};

	StartingPointsLayout.prototype.reset = function reset() {
		this.props.model.reset();
	};

	StartingPointsLayout.prototype._onSelectVisualization = function _onSelectVisualization(recommendation) {
		if (recommendation && recommendation.widgets && recommendation.widgets[0]) {
			this._addRecommendation(recommendation.widgets[0], 'startingPointsSelectRecommendation');
			(0, _SidePanelUtil.openCardsPane)(this.props.dashboardApi);
		}
	};

	StartingPointsLayout.prototype._onAddVisualization = function _onAddVisualization(recommendation) {
		if (recommendation && recommendation.widgets && recommendation.widgets[0]) {
			this._addRecommendation(recommendation.widgets[0], 'addRelatedRecommendation');
			(0, _SidePanelUtil.openCardsPane)(this.props.dashboardApi);
		}
	};

	StartingPointsLayout.prototype._addRecommendation = function _addRecommendation(recommendation, transactionIdPrefix) {
		if (recommendation.spec && recommendation.spec.properties) {
			recommendation.spec.properties.some(function (prop) {
				if (prop.id === 'widget.legend.display') {
					prop.value = true; // re-adding legend once previews generated
					return true;
				}
			});
		}
		var isRecommendationOfStaticType = this.props.model.isRecommendationOfStaticType(recommendation.key);
		var widgetSpecs = {
			model: Object.assign({
				type: 'live',
				visTypeLocked: true
			}, recommendation.spec),
			layoutProperties: {
				isStaticWidget: isRecommendationOfStaticType
			}
		};
		return this.addVisCard(widgetSpecs, undefined, transactionIdPrefix);
	};

	StartingPointsLayout.prototype._refreshVisualizations = function _refreshVisualizations() {
		this.props.model.loadVisForSelectedInfluencers();
	};

	StartingPointsLayout.prototype._getDropdownMaxHeight_wizard = function _getDropdownMaxHeight_wizard() {
		var containerNode = this.wizardContainerRef.current;
		var inputNode = this.wizardInputSectionRef.current;
		if (containerNode && inputNode) {
			return containerNode.clientHeight - inputNode.clientHeight;
		}
		return 0;
	};

	StartingPointsLayout.prototype._getDropdownMaxHeight_mainPage = function _getDropdownMaxHeight_mainPage() {
		var relationshipNode = this.relationshipSectionRef.current;
		var fieldsNode = this.fieldsRef.current;
		if (relationshipNode && fieldsNode) {
			return relationshipNode.clientHeight - fieldsNode.clientHeight;
		}
		return 0;
	};

	return StartingPointsLayout;
}(_react.Component)) || _class;

StartingPointsLayout.propTypes = {
	dashboardApi: _PropTypes2.default.object.isRequired,
	model: _PropTypes2.default.stateTree(_StartingPointsViewModel.StartingPointsViewModel).isRequired,
	maxDisplayedItems: _PropTypes2.default.object,
	services: _PropTypes2.default.object.isRequired,
	activeDataSourceId: _PropTypes2.default.string,
	activeDataSourceModule: _PropTypes2.default.observableObject, //TODO: Merge with activeDataSourceId. Right now, this is only being used to determine whether activeDataSourceId represents an existing data source
	addVisCard: _PropTypes2.default.func.isRequired
};

exports.default = StartingPointsLayout;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (a, s) {
  if ("object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module))) module.exports = s(__webpack_require__(23));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(23)], __WEBPACK_AMD_DEFINE_FACTORY__ = (s),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var i = s("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("@ba-ui-toolkit/ba-graphics/dist/illustrations-js/ba-graphics-icons-commons.js") : a["@ba-ui-toolkit/ba-graphics/dist/illustrations-js/ba-graphics-icons-commons.js"]);for (var e in i) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : a)[e] = i[e];
    }
  }
}("undefined" != typeof self ? self : undefined, function (a) {
  return webpackJsonPBaGraphics([12], { "3865314c5959606874d4": function c5959606874d4(s, i) {
      s.exports = a;
    }, "6986996ff9f096db46c3": function ff9f096db46c3(a, s, i) {
      "use strict";
      Object.defineProperty(s, "__esModule", { value: !0 });var e = i("3865314c5959606874d4"),
          o = (i.n(e), i("fb78783289a5366a88ff"));s.default = o.a;
    }, fb78783289a5366a88ff: function fb78783289a5366a88ff(a, s, i) {
      "use strict";
      var e = i("9689a9c94ae38b47fa2c"),
          o = i.n(e),
          t = i("9ce58a7deea14f49ef01"),
          c = i.n(t),
          n = new o.a({ id: "unknown-warning_128_v7", use: "unknown-warning_128_v7-usage", viewBox: "0 0 128 128", content: '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" id="unknown-warning_128_v7"><circle class="ba-graphics-gray1" cx="55" cy="75.1" r="36" /><path class="ba-graphics-gray1" d="M104.7 50.6l-26.9 7.2-1.2-4.8 14.3-3.8-8.6-32.1 12.5-3.2-3.2 20.6z" /><path class="ba-graphics-gray1" d="M88 47.7L35.3 61.8l-9.9-36.7L78.2 11z" /><path class="ba-graphics-gray20" d="M58.5 22.3c-7.8-1-14.9 4.6-15.9 12.4S47.2 49.6 55 50.6 69.9 46 70.9 38.2c.9-7.8-4.6-14.9-12.4-15.9z" /><path class="ba-graphics-white" d="M58.9 40.4l-1.3-9.3-1.2-4.2-4.2 1.1 1.1 4.2 3.5 8.8zm-.6 1.8c-1.2.3-1.8 1.5-1.5 2.7s1.5 1.8 2.7 1.5 1.8-1.5 1.5-2.7c-.3-1.1-1.5-1.8-2.7-1.5z" /><path class="ba-graphics-gray20" d="M76.1 60.7l32.7-8.8-14.7-18.2 3.6-23.1-16 4.3L79.8 8l-55 14.8L23 16l-3.4.9 27.6 103.2 3.4-.9-14.7-55.1 38.4-10.3 1.8 6.9zm18.7-46.8l-3.1 19.5-.2 1 .7.8 12.4 15.3-26.8 7.2-1.2-4.7 14.3-3.8-8.6-32.1 12.5-3.2zM35.3 61.8l-9.9-36.7L78.2 11 88 47.7 35.3 61.8z" /></symbol>' });c.a.add(n);s.a = n;
    } }, ["6986996ff9f096db46c3"]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)(module)))

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _caUiToolkit = __webpack_require__(6);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var InfoDialog = function (_Component) {
	_inherits(InfoDialog, _Component);

	function InfoDialog() {
		_classCallCheck(this, InfoDialog);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	InfoDialog.prototype.render = function render() {
		var _props = this.props,
		    title = _props.title,
		    body = _props.body,
		    dialogProps = _props.dialogProps;

		return _react2.default.createElement(
			_caUiToolkit.Dialog,
			_extends({}, dialogProps, { onClose: this.props.onClose }),
			_react2.default.createElement(
				_caUiToolkit.Dialog.Header,
				null,
				' ',
				title,
				' '
			),
			_react2.default.createElement(
				_caUiToolkit.Dialog.Body,
				null,
				' ',
				body,
				' '
			),
			_react2.default.createElement(
				_caUiToolkit.Dialog.Footer,
				null,
				_react2.default.createElement(_caUiToolkit.Dialog.Button, { primary: true, label: 'OK', onClick: this.props.onClickOk }),
				this.props.showCancelButton ? _react2.default.createElement(_caUiToolkit.Dialog.Button, { label: 'Cancel', onClick: this.props.onClickCancel }) : null
			)
		);
	};

	return InfoDialog;
}(_react.Component);

InfoDialog.defaultProps = {
	title: '',
	body: '',
	showCancelButton: false,
	dialogProps: {
		'size': 'small',
		'clickaway': true,
		'width': '200px',
		'minWidth': '100px',
		'maxWidth': '400px' //TODO: for consistence in explore, we maybe expose less props
	} };
InfoDialog.propTypes = {
	title: _PropTypes2.default.string.isRequired,
	body: _PropTypes2.default.string.isRequired,
	showCancelButton: _PropTypes2.default.boolean,
	onClose: _PropTypes2.default.func,
	onClickOk: _PropTypes2.default.func,
	onClickCancel: _PropTypes2.default.func,
	dialogProps: _PropTypes2.default.object
};

exports.default = InfoDialog;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FakeVisualizationPreview = __webpack_require__(363);

var _FakeVisualizationPreview2 = _interopRequireDefault(_FakeVisualizationPreview);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(58);

__webpack_require__(366);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var FakeVisualizationPreviewList = function (_Component) {
	_inherits(FakeVisualizationPreviewList, _Component);

	function FakeVisualizationPreviewList() {
		_classCallCheck(this, FakeVisualizationPreviewList);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	FakeVisualizationPreviewList.prototype.render = function render() {
		var classNames = (0, _classnames2.default)({
			'vis-recommender__preview-list vis-recommender__preview-list--horizontal': this.props.horizontal,
			'vis-recommender__preview-list vis-recommender__preview-list--vertical': !this.props.horizontal
		});
		var itemsClassNames = (0, _classnames2.default)({
			'vis-recommender__preview-list--horizontal__items': this.props.horizontal,
			'vis-recommender__preview-list--vertical__items': !this.props.horizontal
		});

		return _react2.default.createElement(
			'div',
			{ className: classNames },
			_react2.default.createElement(
				'div',
				{ className: itemsClassNames },
				this.renderListItems()
			),
			_react2.default.createElement('div', { className: 'vis-recommender__preview-list__fake-see-more' })
		);
	};

	FakeVisualizationPreviewList.prototype.renderListItems = function renderListItems() {
		var listItems = [];
		for (var i = 0; i < this.props.numberOfItems; i++) {
			listItems.push(_react2.default.createElement(_FakeVisualizationPreview2.default, {
				horizontal: this.props.horizontal,
				key: i,
				isNewLayout: this.props.isNewLayout,
				showTextPending: this.props.showTextPending,
				size: this.props.itemSize
			}));
		}
		return listItems;
	};

	return FakeVisualizationPreviewList;
}(_react.Component);

FakeVisualizationPreviewList.propTypes = {
	horizontal: _propTypes2.default.bool,
	numberOfItems: _propTypes2.default.number,
	showTextPending: _propTypes2.default.bool,
	isNewLayout: _propTypes2.default.bool,
	itemSize: _propTypes2.default.oneOf(['small', 'medium', 'large'])
};

FakeVisualizationPreviewList.defaultProps = {
	horizontal: false
};

exports.default = FakeVisualizationPreviewList;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(57);

__webpack_require__(364);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var FAKE_STYLES = {
	text: {
		width: '150px',
		height: '15px',
		marginLeft: '8px',
		marginBottom: '8px'
	}
};

var FakeVisualizationPreview = function (_Component) {
	_inherits(FakeVisualizationPreview, _Component);

	function FakeVisualizationPreview() {
		_classCallCheck(this, FakeVisualizationPreview);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	FakeVisualizationPreview.prototype.render = function render() {
		var classNames = (0, _classnames2.default)('vis-recommender__preview', 'vis-recommender__preview__size-' + this.props.size, 'vis-recommender__preview-fake', {
			'vis-recommender__preview--horizontal': this.props.horizontal,
			'vis-recommender__preview--vertical': !this.props.horizontal
		});
		var oldClassNames = (0, _classnames2.default)('vis-recommender__preview', 'vis-recommender__preview__size-' + this.props.size, 'vis-recommender__preview-fake', {
			'vis-recommender__preview--horizontal': this.props.horizontal,
			'vis-recommender__preview--old_vertical': !this.props.horizontal
		});
		var oldVisBoxClassNames = (0, _classnames2.default)('vis-recommender__preview__preview-box', 'fake', {
			'vis-recommender__preview--horizontal__preview-box': this.props.horizontal,
			'vis-recommender__preview--old_vertical__preview-box': !this.props.horizontal
		});

		var visBoxClassNames = (0, _classnames2.default)('vis-recommender__preview__preview-box', 'fake', {
			'vis-recommender__preview--horizontal__preview-box': this.props.horizontal,
			'vis-recommender__preview--vertical__preview-box': !this.props.horizontal
		});

		classNames = this.props.isNewLayout ? classNames : oldClassNames;
		visBoxClassNames = this.props.isNewLayout ? visBoxClassNames : oldVisBoxClassNames;

		return _react2.default.createElement(
			'div',
			{ className: classNames },
			_react2.default.createElement('div', { className: visBoxClassNames }),
			this.props.showTextPending ? _react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.text }) : undefined
		);
	};

	return FakeVisualizationPreview;
}(_react.Component);

FakeVisualizationPreview.propTypes = {
	horizontal: _propTypes2.default.bool,
	isNewLayout: _propTypes2.default.bool,
	showTextPending: _propTypes2.default.bool,
	size: _propTypes2.default.oneOf(['small', 'medium', 'large'])
};

FakeVisualizationPreview.defaultProps = {
	horizontal: false,
	size: 'small'
};

exports.default = FakeVisualizationPreview;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(365);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./fakeVisPreview.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./fakeVisPreview.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.vis-recommender__preview-list__fake-see-more {\n  width: 1px;\n  height: 20px;\n}\n\n", ""]);

// exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(367);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./fakeVisPreviewList.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./fakeVisPreviewList.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.fake {\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-background-h, 0), var(--ui-background-s, 0%), var(--ui-background-l, 95.68627%), 1);\n}\n\n.vis-recommender__preview-fake {\n  cursor: default;\n}\n\n.vis-recommender__preview-fake:hover,\n.vis-recommender__preview-fake:active {\n  outline: none;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n", ""]);

// exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _EditDiagramMenu = __webpack_require__(369);

var _EditDiagramMenu2 = _interopRequireDefault(_EditDiagramMenu);

var _chevronDown_ = __webpack_require__(95);

var _chevronDown_2 = _interopRequireDefault(_chevronDown_);

var _chevronUp_ = __webpack_require__(96);

var _chevronUp_2 = _interopRequireDefault(_chevronUp_);

var _caUiToolkit = __webpack_require__(6);

__webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var EditDiagramDropDown = function (_Component) {
	_inherits(EditDiagramDropDown, _Component);

	function EditDiagramDropDown(props) {
		_classCallCheck(this, EditDiagramDropDown);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			open: false
		};
		return _this;
	}

	EditDiagramDropDown.prototype.render = function render() {
		var _this2 = this;

		var caret = this.renderCaret();
		return _react2.default.createElement(
			'div',
			{ className: 'edit-diagram-button-container',
				ref: function ref(node) {
					return _this2.el = node;
				}
			},
			_react2.default.createElement(
				'div',
				{ className: 'edit-diagram-dropdown-button',
					tabIndex: 0,
					onKeyDown: function onKeyDown(event) {
						return _this2._onKeyDown(event);
					},
					onClick: function onClick(event) {
						return _this2._onOpen(event);
					},
					onTouchEnd: function onTouchEnd(event) {
						return _this2._onOpen(event);
					}
				},
				_react2.default.createElement(
					'span',
					{ className: 'edit-diagram-dropdown-button__text' },
					_StringResources2.default.get('edit_diagram')
				),
				caret
			),
			this.state.open && this.renderMenu()
		);
	};

	EditDiagramDropDown.prototype.renderCaret = function renderCaret() {
		var id = void 0;
		if (this.state.open) {
			id = _chevronUp_2.default.id;
		} else {
			id = _chevronDown_2.default.id;
		}

		return _react2.default.createElement(
			'div',
			{ className: 'edit-diagram-dropdown-button__caret' },
			_react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: id, size: 'small' })
		);
	};

	EditDiagramDropDown.prototype.renderMenu = function renderMenu() {
		var targetModel = this.props.relationshipVM.getTargetModel();
		return _react2.default.createElement(_EditDiagramMenu2.default, {
			triggerNode: this.el,
			targetModel: targetModel,
			onClose: this._onClose.bind(this),
			onChangeScopeClick: this._onChangeScopeClick.bind(this),
			isEditScopeFeatureEnabled: this.props.relationshipVM.isEditScopeFeatureEnabled(),
			dataState: this.props.relationshipVM.getTargetModel().data.state
		});
	};

	EditDiagramDropDown.prototype._onKeyDown = function _onKeyDown(event) {
		switch (event.key) {
			case ' ': // space
			case 'Enter':
				this._onOpen();
		}
	};

	EditDiagramDropDown.prototype._onOpen = function _onOpen(event) {
		// Toggle the dropdown.
		this.setState({
			open: !this.state.open
		});
		if (event) {
			event.preventDefault();
		}
	};

	EditDiagramDropDown.prototype._onClose = function _onClose() {
		this.setState({
			open: false
		});
	};

	EditDiagramDropDown.prototype._onChangeScopeClick = function _onChangeScopeClick() {
		this.props.onChangeScopeClick();
	};

	return EditDiagramDropDown;
}(_react.Component);

EditDiagramDropDown.propTypes = {
	relationshipVM: _PropTypes2.default.object.isRequired,
	onChangeScopeClick: _PropTypes2.default.func
};

exports.default = EditDiagramDropDown;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /**
             * Licensed Materials - Property of IBM
             *
             * "Restricted Materials of IBM"
             *
             * (C) Copyright IBM Corp. 2019
             *
             * US Government Users Restricted Rights - Use, duplication or disclosure
             * restricted by GSA ADP Schedule Contract with IBM Corp.
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _caUiToolkit = __webpack_require__(6);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _mobxUtils = __webpack_require__(15);

__webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditDiagramMenu = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(EditDiagramMenu, _Component);

	function EditDiagramMenu(props) {
		_classCallCheck(this, EditDiagramMenu);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	EditDiagramMenu.prototype.render = function render() {
		return this._buildMenuItems();
	};

	EditDiagramMenu.prototype.componentDidMount = function componentDidMount() {
		if (this.props.onClose) {
			document.addEventListener('mousedown', this._onClose.bind(this));
			document.addEventListener('touchstart', this._onClose.bind(this));
		}
	};

	EditDiagramMenu.prototype.componentWillUnmount = function componentWillUnmount() {
		if (this.props.onClose) {
			document.removeEventListener('mousedown', this._onClose.bind(this));
			document.removeEventListener('touchstart', this._onClose.bind(this));
		}
	};

	EditDiagramMenu.prototype._onClose = function _onClose(event) {
		if (this._dropdown && !this._dropdown.contains(event.target) && this.props.triggerNode && !this.props.triggerNode.contains(event.target)) {
			this.props.onClose();
		}
	};

	EditDiagramMenu.prototype._buildMenuItems = function _buildMenuItems() {
		var _this2 = this;

		var state = this.props.dataState;
		var contents = [];
		if (this.props.isEditScopeFeatureEnabled) {
			contents.push(_react2.default.createElement(
				'div',
				{ className: 'edit-diagram-menu__changeScope', tabIndex: 0, 'aria-label': _StringResources2.default.get('change_scope'),
					onClick: this._onChangeScopeClick.bind(this),
					onKeyDown: this._onKeyDown.bind(this) },
				_react2.default.createElement(
					'span',
					null,
					_StringResources2.default.get('change_scope')
				)
			));
		}
		if (state !== _mobxUtils.REJECTED) {
			contents.push(_react2.default.createElement(_caUiToolkit.Separator, { className: 'edit-diagram-menu__separator' }));
			contents.push(this._buildCheckboxMarkUp());
		}
		return _react2.default.createElement(
			'div',
			{ className: 'edit-diagram-menu',
				ref: function ref(node) {
					return _this2._dropdown = node;
				}
			},
			contents
		);
	};

	EditDiagramMenu.prototype._onKeyDown = function _onKeyDown(event) {
		switch (event.key) {
			case ' ': // space
			case 'Enter':
				this._onChangeScopeClick();
				break;
		}
	};

	EditDiagramMenu.prototype._onChangeScopeClick = function _onChangeScopeClick() {
		this.props.onChangeScopeClick();
		// Close dropdown after opening "Edit scope" dialog
		this.props.onClose();
	};

	EditDiagramMenu.prototype._buildCheckboxMarkUp = function _buildCheckboxMarkUp() {
		var _this3 = this;

		var label = _StringResources2.default.get('relationshipGraph_secondaryRelationship_label');
		var alignment = 'left';
		return _react2.default.createElement(_caUiToolkit.Checkbox, {
			className: 'edit-diagram-menu__checkbox',
			label: label,
			align: alignment,
			onChange: function onChange() {
				_this3.props.targetModel.setShowPrimaryRelationshipView(!_this3.props.targetModel.showPrimaryRelationshipView);
			},
			checked: !this.props.targetModel.showPrimaryRelationshipView,
			size: 'small'
		});
	};

	return EditDiagramMenu;
}(_react.Component)) || _class;

EditDiagramMenu.propTypes = {
	triggerNode: _PropTypes2.default.node,
	targetModel: _PropTypes2.default.object.isRequired,
	onClose: _PropTypes2.default.func,
	onChangeScopeClick: _PropTypes2.default.func,
	isEditScopeFeatureEnabled: _PropTypes2.default.bool,
	dataState: _PropTypes2.default.object.isRequired
};

exports.default = EditDiagramMenu;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2019, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.edit-diagram-button-container {\n  position: relative;\n}\n\n.edit-diagram-button-container .edit-diagram-menu {\n  position: absolute;\n  min-width: 220px;\n  z-index: 9999;\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  box-shadow: 0 5px 25px -10px #00000036;\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  right: 0px;\n  margin-top: 2px;\n}\n\n.edit-diagram-button-container .edit-diagram-menu__checkbox {\n  padding: 0.5rem 1rem;\n}\n\n.edit-diagram-button-container .edit-diagram-menu__changeScope {\n  padding: 0.5rem 1rem;\n}\n\n.edit-diagram-button-container .edit-diagram-menu__changeScope:hover {\n  cursor: pointer;\n  background-color: #e5e5e5;\n  background-color: hsla(var(--hover-ui-h, 0), var(--hover-ui-s, 0%), var(--hover-ui-l, 89.80392%), 1);\n}\n\n.edit-diagram-button-container .edit-diagram-menu__separator {\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.edit-diagram-button-container .edit-diagram-dropdown-button {\n  padding: 0 8px;\n  height: 38px;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  display: -ms-flexbox;\n  display: flex;\n  white-space: nowrap;\n  position: relative;\n  -ms-flex-align: center;\n      align-items: center;\n  color: #393939;\n  color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n  border: 1px solid;\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  opacity: 1;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: pointer;\n}\n\n.edit-diagram-button-container .edit-diagram-dropdown-button:hover {\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.edit-diagram-button-container .edit-diagram-dropdown-button__caret {\n  text-align: center;\n  -ms-flex: auto;\n      flex: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n.edit-diagram-button-container .edit-diagram-dropdown-button__text {\n  font-size: 0.875rem;\n  font-weight: 700;\n  padding: 0 8px;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n", ""]);

// exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.FIELD_INPUT_DROPDOWN_MODES = undefined;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2020
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(11);

var mobx = _interopRequireWildcard(_mobx);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _caUiToolkit = __webpack_require__(6);

var _shaping = __webpack_require__(28);

var _Dropdown = __webpack_require__(105);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _FieldsList = __webpack_require__(106);

var _FieldsList2 = _interopRequireDefault(_FieldsList);

var _close_ = __webpack_require__(56);

var _close_2 = _interopRequireDefault(_close_);

__webpack_require__(378);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIELD_INPUT_DROPDOWN_MODES = exports.FIELD_INPUT_DROPDOWN_MODES = {
	EMPTY: 0,
	INTERESTING_FIELDS: 1,
	METADATA_TREE: 2
};

var FieldInput = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(FieldInput, _Component);

	function FieldInput(props) {
		_classCallCheck(this, FieldInput);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.props = props;
		_this.filteredValues = [];

		//Use state for whether focus is in the control as it's a very transient property
		_this.state = {
			hasFocus: false,
			userTextInput: ''
		};

		mobx.reaction(function () {
			return _this.props.fields.clearInput;
		}, function (clearInput) {
			if (clearInput) {
				_this.setState({
					userTextInput: ''
				});
				_this.filteredValues = [];
			}
		});
		return _this;
	}

	FieldInput.prototype.componentDidMount = function componentDidMount() {
		var glassContext = this.props.glassContext;
		if (glassContext) {
			this.props.relationshipVM.setGlassContext(glassContext);
		}

		if (this.props.fields.isNewStartingPointsFeatureEnabled()) {
			this._bodyOnMouseDownHandler = this._bodyOnMouseDown.bind(this);
			document.body.addEventListener('mousedown', this._bodyOnMouseDownHandler);
		}
	};

	FieldInput.prototype.componentWillUnmount = function componentWillUnmount() {
		if (this._bodyOnMouseDownHandler) {
			window.removeEventListener('mousedown', this._bodyOnMouseDownHandler);
			this._bodyOnMouseDownHandler = null;
		}
	};

	FieldInput.prototype._shouldShowDropdown = function _shouldShowDropdown() {
		if (!this.props.fields.isNewStartingPointsFeatureEnabled()) {
			return false;
		}

		if (!this.state.hasFocus) {
			//Do not render dropdown when not in focus
			return false;
		}

		var renderMode = this.props.getDropdownMode({ userTextInput: this.state.userTextInput });

		if (renderMode === FIELD_INPUT_DROPDOWN_MODES.INTERESTING_FIELDS) {
			return true;
		} else if (renderMode === FIELD_INPUT_DROPDOWN_MODES.METADATA_TREE) {
			return true;
		}

		return false;
	};

	/*
  * @return the actual text input from which the dropdown appears
  */


	FieldInput.prototype._renderTextInput = function _renderTextInput(getTargetNode) {
		var _this2 = this;

		var clearText = _StringResources2.default.get('startingPoints_fieldInputClear');
		var icon = null;
		if (this.props.close) {
			icon = _react2.default.createElement(
				_caUiToolkit.Tooltip,
				{ orient: 'top', title: clearText, className: 'inputClear' },
				_react2.default.createElement(_caUiToolkit.Button, {
					icon: _close_2.default.id,
					onClick: this._onInputClearButtonClick.bind(this),
					iconSize: 'small',
					variant: 'icon',
					intent: 'primary',
					'aria-label': clearText
				})
			);
		}

		return _react2.default.createElement(_caUiToolkit.TextInput, {
			className: 'fieldInput',
			noBottomBorder: true,
			value: this.state.userTextInput,
			placeholder: this._getTextInputPlaceholder(),
			onChange: function onChange(value) {
				return _this2.onChange(value);
			},
			onKeyDown: function onKeyDown(e) {
				return _this2.onKeyDown(e);
			},
			onFocus: function onFocus() {
				return _this2.onFocus();
			},
			ref: function ref(node) {
				_this2._textInputRef = node;
				getTargetNode(node);
			},
			inputChildren: icon
		});
	};

	FieldInput.prototype._onInputClearButtonClick = function _onInputClearButtonClick() {
		if (this._textInputRef) {
			this._textInputRef.focus();
		}
		this.setState({
			userTextInput: ''
		});
	};

	/*
  * @return the text which is in the 'background' of the text input
  */


	FieldInput.prototype._getTextInputPlaceholder = function _getTextInputPlaceholder() {
		return this.state.hasFocus ? this.props.focusedPlaceholder : this.props.unfocusedPlaceholder;
	};

	FieldInput.prototype._renderRecentFields = function _renderRecentFields() {
		var _this3 = this;

		var fields = this.props.recentFields;
		return fields && fields.length ? _react2.default.createElement(_FieldsList2.default, {
			title: _StringResources2.default.get('startingPoints_recentlyUsed'),
			fields: fields.map(function (_ref) {
				var id = _ref.id,
				    name = _ref.name;
				return { id: id, label: name };
			}),
			onSelectField: function onSelectField(_ref2) {
				var id = _ref2.id;
				return _this3.performAction({ value: id });
			},
			activeDataSourceModule: this.props.activeDataSourceModule,
			shouldUseDisambiguatedPaths: this.props.shouldUseDisambiguatedPaths,
			relationshipVM: this.props.relationshipVM
		}) : null;
	};

	//Replace this with the button list component that support cancel


	FieldInput.prototype._renderRunningButton = function _renderRunningButton() {
		var _this4 = this;

		var runningRequestsTargetIds = this.props.relationshipVM.getRunningRequestsTargetIds();
		if (runningRequestsTargetIds.length) {
			var allFields = this.props.fields.getFields().getAll();
			var mapRunningRequestsTargetIdToField = function mapRunningRequestsTargetIdToField(targetId) {
				var foundField = allFields.find(function (field) {
					return field.id === targetId;
				});
				return {
					id: targetId,
					label: foundField.name,
					deletable: true
				};
			};
			return _react2.default.createElement(_FieldsList2.default, {
				title: _StringResources2.default.get('startingPoints_runningRelationshipRequest'),
				fields: runningRequestsTargetIds.map(mapRunningRequestsTargetIdToField),
				onDeleteField: function onDeleteField(_ref3) {
					var id = _ref3.id;

					var targetModelToAbandon = _this4.props.relationshipVM.getTargetModel({ targetId: id });
					targetModelToAbandon && targetModelToAbandon.abandonRequest();
				},
				onSelectField: function onSelectField(_ref4) {
					var id = _ref4.id;
					return _this4.performAction({ value: id });
				},
				activeDataSourceModule: this.props.activeDataSourceModule,
				shouldUseDisambiguatedPaths: this.props.shouldUseDisambiguatedPaths,
				relationshipVM: this.props.relationshipVM
			});
		} else {
			return null;
		}
	};

	FieldInput.prototype._renderRecommendedFields = function _renderRecommendedFields() {
		var _this5 = this;

		var fields = this.props.recommendedFields || [];
		var error = fields.length ? null : {
			title: _StringResources2.default.get('startingPoints_recommended_fields_unavailable'),
			description: _StringResources2.default.get('startingPoints_wizard_recommendations_enter_column')
		};
		return _react2.default.createElement(_FieldsList2.default, {
			title: _StringResources2.default.get('startingPoints_recommendedFieldsListTitle'),
			fields: fields.map(function (_ref5) {
				var id = _ref5.id,
				    name = _ref5.name;
				return { id: id, label: name };
			}),
			error: error,
			onSelectField: function onSelectField(_ref6) {
				var id = _ref6.id;
				return _this5.performAction({ value: id });
			},
			activeDataSourceModule: this.props.activeDataSourceModule,
			shouldUseDisambiguatedPaths: this.props.shouldUseDisambiguatedPaths,
			relationshipVM: this.props.relationshipVM
		});
	};

	FieldInput.prototype._renderDropdown = function _renderDropdown() {
		var _this6 = this;

		var renderMode = this.props.getDropdownMode({ userTextInput: this.state.userTextInput });

		if (renderMode === FIELD_INPUT_DROPDOWN_MODES.INTERESTING_FIELDS) {
			return [this._renderRecentFields(), this.props.relationshipVM && this.props.relationshipVM.limitConcurrentRequests() ? this._renderRunningButton() : null, this._renderRecommendedFields()];
		} else if (renderMode === FIELD_INPUT_DROPDOWN_MODES.METADATA_TREE) {
			var module = this.props.module;
			var shapingHelper = module.getShapingHelper();
			return _react2.default.createElement(
				shapingHelper.ShapingProvider,
				null,
				_react2.default.createElement(_shaping.ShapingPickTree, {
					filter: this.state.userTextInput,
					onSelect: function onSelect(item) {
						return _this6.performAction({ value: item.idForExpression });
					}
				})
			);
		}
	};

	FieldInput.prototype.render = function render() {
		var _this7 = this;

		return this.props.fields.isNewStartingPointsFeatureEnabled() ? _react2.default.createElement(_Dropdown2.default, {
			renderTrigger: function renderTrigger(getTargetNode) {
				return _this7._renderTextInput(getTargetNode);
			},
			renderDropdownContents: function renderDropdownContents() {
				return _this7._renderDropdown();
			},
			open: this._shouldShowDropdown(),
			getDropdownMaxHeight: this.props.getDropdownMaxHeight,
			onBlur: function onBlur() {
				return _this7.onBlur();
			},
			animationWhenContentChanges: false // Need to set this prop to `false` to avoid the dropdown keep boucing when user types in the field input
		}) : _react2.default.createElement(
			'div',
			{ className: 'field-input' },
			_react2.default.createElement(_caUiToolkit.AutoCompleteInput, {
				values: this.props.values,
				value: this.state.userTextInput,
				placeholder: _StringResources2.default.get('startingPoints_fieldInputPlaceHolder'),
				onChange: function onChange(value) {
					return _this7.onChange(value);
				},
				onSelectionChange: function onSelectionChange(value) {
					return _this7.onSelectionChange(value);
				},
				onKeyDown: function onKeyDown(e) {
					return _this7.onKeyDown(e);
				},
				onValueMatch: function onValueMatch(filteredValues) {
					return _this7.onValueMatch(filteredValues);
				}
			})
		);
	};

	FieldInput.prototype._renderError = function _renderError(error) {
		return _react2.default.createElement(
			'div',
			{ className: 'fieldsListContainer' },
			_react2.default.createElement(
				'div',
				{ className: 'fieldsListTitle' },
				error.title
			),
			_react2.default.createElement(
				'div',
				{ className: 'fieldsListErrorMessage' },
				error.description
			)
		);
	};

	FieldInput.prototype.onKeyDown = function onKeyDown(e) {
		var _this8 = this;

		var handler = {
			'Enter': function Enter() {
				var value = _this8._getTypedValue();
				if (value) {
					_this8.performAction(value);
				}
			}
		}[e.key];

		if (handler) {
			handler();
		}
	};

	FieldInput.prototype._bodyOnMouseDown = function _bodyOnMouseDown(evt) {
		if (!(0, _Dropdown.eventIsInDropdown)(evt)) {
			this.onBlur();
		}
	};

	FieldInput.prototype.onFocus = function onFocus() {
		this.setState({
			hasFocus: true
		});
	};

	FieldInput.prototype.onBlur = function onBlur() {
		this.setState({
			hasFocus: false,
			userTextInput: ''
		});
	};

	/*
  * @return the value associated with the label typed by the user, null if the
  * user's entry does not resolve meaningfully to a suggested value
  */


	FieldInput.prototype._getTypedValue = function _getTypedValue() {
		if (this.filteredValues.length === 0) {
			//No suggested values. No meaningful value.
			return null;
		} else if (this.filteredValues.length === 1) {
			//Exactly one suggested value. User must have wanted that value.
			return this.filteredValues[0];
		}
	};

	FieldInput.prototype.onChange = function onChange(value) {
		this.setState({
			userTextInput: value
		});
		this.props.fields.setClearInput(false);
	};

	FieldInput.prototype.onSelectionChange = function onSelectionChange(value) {
		this.performAction(value);
	};

	FieldInput.prototype.onValueMatch = function onValueMatch(values) {
		this.filteredValues = values;
	};

	FieldInput.prototype.performAction = function performAction(selectedValue) {
		if (this.props.onChange) {
			this.props.onChange(selectedValue.value);
			this.setState({
				userTextInput: ''
			});
			this.filteredValues = [];
		}
		this.setState({
			hasFocus: false
		});
	};

	return FieldInput;
}(_react.Component)) || _class;

var FieldProp = _PropTypes2.default.shape({
	id: _PropTypes2.default.string.isRequired,
	name: _PropTypes2.default.string.isRequired
});

var FieldArrayProp = _PropTypes2.default.observableArrayOf(FieldProp);

FieldInput.propTypes = {
	close: _PropTypes2.default.bool,
	values: _PropTypes2.default.arrayOf(_PropTypes2.default.object), /*deprecated - old UI*/
	fields: _PropTypes2.default.object.isRequired,
	onChange: _PropTypes2.default.func,
	recentFields: FieldArrayProp,
	recommendedFields: FieldArrayProp,
	unfocusedPlaceholder: _PropTypes2.default.string,
	focusedPlaceholder: _PropTypes2.default.string,
	module: _PropTypes2.default.observableObject,
	getDropdownMode: _PropTypes2.default.func.isRequired,
	getDropdownMaxHeight: _PropTypes2.default.func.isRequired,
	activeDataSourceModule: _PropTypes2.default.observableObject,
	shouldUseDisambiguatedPaths: _PropTypes2.default.bool,
	relationshipVM: _PropTypes2.default.object.isRequired,
	glassContext: _PropTypes2.default.object.isRequired
};

FieldInput.defaultProps = {
	close: true,
	unfocusedPlaceholder: '',
	focusedPlaceholder: ''
};

exports.default = FieldInput;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(373);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./dropdown.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./dropdown.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".dropdownWrapper {\n  width: 100%;\n  min-width: 96px;\n}\n\n.dropdownWrapper .dropdown {\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);\n  position: absolute;\n}\n\n", ""]);

// exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _caUiToolkit = __webpack_require__(6);

var _shaping = __webpack_require__(28);

var _close_ = __webpack_require__(56);

var _close_2 = _interopRequireDefault(_close_);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(375);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BUTTON_TEXT_MAX_WIDTH = 200;

var FieldButton = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(FieldButton, _Component);

	function FieldButton(props) {
		_classCallCheck(this, FieldButton);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._onKeyDown = function (e) {
			switch (e.key) {
				case 'Backspace':
				case 'Delete':
					if (_this.props.deletable) {
						_this.props.onDelete && _this.props.onDelete();
						e.stopPropagation();
					}
					break;
				default:
					break;
			}
		};

		_this._showFlyout = function () {
			_this.setState({ isFlyoutShown: true });
		};

		_this._hideFlyout = function () {
			_this.setState({ isFlyoutShown: false });
		};

		_this._shapingAncestorTree_includeParent = function () {
			return true;
		};

		_this._renderFlyout = function () {
			if (_this.state.isFlyoutShown && _this.ref.current) {
				var tooltipLabel = _StringResources2.default.get('relationshipGraph_source_tooltip_label_title');
				return _react2.default.createElement(
					_caUiToolkit.Flyout,
					{
						domNodeToAttachTo: document.body,
						triggerNode: _this.ref._node,
						offset: 10,
						placement: 'topCentred',
						candidatePlacement: ['topCentred'],
						onClose: _this._hideFlyout
					},
					_react2.default.createElement(
						'div',
						{ className: 'relationship-vis-view__disambiguatingTooltipTitle' },
						tooltipLabel
					),
					_react2.default.createElement(
						'div',
						{ className: 'relationship-vis-view__disambiguatingTooltip' },
						_this._renderQuerySubjectItem()
					)
				);
			}
		};

		_this.state = {
			isFlyoutShown: false,
			needResetTextMaxWidth: false
		};
		_this.ref = _react2.default.createRef();

		_this.textRef = _react2.default.createRef();

		_this.dismissButtonRef = _react2.default.createRef();
		return _this;
	}

	FieldButton.prototype.render = function render() {
		if (this.props.shouldUseDisambiguatedPaths) {
			return this._renderButtonWithDisambiguatedTooltip();
		}
		return this._renderButtonWithTooltip();
	};

	FieldButton.prototype.componentDidMount = function componentDidMount() {
		// for deleteable button, have to reset the max width for the text if needed
		if (this.props.deletable && this.textRef.current) {
			var initTextWidth = this.textRef.current._initTextWidth;
			if (initTextWidth && initTextWidth >= BUTTON_TEXT_MAX_WIDTH) {
				this.setState({
					needResetTextMaxWidth: true
				});
			}
		}
	};

	FieldButton.prototype._renderButtonWithDisambiguatedTooltip = function _renderButtonWithDisambiguatedTooltip() {
		var _this2 = this;

		var buttonLabel = this.props.label;
		return _react2.default.createElement(
			'div',
			null,
			this._renderFlyout(),
			_react2.default.createElement(
				_caUiToolkit.Button,
				{
					variant: 'frame',
					intent: 'primary',
					onClick: function onClick(event) {
						if (_this2.props.deletable) {
							if (_this2._handleDelete(event)) {
								//if handled for delete, then return
								return;
							}
						}
						_this2.props.onClick && _this2.props.onClick();
					},
					className: (0, _classnames2.default)({
						'fieldButton': true,
						'deletable-fieldButton': this.props.deletable
					}),
					id: this.props.id,
					onMouseEnter: this._showFlyout,
					onMouseLeave: this._hideFlyout,
					onKeyDown: this._onKeyDown,
					ref: this.ref
				},
				_react2.default.createElement(_caUiToolkit.TruncatedText, { style: this.state.needResetTextMaxWidth ? { maxWidth: BUTTON_TEXT_MAX_WIDTH } : {}, ref: this.textRef, value: buttonLabel, allowTooltip: false }),
				this.props.deletable ? _react2.default.createElement(
					'div',
					{
						ref: this.dismissButtonRef,
						className: 'fieldButton__dismissIcon',
						'aria-label': _StringResources2.default.get('fieldButton_delete'),
						title: _StringResources2.default.get('fieldButton_delete'),
						onClick: function onClick(e) {
							_this2.props.onDelete && _this2.props.onDelete();
							e.stopPropagation();
						}
					},
					_react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _close_2.default.id, width: 14, height: 14 })
				) : null
			)
		);
	};

	FieldButton.prototype._renderButtonWithTooltip = function _renderButtonWithTooltip() {
		var buttonLabel = this.props.label;
		var buttonTooltip = this.props.label + ' (' + _StringResources2.default.get('tooltipId') + ': ' + this.props.id + ')';
		return _react2.default.createElement(
			_caUiToolkit.Tooltip,
			{
				title: buttonTooltip,
				orient: 'top'
			},
			_react2.default.createElement(
				_caUiToolkit.Button,
				{
					variant: 'frame',
					intent: 'primary',
					onClick: this.props.onClick,
					className: 'fieldButton',
					id: this.props.id
				},
				_react2.default.createElement(_caUiToolkit.TruncatedText, { value: buttonLabel, allowTooltip: false })
			)
		);
	};

	/**
  * @return {boolean} true if handled, false if not
  */
	FieldButton.prototype._handleDelete = function _handleDelete(event) {
		var x = event.hasOwnProperty('clientX') ? event.clientX : null;
		var y = event.hasOwnProperty('clientY') ? event.clientY : null;
		if (x !== null && y !== null) {
			var dismissButtonRect = this.dismissButtonRef.current && this.dismissButtonRef.current.getBoundingClientRect();
			if (dismissButtonRect) {
				var left = dismissButtonRect.left,
				    top = dismissButtonRect.top,
				    width = dismissButtonRect.width,
				    height = dismissButtonRect.height;

				var xOffset = x - left;
				var yOffset = y - top;
				if (xOffset >= 0 && xOffset <= width && yOffset >= 0 && yOffset <= height) {
					// click is inside the dismiss button, handle deletemaster
					this.props.onDelete && this.props.onDelete();
					return true;
				}
			}
		}
		return false;
	};

	FieldButton.prototype._renderQuerySubjectItem = function _renderQuerySubjectItem() {
		var _props = this.props,
		    activeDataSourceModule = _props.activeDataSourceModule,
		    id = _props.id;

		var shapingHelper = activeDataSourceModule.value.getShapingHelper();
		var moserColumn = activeDataSourceModule.value.getMetadataColumn(id).moserObject;

		if (moserColumn) {
			return _react2.default.createElement(
				shapingHelper.ShapingProvider,
				null,
				_react2.default.createElement(_shaping.ShapingAncestorTree, {
					includeParent: this._shapingAncestorTree_includeParent,
					moserObject: moserColumn
				})
			);
		}
		return null;
	};

	return FieldButton;
}(_react.Component)) || _class;

FieldButton.defaultProps = {
	onClick: function onClick() {},
	deletable: false,
	onDelete: function onDelete() {},
	shouldUseDisambiguatedPaths: true
};
FieldButton.propTypes = {
	id: _PropTypes2.default.string.isRequired,
	label: _PropTypes2.default.string.isRequired,
	onClick: _PropTypes2.default.func,
	activeDataSourceModule: _PropTypes2.default.observableObject.isRequired,
	shouldUseDisambiguatedPaths: _PropTypes2.default.bool,
	deletable: _PropTypes2.default.bool,
	onDelete: _PropTypes2.default.func
};

exports.default = FieldButton;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(376);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./fieldButton.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./fieldButton.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".fieldsListContainer .fieldsList .fieldButton {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  max-width: 200px;\n  min-width: auto;\n  padding: 0 26px;\n  margin: 0 8px 8px 0;\n}\n\n.fieldsListContainer .fieldsList .fieldButton.deletable-fieldButton .fieldButton__dismissIcon {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  height: 40px;\n  width: 24px;\n  margin-right: 2px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.fieldsListContainer .fieldsList .fieldButton.deletable-fieldButton .fieldButton__dismissIcon:hover .ba-common-svgIcon {\n  opacity: 0.75;\n}\n\n.fieldsListContainer .fieldsList .fieldButton.deletable-fieldButton:hover .ba-common-svgIcon,\n.fieldsListContainer .fieldsList .fieldButton.deletable-fieldButton:focus .ba-common-svgIcon {\n  opacity: 0.5;\n}\n\n", ""]);

// exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".fieldsListContainer {\n  padding: 10px;\n}\n\n.fieldsListContainer .fieldsListTitle {\n  font-size: 12px;\n  font-weight: bold;\n  margin: 5px;\n}\n\n.fieldsListContainer .fieldsList {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  max-height: 500px;\n  margin: 5px 0;\n}\n\n.fieldsListContainer .fieldsListErrorMessage {\n  margin: 5px;\n}\n\n.fieldsListContainer .fakeField {\n  border: 2px solid #eaeaea;\n  width: 140px;\n  height: 40px;\n  margin: 5px;\n  background-color: #eaeaea;\n}\n\n", ""]);

// exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(379);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./FieldInput.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./FieldInput.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.starting-points-page .fieldInput {\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  border-bottom: solid 2px;\n  border-bottom-color: #8d8d8d;\n  border-bottom-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n}\n\n.starting-points-page .inputClear {\n  position: absolute;\n  right: 0;\n  transform: translateY(-50%);\n  top: 50%;\n}\n\n", ""]);

// exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

__webpack_require__(107);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var FakeFieldsList = function (_Component) {
	_inherits(FakeFieldsList, _Component);

	function FakeFieldsList() {
		_classCallCheck(this, FakeFieldsList);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	FakeFieldsList.prototype.render = function render() {

		var fakeFields = [];

		for (var i = 0; i < this.props.numberOfFields; i++) {
			fakeFields.push(_react2.default.createElement('div', { className: 'fakeField' }));
		}

		return _react2.default.createElement(
			'div',
			{ className: 'fieldsListContainer' },
			_react2.default.createElement(
				'div',
				{ className: 'fieldsList' },
				fakeFields
			)
		);
	};

	return FakeFieldsList;
}(_react.Component);

FakeFieldsList.propTypes = {
	numberOfFields: _PropTypes2.default.number.isRequired
};

exports.default = FakeFieldsList;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _mobxReact = __webpack_require__(5);

var _caUiToolkit = __webpack_require__(6);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FieldsListLayout = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(FieldsListLayout, _Component);

	function FieldsListLayout(props) {
		_classCallCheck(this, FieldsListLayout);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	FieldsListLayout.prototype.render = function render() {
		return this.renderFields();
	};

	FieldsListLayout.prototype.renderFields = function renderFields() {
		var _this2 = this;

		var fields = this.props.fields.map(function (field) {
			return _this2.renderField(field);
		});
		var content = void 0;
		if (fields.length === 0) {
			content = '';
		} else {
			content = _react2.default.createElement(
				_caUiToolkit.Tabs
				//deleteable currently doesn't work as intended (tabs can ALWAYS be deleted even when this is false), but ba-ui-toolkit team should fix it soon
				,
				{ deleteable: true,
					tabButton: true,
					selected: this.props.focus.id,
					scrollWhenSelected: true,
					onChange: function onChange(tabId) {
						return _this2.props.onClick(tabId);
					},
					stateTabs: fields,
					setState: function setState(option) {
						_this2._setInterestingFields(option);
					}
				},
				fields
			);
		}

		return _react2.default.createElement(
			'div',
			{ className: (0, _classnames2.default)('explore-fieldList') },
			content
		);
	};

	FieldsListLayout.prototype.renderField = function renderField(field) {
		var fieldTitle = ' (' + _StringResources2.default.get('tooltipId') + ': ' + field.id + ')';
		return _react2.default.createElement(_caUiToolkit.TabPanel, {
			id: field.id,
			label: field.name,
			key: field.id,
			title: field.name + fieldTitle
		});
	};

	FieldsListLayout.prototype._setInterestingFields = function _setInterestingFields(newFields) {
		var fields = newFields.map(function (field) {
			return {
				name: field.props.label,
				id: field.props.id
			};
		});
		this.props.onFieldsChanged(fields);
	};

	return FieldsListLayout;
}(_react.Component)) || _class;

FieldsListLayout.propTypes = {
	fields: _PropTypes2.default.observableArrayOf(_PropTypes2.default.object).isRequired,
	focus: _PropTypes2.default.object,
	onClick: _PropTypes2.default.func,
	onFieldsChanged: _PropTypes2.default.func
};

FieldsListLayout.defaultProps = {
	fields: [],
	focus: 0,
	onClick: function onClick() {},
	onFieldsChanged: function onFieldsChanged() {}
};

exports.default = FieldsListLayout;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(108);

__webpack_require__(109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var TITLE_WIDTH = 350;
var FIELD_WIDTH = 140;
var TEXT_HEIGHT = 15;
var FIELD_HEIGHT = 40;

var FAKE_STYLES = {
	pageTitle: {
		width: TITLE_WIDTH + 'px',
		height: TEXT_HEIGHT + 10 + 'px'
	},
	text: {
		width: TITLE_WIDTH + 80 + 'px',
		height: TEXT_HEIGHT + 'px',
		marginBottom: '30px'
	},
	focusFieldTitle: {
		width: FIELD_WIDTH + 40 + 'px',
		height: TEXT_HEIGHT + 'px',
		marginTop: '0px',
		marginBottom: '0px'
	},
	fieldTextInput: {
		width: FIELD_WIDTH + 80 + 'px',
		height: FIELD_HEIGHT + 'px',
		marginTop: '0px',
		marginRight: '0px'
	},
	field: {
		width: FIELD_WIDTH + 'px',
		height: FIELD_HEIGHT + 'px',
		marginTop: '0px',
		marginRight: '0px'
	}
};

var FakeFields = function (_Component) {
	_inherits(FakeFields, _Component);

	function FakeFields() {
		_classCallCheck(this, FakeFields);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	FakeFields.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			{ className: 'starting-points-fields' },
			_react2.default.createElement(
				'div',
				{ className: 'starting-points-header' },
				_react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.pageTitle }),
				_react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.text })
			),
			_react2.default.createElement(
				'div',
				{ className: 'focusField' },
				_react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.focusFieldTitle })
			),
			_react2.default.createElement(
				'div',
				{ className: 'fields-control' },
				_react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.fieldTextInput }),
				_react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.field }),
				_react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.field }),
				_react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.field }),
				_react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.field }),
				_react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.field })
			)
		);
	};

	return FakeFields;
}(_react.Component);

exports.default = FakeFields;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.fake {\n  background-color: #eaeaea;\n  margin: 7px;\n}\n\n", ""]);

// exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore__animation--fade-appear,\n.explore__animation--fade-enter {\n  opacity: 0.1;\n}\n\n.explore__animation--fade-appear-active,\n.explore__animation--fade-enter-active {\n  opacity: 1;\n  transition: opacity 300ms ease-in;\n}\n\n.explore__animation--fade-exit {\n  opacity: 1;\n  transform: scale(1, 1);\n}\n\n.explore__animation--fade-exit-active {\n  opacity: 0.1;\n  transition: opacity 300ms ease-out;\n}\n\n.explore__animation--slideDown-appear,\n.explore__animation--slideDown-enter {\n  opacity: 0.1;\n  transform: translateY(-100%);\n}\n\n.explore__animation--slideDown-appear-active,\n.explore__animation--slideDown-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n}\n\n.explore__animation--slideDown-exit {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.explore__animation--slideDown-exit-active {\n  opacity: 0.1;\n  transform: translateY(-100%);\n  transition: opacity 300ms ease-out, transform 300ms ease-out;\n}\n\n.explore__animation--slideUp-appear,\n.explore__animation--slideUp-enter {\n  opacity: 0.1;\n  transform: translateY(100%);\n}\n\n.explore__animation--slideUp-appear-active,\n.explore__animation--slideUp-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n}\n\n.explore__animation--slideUp-exit {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.explore__animation--slideUp-exit-active {\n  opacity: 0.1;\n  transform: translateY(100%);\n  transition: opacity 300ms ease-out, transform 300ms ease-out;\n}\n\n.explore__animation--slideLeft-appear,\n.explore__animation--slideLeft-enter {\n  opacity: 0.1;\n  transform: translateX(100%);\n}\n\n.explore__animation--slideLeft-appear-active,\n.explore__animation--slideLeft-enter-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n}\n\n.explore__animation--slideLeft-exit {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.explore__animation--slideLeft-exit-active {\n  opacity: 0.1;\n  transform: translateX(100%);\n  transition: opacity 300ms ease-out, transform 300ms ease-out;\n}\n\n.starting-points-static {\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  height: 100%;\n  width: 100%;\n  overflow-y: auto;\n}\n\n.starting-points-static__content {\n  margin: auto;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n  text-align: center;\n}\n\n.vizlibrary.vizlibrary-network text.element-label tspan.highlight {\n  font-size: 20pt;\n}\n\n.wizard {\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  font-size: medium;\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.wizard h1 {\n  font-weight: 250;\n  margin-top: 0;\n  font-size: 28px;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n.wizard .wizard-instructions {\n  font-size: 0.875rem;\n  color: #393939;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 22.35294%), 1);\n}\n\n.wizard .wizardSections {\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.wizard .wizardSections .wizard-section {\n  padding: 48px 48px 0 0;\n}\n\n.wizard .wizardSections .wizard-section .wizard-section-title {\n  font-weight: 600;\n  margin-bottom: 1em;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n  font-size: 0.875rem;\n}\n\n.wizard .wizardSections .wizard-section .fieldsListContainer {\n  margin: 0;\n}\n\n.wizard .wizardSections .wizard-section .fieldsListContainer .fieldsList {\n  margin: 0;\n  max-height: none;\n}\n\n.wizard .wizardSections .wizard-section .fieldsListContainer .fieldsList .fieldButton {\n  margin: 0 8px 8px 0;\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .wizard .wizardSections {\n    display: block;\n  }\n}\n\n.wizard .wizard-link {\n  color: #0f62fe;\n  color: hsla(var(--link-01-h, 219.16318), var(--link-01-s, 99.17012%), var(--link-01-l, 52.7451%), 1);\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.wizard .wizard-link:hover {\n  color: #0043ce;\n  color: hsla(var(--hover-primary-text-h, 220.48544), var(--hover-primary-text-s, 100%), var(--hover-primary-text-l, 40.39216%), 1);\n  text-decoration: underline;\n}\n\n.wizard .wizard-link:active {\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n  text-decoration: underline;\n}\n\n.wizard .wizard-text-input .dropdownWrapper {\n  max-width: 600px;\n  min-width: 400px;\n}\n\n.starting-points-page {\n  overflow-x: hidden;\n  overflow-y: hidden;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\n.starting-points-page__relationshipSection {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  overflow: hidden;\n  -ms-flex: 4;\n      flex: 4;\n  padding-right: 48px;\n}\n\n.starting-points-page__relationshipSection__pendingUI {\n  margin: auto;\n}\n\n.starting-points-page__relationship__hint {\n  color: #6f6f6f;\n  color: hsla(var(--text-05-h, 0), var(--text-05-s, 0%), var(--text-05-l, 43.52941%), 1);\n  font-size: 12px;\n  text-align: center;\n  min-width: 400px;\n}\n\n.starting-points-page__relationship__hint__hidden {\n  visibility: hidden;\n}\n\n@media screen and (max-width: 1200px) {\n  .starting-points-page__relationship__hint__hidden {\n    visibility: visible;\n  }\n}\n\n.starting-points-page__oldRelationshipSection {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  overflow: hidden;\n  -ms-flex: 3;\n      flex: 3;\n  margin: 0 0 16px 0;\n}\n\n.starting-points-page .starting-points-page-content,\n.starting-points-page .old-starting-points-page-content {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: stretch;\n      align-items: stretch;\n  padding: 48px 0 48px 48px;\n  overflow: auto;\n}\n\n.starting-points-page .starting-points-page-content .bi-mui-moserObjectTree,\n.starting-points-page .old-starting-points-page-content .bi-mui-moserObjectTree {\n  max-height: 300px;\n}\n\n.starting-points-page .starting-points-page-content__vis-type-picker-container {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-visualizations,\n.starting-points-page .old-starting-points-page-content .starting-points-visualizations {\n  width: 262px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding: 0 48px;\n  overflow-y: auto;\n  border-left: 1px solid;\n  border-left-color: #e0e0e0;\n  border-left-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-visualizations .vis-preview-list-header,\n.starting-points-page .old-starting-points-page-content .starting-points-visualizations .vis-preview-list-header {\n  text-align: left;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-visualizations .vis-preview-list-header h2,\n.starting-points-page .old-starting-points-page-content .starting-points-visualizations .vis-preview-list-header h2 {\n  font-size: 20px;\n  font-weight: 300;\n  margin-top: 0px;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-visualizations .vis-preview-list-header h3,\n.starting-points-page .old-starting-points-page-content .starting-points-visualizations .vis-preview-list-header h3 {\n  font-size: 12px;\n  font-weight: 400;\n  margin: 10px 0px 0px;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-visualizations .vis-preview-list-header h4,\n.starting-points-page .old-starting-points-page-content .starting-points-visualizations .vis-preview-list-header h4 {\n  font-size: 12px;\n  margin: 10px 0px 0px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-visualizations .vis-preview-list-wrapper,\n.starting-points-page .old-starting-points-page-content .starting-points-visualizations .vis-preview-list-wrapper {\n  width: inherit;\n  -ms-flex-positive: 3;\n      flex-grow: 3;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  display: block;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-top: 20px;\n  border-top: 1px solid;\n  border-top-color: #e0e0e0;\n  border-top-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-visualizations .vis-preview-list-wrapper__error,\n.starting-points-page .old-starting-points-page-content .starting-points-visualizations .vis-preview-list-wrapper__error {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  min-height: 200px;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-visualizations .vis-preview-list-wrapper__error__refresh-button,\n.starting-points-page .old-starting-points-page-content .starting-points-visualizations .vis-preview-list-wrapper__error__refresh-button {\n  background: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n  outline: none;\n  color: #0f62fe;\n  color: hsla(var(--link-01-h, 219.16318), var(--link-01-s, 99.17012%), var(--link-01-l, 52.7451%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-visualizations .vis-preview-list-wrapper__error__refresh-button:focus,\n.starting-points-page .old-starting-points-page-content .starting-points-visualizations .vis-preview-list-wrapper__error__refresh-button:focus {\n  text-decoration: underline;\n  color: #0f62fe;\n  color: hsla(var(--link-01-h, 219.16318), var(--link-01-s, 99.17012%), var(--link-01-l, 52.7451%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-old-header,\n.starting-points-page .old-starting-points-page-content .starting-points-old-header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  text-align: center;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-old-header h1,\n.starting-points-page .old-starting-points-page-content .starting-points-old-header h1 {\n  margin-top: 0;\n  margin-bottom: 8px;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-old-header p,\n.starting-points-page .old-starting-points-page-content .starting-points-old-header p {\n  margin-bottom: 8px;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-header,\n.starting-points-page .old-starting-points-page-content .starting-points-header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: left;\n      align-items: left;\n  text-align: left;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-header h1,\n.starting-points-page .old-starting-points-page-content .starting-points-header h1 {\n  margin-top: 0;\n  margin-bottom: 8px;\n  font-size: 20px;\n  font-weight: 300;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields,\n.starting-points-page .old-starting-points-page-content .starting-points-fields {\n  min-width: 320px;\n  margin-bottom: 8px;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .starting-points-old-header,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .starting-points-old-header {\n  text-align: center;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .starting-points-header,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .starting-points-header {\n  text-align: left;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-focusField,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-focusField {\n  padding: 8px 0;\n  font-size: 12px;\n  font-weight: bold;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-focusField .focusFieldTitle,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-focusField .focusFieldTitle {\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-focusField .reset-button-container,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-focusField .reset-button-container {\n  padding-left: 15px;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-focusField .reset-button-container .reset-button,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-focusField .reset-button-container .reset-button {\n  background: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n  outline: none;\n  color: #0f62fe;\n  color: hsla(var(--link-01-h, 219.16318), var(--link-01-s, 99.17012%), var(--link-01-l, 52.7451%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-focusField .reset-button-container .reset-button:focus,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-focusField .reset-button-container .reset-button:focus {\n  text-decoration: underline;\n  color: #0f62fe;\n  color: hsla(var(--link-01-h, 219.16318), var(--link-01-s, 99.17012%), var(--link-01-l, 52.7451%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-focusField .reset-button-container .reset-button:hover,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-focusField .reset-button-container .reset-button:hover {\n  text-decoration: underline;\n  color: #0043ce;\n  color: hsla(var(--hover-primary-text-h, 220.48544), var(--hover-primary-text-s, 100%), var(--hover-primary-text-l, 40.39216%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-focusField .reset-button-container .reset-button:active,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-focusField .reset-button-container .reset-button:active {\n  text-decoration: underline;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .focusField,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .focusField {\n  padding: 8px 0;\n  font-size: 12px;\n  font-weight: bold;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .focusField .focusFieldTitle,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .focusField .focusFieldTitle {\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .focusField .datasourceTitle,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .focusField .datasourceTitle {\n  font-weight: 600;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .focusField .reset-button-container,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .focusField .reset-button-container {\n  margin-right: 135px;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .focusField .reset-button-container .reset-button,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .focusField .reset-button-container .reset-button {\n  background: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n  outline: none;\n  color: #0f62fe;\n  color: hsla(var(--link-01-h, 219.16318), var(--link-01-s, 99.17012%), var(--link-01-l, 52.7451%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .focusField .reset-button-container .reset-button:focus,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .focusField .reset-button-container .reset-button:focus {\n  text-decoration: underline;\n  color: #0f62fe;\n  color: hsla(var(--link-01-h, 219.16318), var(--link-01-s, 99.17012%), var(--link-01-l, 52.7451%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .focusField .reset-button-container .reset-button:hover,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .focusField .reset-button-container .reset-button:hover {\n  text-decoration: underline;\n  color: #0043ce;\n  color: hsla(var(--hover-primary-text-h, 220.48544), var(--hover-primary-text-s, 100%), var(--hover-primary-text-l, 40.39216%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .focusField .reset-button-container .reset-button:active,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .focusField .reset-button-container .reset-button:active {\n  text-decoration: underline;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-fields-control,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-fields-control {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-fields-control .field-input,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-fields-control .field-input {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  padding-right: 5px;\n  margin-left: 0.125rem;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-fields-control .field-input .ba-common-autoCompleteInput .ba-common-baseInput__icon,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-fields-control .field-input .ba-common-autoCompleteInput .ba-common-baseInput__icon {\n  display: none;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-fields-control .field-input .ba-common-autoCompleteInput input,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-fields-control .field-input .ba-common-autoCompleteInput input {\n  border-bottom: 2px solid;\n  border-bottom-color: #e0e0e0;\n  border-bottom-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  box-sizing: border-box;\n  padding: 0 0 0 16px;\n  font-size: inherit;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-fields-control .explore-fieldList,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-fields-control .explore-fieldList {\n  overflow: hidden;\n  width: 100%;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-fields-control .explore-fieldList *,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-fields-control .explore-fieldList * {\n  box-sizing: border-box;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-fields-control .fields-list,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-fields-control .fields-list {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-fields-control .fields-list .field,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-fields-control .fields-list .field {\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  border: 2px solid;\n  border-color: #0f62fe;\n  border-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  box-sizing: border-box;\n  width: 120px;\n  margin: 0 5px 0 5px;\n  text-align: center;\n  vertical-align: middle;\n  line-height: 36px;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-fields-control .fields-list .field .field-icon,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-fields-control .fields-list .field .field-icon {\n  width: 0px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-fields-control .fields-list .field .ba-common-truncatedText__text,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-fields-control .fields-list .field .ba-common-truncatedText__text {\n  line-height: 36px;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-fields-control .fields-list .field .ba-common-svgIcon,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-fields-control .fields-list .field .ba-common-svgIcon {\n  vertical-align: middle;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-fields-control .fields-list .field.focus,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-fields-control .fields-list .field.focus {\n  background-color: #0f62fe;\n  background-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  border-color: #0f62fe;\n  border-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  color: white;\n  color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .old-fields-control .fields-list .field.select,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .old-fields-control .fields-list .field.select {\n  outline-style: solid;\n  outline-width: 1px;\n  outline-color: #0f62fe;\n  outline-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .fields-control,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .fields-control {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .fields-control .field-input,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .fields-control .field-input {\n  width: 87%;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  margin-bottom: 0;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .fields-control .field-input .ba-common-autoCompleteInput .ba-common-baseInput__icon,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .fields-control .field-input .ba-common-autoCompleteInput .ba-common-baseInput__icon {\n  display: none;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .fields-control .field-input .ba-common-autoCompleteInput input,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .fields-control .field-input .ba-common-autoCompleteInput input {\n  border-bottom: 2px solid;\n  border-bottom-color: #e0e0e0;\n  border-bottom-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  box-sizing: border-box;\n  padding: 0 0 0 16px;\n  font-size: inherit;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .fields-control .fields-list,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .fields-control .fields-list {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .fields-control .fields-list .field,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .fields-control .fields-list .field {\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  border: 2px solid;\n  border-color: #0f62fe;\n  border-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  box-sizing: border-box;\n  width: 120px;\n  margin: 0 5px 0 5px;\n  text-align: center;\n  vertical-align: middle;\n  line-height: 36px;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .fields-control .fields-list .field .field-icon,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .fields-control .fields-list .field .field-icon {\n  width: 0px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .fields-control .fields-list .field .ba-common-truncatedText__text,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .fields-control .fields-list .field .ba-common-truncatedText__text {\n  line-height: 36px;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .fields-control .fields-list .field .ba-common-svgIcon,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .fields-control .fields-list .field .ba-common-svgIcon {\n  vertical-align: middle;\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .fields-control .fields-list .field.focus,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .fields-control .fields-list .field.focus {\n  background-color: #0f62fe;\n  background-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  border-color: #0f62fe;\n  border-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  color: white;\n  color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n}\n\n.starting-points-page .starting-points-page-content .starting-points-fields .fields-control .fields-list .field.select,\n.starting-points-page .old-starting-points-page-content .starting-points-fields .fields-control .fields-list .field.select {\n  outline-style: solid;\n  outline-width: 1px;\n  outline-color: #0f62fe;\n  outline-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.starting-points-page .old-starting-points-page-content {\n  padding: 32px;\n}\n\n.starting-points-page .old-starting-points-page-content .starting-points-visualizations {\n  border-left: none;\n  margin: 0 16px 0 0;\n  padding: 1px 16px 1px 32px;\n  max-width: 400px;\n  min-width: 300px;\n}\n\n@media only screen and (max-width: 1200px) {\n  .starting-points-page {\n    overflow-y: auto;\n    display: block;\n  }\n\n  .starting-points-page__relationshipSection {\n    min-height: 60vh;\n    -ms-flex: auto;\n        flex: auto;\n    padding: 0 0 48px 0;\n  }\n\n  .starting-points-page__oldRelationshipSection {\n    min-height: 60vh;\n    -ms-flex: auto;\n        flex: auto;\n  }\n\n  .starting-points-page .starting-points-page-content,\n  .starting-points-page .old-starting-points-page-content {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding-right: 48px;\n    overflow: hidden;\n    -ms-flex-wrap: wrap-reverse;\n        flex-wrap: wrap-reverse;\n  }\n\n  .starting-points-page .starting-points-page-content .starting-points-visualizations,\n  .starting-points-page .old-starting-points-page-content .starting-points-visualizations {\n    width: 100%;\n    margin: 0;\n    padding: 48px 0 0 0;\n    border-left: none;\n    border-top: 1px solid;\n    border-top-color: #e0e0e0;\n    border-top-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  }\n\n  .starting-points-page .old-starting-points-page-content {\n    -ms-flex-direction: row;\n        flex-direction: row;\n    padding-left: 16px;\n    padding-right: 16px;\n    overflow-y: visible;\n    -ms-flex-wrap: wrap-reverse;\n        flex-wrap: wrap-reverse;\n  }\n\n  .starting-points-page .old-starting-points-page-content .starting-points-visualizations {\n    max-width: 100%;\n    overflow-y: visible;\n    overflow-x: hidden;\n    margin: 0;\n    padding: 0;\n    -ms-flex-direction: column-reverse;\n        flex-direction: column-reverse;\n    border-top: none;\n  }\n}\n\n", ""]);

// exports


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _caUiToolkit = __webpack_require__(6);

var _buildExploration_ = __webpack_require__(386);

var _buildExploration_2 = _interopRequireDefault(_buildExploration_);

__webpack_require__(387);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Marketing = function Marketing() {
  return _react2.default.createElement(
    'div',
    { className: 'explore-marketing' },
    _react2.default.createElement(_caUiToolkit.SVGIcon, { themable: true, intent: 'primary', iconId: _buildExploration_2.default.id, height: 256, width: 256 }),
    _react2.default.createElement(
      'div',
      { className: 'explore-marketing__title' },
      _StringResources2.default.get('startingPoints_marketing_title')
    ),
    _react2.default.createElement(
      'div',
      { className: 'explore-marketing__description' },
      _StringResources2.default.get('startingPoints_marketing_text')
    ),
    _react2.default.createElement(
      'div',
      { className: 'explore-marketing__description' },
      _StringResources2.default.get('startingPoints_marketing_add_data')
    )
  );
}; /*
    *+------------------------------------------------------------------------+
    *| Licensed Materials - Property of IBM
    *| IBM Cognos Products: Explore
    *| (C) Copyright IBM Corp. 2018
    *|
    *| US Government Users Restricted Rights - Use, duplication or disclosure
    *| restricted by GSA ADP Schedule Contract with IBM Corp.
    *+------------------------------------------------------------------------+
    */

exports.default = Marketing;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (a, c) {
  if ("object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module))) module.exports = c(__webpack_require__(23));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(23)], __WEBPACK_AMD_DEFINE_FACTORY__ = (c),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var s = c("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("@ba-ui-toolkit/ba-graphics/dist/illustrations-js/ba-graphics-icons-commons.js") : a["@ba-ui-toolkit/ba-graphics/dist/illustrations-js/ba-graphics-icons-commons.js"]);for (var i in s) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : a)[i] = s[i];
    }
  }
}("undefined" != typeof self ? self : undefined, function (a) {
  return webpackJsonPBaGraphics([183], { "3865314c5959606874d4": function c5959606874d4(c, s) {
      c.exports = a;
    }, "8264b1174ed94bea0421": function b1174ed94bea0421(a, c, s) {
      "use strict";
      Object.defineProperty(c, "__esModule", { value: !0 });var i = s("3865314c5959606874d4"),
          r = (s.n(i), s("cfc2982079ea756b4702"));c.default = r.a;
    }, cfc2982079ea756b4702: function cfc2982079ea756b4702(a, c, s) {
      "use strict";
      var i = s("9689a9c94ae38b47fa2c"),
          r = s.n(i),
          h = s("9ce58a7deea14f49ef01"),
          t = s.n(h),
          e = new r.a({ id: "build-exploration_200_v7", use: "build-exploration_200_v7-usage", viewBox: "0 0 200 200", content: '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" id="build-exploration_200_v7"><circle class="ba-graphics-neutral-white4" cx="100" cy="100" r="100" /><path class="ba-graphics-white" d="M14.97 170.08h183.04" /><path class="ba-graphics-gray60" d="M198 172.08H15a2 2 0 110-4h183a2 2 0 010 4z" /><path class="ba-graphics-white" d="M2 170.08h4.97" /><path class="ba-graphics-gray60" d="M7 172.08H2a2 2 0 010-4h5a2 2 0 010 4zM75.1 37.41A2.44 2.44 0 0077.54 35a.61.61 0 011.22 0 2.44 2.44 0 002.44 2.44.61.61 0 110 1.22 2.44 2.44 0 00-2.44 2.44.61.61 0 01-1.22 0 2.44 2.44 0 00-2.44-2.44.61.61 0 010-1.22z" /><circle class="ba-graphics-gray60" cx="43.66" cy="39.61" r="2" /><circle class="ba-graphics-gray60" cx="114.6" cy="21.66" r="2" /><path class="ba-graphics-white" d="M31.52 56.68h137.16v113.41H31.52z" /><path class="ba-graphics-gray1" d="M31.48 57.37h58.28v112.66H31.48z" /><path class="ba-graphics-gray60" d="M168.61 172.08H31.33a2 2 0 01-2-2V95.8a2 2 0 014 0v72.28h133.28v-108a1 1 0 00-1-1h-53.47a2 2 0 010-4h53.47a5 5 0 015 5v110a2 2 0 01-2 2z" /><path class="ba-graphics-gray60" d="M31.33 109.05a2 2 0 01-2-2V59.74a5 5 0 015-5h65.59a2 2 0 010 4H34.33a1 1 0 00-1 1v47.31a2 2 0 01-2 2z" /><path class="ba-graphics-gray60" d="M89.63 171.82a2 2 0 01-2-2V59.16a2 2 0 014 0v110.66a2 2 0 01-2 2z" /><path class="ba-graphics-white" d="M127.89 90.8l3.04 26.57" /><path class="ba-graphics-gray60" d="M130.92 119.37a2 2 0 01-2-1.78L125.9 91a2 2 0 014-.46l3 26.57a2 2 0 01-1.76 2.21z" /><path class="ba-graphics-white" d="M148.29 108.34l-17.36 11.23" /><path class="ba-graphics-gray60" d="M130.93 121.57a2 2 0 01-1.09-3.68l17.36-11.23a2 2 0 112.17 3.36L132 121.25a1.94 1.94 0 01-1.07.32z" /><path class="ba-graphics-white" d="M131.29 119.93l-18.5 17.51" /><path class="ba-graphics-gray60" d="M112.8 139.44a2 2 0 01-1.38-3.46l18.5-17.5a2 2 0 012.75 2.91l-18.5 17.5a2 2 0 01-1.37.55z" /><path class="ba-graphics-white" d="M130.36 118.92l-20.49-8.03" /><path class="ba-graphics-gray60" d="M130.36 120.92a2.06 2.06 0 01-.73-.14l-20.49-8a2 2 0 011.46-3.78l20.49 8a2 2 0 01-.73 3.87z" /><path class="ba-graphics-white" d="M147.46 135.02l-16.17-15.45" /><path class="ba-graphics-gray60" d="M147.46 137a2 2 0 01-1.38-.56L129.91 121a2 2 0 012.76-2.9l16.17 15.45a2 2 0 01-1.38 3.45z" /><circle class="ba-graphics-gray60" cx="127.78" cy="90.67" r="6.18" /><circle class="ba-graphics-gray60" cx="148.83" cy="107.89" r="6.18" /><circle class="ba-graphics-gray60" cx="148.2" cy="135.52" r="6.18" /><circle class="ba-graphics-gray60" cx="112.08" cy="138.08" r="6.18" /><circle class="ba-graphics-gray60" cx="108.69" cy="110.48" r="6.18" /><circle class="ba-graphics-gray60" cx="130.99" cy="118.97" r="6.18" /><path class="ba-graphics-white" d="M43.17 68.66h34.27c.66 0 1.2.4 1.2.89v15.54c0 .49-.54.88-1.2.88H43.17c-.66 0-1.2-.39-1.2-.88V69.55c.03-.49.54-.89 1.2-.89z" /><path class="ba-graphics-gray60" d="M77.44 88H43.17A3 3 0 0140 85.09V69.55a3 3 0 013.2-2.89h34.24a3 3 0 013.2 2.89v15.54a3 3 0 01-3.2 2.91zM44 84h32.64V70.66H44zm33.44-13.34z" /><path class="ba-graphics-white" d="M27.22 96h34.26c.67 0 1.2.39 1.2.88v15.54c0 .49-.53.89-1.2.89H27.22c-.67 0-1.21-.4-1.21-.89V96.85c-.01-.49.54-.85 1.21-.85z" /><path class="ba-graphics-gray60" d="M61.48 115.28H27.22a3 3 0 01-3.22-2.89V96.85A3 3 0 0127.22 94h34.26a3 3 0 013.2 2.88v15.54a3 3 0 01-3.2 2.86zm-33.47-4h32.67V98H28zM61.48 98z" /><path class="ba-graphics-white" d="M14 123.89h34.23c.67 0 1.2.4 1.2.89v15.54c0 .49-.53.88-1.2.88H14c-.67 0-1.21-.39-1.21-.88v-15.54c-.03-.49.51-.89 1.21-.89z" /><path class="ba-graphics-gray60" d="M48.23 143.2H14a3 3 0 01-3.21-2.88v-15.54a3 3 0 013.21-2.89h34.23a3 3 0 013.2 2.89v15.54a3 3 0 01-3.2 2.88zm-33.47-4h32.67v-13.31H14.76zm33.47-13.31z" /><circle class="ba-graphics-gray80" style="opacity:.1" cx="140" cy="60" r="20" /><circle class="ba-graphics-gray60" cx="140" cy="56" r="20" /><path class="ba-graphics-white" d="M147.83 54H142v-5.83a2 2 0 10-4 0V54h-5.85a2 2 0 100 4H138v5.85a2 2 0 004 0V58h5.85a2 2 0 000-4z" /></symbol>' });t.a.add(e);c.a = e;
    } }, ["8264b1174ed94bea0421"]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)(module)))

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(388);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./marketing.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./marketing.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore-marketing__title {\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.25rem;\n}\n\n.explore-marketing__description {\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.125rem;\n}\n\n.explore-marketing {\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n  text-align: center;\n  padding: 32px;\n  max-width: 350px;\n}\n\n.explore-marketing__title {\n  margin-bottom: 8px;\n}\n\n", ""]);

// exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

__webpack_require__(87);

__webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var BASE_WIDTH = 140;
var TEXT_HEIGHT = 15;

var FAKE_STYLES = {
	icon: {
		width: BASE_WIDTH + 'px',
		height: BASE_WIDTH + 'px',
		margin: '20px'
	},
	text: {
		width: BASE_WIDTH + 20 + 'px',
		height: TEXT_HEIGHT + 'px'
	},
	wideText: {
		width: BASE_WIDTH + 80 + 'px',
		height: TEXT_HEIGHT + 'px'
	},
	button: {
		width: BASE_WIDTH + 'px',
		height: '40px',
		margin: '20px'
	}
};

var FakeCreateExplorationLayout = function (_Component) {
	_inherits(FakeCreateExplorationLayout, _Component);

	function FakeCreateExplorationLayout() {
		_classCallCheck(this, FakeCreateExplorationLayout);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	FakeCreateExplorationLayout.prototype.render = function render() {

		return _react2.default.createElement(
			'div',
			{ className: 'create-exploration' },
			_react2.default.createElement(
				'div',
				{ className: 'create-exploration__container ' },
				this.props.fill ? _react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.icon }) : null,
				_react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.text }),
				_react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.wideText }),
				_react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.text }),
				_react2.default.createElement('div', { className: 'fake', style: FAKE_STYLES.button })
			)
		);
	};

	return FakeCreateExplorationLayout;
}(_react.Component);

FakeCreateExplorationLayout.propTypes = {
	fill: _PropTypes2.default.bool.isRequired
};

exports.default = FakeCreateExplorationLayout;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RelationshipWidgetContextMenu = __webpack_require__(391);

var _RelationshipWidgetContextMenu2 = _interopRequireDefault(_RelationshipWidgetContextMenu);

var _RelationshipVisView = __webpack_require__(400);

var _RelationshipVisView2 = _interopRequireDefault(_RelationshipVisView);

var _RelationshipTooltip = __webpack_require__(413);

var _RelationshipTooltip2 = _interopRequireDefault(_RelationshipTooltip);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var RelationshipViewWrapper = function (_Component) {
	_inherits(RelationshipViewWrapper, _Component);

	function RelationshipViewWrapper(props) {
		_classCallCheck(this, RelationshipViewWrapper);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	RelationshipViewWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
		this.props.startingPointsVM.relationship.cleanup();
	};

	RelationshipViewWrapper.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			{ className: 'relationshipViewWrapper' },
			_react2.default.createElement(_RelationshipWidgetContextMenu2.default, { module: this.props.module, startingPointsVM: this.props.startingPointsVM }),
			_react2.default.createElement(_RelationshipVisView2.default, { relationship: this.props.startingPointsVM.relationship, services: this.props.services, fields: this.props.fields }),
			_react2.default.createElement(_RelationshipTooltip2.default, { model: this.props.startingPointsVM.relationship.tooltip, module: this.props.module, shouldUseDisambiguatedPaths: this.props.shouldUseDisambiguatedPaths })
		);
	};

	return RelationshipViewWrapper;
}(_react.Component);

RelationshipViewWrapper.propTypes = {
	module: _PropTypes2.default.observableObject.isRequired,
	startingPointsVM: _PropTypes2.default.object.isRequired,
	services: _PropTypes2.default.object,
	fields: _PropTypes2.default.object,
	shouldUseDisambiguatedPaths: _PropTypes2.default.bool
};

exports.default = RelationshipViewWrapper;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /**
             * Licensed Materials - Property of IBM
             *
             * "Restricted Materials of IBM"
             *
             * (C) Copyright IBM Corp. 2019
             *
             * US Government Users Restricted Rights - Use, duplication or disclosure
             * restricted by GSA ADP Schedule Contract with IBM Corp.
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(11);

var mobx = _interopRequireWildcard(_mobx);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _mobxReact = __webpack_require__(5);

var _mobxStateTree = __webpack_require__(7);

var _FloatingToolbar = __webpack_require__(392);

var _FloatingToolbar2 = _interopRequireDefault(_FloatingToolbar);

var _Flyout = __webpack_require__(110);

var _Flyout2 = _interopRequireDefault(_Flyout);

var _FieldSearchInput = __webpack_require__(395);

var _FieldSearchInput2 = _interopRequireDefault(_FieldSearchInput);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _delete_ = __webpack_require__(74);

var _delete_2 = _interopRequireDefault(_delete_);

var _makeCenter_ = __webpack_require__(396);

var _makeCenter_2 = _interopRequireDefault(_makeCenter_);

var _drawLink_ = __webpack_require__(397);

var _drawLink_2 = _interopRequireDefault(_drawLink_);

__webpack_require__(398);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QUERY_ITEM = 'QueryItem';

function setTimeoutPromise(effect, delay) {
	var cancel = void 0,
	    handle = void 0;
	var promise = new Promise(function (resolve, reject) {
		cancel = reject;
		handle = setTimeout(resolve, delay);
	}).then(effect, function () {
		clearTimeout(handle);
		throw new Error('Context menu cancelled');
	});

	return {
		promise: promise, cancel: cancel
	};
}

var DELAY = 250;

var model = _mobxStateTree.types.model('RelationshipWidgetContextMenuViewModel', {
	setTargetHandle: _mobxStateTree.types.optional(_mobxStateTree.types.union(_mobxStateTree.types.number, _mobxStateTree.types.null), null)
}).volatile(function () {
	return {
		target: null,
		_setTargetPromiseInfo: null
	};
}).extend(function (self) {

	var promiseInfo = null;

	return {
		views: {
			getTargetPromise: function getTargetPromise() {
				return promiseInfo && promiseInfo.promise;
			}
		},
		actions: {
			setContextMenuTarget: function setContextMenuTarget(target) {
				//Upon setting a new target, immediately clear the old target
				if (promiseInfo) {
					promiseInfo.cancel();
					promiseInfo = null;
				}
				self.target = null;

				//If there is a new target, initiate a timer to show it
				if (target) {
					promiseInfo = setTimeoutPromise(function () {
						self._setTarget(target);
						promiseInfo = null;
					}, DELAY);
				}
			},
			_setTarget: function _setTarget(target) {
				self.target = target;
			}
		}
	};
});

var RelationshipWidgetContextMenu = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(RelationshipWidgetContextMenu, _Component);

	function RelationshipWidgetContextMenu(props) {
		_classCallCheck(this, RelationshipWidgetContextMenu);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.model = model.create({});

		_this.disposeFunctions = [];
		_this.disposeFunctions.push(mobx.autorun(function () {
			var relationshipVM = _this.props.startingPointsVM.relationship;
			if (relationshipVM.contextMenuElement) {
				_this.model.setContextMenuTarget(relationshipVM.contextMenuElement);
			} else {
				_this.model.setContextMenuTarget(null);
				//when context menu close, the flyout of the context menu button should also be closed
				_this.setState({
					showFieldSearchInput: {
						shown: false,
						triggerNode: null
					}
				});
			}
		}));
		_this.state = {
			showFieldSearchInput: {
				shown: false,
				triggerNode: null
			}
		};
		return _this;
	}

	RelationshipWidgetContextMenu.prototype.render = function render() {
		var _this2 = this;

		var startingPointsVM = this.props.startingPointsVM;
		var fieldsVM = startingPointsVM.fields;
		var relationshipVM = startingPointsVM.relationship;

		if (this.model.target) {
			return _react2.default.createElement(_FloatingToolbar2.default, {
				buttons: [{
					icon: _makeCenter_2.default.id,
					label: _StringResources2.default.get('startingPoints_relationshipDiagram_selectNewFocusField'),
					action: function action() {
						return _this2.setFocusField(relationshipVM.contextMenuField);
					},
					include: function include() {
						return fieldsVM.canSetFocusField(relationshipVM.contextMenuField.itemId);
					}
				}, {
					icon: _drawLink_2.default.id,
					label: _StringResources2.default.get('startingPoints_relationshipDiagram_show_relationships_between_two_fields'),
					action: function action(event) {
						return _this2.toggleFieldSearchInput(event);
					},
					include: function include() {
						return relationshipVM.canShowRelationships();
					},
					otherComponents: function otherComponents() {
						return _this2._renderShowRelationshipsFieldSearchInput();
					}
				}, {
					icon: _delete_2.default.id,
					label: _StringResources2.default.get('startingPoints_relationshipDiagram_deleteField'),
					action: function action() {
						return _this2.deleteFields([relationshipVM.contextMenuField]);
					},
					include: function include() {
						return relationshipVM.canDeleteFields([relationshipVM.contextMenuField]);
					}
				}],
				triggerNode: this.model.target
			});
		} else {
			return null;
		}
	};

	RelationshipWidgetContextMenu.prototype.dismissContextMenu = function dismissContextMenu() {
		var startingPointsVM = this.props.startingPointsVM;
		var relationshipVM = startingPointsVM.relationship;
		relationshipVM.setContextMenu({ element: null, field: null });
	};

	RelationshipWidgetContextMenu.prototype.deleteFields = function deleteFields(fields) {
		var startingPointsVM = this.props.startingPointsVM;
		var relationshipVM = startingPointsVM.relationship;
		relationshipVM.deleteFields(fields);
		this.dismissContextMenu();
	};

	RelationshipWidgetContextMenu.prototype.setFocusField = function setFocusField(field) {
		var startingPointsVM = this.props.startingPointsVM;
		var fieldsVM = startingPointsVM.fields;
		fieldsVM.setFocusField(field.itemId);
		this.dismissContextMenu();
	};

	RelationshipWidgetContextMenu.prototype.bodyOnMouseDown = function bodyOnMouseDown(evt) {
		if (!(0, _FloatingToolbar.eventIsInFloatingToolbar)(evt)) {
			this.dismissContextMenu();
		}
	};

	RelationshipWidgetContextMenu.prototype.toggleFieldSearchInput = function toggleFieldSearchInput(event) {
		if (this.state.showFieldSearchInput.shown) {
			this.setState({
				showFieldSearchInput: {
					shown: false,
					triggerNode: null
				}
			});
		} else {
			if (event.target) {
				this.setState({
					showFieldSearchInput: {
						shown: true,
						triggerNode: event.target
					}
				});
			}
		}
	};

	RelationshipWidgetContextMenu.prototype._renderShowRelationshipsFieldSearchInput = function _renderShowRelationshipsFieldSearchInput() {
		if (this.state.showFieldSearchInput.shown) {
			return _react2.default.createElement(
				_Flyout2.default,
				{
					className: 'showRelationshipsBetweenTwoFields__fieldSearchInputFlyout',
					triggerNode: this.state.showFieldSearchInput.triggerNode
				},
				_react2.default.createElement(_FieldSearchInput2.default, {
					module: this.props.module,
					placeholder: _StringResources2.default.get('startingPoints_relationshipDiagram_show_relationships_between_two_fields_search_input_placeholder'),
					onSelect: this._onShowRelationships.bind(this)
				})
			);
		} else {
			return null;
		}
	};

	RelationshipWidgetContextMenu.prototype._onShowRelationships = function _onShowRelationships(item) {
		if (!item) {
			return;
		}

		var startingPointsVM = this.props.startingPointsVM;
		var relationshipVM = startingPointsVM.relationship;
		var queryObjectType = item.getObjectType();
		var showRelationshipFrom = relationshipVM.contextMenuField.itemId;
		var showRelationshipTo = item.getIdForExpression();
		if (queryObjectType === QUERY_ITEM && showRelationshipTo !== showRelationshipFrom) {
			//can only select a field, can not select table, cannot select target field and current context menu field
			//do showing relationships
			var targetModel = relationshipVM.getTargetModel();
			targetModel.showRelationshipsBetween(showRelationshipFrom, showRelationshipTo);
			//dismiss context menu
			this.dismissContextMenu();
		}
	};

	RelationshipWidgetContextMenu.prototype.componentDidMount = function componentDidMount() {
		this._bodyOnMouseDownHandler = this.bodyOnMouseDown.bind(this);
		document.body.addEventListener('mousedown', this._bodyOnMouseDownHandler);
	};

	RelationshipWidgetContextMenu.prototype.componentWillUnmount = function componentWillUnmount() {
		this.disposeFunctions.forEach(function (dispose) {
			return dispose();
		});
		this.disposeFunctions = null;
		if (this._bodyOnMouseDownHandler) {
			window.removeEventListener('mousedown', this._bodyOnMouseDownHandler);
			this._bodyOnMouseDownHandler = null;
		}
	};

	return RelationshipWidgetContextMenu;
}(_react.Component)) || _class;

RelationshipWidgetContextMenu.propTypes = {
	module: _PropTypes2.default.observableObject.isRequired,
	startingPointsVM: _PropTypes2.default.object.isRequired
};

exports.default = RelationshipWidgetContextMenu;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;
exports.eventIsInFloatingToolbar = eventIsInFloatingToolbar;

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _caUiToolkit = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var BASE_CLASS_NAME = 'flyoutToolbar';

function eventIsInFloatingToolbar(evt) {
	var e = evt.target;
	while (e) {
		var classList = e.classList;
		if (classList && classList.contains(BASE_CLASS_NAME)) {
			return true;
		}
		e = e.parentElement;
	}
	return false;
}

/**
 * Toolbar flyout
 */

var FloatingToolbar = function (_Component) {
	_inherits(FloatingToolbar, _Component);

	function FloatingToolbar(props) {
		_classCallCheck(this, FloatingToolbar);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	FloatingToolbar.prototype.render = function render() {

		var buttons = this.props.buttons.filter(function (_ref) {
			var include = _ref.include;
			return _underscore2.default.isUndefined(include) || include();
		});

		if (!buttons.length) {
			return null;
		}

		return _react2.default.createElement(
			_caUiToolkit.Flyout,
			{
				domNodeToAttachTo: document.body,
				triggerNode: this.props.triggerNode,
				className: BASE_CLASS_NAME
			},
			_react2.default.createElement(
				_caUiToolkit.Toolbar,
				null,
				buttons.map(function (_ref2, index) {
					var icon = _ref2.icon,
					    label = _ref2.label,
					    action = _ref2.action,
					    otherComponents = _ref2.otherComponents;
					return _react2.default.createElement(
						_caUiToolkit.Tooltip,
						{
							key: index,
							title: label,
							orient: 'top'
						},
						_react2.default.createElement(_caUiToolkit.Button, {
							iconSize: 'small',
							variant: 'icon',
							intent: 'primary',
							iconLeft: icon,
							'aria-label': label,
							onClick: action
						}),
						otherComponents ? otherComponents() : null
					);
				})
			)
		);
	};

	return FloatingToolbar;
}(_react.Component);

exports.default = FloatingToolbar;


FloatingToolbar.propTypes = {
	buttons: _PropTypes2.default.arrayOf(_PropTypes2.default.shape({
		icon: _PropTypes2.default.string.isRequired,
		label: _PropTypes2.default.string.isRequired,
		action: _PropTypes2.default.func.isRequired,
		include: _PropTypes2.default.func
	})).isRequired,
	triggerNode: _PropTypes2.default.element.isRequired
};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(394);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./Flyout.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./Flyout.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.exploreFlyout {\n  position: fixed;\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  z-index: 9999;\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);\n}\n\n", ""]);

// exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(17);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _caUiToolkit = __webpack_require__(6);

var _Dropdown = __webpack_require__(105);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _shaping = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var FieldSearchInput = function (_Component) {
	_inherits(FieldSearchInput, _Component);

	function FieldSearchInput(props) {
		_classCallCheck(this, FieldSearchInput);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._renderSearchInput = function (getTargetNode) {
			return _react2.default.createElement(_caUiToolkit.SearchInput, {
				placeholder: _this.props.placeholder,
				value: _this.state.inputValue,
				onChange: _this.onChange.bind(_this),
				ref: function ref(node) {
					if (node) {
						_this._searchInputRef = node;
						getTargetNode(node);
					}
				}
			});
		};

		_this.filteredValues = [];

		//Use state for whether focus is in the control as it's a very transient property
		_this.state = {
			inputValue: ''
		};
		return _this;
	}

	FieldSearchInput.prototype._shouldShowDropdown = function _shouldShowDropdown() {
		// if true, can render metadata tree
		return Boolean(this.state.inputValue && this.state.inputValue.length);
	};

	/*
  * @return the actual Search Input from which the dropdown appears
  */


	FieldSearchInput.prototype._renderDropdown = function _renderDropdown() {
		var module = this.props.module;
		var shapingHelper = module.getShapingHelper();
		return _react2.default.createElement(
			shapingHelper.ShapingProvider,
			null,
			_react2.default.createElement(_shaping.ShapingPickTree, {
				filter: this.state.inputValue,
				onSelect: this.onSelect.bind(this)
			})
		);
	};

	FieldSearchInput.prototype.render = function render() {
		return _react2.default.createElement(_Dropdown2.default, {
			renderTrigger: this._renderSearchInput.bind(this),
			renderDropdownContents: this._renderDropdown.bind(this),
			open: this._shouldShowDropdown(),
			getDropdownMaxHeight: this.getDropdownMaxHeight.bind(this),
			animationWhenContentChanges: false // Need to set this prop to `false` to avoid the dropdown keep boucing when user types in the field input
		});
	};

	FieldSearchInput.prototype.getDropdownMaxHeight = function getDropdownMaxHeight() {
		if (this._searchInputRef) {
			/* eslint react/no-find-dom-node:"off" */
			//findDOMNode is required in this case. More info here:
			// https://github.com/facebook/react/issues/9217#issuecomment-287622539
			var searchInput = (0, _reactDom.findDOMNode)(this._searchInputRef);
			if (searchInput) {
				var _searchInput$getBound = searchInput.getBoundingClientRect(),
				    top = _searchInput$getBound.top,
				    height = _searchInput$getBound.height;

				return window.innerHeight - height - top;
			}
		} else {
			return 0;
		}
	};

	FieldSearchInput.prototype.onChange = function onChange(value) {
		this.setState({
			inputValue: value
		});
	};

	FieldSearchInput.prototype.onSelect = function onSelect(item) {
		this.props.onSelect && this.props.onSelect(item);
	};

	return FieldSearchInput;
}(_react.Component);

FieldSearchInput.propTypes = {
	placeholder: _PropTypes2.default.string,
	module: _PropTypes2.default.observableObject.isRequired,
	onSelect: _PropTypes2.default.func
};

exports.default = FieldSearchInput;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, c) {
  if ("object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module))) module.exports = c(__webpack_require__(19));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (c),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var s = c("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js") : e["@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for (var o in s) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : e)[o] = s[o];
    }
  }
}("undefined" != typeof self ? self : undefined, function (e) {
  return webpackJsonPBaGraphics([941], { "3865314c5959606874d4": function c5959606874d4(c, s) {
      c.exports = e;
    }, "7e7ff5096a2f211949b7": function e7ff5096a2f211949b7(e, c, s) {
      "use strict";
      var o = s("9689a9c94ae38b47fa2c"),
          i = s.n(o),
          t = s("9ce58a7deea14f49ef01"),
          a = s.n(t),
          n = new i.a({ id: "make-center_16_v7", use: "make-center_16_v7-usage", viewBox: "0 0 16 16", content: '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="make-center_16_v7"><path d="M13 11c-.4 0-.7.1-1 .3L9.7 9c.4-.6.4-1.4 0-2L12 4.7c.3.2.6.3 1 .3 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .4.1.7.3 1L9 6.3c-.3-.2-.6-.3-1-.3s-.7.1-1 .3V3H6v2.3L4.7 4c.2-.3.3-.6.3-1 0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2c.4 0 .7-.1 1-.3L5.3 6H3v1h3.3c-.2.3-.3.6-.3 1s.1.7.3 1L4 11.3c-.3-.2-.6-.3-1-.3-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.4-.1-.7-.3-1L7 9.7c.6.4 1.4.4 2 0l2.3 2.3c-.2.3-.3.6-.3 1 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2zM3 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm10-2c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zM3 14c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm10 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z" /></symbol>' });a.a.add(n);c.a = n;
    }, "940cbcce22529045fd99": function cbcce22529045fd99(e, c, s) {
      "use strict";
      Object.defineProperty(c, "__esModule", { value: !0 });var o = s("3865314c5959606874d4"),
          i = (s.n(o), s("7e7ff5096a2f211949b7"));c.default = i.a;
    } }, ["940cbcce22529045fd99"]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)(module)))

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, s) {
  if ("object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module))) module.exports = s(__webpack_require__(19));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (s),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var o = s("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js") : e["@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for (var a in o) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : e)[a] = o[a];
    }
  }
}("undefined" != typeof self ? self : undefined, function (e) {
  return webpackJsonPBaGraphics([1312], { "2c8bc9513a97ee8a75e6": function c8bc9513a97ee8a75e6(e, s, o) {
      "use strict";
      Object.defineProperty(s, "__esModule", { value: !0 });var a = o("3865314c5959606874d4"),
          i = (o.n(a), o("46a57988a708188a72b2"));s.default = i.a;
    }, "3865314c5959606874d4": function c5959606874d4(s, o) {
      s.exports = e;
    }, "46a57988a708188a72b2": function a57988a708188a72b2(e, s, o) {
      "use strict";
      var a = o("9689a9c94ae38b47fa2c"),
          i = o.n(a),
          c = o("9ce58a7deea14f49ef01"),
          t = o.n(c),
          n = new i.a({ id: "draw-link_16_v7", use: "draw-link_16_v7-usage", viewBox: "0 0 16 16", content: '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="draw-link_16_v7"><path d="M5 3c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zM3 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm10 7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM8.4 9.1l.7-.7.7.7-.7.7-.7-.7zM7 6.3l-.7.7-.7-.7.7-.7.7.7zM5.6 4.9l-.7.7-.7-.7.7-.7.7.7zm2.8 2.8l-.7.7-.7-.7.7-.7.7.7zM11 11H8v-1h2V8h1v3z" /></symbol>' });t.a.add(n);s.a = n;
    } }, ["2c8bc9513a97ee8a75e6"]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)(module)))

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(399);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./RelationshipWidgetContextMenu.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./RelationshipWidgetContextMenu.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".showRelationshipsBetweenTwoFields__fieldSearchInputFlyout {\n  border: none;\n  width: 350px;\n}\n\n.showRelationshipsBetweenTwoFields__fieldSearchInputFlyout .ba-common-baseInput {\n  width: 100%;\n}\n\n", ""]);

// exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /**
             * Licensed Materials - Property of IBM
             *
             * "Restricted Materials of IBM"
             *
             * (C) Copyright IBM Corp. 2018, 2019
             *
             * US Government Users Restricted Rights - Use, duplication or disclosure
             * restricted by GSA ADP Schedule Contract with IBM Corp.
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _mobxUtils = __webpack_require__(15);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _RelationshipWidgetView = __webpack_require__(401);

var _RelationshipWidgetView2 = _interopRequireDefault(_RelationshipWidgetView);

var _RelationshipVisErrorView = __webpack_require__(113);

var _RelationshipVisErrorView2 = _interopRequireDefault(_RelationshipVisErrorView);

var _RelationshipStatusBar = __webpack_require__(412);

var _RelationshipStatusBar2 = _interopRequireDefault(_RelationshipStatusBar);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

__webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ERROR_DEFAULT_TITLE = _StringResources2.default.get('startingPoints_error_title_relationshipDiagram_unavailable');
var ERROR_DEFAULT_DESCRIPTION = _StringResources2.default.get('startingPoints_error_instructions_relationshipDiagram');

var RelationshipVisView = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(RelationshipVisView, _Component);

	function RelationshipVisView() {
		_classCallCheck(this, RelationshipVisView);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	/*Main render logic*/
	RelationshipVisView.prototype.render = function render() {
		var targetModel = this.props.relationship.getTargetModel();
		var state = targetModel && targetModel.data && targetModel.data.state;
		void this.props.relationship.exploreViewActivated;

		return _react2.default.createElement(
			'div',
			{ className: 'relationship-vis-view', id: this.props.relationship.uid },
			this._buildStatusBar(this.props.relationship.uid),
			state === _mobxUtils.REJECTED ? _react2.default.createElement(_RelationshipVisErrorView2.default, {
				error: targetModel.data.error,
				defaultTitle: ERROR_DEFAULT_TITLE,
				defaultDescription: ERROR_DEFAULT_DESCRIPTION
			}) : null,
			/*
   * Ideally there should be only one Diagram Widget instance in explore perspective
   * As a result, the parent DOM container is always avaiable and mounted
   * while currently a new VIPR widget instance is created when fetchData is triggered
   * When the process is happening in a deactived perspective, VIPR widget could
   * end up with rendeering in an invisible parent container.
   * Therefore, we are remount the WidgetView when explore perspective becomes activated
   * */

			this.props.relationship.exploreViewActivated ? _react2.default.createElement(_RelationshipWidgetView2.default, { relationship: this.props.relationship, services: this.props.services, fields: this.props.fields }) : null
		);
	};

	RelationshipVisView.prototype._buildStatusBar = function _buildStatusBar(containerId) {
		var targetModel = this.props.relationship.getTargetModel();
		var toastTarget = '' + containerId;
		return _react2.default.createElement(_RelationshipStatusBar2.default, {
			targetModel: targetModel,
			containerId: toastTarget
		});
	};

	return RelationshipVisView;
}(_react.Component)) || _class;

RelationshipVisView.propTypes = {
	relationship: _PropTypes2.default.object.isRequired,
	services: _PropTypes2.default.object,
	fields: _PropTypes2.default.object
};

exports.default = RelationshipVisView;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /**
             * Licensed Materials - Property of IBM
             *
             * "Restricted Materials of IBM"
             *
             * (C) Copyright IBM Corp. 2018, 2019
             *
             * US Government Users Restricted Rights - Use, duplication or disclosure
             * restricted by GSA ADP Schedule Contract with IBM Corp.
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(11);

var mobx = _interopRequireWildcard(_mobx);

var _mobxReact = __webpack_require__(5);

var _mobxStateTree = __webpack_require__(7);

var _mobxUtils = __webpack_require__(15);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMeasure = __webpack_require__(20);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _caUiToolkit = __webpack_require__(6);

var _RelationshipWidgetViewModel = __webpack_require__(402);

var _RelationshipWidgetViewModel2 = _interopRequireDefault(_RelationshipWidgetViewModel);

var _RelationshipDnDHelper = __webpack_require__(403);

var _RelationshipDnDHelper2 = _interopRequireDefault(_RelationshipDnDHelper);

var _RelationshipStrength = __webpack_require__(404);

var _RelationshipStrength2 = _interopRequireDefault(_RelationshipStrength);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

__webpack_require__(31);

var _RelationshipToolbar = __webpack_require__(406);

var _RelationshipToolbar2 = _interopRequireDefault(_RelationshipToolbar);

var _OverrideList = __webpack_require__(407);

var _OverrideList2 = _interopRequireDefault(_OverrideList);

var _filter_ = __webpack_require__(97);

var _filter_2 = _interopRequireDefault(_filter_);

var _RelationshipTargetModel = __webpack_require__(50);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ = __webpack_require__(8);


var VIS_CONTAINER_DOM_ID = 'relationship_graph';
var RENDER_MODE_CLIENT = 'client';
var NODESLIMIT_MIN = 2;
var NODESLIMIT_MAX = 50;
var DEFAULT_NODES_LIMIT = 10;

var RelationshipWidgetView = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(RelationshipWidgetView, _Component);

	/***
  *@constructor
  **/
	function RelationshipWidgetView(props) {
		_classCallCheck(this, RelationshipWidgetView);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.hintRef = _react2.default.createRef(); //DOM ref to hint text DIV
		_this.measureRef = _react2.default.createRef(); //DOM ref to the React Measure component which holds the relationship diagram
		_this.state = { dndHover: false };
		if (!_this.props.relationship.getIsFilterStrengthFeatureEnabled()) {
			_this.state.slider = DEFAULT_NODES_LIMIT;
		}
		_this.model = _RelationshipWidgetViewModel2.default.create();
		_this.disposeFunctions = [];

		//TODO Move to RelationshipWidgetViewModel per https://github.ibm.com/BusinessAnalytics/explore/pull/576#discussion-diff-1115614R40
		_this.disposeFunctions.push(mobx.autorun(function () {
			var targetModel = _this.props.relationship.getTargetModel();
			var state = targetModel && targetModel.data && targetModel.data.state;
			if (state === _mobxUtils.FULFILLED) {
				_this.model.setLastVisValid(true);
				//TODO: Render error without wiping away previous diagram
			} else if (state === _mobxUtils.REJECTED) {
				_this.model.setLastVisValid(false);
			} else if (state === _mobxUtils.PENDING) {
				var eventHandler = _this.getEventHandler && _this.getEventHandler();
				if (eventHandler) {
					eventHandler.onDestroy();
				}
			}
		}));

		_this.disposeFunctions.push(mobx.reaction(function () {
			return _this.props.relationship.nodesLimit;
		}, function (nodesLimit) {
			_this.setState({ slider: nodesLimit });
		}));

		_this.disposeFunctions.push(mobx.autorun(function () {
			if (_this.props.relationship.contextMenuField && _this.props.relationship.contextMenuElement) {
				_this.model.setContextMenuTarget(_this.props.relationship.contextMenuElement);
			} else {
				_this.model.setContextMenuTarget(null);
			}
		}));

		return _this;
	}

	/* Hookup render DOM with vis loader */


	RelationshipWidgetView.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		var measureRefNode = this._getMeasureDOMNode();
		if (measureRefNode) {
			measureRefNode.addEventListener('mouseenter', this._onMouseEnter.bind(this));
			measureRefNode.addEventListener('mouseleave', this._onMouseLeave.bind(this));
		}
		if (this.props.relationship.isAddFieldFeatureEnabled()) {
			this._initializeDndSupport();
		}
		//TODO: revisit this that we may want to return a handler module from visLoader
		this.props.relationship.setElement(this.el).then(function (_ref) {
			var getEventHandler = _ref.getEventHandler,
			    widget = _ref.widget,
			    addHighlight = _ref.addHighlight,
			    removeHighlight = _ref.removeHighlight;

			_this2.getEventHandler = getEventHandler;
			_this2.widget = widget;
			_this2.addHighlight = addHighlight; /*get the node that needs to add hightlight*/
			_this2.removeHighlight = removeHighlight; /*get the node that needs to remove hightlight*/
			_this2._onScrollhandler = _this2._onScroll.bind(_this2);

			window.addEventListener('scroll', _this2._onScrollhandler, true);
		});
	};

	RelationshipWidgetView.prototype._initializeDndSupport = function _initializeDndSupport() {
		var _this3 = this;

		this.props.services && this.props.services.getSvc('.DndManager').then(function (dndManager) {
			if (_this3.el) {
				_this3._dndManager = dndManager;
				_this3.dropOnDiagram = new _RelationshipDnDHelper2.default(_this3.el, 'dndHover', _this3._handleDrop.bind(_this3), _this3._handleAccept.bind(_this3), _this3._handleDragEnter.bind(_this3), _this3._handleDragLeave.bind(_this3), _this3.props.relationship);
				_this3.dropOnDiagram.initializeDndSource(_this3._dndManager, _this3._callback.bind(_this3));
				dndManager.addDropTarget(_this3.el, _this3.dropOnDiagram);
			}
		});
	};

	RelationshipWidgetView.prototype.componentWillUnmount = function componentWillUnmount() {
		this.disposeFunctions.forEach(function (disposeFunction) {
			return disposeFunction();
		});
		this.disposeFunctions = null;
		var measureRefNode = this._getMeasureDOMNode();
		if (measureRefNode) {
			measureRefNode.removeEventListener('mouseenter', this._onMouseEnter);
			measureRefNode.removeEventListener('mouseleave', this._onMouseLeave);
		}
		if (this._onScrollhandler) {
			window.removeEventListener('scroll', this._onScrollhandler, true);
			this._onScrollhandler = null;
		}
		if (this.model) {
			(0, _mobxStateTree.destroy)(this.model);
			this.model = null;
		}
	};

	RelationshipWidgetView.prototype._getMeasureDOMNode = function _getMeasureDOMNode() {
		if (this.measureRef && this.measureRef.current) {
			return this.measureRef.current._node; //workaround to return Measure componnet's DOM Node
		}
		return null;
	};

	RelationshipWidgetView.prototype._onScroll = function _onScroll() {
		var eventHandler = this._getEventHandler();
		return eventHandler && eventHandler.removeTooltip();
	};

	/* Render the widget visView */


	RelationshipWidgetView.prototype.render = function render() {
		return this._buildRenderMarkup();
	};

	RelationshipWidgetView.prototype._buildRenderMarkup = function _buildRenderMarkup() {
		var _this4 = this;

		var targetModel = this.props.relationship.getTargetModel();
		var state = targetModel && targetModel.data && targetModel.data.state;
		var error = state === _mobxUtils.REJECTED;
		var pending = state === _mobxUtils.PENDING;
		var sVizContainerID = _.uniqueId(VIS_CONTAINER_DOM_ID);
		this.sVizContainerID = sVizContainerID;
		var widgetParentClasses = (0, _classnames2.default)({
			'relationship-vis-view__widget-parent-placeholder': true,
			'relationship-vis-view__widget-parent-placeholder--error': error && !this.model.lastVisValid,
			'relationship-vis-view__widget-parent-placeholder--loading': pending,
			'relationship-vis-view__widget-parent-placeholder--loading-error': pending && !this.model.lastVisValid,
			'relationship-vis-view__widget-parent-placeholder--loading-ok': pending && this.model.lastVisValid
		});
		var visContainerParentClasses = (0, _classnames2.default)({
			'relationship-vis-view__widget-parent-placeholder_containerDndHover': this.state.dndHover,
			'relationship-vis-view__widget-parent-placeholder__widget_wrapper': true
		});
		var visContainerClasses = (0, _classnames2.default)({
			'relationship-vis-view__widget-parent-placeholder__widget': true
		});
		var filterIcon = this.props.relationship.isFilterStartingPointsEnabled() && this.props.relationship.getFilterCount() > 0 ? _react2.default.createElement(
			'div',
			{ className: 'relationship-vis-view__filter' },
			_react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _filter_2.default.id, intent: 'primary' })
		) : null;
		return _react2.default.createElement(
			_reactMeasure2.default,
			{ ref: this.measureRef,
				onResize: function onResize() {
					return _this4.onResize();
				}
			},
			function (_ref2) {
				var measureRef = _ref2.measureRef;
				return _react2.default.createElement(
					'div',
					{ className: widgetParentClasses, ref: measureRef },
					_this4._buildToolbarMarkup(state),
					_this4._buildRelationshipToolbar(),
					_react2.default.createElement(
						'div',
						{ id: sVizContainerID + '_parent', className: visContainerParentClasses },
						_this4.props.relationship.isOverrideListFeatureEnabled() ? _this4._renderOverrideList() : null,
						filterIcon,
						_react2.default.createElement('div', {
							id: sVizContainerID,
							className: visContainerClasses,
							ref: function ref(el) {
								return _this4.el = el;
							},
							onClick: function onClick(event) {
								return _this4._onClick(event);
							},
							onContextMenu: function onContextMenu(event) {
								return _this4._onContextMenu(event);
							},
							onMouseOver: function onMouseOver(event) {
								return _this4._onMouseOver(event);
							},
							onMouseOut: function onMouseOut(event) {
								return _this4._onMouseOut(event);
							},
							onTouchStart: function onTouchStart(event) {
								return _this4._onTouchStart(event);
							},
							onTouchEnd: function onTouchEnd(event) {
								return _this4._onTouchEnd(event);
							},
							onKeyDown: function onKeyDown(event) {
								return _this4._onKeyDown(event);
							}
						}),
						_react2.default.createElement(
							'div',
							{ className: 'starting-points-page__relationship__hint', ref: _this4.hintRef },
							_StringResources2.default.get('startingPoints_select_diagram_node_hints')
						),
						_this4._buildRelationshipStrength()
					)
				);
			}
		);
	};

	RelationshipWidgetView.prototype._renderOverrideList = function _renderOverrideList() {
		var targetModel = this.props.relationship.getTargetModel();
		var overrideList = null;
		if (targetModel) {
			var addedFields = targetModel.getAddedFields();
			var deletedFields = targetModel.getDeletedFields();
			var allFields = this.props.fields.getFields().getAll();
			var mapOverrideFields = function mapOverrideFields(action, fieldID) {
				var foundField = allFields.find(function (field) {
					return field.id === fieldID;
				});
				return {
					fieldLabel: foundField.name,
					fieldID: fieldID,
					action: action
				};
			};
			var overrideFields = [].concat(addedFields.map(function (addedField) {
				return mapOverrideFields(_RelationshipTargetModel.OVERRIDE_ACTIONS.ADDED, addedField);
			}).reverse(), deletedFields.map(function (deletedField) {
				return mapOverrideFields(_RelationshipTargetModel.OVERRIDE_ACTIONS.DELETED, deletedField);
			}).reverse());
			if (overrideFields.length) {
				overrideList = _react2.default.createElement(_OverrideList2.default, {
					overrideFields: overrideFields,
					cancelAction: function cancelAction(actionToCancel, fieldID) {
						// Do cancel action
						targetModel.cancelAction(actionToCancel, fieldID);
					}
				});
			}
		}
		return overrideList;
	};

	RelationshipWidgetView.prototype._buildRelationshipToolbar = function _buildRelationshipToolbar() {
		if (this.props.relationship.getIsFilterStrengthFeatureEnabled() && !this.props.relationship.isNewStartingPointsFeatureEnabled()) {
			var targetModel = this.props.relationship.getTargetModel();
			// Using void to force the slider to update when min/max strength is loaded
			if (targetModel) {
				void targetModel.initialFilterStrength.min;
				void targetModel.initialFilterStrength.max;
				return _react2.default.createElement(_RelationshipToolbar2.default, { targetModel: targetModel });
			} else {
				return null;
			}
		} else {
			return null;
		}
	};

	RelationshipWidgetView.prototype._buildToolbarMarkup = function _buildToolbarMarkup(state) {
		if (this.props.relationship.getIsFilterStrengthFeatureEnabled() || this.props.relationship.isNewStartingPointsFeatureEnabled()) {
			return null;
		}
		return _react2.default.createElement(
			'div',
			{ className: 'relationship-vis-view__toolbar' },
			this._buildToggleMarkUp(state),
			this._buildSliderMarkup(state)
		);
	};

	RelationshipWidgetView.prototype._buildRelationshipStrength = function _buildRelationshipStrength() {
		if (!this.props.relationship.isNewStartingPointsFeatureEnabled()) {
			return null;
		}
		var targetModel = this.props.relationship.getTargetModel();
		if (!targetModel) {
			return null;
		}
		// Using void to force the slider to update when min/max strength is loaded
		void targetModel.initialMinStrength;
		void targetModel.initialMaxStrength;
		return _react2.default.createElement(_RelationshipStrength2.default, { targetModel: targetModel });
	};

	RelationshipWidgetView.prototype._buildToggleMarkUp = function _buildToggleMarkUp() {
		var _this5 = this;

		if (!this.props.relationship.isConceptsViewEnabled()) {
			return null;
		}
		var toggleLabel = _StringResources2.default.get('relationshipGraph_toggle_label');
		var alignment = 'right';
		return _react2.default.createElement(
			'div',
			{ className: 'relationship-vis-view__toggler' },
			_react2.default.createElement(_caUiToolkit.ToggleSwitch, {
				label: toggleLabel,
				align: alignment,
				onChange: function onChange() {
					_this5.props.relationship.setShowConcepts(!_this5.props.relationship.showConcepts);
				},
				checked: this.props.relationship.showConcepts,
				small: true
			})
		);
	};

	RelationshipWidgetView.prototype._buildSliderMarkup = function _buildSliderMarkup() {
		var _this6 = this;

		var classes = (0, _classnames2.default)({
			'relationship-vis-view__sliderParent': true
		});
		var sliderLabel = _StringResources2.default.get('relationshipGraph_slider_label');
		var sliderTooltip = _StringResources2.default.get('relationshipGraph_slider_tooltip');

		return _react2.default.createElement(
			'div',
			{ className: classes,
				onMouseUp: function onMouseUp() {
					return _this6._sliderOnMouseUp();
				},
				onKeyUp: function onKeyUp() {
					return _this6._sliderOnMouseUp();
				},
				onTouchEnd: function onTouchEnd() {
					return _this6._sliderOnMouseUp();
				}
			},
			_react2.default.createElement(
				_caUiToolkit.Tooltip,
				{ title: sliderTooltip, orient: 'top' },
				sliderLabel
			),
			_react2.default.createElement(
				'div',
				{ className: 'relationship-vis-view__sliderContainer' },
				_react2.default.createElement(_caUiToolkit.Slider, {
					showTooltip: true,
					value: this.state.slider,
					showBoundaryLabels: true,
					className: 'relationship-vis-view__slider',
					onChange: function onChange(newValue) {
						_this6.setState({ slider: newValue });
					},
					small: true,
					min: NODESLIMIT_MIN, max: NODESLIMIT_MAX })
			)
		);
	};

	RelationshipWidgetView.prototype._sliderOnMouseUp = function _sliderOnMouseUp() {
		this.props.relationship.setNodesLimit(this.state.slider);
	};

	RelationshipWidgetView.prototype.onResize = function onResize() {
		if (this._isValidWidgetSize()) {
			this.widget.render(RENDER_MODE_CLIENT);
		}
	};

	// This is to avoid issue when When switching from Explore to other perspective (e.g Home) and switch back to Explore


	RelationshipWidgetView.prototype._isValidWidgetSize = function _isValidWidgetSize() {
		return this.widget && this.widget.domNode && this.widget.domNode.clientHeight > 0 && this.widget.domNode.clientWidth > 0;
	};

	RelationshipWidgetView.prototype._callback = function _callback() {}
	//TODO: Verify why this function is needed


	/*
  * Mouse Drop event handler
  *
  * Event handler for dragging columns from metadata tree and dropping them
  * on the relationship widget.
  */
	;

	RelationshipWidgetView.prototype._handleDrop = function _handleDrop(dragObj) {
		var _this7 = this;

		this.setState({ 'dndHover': false });
		var itemIds = this._getDragItems(dragObj);
		if (!itemIds) {
			return;
		}
		var targetId = this.props.relationship.getCurrentTargetId();
		if (targetId) {
			if (this.nodesFound.length) {
				this.nodesFound.forEach(function (nodeId) {
					_this7.removeHighlight(nodeId, targetId);
				});
				this.widget.render('client');
			}
			if (this.nodesFound.length !== itemIds.length) {
				// some nodes are not found
				this._handleDragLeave();
				var targetModel = this.props.relationship.getTargetModel();
				if (targetModel) {
					targetModel.setLastAddedFields(itemIds);
				}
			}
		}
	};

	/*Highlight the nodes if the dragged columns are already displayed in the diagram*/


	RelationshipWidgetView.prototype._handleDragEnter = function _handleDragEnter(dragObj) {
		var _this8 = this;

		this.nodesFound = [];
		var targetId = this.props.relationship.getCurrentTargetId();
		var itemIds = this._getDragItems(dragObj);
		if (targetId && itemIds) {
			itemIds.forEach(function (itemId) {
				if (_this8.addHighlight(itemId, targetId)) {
					_this8.nodesFound.push(itemId);
				}
			});

			if (this.nodesFound.length === itemIds.length) {
				// all nodes are already displayed in the diagram, just call render to make highlight effective
				this.widget.render('client');
			} else {
				// at least 1 node is not displayed in the diagram, make the diagram container visible in waiting for looking up the new node
				this.setState({ 'dndHover': true });
				this.el.classList.add('relationship-vis-view__widget-parent-placeholder--dragEnter');
			}
		}
	};

	RelationshipWidgetView.prototype._handleDragLeave = function _handleDragLeave() {
		this.setState({ 'dndHover': false });
		this.el.classList.remove('relationship-vis-view__widget-parent-placeholder--dragEnter');
	};

	RelationshipWidgetView.prototype._getDragItems = function _getDragItems(dragObj) {
		if (dragObj && dragObj.data && dragObj.data.items) {
			var items = dragObj.data.items;
			if (items.length) {
				return items.map(function (item) {
					return item.idForExpression;
				});
			}
		}
		return null;
	};

	RelationshipWidgetView.prototype._handleAccept = function _handleAccept(dragObj) {
		//TODO: We should only accept columns
		void dragObj;
		return true;
	};

	RelationshipWidgetView.prototype._onClick = function _onClick(event) {
		var eventHandler = this._getEventHandler();
		return eventHandler && eventHandler.onClick(event);
	};

	RelationshipWidgetView.prototype._onContextMenu = function _onContextMenu(event) {
		var eventHandler = this._getEventHandler();
		return eventHandler && eventHandler.onRightClick(event);
	};

	RelationshipWidgetView.prototype._onMouseOver = function _onMouseOver(event) {
		var eventHandler = this._getEventHandler();
		return eventHandler && eventHandler.onMouseOver(event);
	};

	RelationshipWidgetView.prototype._onMouseOut = function _onMouseOut(event) {
		var eventHandler = this._getEventHandler();

		return eventHandler && eventHandler.onMouseOut(event);
	};

	RelationshipWidgetView.prototype._onMouseEnter = function _onMouseEnter() {
		this.hintRef.current.classList.remove('starting-points-page__relationship__hint__hidden');
	};

	RelationshipWidgetView.prototype._onMouseLeave = function _onMouseLeave() {
		this.hintRef.current.classList.add('starting-points-page__relationship__hint__hidden');
	};

	RelationshipWidgetView.prototype._onTouchStart = function _onTouchStart(event) {
		var eventHandler = this._getEventHandler();
		eventHandler && eventHandler.onTouchStart(event);
	};

	RelationshipWidgetView.prototype._onTouchEnd = function _onTouchEnd(event) {
		var eventHandler = this._getEventHandler();
		eventHandler && eventHandler.onTouchEnd(event);
	};

	RelationshipWidgetView.prototype._onKeyDown = function _onKeyDown(event) {
		var eventHandler = this._getEventHandler();
		eventHandler && eventHandler.onKeyDown(event);
	};

	RelationshipWidgetView.prototype._getEventHandler = function _getEventHandler() {
		return this.getEventHandler && this.getEventHandler();
	};

	return RelationshipWidgetView;
}(_react.Component)) || _class;

RelationshipWidgetView.propTypes = {
	relationship: _PropTypes2.default.object.isRequired,
	services: _PropTypes2.default.object,
	fields: _PropTypes2.default.object
};

exports.default = RelationshipWidgetView;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _mobxStateTree = __webpack_require__(7);

var DELAY = 250; /*
                  *+------------------------------------------------------------------------+
                  *| Licensed Materials - Property of IBM
                  *| IBM Cognos Products: Explore
                  *| (C) Copyright IBM Corp. 2018, 2019
                  *|
                  *| US Government Users Restricted Rights - Use, duplication or disclosure
                  *| restricted by GSA ADP Schedule Contract with IBM Corp.
                  *+------------------------------------------------------------------------+
                  */
exports.default = _mobxStateTree.types.model('RelationshipVisViewModel', {
	lastVisValid: _mobxStateTree.types.optional(_mobxStateTree.types.boolean, true),
	setTargetHandle: _mobxStateTree.types.optional(_mobxStateTree.types.union(_mobxStateTree.types.number, _mobxStateTree.types.null), null)
}).volatile(function () {
	return {
		target: null
	};
}).actions(function (self) {
	return {
		setLastVisValid: function setLastVisValid(valid) {
			self.lastVisValid = valid;
		},
		setContextMenuTarget: function setContextMenuTarget(target) {
			if (self.setTargetHandle) {
				clearTimeout(self.setTargetHandle);
				self.setTargetHandle = null;
			}
			self.target = null;
			if (target) {
				self.setTargetHandle = setTimeout(function () {
					return self._setTarget(target);
				}, DELAY);
			}
		},
		_setTarget: function _setTarget(target) {
			self.target = target;
			self.setTargetHandle = null;
		}
	};
});

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _jquery = __webpack_require__(14);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

var _Config = __webpack_require__(16);

var _Config2 = _interopRequireDefault(_Config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Licensed Materials - Property of IBM
                                                                                                                                                           * IBM Watson Analytics (C) Copyright IBM Corp. 2019, 2020
                                                                                                                                                           * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           */


var QUERY_ITEM = 'QueryItem';
var CALCULATION = 'Calculation';

var RelationshipDndHelper = function () {
	function RelationshipDndHelper(domNode, className, dropHandler, acceptsHandler, dragEnterHandler, dragLeaveHandler, relationshipVM) {
		_classCallCheck(this, RelationshipDndHelper);

		this.domNode = domNode;
		this.className = className;
		this.dropHandler = dropHandler;
		this.acceptsHandler = acceptsHandler;
		this.dragEnterHandler = dragEnterHandler;
		this.dragLeaveHandler = dragLeaveHandler;
		this.relationshipVM = relationshipVM;
	}

	RelationshipDndHelper.prototype.accepts = function accepts(dragObject) {
		var data = this.getData(dragObject);
		if (data && data.length) {
			var targetModel = this.relationshipVM.getTargetModel();
			var nodeCount = targetModel.getDiagramNodeCount();
			if (!nodeCount || data.length + nodeCount > _Config2.default.max_nodes_to_display) {
				// can't add fields if nothing in diagram or total of nodes in diagram after the drop could be bigger than the limit of number of nodes to display
				return false;
			}
			var invalidObjectType = data.some(function (entry) {
				// if at least one object is not a query item/calculation, do not accept the drop
				if (!entry.getObjectType || entry.getObjectType() !== QUERY_ITEM && entry.getObjectType() !== CALCULATION) {
					return true;
				}
			});
			return !invalidObjectType;
		}
		return false;
	};

	RelationshipDndHelper.prototype.getData = function getData(dragObject) {
		return this._getDropMetadataColumns(dragObject);
	};

	RelationshipDndHelper.prototype._getDropMetadataColumns = function _getDropMetadataColumns(dragObject) {
		return _underscore2.default.map(dragObject && dragObject.data && dragObject.data.columns, function (column) {
			return column.metadataColumn;
		});
	};

	RelationshipDndHelper.prototype.activateDropTarget = function activateDropTarget() {
		(0, _jquery2.default)(this.domNode).toggleClass(this.className, true);
	};

	RelationshipDndHelper.prototype.deactivateDropTarget = function deactivateDropTarget() {
		(0, _jquery2.default)(this.domNode).toggleClass(this.className, false);
	};

	RelationshipDndHelper.prototype.onDragStart = function onDragStart() {};

	RelationshipDndHelper.prototype.onDragEnter = function onDragEnter(dragObject, dropNode) {
		this.dragEnterHandler(dragObject, dropNode);
	};

	RelationshipDndHelper.prototype.onDragMove = function onDragMove() {
		this.activateDropTarget();
	};

	RelationshipDndHelper.prototype.onDragLeave = function onDragLeave() {
		this.deactivateDropTarget();
		this.dragLeaveHandler();
	};

	RelationshipDndHelper.prototype.onDragEnd = function onDragEnd() {
		this.deactivateDropTarget();
	};

	RelationshipDndHelper.prototype.onDrop = function onDrop(dragObject, dropNode) {
		this.dropHandler(dragObject, dropNode);
	};

	RelationshipDndHelper.prototype.initializeDndSource = function initializeDndSource(dndManager) {
		var _this = this;

		(0, _jquery2.default)(this.domNode).on('mousedown touchstart', {}, function (event) {
			var $avatar = (0, _jquery2.default)('<div style="position:absolute; z-index:10000;"/>', {
				'class': 'listitem columnName avatarLive'
			});
			$avatar.append((0, _jquery2.default)(_this.domNode).clone());
			dndManager.startDrag({
				event: event,
				avatar: $avatar,
				moveXThreshold: 20,
				moveYThreshold: 20
			});
			return true;
		});
	};

	return RelationshipDndHelper;
}();

exports.default = RelationshipDndHelper;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class, _desc, _value, _class2, _descriptor; /**
                                                  * Licensed Materials - Property of IBM
                                                  *
                                                  * "Restricted Materials of IBM"
                                                  *
                                                  * (C) Copyright IBM Corp. 2019, 2020
                                                  *
                                                  * US Government Users Restricted Rights - Use, duplication or disclosure
                                                  * restricted by GSA ADP Schedule Contract with IBM Corp.
                                                  */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(11);

var _mobxReact = __webpack_require__(5);

var _reactMeasure = __webpack_require__(20);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _caUiToolkit = __webpack_require__(6);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

__webpack_require__(31);

var _RelationshipInfoTooltip = __webpack_require__(111);

var _RelationshipInfoTooltip2 = _interopRequireDefault(_RelationshipInfoTooltip);

var _getInformation_ = __webpack_require__(112);

var _getInformation_2 = _interopRequireDefault(_getInformation_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
	if (!descriptor) return;
	Object.defineProperty(target, property, {
		enumerable: descriptor.enumerable,
		configurable: descriptor.configurable,
		writable: descriptor.writable,
		value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	});
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

function _initializerWarningHelper(descriptor, context) {
	throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var SIZES = {
	'small': [0, 699],
	'large': [700, Infinity]
};

var RelationshipStrength = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
	_inherits(RelationshipStrength, _Component);

	/***
  *@constructor
  **/
	function RelationshipStrength(props) {
		_classCallCheck(this, RelationshipStrength);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_initDefineProp(_this, 'sliderRange', _descriptor, _this);

		_this.resetFlyout = function () {
			_this.setState({
				isInfoTooltipOpen: false
			});
			// reset focus on the Info icon
			if (_this.strengthInfoRef.current) {
				_this.strengthInfoRef.current.focus();
			}
		};

		_this._onKeyDown = function (event) {
			switch (event.key) {
				case ' ': // space
				case 'Enter':
					_this._onInfoClick(event);
			}
		};

		_this._onInfoClick = function (event) {
			// avoid reacting to the click on X icon when the info flyout is opened
			if (event && event.target && event.target.classList && event.target.classList.contains('relationship-vis-view__strength__info')) {
				// toggle InfoTooltip
				_this.setState({
					isInfoTooltipOpen: !_this.state.isInfoTooltipOpen
				});
			}
		};

		_this.sliderRange = {
			min: _this.props.targetModel.computedMinStrength,
			max: _this.props.targetModel.computedMaxStrength
		};
		_this.state = {
			size: undefined,
			isInfoTooltipOpen: false
		};
		_this.strengthInfoRef = _react2.default.createRef();
		return _this;
	}

	RelationshipStrength.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
		// Update slider state when we have new relationship min-max strength passed in props
		this.sliderRange = {
			min: newProps.targetModel.computedMinStrength,
			max: newProps.targetModel.computedMaxStrength
		};
		this.setState(this.state);
	};

	/* Render the relationship toolbar which includes filter strength slider and checkbox for view type */


	RelationshipStrength.prototype.render = function render() {
		var _this2 = this;

		var sliderLabel = _StringResources2.default.get('relationshipGraph_filterStrength_label');
		var size = this.state.size;

		var classes = (0, _classnames2.default)({
			'relationship-vis-view__strength': true,
			'small': size === 'small',
			'large': size === 'large'
		});
		return _react2.default.createElement(
			_reactMeasure2.default,
			{
				onResize: function onResize(contentRect) {
					return _this2._onResize(contentRect);
				}
			},
			function (_ref) {
				var measureRef = _ref.measureRef;
				return _react2.default.createElement(
					'div',
					{ className: classes, ref: measureRef },
					_this2._buildInformationMarkup(sliderLabel),
					_this2._buildSliderMarkup()
				);
			}
		);
	};

	RelationshipStrength.prototype._onResize = function _onResize() {
		var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
		    _ref2$entry = _ref2.entry;

		_ref2$entry = _ref2$entry === undefined ? {} : _ref2$entry;
		var width = _ref2$entry.width;

		if (width) {
			var size = Object.keys(SIZES).find(function (key) {
				var _SIZES$key = SIZES[key],
				    min = _SIZES$key[0],
				    max = _SIZES$key[1];

				return width >= min && width <= max;
			});

			if (size) {
				this.setState({
					size: size
				});
			}
		}
	};

	RelationshipStrength.prototype._buildInformationMarkup = function _buildInformationMarkup(sliderLabel) {
		return _react2.default.createElement(
			'div',
			{ className: 'relationship-vis-view__strength__infoParent' },
			_react2.default.createElement(
				'div',
				{
					ref: this.strengthInfoRef,
					className: 'relationship-vis-view__strength__info',
					tabIndex: 0,
					'aria-label': sliderLabel,
					onClick: this._onInfoClick,
					onKeyDown: this._onKeyDown
				},
				_react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _getInformation_2.default.id, intent: 'primary' }),
				_react2.default.createElement(
					'div',
					{ className: 'relationship-vis-view__strength__infoTooltip' },
					_react2.default.createElement(_RelationshipInfoTooltip2.default, {
						isOpen: this.state.isInfoTooltipOpen,
						triggerNode: this.strengthInfoRef.current,
						onClose: this.resetFlyout
					})
				)
			),
			_react2.default.createElement(_caUiToolkit.Label, { className: 'relationship-vis-view__strength__infoLabel', label: sliderLabel })
		);
	};

	RelationshipStrength.prototype._buildSliderMarkup = function _buildSliderMarkup() {
		var _this3 = this;

		var size = this.state.size;

		var classes = (0, _classnames2.default)({
			'relationship-vis-view__strength__slider': true,
			'small': size === 'small',
			'large': size === 'large'
		});
		var toPercent = function toPercent(number) {
			if (!number) {
				return null;
			}
			return number.toString() + '%';
		};
		return _react2.default.createElement(
			'div',
			{ className: classes },
			_react2.default.createElement(_caUiToolkit.RangeSlider, {
				showTooltip: true,
				showBoundaryLabels: true,
				className: 'relationship-vis-view__strength__slider__range',
				values: [this.sliderRange.min, this.sliderRange.max],
				labelFormatter: toPercent,
				onChange: function onChange(values) {
					return _this3._onValueChange.apply(_this3, values);
				},
				onInputComplete: function onInputComplete() {
					return _this3._onInputComplete();
				},
				size: 'small',
				min: 10, max: 100 })
		);
	};

	RelationshipStrength.prototype._onValueChange = function _onValueChange(min, max) {
		this.sliderRange = { min: min, max: max };
	};

	RelationshipStrength.prototype._onInputComplete = function _onInputComplete() {
		this.props.targetModel.setFilterStrength({ min: this.sliderRange.min, max: this.sliderRange.max });
	};

	return RelationshipStrength;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'sliderRange', [_mobx.observable], {
	enumerable: true,
	initializer: function initializer() {
		return null;
	}
})), _class2)) || _class;

RelationshipStrength.propTypes = {
	targetModel: _PropTypes2.default.object.isRequired
};

exports.default = RelationshipStrength;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.relationshipViewWrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1;\n  height: 100%;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.relationship-vis-view__tooltip {\n  text-align: left;\n  word-break: break-all;\n  padding: 0;\n  margin: 0;\n}\n\n.relationship-vis-view__tooltip .ba-common-label {\n  color: white;\n  color: hsla(var(--text-04-h, 0), var(--text-04-s, 0%), var(--text-04-l, 100%), 1);\n}\n\n.relationship-vis-view__disambiguatingTooltip {\n  min-width: 240px;\n  text-align: left;\n  padding-bottom: 5px;\n}\n\n.relationship-vis-view__disambiguatingTooltipTitle {\n  min-width: 240px;\n  padding-left: 8px;\n  padding-top: 5px;\n}\n\n.starting-points-page .relationship-vis-view {\n  -ms-flex: 1;\n      flex: 1;\n  position: relative;\n}\n\n.starting-points-page .relationship-vis-view__widget-parent-placeholder {\n  width: 100%;\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.starting-points-page .relationship-vis-view__widget-parent-placeholder__widget_wrapper {\n  width: 100%;\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.starting-points-page .relationship-vis-view__widget-parent-placeholder__widget_wrapper .overrideList {\n  -ms-flex-item-align: end;\n      align-self: flex-end;\n}\n\n.starting-points-page .relationship-vis-view__widget-parent-placeholder__widget {\n  height: 100%;\n  width: 100%;\n}\n\n.starting-points-page .relationship-vis-view__widget-parent-placeholder--error {\n  visibility: hidden;\n}\n\n.starting-points-page .relationship-vis-view__widget-parent-placeholder--loading-error {\n  visibility: hidden;\n}\n\n.starting-points-page .relationship-vis-view__widget-parent-placeholder--loading-ok {\n  opacity: 0.5;\n}\n\n.starting-points-page .relationship-vis-view__widget-parent-placeholder--dragEnter {\n  opacity: 0.3;\n}\n\n.starting-points-page .relationship-vis-view__widget-parent-placeholder_containerDndHover {\n  height: 100%;\n  width: 100%;\n  outline-style: solid;\n  outline-width: 2px;\n  outline-color: #0f62fe;\n  outline-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  outline-offset: -10px;\n  box-sizing: border-box;\n}\n\n.starting-points-page .relationship-vis-view__toolbar {\n  width: 100%;\n  height: 60px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n\n.starting-points-page .relationship-vis-view__filter {\n  position: absolute;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  padding-top: 24px;\n}\n\n.starting-points-page .relationship-vis-view__toolbarNew {\n  width: 100%;\n  height: 23px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  border-bottom: 1px solid;\n  border-bottom-color: #e0e0e0;\n  border-bottom-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 8px 0px;\n  font-size: 12px;\n}\n\n.starting-points-page .relationship-vis-view__toolbarNew__info {\n  padding-top: 2px;\n  cursor: pointer;\n}\n\n.starting-points-page .relationship-vis-view__toolbarNew__info svg {\n  vertical-align: middle;\n  fill: #525252;\n  fill: hsla(var(--icon-02-h, 0), var(--icon-02-s, 0%), var(--icon-02-l, 32.15686%), 1);\n}\n\n.starting-points-page .relationship-vis-view__toolbarNew__sliderParent {\n  min-width: 250px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.starting-points-page .relationship-vis-view__toolbarNew__sliderParent__sliderLabel {\n  padding-left: 5px;\n}\n\n.starting-points-page .relationship-vis-view__toolbarNew__sliderParent__sliderContainer {\n  margin-left: 8px;\n}\n\n.starting-points-page .relationship-vis-view__toolbarNew__sliderParent__slider {\n  width: 150px;\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.starting-points-page .relationship-vis-view__toolbarNew__sliderParent__slider__range {\n  width: 250px;\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.starting-points-page .relationship-vis-view__toolbarNew__sliderParent__slider__range .ba-common-slider__boundary_label {\n  margin: 0px 2px;\n}\n\n.starting-points-page .relationship-vis-view__toolbarNew .ba-common-separator {\n  border-color: #e0e0e0;\n  border-color: hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.84314%), 1);\n}\n\n.starting-points-page .relationship-vis-view__toolbarNew__secondaryRelationship-checkbox .ba-common-checkbox__box {\n  box-sizing: border-box;\n}\n\n.starting-points-page .relationship-vis-view__strength {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 8px 0px;\n  font-size: 12px;\n}\n\n.starting-points-page .relationship-vis-view__strength__infoParent {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n\n.starting-points-page .relationship-vis-view__strength__infoLabel {\n  padding-left: 5px;\n  color: #393939;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 22.35294%), 1);\n}\n\n.starting-points-page .relationship-vis-view__strength__info {\n  cursor: pointer;\n}\n\n.starting-points-page .relationship-vis-view__strength__info svg {\n  vertical-align: middle;\n  fill: #525252;\n  fill: hsla(var(--icon-02-h, 0), var(--icon-02-s, 0%), var(--icon-02-l, 32.15686%), 1);\n}\n\n.starting-points-page .relationship-vis-view__strength__slider__range {\n  width: 250px;\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.starting-points-page .relationship-vis-view__strength__slider__range .ba-common-slider__boundary_label {\n  margin: 0px 2px;\n}\n\n.starting-points-page .relationship-vis-view__strength__slider.small {\n  font-size: inherit;\n  position: relative;\n  margin-bottom: 8px;\n}\n\n.starting-points-page .relationship-vis-view__strength__slider.large {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.starting-points-page .relationship-vis-view__strength.small {\n  -ms-flex-direction: column-reverse;\n      flex-direction: column-reverse;\n}\n\n.starting-points-page .relationship-vis-view__toggler * {\n  box-sizing: border-box;\n}\n\n.starting-points-page .relationship-vis-view__sliderParent {\n  min-width: 250px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n\n.starting-points-page .relationship-vis-view__sliderContainer {\n  margin-left: 16px;\n}\n\n.starting-points-page .relationship-vis-view__slider {\n  width: 150px;\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.starting-points-page .relationship-vis-view__slider__range {\n  width: 250px;\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.starting-points-page .relationship-vis-view__displayVisContent {\n  display: block;\n}\n\n.starting-points-page .relationship-vis-view__error {\n  height: 100%;\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n  text-align: center;\n}\n\n.starting-points-page .relationship-vis-view__error__title {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.starting-points-page .relationship-vis-view--loading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}\n\n", ""]);

// exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class, _desc, _value, _class2, _descriptor; /**
                                                  * Licensed Materials - Property of IBM
                                                  *
                                                  * "Restricted Materials of IBM"
                                                  *
                                                  * (C) Copyright IBM Corp. 2019
                                                  *
                                                  * US Government Users Restricted Rights - Use, duplication or disclosure
                                                  * restricted by GSA ADP Schedule Contract with IBM Corp.
                                                  */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobx = __webpack_require__(11);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _caUiToolkit = __webpack_require__(6);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

__webpack_require__(31);

var _RelationshipInfoTooltip = __webpack_require__(111);

var _RelationshipInfoTooltip2 = _interopRequireDefault(_RelationshipInfoTooltip);

var _getInformation_ = __webpack_require__(112);

var _getInformation_2 = _interopRequireDefault(_getInformation_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
	if (!descriptor) return;
	Object.defineProperty(target, property, {
		enumerable: descriptor.enumerable,
		configurable: descriptor.configurable,
		writable: descriptor.writable,
		value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	});
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

function _initializerWarningHelper(descriptor, context) {
	throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var RelationshipToolbar = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
	_inherits(RelationshipToolbar, _Component);

	/***
  *@constructor
  **/
	function RelationshipToolbar(props) {
		_classCallCheck(this, RelationshipToolbar);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_initDefineProp(_this, 'sliderRange', _descriptor, _this);

		_this._onKeyDown = function (event) {
			switch (event.key) {
				case ' ': // space
				case 'Enter':
					_this._onInfoClick(event);
			}
		};

		_this._onInfoClick = function (event) {
			// avoid reacting to the click on X icon when the info flyout is opened
			if (event && event.target && event.target.classList && event.target.classList.contains('relationship-vis-view__toolbarNew__info')) {
				_this.props.targetModel.relationshipVM.toggleInfoTooltip(event.target);
			}
		};

		_this.sliderRange = {
			min: _this.props.targetModel.computedMinStrength,
			max: _this.props.targetModel.computedMaxStrength
		};
		return _this;
	}

	RelationshipToolbar.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
		// Update slider state when we have new relationship min-max strength passed in props
		this.sliderRange = {
			min: newProps.targetModel.computedMinStrength,
			max: newProps.targetModel.computedMaxStrength
		};
	};

	/* Render the relationship toolbar which includes filter strength slider and checkbox for view type */


	RelationshipToolbar.prototype.render = function render() {
		var sliderLabel = _StringResources2.default.get('relationshipGraph_filterStrength_label');
		return _react2.default.createElement(
			'div',
			{ className: 'relationship-vis-view__toolbarNew' },
			this._buildInformationMarkup(sliderLabel),
			this._buildSliderMarkup(sliderLabel),
			_react2.default.createElement(_caUiToolkit.Separator, { orientation: 'vertical', hMargin: 2 }),
			this._buildCheckboxMarkUp()
		);
	};

	RelationshipToolbar.prototype._buildInformationMarkup = function _buildInformationMarkup(sliderLabel) {
		return _react2.default.createElement(
			'div',
			{ className: 'relationship-vis-view__toolbarNew__info', tabIndex: 0, 'aria-label': sliderLabel,
				onClick: this._onInfoClick,
				onKeyDown: this._onKeyDown },
			_react2.default.createElement(_caUiToolkit.SVGIcon, { iconId: _getInformation_2.default.id, style: { 'vertical-align': 'top' } }),
			_react2.default.createElement(
				'div',
				{ className: 'relationship-vis-view__toolbarNew__infoTooltip' },
				_react2.default.createElement(_RelationshipInfoTooltip2.default, { model: this.props.targetModel.relationshipVM.getInfoTooltipModel() })
			)
		);
	};

	RelationshipToolbar.prototype._buildCheckboxMarkUp = function _buildCheckboxMarkUp() {
		var _this2 = this;

		var label = _StringResources2.default.get('relationshipGraph_secondaryRelationship_label');
		var alignment = 'left';
		return _react2.default.createElement(
			'div',
			{ className: 'relationship-vis-view__toolbarNew__secondaryRelationship-checkbox', tabIndex: 0 },
			_react2.default.createElement(_caUiToolkit.Checkbox, {
				label: label,
				align: alignment,
				onChange: function onChange() {
					_this2.props.targetModel.setShowPrimaryRelationshipView(!_this2.props.targetModel.showPrimaryRelationshipView);
				},
				checked: !this.props.targetModel.showPrimaryRelationshipView,
				size: 'small'
			})
		);
	};

	RelationshipToolbar.prototype._buildSliderMarkup = function _buildSliderMarkup(sliderLabel) {
		var _this3 = this;

		var classes = (0, _classnames2.default)({
			'relationship-vis-view__toolbarNew__sliderParent': true
		});
		var toPercent = function toPercent(number) {
			return number.toString() + '%';
		};
		return _react2.default.createElement(
			'div',
			{ className: classes },
			_react2.default.createElement(_caUiToolkit.Label, { className: 'relationship-vis-view__toolbarNew__sliderParent__sliderLabel', label: sliderLabel }),
			_react2.default.createElement(
				'div',
				{ className: 'relationship-vis-view__toolbarNew__sliderParent__sliderContainer' },
				_react2.default.createElement(_caUiToolkit.RangeSlider, {
					showTooltip: true,
					showBoundaryLabels: true,
					className: 'relationship-vis-view__toolbarNew__sliderParent__slider__range',
					values: [this.sliderRange.min, this.sliderRange.max],
					labelFormatter: toPercent,
					onChange: function onChange(values) {
						return _this3._onValueChange.apply(_this3, values);
					},
					onInputComplete: function onInputComplete() {
						return _this3._onInputComplete();
					},
					size: 'small',
					min: 10, max: 100 })
			)
		);
	};

	RelationshipToolbar.prototype._onValueChange = function _onValueChange(min, max) {
		this.sliderRange = { min: min, max: max };
	};

	RelationshipToolbar.prototype._onInputComplete = function _onInputComplete() {
		this.props.targetModel.setFilterStrength({ min: this.sliderRange.min, max: this.sliderRange.max });
	};

	return RelationshipToolbar;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'sliderRange', [_mobx.observable], {
	enumerable: true,
	initializer: function initializer() {
		return null;
	}
})), _class2)) || _class;

RelationshipToolbar.propTypes = {
	targetModel: _PropTypes2.default.object.isRequired
};

exports.default = RelationshipToolbar;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /**
             * Licensed Materials - Property of IBM
             *
             * "Restricted Materials of IBM"
             *
             * (C) Copyright IBM Corp. 2019
             *
             * US Government Users Restricted Rights - Use, duplication or disclosure
             * restricted by GSA ADP Schedule Contract with IBM Corp.
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _mobxReact = __webpack_require__(5);

var _Flyout = __webpack_require__(110);

var _Flyout2 = _interopRequireDefault(_Flyout);

var _caUiToolkit = __webpack_require__(6);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _reset_ = __webpack_require__(408);

var _reset_2 = _interopRequireDefault(_reset_);

var _Config = __webpack_require__(16);

var _Config2 = _interopRequireDefault(_Config);

__webpack_require__(409);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverrideList = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(OverrideList, _Component);

	/***
  *@constructor
  **/
	function OverrideList(props) {
		_classCallCheck(this, OverrideList);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			showOverrideListFlyout: false
		};
		return _this;
	}

	OverrideList.prototype.componentDidMount = function componentDidMount() {
		document.addEventListener('mousedown', this._onClose.bind(this));
		document.addEventListener('touchstart', this._onClose.bind(this));
	};

	OverrideList.prototype.componentWillUnmount = function componentWillUnmount() {
		document.removeEventListener('mousedown', this._onClose.bind(this));
		document.removeEventListener('touchstart', this._onClose.bind(this));
	};

	OverrideList.prototype.render = function render() {
		var _this2 = this;

		var overrideFields = this.props.overrideFields;
		var numberOfOverride = overrideFields.length;
		if (numberOfOverride === 0) {
			return null;
		}
		var numberOfOverridesText = _StringResources2.default.get('relationshipGraph_number_of_overrides', {
			number: numberOfOverride > _Config2.default.max_number_override_badge_shown ? _StringResources2.default.get('relationshipGraph_more_overrides_than_max_indicator', {
				number: _Config2.default.max_number_override_badge_shown
			}) : numberOfOverride
		});
		return _react2.default.createElement(
			'div',
			{
				className: 'overrideList',
				ref: function ref(node) {
					_this2._overrideListRef = node;
				}
			},
			_react2.default.createElement(
				'div',
				{
					className: 'overrideListBadge',
					tabIndex: '0',
					'arial-label': numberOfOverridesText,
					onClick: this._toggle.bind(this),
					onKeyDown: this._onKeyDown.bind(this),
					onTouchEnd: this._toggle.bind(this),
					ref: function ref(node) {
						_this2._overrideListBadgeRef = node;
					}
				},
				numberOfOverridesText
			),
			this._renderOverrideListFlyout(overrideFields)
		);
	};

	OverrideList.prototype._onClose = function _onClose(event) {
		if (this._overrideListRef && !this._overrideListRef.contains(event.target)) {
			this.setState({
				showOverrideListFlyout: false
			});
		}
	};

	OverrideList.prototype._renderOverrideListFlyout = function _renderOverrideListFlyout(overrideFields) {
		if (this.state.showOverrideListFlyout) {
			return _react2.default.createElement(
				_Flyout2.default,
				{
					triggerNode: this._overrideListBadgeRef,
					className: 'overrideListFlyout',
					placement: _Flyout.PLACEMENTS.BOTTOM,
					alignment: _Flyout.ALIGNMENTS.RIGHT
				},
				this._renderList(overrideFields)
			);
		} else {
			return null;
		}
	};

	OverrideList.prototype._renderList = function _renderList(overrideFields) {
		var _this3 = this;

		var overrideListEntryClassName = 'overrideListFlyout-list__listEntry';
		return _react2.default.createElement(
			'div',
			{
				className: 'overrideListFlyout-list'
			},
			function () {
				return overrideFields.map(function (overrideField, index) {
					return _react2.default.createElement(
						_react2.default.Fragment,
						{
							key: index
						},
						_react2.default.createElement(
							'div',
							{
								className: overrideListEntryClassName
							},
							_react2.default.createElement(_caUiToolkit.TruncatedText, {
								value: overrideField.fieldLabel,
								title: overrideField.fieldID,
								className: 'overrideListFlyout-list__listEntry__field'
							}),
							_react2.default.createElement(
								'div',
								{
									className: 'overrideListFlyout-list__listEntry__action'
								},
								_react2.default.createElement(
									'span',
									{
										className: 'overrideListFlyout-list__listEntry__action__text'
									},
									_StringResources2.default.get('relationshipGraph_override_action_' + overrideField.action)
								),
								_react2.default.createElement(_caUiToolkit.Button, {
									className: 'overrideListFlyout-list__listEntry__action__cancelButton',
									iconSize: 'small',
									variant: 'icon',
									intent: 'primary',
									iconLeft: _reset_2.default.id,
									'aria-label': _StringResources2.default.get('relationshipGraph_cancel_override'),
									onClick: function onClick() {
										return _this3.props.cancelAction(overrideField.action, overrideField.fieldID);
									}
								})
							)
						),
						index < overrideFields.length - 1 ? _react2.default.createElement(_caUiToolkit.Separator, { className: 'overrideListFlyout-list__separator' }) : null
					);
				});
			}()
		);
	};

	OverrideList.prototype._onKeyDown = function _onKeyDown(event) {
		switch (event.key) {
			case ' ':
				break; // space
			case 'Enter':
				this._toggle();
				break;
		}
	};

	OverrideList.prototype._toggle = function _toggle() {
		this.setState({
			showOverrideListFlyout: !this.state.showOverrideListFlyout
		});
	};

	return OverrideList;
}(_react.Component)) || _class;

OverrideList.propTypes = {
	overrideFields: _PropTypes2.default.array,
	cancelAction: _PropTypes2.default.function
};

exports.default = OverrideList;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, s) {
  if ("object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module))) module.exports = s(__webpack_require__(19));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (s),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var o = s("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js") : e["@ba-ui-toolkit/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for (var i in o) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : e)[i] = o[i];
    }
  }
}("undefined" != typeof self ? self : undefined, function (e) {
  return webpackJsonPBaGraphics([525], { "3865314c5959606874d4": function c5959606874d4(s, o) {
      s.exports = e;
    }, "4d98f53e61fdcfb55d18": function d98f53e61fdcfb55d18(e, s, o) {
      "use strict";
      Object.defineProperty(s, "__esModule", { value: !0 });var i = o("3865314c5959606874d4"),
          t = (o.n(i), o("e0f9fbeeec6e2f0b6a93"));s.default = t.a;
    }, e0f9fbeeec6e2f0b6a93: function e0f9fbeeec6e2f0b6a93(e, s, o) {
      "use strict";
      var i = o("9689a9c94ae38b47fa2c"),
          t = o.n(i),
          a = o("9ce58a7deea14f49ef01"),
          c = o.n(a),
          n = new t.a({ id: "reset_32_v7", use: "reset_32_v7-usage", viewBox: "0 0 32 32", content: '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="reset_32_v7"><path d="M18 28A12 12 0 106 16v6.2l-3.6-3.6L1 20l6 6 6-6-1.4-1.4L8 22.2V16a10 10 0 1110 10z" /><path style="fill:none" d="M0 0h32v32H0z" /></symbol>' });c.a.add(n);s.a = n;
    } }, ["4d98f53e61fdcfb55d18"]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)(module)))

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(410);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./OverrideList.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./OverrideList.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".overrideList {\n  font-size: 0.75rem;\n}\n\n.overrideList .overrideListBadge {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  cursor: pointer;\n  border-radius: 10px;\n  background: black;\n  padding: 0 8px;\n  color: #fff;\n}\n\n.overrideList .overrideListFlyout {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.overrideList .overrideListFlyout-list {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  width: 300px;\n  max-height: 175px;\n  overflow: auto;\n}\n\n.overrideList .overrideListFlyout-list__listEntry {\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 35px;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding-left: 8px;\n  box-sizing: border-box;\n}\n\n.overrideList .overrideListFlyout-list__listEntry__field {\n  font-weight: 700;\n  width: 200px;\n}\n\n.overrideList .overrideListFlyout-list__separator {\n  border-color: #eaeaea;\n}\n\n", ""]);

// exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (s, i) {
  if ("object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module))) module.exports = i(__webpack_require__(23));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(23)], __WEBPACK_AMD_DEFINE_FACTORY__ = (i),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var a = i("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("@ba-ui-toolkit/ba-graphics/dist/illustrations-js/ba-graphics-icons-commons.js") : s["@ba-ui-toolkit/ba-graphics/dist/illustrations-js/ba-graphics-icons-commons.js"]);for (var e in a) {
      ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports : s)[e] = a[e];
    }
  }
}("undefined" != typeof self ? self : undefined, function (s) {
  return webpackJsonPBaGraphics([61], { "3865314c5959606874d4": function c5959606874d4(i, a) {
      i.exports = s;
    }, d09b3593c610aa068728: function d09b3593c610aa068728(s, i, a) {
      "use strict";
      var e = a("9689a9c94ae38b47fa2c"),
          o = a.n(e),
          c = a("9ce58a7deea14f49ef01"),
          t = a.n(c),
          n = new o.a({ id: "no-relationship-diagram_128_v7", use: "no-relationship-diagram_128_v7-usage", viewBox: "0 0 128 128", content: '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" id="no-relationship-diagram_128_v7"><path class="ba-graphics-gray20" d="M55.6 33.7c0-6.6-5.4-12-12-12-3.2 0-6.1 1.3-8.2 3.3l16.9 16.9c2.1-2.1 3.3-5 3.3-8.2zm43.3 26c-4.8 0-8.9 2.8-10.8 6.9l-8.9-3.5c.3-1.1.5-2.2.5-3.4 0-3.8-1.8-7.2-4.6-9.4l6.7-9.7c1.6.7 3.3 1.2 5.2 1.2 6.6 0 12-5.4 12-12s-5.4-12-12-12-12 5.4-12 12c0 4.1 2 7.6 5.1 9.8l-6.6 9.6c-1.7-.9-3.7-1.5-5.7-1.5-2.6 0-5.1.9-7 2.3l-.1.1 16.7 16.7c.4-.6.8-1.2 1.2-1.9l8.9 3.5c-.3 1-.5 2.1-.5 3.2 0 2.7.9 5.1 2.4 7.1l2.5 2.5c2 1.5 4.5 2.4 7.1 2.4 6.6 0 12-5.4 12-12 0-6.7-5.5-11.9-12.1-11.9zm-75-37.6l7.3 7.3c-1.6 2-2.5 4.5-2.5 7.3 0 6.6 5.4 12 12 12 2.7 0 5.2-.9 7.2-2.4l7.8 7.6.4.4c-2.1 2.2-3.4 5.1-3.4 8.4 0 2.1.6 4.1 1.5 5.9L37.7 80.8c-.7-.8-1.5-1.5-2.5-2.1-2-1.2-4.1-1.8-6.3-1.8-4 0-8 2-10.2 5.7-3.5 5.7-1.7 13 4 16.5 2 1.2 4.1 1.8 6.3 1.8 4 0 8-2 10.2-5.7 2.5-4.1 2.3-9.1-.2-12.9l16.4-12.1c2 2.5 5 4.2 8.5 4.4v11.8c-6 .6-10.8 5.7-10.8 11.9 0 6.6 5.4 12 12 12s12-5.4 12-12c0-6.4-5-11.6-11.2-12V74.6c2.8-.3 5.3-1.5 7.3-3.4l28.7 28.9L104 98 26 20l-2.1 2.1z" /></symbol>' });t.a.add(n);i.a = n;
    }, d755a3ec487601b1fd33: function d755a3ec487601b1fd33(s, i, a) {
      "use strict";
      Object.defineProperty(i, "__esModule", { value: !0 });var e = a("3865314c5959606874d4"),
          o = (a.n(e), a("d09b3593c610aa068728"));i.default = o.a;
    } }, ["d755a3ec487601b1fd33"]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)(module)))

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /**
             * Licensed Materials - Property of IBM
             *
             * "Restricted Materials of IBM"
             *
             * (C) Copyright IBM Corp. 2019
             *
             * US Government Users Restricted Rights - Use, duplication or disclosure
             * restricted by GSA ADP Schedule Contract with IBM Corp.
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _caUiToolkit = __webpack_require__(6);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _Config = __webpack_require__(16);

var _Config2 = _interopRequireDefault(_Config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This react component currently renders an action status bar as a toast message of different level.
 * such as error, warning, info, success.It's used for relationship diagram but it can
 * be used for any other use cases. As a special case, the toast message is rendered as an inline
 * toast message. It could be also extended to render other status information such as info icon.
 */
var RelationshipStatusBar = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(RelationshipStatusBar, _Component);

	function RelationshipStatusBar() {
		_classCallCheck(this, RelationshipStatusBar);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	RelationshipStatusBar.prototype.render = function render() {
		var targetModel = this.props.targetModel;
		if (!targetModel) {
			return null;
		}

		if (!targetModel.relationshipVM.isNewStartingPointsFeatureEnabled()) {
			return null;
		}

		var actionStatus = targetModel.actionStatus;
		if (!actionStatus) {
			return null;
		}

		var properties = {
			targetId: this.props.containerId,
			statusType: actionStatus.level,
			milliseconds: _Config2.default.diagram_status_bar_toast_time_duration,
			timedDismiss: actionStatus.level !== 'error', //For Error level status, toast meessage does not dismiss automatically
			contentString: '' + actionStatus.message,
			style: { //GlobalToast supports style overriding using style property
				position: 'absolute',
				left: 0,
				top: '0px'
			},
			onClose: function onClose() {
				targetModel.emptyActionStatus();
			}
		};
		return _react2.default.createElement(_caUiToolkit.GlobalToast, properties);
	};

	return RelationshipStatusBar;
}(_react.Component)) || _class;

RelationshipStatusBar.propTypes = {
	containerId: _PropTypes2.default.string.isRequired,
	targetModel: _PropTypes2.default.object
};

exports.default = RelationshipStatusBar;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /**
             * Licensed Materials - Property of IBM
             *
             * "Restricted Materials of IBM"
             *
             * (C) Copyright IBM Corp. 2018, 2019
             *
             * US Government Users Restricted Rights - Use, duplication or disclosure
             * restricted by GSA ADP Schedule Contract with IBM Corp.
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _caUiToolkit = __webpack_require__(6);

var _shaping = __webpack_require__(28);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

__webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RelationshipTooltip = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(RelationshipTooltip, _Component);

	function RelationshipTooltip(props) {
		_classCallCheck(this, RelationshipTooltip);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this._closeToolTip = function () {
			_this.props.model.showTooltip(null);
		};

		_this._shapingAncestorTree_includeParent = function () {
			return true;
		};

		return _this;
	}

	RelationshipTooltip.prototype.render = function render() {
		var _props = this.props,
		    model = _props.model,
		    shouldUseDisambiguatedPaths = _props.shouldUseDisambiguatedPaths;


		var tooltipInfo = model.getTooltipInfo();

		if (!tooltipInfo) {
			return null;
		}

		if (shouldUseDisambiguatedPaths && this._isTooltipForRGNode(tooltipInfo)) {
			// we keep old tooltips for relationship stregnths even w path disambiguation pending UX design
			return this._renderDisambiguatedTooltip(tooltipInfo);
		}
		return this._renderTooltip(tooltipInfo);
	};

	/* tooltipInfo structure:
 *	tooltipInfo = {
 *		title: [
 *			{
 *				label: '',
 *				value: ''
 *			}
 *		],
 *		coordinates: {
 *			top: Y,
 *			left: X,
 *			width: 0
 *		}
 *	};
 */


	RelationshipTooltip.prototype._renderTooltip = function _renderTooltip(tooltipInfo) {
		var title = this._renderTitle(tooltipInfo);
		return _react2.default.createElement(_caUiToolkit.TooltipPopup, {
			orient: 'top',
			title: title,
			triggerState: {
				top: tooltipInfo.coordinates.top,
				left: tooltipInfo.coordinates.left,
				width: tooltipInfo.coordinates.width
			},
			delay: 1500,
			style: {
				position: 'fixed'
			}
		});
	};

	RelationshipTooltip.prototype._isTooltipForRGNode = function _isTooltipForRGNode(tooltipInfo) {
		return tooltipInfo.title[0].label !== ''; //TODO: relationship strength parabola title's label is an empty string - need's better identifier
	};

	RelationshipTooltip.prototype._renderTitle = function _renderTitle(tooltipInfo) {
		var items = tooltipInfo.title.map(function (text, index) {
			var lineBreak = void 0;
			if (index < tooltipInfo.title.length - 1) {
				lineBreak = _react2.default.createElement('br', null);
			}
			var value = text.label + text.value;
			return _react2.default.createElement(
				'div',
				{ key: value },
				_react2.default.createElement(_caUiToolkit.Label, { label: value, className: 'relationship-vis-view__tooltip__label' }),
				lineBreak
			);
		});

		return _react2.default.createElement(
			'div',
			{ className: 'relationship-vis-view__tooltip' },
			items
		);
	};

	RelationshipTooltip.prototype._renderQuerySubjectItem = function _renderQuerySubjectItem() {
		var _props2 = this.props,
		    module = _props2.module,
		    model = _props2.model;

		var shapingHelper = module.getShapingHelper();
		var mdColumn = module.getMetadataColumn(model.tooltipInfo.itemId);
		var moserColumn = mdColumn ? mdColumn.moserObject : null;
		if (!moserColumn) {
			return null;
		}
		return _react2.default.createElement(
			shapingHelper.ShapingProvider,
			null,
			_react2.default.createElement(_shaping.ShapingAncestorTree, {
				includeParent: this.shapingAncestorTree_includeParent,
				moserObject: moserColumn
			})
		);
	};

	RelationshipTooltip.prototype._renderDisambiguatedTooltip = function _renderDisambiguatedTooltip(tooltipInfo) {
		var tooltipLabel = _StringResources2.default.get('relationshipGraph_source_tooltip_label_title');
		return _react2.default.createElement(
			_caUiToolkit.Flyout,
			{
				domNodeToAttachTo: document.body,
				triggerNode: tooltipInfo.eventTarget,
				offset: 10,
				placement: 'topCentred',
				candidatePlacement: ['topCentred'],
				onClose: this._closeToolTip
			},
			_react2.default.createElement(
				'div',
				{ className: 'relationship-vis-view__disambiguatingTooltipTitle' },
				tooltipLabel
			),
			_react2.default.createElement(
				'div',
				{ className: 'relationship-vis-view__disambiguatingTooltip' },
				this._renderQuerySubjectItem()
			)
		);
	};

	return RelationshipTooltip;
}(_react.Component)) || _class;

RelationshipTooltip.propTypes = {
	model: _PropTypes2.default.object.isRequired,
	module: _PropTypes2.default.object.isRequired,
	shouldUseDisambiguatedPaths: _PropTypes2.default.boolean
};

exports.default = RelationshipTooltip;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LayoutBaseAuthoring = __webpack_require__(88);

var _LayoutBaseAuthoring2 = _interopRequireDefault(_LayoutBaseAuthoring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var ExploreCardAuthoring = _LayoutBaseAuthoring2.default.extend({

  init: function init() {
    ExploreCardAuthoring.inherited('init', this, arguments);
  },

  add: function add(widgetLayoutView) {
    this.consumeView.addChildRenderMarkup(widgetLayoutView.id, widgetLayoutView);
    this.consumeView.model.incrChildReadyCount();
  }
});

exports.default = ExploreCardAuthoring;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LayoutBase2 = __webpack_require__(38);

var _ExploreCardView = __webpack_require__(416);

var _CompareUtils = __webpack_require__(428);

var _CompareUtils2 = _interopRequireDefault(_CompareUtils);

var _CompareCardView = __webpack_require__(429);

var _CometCardView = __webpack_require__(443);

var _SidePanelUtil = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ExploreCard = function (_LayoutBase) {
	_inherits(ExploreCard, _LayoutBase);

	function ExploreCard(props) {
		_classCallCheck(this, ExploreCard);

		var _this = _possibleConstructorReturn(this, _LayoutBase.call(this, props));

		if (_this.model.isCompareEnabled) {
			//@todo we should not access internal (dashboardApi) from layout controller directly
			_this._compareUtils = new _CompareUtils2.default({ services: _this.services, model: _this.model, dashboardApi: _this.layoutController.dashboardApi });
			_this.Component = _CompareCardView.CompareCardView;
		} else {
			_this.Component = _ExploreCardView.ExploreCardView;
		}

		_this._tempParentNode = props.tempParentNode || _this._tempParent || document.createElement('div');
		_this._tempParentNode.style.visibility = 'hidden';
		var main = document.getElementById('main');
		main.appendChild(_this._tempParentNode);

		_this._widgetPromises = {};

		//CC
		_this._widgetNodeMap = {};
		return _this;
	}

	ExploreCard.prototype.getWidgetPromises = function getWidgetPromises(widgetId) {
		var _this2 = this;

		if (!this._widgetPromises[widgetId]) {
			var promisesObject = {};
			var domNodePromise = new Promise(function (resolve) {
				promisesObject.setDomNode = function (val) {
					resolve(val);
				};
			});
			var markupPromise = new Promise(function (resolve) {
				promisesObject.setMarkup = function (val) {
					resolve(val);
				};
			});
			promisesObject.allPromisesForOneWidget = [domNodePromise, markupPromise];

			Promise.all([domNodePromise, markupPromise]).then(function (data) {
				var domNode = data[0],
				    markup = data[1];
				domNode.appendChild(markup);
				_this2._widgetNodeMap[widgetId] = markup;
				_this2._resolvedChild && _this2._resolvedChild(widgetId); //for debugging
			});
			this._widgetPromises[widgetId] = promisesObject;
		}
		return this._widgetPromises[widgetId];
	};

	ExploreCard.prototype.getNodeId = function getNodeId(id) {
		return id;
	};

	ExploreCard.prototype.trackChildWidget = function trackChildWidget(widgetLayoutView) {
		if (this.addChildRenderMarkup(widgetLayoutView.id, widgetLayoutView)) {
			this.setupShowBy(widgetLayoutView.id);
			if (this._compareUtils) {
				this._compareUtils.initialize(widgetLayoutView.id, this.model);
			}
			this.model.incrChildReadyCount();
		}
		this.getWidgetPromises(widgetLayoutView.id).setMarkup(widgetLayoutView.domNode);
	};

	ExploreCard.prototype.setupShowBy = function setupShowBy(id) {
		var _this3 = this;

		//widget has the same id
		return this.dashboardApi.getCanvasWhenReady().then(function (canvas) {
			var state = canvas.getContent(id).getFeature('state');
			return state.whenStatusChanges(state.STATUS.RENDERED);
		}).then(function () {
			var content = _this3.dashboardApi.getCanvas().getContent(id);
			var showByAction = content && content.getFeature('ShowByAction');
			showByAction && showByAction.setOnSelectCallback({ cb: _this3.addShowByCard.bind(_this3) });
		});
	};

	/**
  * Add a show by/compare by card
  * @param {Array} result - an array of widget spec(s) - one spec for show by; two for compare by
  * @param {Object} payloadData - object containing undoRedoTransactionId passed from showByFeature
  */


	ExploreCard.prototype.addShowByCard = function addShowByCard(result, payloadData) {
		if (result && result.length > 0 && result.length <= 2) {
			var models = [{ model: result[0] }];
			var params = void 0;
			if (result.length === 2) {
				models.push({
					model: result[1]
				});
				params = {
					model: {
						subType: 'compare'
					},
					selectAfterAdd: true
				};
			} else {
				params = {
					selectAfterAdd: true
				};
			}
			var layoutModel = this.parentLayout.model;
			var newLayoutId = layoutModel.addVisCard(models, payloadData, params /*new card options*/);
			if (result.length === 2) {
				layoutModel.cardModelUtil.copyPageContextAndRescope(layoutModel, {
					layoutId: this.id,
					cloneId: newLayoutId
				});
			}
		}
	};

	ExploreCard.prototype._beforeOnShow = function _beforeOnShow(widgetViewId, widgetView) {
		var childViewNode = document.getElementById(widgetViewId);
		if (childViewNode) {
			this._tempParentNode.appendChild(childViewNode);
			this.addChildRenderMarkup(widgetViewId, widgetView);
			this.model.incrChildReadyCount();
		}
	};

	ExploreCard.prototype._onAddCometVisualization = function _onAddCometVisualization(recommendation) {
		this._onAddVisualization(recommendation, 'addRelatedRecommendation');
	};

	ExploreCard.prototype._onClickVisualizationFromFooterView = function _onClickVisualizationFromFooterView(recommendation) {
		this._onAddVisualization(recommendation, 'exploreSelectCometRecommendation');
	};

	ExploreCard.prototype._onAddVisualization = function _onAddVisualization(recommendation, operation) {
		var widgetSpec = this.model.cometViewModel.covertRecommendationToWidgetSpec(recommendation);
		this.parentLayout.view.addVisCard(widgetSpec, operation);
		(0, _SidePanelUtil.openCardsPane)(this.layoutController.dashboardApi);
	};

	ExploreCard.prototype.triggerWidgetRender = function triggerWidgetRender() {
		var exploreVM = this.parentLayout.model.exploreVM;
		if (exploreVM) {
			var selected = exploreVM.isCardDisplayed(this.id);
			if (selected) {
				var contentNode = document.querySelector('[data-id=' + this.model.id + '] .widgetContent[rendercount]');
				var widgetRenderedChildren = contentNode ? contentNode.childElementCount : 0;
				if (widgetRenderedChildren === 0) {
					this._callChildrenFunction('onShow');
				}
			}
		}
	};

	/**
  * Normally, triggerWidgetRender is sufficient to ensure a card and its widgets are rendered, however;
  * when moving to a new card (tab) which has previously been rendered as a thumbnail, we need to ensure the render
  * occurs to add interactive features to the rendering.
  */


	ExploreCard.prototype.triggerOnShowCard = function triggerOnShowCard() {
		var _this4 = this;

		var trigger = function trigger() {
			var resizeDone = void 0;
			if (_this4.resizePendingOnShow) {
				_this4.resizePendingOnShow = false;
				_this4.resize();
				resizeDone = 1;
			} else {
				_this4._callChildrenFunction('onShow');
				resizeDone = 0;
			}
			return resizeDone;
		};

		var selected = this.parentLayout.model.exploreVM.isCardDisplayed(this.id);
		if (selected) {
			return this._waitTillChildLayoutsReady().then(function () {
				return trigger();
			});
		}
		return Promise.resolve();
	};

	ExploreCard.prototype._waitTillChildLayoutsReady = function _waitTillChildLayoutsReady() {
		var allPromises = [];
		var entries = Object.values(this._widgetPromises);
		entries.forEach(function (entry) {
			entry.allPromisesForOneWidget.forEach(function (prom) {
				allPromises.push(prom);
			});
		});
		return Promise.all(allPromises);
	};

	ExploreCard.prototype.showVisTypesDialog = function showVisTypesDialog(destinationId) {
		this.model.setShowModalVisTypePicker(true, destinationId);
	};

	ExploreCard.prototype.closeVisTypeChooser = function closeVisTypeChooser() {
		this.model.setShowModalVisTypePicker(false);
	};

	ExploreCard.prototype.replaceWithWidget = function replaceWithWidget(widgetSpec, layoutToBeReplaced) {
		return this.model.replaceWidgetInCard(widgetSpec, layoutToBeReplaced, 'cardCreate');
	};

	ExploreCard.prototype.placeWidgetInCard = function placeWidgetInCard(widgetSpec, payload) {
		return this.model.placeWidgetInCard(widgetSpec, payload);
	};

	ExploreCard.prototype.createVisFromVisType = function createVisFromVisType(visTypeId, replaceLayoutId) {
		var widgetSpec = {
			model: {
				type: 'live',
				visId: visTypeId,
				visTypeLocked: true,
				data: {}
			}
		};
		this.replaceWithWidget(widgetSpec, replaceLayoutId);
	};

	ExploreCard.prototype.removeChild = function removeChild(layoutView) {
		layoutView && this._removeChild(layoutView.id);
	};

	ExploreCard.prototype._removeChild = function _removeChild(layoutViewId) {
		this.removeChildRenderMarkup(layoutViewId);
		if (this._widgetPromises[layoutViewId]) {
			delete this._widgetPromises[layoutViewId];
		}
		if (this._widgetNodeMap[layoutViewId]) {
			delete this._widgetNodeMap[layoutViewId];
		}
	};

	ExploreCard.prototype._onModelRemoveItem = function _onModelRemoveItem(e) {
		this.destroy(e);
	};

	ExploreCard.prototype._destroyWidgets = function _destroyWidgets(e) {
		var _this5 = this;

		var childLayoutMap = this._widgetNodeMap || {};
		Object.entries(childLayoutMap).forEach(function (entry) {
			_this5._removeChild(entry[1].id);

			if (entry[1]._layout) {
				entry[1]._layout.destroy(e);
				entry[1]._layout = null;
			}
		});
	};

	ExploreCard.prototype.destroy = function destroy(e) {
		if (this.layoutController && e && e.value && e.value.parameter === this.model.id) {
			if (this._tempParentNode) {
				if (this._tempParentNode.remove) {
					// non-IE
					this._tempParentNode.remove();
				} else if (this._tempParentNode.removeChild) {
					// IE
					var children = this._tempParentNode.children;
					if (children.length > 0) {
						for (var _iterator = children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
							var _ref;

							if (_isArray) {
								if (_i >= _iterator.length) break;
								_ref = _iterator[_i++];
							} else {
								_i = _iterator.next();
								if (_i.done) break;
								_ref = _i.value;
							}

							var child = _ref;

							this._tempParentNode.removeChild(child);
						}
					}
				}
			}
			this._tempParentNode = null;
			this._destroyWidgets(e);
			if (this.view) {
				this.view._alive = false;
			}
			_LayoutBase.prototype.destroy.call(this, e);
		} else {
			this.logger.warn('destroy not done for layout ' + this.model.type + ' id ' + this.id);
		}
	};

	ExploreCard.prototype.getRenderMarkup = function getRenderMarkup() {
		var _this6 = this;

		if (this.model.isCompareEnabled) {
			// compare card
			return _react2.default.createElement(
				_CompareCardView.CompareCardView,
				{ model: this.model },
				function (getHeaderView, getWidgetHeaderMap, getFooterView, getCssClasses, getCrossHairMatchingPoints, renderPopOver) {
					return _react2.default.createElement(_ExploreCardView.ExploreCardView, {
						getWidgetHeaderMap: getWidgetHeaderMap,
						footerView: getFooterView(),
						layoutOwner: _this6,
						headerView: getHeaderView,
						model: _this6.model,
						layoutClasses: getCssClasses,
						cardLayoutVM: _this6.cardLayoutVM,
						layoutController: _this6.layoutController,
						renderPopOver: renderPopOver,
						getCrossHairMatchingPoints: getCrossHairMatchingPoints,
						services: _this6.services });
				}
			);
		} else {
			// comet or explore card
			return _react2.default.createElement(
				_CometCardView.CometCardView,
				{
					onAddItem: this._onAddCometVisualization.bind(this),
					onClickItem: this._onClickVisualizationFromFooterView.bind(this),
					model: this.model,
					dashboardApi: this.layoutController.dashboardApi,
					dataSourceId: this.layoutController.boardModel.layout.exploreVM.activeDataSourceId,
					layoutOwner: this,
					logger: this.logger },
				function (getHeaderView, getWidgetHeaderMap, getFooterView, getCssClasses) {
					return _react2.default.createElement(_ExploreCardView.ExploreCardView, {
						layoutOwner: _this6,
						model: _this6.model,
						layoutClasses: getCssClasses,
						cardLayoutVM: _this6.cardLayoutVM,
						layoutController: _this6.layoutController,
						footerView: getFooterView(),
						services: _this6.services });
				}
			);
		}
	};

	ExploreCard.prototype.onItemAddDone = function onItemAddDone() {
		this.model.cometViewModel.hookupCustomDataHandler();
	};

	ExploreCard.prototype.resizeIfVisible = function resizeIfVisible() {
		if (this.model.isDisplayed) {
			this.resize();
		} else {
			this.resizePendingOnShow = true;
		}
	};

	return ExploreCard;
}(_LayoutBase2.LayoutBase);

exports.default = ExploreCard;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ExploreCardView = undefined;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2020
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _mobxStateTree = __webpack_require__(7);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _LayoutBase = __webpack_require__(38);

var _ExploreVisWidget = __webpack_require__(417);

var _reactMeasure = __webpack_require__(20);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _classnames2 = __webpack_require__(10);

var _classnames3 = _interopRequireDefault(_classnames2);

__webpack_require__(426);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LIVE_WIDGET = 'widget.live';
var PLACEHOLDER = 'widget.placeholder';
/**
 * Class representing view implementation (using react) for ExploreCard layout view
 * @extends ReactLayoutImplBase
 */

var ExploreCardView = exports.ExploreCardView = (0, _mobxReact.observer)(_class = function (_ReactLayoutImplBase) {
	_inherits(ExploreCardView, _ReactLayoutImplBase);

	function ExploreCardView(props) {
		_classCallCheck(this, ExploreCardView);

		var _this = _possibleConstructorReturn(this, _ReactLayoutImplBase.call(this, props));

		_this.state = {
			dimensions: {
				width: -1,
				height: -1
			}
		};

		_this.onResize = function (contentRect) {
			if (contentRect.bounds.height !== 0 && contentRect.bounds.width !== 0) {
				_this.setState({ dimensions: contentRect.bounds });
			}
		};

		_this.footerView = _this.props.footerView;
		_this.boardModel = _this.props.layoutController.boardModel;
		_this._childrenRenderMarkupAdded = _this.model.childrenRenderMarkupAdded || 0;

		//TODO _alive - VisTypeChooser refers to layoutOwner where object might not be available, introduce this flag to indicate if the view is destroyed or not. perhaps we can use a more proper way to address this
		_this._alive = true;
		_this.listeners = [];
		_this.boardModel._hookupCustomDataHandler = function () {
			return _this.props.model.cometViewModel.hookupCustomDataHandler();
		};
		return _this;
	}

	ExploreCardView.prototype.componentDidMount = function componentDidMount() {
		this.props.model.cometViewModel.hookupCustomDataHandler();
		// TODO we should listen on content api event, but our code currently are directly using the boardModel method
		// to add or remove widgets, we need to clean up our code to use content api to add or remove widgets.
		this.listeners.push(this.boardModel.on('addWidget', this._onAddWidget.bind(this)));
		this.listeners.push(this.boardModel.on('addLayouts', this._onAddLayout.bind(this)));
	};

	ExploreCardView.prototype.componentWillUnmount = function componentWillUnmount() {
		this._removeListeners();
	};

	/**
  * handle selection when
  *  - adding a data widget in a card by `addWidget`
  *  - undo adding a data widget in a card, a placeholder is added by `_onAddWidget`
  * @param {object} payload 
  */


	ExploreCardView.prototype._onAddWidget = function _onAddWidget(payload) {
		if (payload.value) {
			var id = payload.value.parameter.model.id;
			var typesToSelect = [LIVE_WIDGET];
			// if is undoing, then we also select for placecholder
			if (payload.sender === 'UndoRedoController') {
				typesToSelect.push(PLACEHOLDER);
			}
			return this._doContentSelection(id, typesToSelect);
		}
		return Promise.resolve();
	};

	/**
  * handle selection when
  *  - adding a data widget in a card by `addLayouts`
  *  - undo adding a data widget in a card, a placeholder is added by `addLayouts`
  * @param {object} payload 
  */


	ExploreCardView.prototype._onAddLayout = function _onAddLayout(payload) {
		if (payload.value) {
			var addLayoutArray = payload.value.parameter.addLayoutArray;
			if (addLayoutArray && addLayoutArray.length === 1) {
				var id = addLayoutArray[0].model.id;
				var typesToSelect = [LIVE_WIDGET];
				// if is undoing, then we also select for placecholder
				if (payload.sender === 'UndoRedoController') {
					typesToSelect.push(PLACEHOLDER);
				}
				return this._doContentSelection(id, typesToSelect);
			}
		}
		return Promise.resolve();
	};

	ExploreCardView.prototype._doContentSelection = function _doContentSelection(id, typesToSelect) {
		if (id && this.model.findModel(id)) {
			var dashboardApi = this._getDashboardApi();
			var canvas = dashboardApi && dashboardApi.getFeature('Canvas');
			if (canvas) {
				var content = canvas.getContent(id);
				if (content && typesToSelect.indexOf(content.getType()) !== -1) {
					var state = canvas.getContent(id).getFeature('state');
					return state.whenStatusChanges(state.STATUS.RENDERED).then(function () {
						var selectedContentList = canvas.getSelectedContentList();
						var selectedContentIds = selectedContentList.map(function (item) {
							return item.getId();
						});
						canvas.deselectContent(selectedContentIds);
						canvas.selectContent([id]);
					});
				}
			}
		}
		return Promise.resolve();
	};

	ExploreCardView.prototype._getDashboardApi = function _getDashboardApi() {
		return (0, _mobxStateTree.getEnv)(this.props.model).dashboardApi;
	};

	ExploreCardView.prototype._removeListeners = function _removeListeners() {
		this.listeners.forEach(function (entry) {
			entry.remove();
		});
	};

	ExploreCardView.prototype.render = function render() {
		return this.getRenderMarkup();
	};

	ExploreCardView.prototype.renderContent = function renderContent() {
		var _this2 = this,
		    _classnames;

		var numWidgets = 0;
		this.layoutOwner = this.props.layoutOwner; //should always use props, still need this.layoutOwner to support getChildrenRenderMarkup()

		var items = this.props.model.getVisualizations().map(function (o) {
			if (o.widgetLayout) {
				numWidgets++;
			}
			var id = o.widgetLayout ? o.widgetLayout.id : o.placeholder.id;
			var headerMap = _this2.props.getWidgetHeaderMap && _this2.props.getWidgetHeaderMap();
			return _react2.default.createElement(_ExploreVisWidget.ExploreVisWidget, {
				dashboardApi: _this2.layoutController.dashboardApi,
				header: headerMap && headerMap[id] || null,
				renderPopOver: _this2.props.renderPopOver,
				getCrossHairMatchingPoints: _this2.props.getCrossHairMatchingPoints,
				key: id, model: o,
				layoutOwner: _this2.layoutOwner,
				onDragEnd: function onDragEnd() {}
			});
		});

		var classNamesMain = this.props.layoutClasses().classNamesMain;
		var classNamesCardRow = this.props.layoutClasses().classNamesCardRow;
		var _state$dimensions = this.state.dimensions,
		    width = _state$dimensions.width,
		    height = _state$dimensions.height;


		var classes = (0, _classnames3.default)(classNamesCardRow, (_classnames = {}, _classnames[classNamesCardRow + '__vertical'] = height > width, _classnames));

		return _react2.default.createElement(
			'div',
			{ className: 'card-layout-content' },
			_react2.default.createElement(
				'div',
				{ className: classNamesMain },
				_react2.default.createElement(
					_reactMeasure2.default,
					{
						bounds: true,
						onResize: this.onResize
					},
					function (_ref) {
						var measureRef = _ref.measureRef;
						return _react2.default.createElement(
							'div',
							{ ref: measureRef, className: classes },
							items
						);
					}
				),
				numWidgets > 0 && this.props.footerView
			)
		);
	};

	ExploreCardView.prototype.getRenderMarkup = function getRenderMarkup() {
		return _react2.default.createElement(
			'div',
			{ className: 'card-layout' },
			this.renderContent()
		);
	};

	ExploreCardView.prototype.trackWidgetDropTarget = function trackWidgetDropTarget(target) {
		this.parentLayout.trackWidgetDropTarget(target);
	};

	return ExploreCardView;
}(_LayoutBase.ReactLayoutImplBase)) || _class;

ExploreCardView.propTypes = {
	items: _PropTypes2.default.array,
	layoutController: _PropTypes2.default.object,
	services: _PropTypes2.default.object,
	parentLayout: _PropTypes2.default.object,
	model: _PropTypes2.default.object,
	layoutOwner: _PropTypes2.default.object,
	getWidgetHeaderMap: _PropTypes2.default.func,
	getOverview: _PropTypes2.default.func,
	footerView: _PropTypes2.default.object,
	renderPopOver: _PropTypes2.default.func,
	getCrossHairMatchingPoints: _PropTypes2.default.func
};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ExploreVisWidget = undefined;

var _class, _desc, _value, _class2, _descriptor; /*
                                                  *+------------------------------------------------------------------------+
                                                  *| Licensed Materials - Property of IBM
                                                  *| IBM Cognos Products: Explore
                                                  *| (C) Copyright IBM Corp. 2018, 2019
                                                  *|
                                                  *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                  *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                  *+------------------------------------------------------------------------+
                                                  */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactMeasure = __webpack_require__(20);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _mobxReact = __webpack_require__(5);

var _mobx = __webpack_require__(11);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _BadgeTooltip = __webpack_require__(418);

var _BadgeTooltip2 = _interopRequireDefault(_BadgeTooltip);

var _SingleVisDnDHandler = __webpack_require__(85);

var _SingleVisDnDHandler2 = _interopRequireDefault(_SingleVisDnDHandler);

var _Empty = __webpack_require__(18);

var _Empty2 = _interopRequireDefault(_Empty);

var _DisplayTooltipInfo = __webpack_require__(421);

var _DisplayTooltipInfo2 = _interopRequireDefault(_DisplayTooltipInfo);

__webpack_require__(424);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
	if (!descriptor) return;
	Object.defineProperty(target, property, {
		enumerable: descriptor.enumerable,
		configurable: descriptor.configurable,
		writable: descriptor.writable,
		value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	});
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

function _initializerWarningHelper(descriptor, context) {
	throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
* Encapsulates plumbing for rendering widgets (ie visualizations)
* Manages handling visPlaceholder & widget layout
* Also, 'glides' legacy widget layout into a react view (uses ref prop)
* Each visualization can have a header section, which can be optionally filled e.g. for compare, we
* show stats table
*/

var FOOTER_HEIGHT = 17;

var ExploreVisWidget = exports.ExploreVisWidget = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
	_inherits(ExploreVisWidget, _Component);

	function ExploreVisWidget(props) {
		_classCallCheck(this, ExploreVisWidget);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_initDefineProp(_this, 'activateDropTarget', _descriptor, _this);

		_this.layoutOwner = props.layoutOwner;
		_this.domNode = null;
		_this._widgetDropTargetList = [];
		_this.contentRect = {
			width: 0,
			height: 0
		};
		_this._disposeEvents = [];
		_this.popoverParent = _react2.default.createRef();
		return _this;
	}

	ExploreVisWidget.prototype.setBadgesInfo = function setBadgesInfo(badgesInfo) {
		this.badgesInfo = badgesInfo;
	};

	ExploreVisWidget.prototype.render = function render() {
		void this.activateDropTarget;
		return this.getRenderMarkup();
	};

	/**
  * 
  * @param {Object} caption - an object containing the rows to be displayed in the popover
  *  @returns {Array} - formatting the captions into columns for convenience in displaying
  */


	ExploreVisWidget.prototype._formatCaption = function _formatCaption(caption) {
		var category = [];
		var quantity = [];
		Object.keys(caption).forEach(function (key) {
			category.push(caption[key][0]);
			quantity.push(caption[key][1]);
		});
		return [category, quantity];
	};
	/**
  * check if the compare line is enabled. The compare line is only disabled when the flag is set to false specifically.
  * @returns {Boolean} true if enabled
  */


	ExploreVisWidget.prototype.getIsNewCompareLineEnabled = function getIsNewCompareLineEnabled() {
		return !this.props.dashboardApi.getGlassCoreSvc('.FeatureChecker').checkValue('explore', 'newCompareLine', 'false');
	};

	/**
  * Creates a popover with the formatted display info
  * Popover is hidden when there are no matching points
  * @param {String} id - of the Vis Model where the popover will be displayed
  * @returns {String} - returns block to display the popover or none to hide it
  */


	ExploreVisWidget.prototype._createPopover = function _createPopover(id) {
		var formattedCaption = void 0;
		var crossHairInfo = void 0;
		var displayPopOverClass = 'popoverHidden';
		var caption = this.props.getCrossHairMatchingPoints && this.props.getCrossHairMatchingPoints();
		if (caption && caption[id] && caption[id].length > 0) {
			displayPopOverClass = 'popoverShown';
			formattedCaption = this._formatCaption(caption[id]);
			crossHairInfo = _react2.default.createElement(_DisplayTooltipInfo2.default, { crossHairInfo: formattedCaption });
			var totalItems = caption[id].length;
			this.popoverParent && this.popoverParent.current && this.props.renderPopOver(crossHairInfo, this.popoverParent.current, totalItems, { showFooter: true, footerHeight: FOOTER_HEIGHT }, this.domNode);
		}
		return displayPopOverClass;
	};

	ExploreVisWidget.prototype.getRenderMarkup = function getRenderMarkup() {
		var _this2 = this;

		var layoutOwner = this.props.layoutOwner;
		var model = this.props.model;
		var header = this.props.header;
		var id = model.widgetLayout ? model.widgetLayout.id : model.placeholder.id;
		var getBadgesTooltipModel = model.widgetLayout && model.widgetLayout.getBadgesTooltipModel && model.widgetLayout.getBadgesTooltipModel();

		var displayPopOverClass = this.getIsNewCompareLineEnabled() && this._createPopover(id);

		var badgeTooltip = null;
		if (getBadgesTooltipModel) {
			badgeTooltip = _react2.default.createElement(_BadgeTooltip2.default, { layoutOwner: layoutOwner, model: getBadgesTooltipModel });
		}

		return _react2.default.createElement(
			_reactMeasure2.default,
			{ bounds: true,
				onResize: function onResize(args) {
					return _this2.onResize(args);
				}
			},
			function (_ref) {
				var measureRef = _ref.measureRef;
				return _react2.default.createElement(
					'div',
					{ className: 'layout-wrapper-container', ref: measureRef },
					_react2.default.createElement(
						'div',
						{ className: 'layout-wrapper', ref: function ref(node) {
								_this2.domNode = node;
							} },
						_this2.activateDropTarget && _this2.getEmptyRenderMarkup(),
						badgeTooltip,
						header,
						_react2.default.createElement('div', { className: 'widget-wrapper', ref: function ref(node) {
								node && _this2._attachWidgetLayout(layoutOwner, node, id);
							} }),
						_react2.default.createElement('div', { className: displayPopOverClass, ref: _this2.popoverParent })
					)
				);
			}
		);
	};

	ExploreVisWidget.prototype.onResize = function onResize(contentRect) {
		//React Measure can send resize events when element has no size, guard against it
		//Do not resize when vis renders first time when this.contentRect.height/width is 0
		if (contentRect.bounds.height !== 0 && contentRect.bounds.width !== 0) {
			if (this.contentRect.height !== 0 && (contentRect.bounds.height !== this.contentRect.height || contentRect.bounds.width !== this.contentRect.width)) {
				this.props.layoutOwner.resizeIfVisible();
			}
			this.contentRect.width = contentRect.bounds.width;
			this.contentRect.height = contentRect.bounds.height;
		}
	};

	ExploreVisWidget.prototype._isLoading = function _isLoading() {
		var renderMarkupAvailable = false;
		if (this._childrenRenderMarkupAdded < this.model.numberOfChildLayoutsReady && this.model.numberOfChildLayoutsReady > 0) {
			this._childrenRenderMarkupAdded = this.model.numberOfChildLayoutsReady;
			renderMarkupAvailable = true;
		}
		return !renderMarkupAvailable;
	};

	ExploreVisWidget.prototype._attachWidgetLayout = function _attachWidgetLayout(layoutOwner, parentNode, widgetId) {
		//For the interim, we are using legacy Widget layout view as the widget requires DOM nodes
		//to be pre-created
		if (parentNode && layoutOwner) {
			layoutOwner.getWidgetPromises(widgetId).setDomNode(parentNode);
		}
	};

	ExploreVisWidget.prototype._cleanupWidgetDropTargets = function _cleanupWidgetDropTargets() {
		if (this._widgetDropTargetList) {
			this._widgetDropTargetList.forEach(function (tgt) {
				tgt.remove();
			});
		}
	};

	ExploreVisWidget.prototype.trackWidgetDropTarget = function trackWidgetDropTarget(target) {
		this._widgetDropTargetList.push(target);
	};

	ExploreVisWidget.prototype.componentDidMount = function componentDidMount() {
		var _this3 = this;

		var options = {
			domNode: this.domNode,
			className: 'dndHover',
			dashboardApi: this.props.dashboardApi,
			replaceWithWidget: this.layoutOwner.replaceWithWidget.bind(this.layoutOwner),
			placeWidgetInCard: this.layoutOwner.placeWidgetInCard.bind(this.layoutOwner),
			widgetLayout: this.props.model.placeholder || this.props.model.widgetLayout,
			layoutModel: this.props.layoutOwner.model,
			activate: function activate() {
				return _this3.activateDropTarget = true;
			},
			deactivate: function deactivate() {
				_this3.props.onDragEnd();
				_this3.activateDropTarget = false;
			}
		};
		this.props.dashboardApi.getDashboardSvc('.DndManager').then(function (dndManager) {
			if (_this3.domNode) {
				var removeDropTarget = dndManager.addDropTarget(_this3.domNode, new _SingleVisDnDHandler2.default(options));
				_this3.trackWidgetDropTarget(removeDropTarget);
			}
		});
		this._disposeEvents.push(this.props.dashboardApi.on('dashboard:show', function () {
			return _this3._resetContentRect();
		}));
	};

	ExploreVisWidget.prototype._resetContentRect = function _resetContentRect() {
		this.contentRect = {
			width: 0,
			height: 0
		};
	};

	ExploreVisWidget.prototype.componentWillUnmount = function componentWillUnmount() {
		this._cleanupWidgetDropTargets();
		this._disposeEvents.forEach(function (dispose) {
			return dispose && dispose.remove();
		});
		this._disposeEvents = [];
	};

	ExploreVisWidget.prototype.getEmptyRenderMarkup = function getEmptyRenderMarkup() {
		return _react2.default.createElement(
			'div',
			{ className: 'explore-empty-widget-layout-dnd' },
			_react2.default.createElement(_Empty2.default, null)
		);
	};

	return ExploreVisWidget;
}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'activateDropTarget', [_mobx.observable], {
	enumerable: true,
	initializer: function initializer() {
		return false;
	}
})), _class2)) || _class;

ExploreVisWidget.propTypes = {
	model: _PropTypes2.default.object,
	layoutOwner: _PropTypes2.default.object,
	header: _PropTypes2.default.object,
	dashboardApi: _PropTypes2.default.object,
	onDragEnd: _PropTypes2.default.func,
	getCrossHairMatchingPoints: _PropTypes2.default.func,
	renderPopOver: _PropTypes2.default.func
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2020
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(5);

var _mobxStateTree = __webpack_require__(7);

var _caUiToolkit = __webpack_require__(6);

__webpack_require__(419);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BadgeTooltip = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(BadgeTooltip, _Component);

	function BadgeTooltip(props) {
		_classCallCheck(this, BadgeTooltip);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	BadgeTooltip.prototype.componentDidMount = function componentDidMount() {
		this._onScrollhandler = this._onScroll.bind(this);
		window.addEventListener('scroll', this._onScrollhandler, true);
	};

	BadgeTooltip.prototype.componentWillUnmount = function componentWillUnmount() {
		if (this._onScrollhandler) {
			window.removeEventListener('scroll', this._onScrollhandler, true);
			this._onScrollhandler = null;
		}
		this.props.model = null;
	};

	BadgeTooltip.prototype._onScroll = function _onScroll(event) {
		if (event.target.className !== 'explore__badge-decoration__menu') {
			this.resetFlyout();
		}
	};

	BadgeTooltip.prototype.getBadgeFlyoutContent = function getBadgeFlyoutContent() {
		var _this2 = this;

		var badgesInfo = this.props.model.getBadgesInfo();
		var items = [];
		var name = void 0;
		for (name in badgesInfo) {
			items.push(_react2.default.createElement(
				'div',
				{ key: items.length },
				_react2.default.createElement(_caUiToolkit.Label, { className: 'explore__badge-decoration__menu__title', label: badgesInfo[name].label })
			));
			badgesInfo[name].drivers.forEach(function (entry) {
				items.push(_this2._getEntry(entry, items.length));
			});
		}

		var badgeContent = _react2.default.createElement(
			'div',
			{ className: 'explore__badge-decoration__menu', 'appcues-data-id': 'badge-menu' },
			items
		);

		return badgeContent;
	};

	BadgeTooltip.prototype._getEntry = function _getEntry(entry, key) {
		var _this3 = this;

		return _react2.default.createElement(
			'div',
			{ key: key, className: 'explore__badge-decoration__menu__item' },
			_react2.default.createElement(
				_caUiToolkit.Link,
				{ onClick: function onClick() {
						_this3._onClickEntry(entry);
					} },
				entry.label
			)
		);
	};

	BadgeTooltip.prototype._onClickEntry = function _onClickEntry(entry) {
		this.props.layoutOwner.parentLayout.model.addCometCardForCorrelation(entry);
		this.resetFlyout();
	};

	BadgeTooltip.prototype.render = function render() {
		var content = null;
		if (this.props.model.isTooltipOpen()) {
			var position = this.props.model.getPosition();
			content = _react2.default.createElement(
				'div',
				{ className: 'explore__badge-decoration', style: { top: position.top + 'px', left: position.left + 'px', height: position.height + 'px', width: position.width + 'px' } },
				_react2.default.createElement(
					_caUiToolkit.Flyout,
					{
						trigger: 'Click',
						alignment: true,
						domNodeToAttachTo: document.body,
						onClose: this.resetFlyout.bind(this)
					},
					this.getBadgeFlyoutContent()
				)
			);
		}

		return content;
	};

	BadgeTooltip.prototype.resetFlyout = function resetFlyout() {
		this.props.model && this._isAliveModel() && this.props.model.closeTooltip();
	};

	BadgeTooltip.prototype._isAliveModel = function _isAliveModel() {
		return (0, _mobxStateTree.isAlive)(this.props.model);
	};

	return BadgeTooltip;
}(_react.Component)) || _class;

BadgeTooltip.propTypes = {
	model: _propTypes2.default.object,
	layoutOwner: _propTypes2.default.object
};

exports.default = BadgeTooltip;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(420);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./BadgeDecoration.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./BadgeDecoration.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore__badge-decoration {\n  position: fixed;\n}\n\n.explore__badge-decoration__menu {\n  text-align: left;\n  max-height: 350px;\n  width: 300px;\n  overflow: auto;\n  padding: 8px;\n}\n\n.explore__badge-decoration__menu__title {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #343334;\n  padding: 4px 8px;\n}\n\n.explore__badge-decoration__menu__item {\n  font-size: 0.875rem;\n  padding-top: 8px;\n  padding-left: 16px;\n}\n\n.explore__badge-decoration_empty {\n  visibility: hidden;\n}\n\n", ""]);

// exports


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _caUiToolkit = __webpack_require__(6);

var _mobxReact = __webpack_require__(5);

__webpack_require__(422);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DisplayTooltipInfo = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(DisplayTooltipInfo, _Component);

	function DisplayTooltipInfo() {
		_classCallCheck(this, DisplayTooltipInfo);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	DisplayTooltipInfo.prototype.renderColumn = function renderColumn(column, textPosition, columnClassName) {
		return _react2.default.createElement(
			'div',
			{ className: columnClassName },
			column.map(function (columnInstance, key) {
				return _react2.default.createElement(
					'div',
					{ key: key, className: 'popover_rows' },
					_react2.default.createElement(_caUiToolkit.TruncatedText, {
						style: { maxWidth: '100%' },
						textAlign: textPosition,
						className: 'displayBoxRow',
						location: 'end',
						value: columnInstance })
				);
			})
		);
	};

	//Renders the formatted text to be displayed in the popover when the compare line is moved.


	DisplayTooltipInfo.prototype.render = function render() {
		return _react2.default.createElement(
			'div',
			{ className: 'displayBox' },
			_react2.default.createElement(
				'div',
				{ className: 'crossHair' },
				this.renderColumn(this.props.crossHairInfo[0], 'left', 'display_col1'),
				this.renderColumn(this.props.crossHairInfo[1], 'right', 'display_col2')
			)
		);
	};

	return DisplayTooltipInfo;
}(_react.Component)) || _class;

DisplayTooltipInfo.propTypes = {
	crossHairInfo: _propTypes2.default.array
};

DisplayTooltipInfo.defaultProps = {
	crossHairInfo: []
};

exports.default = DisplayTooltipInfo;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(423);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./DisplayTooltipInfo.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./DisplayTooltipInfo.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2019\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore .crossHair {\n  width: 100%;\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.explore .displayBox {\n  width: 100%;\n  height: 100%;\n}\n\n.explore .display_col1 {\n  width: 50%;\n  padding-left: 8px;\n}\n\n.explore .display_col2 {\n  width: 50%;\n  font-weight: 600;\n  padding-right: 8px;\n}\n\n.explore .popover_rows {\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n", ""]);

// exports


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(425);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./exploreVisWidget.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./exploreVisWidget.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.widget-wrapper .widget .widgetHeader {\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.widget-wrapper .widget .widgetHeader .widgetTitle {\n  -ms-flex: 0 1 auto;\n      flex: 0 1 auto;\n  margin-right: 8px;\n}\n\n.widget-wrapper .widget .widgetHeader .widgetIcons {\n  -ms-flex: 1 0 auto;\n      flex: 1 0 auto;\n}\n\n", ""]);

// exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(427);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./exploreCard.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./exploreCard.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2019\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.card-layout {\n  -ms-flex: 1 1;\n      flex: 1 1;\n  position: relative;\n  min-width: 300px;\n}\n\n.card-layout .card-layout-content .widget .widgetHeader .widgetTitle * {\n  color: #343334;\n  font-size: 16px;\n  text-align: left;\n  font-weight: 700;\n}\n\n.card-layout .widget .attachedView.expanded {\n  top: 35px;\n}\n\n", ""]);

// exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

var emptyStats = {
	header: [{ id: 'min', name: 'Min' }, { id: 'max', name: 'Max' }, { id: 'avg', name: 'Average' }, { id: 'total', name: 'Total' }, { id: 'totalPercent', name: '%Total' }]
};

var emptySelStats = {
	header: [{ id: 'values', name: 'Values' }]
};

var CompareUtils = function () {
	function CompareUtils(props) {
		_classCallCheck(this, CompareUtils);

		this.services = props.services;
		this.model = props.model;
		this.dashboardApi = props.dashboardApi;
		this.model.compareModel.setDashboardApi(this.dashboardApi);
	}

	CompareUtils.prototype.initialize = function initialize(widgetId, cardModel) {
		var _this = this;

		var abortPromiseMessage = 'do nothing for non live widgets';
		return this.dashboardApi.getCanvasWhenReady().then(function (canvas) {
			// board spec will not be ready until canvas is ready
			var isVisualization = false;
			var widgets = _this.dashboardApi.getFeature('internal').getBoardModel().widgetInstances;
			isVisualization = widgets[widgetId].type === 'live';
			if (isVisualization && _this.model.isCompareEnabled) {
				var measureLabel = _StringResources2.default.get('cardStats_measureLabel');
				var widgetAlias = _this._getWidgetAlias(widgetId, cardModel && cardModel.items);
				_this.model.addStatsModels(widgetId, emptyStats, emptySelStats, measureLabel, widgetAlias);
				_this.model.compareModel.initializeWidgetSelectionsSynced(_this.model.boardModel && _this.model.boardModel.eventGroups);
				return canvas;
			} else {
				throw new Error(abortPromiseMessage);
			}
		}).then(function (canvas) {
			return canvas.getWidgetWhenReady(widgetId).then(function () {
				return canvas;
			});
		}).then(function (canvas) {
			var widgetContentApi = canvas.getContent(widgetId);
			var compareModel = _this.model.compareModel;
			compareModel.initializeWidgetApis(widgetContentApi);
			compareModel.initializeSynch(widgetContentApi);
			return _this.model.setupStatsModels(widgetId, widgetContentApi.getFeature('WidgetAPI.deprecated').getFeature('vis-summarizer'));
		}).catch(function (error) {
			if (error.message === abortPromiseMessage) {
				// just swallow error because chain was intentionally aborted
				return true;
			} else {
				// else let the error bubble up because it's coming from somewhere else
				throw error;
			}
		});
	};

	CompareUtils.prototype._getWidgetAlias = function _getWidgetAlias(widgetId, items) {
		items = items || [];
		var widgetAliasStart = 65;
		var index = items.findIndex(function (e) {
			return e.id === widgetId;
		});
		index = index > -1 ? index : 0;
		return String.fromCharCode(widgetAliasStart + index);
	};

	return CompareUtils;
}();

exports.default = CompareUtils;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.CompareCardView = undefined;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _CombinedCompareTable = __webpack_require__(430);

var _CombinedCompareTable2 = _interopRequireDefault(_CombinedCompareTable);

var _CompareChartHeader = __webpack_require__(440);

var _CompareChartHeader2 = _interopRequireDefault(_CompareChartHeader);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
* Compare Card react view
* Customizes ExploreCardView - provides overview & stats tables for each visualization in the compare card
*/
var CompareCardView = exports.CompareCardView = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(CompareCardView, _Component);

	function CompareCardView(props) {
		_classCallCheck(this, CompareCardView);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.headerMap = null;
		return _this;
	}

	CompareCardView.prototype.render = function render() {
		//Uses function as children react pattern
		//Child react component is a function that renders ExploreCardView, but passes in 2 params
		//to render the 'card' overview (for compare, show a compare specific overview)
		//and visualization 'header' (for compare, shows stats for the visualization)
		var model = this.props.model;
		var compareModel = model.compareModel;

		var showCompareTable = compareModel && model.shouldShowCompareTable(compareModel);
		var compareTable = showCompareTable ? _react2.default.createElement(_CombinedCompareTable2.default, { compareModel: compareModel }) : null;
		var getFooterView = function getFooterView() {
			return compareTable;
		};

		var headerMap = this._getWidgetHeaderMap();
		var renderPopOver = compareModel.renderPopOver;

		var getWidgetHeaderMap = function getWidgetHeaderMap() {
			return headerMap;
		};
		var getCssClasses = this.getCardStyleClasses;
		var getCrossHairMatchingPoints = compareModel.getCrossHairMatchingPoints;
		return this.props.children(null, getWidgetHeaderMap, getFooterView, getCssClasses, getCrossHairMatchingPoints, renderPopOver);
	};

	CompareCardView.prototype.getCardStyleClasses = function getCardStyleClasses() {
		var containsPlaceholder = this.model.getVisualizations().find(function (widget) {
			return widget.placeholder;
		});
		var classNamesMain = (0, _classnames2.default)({
			'card-layout-main': true
		});
		var classNamesCardRow = (0, _classnames2.default)({
			'card-row': !containsPlaceholder,
			'card-row-placeholder': containsPlaceholder
		});
		return {
			classNamesMain: classNamesMain,
			classNamesCardRow: classNamesCardRow
		};
	};

	CompareCardView.prototype._getWidgetHeaderMap = function _getWidgetHeaderMap() {
		var model = this.props.model;
		var compareModel = model.compareModel;
		var headerMap = {};
		void compareModel.widgetUpdatedCount;

		model.getVisualizations().map(function (o) {
			var id = o.widgetLayout ? o.widgetLayout.id : o.placeholder.id;
			var header = null;
			var m = o.widgetLayout ? compareModel.getStatsModel(id) : null;
			if (m) {
				var subLabel = compareModel.getWidgetSubLabel(id);
				header = _react2.default.createElement(_CompareChartHeader2.default, { key: id, label: compareModel.getWidgetAlias(id), subLabel: subLabel });
			}
			headerMap[id] = header;
		});

		return headerMap;
	};

	return CompareCardView;
}(_react.Component)) || _class;

CompareCardView.propTypes = {
	model: _PropTypes2.default.object,
	children: _PropTypes2.default.any
};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _CompareTable = __webpack_require__(431);

var _CompareTable2 = _interopRequireDefault(_CompareTable);

__webpack_require__(438);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var summaryLabel = _StringResources2.default.get('compareTable_SummaryLabel');
var selectionsLabel = _StringResources2.default.get('compareTable_SelectionsLabel');

var FullSideList = [{ value: 'summary', label: summaryLabel }, { value: 'selections', label: selectionsLabel }];
var SummarySideList = [{ value: 'summary', label: summaryLabel }];

/**
* Compare Card table
* for showing stats on selection &
*/

var CombinedCompareTable = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(CombinedCompareTable, _Component);

	function CombinedCompareTable(props) {
		_classCallCheck(this, CombinedCompareTable);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.sideHeaderList = [{ value: 'summary', label: summaryLabel }];
		_this.state = {
			selectedCategory: 'summary'
		};
		_this.selectionUpdated = undefined;
		return _this;
	}

	CombinedCompareTable.prototype.switchTo = function switchTo(category) {
		this.setState({ selectedCategory: category });
	};

	CombinedCompareTable.prototype.switchViewOnSelection = function switchViewOnSelection() {
		var selectionUpdated = this.props.compareModel.selectionUpdated;
		if (this.selectionUpdated === undefined) {
			this.selectionUpdated = selectionUpdated;
		} else {
			if (this.selectionUpdated != selectionUpdated && selectionUpdated > 1) {
				this.selectionUpdated = selectionUpdated;
				this.switchTo('selections');
			} else {
				this.selectionUpdated = selectionUpdated;
			}
		}
	};

	CombinedCompareTable.prototype.render = function render() {

		var compareModel = this.props.compareModel;
		if (!compareModel.showStats) {
			return null;
		}

		var compareTableSummary = compareModel.compareTableSummary || {};
		if (!compareTableSummary.charts || compareTableSummary.charts && compareTableSummary.charts.length === 0) {
			return null; //can't render anything yet
		}
		this.switchViewOnSelection();

		var useSummaryOnly = false;
		var selections = compareModel.getChartSummaryModel('selections');
		if (selections && selections.charts && selections.charts.length > 0) {
			this.sideHeaderList = FullSideList;
		} else {
			useSummaryOnly = true;
			this.sideHeaderList = SummarySideList;
		}

		var summaryInfo = {
			title: summaryLabel,
			category: 'summary',
			sideHeaderList: this.sideHeaderList,
			onSwitch: this.switchTo.bind(this)
		};
		var selectionsInfo = {
			title: selectionsLabel,
			category: 'selections',
			sideHeaderList: this.sideHeaderList,
			onSwitch: this.switchTo.bind(this)
		};

		if (useSummaryOnly && this.state.selectedCategory !== 'summary') {
			this.setState({ selectedCategory: 'summary' });
		}

		var info = summaryInfo;
		if (this.state.selectedCategory !== 'summary') {
			info = selectionsInfo;
		}

		return _react2.default.createElement(
			'div',
			{ className: 'combinedCompareTable__container' },
			_react2.default.createElement(_CompareTable2.default, { options: info, compareModel: compareModel })
		);
	};

	return CombinedCompareTable;
}(_react.Component)) || _class;

exports.default = CombinedCompareTable;


CombinedCompareTable.propTypes = {
	compareModel: _PropTypes2.default.object
};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

__webpack_require__(114);

var _CompareTableSideHeader = __webpack_require__(433);

var _CompareTableSideHeader2 = _interopRequireDefault(_CompareTableSideHeader);

var _ChartDetail = __webpack_require__(434);

var _ChartDetail2 = _interopRequireDefault(_ChartDetail);

var _CalculatedChartDetail = __webpack_require__(435);

var _CalculatedChartDetail2 = _interopRequireDefault(_CalculatedChartDetail);

var _CompareTableDetailHeader = __webpack_require__(436);

var _CompareTableDetailHeader2 = _interopRequireDefault(_CompareTableDetailHeader);

var _caUiToolkit = __webpack_require__(6);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _CompareTableDynamicCell = __webpack_require__(437);

var _CompareTableDynamicCell2 = _interopRequireDefault(_CompareTableDynamicCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
* Compare Card table
* for showing summary stats
*/
var CompareTable = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(CompareTable, _Component);

	function CompareTable(props) {
		_classCallCheck(this, CompareTable);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	CompareTable.prototype.render = function render() {
		var _this2 = this;

		var _props$options = this.props.options,
		    category = _props$options.category,
		    sideHeaderList = _props$options.sideHeaderList,
		    onSwitch = _props$options.onSwitch;

		var compareModel = this.props.compareModel;

		var summaryModel = compareModel.getChartSummaryModel(category) || {};
		var applicableCalcs = summaryModel.applicableCalcs;

		var getChartSummaryStats = compareModel.summaryStatsGetter(category);
		var getChartSubHeader = compareModel.summarySubHeaderGetter(category);

		if (!applicableCalcs) {
			return null; //not ready yet, bail out
		}
		void compareModel.statsUpdated; //render every time info is updated
		void summaryModel.updated; //render every time info is updated

		// prepare the columns

		var columns = [new _CompareTableSideHeader2.default({ applicableCalcs: applicableCalcs })];

		var widgets = summaryModel.charts || [];
		widgets.forEach(function (widgetInfo) {
			var chart = new _ChartDetail2.default({ widgetInfo: widgetInfo, summaryModel: summaryModel, getChartSummaryStats: getChartSummaryStats, getChartSubHeader: getChartSubHeader });
			columns.push(chart);
		});

		columns.push(new _CalculatedChartDetail2.default({ summaryModel: summaryModel, getChartSummaryStats: getChartSummaryStats }));

		// setup the cell, header renderers
		var filler = _react2.default.createElement('div', { className: 'compareTable__subHeader' });

		var cellRenderer = function cellRenderer(row, col) {
			var value = columns[col].cellRenderer(row);
			if (col !== 0) {
				return _this2._getCellwithToolTip(value);
			}
			return _react2.default.createElement(
				'div',
				{ className: 'compareTable__cell' },
				' ',
				_react2.default.createElement(_caUiToolkit.TruncatedText, { role: 'cell', value: value }),
				' '
			);
		};
		var headerRenderer = function headerRenderer(col) {
			var header = columns[col].headerRenderer();

			if (header.type === 'Category') {
				if (sideHeaderList && sideHeaderList.length > 1) {
					return _react2.default.createElement(
						'div',
						null,
						filler,
						_react2.default.createElement(
							'div',
							{ className: 'columnSelect', key: col },
							_react2.default.createElement(_caUiToolkit.Select, {
								truncated: false,
								size: 'small',
								options: sideHeaderList,
								selected: category,
								onChange: function onChange(v) {
									return onSwitch(v);
								},
								variant: 'frameless'
							})
						)
					);
				} else {
					return _react2.default.createElement(
						'div',
						null,
						filler,
						_react2.default.createElement(
							'div',
							{ role: 'columnheader', className: 'compareTable__header compareTable--centerAlign', key: col },
							_react2.default.createElement(_caUiToolkit.TruncatedText, { value: sideHeaderList[0].label })
						)
					);
				}
			} else if (header.type === 'ChartDetail') {
				return _react2.default.createElement(_CompareTableDetailHeader2.default, { header: header, column: col, filler: filler });
			}

			return _react2.default.createElement(
				'div',
				null,
				filler,
				_react2.default.createElement(
					'div',
					{ role: 'columnheader', className: 'compareTable__header compareTable--rightAlign' },
					_react2.default.createElement(_caUiToolkit.TruncatedText, { value: header.label })
				)
			);
		};

		// render the table

		var classes = (0, _classnames2.default)({
			'compareTable__container': true
		});

		return _react2.default.createElement(
			'div',
			{ className: classes },
			_react2.default.createElement(_caUiToolkit.SimpleTable, {
				rowLength: applicableCalcs && applicableCalcs.length || 0,
				colLength: columns.length,
				cellRenderer: cellRenderer,
				headerRenderer: headerRenderer
			})
		);
	};

	CompareTable.prototype._getCellwithToolTip = function _getCellwithToolTip(value) {
		var toolTip = value.toolTip;
		//If the dataset has negative values, percentage calculations results are correct but can be a bit unexpected (ie: negative or > 100%).
		//Style the cell differently and append an indicator (*) to the value to encourage the user to see a tooltip about this.
		var cellValue = value.value + (value.hasNegativeValuesIndicator ? value.hasNegativeValuesIndicator : '');
		var cellStyle = value.hasNegativeValuesIndicator ? 'compareTable__cellWithHasNegativeValuesIndicator--rightAlign' : 'compareTable__cell--rightAlign';
		var toolTipLabelClass = 'compareTableTooltipLabel';
		if (typeof toolTip === 'string') {
			return _react2.default.createElement(_CompareTableDynamicCell2.default, { value: cellValue, valueUse: value.valueUse, formatSpec: value.formatSpec, className: cellStyle, tooltipValue: toolTip });
		} else if (toolTip) {
			var tiplist = [];
			var key = 0;
			toolTip.forEach(function (line, index) {
				if (index > 0) {
					tiplist.push(_react2.default.createElement('br', { key: key++ }));
					tiplist.push(_react2.default.createElement('br', { key: key++ }));
				}
				tiplist.push(_react2.default.createElement(_caUiToolkit.Label, { label: line, className: toolTipLabelClass, key: key++ }));
			});
			var tip = _react2.default.createElement(
				'div',
				{ className: 'compareTable__toolTip' },
				tiplist
			);
			return _react2.default.createElement(_CompareTableDynamicCell2.default, { value: cellValue, valueUse: value.valueUse, formatSpec: value.formatSpec, className: cellStyle, tooltipValue: tip });
		} else {
			return _react2.default.createElement(_CompareTableDynamicCell2.default, { value: cellValue, valueUse: value.valueUse, formatSpec: value.formatSpec, className: cellStyle });
		}
	};

	return CompareTable;
}(_react.Component)) || _class;

exports.default = CompareTable;


CompareTable.propTypes = {
	options: _PropTypes2.default.object,
	compareModel: _PropTypes2.default.object
};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.compareTable__toolTip {\n  text-align: left;\n}\n\n.compareTable__toolTip .compareTableTooltipLabel {\n  color: white;\n  color: hsla(var(--text-04-h, 0), var(--text-04-s, 0%), var(--text-04-l, 100%), 1);\n}\n\n.compareTable__cell {\n  padding-left: 8px;\n  padding-right: 8px;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.compareTable__cell--rightAlign {\n  float: right;\n  padding-right: 1%;\n}\n\n.compareTable__cellWithHasNegativeValuesIndicator--rightAlign {\n  float: right;\n  padding-right: 1%;\n  color: #0f62fe;\n  color: hsla(var(--interactive-03-h, 219.16318), var(--interactive-03-s, 99.17012%), var(--interactive-03-l, 52.7451%), 1);\n  white-space: nowrap;\n}\n\n.compareTable--centerAlign {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 100%;\n  width: 100%;\n}\n\n.compareTable--rightAlign {\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 100%;\n  width: 100%;\n}\n\n.compareTable__container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: center;\n      justify-content: center;\n  font-size: 12px;\n}\n\n.compareTable__container .ba-common-simpletable-thead {\n  border-bottom: 1px solid;\n}\n\n.compareTable__container .ba-common-simpletable-thead .ba-common-button__label {\n  font-size: 0.75rem;\n}\n\n.compareTable__container .ba-common-simpletable-thead .ba-common-listItem {\n  font-size: 0.75rem;\n}\n\n.compareTable__container .ba-common-simpletable-tbody {\n  border-bottom: 1px solid;\n}\n\n.compareTable__container--hide {\n  display: none;\n}\n\n.compareTable__container .columnSelect {\n  margin-left: -4px;\n}\n\n.compareTable__header {\n  height: 32px;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.compareTable__subHeader {\n  font-size: 12px;\n  height: 20px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  color: #343334;\n}\n\n.compareTable__subHeaderItem1 {\n  padding-right: 2px;\n}\n\n.compareTable__subHeaderItem1-appear,\n.compareTable__subHeaderItem1-enter {\n  opacity: 0.1;\n  color: #a8c0f3;\n}\n\n.compareTable__subHeaderItem1-appear-active,\n.compareTable__subHeaderItem1-enter-active {\n  opacity: 1;\n  transition: opacity 0.5s ease;\n}\n\n.compareTable__subHeaderItem1-exit {\n  opacity: 1;\n}\n\n.compareTable__subHeaderItem1-exit-active {\n  opacity: 0.1;\n  transition: opacity 0.5s ease;\n}\n\n.compareTable__subHeaderItem2 {\n  padding-left: 2px;\n}\n\n.compareTable__detailHeaderContainer {\n  padding-left: 18%;\n}\n\n.compareTable__detailHeader {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n", ""]);

// exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _StatsProcessor = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

var res = function res(str) {
	return _StringResources2.default.get(str);
};
var calcLabels = {};
calcLabels[_StatsProcessor.CalcType.TOTAL] = res('compareTable_Header_total');
calcLabels[_StatsProcessor.CalcType.TOTAL_SEL] = res('compareTable_Header_total_selection');
calcLabels[_StatsProcessor.CalcType.MIN_SEL] = res('compareTable_Header_min_selection');
calcLabels[_StatsProcessor.CalcType.MAX_SEL] = res('compareTable_Header_max_selection');
calcLabels[_StatsProcessor.CalcType.DIFF] = res('compareTable_Header_difference');
calcLabels[_StatsProcessor.CalcType.DIFF_SEL] = res('compareTable_Header_difference_selection');
calcLabels[_StatsProcessor.CalcType.PERCENT_vsALLDATA] = res('compareTable_Header_chartpercent_of_dataset');
calcLabels[_StatsProcessor.CalcType.PERCENT_SEL_vsALLDATA] = res('compareTable_Header_chart_selection_percent_of_dataset');
calcLabels[_StatsProcessor.CalcType.PERCENT_CHARTvsCHART] = res('compareTable_Header_chartpercent_displayed');
calcLabels[_StatsProcessor.CalcType.PERCENT_SELvsCHART] = res('compareTable_Header_selection_percent_of_chart');

calcLabels[_StatsProcessor.CalcType.SEL_CONTEXT] = res('compareTable_Header_selection_context');
calcLabels[_StatsProcessor.CalcType.NUM_SELECTIONS] = res('compareTable_Header_mumber_of_selections');

calcLabels[_StatsProcessor.CalcType.MIN] = res('compareTable_Header_min');
calcLabels[_StatsProcessor.CalcType.MAX] = res('compareTable_Header_max');
calcLabels[_StatsProcessor.CalcType.AVG] = res('compareTable_Header_avg');
calcLabels[_StatsProcessor.CalcType.AVG_SEL] = res('compareTable_Header_avgSelection');
calcLabels[_StatsProcessor.CalcType.WEIGHTED_AVG] = res('compareTable_Header_weightedAvg');
calcLabels[_StatsProcessor.CalcType.WEIGHTED_AVG_SEL] = res('compareTable_Header_weightedAvgSelection');

/**
*
*/

var CompareTableSideHeader = function () {
	function CompareTableSideHeader(props) {
		_classCallCheck(this, CompareTableSideHeader);

		this.process(props);
	}

	CompareTableSideHeader.prototype.process = function process(props) {
		var applicableCalcs = props.applicableCalcs;

		this.cellRenderer = function (row) {
			var calc = applicableCalcs && applicableCalcs[row] || '';
			return calcLabels[calc];
		};
		this.headerRenderer = function () {
			var type = 'Category';
			return { type: type };
		};
	};

	return CompareTableSideHeader;
}();

exports.default = CompareTableSideHeader;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

/**
* Helper class to encapsulate logic around getting data for the individual visualization stats
* (the middle 2 columns)
*/
var ChartDetail = function () {
	function ChartDetail(props) {
		_classCallCheck(this, ChartDetail);

		this.process(props);
	}

	ChartDetail.prototype.process = function process(props) {
		var _props$widgetInfo = props.widgetInfo,
		    widgetId = _props$widgetInfo.widgetId,
		    widgetAlias = _props$widgetInfo.widgetAlias,
		    measureList = _props$widgetInfo.measureList;
		var measureName = props.widgetInfo.measureName;

		var summaryModel = props.summaryModel;
		var getChartSummaryStats = props.getChartSummaryStats;
		var getChartSubHeader = props.getChartSubHeader;

		measureName = summaryModel.getSelectedMeasureName(widgetId) || measureName;
		var statsInfo = getChartSummaryStats(widgetId, measureName);

		var list = [];
		measureList && measureList.forEach(function (e) {
			var label = _StringResources2.default.get('compareTable_ChartMeasureHeader', { name: widgetAlias, measure: e.metadata.label });
			list.push({ value: e.measureName, label: label });
		});

		var onChange = function onChange(measureName) {
			summaryModel.recomputeSummaryInfo({ widgetId: widgetId, measureName: measureName });
		};

		this.cellRenderer = function (row) {
			return summaryModel.getData(row, statsInfo);
		};
		this.headerRenderer = function () {
			var type = 'ChartDetail';
			var selected = measureName;
			var subHeader = getChartSubHeader(widgetId, measureName);
			return { type: type, selected: selected, list: list, subHeader: subHeader, onChange: onChange };
		};
	};

	return ChartDetail;
}();

exports.default = ChartDetail;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */

/**
* Helper class to encapsulate logic around getting data for rendering 'Combined' calculations column in
* compare summary table
*
*/
var CalculatedChartDetail = function () {
	function CalculatedChartDetail(props) {
		_classCallCheck(this, CalculatedChartDetail);

		this.process(props);
	}

	CalculatedChartDetail.prototype.process = function process(props) {
		var summaryModel = props.summaryModel;
		var widgets = summaryModel.charts || [];
		var getChartSummaryStats = props.getChartSummaryStats;

		var allWidgetsStats = [];
		widgets.forEach(function (widgetInfo) {
			var chartSumStats = getChartSummaryStats(widgetInfo.widgetId, widgetInfo.measureName);
			if (chartSumStats) {
				allWidgetsStats.push(chartSumStats);
			}
		});

		void summaryModel.widgetContextProcessState; //re-render if state changes
		var calculatedData = summaryModel.getCalculatedData(allWidgetsStats) || [];

		this.cellRenderer = function (row) {
			return { value: calculatedData[row].value, valueUse: calculatedData[row].valueUse, toolTip: calculatedData[row].toolTip };
		};
		this.headerRenderer = function () {
			return { label: _StringResources2.default.get('compareTable_CalculatedStatsHeader') };
		};
	};

	return CalculatedChartDetail;
}();

exports.default = CalculatedChartDetail;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

__webpack_require__(114);

var _caUiToolkit = __webpack_require__(6);

var _CSSTransition = __webpack_require__(26);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
*/
var CompareTableDetailHeader = function (_Component) {
	_inherits(CompareTableDetailHeader, _Component);

	function CompareTableDetailHeader(props) {
		_classCallCheck(this, CompareTableDetailHeader);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	CompareTableDetailHeader.prototype.render = function render() {
		var header = this.props.header;
		var _filler = this.props.filler;
		var col = this.props.column;

		if (header.type === 'ChartDetail') {
			var subHeader = null;

			var headerMarkup = null;
			if (header && header.list.length > 1) {
				var selected = header.selected;
				var selectStyle = {
					width: '100%',
					'text-align': 'right'
				};
				headerMarkup = _react2.default.createElement(
					'div',
					{ 'data-tid': col, className: 'compareTable__header compareTable--rightAlign', key: col },
					_react2.default.createElement(_caUiToolkit.Select, {
						size: 'small',
						variant: 'frameless',
						options: header.list,
						selected: selected,
						style: selectStyle,
						onChange: this.onChange.bind(this, header) })
				);
			} else {
				headerMarkup = _react2.default.createElement(
					'div',
					{ className: 'compareTable__header compareTable--rightAlign' },
					_react2.default.createElement(_caUiToolkit.TruncatedText, { role: 'columnheader', value: header.list[0].label })
				);
			}

			if (header.subHeader) {
				subHeader = _react2.default.createElement(
					'div',
					{ className: 'compareTable__subHeader compareTable__subHeader--divider' },
					_react2.default.createElement(
						_CSSTransition2.default,
						{
							'in': true,
							appear: true,
							timeout: 500,
							classNames: 'compareTable__subHeaderItem1'
						},
						_react2.default.createElement(
							'div',
							{ className: 'compareTable__subHeaderItem1' },
							_react2.default.createElement(_caUiToolkit.TruncatedText, { value: header.subHeader[0] })
						)
					),
					_react2.default.createElement('div', { className: 'compareTable__subHeaderItem2' })
				);
			}

			var filler = !subHeader ? _filler : null;

			return _react2.default.createElement(
				'div',
				{ className: 'compareTable__detailHeaderContainer' },
				filler,
				headerMarkup,
				subHeader
			);
		}
		return null;
	};

	CompareTableDetailHeader.prototype.onChange = function onChange(header, v) {
		header.onChange(v);
	};

	return CompareTableDetailHeader;
}(_react.Component);

exports.default = CompareTableDetailHeader;


CompareTableDetailHeader.propTypes = {
	header: _PropTypes2.default.object,
	filler: _PropTypes2.default.object,
	column: _PropTypes2.default.number
};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2; /*
                     *+------------------------------------------------------------------------+
                     *| Licensed Materials - Property of IBM
                     *| IBM Cognos Products: Explore
                     *| (C) Copyright IBM Corp. 2019
                     *|
                     *| US Government Users Restricted Rights - Use, duplication or disclosure
                     *| restricted by GSA ADP Schedule Contract with IBM Corp.
                     *+------------------------------------------------------------------------+
                     */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMeasure = __webpack_require__(20);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _caUiToolkit = __webpack_require__(6);

var _FormatterWrapper = __webpack_require__(71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PADDING = 10;

var CompareTableDynamicCell = (_temp2 = _class = function (_Component) {
	_inherits(CompareTableDynamicCell, _Component);

	function CompareTableDynamicCell() {
		var _temp, _this, _ret;

		_classCallCheck(this, CompareTableDynamicCell);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			charCount: _this._handleValueType().length
		}, _this.onMeasure = function (dimensions) {
			_this.containerWidth = Math.ceil(dimensions.entry.width);
			_this._getTextWidth();
			_this._compareTextAndContainerWidth(_this.containerWidth);
		}, _this._getTextWidth = function () {
			if (_this._textNode) {
				_this._textWidth = _this._textNode.offsetWidth;
				_this.setState({ _isMounted: true });
			}
		}, _this._getTruncValue = function () {
			var formatSpec = _extends({}, _this.props.formatSpec, {
				decimalFormatLength: 'short',
				maximumFractionDigits: 2
			});
			/* The Formatter we use does not support abbreviation of numbers as a percent. For the mean time we will not see
    * percent formatted values be truncated but hopefully in R5 we will be able to get this added to the Formatter.
    */
			// If our valueUse is defined, we want to truncate it. If not, we use the display value.
			if (_this.props.valueUse) {
				return _FormatterWrapper.Formatter.format(_this.props.valueUse, formatSpec);
			} else {
				return _this.props.value;
			}
		}, _this._ref = function (node) {
			_this._node = node;
			_this._measureRef(node);
		}, _this._refText = function (node) {
			_this._textNode = node;
		}, _this.getDefaultNode = function (className) {
			return _react2.default.createElement(
				'span',
				{ role: 'cell', className: className, ref: _this._refText },
				_this.props.value
			);
		}, _this.getTruncNode = function () {
			return _react2.default.createElement(
				'span',
				{ role: 'cell', ref: _this._refText },
				_this._getTruncValue()
			);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	CompareTableDynamicCell.prototype.componentDidMount = function componentDidMount() {
		if (!this._textNode.offsetWidth) {
			this._getTextWidth();
		} else {
			this._textNode && this._getTextWidth();
		}
	};

	CompareTableDynamicCell.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
		if (this.state._isMounted) {
			var containerWidth = this._node.offsetWidth;
			this._textWidth = this._textNode.offsetWidth;

			if (prevState.charCount !== this.state.charCount) {
				// check if resizing is still needed after first render
				this._compareTextAndContainerWidth(containerWidth);
			}
		} else if (prevProps.value !== this.props.value) {
			// trigger measuring after updating props
			this._getTextWidth();
		}
	};

	CompareTableDynamicCell.prototype._handleValueType = function _handleValueType() {
		var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.value;

		return value === null ? '' : String(value);
	};

	CompareTableDynamicCell.prototype._compareTextAndContainerWidth = function _compareTextAndContainerWidth(containerWidth) {
		// check to see if our text fits within our container minus a 10 pixel "padding"
		this.willTruncate = containerWidth - PADDING < this._textWidth;
	};

	CompareTableDynamicCell.prototype._render = function _render() {
		var className = 'dynamicCell ' + this.props.className;
		var truncClassName = 'truncated-' + className;
		this._compareTextAndContainerWidth(this.containerWidth);

		// check if we are supposed to display a truncated value or not
		if (!this.willTruncate) {
			// check if our value has a tooltip associated with it
			if (this.props.tooltipValue) {
				return _react2.default.createElement(
					_caUiToolkit.Tooltip,
					{ className: className, title: this.props.tooltipValue },
					this.getDefaultNode(className)
				);
			} else {
				return this.getDefaultNode(className);
			}
		} else {
			if (this.props.tooltipValue) {
				return _react2.default.createElement(
					_caUiToolkit.Tooltip,
					{ className: truncClassName, title: this.props.tooltipValue },
					this.getTruncNode()
				);
			} else {
				return _react2.default.createElement(
					_caUiToolkit.Tooltip,
					{ className: truncClassName, title: this.props.value },
					this.getTruncNode()
				);
			}
		}
	};

	CompareTableDynamicCell.prototype.render = function render() {
		var _this2 = this;

		return _react2.default.createElement(
			_reactMeasure2.default,
			{ onResize: this.onMeasure },
			function (_ref) {
				var measureRef = _ref.measureRef;

				_this2._measureRef = measureRef;
				return _react2.default.createElement(
					'div',
					{ ref: _this2._ref },
					_this2._render()
				);
			}
		);
	};

	return CompareTableDynamicCell;
}(_react.Component), _class.propTypes = {
	value: _propTypes2.default.string.isRequired,
	valueUse: _propTypes2.default.number,
	formatSpec: _propTypes2.default.object,
	className: _propTypes2.default.string,
	tooltipValue: _propTypes2.default.string
}, _temp2);
exports.default = CompareTableDynamicCell;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(439);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./CombinedCompareTable.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./CombinedCompareTable.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2019\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.combinedCompareTable__container {\n  -ms-flex: none;\n      flex: none;\n  min-height: 150px;\n  max-height: 200px;\n  padding-bottom: 8px;\n  overflow-y: auto;\n}\n\n.combinedCompareTable__table--show {\n  display: block;\n}\n\n.combinedCompareTable__table--hide {\n  display: none;\n}\n\n", ""]);

// exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _caUiToolkit = __webpack_require__(6);

__webpack_require__(441);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var truncatedTextStyle = { maxWidth: '80%' };

/**
* Simple control to show label of the chart (appears on top of the visualization in compare card)
*/

var CompareChartHeader = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(CompareChartHeader, _Component);

	function CompareChartHeader(props) {
		_classCallCheck(this, CompareChartHeader);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	CompareChartHeader.prototype.render = function render() {
		var id = 'chartHeader_' + this.props.label;
		var idSub = 'subLabel_' + this.props.label;
		var label = _StringResources2.default.get('compareChartHeader', { name: this.props.label });
		var subLabel = this.props.subLabel;
		var subLabelMarkup = null;
		if (subLabel) {
			subLabelMarkup = _react2.default.createElement(_caUiToolkit.TruncatedText, { style: truncatedTextStyle, className: 'CompareChartHeader__subLabel', id: idSub, location: 'end', value: subLabel });
		}
		return _react2.default.createElement(
			'div',
			{ role: 'heading', 'aria-labelledby': id, className: 'CompareChartHeader' },
			_react2.default.createElement(_caUiToolkit.Label, { className: 'CompareChartHeader__label', id: id, label: label }),
			subLabelMarkup
		);
	};

	return CompareChartHeader;
}(_react.Component)) || _class;

exports.default = CompareChartHeader;


CompareChartHeader.propTypes = {
	label: _PropTypes2.default.string,
	subLabel: _PropTypes2.default.string
};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(442);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./CompareChartHeader.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/resolve-url-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./CompareChartHeader.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.CompareChartHeader {\n  text-align: left;\n  padding-top: 10px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.CompareChartHeader__label {\n  font-weight: 800;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.CompareChartHeader__subLabel {\n  -ms-flex: 0.5 0 0px;\n      flex: 0.5 0 0;\n  font-size: 12px;\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-background-h, 0), var(--ui-background-s, 0%), var(--ui-background-l, 95.68627%), 1);\n  font-weight: 400;\n  border-radius: 2px;\n  padding-left: 4px;\n  padding-right: 4px;\n}\n\n", ""]);

// exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.CometCardView = undefined;

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2018, 2019
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(5);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _CometFooterView = __webpack_require__(444);

var _CometFooterView2 = _interopRequireDefault(_CometFooterView);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
* Comet Card react view
* Customizes ExploreCardView - provides footer visualization in the comet card
*/
var CometCardView = exports.CometCardView = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(CometCardView, _Component);

	function CometCardView(props) {
		_classCallCheck(this, CometCardView);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	CometCardView.prototype.render = function render() {
		var model = this.props.model;

		var showFooterView = model.cometViewModel.show;
		var cometFooterView = showFooterView ? _react2.default.createElement(_CometFooterView2.default, {
			onAddItem: this.props.onAddItem,
			onClickItem: this.props.onClickItem,
			model: model.cometViewModel,
			dashboardApi: this.props.dashboardApi,
			dataSourceId: this.props.dataSourceId,
			layoutOwner: this.props.layoutOwner,
			logger: this.props.logger
		}) : null;

		var getFooterView = function getFooterView() {
			return cometFooterView;
		};
		var getCssClasses = this.getCardStyleClasses;
		return this.props.children(null, null, getFooterView, getCssClasses);
	};

	CometCardView.prototype.getCardStyleClasses = function getCardStyleClasses() {
		var showFooterView = this.model.cometViewModel.show;
		var containsPlaceholder = this.model.getVisualizations().length > 1;
		var classNamesMain = (0, _classnames2.default)({
			'card-layout-main_comet': showFooterView,
			'card-layout-main': !showFooterView
		});
		var classNamesCardRow = (0, _classnames2.default)({
			'card-row_comet': showFooterView,
			'card-row': !showFooterView && !containsPlaceholder,
			'card-row-placeholder': containsPlaceholder
		});
		return {
			classNamesMain: classNamesMain,
			classNamesCardRow: classNamesCardRow
		};
	};

	return CometCardView;
}(_react.Component)) || _class;

CometCardView.propTypes = {
	model: _PropTypes2.default.object,
	children: _PropTypes2.default.any,
	dashboardApi: _PropTypes2.default.object,
	onAddItem: _PropTypes2.default.func,
	onClickItem: _PropTypes2.default.func,
	layoutOwner: _PropTypes2.default.object,
	dataSourceId: _PropTypes2.default.string,
	logger: _PropTypes2.default.object
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /**
             * Licensed Materials - Property of IBM
             *
             * 'Restricted Materials of IBM'
             *
             * (C) Copyright IBM Corp. 2018
             *
             * US Government Users Restricted Rights - Use, duplication or disclosure
             * restricted by GSA ADP Schedule Contract with IBM Corp.
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(1);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _mobxReact = __webpack_require__(5);

var _VisualizationPreviewListSlider = __webpack_require__(445);

var _VisualizationPreviewListSlider2 = _interopRequireDefault(_VisualizationPreviewListSlider);

var _PredictSpecConverter = __webpack_require__(451);

var _PredictSpecConverter2 = _interopRequireDefault(_PredictSpecConverter);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

__webpack_require__(453);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
* The class renders explore card foodter view. Centerina type of explore card has dedicated
*	Footer view, such as explore card that contains Comet chart, in that case, the footer view
* renders related visualization when clicking one node on the comet chart
**/
var CometFooterView = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(CometFooterView, _Component);

	/***
 *@constructor
 **/
	function CometFooterView(props) {
		_classCallCheck(this, CometFooterView);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.predictSpecConverter = new _PredictSpecConverter2.default({
			modelRef: props.layoutOwner.layoutController.boardModel.layout.exploreVM.activeDataSourceId
		});
		_this.prevKey = null;
		return _this;
	}

	CometFooterView.prototype.onDotClick = function onDotClick(options) {
		this.props.model.setVisIndexToShow(options.indexClicked);
	};

	CometFooterView.prototype.render = function render() {
		var selections = this.props.model.getSelections();
		var localFilters = this.props.model.getLocalFilters();
		this._resetRecommendationsIfNeeded(selections, localFilters);
		return _react2.default.createElement(
			'div',
			{ className: 'vis-preview-list-slider-wrapper' },
			_react2.default.createElement(
				'div',
				{ className: 'vis-preview-list-slider-wrapper-child' },
				this._renderVisPreviewList(selections)
			)
		);
	};

	CometFooterView.prototype._renderVisPreviewList = function _renderVisPreviewList(selections) {
		if (!selections.length) {
			//Default Text
			return _react2.default.createElement(
				'div',
				{ className: 'defaultTextPlaceholder' },
				_react2.default.createElement(
					'div',
					{ className: 'defaultText' },
					_react2.default.createElement(
						'div',
						{ className: 'title' },
						_StringResources2.default.get('footerView_title')
					),
					_react2.default.createElement(
						'div',
						{ className: 'description' },
						_StringResources2.default.get('footerView_description')
					)
				)
			);
		}
		//PreviewList
		return _react2.default.createElement(_VisualizationPreviewListSlider2.default, { items: this.props.model.getRecommendations(),
			predictData: this.props.model.getFooterRenderData(),
			isPredictPreview: true,
			model: this.props.model.getSelections(),
			horizontal: true,
			dashboardApi: this.props.dashboardApi,
			onAddItem: this.props.onAddItem,
			onClickItem: this.props.onClickItem,
			visStartingIndex: this.props.model.getVisIndexToShow(),
			onDotClick: this.onDotClick.bind(this) });
	};

	CometFooterView.prototype.generateRecommandations = function generateRecommandations(selections) {
		return new Promise(function (resolve) {
			var _this2 = this;

			var vis = this.predictSpecConverter.collectPredictVisRecommendations(selections);
			this.props.model.getSavedPrompts().then(function (savedPrompts) {
				var specs = _this2.predictSpecConverter.transformPredictRecommendations(vis);
				var recommendations = [];
				specs.forEach(function (spec) {
					/* set local filters to spec.
     local filters can be empty if they get removed in the previous action */
					spec.localFilters = _this2.prevLocalFilters;
					if (savedPrompts) {
						spec.savedPrompts = savedPrompts;
					}

					recommendations.push({
						widgets: [{
							spec: spec
						}],
						name: ''
					});
				});
				resolve(recommendations);
			});
		}.bind(this));
	};

	CometFooterView.prototype._isSelectionsChange = function _isSelectionsChange(selections) {
		if (selections && selections.length > 0) {
			return selections[0].key !== this.prevKey;
		} else {
			return true;
		}
	};

	/* check local filters JSON equality */


	CometFooterView.prototype._hasLocalFiltersChanged = function _hasLocalFiltersChanged(localFilters) {
		return JSON.stringify(this.prevLocalFilters) !== JSON.stringify(localFilters);
	};
	/**
  * resets the recommendations in the comet view model if selections or local filters have changed
  * extracting this function out from render for proper testing
  * @param {Array} selections
  * @param {Array} localFilters
  * @returns Promise
  */


	CometFooterView.prototype._resetRecommendationsIfNeeded = function _resetRecommendationsIfNeeded(selections, localFilters) {
		var _this3 = this;

		if (this._isSelectionsChange(selections) || this._hasLocalFiltersChanged(localFilters)) {
			this.prevKey = selections.length > 0 ? selections[0].key : null;
			this.prevLocalFilters = localFilters;
			this.props.model.setRecommendations([]);
			return this.generateRecommandations(selections).then(function (recommendations) {
				return _this3.props.model.setRecommendations(recommendations);
			});
		}
		return Promise.resolve([]);
	};

	return CometFooterView;
}(_react.Component)) || _class;

CometFooterView.propTypes = {
	model: _PropTypes2.default.object,
	dashboardApi: _PropTypes2.default.object,
	horizontal: _PropTypes2.default.bool,
	onAddItem: _PropTypes2.default.func,
	onClickItem: _PropTypes2.default.func,
	layoutOwner: _PropTypes2.default.object
};

exports.default = CometFooterView;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class; /**
             * Licensed Materials - Property of IBM
             * IBM Watson (C) Copyright IBM Corp. 2018
             * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
             */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = __webpack_require__(5);

var _VisualizationPreviewList = __webpack_require__(29);

var _VisualizationPreviewList2 = _interopRequireDefault(_VisualizationPreviewList);

var _DotsIndicator = __webpack_require__(446);

var _DotsIndicator2 = _interopRequireDefault(_DotsIndicator);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(58);

__webpack_require__(449);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualizationPreviewListSlider = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(VisualizationPreviewListSlider, _Component);

	function VisualizationPreviewListSlider(props) {
		_classCallCheck(this, VisualizationPreviewListSlider);

		return _possibleConstructorReturn(this, _Component.call(this, props));
	}

	VisualizationPreviewListSlider.prototype.onDotClick = function onDotClick(options) {
		this.props.onDotClick && this.props.onDotClick(options);
	};

	VisualizationPreviewListSlider.prototype.render = function render() {
		var classNames = (0, _classnames2.default)('vis-recommender__preview-slider', {
			'vis-recommender__preview-slider--horizontal': this.props.horizontal,
			'vis-recommender__preview-slider--vertical': !this.props.horizontal
		});

		return _react2.default.createElement(
			'div',
			{ className: classNames },
			_react2.default.createElement(_DotsIndicator2.default, {
				items: this.props.items,
				activeIndex: this.props.visStartingIndex,
				onDotClick: this.onDotClick.bind(this)
			}),
			_react2.default.createElement(_VisualizationPreviewList2.default, {
				onAddItem: this.props.onAddItem,
				onClickItem: this.props.onClickItem,
				items: this.props.items,
				visStartingIndex: this.props.visStartingIndex,
				maxDisplayedItems: 1,
				enableSeeMore: false,
				predictData: this.props.predictData,
				isPredictPreview: this.props.isPredictPreview,
				model: this.props.model,
				horizontal: true,
				dashboardApi: this.props.dashboardApi,
				titleOnBottom: false,
				spinnerSize: 'large',
				featureSet: ['vis-title-fetcher'],
				logger: this.props.logger
			})
		);
	};

	return VisualizationPreviewListSlider;
}(_react.Component)) || _class;

VisualizationPreviewListSlider.propTypes = {
	dashboardApi: _propTypes2.default.object.isRequired,
	items: _propTypes2.default.array.isRequired,
	onClickItem: _propTypes2.default.func,
	onAddItem: _propTypes2.default.func,
	horizontal: _propTypes2.default.bool,
	predictData: _propTypes2.default.object,
	isPredictPreview: _propTypes2.default.bool,
	maxDisplayedItems: _propTypes2.default.number,
	visStartingIndex: _propTypes2.default.number,
	titleOnBottom: _propTypes2.default.bool,
	enableSeeMore: _propTypes2.default.bool,
	onGetMore: _propTypes2.default.func,
	model: _propTypes2.default.arrayOf(_propTypes2.default.object),
	onDotClick: _propTypes2.default.func,
	featureSet: _propTypes2.default.array,
	logger: _propTypes2.default.object
};

VisualizationPreviewListSlider.defaultProps = {
	horizontal: false,
	maxDisplayedItems: 1,
	visStartingIndex: 0,
	onAddItem: function onAddItem() {},
	titleOnBottom: true,
	enableSeeMore: false
};

exports.default = VisualizationPreviewListSlider;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Watson (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */



exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class, _desc, _value, _class2, _descriptor;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(447);

var _mobx = __webpack_require__(11);

var _mobxReact = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
	if (!descriptor) return;
	Object.defineProperty(target, property, {
		enumerable: descriptor.enumerable,
		configurable: descriptor.configurable,
		writable: descriptor.writable,
		value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	});
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

function _initializerWarningHelper(descriptor, context) {
	throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var DotsIndicator = (_dec = _mobx.observable.shallow, (0, _mobxReact.observer)(_class = (_class2 = function (_React$Component) {
	_inherits(DotsIndicator, _React$Component);

	function DotsIndicator(props) {
		_classCallCheck(this, DotsIndicator);

		var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

		_initDefineProp(_this, 'items', _descriptor, _this);

		_this.items = props.items;
		return _this;
	}

	DotsIndicator.prototype._onDotClick = function _onDotClick(options, e) {
		e.preventDefault();
		this.props.onDotClick && this.props.onDotClick(options);
	};

	DotsIndicator.prototype._renderDot = function _renderDot(i) {
		var className = (0, _classnames2.default)({
			'dot-active': this.props.activeIndex === i
		});

		var dotOptions = {
			message: 'dots',
			indexClicked: i,
			currentActiveIndex: this.props.activeIndex
		};

		var onClick = this._onDotClick.bind(this, dotOptions);
		return _react2.default.createElement(
			'li',
			{ key: i, className: className },
			_react2.default.createElement(
				'button',
				{ onClick: onClick },
				' ',
				i + 1
			)
		);
	};

	DotsIndicator.prototype.render = function render() {
		var _this2 = this;

		var dotCount = this.props.items ? this.props.items.length : 0;
		if (dotCount <= 1) {
			return null;
		}
		var _props = this.props,
		    onMouseEnter = _props.onMouseEnter,
		    onMouseOver = _props.onMouseOver,
		    onMouseLeave = _props.onMouseLeave;

		var mouseEvents = {
			onMouseEnter: onMouseEnter,
			onMouseOver: onMouseOver,
			onMouseLeave: onMouseLeave
		};
		var dotArray = Array(dotCount + 1).join('0').split('');
		var dots = Array.apply(null, dotArray).map(function (item, index) {
			return _this2._renderDot(index);
		});
		return _react2.default.createElement(
			'ul',
			_extends({ className: 'dots-indicator' }, mouseEvents),
			dots
		);
	};

	return DotsIndicator;
}(_react2.default.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'items', [_dec], {
	enumerable: true,
	initializer: function initializer() {
		return [];
	}
})), _class2)) || _class);


DotsIndicator.propTypes = {
	items: _propTypes2.default.array.isRequired,
	dotsClass: _propTypes2.default.string,
	onMouseEnter: _propTypes2.default.func,
	onMouseOver: _propTypes2.default.func,
	onMouseLeave: _propTypes2.default.func,
	onDotClick: _propTypes2.default.func,
	activeIndex: _propTypes2.default.number
};

DotsIndicator.defaultProps = {
	activeIndex: 0,
	onDotClick: function onDotClick() {}
};

exports.default = DotsIndicator;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(448);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./dotsIndicator.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./dotsIndicator.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n * Licensed Materials - Property of IBM\n * IBM Watson (C) Copyright IBM Corp. 2018, 2020\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n.dots-indicator {\n  position: relative;\n  list-style: none;\n  display: block;\n  text-align: center;\n  padding: 0;\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.dots-indicator li {\n  position: relative;\n  display: inline-block;\n  height: 20px;\n  width: 20px;\n  margin: 0 5px;\n  padding: 0;\n  cursor: pointer;\n}\n\n.dots-indicator li button {\n  border: 0;\n  background: transparent;\n  display: block;\n  height: 20px;\n  width: 20px;\n  outline: none;\n  line-height: 0;\n  font-size: 0;\n  color: transparent;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.dots-indicator li button:focus,\n.dots-indicator li button:hover {\n  outline: none;\n}\n\n.dots-indicator li button:focus:before,\n.dots-indicator li button:hover:before {\n  opacity: 1;\n}\n\n.dots-indicator li button:before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  content: \"\\2022\";\n  width: 20px;\n  height: 20px;\n  font-size: 25px;\n  line-height: 20px;\n  text-align: center;\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  opacity: 0.25;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.dots-indicator li.dot-active button:before {\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  opacity: 0.75;\n}\n\n", ""]);

// exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(450);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./visPreviewListSlider.scss", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/resolve-url-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./visPreviewListSlider.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/**\n * Licensed Materials - Property of IBM\n * IBM Watson (C) Copyright IBM Corp. 2018\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n.vis-preview-list-slider-wrapper .vis-recommender__preview-slider {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column-reverse nowrap;\n      flex-flow: column-reverse nowrap;\n  -ms-flex: 1;\n      flex: 1;\n  position: relative;\n  border: 1px solid #1f57a4;\n}\n\n.vis-preview-list-slider-wrapper .vis-recommender__preview-list--horizontal {\n  -ms-flex: 1;\n      flex: 1;\n  margin-left: 24px;\n  margin-right: 24px;\n  margin-top: 24px;\n  overflow: hidden;\n}\n\n.vis-preview-list-slider-wrapper .vis-recommender__preview-list--horizontal__items {\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 100%;\n}\n\n.vis-preview-list-slider-wrapper .vis-recommender__preview--horizontal {\n  min-height: 80px;\n  width: 100%;\n  height: 100%;\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n}\n\n.vis-preview-list-slider-wrapper .vis-recommender__preview {\n  cursor: pointer;\n}\n\n.vis-preview-list-slider-wrapper .vis-recommender__preview:hover,\n.vis-preview-list-slider-wrapper .vis-recommender__preview:active {\n  outline: none;\n}\n\n.vis-preview-list-slider-wrapper .vis-recommender__preview--horizontal__preview-box {\n  height: 100%;\n}\n\n", ""]);

// exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PredictToVizMapping = __webpack_require__(452);

var _PredictToVizMapping2 = _interopRequireDefault(_PredictToVizMapping);

var _underscore = __webpack_require__(8);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           *| Licensed Materials - Property of IBM
                                                                                                                                                           *| IBM Cognos Products: Explore
                                                                                                                                                           *| (C) Copyright IBM Corp. 2018, 2019
                                                                                                                                                           *|
                                                                                                                                                           *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                           *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                           *+------------------------------------------------------------------------+
                                                                                                                                                           */


var PredictSpecConverter = function () {
	function PredictSpecConverter(options) {
		_classCallCheck(this, PredictSpecConverter);

		this._predictToVizMapping = _PredictToVizMapping2.default;
		this._modelRef = options.modelRef;
	}

	PredictSpecConverter.prototype.transformPredictRecommendations = function transformPredictRecommendations(recommendations) {
		var _this = this;

		return recommendations.map(function (recommendation) {
			return _this._transformWidgetRecommendationToLiveWidgetSpec(recommendation);
		});
	};

	PredictSpecConverter.prototype.collectPredictVisRecommendations = function collectPredictVisRecommendations(selections) {
		var recommendations = [];
		selections.forEach(function (selection) {
			if (selection && selection.values) {
				selection.values.forEach(function (value) {
					if (value.payload) {
						var vis = _underscore2.default.isArray(value.payload.vis) ? value.payload.vis : [value.payload.vis];
						if (value.payload.fields) {
							vis.forEach(function (v) {
								if (v.dataItems) {
									v.dataItems.forEach(function (dataItem) {
										var field = value.payload.fields.find(function (field) {
											return field.id === dataItem.itemId;
										});
										if (field) {
											dataItem.itemLabel = field.label;
										} else {
											if (value.payload.target && value.payload.target.id === dataItem.itemId) {
												dataItem.itemLabel = value.payload.target.label;
											}
										}
									});
								}
							});
						}
						recommendations = recommendations.concat(vis);
					}
				});
			}
		});
		return recommendations;
	};

	PredictSpecConverter.prototype._transformWidgetRecommendationToLiveWidgetSpec = function _transformWidgetRecommendationToLiveWidgetSpec(recommendation) {
		var dataItems = recommendation.dataItems;
		var chartType = recommendation.chartType,
		    slotmapping = recommendation.slotmapping,
		    annotations = recommendation.annotations;

		var smartsToVisMap = this._predictToVizMapping[chartType];
		var slots = slotmapping.slots;

		slots = this._transformSlopmapping(slots, smartsToVisMap);
		dataItems = this._transformDataItems(dataItems);

		return {
			type: 'live',
			visTypeLocked: true,
			visId: smartsToVisMap.visId,
			data: {
				dataViews: [{
					modelRef: this._modelRef,
					dataItems: dataItems
				}]
			},
			slotmapping: {
				slots: slots
			},
			annotations: {
				toggleEnabled: annotations && annotations.length > 0,
				selectedAnnotations: annotations || []
			}
		};
	};

	PredictSpecConverter.prototype._transformSlopmapping = function _transformSlopmapping(slots, smartsToVisMap) {
		slots.forEach(function (slot) {
			slot.name = smartsToVisMap[slot.name] ? smartsToVisMap[slot.name] : slot.name;
			slot.layerId = 'data';
		});
		return slots;
	};

	PredictSpecConverter.prototype._transformDataItems = function _transformDataItems(dataItems) {
		dataItems.forEach(function (dataItem) {
			var id = dataItem.id,
			    binning = dataItem.binning;

			if (binning) {
				dataItem.binningDefinition = {
					id: id,
					binning: binning
				};
				delete dataItem.binning;
			}
		});
		return dataItems;
	};

	return PredictSpecConverter;
}();

exports.default = PredictSpecConverter;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/*
* A map of Predict Vis Recommender info to Explore's.
*/
!(module.exports = {
	Area: {
		visId: 'com.ibm.vis.rave2bundlearea',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	StackedArea: {
		visId: 'com.ibm.vis.rave2bundlearea',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Bar: {
		visId: 'com.ibm.vis.rave2bundlebar',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	ClusteredBar: {
		visId: 'com.ibm.vis.rave2bundlebar',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	StackedBar: {
		visId: 'com.ibm.vis.rave2bundlestackedbar',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Bubble: {
		visId: 'com.ibm.vis.ravebubble',
		X: 'x',
		Y: 'y',
		SIZE: 'size',
		COLOR: 'color',
		POINTS: 'categories',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Column: {
		visId: 'com.ibm.vis.rave2bundlecolumn',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	ClusteredColumn: {
		visId: 'com.ibm.vis.rave2bundlecolumn',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	StackedColumn: {
		visId: 'com.ibm.vis.rave2bundlestackedcolumn',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Crosstab: {
		visId: 'crosstab',
		VALUE: 'values',
		CATEGORY: 'column_level1',
		COLUMN_HIERARCHY: 'column_level1',
		ROW_HIERARCHY: 'row_level1',
		COLOR: 'heat'
	},
	Heatmap: {
		visId: 'com.ibm.vis.rave2heat',
		ROW: 'categories',
		COLUMN: 'series',
		COLOR: 'color',
		SIZE: 'size',
		POINTS: 'points',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Line: {
		visId: 'com.ibm.vis.rave2line',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	ClusteredLine: {
		visId: 'com.ibm.vis.rave2line',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	DualAxis: {
		visId: 'com.ibm.vis.rave2bundlecomposite',
		CATEGORY: 'categories',
		Y1: 'lineValue',
		Y2: 'columnValue',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Tiledmap: {
		visId: 'com.ibm.vis.rave2bundletiledmap',
		REGION_LOCATION: 'locations',
		REGION_COLOR: 'locationColor',
		POINT_LOCATION: 'pointLocations',
		POINT_COLOR: 'pointColor',
		POINT_SIZE: 'pointSize',
		COORDINATE_LATITUDE: 'latlongLocations.latitude',
		COORDINATE_LONGITUDE: 'latlongLocations.longitude',
		COORDINATE_COLOR: 'latlongColor',
		COORDINATE_SIZE: 'latlongSize',
		COORDINATE_LABEL: 'latlongLocations.caption'
	},
	PackedBubble: {
		visId: 'com.ibm.vis.rave2bundlepackedbubble',
		CATEGORY: 'categories',
		COLOR: 'color',
		SIZE: 'size',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	HierarchicalPackedBubble: {
		visId: 'com.ibm.vis.rave2bundlehierarchicalpackedbubble',
		CATEGORY: 'categories',
		HIERARCHY: 'categories',
		COLOR: 'color',
		SIZE: 'size',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Pie: {
		visId: 'com.ibm.vis.rave2bundlepie',
		CATEGORY: 'categories',
		VALUE: 'values',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	HierarchicalPie: {
		visId: 'com.ibm.vis.rave2bundlepie',
		HIERARCHY: 'categories',
		VALUE: 'values',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Point: {
		visId: 'com.ibm.vis.rave2point',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	ClusteredPoint: {
		visId: 'com.ibm.vis.rave2point',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'series',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Dial: {
		visId: 'com.ibm.vis.rave2bundleradialbar',
		CATEGORY: 'categories',
		VALUE: 'values',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Scatter: {
		visId: 'com.ibm.vis.ravescatter',
		X: 'x',
		Y: 'y',
		COLOR: 'color',
		POINTS: 'categories',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Singleton: {
		visId: 'summary',
		VALUE: 'values'
	},
	List: {
		visId: 'JQGrid',
		ANY: 'grid_cols'
	},
	Treemap: {
		visId: 'com.ibm.vis.rave2bundletreemap',
		HIERARCHY: 'categories',
		CATEGORY: 'categories',
		SIZE: 'size',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Wordle: {
		visId: 'com.ibm.vis.rave2bundlewordcloud',
		CATEGORY: 'categories',
		SIZE: 'size',
		COLOR: 'color',
		MATRIX_COLUMN: 'repeatHorizontal',
		MATRIX_ROW: 'repeatVertical'
	},
	Spiral: {
		visId: 'com.ibm.vis.spiral',
		TARGET: 'values'
	},
	Tree: {
		visId: 'com.ibm.vis.decisiontree',
		TARGET: 'values'
	},
	KPI: {
		visId: 'kpi',
		ACTUAL: 'actual',
		PLANNED: 'goal'
	}
});

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(454);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./cometFooter.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/resolve-url-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js??ref--2-4!./cometFooter.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.vis-preview-list-slider-wrapper {\n  display: block;\n  min-height: 60%;\n  max-height: 60%;\n  width: 100%;\n  position: relative;\n}\n\n.vis-preview-list-slider-wrapper .vis-preview-list-slider-wrapper-child {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.vis-preview-list-slider-wrapper .vis-preview-list-slider-wrapper-child > :first-child {\n  width: 100%;\n  height: 100%;\n}\n\n.vis-preview-list-slider-wrapper .vis-preview-list-slider-wrapper-child .defaultTextPlaceholder {\n  padding: 0;\n  display: -ms-flexbox;\n  display: flex;\n  border: 1px solid #eaeaea;\n}\n\n.vis-preview-list-slider-wrapper .vis-preview-list-slider-wrapper-child .defaultTextPlaceholder .defaultText {\n  padding: 0;\n  width: 100%;\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n  text-align: center;\n}\n\n.vis-preview-list-slider-wrapper .vis-preview-list-slider-wrapper-child .defaultTextPlaceholder .defaultText .title {\n  color: #343334;\n  font-weight: bold;\n  padding: 3px;\n}\n\n.vis-preview-list-slider-wrapper .vis-preview-list-slider-wrapper-child .defaultTextPlaceholder .defaultText .description {\n  color: #343334;\n}\n\n", ""]);

// exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _CreateExplorationLayout = __webpack_require__(52);

var _CreateExplorationLayout2 = _interopRequireDefault(_CreateExplorationLayout);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(17);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var BaseClass = __webpack_require__(456);

var ExploreWidget = BaseClass.extend({
	init: function init() {
		ExploreWidget.inherited('init', this, arguments);
		this.parentLayout && this.parentLayout.trackChildWidget(this);
		if (this.widgetModel && this.widgetModel.placeHolder) {
			this._renderPlaceHolder();
		}

		this._onShowInProgress = false;
	},

	destroy: function destroy() {
		this.widgetChromeEventRouter = null;
		if (this.$el) {
			//Unmount the react element to avoid zombie DOM
			_reactDom2.default.unmountComponentAtNode(this.$el.get(0));
		}
		// If no id no content so nothing to destroy
		this.id && ExploreWidget.inherited('destroy', this, arguments);
	},

	onKeyDown: function onKeyDown(event) {
		if (event.keyCode === 121) {
			// if F10 pressed dont open focus mode in Explore
			event.stopPropagation();
		}
	},

	_renderPlaceHolder: function _renderPlaceHolder() {
		var e = _react2.default.createElement(_CreateExplorationLayout2.default, {
			isComparison: this.parentLayout.model.isCompareEnabled,
			fill: true,
			services: this.services,
			activeDataSourceId: this.model.boardModel.layout.exploreVM.activeDataSourceId,
			handleShowVisTypesClick: this._showVisTypesDialog.bind(this),
			createVis: this.createVis.bind(this),
			dashboardApi: this.dashboardApi
		});
		_reactDom2.default.render(e, this.$el.get(0));
	},

	_showVisTypesDialog: function _showVisTypesDialog() {
		this.model.boardModel.layout.exploreVM.setToolBarVisTypePicker(false, this);
		this.model.boardModel.layout.exploreVM.setShowModalVisTypePicker(true);
		this.parentLayout.view.widgetSelectionUpToDate = false;
	},

	createVis: function createVis(widgetSpec) {
		this.parentLayout.replaceWithWidget(widgetSpec, this.model.id);
	},

	getSize: function getSize(payload) {
		if (payload.deferred) {
			payload.deferred.resolve({});
		}
	}
});

exports.default = ExploreWidget;

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_456__;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Provides a mechanism to enable or disable selection interactions based on whether there
 * are multiple visualizations in a card or not.
 */
var Selection = function () {
	function Selection(context) {
		_classCallCheck(this, Selection);

		this.context = context;
	}

	Selection.prototype.isEnabled = function isEnabled() {
		var layout = this.context.boardModel.layout;


		var id = layout.exploreVM.displayedCard;
		var card = layout.findModel(id);
		var visualizations = card && card.getVisualizations();

		// Selection should be disabled for cards with only 1 visualization.
		return visualizations && visualizations.length > 1;
	};

	return Selection;
}();

exports.default = Selection;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

function isCompare(context) {
  var layout = context.boardModel.layout;


  var id = layout.exploreVM.displayedCard;
  var card = layout.findModel(id);
  var visualizations = card && card.getVisualizations();

  // Selection should be disabled for cards with only 1 visualization.
  return visualizations && visualizations.length > 1;
}

/**
 * Returns a selector that is used to determine what touch/pointer-events will result in the
 * deselection of widgets. Any event target (node) that is not a child of the nodes found
 * by this selector will not result in widgets being deselected.
 *
 * @return {string} a selector
 */

exports.default = function (context) {
  return isCompare(context) ? '.card-layout-main' : '.card-row';
};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Licensed Materials - Property of IBM
 *
 * "Restricted Materials of IBM"
 *
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * An action controller to handle links that display under the Help menu; contributed by Explore, in particular: the tutorials link.
 */

var BaseClass = __webpack_require__(39);

var ActionHandler = BaseClass.extend({

	actionHandlers: {
		'tutorials': function tutorials() {
			return this._openExternalPage('https://www.youtube.com/playlist?list=PLfq0ST5X3p-R0Q6PqFXBO4Al0JNxsr1J2');
		}
	},

	/**
  * Menu item handler
  */
	onSelectItem: function onSelectItem(context) {
		var key = this._getPluginKey(context.target.itemId);
		var action = this.actionHandlers[key];
		if (action) {
			return action.call(this);
		}
	},

	_openExternalPage: function _openExternalPage(url) {
		window.open(url, '_blank');
	},

	_getPluginKey: function _getPluginKey(itemId) {
		var idTokens = itemId.split('.');

		return idTokens[idTokens.length - 1];
	}

});

exports.default = ActionHandler;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(461);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./main.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--2-1!../../node_modules/postcss-loader/index.js??ref--2-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--2-4!./main.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\nhtml {\n  font-size: 14px;\n}\n\n/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\nbutton {\n  line-height: 16px;\n  font-weight: normal;\n}\n\n/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.explore__animation--fade-appear,\n.explore__animation--fade-enter {\n  opacity: 0.1;\n}\n\n.explore__animation--fade-appear-active,\n.explore__animation--fade-enter-active {\n  opacity: 1;\n  transition: opacity 300ms ease-in;\n}\n\n.explore__animation--fade-exit {\n  opacity: 1;\n  transform: scale(1, 1);\n}\n\n.explore__animation--fade-exit-active {\n  opacity: 0.1;\n  transition: opacity 300ms ease-out;\n}\n\n.explore__animation--slideDown-appear,\n.explore__animation--slideDown-enter {\n  opacity: 0.1;\n  transform: translateY(-100%);\n}\n\n.explore__animation--slideDown-appear-active,\n.explore__animation--slideDown-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n}\n\n.explore__animation--slideDown-exit {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.explore__animation--slideDown-exit-active {\n  opacity: 0.1;\n  transform: translateY(-100%);\n  transition: opacity 300ms ease-out, transform 300ms ease-out;\n}\n\n.explore__animation--slideUp-appear,\n.explore__animation--slideUp-enter {\n  opacity: 0.1;\n  transform: translateY(100%);\n}\n\n.explore__animation--slideUp-appear-active,\n.explore__animation--slideUp-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n}\n\n.explore__animation--slideUp-exit {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.explore__animation--slideUp-exit-active {\n  opacity: 0.1;\n  transform: translateY(100%);\n  transition: opacity 300ms ease-out, transform 300ms ease-out;\n}\n\n.explore__animation--slideLeft-appear,\n.explore__animation--slideLeft-enter {\n  opacity: 0.1;\n  transform: translateX(100%);\n}\n\n.explore__animation--slideLeft-appear-active,\n.explore__animation--slideLeft-enter-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n}\n\n.explore__animation--slideLeft-exit {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.explore__animation--slideLeft-exit-active {\n  opacity: 0.1;\n  transform: translateX(100%);\n  transition: opacity 300ms ease-out, transform 300ms ease-out;\n}\n\n/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.exploreContainer-react-layout-view {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.exploreContainer-react-layout-view .explore {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content {\n  position: relative;\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content__cards {\n  height: 100%;\n  overflow-y: hidden;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-item {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 100;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-item.background,\n.exploreContainer-react-layout-view .explore .explore-content .card-item.done {\n  z-index: 0;\n  opacity: 0;\n  left: 999999px;\n  position: fixed;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-item.background .widgetContent,\n.exploreContainer-react-layout-view .explore .explore-content .card-item.done .widgetContent {\n  opacity: 0;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-item .card-layout-content {\n  -ms-flex-align: stretch;\n      align-items: stretch;\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  -ms-flex-pack: space-evenly;\n      justify-content: space-evenly;\n  box-sizing: border-box;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-item .card-layout-content__side-panel {\n  max-width: 320px;\n  min-width: 200px;\n  -ms-flex: 1 3;\n      flex: 1 3;\n  padding: 32px 16px 48px 0;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .layout-wrapper-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .layout-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column;\n      flex-flow: column;\n  -ms-flex: 1 0 0px;\n      flex: 1 0 0;\n  -ms-flex-positive: 2;\n      flex-grow: 2;\n  margin: 0 8px;\n  position: relative;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .layout-wrapper .widget-wrapper {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  /* TODO: Remove LW css from Explore and come up with proper solution.\n\t\t\t\t\t224422 - temp fix. Currently LW maintains their state using css\n\t\t\t\t\twe have to stop augmenting LW css on our side. Need coordinated effort\n\t\t\t\t\tbetween LV and Explore to achieve separation of concerns between our components.\n\t\t\t\t\tOtherwise as soon as they change css, we'll be broken in Explore. Ideally there\n\t\t\t\t\tshould be a model controlling state of showing/hiding hint text programatically.\n\t\t\t\t\t*/\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .layout-wrapper .widget-wrapper .vis-icon-view .vis-icon-view-hint {\n  display: inline;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .layout-wrapper .widget-wrapper .vis-icon-view .vis-icon-view-hint .icon {\n  display: none;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .layout-wrapper .widget:not(.kpi-widget-sparkline) {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .layout-wrapper .single-card {\n  width: 100%;\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .layout-wrapper .single-card .layout-wrapper {\n  width: 70%;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .layout-wrapper .explore-empty-widget-layout-dnd {\n  outline-style: solid;\n  outline-width: 1px;\n  outline-color: #161616;\n  outline-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #161616;\n  background-color: hsla(var(--ui-05-h, 0), var(--ui-05-s, 0%), var(--ui-05-l, 8.62745%), 1);\n  opacity: 0.1;\n  z-index: 1000;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .layout-wrapper .popoverHidden {\n  display: none;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-layout-main {\n  padding: 32px 40px 48px 40px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column wrap;\n      flex-flow: column wrap;\n  position: relative;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  flex-direction: column;\n  -ms-flex-direction: column;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-layout-main_comet {\n  padding: 32px 40px 48px 40px;\n  display: block;\n  -ms-flex-flow: column wrap;\n      flex-flow: column wrap;\n  position: relative;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 250px;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  -ms-flex: 1 0 0px;\n      flex: 1 0 0;\n  -ms-flex-pack: space-evenly;\n      justify-content: space-evenly;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-row__vertical {\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-row-placeholder {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  -ms-flex: 1 0 0px;\n      flex: 1 0 0;\n  -ms-flex-pack: space-evenly;\n      justify-content: space-evenly;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-row-placeholder__vertical {\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-row-placeholder__vertical .create-exploration-icon {\n  display: none;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-row_comet {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  position: relative;\n  min-height: 40%;\n  max-height: 40%;\n  -ms-flex-pack: space-evenly;\n      justify-content: space-evenly;\n}\n\n.exploreContainer-react-layout-view .explore .explore-content .card-row_comet > :first-child {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  right: 0px;\n  left: 0px;\n}\n\n.exploreContainer-react-layout-view .explore .explore-empty-container-dnd {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  color: #8d8d8d;\n  color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n  background-color: white;\n  background-color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n  opacity: 0.9;\n  z-index: 1000;\n}\n\n.exploreContainer-react-layout-view .explore .explore-empty-container-dnd .explore__empty__icon {\n  color: #161616;\n  color: hsla(var(--icon-01-h, 0), var(--icon-01-s, 0%), var(--icon-01-l, 8.62745%), 1);\n  margin-bottom: 8px;\n}\n\n.exploreContainer-react-layout-view .explore .explore-empty-container-dnd .explore__empty__title {\n  margin-top: 8px;\n}\n\n/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.exploreFilterDockContainer.filterDockContainer .filterDock .filter-dock-overflow .filter-menu {\n  bottom: auto;\n}\n\n#filter-dock-collapse-handle-container .exploreFilterCollapseControlContainer#filter-dock-collapse-handle-content #filter-dock-collapse-handle-icon .svgIcon {\n  height: 70px;\n}\n\n#filter-dock-collapse-handle-container.filter-dock-collapse-handle-container-expanded #filter-dock-collapse-handle-content.exploreFilterCollapseControlContainer {\n  display: none;\n}\n\n", ""]);

// exports


/***/ })
],[170]);
});


// WEBPACK FOOTER //
// component.min.js